import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  UUID: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  Map: any;
  Time: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type GqlQuery = {
  __typename?: 'Query';
  company: Maybe<GqlCompanyGqlConnection>;
  company_by_id: Maybe<GqlCompanyGql>;
  account: Maybe<GqlAccountGqlConnection>;
  account_by_id: Maybe<GqlAccountGql>;
  account_by_entity_id: Maybe<GqlAccountGql>;
  account_by_dms_entity_id: Maybe<GqlAccountGql>;
  transaction_types: Maybe<GqlTransactionTypeGqlConnection>;
  transaction_type_by_id: Maybe<GqlTransactionTypeGql>;
  ledgerentry: Maybe<GqlLedgerEntryGqlConnection>;
  ledgerentries_by_entity_id: Maybe<GqlLedgerEntryGqlConnection>;
  ledgerentries_by_ent_id: Maybe<GqlLedgerEntryGqlConnection>;
  ledgerentry_by_id: Maybe<GqlLedgerEntryGql>;
  service: Maybe<GqlServiceGqlConnection>;
  service_by_id: Maybe<GqlServiceGql>;
  permission: Maybe<GqlPermissionsGqlConnection>;
  permission_by_id: Maybe<GqlPermissionsGql>;
  role: Maybe<GqlRoleGqlConnection>;
  role_by_id: Maybe<GqlRoleGql>;
  inbound_payment: Maybe<GqlInboundPaymentGqlConnection>;
  inbound_payment_config: Maybe<GqlInboundPaymentConfigGqlConnection>;
  inbound_payment_by_id: Maybe<GqlInboundPaymentConfigGql>;
  inbound_payment_provider: Maybe<GqlInboundPaymentProviderGqlConnection>;
  inbound_payment_provider_by_id: Maybe<GqlInboundPaymentProviderGql>;
  payment: Maybe<GqlPaymentGqlConnection>;
  payment_by_id: Maybe<GqlPaymentGql>;
  party: Maybe<GqlPartyGqlConnection>;
  party_by_id: Maybe<GqlPartyGql>;
  payment_provider: Maybe<GqlPaymentProviderGqlConnection>;
  payment_provider_by_id: Maybe<GqlPaymentProviderGql>;
  payment_provider_mode: Maybe<GqlPaymentProviderModeGqlConnection>;
  payment_provider_mode_by_id: Maybe<GqlPaymentProviderModeGql>;
  payment_mode: Maybe<GqlPaymentModeGqlConnection>;
  payment_mode_by_id: Maybe<GqlPaymentModeGql>;
  party_mapping: Maybe<GqlPartyMappingGqlConnection>;
  party_mapping_by_id: Maybe<GqlPartyMappingGql>;
  LeadCallbackConnection: Maybe<GqlLeadCallbackConnection>;
  OrderCallbackConnection: Maybe<GqlOrderCallbackConnection>;
  LoanOfferConnection: Maybe<GqlLoanOfferConnection>;
  LoanRequestConnection: Maybe<GqlLoanRequestConnection>;
  CustomerPartnerConnection: Maybe<GqlCustomerPartnerConnection>;
  CustomerConnection: Maybe<GqlCustomerConnection>;
  PartnerConnection: Maybe<GqlPartnerConnection>;
  PartnerTopupConnection: Maybe<GqlPartnerTopupConnection>;
  PartnerUpdateConnection: Maybe<GqlPartnerUpdateConnection>;
  PartnerEarningConnection: Maybe<GqlPartnerEarningConnection>;
  LoanProductConnection: Maybe<GqlLoanProductConnection>;
  DepotPartnerConnection: Maybe<GqlDepotPartnerConnection>;
  LoanConnection: Maybe<GqlLoanConnection>;
  LoanUpdateConnection: Maybe<GqlLoanUpdateConnection>;
  LoanRepaymentConnection: Maybe<GqlLoanRepaymentConnection>;
  LoanRejectionReason: Array<Maybe<GqlLoanRejectionReason>>;
  LoanWaiverReason: Array<Maybe<GqlLoanWaiverReason>>;
  suppliers: Maybe<GqlSupplierV2GqlConnection>;
  supplier_by_id: Maybe<GqlSupplierV2Gql>;
  supplier_users: Maybe<GqlSupplierUserGqlConnection>;
  supplier_user_by_id: Maybe<GqlSupplierUserGql>;
  supplier_products: Maybe<GqlSupplierProductGqlConnection>;
  supplier_product_by_id: Maybe<GqlSupplierProductGql>;
  supplier_campaigns: Maybe<GqlSupplierCampaignV2GqlConnection>;
  supplier_campaigns_by_id: Maybe<GqlSupplierCampaignV2Gql>;
  serverVersion: Scalars['String'];
  digitalServices: Array<GqlDigitalService>;
  digitalProducts: Array<GqlDigitalProduct>;
  digitalTransactions: GqlDigitalTransactionConnection;
  digitalService: Maybe<GqlDigitalService>;
  digitalProduct: Maybe<GqlDigitalProduct>;
  digitalTransaction: Maybe<GqlDigitalTransaction>;
  sokoloan_repayments: Maybe<GqlSokoLoanRepaymentGqlConnection>;
  sokoloan_repayment_by_id: Maybe<GqlSokoLoanRepaymentGql>;
  lead_callbacks: Maybe<GqlLeadCallbackGqlConnection>;
  lead_callback_by_id: Maybe<GqlLeadCallbackGql>;
  fintech_loans: Maybe<GqlLoanGqlConnection>;
  fintech_loans_by_customer_id: Maybe<GqlLoanGqlConnection>;
  fintech_loan_by_id: Maybe<GqlLoanGql>;
  loan_offers: Maybe<GqlLoanOfferGqlConnection>;
  loan_offer_by_delivery_id: Maybe<GqlLoanOfferGql>;
  loan_offer_by_id: Maybe<GqlLoanOfferGql>;
  loan_requests: Maybe<GqlLoanRequestGqlConnection>;
  loan_request_by_id: Maybe<GqlLoanRequestGql>;
  partner_loan_query_by_customer_id: Maybe<Array<Maybe<GqlPartnerLoanQueryGql>>>;
  partner_member_query_by_customer_id: Maybe<Array<Maybe<GqlPartnerMemberQueryGql>>>;
  fintech_deliveries: Maybe<GqlFintechDeliveryGqlConnection>;
  fintech_deliveries_by_customer_id: Maybe<GqlFintechDeliveryGqlConnection>;
  fintech_customers: Maybe<GqlFintechCustomerGqlConnection>;
  fintech_customer_by_id: Maybe<GqlFintechCustomerGql>;
  fintech_partners: Maybe<Array<Maybe<GqlPartnerGql>>>;
  fintech_partner_by_id: Maybe<GqlPartnerGql>;
  pricing_v2: Maybe<GqlPricingV2GqlConnection>;
  pricing_v2_by_id: Maybe<GqlPricingV2Gql>;
  pricing_v2_by_product_item_id: Maybe<GqlPricingV2Gql>;
  pricing_v2_by_region_id: Maybe<GqlPricingV2Gql>;
  dynamic_pricing: Maybe<GqlDynamicPricingGqlConnection>;
  dynamic_pricing_by_id: Maybe<GqlDynamicPricingGql>;
  price_comparison: Maybe<Array<Maybe<GqlPriceComparisonGql>>>;
  work_orders: Maybe<GqlWorkOrderGqlConnection>;
  work_order_by_id: Maybe<GqlWorkOrderGql>;
  work_order_definitions: Maybe<Array<Maybe<GqlWorkOrderDefinitionGql>>>;
  work_order_definition_by_id: Maybe<GqlWorkOrderDefinitionGql>;
  work_order_items: Maybe<GqlWorkOrderItemGqlConnection>;
  work_order_item_by_id: Maybe<GqlWorkOrderItemGql>;
  work_order_reasons: Maybe<Array<Maybe<GqlWorkOrderReasonGql>>>;
  work_order_reason_by_id: Maybe<GqlWorkOrderReasonGql>;
  clusters: Maybe<GqlSalesAgentClusterGqlConnection>;
  cluster_by_id: Maybe<GqlSalesAgentClusterGql>;
  cluster_assignments: Maybe<GqlClusterAssignmentGqlConnection>;
  cluster_assignment_by_id: Maybe<GqlClusterAssignmentGql>;
  cluster_assignments_by_user_id: Maybe<Array<Maybe<GqlClusterAssignmentGql>>>;
  cluster_agent_earnings: Maybe<GqlClusterAgentEarningGqlConnection>;
  cluster_agent_earning_by_id: Maybe<GqlClusterAgentEarningGql>;
  cluster_earning_summary: Maybe<GqlClusterEarningSummaryGql>;
  agent_daily_order_summary: Maybe<GqlAgentDailyOrderSummaryGqlConnection>;
  segment_earnings_summary: Maybe<Array<Maybe<GqlSegmentEarningsSummaryGql>>>;
  agent_earnings: Maybe<Array<Maybe<GqlAgentEarningsGql>>>;
  agent_earnings_summary: Maybe<GqlAgentEarningsSummaryGql>;
  delivery_returns: Maybe<GqlDeliveryReturnGqlConnection>;
  delivery_return_by_id: Maybe<GqlDeliveryReturnGql>;
  delivery_return_items: Maybe<GqlDeliveryReturnItemGqlConnection>;
  delivery_return_item_by_id: Maybe<GqlDeliveryReturnItemGql>;
  order_returns: Maybe<GqlOrderReturnGqlConnection>;
  order_return_by_id: Maybe<GqlOrderReturnGql>;
  order_return_items: Maybe<GqlOrderReturnItemGqlConnection>;
  order_return_item_by_id: Maybe<GqlOrderReturnItemGql>;
  sales_return_reasons: Maybe<Array<Maybe<GqlReturnReasonGql>>>;
  sales_return_reason_by_id: Maybe<GqlReturnReasonGql>;
  return_item_rejection_reasons: Maybe<Array<Maybe<GqlReturnItemRejectionReasonGql>>>;
  return_item_rejection_reason_by_id: Maybe<GqlReturnItemRejectionReasonGql>;
  mcommerce_account_by_customer_id: Maybe<GqlMcommerceAccountGql>;
  stock_notifications: Maybe<GqlStockNotificationGqlConnection>;
  stock_notification_by_id: Maybe<GqlStockNotificationGql>;
  ordering_windows: Maybe<GqlOrderingWindowGqlConnection>;
  ordering_window_by_id: Maybe<GqlOrderingWindowGql>;
  ordering_window_items: Maybe<GqlOrderingWindowItemGqlConnection>;
  ordering_window_item_by_id: Maybe<GqlOrderingWindowItemGql>;
  mcommerce_faq_sections: Maybe<Array<Maybe<GqlMcommerceFaqSectionGql>>>;
  mcommerce_faq_section_by_id: Maybe<GqlMcommerceFaqSectionGql>;
  mcommerce_faqs: Maybe<GqlMcommerceFaqgqlConnection>;
  mcommerce_faq_by_id: Maybe<GqlMcommerceFaqgql>;
  payment_accounts_v2: Maybe<GqlPaymentAccountV2GqlConnection>;
  payment_account_v2_by_id: Maybe<GqlPaymentAccountV2Gql>;
  route_payment_accounts_v2: Maybe<GqlRoutePaymentAccountV2GqlConnection>;
  route_payment_account_v2_by_id: Maybe<GqlRoutePaymentAccountV2Gql>;
  route_payment_accounts_v2_by_route_id: Maybe<Array<Maybe<GqlRoutePaymentAccountV2Gql>>>;
  payments_v2: Maybe<GqlPaymentV2GqlConnection>;
  payment_v2_by_id: Maybe<GqlPaymentV2Gql>;
  payment_modes: Maybe<Array<Maybe<Scalars['String']>>>;
  payment_visibilities: Maybe<Array<Maybe<GqlPaymentVisibilityGql>>>;
  payment_visibility_by_id: Maybe<GqlPaymentVisibilityGql>;
  payment_methods: Maybe<Array<Maybe<GqlPaymentMethodGql>>>;
  payment_method_by_id: Maybe<GqlPaymentMethodGql>;
  route_till_alert_contacts: Maybe<GqlRouteTillAlertContactGqlConnection>;
  deliveries_v2: Maybe<GqlDeliveryV2GqlConnection>;
  delivery_v2_by_id: Maybe<GqlDeliveryV2Gql>;
  delivery_fee_schedules: Maybe<GqlDeliveryFeeScheduleGqlConnection>;
  delivery_fee_schedule_by_id: Maybe<GqlDeliveryFeeScheduleGql>;
  realized_revenue_v2: Maybe<GqlRealizedRevenueV2Gql>;
  delivery_items_v2: Maybe<GqlDeliveryItemV2GqlConnection>;
  delivery_item_v2_by_id: Maybe<GqlDeliveryItemV2Gql>;
  shop_delivery_summary_v2: Maybe<GqlShopDeliverySummaryV2Gql>;
  delivery_product_summary_v2: Maybe<GqlDeliveryProductSummaryV2GqlConnection>;
  delivery_item_warranties: Maybe<GqlDeliveryItemWarrantyGqlConnection>;
  delivery_item_warranty_by_id: Maybe<GqlDeliveryItemWarrantyGql>;
  trader_entities_v2: Maybe<Array<Maybe<GqlTraderEntityV2Gql>>>;
  trader_entity_v2_by_id: Maybe<GqlTraderEntityV2Gql>;
  orders_v2: Maybe<GqlOrderV2GqlConnection>;
  order_v2_by_id: Maybe<GqlOrderV2Gql>;
  current_orders_v2: Maybe<Array<Maybe<GqlOrderV2Gql>>>;
  order_items_v2: Maybe<GqlOrderItemV2GqlConnection>;
  order_item_v2_by_id: Maybe<GqlOrderItemV2Gql>;
  order_again: Maybe<GqlOrderAgainGql>;
  order_assignments_v2: Maybe<GqlOrderAssignmentV2GqlConnection>;
  order_assignment_v2_by_id: Maybe<GqlOrderAssignmentV2Gql>;
  all_stock_ordered_depot_summary: Maybe<Array<Maybe<GqlStockOrderedGql>>>;
  stock_ordered_depot_summary: Maybe<GqlStockOrderedGql>;
  stock_ordered_by_product_item: Maybe<GqlStockOrderedGql>;
  shop_order_summary_v2: Maybe<GqlShopOrderSummaryV2Gql>;
  order_product_summary_v2: Maybe<GqlOrderProductSummaryV2GqlConnection>;
  projected_revenue_v2: Maybe<GqlProjectedRevenueV2Gql>;
  route_plan_order_summary: Maybe<GqlRoutePlanOrderSummaryGql>;
  route_plan_order_summaries_by_route_plan_ids: Maybe<Array<Maybe<GqlRoutePlanOrderSummaryGql>>>;
  order_restrictions: Maybe<GqlOrderRestrictionGqlConnection>;
  depot_dc_product_item_restrictions: Maybe<GqlDepotDcProductItemRestrictionGqlConnection>;
  distribution_center_orders_summary: Maybe<Array<Maybe<GqlDistributionCenterOrderSummaryGql>>>;
  regions_v2: Maybe<GqlRegionV2GqlConnection>;
  region_v2_by_id: Maybe<GqlRegionV2Gql>;
  country_by_id: Maybe<GqlCountryGql>;
  countries_by_ids: Maybe<Array<Maybe<GqlCountryGql>>>;
  regions_v2_by_ids: Maybe<Array<Maybe<GqlRegionV2Gql>>>;
  areas_v2: Maybe<GqlAreaV2GqlConnection>;
  area_v2_by_id: Maybe<GqlAreaV2Gql>;
  depots_v2: Maybe<GqlDepotV2GqlConnection>;
  depot_v2_by_id: Maybe<GqlDepotV2Gql>;
  depots_v2_by_ids: Maybe<Array<Maybe<GqlDepotV2Gql>>>;
  route_types: Maybe<Array<Maybe<GqlRouteType>>>;
  routes_v2: Maybe<GqlRouteV2GqlConnection>;
  route_v2_by_id: Maybe<GqlRouteV2Gql>;
  routes_v2_by_ids: Maybe<Array<Maybe<GqlRouteV2Gql>>>;
  route_teams_v2: Maybe<GqlRouteTeamV2GqlConnection>;
  route_team_v2_by_id: Maybe<GqlRouteTeamV2Gql>;
  route_team_v2_by_user_id: Maybe<GqlRouteTeamV2Gql>;
  route_team_members_v2: Maybe<GqlRouteTeamMemberV2GqlConnection>;
  route_team_member_v2_by_id: Maybe<GqlRouteTeamMemberV2Gql>;
  countries: Maybe<Array<Maybe<GqlCountryGql>>>;
  depot_routing_summary: Maybe<GqlDepotRoutingSummaryGqlConnection>;
  customers_v2: Maybe<GqlCustomerV2GqlConnection>;
  customer_v2_by_id: Maybe<GqlCustomerV2Gql>;
  phone_number_change_reasons: Maybe<Array<Maybe<GqlPhoneNumberChangeReasonGql>>>;
  phone_number_change_approvals: Maybe<Array<Maybe<GqlPhoneNumberChangeApprovalGql>>>;
  shops_v2: Maybe<GqlShopV2GqlConnection>;
  shops_v2_by_customer_id: Maybe<Array<Maybe<GqlShopV2Gql>>>;
  shop_v2_by_id: Maybe<GqlShopV2Gql>;
  shop_types_v2: Maybe<Array<Maybe<GqlShopTypeV2Gql>>>;
  shop_type_v2_by_id: Maybe<GqlShopTypeV2Gql>;
  customer_types_v2: Maybe<Array<Maybe<GqlCustomerTypeV2Gql>>>;
  vendor_kyc: Maybe<GqlVendorKycgqlConnection>;
  vendor_kyc_by_id: Maybe<GqlVendorKycgql>;
  customer_type_v2_by_id: Maybe<GqlCustomerTypeV2Gql>;
  customer_v2_by_phone_number: Maybe<GqlCustomerV2Gql>;
  vendor_finance_plans: Maybe<Array<Maybe<GqlVendorFinancePlanGql>>>;
  delivery_fee_by_shop_id: Maybe<GqlShopDeliveryFeeGql>;
  shops_v2_by_ids: Maybe<Array<Maybe<GqlShopV2Gql>>>;
  returns_handling_unit_items: Maybe<GqlReturnsHandlingUnitItemGqlConnection>;
  returns_handling_units: Maybe<GqlReturnsHandlingUnitGqlConnection>;
  wms_returns: Maybe<GqlWmsReturnsGqlConnection>;
  disposal_items: Maybe<GqlDisposalItemGqlConnection>;
  disposals: Maybe<GqlDisposalGqlConnection>;
  warehouse_transfer_request_items: Maybe<GqlWarehouseTransferRequestItemGqlConnection>;
  warehouse_transfer_requests: Maybe<GqlWarehouseTransferRequestGqlConnection>;
  fdr_skus: Maybe<GqlFdrskugqlConnection>;
  fulfilment_dispatch_request_items: Maybe<GqlFulfilmentDispatchRequestItemGqlConnection>;
  fulfilment_dispatch_requests: Maybe<GqlFulfilmentDispatchRequestGqlConnection>;
  reserve_picking_jobs: Maybe<GqlReservePickingJobGqlConnection>;
  pickface_picking_tasks: Maybe<GqlPickFacePickingTaskGqlConnection>;
  picking_handling_units: Maybe<GqlPickingHandlingUnitGqlConnection>;
  pickface_picking_task_items: Maybe<GqlPickFacePickingTaskItemGqlConnection>;
  loading_tasks: Maybe<GqlLoadingTaskGqlConnection>;
  loading_task_items: Maybe<GqlLoadingTaskItemGqlConnection>;
  /** The ID of the object */
  node: Maybe<GqlNode>;
  putaway_jobs: Maybe<GqlPutAwayJobGqlConnection>;
  product_zones: Maybe<GqlProductZoneGqlConnection>;
  rules: Maybe<GqlRuleGqlConnection>;
  product_rules: Maybe<GqlProductRuleGqlConnection>;
  category_rules: Maybe<GqlCategoryRuleGqlConnection>;
  handling_units: Maybe<GqlHandlingUnitGqlConnection>;
  stock_intake_skus: Maybe<GqlStockIntakeSkuGqlConnection>;
  handling_unit_items: Maybe<GqlHandlingUnitItemGqlConnection>;
  storage_locations: Maybe<GqlStorageLocationGqlConnection>;
  storage_location_types: Maybe<GqlStorageLocationTypeGqlConnection>;
  product_loss_reasons: Maybe<GqlProductLossReasonGqlConnection>;
  product_loss_reason_by_id: Maybe<GqlProductLossReasonGql>;
  product_loss_reason_by_product_id: Maybe<GqlProductLossReasonGql>;
  storage_unit_types: Maybe<Array<Maybe<GqlStorageUnitTypeGql>>>;
  dock_doors: Maybe<GqlDockDoorGqlConnection>;
  filter_bins: Maybe<Array<Maybe<GqlCustomBinGql>>>;
  bins: Maybe<GqlBinGqlConnection>;
  bin_names: Maybe<GqlBinNameGqlConnection>;
  waste_areas: Maybe<GqlWasteAreaGqlConnection>;
  appointment_items: Maybe<GqlAppointmentItemGqlConnection>;
  appointment_item_by_batch_id: Maybe<Array<Maybe<GqlAppointmentItemGql>>>;
  appointments: Maybe<GqlAppointmentGqlConnection>;
  warehouses: Maybe<GqlWarehouseGqlConnection>;
  stock_intakes: Maybe<GqlStockIntakeGqlConnection>;
  stock_intake_by_id: Maybe<GqlStockIntakeGql>;
  stock_intake_items: Maybe<GqlStockIntakeItemGqlConnection>;
  stock_intake_item_by_id: Maybe<GqlStockIntakeItemGql>;
  stock_intake_items_by_batch_id: Maybe<GqlStockIntakeItemBatchGql>;
  processing_loss: Maybe<GqlProcessingLossGqlConnection>;
  processing_loss_by_id: Maybe<GqlProcessingLossGql>;
  processing_loss_items: Maybe<GqlProcessingLossItemGqlConnection>;
  processing_loss_item_by_id: Maybe<GqlProcessingLossItemGql>;
  storage_units: Maybe<GqlStorageUnitGqlConnection>;
  storage: Maybe<GqlStorageGqlConnection>;
  storage_by_id: Maybe<GqlStorageGql>;
  v2_stock_availability: Maybe<GqlStockAvailabilityGqlConnection>;
  v2_stock_availability_by_id: Maybe<GqlStockAvailabilityGqLv2>;
  v2_stock_availability_product_item_summary: Maybe<GqlStockAvailabilitySummaryGqlConnection>;
  stock_availability_by_product_item: Maybe<GqlStockAvailabilityProductItemGqlConnection>;
  v2_stock_availability_by_product_item_id: Maybe<GqlStockAvailabilityGqLv2>;
  dc_stock_availability_by_product_item_id: Maybe<GqlDcStockAvailabilityGql>;
  loss_reasons: Maybe<Array<Maybe<GqlLossReasonGql>>>;
  loss_reason_by_id: Maybe<GqlLossReasonGql>;
  processing_loss_types: Maybe<GqlProcessingLossTypeGqlConnection>;
  processing_loss_type_by_id: Maybe<GqlProcessingLossTypeGql>;
  inventory_by_product_item: Maybe<GqlInventoryGql>;
  stock_intake_weight_by_batch_id: Maybe<Scalars['Float']>;
  processing_loss_weight_by_batch_id: Maybe<Scalars['Float']>;
  distribution_centers: Maybe<Array<Maybe<GqlDistributionCenterGql>>>;
  distribution_centers_v2: Maybe<GqlDistributionCenterGqlConnection>;
  distribution_center_by_id: Maybe<GqlDistributionCenterGql>;
  distribution_centers_by_ids: Maybe<Array<Maybe<GqlDistributionCenterGql>>>;
  stock_take: Maybe<GqlStockTakeGqlConnection>;
  stock_take_by_id: Maybe<GqlStockTakeGql>;
  stock_take_location: Maybe<GqlStockTakeLocationGqlConnection>;
  stock_take_location_by_id: Maybe<GqlStockTakeLocationGql>;
  warehouse_transfer_item: Maybe<GqlWarehouseTransferItemGqlConnection>;
  warehouse_transfer_item_by_id: Maybe<GqlWarehouseTransferItemGql>;
  warehouse_transfer_reason: Maybe<GqlWarehouseTransferReasonGqlConnection>;
  warehouse_transfer: Maybe<GqlWarehouseTransferGqlConnection>;
  warehouse_transfer_by_id: Maybe<GqlWarehouseTransferGql>;
  assets: Maybe<GqlAssetGqlConnection>;
  asset_by_id: Maybe<GqlAssetGql>;
  asset_types: Maybe<Array<Maybe<GqlAssetTypeGql>>>;
  asset_photos: Maybe<GqlAssetPhotoGqlConnection>;
  asset_photo_by_id: Maybe<GqlAssetPhotoGql>;
  damaged_asset_photos: Maybe<GqlDamagedAssetPhotoGqlConnection>;
  damaged_asset_photo_by_id: Maybe<GqlDamagedAssetPhotoGql>;
  asset_status: Maybe<Array<GqlAssetStatus>>;
  asset_trackers: Maybe<GqlAssetTrackerGqlConnection>;
  asset_tracker_by_id: Maybe<GqlAssetTrackerGql>;
  asset_tracker_items: Maybe<GqlAssetTrackerItemGqlConnection>;
  asset_tracker_item_by_id: Maybe<GqlAssetTrackerItemGql>;
  inventory_locations: Maybe<GqlInventoryLocationGqlConnection>;
  inventory_location_by_id: Maybe<GqlInventoryLocationGql>;
  inventory_location_type: Maybe<Array<Maybe<Scalars['String']>>>;
  asset_controls: Maybe<GqlAssetControlGqlConnection>;
  asset_control_by_id: Maybe<GqlAssetControlGql>;
  appointment_types: Maybe<Array<GqlAppointmentType>>;
  stock_availability_status: Maybe<Array<Maybe<GqlStockAvailabilityStatus>>>;
  stock_intake_status: Maybe<Array<Maybe<GqlStockIntakeStatus>>>;
  stock_intake_type: Maybe<Array<GqlStockIntakeType>>;
  stock_intake_item_status: Maybe<Array<Maybe<GqlStockIntakeItemStatus>>>;
  product_zone_types: Maybe<Array<Maybe<Scalars['String']>>>;
  product_locations: Maybe<GqlProductLocationGqlConnection>;
  product_transfer_reasons: Maybe<GqlProductTransferReasonGqlConnection>;
  product_transfer_reason_by_id: Maybe<GqlProductTransferReasonGql>;
  product_transfers: Maybe<GqlProductTransferGqlConnection>;
  product_transfer_by_id: Maybe<GqlProductTransferGql>;
  product_transfer_type: Maybe<Array<GqlProductTransferType>>;
  product_transfer_handling_units: Maybe<GqlProductTransferHandlingUnitGqlConnection>;
  product_transfer_handling_unit_by_id: Maybe<GqlProductTransferHandlingUnitGql>;
  product_transfer_handling_unit_items: Maybe<GqlProductTransferHandlingUnitItemGqlConnection>;
  product_transfer_handling_unit_item_by_id: Maybe<GqlProductTransferHandlingUnitItemGql>;
  paginated_product_items_v2: Maybe<GqlProductItemV2GqlConnection>;
  product_items_v2_by_ids: Maybe<Array<Maybe<GqlProductItemV2Gql>>>;
  product_item_v2_by_id: Maybe<GqlProductItemV2Gql>;
  product_items_v2: Maybe<Array<Maybe<GqlProductItemV2Gql>>>;
  product_item_segments_v2: Maybe<Array<Maybe<GqlProductItemSegmentV2Gql>>>;
  product_item_segment_v2_by_id: Maybe<GqlProductItemSegmentV2Gql>;
  bundle_association_v2_by_sku: Maybe<Array<Maybe<GqlBundleAssociationV2Gql>>>;
  product_promotional_banners_v2: Maybe<Array<Maybe<GqlProductPromotionalBannerV2Gql>>>;
  product_promotional_banner_v2_by_id: Maybe<GqlProductPromotionalBannerV2Gql>;
  product_items_with_tags: Maybe<Array<Maybe<GqlPromotionTagGql>>>;
  promotion_tag_by_id: Maybe<GqlPromotionTagGql>;
  promotion_types: Maybe<Array<Maybe<GqlPromotionTypeGql>>>;
  promotion_type_by_id: Maybe<GqlPromotionTypeGql>;
  product_categories_v2: Maybe<Array<Maybe<GqlCategoryV2Gql>>>;
  product_category_v2_by_id: Maybe<GqlCategoryV2Gql>;
  product_categories_v2_by_department_id: Maybe<Array<Maybe<GqlCategoryV2Gql>>>;
  product_departments_v2: Maybe<Array<Maybe<GqlDepartmentV2Gql>>>;
  product_department_v2_by_id: Maybe<GqlDepartmentV2Gql>;
  uoms_v2: Maybe<GqlUomv2GqlConnection>;
  uom_v2_by_id: Maybe<GqlUomv2Gql>;
  business_domains_v2: Maybe<Array<Maybe<GqlBusinessDomainV2Gql>>>;
  uom_v2_by_ids: Maybe<Array<Maybe<GqlUomv2Gql>>>;
  product_item_uoms_v2: Maybe<GqlProductItemUomv2GqlConnection>;
  product_item_uom_v2_by_id: Maybe<GqlProductItemUomv2Gql>;
  product_item_uom_v2_by_ids: Maybe<Array<Maybe<GqlProductItemUomv2Gql>>>;
  paginated_products_v2: Maybe<GqlProductV2GqlConnection>;
  product_v2_by_id: Maybe<GqlProductV2Gql>;
  product_v2_by_ids: Maybe<Array<Maybe<GqlProductV2Gql>>>;
  packaging_units_v2: Maybe<GqlPackagingUnitV2GqlConnection>;
  packaging_unit_v2_by_id: Maybe<GqlPackagingUnitV2Gql>;
  packaging_unit_v2_by_ids: Maybe<Array<Maybe<GqlPackagingUnitV2Gql>>>;
  product_types_v2: Maybe<Array<Maybe<Scalars['String']>>>;
  finance_product_types: Maybe<Array<Maybe<GqlFinanceProductTypeGql>>>;
  finance_product_type_by_id: Maybe<GqlFinanceProductTypeGql>;
  standard_unit_costs: Maybe<Array<Maybe<GqlStandardUnitCostGql>>>;
  standard_unit_cost_by_id: Maybe<GqlStandardUnitCostGql>;
  standard_unit_cost_by_product_id: Maybe<GqlStandardUnitCostGql>;
  product_varieties: Maybe<GqlProductVarietyGqlConnection>;
  dispatches: Maybe<GqlDispatchGqlConnection>;
  dispatch: Maybe<GqlDispatchGqlConnection>;
  dispatch_by_id: Maybe<GqlDispatchGql>;
  dispatch_by_route_id: Maybe<GqlDispatchGql>;
  dispatch_item_by_id: Maybe<GqlDispatchItemGql>;
  dispatch_items: Maybe<GqlDispatchItemGqlConnection>;
  stock_transfers: Maybe<GqlStockTransferGqlConnection>;
  stock_transfer: Maybe<GqlStockTransferGqlConnection>;
  stock_transfer_by_id: Maybe<GqlStockTransferGql>;
  stock_transfer_item_by_id: Maybe<GqlStockTransferItemGql>;
  stock_transfer_items: Maybe<GqlStockTransferItemGqlConnection>;
  dispatch_balance: Maybe<GqlDispatchBalanceGql>;
  depot_intakes: Maybe<GqlDepotIntakeGqlConnection>;
  depot_intake: Maybe<GqlDepotIntakeGqlConnection>;
  depot_intake_by_id: Maybe<GqlDepotIntakeGql>;
  depot_intake_item_by_id: Maybe<GqlDepotIntakeItemGql>;
  depot_intake_items: Maybe<GqlDepotIntakeItemGqlConnection>;
  returns: Maybe<GqlReturnGqlConnection>;
  return_by_id: Maybe<GqlReturnGql>;
  product_return_item_by_id: Maybe<GqlProductReturnItemGql>;
  product_return_items: Maybe<GqlProductReturnItemGqlConnection>;
  packaging_return_item_by_id: Maybe<GqlPackagingReturnItemGql>;
  packaging_return_items: Maybe<GqlPackagingReturnItemGqlConnection>;
  dispatch_product_summary_v2: Maybe<GqlDispatchProductSummaryV2GqlConnection>;
  projected_ph_revenue_v2: Maybe<GqlProjectedPhRevenueV2Gql>;
  vehicle_stock_allocations: Maybe<GqlVehicleStockAllocationGqlConnection>;
  vehicle_stock_allocation_by_id: Maybe<GqlVehicleStockAllocationGql>;
  batches: Maybe<GqlBatchGqlConnection>;
  batch_by_id: Maybe<GqlBatchGql>;
  articles: Maybe<GqlArticleGqlConnection>;
  article_by_id: Maybe<GqlArticleGql>;
  saved_articles: Maybe<GqlSavedArticleGqlConnection>;
  saved_article_by_id: Maybe<GqlSavedArticleGql>;
  bids: Maybe<GqlBidGqlConnection>;
  bid_applications: Maybe<GqlBidApplicationGqlConnection>;
  bid_by_id: Maybe<GqlBidGql>;
  bids_by_category_ids: Maybe<GqlBidGqlConnection>;
  count_bids_by_category_ids: Maybe<Scalars['Int']>;
  bid_application_by_id: Maybe<GqlBidApplicationGql>;
  bid_status: Maybe<Array<Maybe<GqlBidStatus>>>;
  bid_application_status: Maybe<Array<Maybe<GqlBidApplicationStatus>>>;
  bid_application_status_type: Maybe<Array<Maybe<GqlBidApplicationType>>>;
  bid_application_by_agent_id: Maybe<GqlBidApplicationGqlConnection>;
  bid_application_by_vehicle_registration: Maybe<GqlBidApplicationGqlConnection>;
  currency: Maybe<Array<Maybe<GqlCurrency>>>;
  harvests: Maybe<GqlHarvestGqlConnection>;
  harvest_issues: Maybe<Array<Maybe<GqlHarvestIssueGql>>>;
  harvest_issue_types: Maybe<Array<Maybe<GqlHarvestIssueTypeGql>>>;
  harvest_by_id: Maybe<GqlHarvestGql>;
  harvest_issues_by_harvest_id: Maybe<Array<Maybe<GqlHarvestIssueGql>>>;
  payment_details: Maybe<GqlPaymentDetailGqlConnection>;
  harvest_items: Maybe<GqlHarvestItemGqlConnection>;
  harvest_item_by_id: Maybe<GqlHarvestItemGql>;
  harvest_item_assets: Maybe<GqlHarvestItemAssetGqlConnection>;
  harvest_item_assets_by_id: Maybe<GqlHarvestItemAssetGqlConnection>;
  payment_account_types: Maybe<Array<Maybe<GqlPaymentAccountType>>>;
  farmer_types: Maybe<Array<Maybe<GqlFarmerType>>>;
  farmers: Maybe<GqlFarmerGqlConnection>;
  farmers_by_collection_center_id: Maybe<Array<Maybe<GqlFarmerGql>>>;
  farmers_by_area_id: Maybe<Array<Maybe<GqlFarmerGql>>>;
  farmer_by_id: Maybe<GqlFarmerGql>;
  sourcing_agents: Maybe<GqlSourcingAgentGqlConnection>;
  sourcing_agent_by_id: Maybe<GqlSourcingAgentGql>;
  farm_by_id: Maybe<GqlFarmGql>;
  farms: Maybe<GqlFarmGqlConnection>;
  farms_by_farmer_id: Maybe<Array<Maybe<GqlFarmGql>>>;
  farmer_payment_accounts: Maybe<GqlFarmerPaymentAccountGqlConnection>;
  agent_feedback: Maybe<GqlAgentFeedbackGqlConnection>;
  agent_feedback_by_id: Maybe<GqlAgentFeedbackGql>;
  categories: Maybe<Array<Maybe<Scalars['GenericScalar']>>>;
  discovery_methods: Maybe<Array<Maybe<GqlDiscoveryGql>>>;
  supplier_user_by_supplier_id: Maybe<GqlSupplierUserGqlConnection>;
  supplier_product_by_supplier_id: Maybe<GqlSupplierProductGqlConnection>;
  booking_by_id: Maybe<GqlBookingGql>;
  bookings: Maybe<GqlBookingGqlConnection>;
  sourcing_price_range: Maybe<GqlPriceRangeGqlConnection>;
  sourcing_price_range_by_id: Maybe<GqlPriceRangeGql>;
  sourcing_price_range_by_product_id: Maybe<GqlPriceRangeGql>;
  booking_items: Maybe<GqlBookingItemGqlConnection>;
  booking_item_by_id: Maybe<GqlBookingItemGql>;
  areas: Maybe<Array<Maybe<GqlAreaGql>>>;
  blocks: Maybe<Array<Maybe<GqlBlockGql>>>;
  pivots: Maybe<Array<Maybe<GqlPivotGql>>>;
  area_by_id: Maybe<GqlAreaGql>;
  collection_centers: Maybe<Array<Maybe<GqlCollectionCenterGql>>>;
  collection_centers_by_area_id: Maybe<Array<Maybe<GqlCollectionCenterGql>>>;
  collection_center_by_id: Maybe<GqlCollectionCenterGql>;
  harvest_areas: Maybe<Array<Maybe<GqlHarvestAreaGql>>>;
  harvest_area_by_id: Maybe<GqlHarvestAreaGql>;
  harvest_areas_by_collection_center_id: Maybe<Array<Maybe<GqlHarvestAreaGql>>>;
  permissions_v2: Maybe<GqlPermissionV2GqlConnection>;
  permission_v2_by_id: Maybe<GqlPermissionV2Gql>;
  users_v2: Maybe<GqlUserV2GqlConnection>;
  user_v2_by_id: Maybe<GqlUserV2Gql>;
  users_v2_by_permissions: Maybe<Array<Maybe<GqlUserV2Gql>>>;
  user_v2_by_id_or_number: Maybe<GqlUserV2Gql>;
  users_v2_by_ids: Maybe<Array<Maybe<GqlUserV2Gql>>>;
  roles_v2: Maybe<GqlRoleV2GqlConnection>;
  role_v2_by_id: Maybe<GqlRoleV2Gql>;
  feedbacks: Maybe<Array<GqlFeedback>>;
  promoter_score: Maybe<Array<GqlNps>>;
  meta_data: Maybe<GqlMetaData>;
  average_user_rating: Maybe<GqlAverageRating>;
  notification_templates: Maybe<GqlNotificationTemplateGqlConnection>;
  notification_template_by_id: Maybe<GqlNotificationTemplateGql>;
  notifications: Maybe<GqlNotificationMessageGqlConnection>;
  notification_by_id: Maybe<GqlNotificationMessageGql>;
  notification_messages_by_user_id: Maybe<GqlNotificationMessageGqlConnection>;
  notification_providers: Maybe<GqlNotificationProviderGqlConnection>;
  notification_provider_by_id: Maybe<GqlNotificationProviderGql>;
  status: Scalars['String'];
  taxInvoice: Maybe<GqlTaxInvoice>;
  hsCodes: Array<GqlHsCode>;
  checklist_sections: Maybe<Array<Maybe<GqlChecklistSectionGql>>>;
  checklist_section_by_id: Maybe<GqlChecklistSectionGql>;
  checklist_questions: Maybe<GqlChecklistQuestionGqlConnection>;
  checklist_question_by_id: Maybe<GqlChecklistQuestionGql>;
  checklist_entries: Maybe<GqlChecklistEntryGqlConnection>;
  checklist_entry_by_id: Maybe<GqlChecklistEntryGql>;
  incident_categories: Maybe<Array<Maybe<GqlIncidentCategoryGql>>>;
  incidents: Maybe<GqlIncidentGqlConnection>;
  incident_by_id: Maybe<GqlIncidentGql>;
  vehicle_cost_models: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicle_rejection_reasons: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicle_suppliers: Maybe<GqlVehicleSupplierGqlConnection>;
  vehicle_supplier_payment_accounts: Maybe<GqlVehicleSupplierPaymentAccountGqlConnection>;
  trips: Maybe<GqlTripGqlConnection>;
  vehicle_supplier_statement_files: Maybe<GqlVehicleSupplierStatementFileGqlConnection>;
  vehicle_supplier_statements: Maybe<GqlVehicleSupplierStatementGqlConnection>;
  vehicle_types: Maybe<GqlVehicleTypeGqlConnection>;
  vehicle_type_by_id: Maybe<GqlVehicleTypeGql>;
  vehicles: Maybe<GqlVehicleGqlConnection>;
  vehicle_by_id: Maybe<GqlVehicleGql>;
  route_plans: Maybe<GqlRoutePlanGqlConnection>;
  route_plan_by_id: Maybe<GqlRoutePlanGql>;
  route_plans_by_ids: Maybe<Array<Maybe<GqlRoutePlanGql>>>;
  fulfillment_teams: Maybe<GqlFulfillmentTeamGqlConnection>;
  fulfillment_team_by_id: Maybe<GqlFulfillmentTeamGql>;
  static_routes: Maybe<GqlStaticRouteGqlConnection>;
  static_route_by_id: Maybe<GqlStaticRouteGql>;
  depot_route_plan_summary: Maybe<GqlDepotRoutePlanSummaryGql>;
  pseudo_routes: Maybe<GqlPseudoRouteGqlConnection>;
  pseudo_route_by_id: Maybe<GqlPseudoRouteGql>;
};


export type GqlQueryCompanyArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryCompany_By_IdArgs = {
  company_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAccountArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryAccount_By_IdArgs = {
  account_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAccount_By_Entity_IdArgs = {
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAccount_By_Dms_Entity_IdArgs = {
  active: Maybe<Scalars['Boolean']>;
  entity_id: Scalars['UUID'];
};


export type GqlQueryTransaction_TypesArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryTransaction_Type_By_IdArgs = {
  transaction_type_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLedgerentryArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryLedgerentries_By_Entity_IdArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  entity_id: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryLedgerentries_By_Ent_IdArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  entity_id: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryLedgerentry_By_IdArgs = {
  ledgerentry_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryServiceArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryService_By_IdArgs = {
  service_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPermissionArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryPermission_By_IdArgs = {
  permission_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoleArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRole_By_IdArgs = {
  role_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryInbound_PaymentArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryInbound_Payment_ConfigArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryInbound_Payment_By_IdArgs = {
  inbound_payment_config_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryInbound_Payment_ProviderArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryInbound_Payment_Provider_By_IdArgs = {
  inbound_payment_provider_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPaymentArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  start: Maybe<Scalars['String']>;
  end: Maybe<Scalars['String']>;
  sort: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryPayment_By_IdArgs = {
  payment_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPartyArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryParty_By_IdArgs = {
  party_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_ProviderArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryPayment_Provider_By_IdArgs = {
  payment_provider_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_Provider_ModeArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryPayment_Provider_Mode_By_IdArgs = {
  payment_provider_mode_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_ModeArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryPayment_Mode_By_IdArgs = {
  payment_mode_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryParty_MappingArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryParty_Mapping_By_IdArgs = {
  payment_mapping_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLeadCallbackConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type GqlQueryOrderCallbackConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type GqlQueryLoanOfferConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type GqlQueryLoanRequestConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type GqlQueryCustomerPartnerConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlCustomerPartnerConnectionFilters>;
};


export type GqlQueryCustomerConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlCustomerConnectionFilters>;
};


export type GqlQueryPartnerConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlPartnerConnectionFilters>;
};


export type GqlQueryPartnerTopupConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlPartnerTopupConnectionFilters>;
};


export type GqlQueryPartnerUpdateConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlPartnerUpdateConnectionFilters>;
};


export type GqlQueryPartnerEarningConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlPartnerEarningConnectionFilters>;
};


export type GqlQueryLoanProductConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlLoanProductConnectionFilters>;
};


export type GqlQueryDepotPartnerConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type GqlQueryLoanConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlLoanConnectionFilters>;
};


export type GqlQueryLoanUpdateConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlLoanUpdateConnectionFilters>;
};


export type GqlQueryLoanRepaymentConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: Maybe<GqlLoanRepaymentConnectionFilters>;
};


export type GqlQueryLoanRejectionReasonArgs = {
  filters: Maybe<GqlLoanRejectionReasonFilters>;
};


export type GqlQuerySuppliersArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySupplier_By_IdArgs = {
  supplier_id: Scalars['String'];
};


export type GqlQuerySupplier_UsersArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySupplier_User_By_IdArgs = {
  supplier_user_id: Maybe<Scalars['String']>;
};


export type GqlQuerySupplier_ProductsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySupplier_Product_By_IdArgs = {
  supplier_product_id: Maybe<Scalars['String']>;
};


export type GqlQuerySupplier_CampaignsArgs = {
  supplier_id: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySupplier_Campaigns_By_IdArgs = {
  supplier_campaign_id: Scalars['String'];
};


export type GqlQueryDigitalServicesArgs = {
  filters: Maybe<GqlDigitalServiceFilters>;
};


export type GqlQueryDigitalProductsArgs = {
  filters: Maybe<GqlDigitalProductFilters>;
};


export type GqlQueryDigitalTransactionsArgs = {
  next?: Scalars['Int'];
  after?: Scalars['String'];
  filters: Maybe<GqlDigitalTransactionFilters>;
};


export type GqlQueryDigitalServiceArgs = {
  id: Scalars['UUID'];
};


export type GqlQueryDigitalProductArgs = {
  id: Scalars['UUID'];
};


export type GqlQueryDigitalTransactionArgs = {
  id: Scalars['UUID'];
};


export type GqlQuerySokoloan_RepaymentsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQuerySokoloan_Repayment_By_IdArgs = {
  sokoloan_repayment_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLead_CallbacksArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryLead_Callback_By_IdArgs = {
  active: Maybe<Scalars['Boolean']>;
  lead_callback_id: Scalars['UUID'];
};


export type GqlQueryFintech_LoansArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryFintech_Loans_By_Customer_IdArgs = {
  customer_id: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryFintech_Loan_By_IdArgs = {
  loan_confirmation_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLoan_OffersArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryLoan_Offer_By_Delivery_IdArgs = {
  delivery_id: Scalars['String'];
};


export type GqlQueryLoan_Offer_By_IdArgs = {
  loan_offer_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLoan_RequestsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryLoan_Request_By_IdArgs = {
  loan_request_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPartner_Loan_Query_By_Customer_IdArgs = {
  customer_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPartner_Member_Query_By_Customer_IdArgs = {
  customer_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFintech_DeliveriesArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryFintech_Deliveries_By_Customer_IdArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  customer_id: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryFintech_CustomersArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryFintech_Customer_By_IdArgs = {
  fintech_customer_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFintech_PartnersArgs = {
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryFintech_Partner_By_IdArgs = {
  partner_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPricing_V2Args = {
  filter: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryPricing_V2_By_IdArgs = {
  pricing_id: Maybe<Scalars['String']>;
};


export type GqlQueryPricing_V2_By_Product_Item_IdArgs = {
  product_item_id: Maybe<Scalars['String']>;
  region_id: Scalars['String'];
};


export type GqlQueryPricing_V2_By_Region_IdArgs = {
  region_id: Maybe<Scalars['String']>;
};


export type GqlQueryDynamic_PricingArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  valid_only: Maybe<Scalars['Boolean']>;
  exclude_markdowns: Maybe<Scalars['Boolean']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryDynamic_Pricing_By_IdArgs = {
  dynamic_pricing_id: Maybe<Scalars['String']>;
};


export type GqlQueryPrice_ComparisonArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  product_item_id: Scalars['UUID'];
  depot_id: Scalars['UUID'];
  pricing_date: Scalars['Date'];
  static_params: Scalars['GenericScalar'];
};


export type GqlQueryWork_OrdersArgs = {
  cluster_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWork_Order_By_IdArgs = {
  work_order_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWork_Order_Definition_By_IdArgs = {
  definition_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWork_Order_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWork_Order_Item_By_IdArgs = {
  work_order_item_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWork_Order_Reason_By_IdArgs = {
  reason_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryClustersArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_By_IdArgs = {
  cluster_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_AssignmentsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_Assignment_By_IdArgs = {
  assignment_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_Assignments_By_User_IdArgs = {
  user_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
};


export type GqlQueryCluster_Agent_EarningsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_Agent_Earning_By_IdArgs = {
  agent_earning_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCluster_Earning_SummaryArgs = {
  delivery_date: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['String']>;
  end_date: Maybe<Scalars['String']>;
  agent_id: Scalars['String'];
};


export type GqlQueryAgent_Daily_Order_SummaryArgs = {
  agent_id: Scalars['String'];
  delivery_date: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySegment_Earnings_SummaryArgs = {
  start_date: Scalars['String'];
  end_date: Scalars['String'];
  agent_id: Scalars['String'];
};


export type GqlQueryAgent_EarningsArgs = {
  start_date: Scalars['String'];
  end_date: Scalars['String'];
  agent_id: Scalars['String'];
};


export type GqlQueryAgent_Earnings_SummaryArgs = {
  start_date: Scalars['String'];
  end_date: Scalars['String'];
  agent_id: Scalars['String'];
};


export type GqlQueryDelivery_ReturnsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryDelivery_Return_By_IdArgs = {
  return_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Return_ItemsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDelivery_Return_Item_By_IdArgs = {
  return_item_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_ReturnsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryOrder_Return_By_IdArgs = {
  return_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_Return_ItemsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryOrder_Return_Item_By_IdArgs = {
  return_item_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySales_Return_ReasonsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQuerySales_Return_Reason_By_IdArgs = {
  reason_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryReturn_Item_Rejection_ReasonsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryReturn_Item_Rejection_Reason_By_IdArgs = {
  rejection_reason_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryMcommerce_Account_By_Customer_IdArgs = {
  customer_id: Scalars['String'];
};


export type GqlQueryStock_NotificationsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Notification_By_IdArgs = {
  stock_notification_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrdering_WindowsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrdering_Window_By_IdArgs = {
  ordering_window_id: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrdering_Window_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrdering_Window_Item_By_IdArgs = {
  ordering_window_item_id: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryMcommerce_Faq_Section_By_IdArgs = {
  faq_section_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryMcommerce_FaqsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryMcommerce_Faq_By_IdArgs = {
  faq_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_Accounts_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_Account_V2_By_IdArgs = {
  payment_account_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Payment_Accounts_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Payment_Account_V2_By_IdArgs = {
  route_payment_account_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Payment_Accounts_V2_By_Route_IdArgs = {
  route_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayments_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_V2_By_IdArgs = {
  payment_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_VisibilitiesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_Visibility_By_IdArgs = {
  payment_visibility_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_MethodsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPayment_Method_By_IdArgs = {
  payment_method_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Till_Alert_ContactsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDeliveries_V2Args = {
  cluster_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_V2_By_IdArgs = {
  delivery_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Fee_SchedulesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Fee_Schedule_By_IdArgs = {
  schedule_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRealized_Revenue_V2Args = {
  route_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
};


export type GqlQueryDelivery_Items_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Item_V2_By_IdArgs = {
  delivery_item_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryShop_Delivery_Summary_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryDelivery_Product_Summary_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Item_WarrantiesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDelivery_Item_Warranty_By_IdArgs = {
  warranty_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryTrader_Entities_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryTrader_Entity_V2_By_IdArgs = {
  trader_entity_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrders_V2Args = {
  sort_order: Maybe<Scalars['Int']>;
  cluster_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_V2_By_IdArgs = {
  order_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCurrent_Orders_V2Args = {
  shop_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_Items_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_Item_V2_By_IdArgs = {
  order_item_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_AgainArgs = {
  shop_id: Scalars['String'];
};


export type GqlQueryOrder_Assignments_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryOrder_Assignment_V2_By_IdArgs = {
  order_assignment_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAll_Stock_Ordered_Depot_SummaryArgs = {
  depot_name: Maybe<Scalars['String']>;
  delivery_date: Scalars['String'];
  time_window: Scalars['String'];
};


export type GqlQueryStock_Ordered_Depot_SummaryArgs = {
  depot_id: Scalars['String'];
  product_item_id: Scalars['String'];
  delivery_date: Scalars['String'];
};


export type GqlQueryStock_Ordered_By_Product_ItemArgs = {
  product_item_id: Maybe<Scalars['String']>;
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  sale_date: Maybe<Scalars['String']>;
  depot_id: Scalars['String'];
};


export type GqlQueryShop_Order_Summary_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryOrder_Product_Summary_V2Args = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProjected_Revenue_V2Args = {
  route_id: Maybe<Scalars['String']>;
  sale_date: Maybe<Scalars['String']>;
};


export type GqlQueryRoute_Plan_Order_SummaryArgs = {
  route_plan_id: Maybe<Scalars['String']>;
};


export type GqlQueryRoute_Plan_Order_Summaries_By_Route_Plan_IdsArgs = {
  route_plan_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryOrder_RestrictionsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDepot_Dc_Product_Item_RestrictionsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDistribution_Center_Orders_SummaryArgs = {
  distribution_center_id: Maybe<Scalars['String']>;
  route_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  route_plan_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  sale_date: Scalars['String'];
  end_time: Scalars['String'];
  start_time: Scalars['String'];
};


export type GqlQueryRegions_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRegion_V2_By_IdArgs = {
  region_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCountry_By_IdArgs = {
  country_id: Maybe<Scalars['String']>;
};


export type GqlQueryCountries_By_IdsArgs = {
  country_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryRegions_V2_By_IdsArgs = {
  region_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryAreas_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryArea_V2_By_IdArgs = {
  area_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDepots_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryDepot_V2_By_IdArgs = {
  depot_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDepots_V2_By_IdsArgs = {
  depot_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryRoutes_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRoute_V2_By_IdArgs = {
  route_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoutes_V2_By_IdsArgs = {
  route_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryRoute_Teams_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRoute_Team_V2_By_IdArgs = {
  route_team_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Team_V2_By_User_IdArgs = {
  user_id: Maybe<Scalars['String']>;
  sale_date: Maybe<Scalars['String']>;
};


export type GqlQueryRoute_Team_Members_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRoute_Team_Member_V2_By_IdArgs = {
  route_team_member_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCountriesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDepot_Routing_SummaryArgs = {
  search: Maybe<Scalars['String']>;
  sale_date: Maybe<Scalars['String']>;
  depot_id: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCustomers_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryCustomer_V2_By_IdArgs = {
  customer_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPhone_Number_Change_ApprovalsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryShops_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  cordinates: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  business_domain: Maybe<Scalars['String']>;
  cluster_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryShops_V2_By_Customer_IdArgs = {
  customer_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryShop_V2_By_IdArgs = {
  shop_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryShop_Types_V2Args = {
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  grouped: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryShop_Type_V2_By_IdArgs = {
  shop_type_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCustomer_Types_V2Args = {
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryVendor_KycArgs = {
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryVendor_Kyc_By_IdArgs = {
  vendor_kyc_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCustomer_Type_V2_By_IdArgs = {
  customer_type_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCustomer_V2_By_Phone_NumberArgs = {
  phone_number: Maybe<Scalars['String']>;
};


export type GqlQueryVendor_Finance_PlansArgs = {
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryDelivery_Fee_By_Shop_IdArgs = {
  shop_id: Scalars['String'];
};


export type GqlQueryShops_V2_By_IdsArgs = {
  shop_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryReturns_Handling_Unit_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryReturns_Handling_UnitsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWms_ReturnsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDisposal_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDisposalsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehouse_Transfer_Request_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehouse_Transfer_RequestsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFdr_SkusArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFulfilment_Dispatch_Request_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFulfilment_Dispatch_RequestsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryReserve_Picking_JobsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPickface_Picking_TasksArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPicking_Handling_UnitsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPickface_Picking_Task_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLoading_TasksArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryLoading_Task_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryNodeArgs = {
  id: Scalars['ID'];
};


export type GqlQueryPutaway_JobsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_ZonesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRulesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_RulesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCategory_RulesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHandling_UnitsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Intake_SkusArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHandling_Unit_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStorage_LocationsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStorage_Location_TypesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Loss_ReasonsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Loss_Reason_By_IdArgs = {
  product_loss_reason_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Loss_Reason_By_Product_IdArgs = {
  product_id: Maybe<Scalars['String']>;
};


export type GqlQueryDock_DoorsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFilter_BinsArgs = {
  _from: Maybe<Scalars['String']>;
  _to: Maybe<Scalars['String']>;
};


export type GqlQueryBinsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBin_NamesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWaste_AreasArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAppointment_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAppointment_Item_By_Batch_IdArgs = {
  batch_id: Maybe<Scalars['String']>;
};


export type GqlQueryAppointmentsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehousesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_IntakesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Intake_By_IdArgs = {
  stock_intake_id: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Intake_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Intake_Item_By_IdArgs = {
  stock_intake_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Intake_Items_By_Batch_IdArgs = {
  batch_id: Maybe<Scalars['String']>;
};


export type GqlQueryProcessing_LossArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProcessing_Loss_By_IdArgs = {
  processing_loss_id: Maybe<Scalars['String']>;
};


export type GqlQueryProcessing_Loss_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProcessing_Loss_Item_By_IdArgs = {
  processing_loss_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryStorage_UnitsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStorageArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStorage_By_IdArgs = {
  storage_id: Maybe<Scalars['String']>;
};


export type GqlQueryV2_Stock_AvailabilityArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryV2_Stock_Availability_By_IdArgs = {
  stock_availability_id: Maybe<Scalars['String']>;
};


export type GqlQueryV2_Stock_Availability_Product_Item_SummaryArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Availability_By_Product_ItemArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  sale_date: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
};


export type GqlQueryV2_Stock_Availability_By_Product_Item_IdArgs = {
  product_item_id: Scalars['String'];
  sale_date: Maybe<Scalars['String']>;
  distribution_center_id: Scalars['String'];
};


export type GqlQueryDc_Stock_Availability_By_Product_Item_IdArgs = {
  product_item_id: Scalars['String'];
  sale_date: Maybe<Scalars['String']>;
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  depot_id: Scalars['String'];
};


export type GqlQueryLoss_Reason_By_IdArgs = {
  loss_reason_id: Maybe<Scalars['String']>;
};


export type GqlQueryProcessing_Loss_TypesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProcessing_Loss_Type_By_IdArgs = {
  processing_loss_type_id: Maybe<Scalars['String']>;
};


export type GqlQueryInventory_By_Product_ItemArgs = {
  product_item_id: Scalars['String'];
  date: Scalars['String'];
  distribution_center_id: Scalars['String'];
};


export type GqlQueryStock_Intake_Weight_By_Batch_IdArgs = {
  batch_id: Scalars['String'];
};


export type GqlQueryProcessing_Loss_Weight_By_Batch_IdArgs = {
  batch_id: Scalars['String'];
};


export type GqlQueryDistribution_CentersArgs = {
  dc_names: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryDistribution_Centers_V2Args = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDistribution_Center_By_IdArgs = {
  distribution_center_id: Maybe<Scalars['String']>;
};


export type GqlQueryDistribution_Centers_By_IdsArgs = {
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryStock_TakeArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Take_By_IdArgs = {
  stock_take_id: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Take_LocationArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStock_Take_Location_By_IdArgs = {
  stock_take_location_id: Maybe<Scalars['String']>;
};


export type GqlQueryWarehouse_Transfer_ItemArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehouse_Transfer_Item_By_IdArgs = {
  warehouse_transfer_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryWarehouse_Transfer_ReasonArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehouse_TransferArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryWarehouse_Transfer_By_IdArgs = {
  warehouse_transfer_id: Maybe<Scalars['String']>;
};


export type GqlQueryAssetsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAsset_By_IdArgs = {
  asset_id: Maybe<Scalars['String']>;
};


export type GqlQueryAsset_PhotosArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAsset_Photo_By_IdArgs = {
  asset_photo_id: Maybe<Scalars['String']>;
};


export type GqlQueryDamaged_Asset_PhotosArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryDamaged_Asset_Photo_By_IdArgs = {
  asset_photo_id: Maybe<Scalars['String']>;
};


export type GqlQueryAsset_TrackersArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAsset_Tracker_By_IdArgs = {
  asset_tracker_id: Maybe<Scalars['String']>;
};


export type GqlQueryAsset_Tracker_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAsset_Tracker_Item_By_IdArgs = {
  asset_tracker_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryInventory_LocationsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryInventory_Location_By_IdArgs = {
  inventory_location_id: Maybe<Scalars['String']>;
};


export type GqlQueryAsset_ControlsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAsset_Control_By_IdArgs = {
  asset_control_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_LocationsArgs = {
  product_item_id: Maybe<Scalars['String']>;
  storage_location_number: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Transfer_ReasonsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Transfer_Reason_By_IdArgs = {
  product_transfer_reason_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_TransfersArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Transfer_By_IdArgs = {
  product_transfer_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Transfer_Handling_UnitsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Transfer_Handling_Unit_By_IdArgs = {
  product_transfer_handling_unit_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Transfer_Handling_Unit_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Transfer_Handling_Unit_Item_By_IdArgs = {
  product_transfer_handling_unit_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryPaginated_Product_Items_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  static_params: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Items_V2_By_IdsArgs = {
  active: Maybe<Scalars['Boolean']>;
  product_item_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  static_params: Maybe<Scalars['GenericScalar']>;
  filters: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryProduct_Item_V2_By_IdArgs = {
  product_item_id: Maybe<Scalars['String']>;
  product_slug: Maybe<Scalars['String']>;
  item_slug: Maybe<Scalars['String']>;
  static_params: Maybe<Scalars['GenericScalar']>;
  filters: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryProduct_Items_V2Args = {
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  static_params: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Item_Segments_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Item_Segment_V2_By_IdArgs = {
  product_item_segment_id: Scalars['String'];
};


export type GqlQueryBundle_Association_V2_By_SkuArgs = {
  product_item_id: Scalars['String'];
};


export type GqlQueryProduct_Promotional_Banners_V2Args = {
  active: Maybe<Scalars['Boolean']>;
  published: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Promotional_Banner_V2_By_IdArgs = {
  banner_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Items_With_TagsArgs = {
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  static_params: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryPromotion_Tag_By_IdArgs = {
  promotion_tag_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryPromotion_TypesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPromotion_Type_By_IdArgs = {
  promotion_type_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Categories_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Category_V2_By_IdArgs = {
  category_id: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Categories_V2_By_Department_IdArgs = {
  department_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Departments_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Department_V2_By_IdArgs = {
  department_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryUoms_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryUom_V2_By_IdArgs = {
  uom_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBusiness_Domains_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryUom_V2_By_IdsArgs = {
  uom_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryProduct_Item_Uoms_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Item_Uom_V2_By_IdArgs = {
  product_item_uom_id: Scalars['String'];
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryProduct_Item_Uom_V2_By_IdsArgs = {
  product_item_uom_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryPaginated_Products_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_V2_By_IdArgs = {
  product_id: Scalars['String'];
};


export type GqlQueryProduct_V2_By_IdsArgs = {
  product_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryPackaging_Units_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryPackaging_Unit_V2_By_IdArgs = {
  packaging_unit_id: Scalars['String'];
};


export type GqlQueryPackaging_Unit_V2_By_IdsArgs = {
  packaging_unit_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryFinance_Product_TypesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFinance_Product_Type_By_IdArgs = {
  id: Scalars['String'];
};


export type GqlQueryStandard_Unit_CostsArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStandard_Unit_Cost_By_IdArgs = {
  id: Scalars['String'];
};


export type GqlQueryStandard_Unit_Cost_By_Product_IdArgs = {
  product_id: Scalars['String'];
  date: Scalars['String'];
};


export type GqlQueryProduct_VarietiesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryDispatchesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDispatchArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_By_IdArgs = {
  dispatch_id: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_By_Route_IdArgs = {
  route_id: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_Item_By_IdArgs = {
  dispatch_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryStock_TransfersArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryStock_TransferArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Transfer_By_IdArgs = {
  stock_transfer_id: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Transfer_Item_By_IdArgs = {
  stock_transfer_item: Maybe<Scalars['String']>;
};


export type GqlQueryStock_Transfer_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_BalanceArgs = {
  route_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_IntakesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_IntakeArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_Intake_By_IdArgs = {
  depot_intake_id: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_Intake_Item_By_IdArgs = {
  depot_intake_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_Intake_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryReturnsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryReturn_By_IdArgs = {
  return_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Return_Item_By_IdArgs = {
  product_return_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryProduct_Return_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryPackaging_Return_Item_By_IdArgs = {
  packaging_return_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryPackaging_Return_ItemsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryDispatch_Product_Summary_V2Args = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryProjected_Ph_Revenue_V2Args = {
  route_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
};


export type GqlQueryVehicle_Stock_AllocationsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
  return_all: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_Stock_Allocation_By_IdArgs = {
  vehicle_stock_allocation_id: Maybe<Scalars['String']>;
};


export type GqlQueryBatchesArgs = {
  product_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBatch_By_IdArgs = {
  batch_id: Maybe<Scalars['String']>;
};


export type GqlQueryArticlesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryArticle_By_IdArgs = {
  article_id: Maybe<Scalars['String']>;
};


export type GqlQuerySaved_ArticlesArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySaved_Article_By_IdArgs = {
  saved_article_id: Maybe<Scalars['String']>;
};


export type GqlQueryBidsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBid_ApplicationsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBid_By_IdArgs = {
  bid_id: Maybe<Scalars['String']>;
};


export type GqlQueryBids_By_Category_IdsArgs = {
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryCount_Bids_By_Category_IdsArgs = {
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryBid_Application_By_IdArgs = {
  bid_application_id: Maybe<Scalars['String']>;
};


export type GqlQueryBid_Application_By_Agent_IdArgs = {
  agent_id: Scalars['String'];
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBid_Application_By_Vehicle_RegistrationArgs = {
  vehicle_registration: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHarvestsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHarvest_By_IdArgs = {
  harvest_id: Maybe<Scalars['String']>;
};


export type GqlQueryHarvest_Issues_By_Harvest_IdArgs = {
  harvest_id: Maybe<Scalars['String']>;
};


export type GqlQueryPayment_DetailsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHarvest_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHarvest_Item_By_IdArgs = {
  harvest_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryHarvest_Item_AssetsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryHarvest_Item_Assets_By_IdArgs = {
  harvest_item_asset_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFarmersArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFarmers_By_Collection_Center_IdArgs = {
  collection_center_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryFarmers_By_Area_IdArgs = {
  area_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryFarmer_By_IdArgs = {
  farmer_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySourcing_AgentsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySourcing_Agent_By_IdArgs = {
  agent_number: Maybe<Scalars['String']>;
  agent_id: Maybe<Scalars['String']>;
};


export type GqlQueryFarm_By_IdArgs = {
  farm_id: Maybe<Scalars['String']>;
};


export type GqlQueryFarmsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFarms_By_Farmer_IdArgs = {
  farmer_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryFarmer_Payment_AccountsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAgent_FeedbackArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryAgent_Feedback_By_IdArgs = {
  agent_feedback_id: Maybe<Scalars['String']>;
};


export type GqlQuerySupplier_User_By_Supplier_IdArgs = {
  supplier_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySupplier_Product_By_Supplier_IdArgs = {
  supplier_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBooking_By_IdArgs = {
  booking_id: Maybe<Scalars['String']>;
};


export type GqlQueryBookingsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySourcing_Price_RangeArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQuerySourcing_Price_Range_By_IdArgs = {
  price_range_id: Maybe<Scalars['String']>;
};


export type GqlQuerySourcing_Price_Range_By_Product_IdArgs = {
  product_id: Maybe<Scalars['String']>;
};


export type GqlQueryBooking_ItemsArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryBooking_Item_By_IdArgs = {
  booking_item_id: Maybe<Scalars['String']>;
};


export type GqlQueryAreasArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryArea_By_IdArgs = {
  area_id: Maybe<Scalars['String']>;
};


export type GqlQueryCollection_CentersArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryCollection_Centers_By_Area_IdArgs = {
  area_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryCollection_Center_By_IdArgs = {
  collection_center_id: Maybe<Scalars['String']>;
};


export type GqlQueryHarvest_AreasArgs = {
  filter: Maybe<Scalars['GenericScalar']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryHarvest_Area_By_IdArgs = {
  harvest_area_id: Maybe<Scalars['String']>;
};


export type GqlQueryHarvest_Areas_By_Collection_Center_IdArgs = {
  collection_center_id: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
};


export type GqlQueryPermissions_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryPermission_V2_By_IdArgs = {
  permission_id: Maybe<Scalars['String']>;
};


export type GqlQueryUsers_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryUser_V2_By_IdArgs = {
  user_id: Maybe<Scalars['String']>;
};


export type GqlQueryUsers_V2_By_PermissionsArgs = {
  permissions: Maybe<Array<Maybe<Scalars['String']>>>;
  search: Maybe<Scalars['String']>;
};


export type GqlQueryUser_V2_By_Id_Or_NumberArgs = {
  user_id_or_number: Maybe<Scalars['String']>;
};


export type GqlQueryUsers_V2_By_IdsArgs = {
  user_ids: Array<Maybe<Scalars['String']>>;
};


export type GqlQueryRoles_V2Args = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
};


export type GqlQueryRole_V2_By_IdArgs = {
  role_id: Maybe<Scalars['String']>;
};


export type GqlQueryFeedbacksArgs = {
  channel: Maybe<GqlMedium>;
  feedback_type: Maybe<GqlFeedBackType>;
};


export type GqlQueryPromoter_ScoreArgs = {
  channel: Maybe<Scalars['String']>;
};


export type GqlQueryAverage_User_RatingArgs = {
  fulfiller_id: Scalars['String'];
};


export type GqlQueryNotification_TemplatesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryNotification_Template_By_IdArgs = {
  notification_template_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryNotificationsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryNotification_By_IdArgs = {
  notification_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryNotification_Messages_By_User_IdArgs = {
  user_id: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryNotification_ProvidersArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryNotification_Provider_By_IdArgs = {
  provider_id: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryTaxInvoiceArgs = {
  filters: Maybe<GqlTaxInvoiceFilter>;
};


export type GqlQueryHsCodesArgs = {
  filters: Maybe<GqlHsCodeFilters>;
};


export type GqlQueryChecklist_SectionsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryChecklist_Section_By_IdArgs = {
  section_id: Maybe<Scalars['String']>;
};


export type GqlQueryChecklist_QuestionsArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryChecklist_Question_By_IdArgs = {
  question_id: Maybe<Scalars['String']>;
};


export type GqlQueryChecklist_EntriesArgs = {
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryChecklist_Entry_By_IdArgs = {
  entry_id: Maybe<Scalars['String']>;
};


export type GqlQueryIncident_CategoriesArgs = {
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
};


export type GqlQueryIncidentsArgs = {
  active: Maybe<Scalars['Boolean']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
};


export type GqlQueryIncident_By_IdArgs = {
  incident_id: Maybe<Scalars['String']>;
};


export type GqlQueryVehicle_SuppliersArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_Supplier_Payment_AccountsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryTripsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_Supplier_Statement_FilesArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_Supplier_StatementsArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_TypesArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_Type_By_IdArgs = {
  vehicle_type_id: Maybe<Scalars['String']>;
};


export type GqlQueryVehiclesArgs = {
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  available_on_delivery_date: Maybe<Scalars['Date']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryVehicle_By_IdArgs = {
  vehicle_id: Maybe<Scalars['String']>;
};


export type GqlQueryRoute_PlansArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryRoute_Plan_By_IdArgs = {
  route_plan_id: Maybe<Scalars['String']>;
};


export type GqlQueryRoute_Plans_By_IdsArgs = {
  route_plan_ids: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type GqlQueryFulfillment_TeamsArgs = {
  since: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryFulfillment_Team_By_IdArgs = {
  fulfillment_team_id: Maybe<Scalars['String']>;
};


export type GqlQueryStatic_RoutesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryStatic_Route_By_IdArgs = {
  static_route_id: Maybe<Scalars['String']>;
};


export type GqlQueryDepot_Route_Plan_SummaryArgs = {
  depot_id: Maybe<Scalars['String']>;
  delivery_date: Maybe<Scalars['String']>;
};


export type GqlQueryPseudo_RoutesArgs = {
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  since: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
};


export type GqlQueryPseudo_Route_By_IdArgs = {
  pseudo_route_id: Scalars['String'];
};

/** Merge multiple mutations thru inheritance. */
export type GqlMutation = {
  __typename?: 'Mutation';
  add_inbound_payment_config: Maybe<GqlCreateInboundPaymentConfig>;
  update_inbound_payment_config: Maybe<GqlUpdateInboundPaymentConfig>;
  delete_inbound_payment_config: Maybe<GqlDeleteInboundPaymentConfig>;
  add_permission: Maybe<GqlCreatePermissions>;
  update_permission: Maybe<GqlUpdatePermissions>;
  delete_permission: Maybe<GqlDeletePermissions>;
  add_payment_provider: Maybe<GqlCreatePaymentProvider>;
  update_payment_provider: Maybe<GqlUpdatePaymentProvider>;
  delete_payment_provider: Maybe<GqlDeletePaymentProvider>;
  add_payment_provider_mode: Maybe<GqlCreatePaymentProviderMode>;
  update_payment_provider_mode: Maybe<GqlUpdatePaymentProviderMode>;
  delete_payment_provider_mode: Maybe<GqlDeletePaymentProviderMode>;
  add_payment_mode: Maybe<GqlCreatePaymentMode>;
  update_payment_mode: Maybe<GqlUpdatePaymentMode>;
  delete_payment_mode: Maybe<GqlDeletePaymentMode>;
  add_party: Maybe<GqlCreateParty>;
  update_party: Maybe<GqlUpdateParty>;
  delete_party: Maybe<GqlDeleteParty>;
  add_party_mapping: Maybe<GqlCreatePartyMapping>;
  update_party_mapping: Maybe<GqlUpdatePartyMapping>;
  delete_party_mapping: Maybe<GqlDeletePartyMapping>;
  add_service: Maybe<GqlCreateService>;
  update_service: Maybe<GqlUpdateService>;
  delete_service: Maybe<GqlDeleteService>;
  add_role: Maybe<GqlCreateRole>;
  update_role: Maybe<GqlUpdateRole>;
  delete_role: Maybe<GqlDeleteRole>;
  login: Maybe<GqlLogin>;
  createPartner: Maybe<GqlPartner>;
  updatePartner: Maybe<GqlPartner>;
  deletePartner: Scalars['ID'];
  createPartnerTopup: Maybe<GqlPartnerTopup>;
  updatePartnerTopup: Maybe<GqlPartnerTopup>;
  deletePartnerTopup: Scalars['ID'];
  createPartnerWithdrawal: Maybe<GqlPartnerTopup>;
  updatePartnerWithdrawal: Maybe<GqlPartnerTopup>;
  createPartnerEarning: Maybe<GqlPartnerEarning>;
  createLoanProduct: Maybe<GqlLoanProduct>;
  updateLoanProduct: Maybe<GqlLoanProduct>;
  deleteLoanProduct: Scalars['ID'];
  createDepotPartner: Maybe<GqlDepotPartner>;
  updateDepotPartner: Maybe<GqlDepotPartner>;
  deleteDepotPartner: Scalars['ID'];
  createLoanUpdate: Maybe<GqlLoanUpdate>;
  deleteLoanUpdate: Scalars['ID'];
  createLoanRejectionReason: Maybe<GqlLoanRejectionReason>;
  deleteLoanRejectionReason: Scalars['ID'];
  createLoanWaiverReason: Maybe<GqlLoanWaiverReason>;
  deleteLoanWaiverReason: Scalars['ID'];
  updateCustomerPartner: Maybe<GqlCustomerPartner>;
  serverVersion: Scalars['String'];
  createDigitalService: GqlDigitalService;
  updateDigitalService: GqlDigitalService;
  createDigitalProduct: GqlDigitalProduct;
  updateDigitalProduct: GqlDigitalProduct;
  performDigitalTopup: GqlNonScalarBoolean;
  sellDigitalProduct: GqlNonScalarBoolean;
  subscribeNotifications: GqlNonScalarBoolean;
  add_promotional_banner: Maybe<GqlCreateProductPromotionalBanner>;
  upload_banner_image: Maybe<GqlUploadProductPromotionalBannerImage>;
  update_promotional_banner: Maybe<GqlUpdateProductPromotionalBanner>;
  delete_promotional_banner: Maybe<GqlDeleteProductPromotionalBanner>;
  add_promotion_tag: Maybe<GqlCreatePromotionTag>;
  update_promotion_tag: Maybe<GqlUpdatePromotionTag>;
  delete_promotion_tag: Maybe<GqlDeletePromotionTag>;
  add_promotion_type: Maybe<GqlCreatePromotionType>;
  update_promotion_type: Maybe<GqlUpdatePromotionType>;
  delete_promotion_type: Maybe<GqlDeletePromotionType>;
  add_department: Maybe<GqlCreateDepartment>;
  update_department: Maybe<GqlUpdateDepartment>;
  delete_department: Maybe<GqlDeleteDepartment>;
  add_category: Maybe<GqlCreateCategory>;
  update_category: Maybe<GqlUpdateCategory>;
  delete_category: Maybe<GqlDeleteCategory>;
  add_category_region: Maybe<GqlCreateCategoryRegion>;
  update_category_region: Maybe<GqlUpdateCategoryRegion>;
  delete_category_region: Maybe<GqlDeleteCategoryRegion>;
  upload_category_image: Maybe<GqlUploadCategoryImage>;
  upload_department_image: Maybe<GqlUploadDepartmentImage>;
  add_product_item: Maybe<GqlCreateProductItem>;
  update_product_item: Maybe<GqlUpdateProductItem>;
  delete_product_item: Maybe<GqlDeleteProductItem>;
  add_product_item_image: Maybe<GqlUploadProductItemImage>;
  add_product_item_region: Maybe<GqlCreateProductItemRegion>;
  update_product_item_region: Maybe<GqlUpdateProductItemRegion>;
  delete_product_item_region: Maybe<GqlDeleteProductItemRegion>;
  add_product_item_segment: Maybe<GqlCreateProductItemSegment>;
  update_product_item_segment: Maybe<GqlUpdateProductItemSegment>;
  delete_product_item_segment: Maybe<GqlDeleteProductItemSegment>;
  add_bundle_association: Maybe<GqlCreateBundleAssociation>;
  delete_bundle_association: Maybe<GqlDeleteBundleAssociation>;
  add_uom: Maybe<GqlCreateUom>;
  update_uom: Maybe<GqlUpdateUom>;
  delete_uom: Maybe<GqlDeleteUom>;
  add_product_item_uom: Maybe<GqlCreateProductItemUom>;
  update_product_item_uom: Maybe<GqlUpdateProductItemUom>;
  delete_product_item_uom: Maybe<GqlDeleteProductItemUom>;
  add_business_domain: Maybe<GqlCreateBusinessDomain>;
  update_business_domain: Maybe<GqlUpdateBusinessDomain>;
  delete_business_domain: Maybe<GqlDeleteBusinessDomain>;
  add_product_domain_activation: Maybe<GqlCreateProductDomainActivation>;
  update_product_domain_activation: Maybe<GqlUpdateProductDomainActivation>;
  delete_product_domain_activation: Maybe<GqlDeleteProductDomainActivation>;
  add_packaging_unit: Maybe<GqlCreatePackagingUnit>;
  update_packaging_unit: Maybe<GqlUpdatePackagingUnit>;
  delete_packaging_unit: Maybe<GqlDeletePackagingUnit>;
  add_product: Maybe<GqlCreateProduct>;
  update_product: Maybe<GqlUpdateProduct>;
  delete_product: Maybe<GqlDeleteProduct>;
  add_product_image: Maybe<GqlUploadProductImage>;
  add_product_tag: Maybe<GqlCreateProductTag>;
  update_product_tag: Maybe<GqlUpdateProductTag>;
  delete_product_tag: Maybe<GqlDeleteProductTag>;
  add_finance_product_type: Maybe<GqlCreateFinanceProductType>;
  update_finance_product_type: Maybe<GqlUpdateFinanceProductType>;
  add_standard_unit_cost: Maybe<GqlCreateStandardUnitCost>;
  update_standard_unit_cost: Maybe<GqlUpdateStandardUnitCost>;
  add_product_variety: Maybe<GqlCreateProductVariety>;
  update_product_variety: Maybe<GqlUpdateProductVariety>;
  delete_product_variety: Maybe<GqlDeleteProductVariety>;
  addFeedback: Maybe<GqlFeedback>;
  addNps: Maybe<GqlNps>;
  addUserRating: Maybe<GqlRatingType>;
  upload_incident_image: Maybe<GqlUploadIncidentImage>;
  add_incident_category: Maybe<GqlCreateIncidentCategory>;
  update_incident_category: Maybe<GqlUpdateIncidentCategory>;
  delete_incident_category: Maybe<GqlDeleteIncidentCategory>;
  add_incident: Maybe<GqlCreateIncident>;
  update_incident: Maybe<GqlUpdateIncident>;
  delete_incident: Maybe<GqlDeleteIncident>;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Inbound_Payment_ConfigArgs = {
  data: GqlInboundPaymentConfigInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Inbound_Payment_ConfigArgs = {
  data: GqlInboundPaymentConfigInput;
  inbound_payment_config_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Inbound_Payment_ConfigArgs = {
  inbound_payment_config_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_PermissionArgs = {
  data: GqlPermissionsInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_PermissionArgs = {
  data: GqlPermissionsInput;
  permission_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_PermissionArgs = {
  permission_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Payment_ProviderArgs = {
  data: GqlPaymentProviderInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Payment_ProviderArgs = {
  data: GqlPaymentProviderInput;
  payment_provider_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Payment_ProviderArgs = {
  payment_provider_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Payment_Provider_ModeArgs = {
  data: GqlPaymentProviderModeInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Payment_Provider_ModeArgs = {
  data: GqlPaymentProviderModeInput;
  payment_provider_mode_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Payment_Provider_ModeArgs = {
  payment_provider_mode_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Payment_ModeArgs = {
  data: GqlPaymentModeInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Payment_ModeArgs = {
  data: GqlPaymentModeInput;
  payment_mode_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Payment_ModeArgs = {
  payment_mode_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_PartyArgs = {
  data: GqlPartyInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_PartyArgs = {
  data: GqlPartyInput;
  party_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_PartyArgs = {
  party_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Party_MappingArgs = {
  data: GqlPartyMappingInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Party_MappingArgs = {
  data: GqlPartyMappingInput;
  party_mapping_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Party_MappingArgs = {
  party_mapping_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_ServiceArgs = {
  data: GqlServiceInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_ServiceArgs = {
  data: GqlServiceInput;
  service_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_ServiceArgs = {
  service_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_RoleArgs = {
  data: GqlRoleInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_RoleArgs = {
  data: GqlRoleInput;
  serrole: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_RoleArgs = {
  role_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreatePartnerArgs = {
  input: GqlNewPartner;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdatePartnerArgs = {
  input: GqlUpdatePartner;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeletePartnerArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreatePartnerTopupArgs = {
  input: GqlNewPartnerTopup;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdatePartnerTopupArgs = {
  input: GqlUpdatePartnerTopup;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeletePartnerTopupArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreatePartnerWithdrawalArgs = {
  input: GqlNewPartnerWithdrawal;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdatePartnerWithdrawalArgs = {
  input: GqlUpdatePartnerWithdrawal;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreatePartnerEarningArgs = {
  input: GqlNewPartnerEarning;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateLoanProductArgs = {
  input: GqlNewLoanProduct;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdateLoanProductArgs = {
  input: GqlUpdateLoanProduct;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeleteLoanProductArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateDepotPartnerArgs = {
  input: GqlNewDepotPartner;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdateDepotPartnerArgs = {
  input: GqlUpdateDepotPartner;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeleteDepotPartnerArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateLoanUpdateArgs = {
  input: GqlNewLoanUpdate;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeleteLoanUpdateArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateLoanRejectionReasonArgs = {
  input: GqlNewLoanRejectionReason;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeleteLoanRejectionReasonArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateLoanWaiverReasonArgs = {
  input: GqlNewLoanWaiverReason;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDeleteLoanWaiverReasonArgs = {
  id: Scalars['ID'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdateCustomerPartnerArgs = {
  input: GqlUpdateCustomerPartner;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateDigitalServiceArgs = {
  input: GqlCreateDigitalServiceInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdateDigitalServiceArgs = {
  input: GqlUpdateDigitalServiceInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationCreateDigitalProductArgs = {
  input: GqlCreateDigitalProductInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdateDigitalProductArgs = {
  input: GqlUpdateDigitalProductInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationPerformDigitalTopupArgs = {
  input: GqlDigitalTopupInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationSellDigitalProductArgs = {
  input: GqlSellProductInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationSubscribeNotificationsArgs = {
  input: GqlUserSubscribeInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Promotional_BannerArgs = {
  data: GqlProductPromotionalBannerInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpload_Banner_ImageArgs = {
  banner_id: Scalars['String'];
  image: Scalars['Upload'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Promotional_BannerArgs = {
  banner_id: Scalars['String'];
  data: GqlProductPromotionalBannerInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Promotional_BannerArgs = {
  banner_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Promotion_TagArgs = {
  data: GqlPromotionTagInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Promotion_TagArgs = {
  data: GqlPromotionTagInput;
  promotion_tag_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Promotion_TagArgs = {
  promotion_tag_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Promotion_TypeArgs = {
  data: GqlPromotionTypeInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Promotion_TypeArgs = {
  data: GqlPromotionTypeInput;
  promotion_type_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Promotion_TypeArgs = {
  promotion_type_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_DepartmentArgs = {
  data: GqlDepartmentInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_DepartmentArgs = {
  data: GqlDepartmentInput;
  department_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_DepartmentArgs = {
  department_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_CategoryArgs = {
  data: GqlCategoryInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_CategoryArgs = {
  category_id: Scalars['String'];
  data: GqlCategoryInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_CategoryArgs = {
  category_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Category_RegionArgs = {
  data: GqlCategoryRegionInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Category_RegionArgs = {
  category_region_id: Scalars['String'];
  data: GqlCategoryRegionInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Category_RegionArgs = {
  category_region_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpload_Category_ImageArgs = {
  category_id: Scalars['String'];
  image: Scalars['Upload'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpload_Department_ImageArgs = {
  department_id: Scalars['String'];
  image: Scalars['Upload'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_ItemArgs = {
  data: GqlProductItemInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_ItemArgs = {
  data: GqlProductItemInput;
  product_item_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_ItemArgs = {
  product_item_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_Item_ImageArgs = {
  image: Scalars['Upload'];
  product_item_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_Item_RegionArgs = {
  data: GqlProductItemRegionInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_Item_RegionArgs = {
  data: GqlProductItemRegionInput;
  product_item_region_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_Item_RegionArgs = {
  product_item_region_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_Item_SegmentArgs = {
  data: GqlProductItemSegmentInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_Item_SegmentArgs = {
  data: GqlProductItemSegmentInput;
  product_item_segment_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_Item_SegmentArgs = {
  product_item_segment_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Bundle_AssociationArgs = {
  data: Maybe<Array<Maybe<GqlBundleAssociationInput>>>;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Bundle_AssociationArgs = {
  association_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_UomArgs = {
  data: GqlUomInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_UomArgs = {
  data: GqlUomInput;
  uom_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_UomArgs = {
  uom_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_Item_UomArgs = {
  data: GqlProductItemUomInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_Item_UomArgs = {
  business_domain_id: Scalars['String'];
  data: GqlProductItemUomInput;
  product_item_id: Scalars['String'];
  product_item_uom_id: Scalars['String'];
  uom_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_Item_UomArgs = {
  business_domain_id: Scalars['String'];
  product_item_id: Scalars['String'];
  product_item_uom_id: Scalars['String'];
  uom_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Business_DomainArgs = {
  data: GqlBusinessDomainInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Business_DomainArgs = {
  business_domain_id: Scalars['String'];
  data: GqlBusinessDomainInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Business_DomainArgs = {
  business_domain_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_Domain_ActivationArgs = {
  data: GqlProductDomainActivationInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_Domain_ActivationArgs = {
  data: GqlProductDomainActivationInput;
  product_domain_activation_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_Domain_ActivationArgs = {
  product_domain_activation_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Packaging_UnitArgs = {
  data: GqlPackagingUnitInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Packaging_UnitArgs = {
  data: GqlPackagingUnitInput;
  packaging_unit_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Packaging_UnitArgs = {
  packaging_unit_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_ProductArgs = {
  data: GqlProductInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_ProductArgs = {
  data: GqlProductInput;
  product_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_ProductArgs = {
  product_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_ImageArgs = {
  image: Scalars['Upload'];
  product_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_TagArgs = {
  data: GqlProductTagInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_TagArgs = {
  data: GqlProductTagInput;
  product_tag_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_TagArgs = {
  product_tag_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Finance_Product_TypeArgs = {
  data: GqlFinanceProductTypeInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Finance_Product_TypeArgs = {
  data: GqlFinanceProductTypeInput;
  finance_product_type_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Standard_Unit_CostArgs = {
  data: GqlStandardUnitCostInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Standard_Unit_CostArgs = {
  data: GqlStandardUnitCostInput;
  standard_unit_cost_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Product_VarietyArgs = {
  data: GqlProductVarietyInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Product_VarietyArgs = {
  data: GqlProductVarietyInput;
  product_variety_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Product_VarietyArgs = {
  product_variety_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAddFeedbackArgs = {
  data: GqlFeedbackInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAddNpsArgs = {
  data: Maybe<GqlNpsInput>;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAddUserRatingArgs = {
  data: Maybe<GqlUserRatingInput>;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpload_Incident_ImageArgs = {
  image: Scalars['Upload'];
  incident_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_Incident_CategoryArgs = {
  data: GqlIncidentCategoryInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_Incident_CategoryArgs = {
  data: GqlIncidentCategoryInput;
  incident_category_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_Incident_CategoryArgs = {
  incident_category_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationAdd_IncidentArgs = {
  data: GqlIncidentInput;
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationUpdate_IncidentArgs = {
  data: GqlIncidentInput;
  incident_id: Scalars['String'];
};


/** Merge multiple mutations thru inheritance. */
export type GqlMutationDelete_IncidentArgs = {
  incident_id: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlCompanyGqlConnection = {
  __typename?: 'CompanyGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlCompanyGqlEdge>>;
};

/** Construct pagination info. */
export type GqlPaginatorInfo = {
  __typename?: 'PaginatorInfo';
  current_page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  has_next: Maybe<Scalars['Boolean']>;
  has_previous: Maybe<Scalars['Boolean']>;
  total_pages: Maybe<Scalars['Int']>;
  total_count: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CompanyGQL` and its cursor. */
export type GqlCompanyGqlEdge = {
  __typename?: 'CompanyGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlCompanyGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Company GQL. */
export type GqlCompanyGql = {
  __typename?: 'CompanyGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  currency: Scalars['String'];
  country: Scalars['String'];
  ewallet_metadata: Maybe<Scalars['JSONString']>;
};




/** Node and relay Connection. */
export type GqlAccountGqlConnection = {
  __typename?: 'AccountGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAccountGqlEdge>>;
};

/** A Relay edge containing a `AccountGQL` and its cursor. */
export type GqlAccountGqlEdge = {
  __typename?: 'AccountGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAccountGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Account GQL. */
export type GqlAccountGql = {
  __typename?: 'AccountGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  account_id: Scalars['String'];
  company_name: Maybe<Scalars['String']>;
  entity_id: Maybe<Scalars['String']>;
  entity_type: GqlEntityTypeEnum;
  account_type: GqlAccountTypeEnum;
  name: Scalars['String'];
  withdrawable_balance: Scalars['Float'];
  nonwithdrawable_balance: Scalars['Float'];
  country: Maybe<Scalars['String']>;
  ewallet_metadata: Maybe<Scalars['JSONString']>;
  company: Maybe<GqlCompanyGql>;
};

/** ewallet entity_type enums */
export enum GqlEntityTypeEnum {
  Customer = 'CUSTOMER',
  Shop = 'SHOP',
  Farmer = 'FARMER',
  ErpAccount = 'ERP_ACCOUNT'
}

/** ewallet account_type enums */
export enum GqlAccountTypeEnum {
  Master = 'MASTER',
  Customer = 'CUSTOMER'
}


/** Node and relay Connection. */
export type GqlTransactionTypeGqlConnection = {
  __typename?: 'TransactionTypeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlTransactionTypeGqlEdge>>;
};

/** A Relay edge containing a `TransactionTypeGQL` and its cursor. */
export type GqlTransactionTypeGqlEdge = {
  __typename?: 'TransactionTypeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlTransactionTypeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** TransactionType GQL. */
export type GqlTransactionTypeGql = {
  __typename?: 'TransactionTypeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  transaction_type_id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  credit_policy: GqlCreditTransactionPolicy;
  debit_policy: GqlDebitTransactionPolicy;
};

/** An enumeration. */
export enum GqlCreditTransactionPolicy {
  Withdrawable = 'WITHDRAWABLE',
  Nonwithdrawable = 'NONWITHDRAWABLE'
}

/** An enumeration. */
export enum GqlDebitTransactionPolicy {
  Withdrawable = 'WITHDRAWABLE',
  Nonwithdrawable = 'NONWITHDRAWABLE',
  All = 'ALL'
}

/** Node and relay Connection. */
export type GqlLedgerEntryGqlConnection = {
  __typename?: 'LedgerEntryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlLedgerEntryGqlEdge>>;
};

/** A Relay edge containing a `LedgerEntryGQL` and its cursor. */
export type GqlLedgerEntryGqlEdge = {
  __typename?: 'LedgerEntryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLedgerEntryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** LedgerEntry GQL. */
export type GqlLedgerEntryGql = {
  __typename?: 'LedgerEntryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  ledgerentry_id: Scalars['String'];
  debit_account_id: Maybe<Scalars['String']>;
  credit_account_id: Maybe<Scalars['String']>;
  transaction_type_id: Maybe<Scalars['String']>;
  reference_id: Scalars['String'];
  amount: Scalars['Float'];
  debit_account_withdrawable_balance: Scalars['Float'];
  debit_account_nonwithdrawable_balance: Scalars['Float'];
  credit_account_withdrawable_balance: Scalars['Float'];
  credit_account_nonwithdrawable_balance: Scalars['Float'];
  ewallet_metadata: Maybe<Scalars['JSONString']>;
  transaction_type: Maybe<GqlTransactionTypeGql>;
};

/** Node and relay Connection. */
export type GqlServiceGqlConnection = {
  __typename?: 'ServiceGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlServiceGqlEdge>>;
};

/** A Relay edge containing a `ServiceGQL` and its cursor. */
export type GqlServiceGqlEdge = {
  __typename?: 'ServiceGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlServiceGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Service GQL. */
export type GqlServiceGql = {
  __typename?: 'ServiceGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  service_id: Scalars['String'];
  username: Scalars['String'];
  service_metadata: Maybe<Scalars['JSONString']>;
  service_user_roles: Maybe<Array<Maybe<GqlRoleGql>>>;
};

/** Role GQL. */
export type GqlRoleGql = {
  __typename?: 'RoleGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  role_id: Scalars['String'];
  service_id: Maybe<Scalars['String']>;
  permission_id: Maybe<Scalars['String']>;
  service: Maybe<GqlServiceGql>;
  permission: Maybe<GqlPermissionsGql>;
};

/** Permissions GQL. */
export type GqlPermissionsGql = {
  __typename?: 'PermissionsGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  permission_id: Scalars['String'];
  permission: Scalars['String'];
  description: Maybe<Scalars['String']>;
  service_permissions: Maybe<Array<Maybe<GqlRoleGql>>>;
};

/** Node and relay Connection. */
export type GqlPermissionsGqlConnection = {
  __typename?: 'PermissionsGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPermissionsGqlEdge>>;
};

/** A Relay edge containing a `PermissionsGQL` and its cursor. */
export type GqlPermissionsGqlEdge = {
  __typename?: 'PermissionsGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPermissionsGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlRoleGqlConnection = {
  __typename?: 'RoleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRoleGqlEdge>>;
};

/** A Relay edge containing a `RoleGQL` and its cursor. */
export type GqlRoleGqlEdge = {
  __typename?: 'RoleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRoleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlInboundPaymentGqlConnection = {
  __typename?: 'InboundPaymentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlInboundPaymentGqlEdge>>;
};

/** A Relay edge containing a `InboundPaymentGQL` and its cursor. */
export type GqlInboundPaymentGqlEdge = {
  __typename?: 'InboundPaymentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlInboundPaymentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Inbound Payment GQL. */
export type GqlInboundPaymentGql = {
  __typename?: 'InboundPaymentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  inbound_payment_id: Scalars['String'];
  inbound_payment_config_id: Maybe<Scalars['String']>;
  reference_id: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  account_number: Scalars['String'];
  account_number_type: GqlInboundPaymentAccountNumberTypeEnum;
  transaction_id: Maybe<Scalars['String']>;
  transaction_receipt: Maybe<Scalars['String']>;
  transaction_request: Maybe<Scalars['JSONString']>;
  transaction_response: Maybe<Scalars['JSONString']>;
  transaction_callback: Maybe<Scalars['JSONString']>;
  transaction_status: GqlInboundPaymentTransactionStatusEnum;
  inbound_payment_config: Maybe<GqlInboundPaymentConfigGql>;
};

/** Payment Type Enums. */
export enum GqlInboundPaymentAccountNumberTypeEnum {
  PhoneNumber = 'PHONE_NUMBER'
}

/** Inbound Payment Transaction status enums. */
export enum GqlInboundPaymentTransactionStatusEnum {
  Queued = 'QUEUED',
  Failed = 'FAILED',
  Timeout = 'TIMEOUT',
  Cancelled = 'CANCELLED',
  Successful = 'SUCCESSFUL',
  InProgress = 'IN_PROGRESS',
  UnknownError = 'UNKNOWN_ERROR',
  InsufficientBalance = 'INSUFFICIENT_BALANCE'
}

/** Inbound Payment Config GQL. */
export type GqlInboundPaymentConfigGql = {
  __typename?: 'InboundPaymentConfigGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  inbound_payment_config_id: Scalars['String'];
  inbound_payment_provider_id: Maybe<Scalars['String']>;
  name: Scalars['String'];
  service_name: Scalars['String'];
  payment_type: GqlInboundPaymentTypeEnum;
  config: Maybe<Scalars['JSONString']>;
  inbound_payment_provider: Maybe<GqlInboundPaymentProviderGql>;
  inbound_payment_payment: Maybe<Array<Maybe<GqlInboundPaymentGql>>>;
};

/** Inbound Payment Type Enums. */
export enum GqlInboundPaymentTypeEnum {
  Stk = 'STK',
  Till = 'TILL'
}

/** Inbound Payment Provider GQL. */
export type GqlInboundPaymentProviderGql = {
  __typename?: 'InboundPaymentProviderGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  inbound_payment_provider_id: Scalars['String'];
  name: Scalars['String'];
  provider_meta: Maybe<Scalars['JSONString']>;
  inbound_payment_configs: Maybe<Array<Maybe<GqlInboundPaymentConfigGql>>>;
};

/** Node and relay Connection. */
export type GqlInboundPaymentConfigGqlConnection = {
  __typename?: 'InboundPaymentConfigGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlInboundPaymentConfigGqlEdge>>;
};

/** A Relay edge containing a `InboundPaymentConfigGQL` and its cursor. */
export type GqlInboundPaymentConfigGqlEdge = {
  __typename?: 'InboundPaymentConfigGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlInboundPaymentConfigGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlInboundPaymentProviderGqlConnection = {
  __typename?: 'InboundPaymentProviderGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlInboundPaymentProviderGqlEdge>>;
};

/** A Relay edge containing a `InboundPaymentProviderGQL` and its cursor. */
export type GqlInboundPaymentProviderGqlEdge = {
  __typename?: 'InboundPaymentProviderGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlInboundPaymentProviderGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlPaymentGqlConnection = {
  __typename?: 'PaymentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentGqlEdge>>;
};

/** A Relay edge containing a `PaymentGQL` and its cursor. */
export type GqlPaymentGqlEdge = {
  __typename?: 'PaymentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Payment GQL. */
export type GqlPaymentGql = {
  __typename?: 'PaymentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_id: Scalars['String'];
  payment_provider_id: Scalars['String'];
  account_number: Scalars['String'];
  amount: Scalars['Float'];
  party_id: Maybe<Scalars['String']>;
  transaction_receipt: Maybe<Scalars['String']>;
  transaction_id: Maybe<Scalars['String']>;
  transaction_status: GqlTransactionStatusEnum;
  transaction_result: Maybe<Scalars['String']>;
  payment_metadata: Maybe<Scalars['JSONString']>;
  merchant_params: Maybe<Scalars['JSONString']>;
  post_transaction_response: Maybe<Scalars['JSONString']>;
  ipn_response: Maybe<Scalars['JSONString']>;
  completion_timestamp: Maybe<Scalars['DateTime']>;
  payment_type: GqlPaymentTypeEnum;
  is_reversed: Maybe<Scalars['Boolean']>;
  callback_event_label: Maybe<Scalars['String']>;
  reference_id: Maybe<Scalars['String']>;
  party: Maybe<GqlPartyGql>;
  payment_provider: Maybe<GqlPaymentProviderGql>;
};

/** Transaction status enums. */
export enum GqlTransactionStatusEnum {
  Pending = 'PENDING',
  Inprogress = 'INPROGRESS',
  Successful = 'SUCCESSFUL',
  Failed = 'FAILED'
}

/** An enumeration. */
export enum GqlPaymentTypeEnum {
  B2C = 'B2_C',
  B2B = 'B2_B',
  Manual = 'MANUAL'
}

/** Party GQL. */
export type GqlPartyGql = {
  __typename?: 'PartyGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  party_id: Scalars['String'];
  name: Scalars['String'];
  swift_code: Scalars['String'];
  payment_mode_id: Scalars['String'];
  payment_mode: Maybe<GqlPaymentModeGql>;
  payment: Maybe<Array<Maybe<GqlPaymentGql>>>;
  party_mapping: Maybe<Array<Maybe<GqlPartyMappingGql>>>;
};

/** PaymentModeGQL. */
export type GqlPaymentModeGql = {
  __typename?: 'PaymentModeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_mode_id: Scalars['String'];
  name: Scalars['String'];
  party: Maybe<Array<Maybe<GqlPartyGql>>>;
  payment_provider_modes: Maybe<Array<Maybe<GqlPaymentProviderModeGql>>>;
};

/** Payment Provider Mode GQL. */
export type GqlPaymentProviderModeGql = {
  __typename?: 'PaymentProviderModeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_provider_mode_id: Scalars['String'];
  payment_provider_id: Scalars['String'];
  payment_mode_id: Scalars['String'];
  min_amount: Scalars['Float'];
  max_amount: Scalars['Float'];
  payment_provider: Maybe<GqlPaymentProviderGql>;
  payment_mode: Maybe<GqlPaymentModeGql>;
};

/** Payment Provider GQL. */
export type GqlPaymentProviderGql = {
  __typename?: 'PaymentProviderGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_provider_id: Scalars['String'];
  name: Scalars['String'];
  base_url: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  account_balance: Scalars['Float'];
  payment: Maybe<Array<Maybe<GqlPaymentGql>>>;
  payment_provider_modes: Maybe<Array<Maybe<GqlPaymentProviderModeGql>>>;
  party_mapping: Maybe<Array<Maybe<GqlPartyMappingGql>>>;
};

/** PartyMapping GQL. */
export type GqlPartyMappingGql = {
  __typename?: 'PartyMappingGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  party_mapping_id: Scalars['String'];
  payment_provider_id: Scalars['String'];
  provider_party_code: Scalars['Int'];
  party_id: Scalars['String'];
  payment_provider: Maybe<GqlPaymentProviderGql>;
  party: Maybe<GqlPartyGql>;
};

/** Node and relay Connection. */
export type GqlPartyGqlConnection = {
  __typename?: 'PartyGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPartyGqlEdge>>;
};

/** A Relay edge containing a `PartyGQL` and its cursor. */
export type GqlPartyGqlEdge = {
  __typename?: 'PartyGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPartyGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlPaymentProviderGqlConnection = {
  __typename?: 'PaymentProviderGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentProviderGqlEdge>>;
};

/** A Relay edge containing a `PaymentProviderGQL` and its cursor. */
export type GqlPaymentProviderGqlEdge = {
  __typename?: 'PaymentProviderGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentProviderGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlPaymentProviderModeGqlConnection = {
  __typename?: 'PaymentProviderModeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentProviderModeGqlEdge>>;
};

/** A Relay edge containing a `PaymentProviderModeGQL` and its cursor. */
export type GqlPaymentProviderModeGqlEdge = {
  __typename?: 'PaymentProviderModeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentProviderModeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlPaymentModeGqlConnection = {
  __typename?: 'PaymentModeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentModeGqlEdge>>;
};

/** A Relay edge containing a `PaymentModeGQL` and its cursor. */
export type GqlPaymentModeGqlEdge = {
  __typename?: 'PaymentModeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentModeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlPartyMappingGqlConnection = {
  __typename?: 'PartyMappingGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPartyMappingGqlEdge>>;
};

/** A Relay edge containing a `PartyMappingGQL` and its cursor. */
export type GqlPartyMappingGqlEdge = {
  __typename?: 'PartyMappingGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPartyMappingGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlCreateInboundPaymentConfig = {
  __typename?: 'CreateInboundPaymentConfig';
  created: Maybe<Scalars['Boolean']>;
  inbound_payment_config: Maybe<GqlInboundPaymentConfigGql>;
};

export type GqlInboundPaymentConfigInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  inbound_payment_provider_id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JSONString']>;
};

export type GqlUpdateInboundPaymentConfig = {
  __typename?: 'UpdateInboundPaymentConfig';
  inbound_payment_config: Maybe<GqlInboundPaymentConfigGql>;
};

export type GqlDeleteInboundPaymentConfig = {
  __typename?: 'DeleteInboundPaymentConfig';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePermissions = {
  __typename?: 'CreatePermissions';
  created: Maybe<Scalars['Boolean']>;
  permission: Maybe<GqlPermissionsGql>;
};

export type GqlPermissionsInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  permission?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type GqlUpdatePermissions = {
  __typename?: 'UpdatePermissions';
  permission: Maybe<GqlPermissionsGql>;
};

export type GqlDeletePermissions = {
  __typename?: 'DeletePermissions';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePaymentProvider = {
  __typename?: 'CreatePaymentProvider';
  created: Maybe<Scalars['Boolean']>;
  payment_provider: Maybe<GqlPaymentProviderGql>;
};

export type GqlPaymentProviderInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
  base_url?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  account_balance?: Maybe<Scalars['Decimal']>;
};


export type GqlUpdatePaymentProvider = {
  __typename?: 'UpdatePaymentProvider';
  payment_provider: Maybe<GqlPaymentProviderGql>;
};

export type GqlDeletePaymentProvider = {
  __typename?: 'DeletePaymentProvider';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePaymentProviderMode = {
  __typename?: 'CreatePaymentProviderMode';
  created: Maybe<Scalars['Boolean']>;
  payment_provider_mode: Maybe<GqlPaymentProviderModeGql>;
};

export type GqlPaymentProviderModeInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  payment_provider_id?: Maybe<Scalars['UUID']>;
  payment_mode_id?: Maybe<Scalars['UUID']>;
  min_amount?: Maybe<Scalars['Decimal']>;
  max_amount?: Maybe<Scalars['Decimal']>;
};

export type GqlUpdatePaymentProviderMode = {
  __typename?: 'UpdatePaymentProviderMode';
  payment_provider_mode: Maybe<GqlPaymentProviderModeGql>;
};

export type GqlDeletePaymentProviderMode = {
  __typename?: 'DeletePaymentProviderMode';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePaymentMode = {
  __typename?: 'CreatePaymentMode';
  created: Maybe<Scalars['Boolean']>;
  payment_mode: Maybe<GqlPaymentModeGql>;
};

export type GqlPaymentModeInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlUpdatePaymentMode = {
  __typename?: 'UpdatePaymentMode';
  payment_mode: Maybe<GqlPaymentModeGql>;
};

export type GqlDeletePaymentMode = {
  __typename?: 'DeletePaymentMode';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateParty = {
  __typename?: 'CreateParty';
  created: Maybe<Scalars['Boolean']>;
  party: Maybe<GqlPartyGql>;
};

export type GqlPartyInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
  swift_code?: Maybe<Scalars['String']>;
  payment_mode_id?: Maybe<Scalars['UUID']>;
};

export type GqlUpdateParty = {
  __typename?: 'UpdateParty';
  party: Maybe<GqlPartyGql>;
};

export type GqlDeleteParty = {
  __typename?: 'DeleteParty';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePartyMapping = {
  __typename?: 'CreatePartyMapping';
  created: Maybe<Scalars['Boolean']>;
  party_mapping: Maybe<GqlPartyMappingGql>;
};

export type GqlPartyMappingInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  payment_provider_id?: Maybe<Scalars['UUID']>;
  provider_party_code?: Maybe<Scalars['Int']>;
  party_id?: Maybe<Scalars['UUID']>;
};

export type GqlUpdatePartyMapping = {
  __typename?: 'UpdatePartyMapping';
  party_mapping: Maybe<GqlPartyMappingGql>;
};

export type GqlDeletePartyMapping = {
  __typename?: 'DeletePartyMapping';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateService = {
  __typename?: 'CreateService';
  created: Maybe<Scalars['Boolean']>;
  service: Maybe<GqlServiceGql>;
};

export type GqlServiceInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  service_metadata?: Maybe<Scalars['JSONString']>;
};

export type GqlUpdateService = {
  __typename?: 'UpdateService';
  service: Maybe<GqlServiceGql>;
};

export type GqlDeleteService = {
  __typename?: 'DeleteService';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateRole = {
  __typename?: 'CreateRole';
  created: Maybe<Scalars['Boolean']>;
  role: Maybe<GqlRoleGql>;
};

export type GqlRoleInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['JSONString']>;
  client_info?: Maybe<Scalars['JSONString']>;
  service_id?: Maybe<Scalars['UUID']>;
  permission_id?: Maybe<Scalars['UUID']>;
};

export type GqlUpdateRole = {
  __typename?: 'UpdateRole';
  role: Maybe<GqlRoleGql>;
};

export type GqlDeleteRole = {
  __typename?: 'DeleteRole';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlLogin = {
  __typename?: 'Login';
  status_code: Maybe<Scalars['Int']>;
  success: Maybe<Scalars['Boolean']>;
  token: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export enum GqlCallbackType {
  Order = 'ORDER',
  Delivery = 'DELIVERY'
}

export type GqlCustomer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  leadCallbackID: Scalars['ID'];
  leadCallback: GqlLeadCallback;
  twigaCustomerID: Scalars['ID'];
  legalName: Scalars['String'];
  phoneNumber: Scalars['String'];
  documentType: GqlDocumentType;
  documentNo: Scalars['String'];
  optedIn: Scalars['Boolean'];
  deliveryCount: Scalars['Int'];
  customerStatus: GqlCustomerStatus;
  loans: Array<GqlLoan>;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  ClientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlCustomerConnection = {
  __typename?: 'CustomerConnection';
  edges: Array<Maybe<GqlCustomer>>;
  page_info: GqlPageInfo;
};

export type GqlCustomerConnectionFilters = {
  id?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
};

export type GqlCustomerPartner = {
  __typename?: 'CustomerPartner';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  customer: GqlCustomer;
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  loanLimit: Scalars['Int'];
  loanAvailable: Scalars['Int'];
  canTakeALoan: Scalars['Boolean'];
  rejectionReasonCode: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  ClientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlCustomerPartnerConnection = {
  __typename?: 'CustomerPartnerConnection';
  edges: Array<Maybe<GqlCustomerPartner>>;
  page_info: GqlPageInfo;
};

export type GqlCustomerPartnerConnectionFilters = {
  id?: Maybe<Scalars['ID']>;
  customerID?: Maybe<Scalars['ID']>;
  partnerID?: Maybe<Scalars['ID']>;
};

export enum GqlCustomerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unqualified = 'UNQUALIFIED'
}


export type GqlDepotPartner = {
  __typename?: 'DepotPartner';
  id: Scalars['ID'];
  partnerID: Maybe<Scalars['ID']>;
  partner: Maybe<GqlPartner>;
  depot: GqlDepotV2Gql;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlDepotPartnerConnection = {
  __typename?: 'DepotPartnerConnection';
  edges: Array<Maybe<GqlDepotPartner>>;
  page_info: GqlPageInfo;
};

export type GqlDepotV2Gql = {
  __typename?: 'DepotV2GQL';
  depot_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  area_id: Maybe<Scalars['String']>;
  depot_name: Maybe<Scalars['String']>;
  area_sales_manager: Maybe<Scalars['String']>;
  depot_clerk: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  depot_fulfillment_officer: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  area: Maybe<GqlAreaV2Gql>;
  distribution_centers: Maybe<Array<Maybe<GqlDepotDistributionCenterGql>>>;
  routes: Maybe<Array<Maybe<GqlRouteV2Gql>>>;
  depot_dc_product_item_restrictions: Maybe<Array<Maybe<GqlDepotDcProductItemRestrictionGql>>>;
  user: Maybe<GqlUserV2Gql>;
  clerk: Maybe<GqlUserV2Gql>;
  dfo: Maybe<GqlUserV2Gql>;
  route_plan_summary: Maybe<GqlDepotRoutePlanSummaryGql>;
};


export type GqlDepotV2GqlRoute_Plan_SummaryArgs = {
  delivery_date: Scalars['String'];
};

export enum GqlDocumentType {
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export enum GqlEarningType {
  Interest = 'INTEREST',
  Penalty = 'PENALTY',
  Waiver = 'WAIVER',
  Withdrawal = 'WITHDRAWAL'
}

export enum GqlInterestType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type GqlLeadCallback = {
  __typename?: 'LeadCallback';
  id: Scalars['ID'];
  twigaLeadCallbackID: Scalars['ID'];
  customerData: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  ClientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLeadCallbackConnection = {
  __typename?: 'LeadCallbackConnection';
  edges: Array<Maybe<GqlLeadCallback>>;
  page_info: GqlPageInfo;
};

export type GqlLoan = {
  __typename?: 'Loan';
  id: Scalars['ID'];
  loanNumber: Scalars['String'];
  loanedAmount: Scalars['Int'];
  status: GqlLoanStatus;
  loanRequestID: Scalars['ID'];
  loanRequest: GqlLoanRequest;
  loanOfferID: Scalars['ID'];
  loanOffer: GqlLoanOffer;
  loanProductID: Scalars['ID'];
  loanProduct: GqlLoanProduct;
  balance: Scalars['Int'];
  repaidAmount: Scalars['Int'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  customerID: Scalars['ID'];
  customer: GqlCustomer;
  gracePeriodEndDate: Scalars['String'];
  loanMaturityDate: Scalars['String'];
  loanSuspensionDate: Scalars['String'];
  details: Scalars['String'];
  receiptNo: Scalars['String'];
  rejectionReasonCode: Scalars['String'];
  penaltyCommencementDate: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanConnection = {
  __typename?: 'LoanConnection';
  edges: Array<Maybe<GqlLoan>>;
  page_info: GqlPageInfo;
};

export type GqlLoanConnectionFilters = {
  id?: Maybe<Scalars['ID']>;
  loanNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GqlLoanOffer = {
  __typename?: 'LoanOffer';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  customer: GqlCustomer;
  offerAmount: Scalars['Int'];
  rejectionReasonCode: Scalars['String'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  orderCallbackID: Scalars['ID'];
  orderCallback: GqlOrderCallback;
  expiryDate: Scalars['Time'];
  receiptNo: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanOfferConnection = {
  __typename?: 'LoanOfferConnection';
  edges: Array<Maybe<GqlLoanOffer>>;
  page_info: GqlPageInfo;
};

export type GqlLoanProduct = {
  __typename?: 'LoanProduct';
  id: Scalars['ID'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  name: Scalars['String'];
  interestRate: Scalars['Float'];
  interestType: GqlInterestType;
  interestGracePeriod: Scalars['Int'];
  penaltyGracePeriod: Scalars['Int'];
  penaltyApplicationPeriod: Scalars['Int'];
  repaymentPeriod: Scalars['Int'];
  penaltyType: GqlInterestType;
  penaltyRate: Scalars['Float'];
  interestAmount: Scalars['Int'];
  interestSchedule: Scalars['Int'];
  penaltyAmount: Scalars['Int'];
  minAmount: Scalars['Int'];
  maxAmount: Scalars['Int'];
  hasFacilitationFee: Scalars['Boolean'];
  facilitationFeeAmount: Scalars['Int'];
  facilitationFeeRate: Scalars['Float'];
  facilitationFeeType: GqlInterestType;
  facilitationFeeThreshold: Scalars['Int'];
  loanType: GqlLoanType;
  penaltyMethod: GqlPenaltyMethod;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanProductConnection = {
  __typename?: 'LoanProductConnection';
  edges: Array<Maybe<GqlLoanProduct>>;
  page_info: GqlPageInfo;
};

export type GqlLoanProductConnectionFilters = {
  id?: Maybe<Scalars['ID']>;
  partnerID?: Maybe<Scalars['ID']>;
  loanLimit?: Maybe<Scalars['String']>;
};

export type GqlLoanRejectionReason = {
  __typename?: 'LoanRejectionReason';
  id: Scalars['ID'];
  code: Scalars['String'];
  description: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanRejectionReasonFilters = {
  rejectionReasonCode?: Maybe<Scalars['String']>;
};

export type GqlLoanRepayment = {
  __typename?: 'LoanRepayment';
  id: Scalars['ID'];
  amount: Scalars['Int'];
  transactionRef: Scalars['String'];
  claimed: Scalars['Boolean'];
  payloadReceived: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanRepaymentConnection = {
  __typename?: 'LoanRepaymentConnection';
  edges: Array<Maybe<GqlLoanRepayment>>;
  page_info: GqlPageInfo;
};

export type GqlLoanRepaymentConnectionFilters = {
  code?: Maybe<Scalars['String']>;
};

export type GqlLoanRequest = {
  __typename?: 'LoanRequest';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  customer: GqlCustomer;
  receiptNo: Scalars['String'];
  amount: Scalars['Int'];
  loanOfferID: Scalars['ID'];
  loanOffer: GqlLoanOffer;
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  payloadReceived: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanRequestConnection = {
  __typename?: 'LoanRequestConnection';
  edges: Array<Maybe<GqlLoanRequest>>;
  page_info: GqlPageInfo;
};

export enum GqlLoanStatus {
  ActiveUnpaid = 'ACTIVE_UNPAID',
  ActivePartiallyPaid = 'ACTIVE_PARTIALLY_PAID',
  FullyPaid = 'FULLY_PAID',
  Cancelled = 'CANCELLED',
  Defaulted = 'DEFAULTED',
  Suspended = 'SUSPENDED',
  Overdue = 'OVERDUE'
}

export enum GqlLoanType {
  Single = 'SINGLE',
  MultiloanSingleDay = 'MULTILOAN_SINGLE_DAY',
  MultiloanInfinite = 'MULTILOAN_INFINITE'
}

export type GqlLoanUpdate = {
  __typename?: 'LoanUpdate';
  id: Scalars['ID'];
  updateType: GqlLoanUpdateType;
  transactionType: GqlTransactionType;
  amount: Scalars['Int'];
  loanBalance: Scalars['Int'];
  loanID: Scalars['ID'];
  loan: GqlLoan;
  transactionRef: Scalars['String'];
  details: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlLoanUpdateConnection = {
  __typename?: 'LoanUpdateConnection';
  edges: Array<Maybe<GqlLoanUpdate>>;
  page_info: GqlPageInfo;
};

export type GqlLoanUpdateConnectionFilters = {
  loanID?: Maybe<Scalars['ID']>;
};

export enum GqlLoanUpdateType {
  Interest = 'INTEREST',
  Penalty = 'PENALTY',
  Repayment = 'REPAYMENT',
  Waiver = 'WAIVER',
  Cancellation = 'CANCELLATION',
  Suspended = 'SUSPENDED'
}

export type GqlLoanWaiverReason = {
  __typename?: 'LoanWaiverReason';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};


export type GqlMediatedLimit = {
  __typename?: 'MediatedLimit';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  partnerID: Scalars['ID'];
  loanLimit: Scalars['Int'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  ClientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlNewDepotPartner = {
  partnerID: Scalars['ID'];
  depotID: Scalars['ID'];
  clientStamp: Scalars['String'];
};

export type GqlNewLoanProduct = {
  partnerID: Scalars['ID'];
  name: Scalars['String'];
  interestRate: Scalars['Float'];
  interestType: GqlInterestType;
  interestGracePeriod: Scalars['Int'];
  penaltyGracePeriod: Scalars['Int'];
  repaymentPeriod: Scalars['Int'];
  penaltyType: GqlInterestType;
  penaltyRate: Scalars['Float'];
  interestAmount: Scalars['Int'];
  penaltyAmount: Scalars['Int'];
  minAmount: Scalars['Int'];
  maxAmount: Scalars['Int'];
  facilitationFee: Scalars['Int'];
  facilitationFeeType: GqlInterestType;
  facilitationFeeThreshold: Scalars['Int'];
  loanType: GqlLoanType;
  penaltyMethod: GqlPenaltyMethod;
  clientStamp: Scalars['String'];
};

export type GqlNewLoanRejectionReason = {
  code: Scalars['String'];
  description: Scalars['String'];
  clientStamp: Scalars['String'];
};

export type GqlNewLoanUpdate = {
  updateType: GqlLoanUpdateType;
  amount?: Maybe<Scalars['Int']>;
  loanID: Scalars['ID'];
  details?: Maybe<Scalars['String']>;
  clientStamp: Scalars['String'];
};

export type GqlNewLoanWaiverReason = {
  name: Scalars['String'];
  description: Scalars['String'];
  clientStamp: Scalars['String'];
};

export type GqlNewPartner = {
  name: Scalars['String'];
  creditScoringURL: Scalars['String'];
  creditScoringToken?: Maybe<Scalars['String']>;
  amount: Scalars['Int'];
  clientStamp: Scalars['String'];
};

export type GqlNewPartnerEarning = {
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  earningType: GqlEarningType;
  clientStamp: Scalars['String'];
};

export type GqlNewPartnerTopup = {
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  details: Scalars['String'];
  clientStamp: Scalars['String'];
};

export type GqlNewPartnerWithdrawal = {
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  details: Scalars['String'];
  clientStamp: Scalars['String'];
};

export type GqlOrderCallback = {
  __typename?: 'OrderCallback';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  receiptNo: Scalars['String'];
  amount: Scalars['Int'];
  referenceID: Scalars['String'];
  callbackType: GqlCallbackType;
  depotID: Scalars['ID'];
  payloadReceived: Scalars['String'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  ClientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlOrderCallbackConnection = {
  __typename?: 'OrderCallbackConnection';
  edges: Array<Maybe<GqlOrderCallback>>;
  page_info: GqlPageInfo;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type GqlPageInfo = {
  __typename?: 'PageInfo';
  hasNext: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  pageSize: Scalars['Int'];
  count: Scalars['Int'];
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
};

export type GqlPartner = {
  __typename?: 'Partner';
  id: Scalars['ID'];
  name: Scalars['String'];
  creditScoringURL: Scalars['String'];
  floatBalance: Scalars['Int'];
  earningsBalance: Scalars['Int'];
  creditScoringToken: Scalars['String'];
  details: Scalars['String'];
  loans: Array<GqlLoan>;
  loanProducts: Array<GqlLoanProduct>;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlPartnerConnection = {
  __typename?: 'PartnerConnection';
  edges: Array<Maybe<GqlPartner>>;
  page_info: GqlPageInfo;
};

export type GqlPartnerConnectionFilters = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlPartnerEarning = {
  __typename?: 'PartnerEarning';
  id: Scalars['ID'];
  amount: Scalars['Int'];
  earningsBalance: Scalars['Int'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  earningType: GqlEarningType;
  transactionType: GqlTransactionType;
  loanID: Scalars['ID'];
  loan: GqlLoan;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlPartnerEarningConnection = {
  __typename?: 'PartnerEarningConnection';
  edges: Array<Maybe<GqlPartnerEarning>>;
  page_info: GqlPageInfo;
};

export type GqlPartnerEarningConnectionFilters = {
  partnerID?: Maybe<Scalars['ID']>;
};

export type GqlPartnerTopup = {
  __typename?: 'PartnerTopup';
  id: Scalars['ID'];
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  details: Scalars['String'];
  approved: Scalars['Boolean'];
  approvedByID: Scalars['String'];
  floatBalance: Scalars['Int'];
  updateType: GqlPartnerUpdateType;
  transactionType: GqlTransactionType;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlPartnerTopupConnection = {
  __typename?: 'PartnerTopupConnection';
  edges: Array<Maybe<GqlPartnerTopup>>;
  page_info: GqlPageInfo;
};

export type GqlPartnerTopupConnectionFilters = {
  partnerID?: Maybe<Scalars['ID']>;
};

export type GqlPartnerUpdate = {
  __typename?: 'PartnerUpdate';
  id: Scalars['ID'];
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  partner: GqlPartner;
  loanID: Scalars['ID'];
  loan: GqlLoan;
  floatBalance: Scalars['Int'];
  updateType: GqlPartnerUpdateType;
  transactionType: GqlTransactionType;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlPartnerUpdateConnection = {
  __typename?: 'PartnerUpdateConnection';
  edges: Array<Maybe<GqlPartnerUpdate>>;
  page_info: GqlPageInfo;
};

export type GqlPartnerUpdateConnectionFilters = {
  partnerID?: Maybe<Scalars['ID']>;
};

export enum GqlPartnerUpdateType {
  Repayment = 'REPAYMENT',
  Loan = 'LOAN',
  Topup = 'TOPUP'
}

export enum GqlPenaltyMethod {
  OneOff = 'ONE_OFF',
  Recurring = 'RECURRING'
}

export type GqlSokowalletRequest = {
  __typename?: 'SokowalletRequest';
  id: Scalars['ID'];
  customerID: Scalars['ID'];
  customer: GqlCustomer;
  amount: Scalars['Int'];
  transactionRef: Scalars['String'];
  sent: Scalars['Boolean'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Maybe<Scalars['Boolean']>;
  createdByID: Scalars['String'];
  updatedByID: Scalars['String'];
  clientStamp: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};


export enum GqlTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  None = 'NONE'
}

export type GqlUpdateCustomerPartner = {
  id: Scalars['ID'];
  limit: Scalars['Int'];
};

export type GqlUpdateDepotPartner = {
  ID: Scalars['ID'];
  partnerID: Scalars['ID'];
};

export type GqlUpdateLoanProduct = {
  ID: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestType?: Maybe<GqlInterestType>;
  interestGracePeriod?: Maybe<Scalars['Int']>;
  penaltyGracePeriod?: Maybe<Scalars['Int']>;
  repaymentPeriod?: Maybe<Scalars['Int']>;
  penaltyType?: Maybe<GqlInterestType>;
  penaltyRate?: Maybe<Scalars['Float']>;
  interestAmount?: Maybe<Scalars['Int']>;
  penaltyAmount?: Maybe<Scalars['Int']>;
  minAmount?: Maybe<Scalars['Int']>;
  maxAmount?: Maybe<Scalars['Int']>;
  loanType?: Maybe<GqlLoanType>;
  active?: Maybe<Scalars['Boolean']>;
};

export type GqlUpdatePartner = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  creditScoringURL?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
};

export type GqlUpdatePartnerTopup = {
  id: Scalars['ID'];
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  approved: Scalars['Boolean'];
  clientStamp: Scalars['String'];
};

export type GqlUpdatePartnerWithdrawal = {
  id: Scalars['ID'];
  amount: Scalars['Int'];
  partnerID: Scalars['ID'];
  approved: Scalars['Boolean'];
  clientStamp: Scalars['String'];
};

/** Pagination Connection for SupplierV2GQL. */
export type GqlSupplierV2GqlConnection = {
  __typename?: 'SupplierV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierV2GqlEdge>>;
};

/** A Relay edge containing a `SupplierV2GQL` and its cursor. */
export type GqlSupplierV2GqlEdge = {
  __typename?: 'SupplierV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSupplierV2Gql = {
  __typename?: 'SupplierV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  supplier_id: Scalars['String'];
  supplier_name: Scalars['String'];
  phone_number: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  users: Maybe<Array<Maybe<GqlSupplierUserV2Gql>>>;
  products: Maybe<Array<Maybe<GqlSupplierProductV2Gql>>>;
};

export type GqlSupplierUserV2Gql = {
  __typename?: 'SupplierUserV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  supplier_user_id: Scalars['String'];
  user_id: Scalars['String'];
  supplier_id: Scalars['String'];
  user_active: Scalars['Boolean'];
  role_id: Scalars['String'];
  supplier_user: Maybe<GqlSupplierV2Gql>;
};

export type GqlSupplierProductV2Gql = {
  __typename?: 'SupplierProductV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  supplier_product_id: Scalars['String'];
  supplier_id: Scalars['String'];
  product_id: Scalars['String'];
  supplier_product: Maybe<GqlSupplierV2Gql>;
};

/** Pagination Connection for SupplierUserV2GQL. */
export type GqlSupplierUserV2GqlConnection = {
  __typename?: 'SupplierUserV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierUserV2GqlEdge>>;
};

/** A Relay edge containing a `SupplierUserV2GQL` and its cursor. */
export type GqlSupplierUserV2GqlEdge = {
  __typename?: 'SupplierUserV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierUserV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for SupplierProductV2GQL. */
export type GqlSupplierProductV2GqlConnection = {
  __typename?: 'SupplierProductV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierProductV2GqlEdge>>;
};

/** A Relay edge containing a `SupplierProductV2GQL` and its cursor. */
export type GqlSupplierProductV2GqlEdge = {
  __typename?: 'SupplierProductV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierProductV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for SupplierCampaignV2GQL. */
export type GqlSupplierCampaignV2GqlConnection = {
  __typename?: 'SupplierCampaignV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierCampaignV2GqlEdge>>;
};

/** A Relay edge containing a `SupplierCampaignV2GQL` and its cursor. */
export type GqlSupplierCampaignV2GqlEdge = {
  __typename?: 'SupplierCampaignV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierCampaignV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSupplierCampaignV2Gql = {
  __typename?: 'SupplierCampaignV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  supplier_campaign_id: Scalars['String'];
  supplier_id: Scalars['String'];
  title: Maybe<Scalars['String']>;
  campaign_type: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['DateTime']>;
  end_date: Maybe<Scalars['DateTime']>;
  passenger_product_id: Scalars['String'];
  carrier_product_id: Scalars['String'];
  distribution_areas: Maybe<Scalars['JSONString']>;
  carrier_discount: Scalars['Float'];
  total_cost: Scalars['Float'];
};

export type GqlDigitalTransaction = {
  __typename?: 'DigitalTransaction';
  id: Scalars['ID'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Scalars['Boolean'];
  createdByID: Scalars['String'];
  updatedByID: Maybe<Scalars['String']>;
  productID: Scalars['String'];
  product: GqlDigitalProduct;
  amount: Scalars['Int'];
  transactionNumber: Scalars['String'];
  shopID: Scalars['String'];
  accountID: Scalars['String'];
  targetPhoneNumber: Scalars['String'];
  targetAccountNumber: Scalars['String'];
  commission: Scalars['Float'];
  payloadSent: Maybe<Scalars['String']>;
  payloadReceived: Maybe<Scalars['String']>;
  callbackResponse: Maybe<Scalars['String']>;
  transactionRef: Maybe<Scalars['String']>;
  requestCompleted: Scalars['Boolean'];
  status: GqlDigitalTransactionStatus;
  description: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['Map']>;
};

export type GqlUserSubscribeInput = {
  token: Scalars['String'];
  platform: Scalars['String'];
  accountID: Scalars['String'];
  topics: Array<Scalars['String']>;
};

export type GqlDigitalServiceFilters = {
  ids?: Maybe<Array<Scalars['UUID']>>;
  active?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
};

export type GqlUpdateDigitalProductInput = {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  commission?: Maybe<Scalars['Float']>;
  serviceID?: Maybe<Scalars['String']>;
  minAmount?: Maybe<Scalars['Int']>;
  maxAmount?: Maybe<Scalars['Int']>;
};

export type GqlSellProductInput = {
  shopID: Scalars['UUID'];
  amount: Scalars['Int'];
  shopNumber: Scalars['String'];
  targetPhoneNumber: Scalars['String'];
  productID: Scalars['UUID'];
  targetAccountNumber: Scalars['String'];
  meta?: Maybe<Scalars['Map']>;
};

export type GqlDigitalProductFilters = {
  ids?: Maybe<Array<Scalars['UUID']>>;
  active?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  serviceID?: Maybe<Scalars['String']>;
};

export type GqlUpdateDigitalServiceInput = {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageSvg?: Maybe<Scalars['String']>;
};

export type GqlDigitalTopupInput = {
  shopID: Scalars['UUID'];
  accountID: Scalars['UUID'];
  amount: Scalars['Int'];
  phoneNumber: Scalars['String'];
  meta?: Maybe<Scalars['Map']>;
};

export enum GqlDigitalTransactionStatus {
  Pending = 'PENDING',
  Failed = 'FAILED',
  Successful = 'SUCCESSFUL'
}

export type GqlDigitalProductCommission = {
  __typename?: 'DigitalProductCommission';
  id: Scalars['ID'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Scalars['Boolean'];
  createdByID: Scalars['String'];
  updatedByID: Maybe<Scalars['String']>;
  productID: Scalars['String'];
  commissionPercentage: Scalars['Float'];
  startValue: Scalars['Int'];
  endValue: Scalars['Int'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlDigitalTopup = {
  __typename?: 'DigitalTopup';
  id: Scalars['ID'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Scalars['Boolean'];
  createdByID: Scalars['String'];
  updatedByID: Maybe<Scalars['String']>;
  amount: Scalars['Int'];
  status: Maybe<Scalars['String']>;
  shopID: Scalars['String'];
  accountID: Scalars['String'];
  phoneNumber: Scalars['String'];
  transactionRef: Maybe<Scalars['String']>;
  stkCompleted: Scalars['Boolean'];
  topupCompleted: Scalars['Boolean'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlCreateDigitalServiceInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  imageSvg: Scalars['String'];
};

export type GqlNonScalarBoolean = {
  __typename?: 'NonScalarBoolean';
  result: Scalars['Boolean'];
};

export type GqlDigitalService = {
  __typename?: 'DigitalService';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Scalars['Boolean'];
  createdByID: Scalars['String'];
  updatedByID: Maybe<Scalars['String']>;
  imageSvg: Scalars['String'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlDigitalTransactionFilters = {
  ids?: Maybe<Array<Scalars['UUID']>>;
  active?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  shopID?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  status?: Maybe<GqlDigitalTransactionStatus>;
};

export type GqlCreateDigitalProductInput = {
  name: Scalars['String'];
  serviceID: Scalars['UUID'];
  method?: Maybe<Scalars['String']>;
  commission: Scalars['Float'];
  code: Scalars['String'];
  minAmount: Scalars['Int'];
  maxAmount: Scalars['Int'];
};

export type GqlDigitalProduct = {
  __typename?: 'DigitalProduct';
  id: Scalars['ID'];
  dateCreated: Scalars['Time'];
  dateUpdated: Scalars['Time'];
  deletedAt: Maybe<Scalars['Time']>;
  active: Scalars['Boolean'];
  createdByID: Scalars['String'];
  updatedByID: Maybe<Scalars['String']>;
  name: Scalars['String'];
  method: Maybe<Scalars['String']>;
  code: Scalars['String'];
  serviceID: Scalars['String'];
  service: GqlDigitalService;
  bandedCommissions: Array<GqlDigitalProductCommission>;
  description: Maybe<Scalars['String']>;
  commission: Scalars['Float'];
  minAmount: Scalars['Int'];
  maxAmount: Scalars['Int'];
  meta: Maybe<Scalars['Map']>;
};

export type GqlDigitalTransactionConnection = {
  __typename?: 'DigitalTransactionConnection';
  pageInfo: GqlPageInfo;
  edges: Array<GqlDigitalTransaction>;
};

/** Pagination Connection for SokoLoanRepaymentGQL */
export type GqlSokoLoanRepaymentGqlConnection = {
  __typename?: 'SokoLoanRepaymentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlSokoLoanRepaymentGqlEdge>>;
};

export type GqlSokoLoanRepaymentGqlEdge = {
  __typename?: 'SokoLoanRepaymentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSokoLoanRepaymentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSokoLoanRepaymentGql = {
  __typename?: 'SokoLoanRepaymentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  sokoloan_repayment_id: Scalars['String'];
  loan_confirmation_id: Scalars['String'];
  partner_id: Scalars['String'];
  reference_number: Maybe<Scalars['String']>;
  loan_reference_id: Scalars['String'];
  amount: Scalars['Float'];
  payment_date: Scalars['String'];
  partner_payment_reference: Maybe<Scalars['String']>;
  forwarded: Scalars['Boolean'];
  payment_mode: Scalars['String'];
  loan_confirmation: Maybe<GqlLoanGql>;
};

export type GqlLoanGql = {
  __typename?: 'LoanGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  loan_confirmation_id: Scalars['String'];
  delivery_callback_id: Maybe<Scalars['String']>;
  delivery_id: Maybe<Scalars['String']>;
  delivery_amount: Maybe<Scalars['Float']>;
  loaned_amount: Maybe<Scalars['Float']>;
  loan_reference_id: Maybe<Scalars['String']>;
  loan_status: Maybe<Scalars['Boolean']>;
  due_amount: Maybe<Scalars['Float']>;
  due_date: Maybe<Scalars['DateTime']>;
  offer_date: Maybe<Scalars['DateTime']>;
  receipt_no: Maybe<Scalars['String']>;
  reported_balance: Maybe<Scalars['Float']>;
  loan_offer_id: Maybe<Scalars['String']>;
  rejection_reason_id: Maybe<Scalars['String']>;
  partner_id: Maybe<Scalars['String']>;
  charge: Scalars['Float'];
  delivery_callback: Maybe<GqlDeliveryCallbackGql>;
  partner: Maybe<GqlPartnerGql>;
  rejection_reason: Maybe<GqlLoanRejectionReasonGql>;
  repayments: Maybe<Array<Maybe<GqlLoanRepaymentGql>>>;
  loan_offer: Maybe<GqlLoanOfferGql>;
};

export type GqlDeliveryCallbackGql = {
  __typename?: 'DeliveryCallbackGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  delivery_callback_id: Scalars['String'];
  partner_id: Maybe<Scalars['String']>;
  customer_id: Maybe<Scalars['String']>;
  fintech_delivery_id: Maybe<Scalars['String']>;
  delivery_id: Maybe<Scalars['String']>;
  receipt_no: Maybe<Scalars['String']>;
  partner: Maybe<GqlPartnerGql>;
  delivery: Maybe<GqlFintechDeliveryGql>;
  loan_confirmation: Maybe<Array<Maybe<GqlLoanGql>>>;
};

/** Fintech Partner GQL Type */
export type GqlPartnerGql = {
  __typename?: 'PartnerGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  partner_id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  auth_token: Maybe<Scalars['String']>;
  delivery_callback_url: Maybe<Scalars['String']>;
  lead_callback_url: Maybe<Scalars['String']>;
  loan_request_url: Maybe<Scalars['String']>;
  loan_query_url: Maybe<Scalars['String']>;
  member_query_url: Maybe<Scalars['String']>;
  repayment_callback_url: Maybe<Scalars['String']>;
  options: Maybe<Scalars['JSONString']>;
  product_name: Maybe<Scalars['String']>;
  blacklisted_routes: Maybe<Array<Maybe<Scalars['String']>>>;
  subscribed_routes: Maybe<Array<Maybe<Scalars['String']>>>;
  payment_info: Maybe<Scalars['JSONString']>;
  is_charged: Scalars['Boolean'];
  summary: Maybe<Scalars['String']>;
  delivery_callbacks: Maybe<Array<Maybe<GqlDeliveryCallbackGql>>>;
  customers: Maybe<Array<Maybe<GqlFintechCustomerGql>>>;
  loans: Maybe<Array<Maybe<GqlLoanGql>>>;
  can_receive_payment: Maybe<Scalars['Boolean']>;
};

export type GqlFintechCustomerGql = {
  __typename?: 'FintechCustomerGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  fintech_customer_id: Scalars['String'];
  customer_number: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  phone_number: Maybe<Scalars['String']>;
  legal_name: Maybe<Scalars['String']>;
  document_number: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  date_registered: Maybe<Scalars['String']>;
  opt_in: Maybe<Scalars['Boolean']>;
  lead_callback_id: Maybe<Scalars['String']>;
  partners: Maybe<Array<Maybe<GqlPartnerGql>>>;
  deliveries: Maybe<Array<Maybe<GqlFintechDeliveryGql>>>;
  total_deliveries: Maybe<Scalars['Int']>;
  total_loans: Maybe<Scalars['Int']>;
  total_delivery_amount: Maybe<Scalars['Float']>;
  total_loan_amount_received: Maybe<Scalars['Float']>;
};

export type GqlFintechDeliveryGql = {
  __typename?: 'FintechDeliveryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  fintech_delivery_id: Scalars['String'];
  delivery_id: Maybe<Scalars['String']>;
  customer_id: Maybe<Scalars['String']>;
  stall_id: Maybe<Scalars['String']>;
  route_id: Maybe<Scalars['String']>;
  route_team_id: Maybe<Scalars['String']>;
  amount: Maybe<Scalars['Float']>;
  receipt_no: Maybe<Scalars['String']>;
  till_number: Maybe<Scalars['String']>;
  date: Maybe<Scalars['DateTime']>;
  delivery_data: Maybe<Scalars['JSONString']>;
  assigned_partner_id: Maybe<Scalars['String']>;
  order_delivery_id: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSONString']>;
  customer: Maybe<GqlFintechCustomerGql>;
  assigned_partner: Maybe<GqlPartnerGql>;
  delivery_callbacks: Maybe<Array<Maybe<GqlDeliveryCallbackGql>>>;
  route_team_members: Maybe<Array<Maybe<GqlRouteTeamMemberGql>>>;
};

export type GqlRouteTeamMemberGql = {
  __typename?: 'RouteTeamMemberGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  route_team_member_id: Scalars['String'];
  fintech_delivery_id: Maybe<Scalars['String']>;
  route_team_id: Maybe<Scalars['String']>;
  phone_number: Maybe<Scalars['String']>;
  user_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  last_name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  user_no: Maybe<Scalars['String']>;
  delivery: Maybe<GqlFintechDeliveryGql>;
};

export type GqlLoanRejectionReasonGql = {
  __typename?: 'LoanRejectionReasonGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  loan_rejection_reason_id: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  message: Maybe<Scalars['String']>;
};

export type GqlLoanRepaymentGql = {
  __typename?: 'LoanRepaymentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  loan_repayment_id: Scalars['String'];
  loan_confirmation_id: Maybe<Scalars['String']>;
  loan_reference_id: Maybe<Scalars['String']>;
  loan_amount: Maybe<Scalars['Float']>;
  amount_paid: Maybe<Scalars['Float']>;
  loan_balance: Maybe<Scalars['Float']>;
  paid_datetime: Maybe<Scalars['DateTime']>;
  due_date: Maybe<Scalars['DateTime']>;
  receipt_no: Maybe<Scalars['String']>;
  partner_id: Maybe<Scalars['String']>;
  loan_confirmation: Maybe<GqlLoanGql>;
};

export type GqlLoanOfferGql = {
  __typename?: 'LoanOfferGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  loan_offer_id: Scalars['String'];
  partner_id: Scalars['String'];
  delivery_callback_id: Maybe<Scalars['String']>;
  delivery_id: Scalars['String'];
  offer_amount: Scalars['Float'];
  offer_status: Scalars['Boolean'];
  receipt_no: Maybe<Scalars['String']>;
  offer_expiry: Scalars['DateTime'];
  limit_amount: Maybe<Scalars['Float']>;
  offer_reference_id: Scalars['String'];
  offer_date: Scalars['DateTime'];
  loan_terms: Scalars['JSONString'];
  rejection_reason_id: Maybe<Scalars['String']>;
  rejection_reason: Maybe<GqlLoanRejectionReasonGql>;
  partner: Maybe<GqlPartnerGql>;
  loan_request: Maybe<GqlLoanRequestGql>;
};

export type GqlLoanRequestGql = {
  __typename?: 'LoanRequestGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  loan_request_id: Scalars['String'];
  customer_id: Scalars['String'];
  partner_id: Scalars['String'];
  delivery_id: Scalars['String'];
  loan_amount: Scalars['Float'];
  loan_offer_id: Maybe<Scalars['String']>;
  date_initiated: Scalars['DateTime'];
  loan_offer: Maybe<GqlLoanOfferGql>;
  partner: Maybe<GqlPartnerGql>;
  customer: Maybe<GqlFintechCustomerGql>;
};

export type GqlLeadCallbackGqlConnection = {
  __typename?: 'LeadCallbackGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlLeadCallbackGqlEdge>>;
};

export type GqlLeadCallbackGqlEdge = {
  __typename?: 'LeadCallbackGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLeadCallbackGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlLeadCallbackGql = {
  __typename?: 'LeadCallbackGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  lead_callback_id: Scalars['String'];
  partner_id: Maybe<Scalars['String']>;
  customer_id: Scalars['String'];
  shop_id: Scalars['String'];
  customer_data: Scalars['JSONString'];
  partner: Maybe<GqlPartnerGql>;
};

/** Pagination Connection for LoanGQL */
export type GqlLoanGqlConnection = {
  __typename?: 'LoanGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlLoanGqlEdge>>;
};

export type GqlLoanGqlEdge = {
  __typename?: 'LoanGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLoanGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for LoanOfferGQL */
export type GqlLoanOfferGqlConnection = {
  __typename?: 'LoanOfferGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlLoanOfferGqlEdge>>;
};

export type GqlLoanOfferGqlEdge = {
  __typename?: 'LoanOfferGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLoanOfferGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for LoanRequestGQL */
export type GqlLoanRequestGqlConnection = {
  __typename?: 'LoanRequestGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlLoanRequestGqlEdge>>;
};

export type GqlLoanRequestGqlEdge = {
  __typename?: 'LoanRequestGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLoanRequestGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPartnerLoanQueryGql = {
  __typename?: 'PartnerLoanQueryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  partner_loan_query_id: Scalars['String'];
  limit_amount: Scalars['Float'];
  limit_date: Scalars['DateTime'];
  loan_balance: Scalars['Float'];
  customer_id: Scalars['String'];
  partner_id: Scalars['String'];
  partner: Maybe<GqlPartnerGql>;
  customer: Maybe<GqlFintechCustomerGql>;
};

export type GqlPartnerMemberQueryGql = {
  __typename?: 'PartnerMemberQueryGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  payload_sent: Maybe<Scalars['JSONString']>;
  payload_received: Maybe<Scalars['JSONString']>;
  completed: Scalars['Boolean'];
  attempts: Scalars['Int'];
  date_updated: Scalars['DateTime'];
  partner_member_query_id: Scalars['String'];
  opted_in: Scalars['Boolean'];
  current_loan_limit: Scalars['Float'];
  can_take_a_loan: Scalars['Boolean'];
  vendor_class: Scalars['JSONString'];
  rejection_reason_id: Maybe<Scalars['String']>;
  customer_id: Scalars['String'];
  partner_id: Scalars['String'];
  partner: Maybe<GqlPartnerGql>;
  customer: Maybe<GqlFintechCustomerGql>;
  rejection_reason: Maybe<GqlLoanRejectionReasonGql>;
};

/** Pagination Connection for FintechDeliveryGQL */
export type GqlFintechDeliveryGqlConnection = {
  __typename?: 'FintechDeliveryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlFintechDeliveryGqlEdge>>;
};

export type GqlFintechDeliveryGqlEdge = {
  __typename?: 'FintechDeliveryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFintechDeliveryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for FintechCustomerGQL */
export type GqlFintechCustomerGqlConnection = {
  __typename?: 'FintechCustomerGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlFintechCustomerGqlEdge>>;
};

export type GqlFintechCustomerGqlEdge = {
  __typename?: 'FintechCustomerGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFintechCustomerGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for PricingGQL type. */
export type GqlPricingV2GqlConnection = {
  __typename?: 'PricingV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPricingV2GqlEdge>>;
};

/** A Relay edge containing a `PricingV2GQL` and its cursor. */
export type GqlPricingV2GqlEdge = {
  __typename?: 'PricingV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPricingV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPricingV2Gql = GqlNode & {
  __typename?: 'PricingV2GQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  pricing_id: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Scalars['String'];
  pricing_date: Scalars['String'];
  base_price: Scalars['Float'];
  rrp: Scalars['Float'];
  currency: GqlCurrencyEnum;
  region_id: Scalars['String'];
  previous_price: Maybe<Scalars['Float']>;
  discount_tag: Maybe<Scalars['Boolean']>;
  discount_value_type: Maybe<GqlDiscountValueTypeEnum>;
  /** The ID of the object. */
  id: Scalars['ID'];
  product_item: Maybe<GqlProductItemV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

/** An object with an ID */
export type GqlNode = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

/** currency enum */
export enum GqlCurrencyEnum {
  Kes = 'KES',
  Tzs = 'TZS',
  Ugx = 'UGX'
}

/** An enumeration. */
export enum GqlDiscountValueTypeEnum {
  Percentage = 'PERCENTAGE',
  Value = 'VALUE'
}

export type GqlProductItemV2Gql = {
  __typename?: 'ProductItemV2GQL';
  product_item_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  upc_code: Maybe<Scalars['String']>;
  product_item_code: Maybe<Scalars['String']>;
  product_item_name: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  staff_only: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  packed_weight: Scalars['Float'];
  packed_volume: Scalars['Float'];
  supplier_item: Scalars['Boolean'];
  product_item_segment_id: Maybe<Scalars['String']>;
  whitelisted_routes: Maybe<Array<Maybe<Scalars['String']>>>;
  blacklisted_routes: Maybe<Array<Maybe<Scalars['String']>>>;
  wms_default_available: Maybe<Scalars['Boolean']>;
  wms_pickface_putaway: Scalars['Boolean'];
  wms_std_pallet_quantity: Maybe<Scalars['Int']>;
  has_warranty: Scalars['Boolean'];
  product: Maybe<GqlProductV2Gql>;
  product_item_segment: Maybe<GqlProductItemSegmentV2Gql>;
  units_of_measure: Maybe<Array<Maybe<GqlProductItemUomv2Gql>>>;
  promotion_tags: Maybe<Array<Maybe<GqlPromotionTagGql>>>;
  base_price: Maybe<Scalars['Float']>;
  dynamic_price: Maybe<GqlDynamicPriceGql>;
  promotion_tag: Maybe<GqlPromotionTagGql>;
  regions: Maybe<Array<Maybe<GqlProductItemRegionV2Gql>>>;
  total_regions: Maybe<Scalars['Int']>;
  whitelisted: Maybe<Array<Maybe<GqlWhitelistedRoutesGql>>>;
  blacklisted: Maybe<Array<Maybe<GqlBlacklistedRoutesGql>>>;
  is_liquor: Maybe<Scalars['Boolean']>;
  currency_base_price: Maybe<GqlBasePriceGql>;
  current_stock_availability: Maybe<GqlStockAvailabilityGqLv2>;
  current_dcs_stock_availability: Maybe<GqlDcStockAvailabilityGql>;
  current_pricing_v2: Maybe<GqlPricingV2Gql>;
  ordered_stock: Maybe<GqlStockOrderedGql>;
  ordered_stock_depot: Maybe<GqlStockOrderedGql>;
  inventory: Maybe<GqlInventoryGql>;
};


export type GqlProductItemV2GqlCurrent_Stock_AvailabilityArgs = {
  distribution_center_id: Scalars['String'];
};


export type GqlProductItemV2GqlCurrent_Dcs_Stock_AvailabilityArgs = {
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  depot_id: Scalars['String'];
};


export type GqlProductItemV2GqlCurrent_Pricing_V2Args = {
  region_id: Scalars['String'];
};


export type GqlProductItemV2GqlOrdered_StockArgs = {
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  depot_id: Scalars['String'];
};


export type GqlProductItemV2GqlOrdered_Stock_DepotArgs = {
  date: Scalars['String'];
  depot_id: Scalars['String'];
};


export type GqlProductItemV2GqlInventoryArgs = {
  date: Maybe<Scalars['String']>;
  distribution_center_id: Scalars['String'];
};

export type GqlUserV2Gql = {
  __typename?: 'UserV2GQL';
  user_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Scalars['String'];
  client_timestamp: Scalars['DateTime'];
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  user_number: Scalars['String'];
  phone_number: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  primary_role_id: Scalars['String'];
  last_login: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  region_id: Maybe<Scalars['String']>;
  default_country_id: Maybe<Scalars['String']>;
  country_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  primary_role: Maybe<GqlRoleV2Gql>;
  roles: Maybe<Array<Maybe<GqlRoleV2Gql>>>;
  permissions: Maybe<Array<Maybe<GqlPermissionV2Gql>>>;
  permissions_blacklist: Maybe<Array<Maybe<GqlPermissionV2Gql>>>;
  user_no: Maybe<Scalars['Int']>;
  region: Maybe<GqlRegionV2Gql>;
};

export type GqlUomv2Gql = {
  __typename?: 'UOMV2GQL';
  uom_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  abbreviation: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  uom: Maybe<GqlProductItemUomv2Gql>;
};

/** Pagination Connection for DynamicPricingGQL type. */
export type GqlDynamicPricingGqlConnection = {
  __typename?: 'DynamicPricingGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDynamicPricingGqlEdge>>;
};

/** A Relay edge containing a `DynamicPricingGQL` and its cursor. */
export type GqlDynamicPricingGqlEdge = {
  __typename?: 'DynamicPricingGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDynamicPricingGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** DynamicPricingGQL type. */
export type GqlDynamicPricingGql = GqlNode & {
  __typename?: 'DynamicPricingGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  dynamic_pricing_id: Scalars['String'];
  pricing_name: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  start_time: Maybe<Scalars['DateTime']>;
  end_time: Maybe<Scalars['DateTime']>;
  exclusive: Maybe<Scalars['Boolean']>;
  discount_type: Maybe<GqlDiscountTypeEnum>;
  value: Maybe<Scalars['Float']>;
  formula: Scalars['JSONString'];
  markdown_display: Maybe<GqlDiscountValueTypeEnum>;
  /** The ID of the object. */
  id: Scalars['ID'];
  user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlDiscountTypeEnum {
  Ratio = 'RATIO',
  Value = 'VALUE',
  FixedPrice = 'FIXED_PRICE',
  PriceMarkdown = 'PRICE_MARKDOWN'
}

/** PriceComparisonGQL type. */
export type GqlPriceComparisonGql = GqlNode & {
  __typename?: 'PriceComparisonGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  price_comparison_id: Scalars['String'];
  product_item_id: Scalars['String'];
  region: Scalars['String'];
  region_id: Scalars['String'];
  competitor_name: Scalars['String'];
  competitor_price: Scalars['Float'];
  pricing_date: Scalars['String'];
  best_price: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlWorkOrderGqlConnection = {
  __typename?: 'WorkOrderGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWorkOrderGqlEdge>>;
};

/** A Relay edge containing a `WorkOrderGQL` and its cursor. */
export type GqlWorkOrderGqlEdge = {
  __typename?: 'WorkOrderGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWorkOrderGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWorkOrderGql = {
  __typename?: 'WorkOrderGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  work_order_id: Scalars['String'];
  route_id: Scalars['String'];
  shop_id: Scalars['String'];
  role_id: Scalars['String'];
  user_id: Maybe<Scalars['String']>;
  sort_order: Maybe<Scalars['Int']>;
  date: Scalars['String'];
  cluster_id: Maybe<Scalars['String']>;
  shop: Maybe<GqlShopV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
  work_order_items: Maybe<Array<Maybe<GqlWorkOrderItemGql>>>;
};

export type GqlShopV2Gql = {
  __typename?: 'ShopV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  shop_id: Scalars['String'];
  shop_number: Scalars['String'];
  shop_name: Scalars['String'];
  shop_type_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  region_id: Maybe<Scalars['String']>;
  customer_id: Scalars['String'];
  kra_pin: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  physical_address: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  version: Maybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  approved_by: Maybe<Scalars['String']>;
  approved_date: Maybe<Scalars['DateTime']>;
  depot_distance: Maybe<Scalars['Float']>;
  cluster_id: Maybe<Scalars['String']>;
  shop_type: Maybe<GqlShopTypeV2Gql>;
  customer: Maybe<GqlCustomerV2Gql>;
  region: Maybe<GqlRegionV2Gql>;
  country: Maybe<GqlCountryGql>;
  contacts: Maybe<Array<Maybe<GqlShopContactV2Gql>>>;
  customer_types: Maybe<Array<Maybe<GqlCustomerTypeV2Gql>>>;
  route: Maybe<GqlRouteV2Gql>;
  distribution_centers: Maybe<Array<Maybe<GqlDepotDistributionCenterGql>>>;
  work_orders: Maybe<Array<Maybe<GqlWorkOrderGql>>>;
  order_returns: Maybe<Array<Maybe<GqlOrderReturnGql>>>;
  delivery_returns: Maybe<Array<Maybe<GqlDeliveryReturnGql>>>;
  status: Maybe<Array<Maybe<Scalars['String']>>>;
  signed_image_url: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  delivery_fee: Maybe<Scalars['Float']>;
  updated_by_user: Maybe<GqlUserV2Gql>;
};

export type GqlShopTypeV2Gql = {
  __typename?: 'ShopTypeV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  shop_type_id: Scalars['String'];
  name: Scalars['String'];
  parent_id: Maybe<Scalars['String']>;
  parent: Maybe<GqlShopTypeV2Gql>;
  children: Maybe<Array<Maybe<GqlShopTypeV2Gql>>>;
  shops: Maybe<Array<Maybe<GqlShopV2Gql>>>;
};

export type GqlCustomerV2Gql = {
  __typename?: 'CustomerV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  customer_id: Scalars['String'];
  customer_name: Scalars['String'];
  phone_number: Scalars['String'];
  approved: Scalars['Boolean'];
  approved_by: Maybe<Scalars['String']>;
  approved_date: Maybe<Scalars['DateTime']>;
  shops: Maybe<Array<Maybe<GqlShopV2Gql>>>;
  vendor_kyc: Maybe<GqlVendorKycgql>;
  account: Maybe<GqlMcommerceAccountGql>;
};

export type GqlVendorKycgql = {
  __typename?: 'VendorKYCGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  vendor_kyc_id: Scalars['String'];
  legal_name: Scalars['String'];
  customer_id: Maybe<Scalars['String']>;
  legal_document: GqlLegalDocumentEnum;
  phone_number: Scalars['String'];
  legal_document_number: Scalars['String'];
  legal_document_front_image: Maybe<Scalars['String']>;
  legal_document_back_image: Maybe<Scalars['String']>;
  consent_form_image: Maybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  approved_by: Maybe<Scalars['String']>;
  date_approved: Maybe<Scalars['DateTime']>;
  monthly_income: Maybe<Scalars['Float']>;
  monthly_expenditure: Maybe<Scalars['Float']>;
  id_verified: Scalars['Boolean'];
  country_id: Maybe<Scalars['String']>;
  customer: Maybe<GqlCustomerV2Gql>;
  finance_plans: Maybe<Array<Maybe<GqlVendorFinancePlanGql>>>;
  signed_consent_form_url: Maybe<Scalars['String']>;
  signed_legal_document_front_image_url: Maybe<Scalars['String']>;
  signed_legal_document_back_image_url: Maybe<Scalars['String']>;
};

/** Legal Document Enum */
export enum GqlLegalDocumentEnum {
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export type GqlVendorFinancePlanGql = {
  __typename?: 'VendorFinancePlanGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  plan_id: Scalars['String'];
  name: Scalars['String'];
  required_fields: Array<Maybe<Scalars['String']>>;
};

export type GqlMcommerceAccountGql = {
  __typename?: 'McommerceAccountGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  account_id: Scalars['String'];
  shop_id: Maybe<Scalars['String']>;
  customer_id: Maybe<Scalars['String']>;
  user_name: Maybe<Scalars['String']>;
  change_password: Scalars['Boolean'];
  terms_date: Maybe<Scalars['DateTime']>;
  customer: Maybe<GqlCustomerV2Gql>;
};

export type GqlRegionV2Gql = {
  __typename?: 'RegionV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  region_id: Maybe<Scalars['String']>;
  region_name: Maybe<Scalars['String']>;
  regional_manager: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  country: Maybe<GqlCountryGql>;
  areas: Maybe<Array<Maybe<GqlAreaV2Gql>>>;
};

export type GqlCountryGql = {
  __typename?: 'CountryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  country_id: Scalars['String'];
  iso_alpha2_code: GqlIsoAlpha2Enum;
  iso_alpha2_name: Scalars['String'];
  default_currency: GqlCurrencyEnum;
  country_calling_code: Scalars['String'];
  company_legal_entity: Scalars['String'];
  default_language_code: Scalars['String'];
  timezone_utc_offset: Scalars['Int'];
  regions: Maybe<Array<Maybe<GqlRegionV2Gql>>>;
};

/** ISO Alpha2 Code Enum */
export enum GqlIsoAlpha2Enum {
  Ke = 'KE',
  Tz = 'TZ',
  Ug = 'UG'
}

/** Area GQL. */
export type GqlAreaV2Gql = {
  __typename?: 'AreaV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  area_id: Scalars['String'];
  region_id: Scalars['String'];
  area_name: Maybe<Scalars['String']>;
  area_manager: Maybe<Scalars['String']>;
  region: Maybe<GqlRegionV2Gql>;
  depots: Maybe<Array<Maybe<GqlDepotV2Gql>>>;
};

/** Depot Distribution Center GQL. */
export type GqlDepotDistributionCenterGql = {
  __typename?: 'DepotDistributionCenterGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  depot_distribution_center_id: Scalars['String'];
  depot_id: Scalars['String'];
  distribution_center_id: Scalars['String'];
  distribution_center_type: GqlDistributionCenterType;
  depot: Maybe<GqlDepotV2Gql>;
};

/** An enumeration. */
export enum GqlDistributionCenterType {
  Warehouse = 'WAREHOUSE',
  CrossDock = 'CROSS_DOCK'
}

export type GqlRouteV2Gql = {
  __typename?: 'RouteV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  route_id: Maybe<Scalars['String']>;
  depot_id: Scalars['String'];
  route_name: Maybe<Scalars['String']>;
  route_type: Maybe<Scalars['String']>;
  auto_assign_shop: Scalars['Boolean'];
  depot: Maybe<GqlDepotV2Gql>;
  payment_accounts: Maybe<Array<Maybe<GqlRoutePaymentAccountV2Gql>>>;
};

export type GqlRoutePaymentAccountV2Gql = {
  __typename?: 'RoutePaymentAccountV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  route_payment_account_id: Scalars['String'];
  route_id: Scalars['String'];
  payment_account_id: Scalars['String'];
  inbound_payment_config_id: Maybe<Scalars['String']>;
  route: Maybe<GqlRouteV2Gql>;
  payment_account: Maybe<GqlPaymentAccountV2Gql>;
};

export type GqlPaymentAccountV2Gql = {
  __typename?: 'PaymentAccountV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_account_id: Scalars['String'];
  account_number: Scalars['String'];
  account_type: Maybe<GqlPaymentAccountTypeEnum>;
  account_details: Maybe<Scalars['String']>;
  account_name: Maybe<Scalars['String']>;
};

/** Payment Account Type */
export enum GqlPaymentAccountTypeEnum {
  Mpesa = 'MPESA',
  Bank = 'BANK'
}

export type GqlDepotDcProductItemRestrictionGql = {
  __typename?: 'DepotDCProductItemRestrictionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  depot_dc_product_item_restriction_id: Scalars['String'];
  product_item_id: Scalars['String'];
  depot_id: Scalars['String'];
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  depot: Maybe<GqlDepotV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  distribution_centers: Array<Maybe<GqlDistributionCenterGql>>;
};

export type GqlDistributionCenterGql = {
  __typename?: 'DistributionCenterGQL';
  distribution_center_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  distribution_center_name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  group_email: Scalars['String'];
  distribution_center_type: GqlDistributionCenterType;
  warehouses: Maybe<Array<Maybe<GqlWarehouseGql>>>;
  intakes: Maybe<Array<Maybe<GqlStockIntakeGql>>>;
  stock_counts: Maybe<Array<Maybe<GqlStockTakeGql>>>;
  processing_losses: Maybe<Array<Maybe<GqlProcessingLossGql>>>;
  appointments: Maybe<Array<Maybe<GqlAppointmentGql>>>;
  stock_availability: Maybe<GqlStockAvailabilityGqLv2Connection>;
};


export type GqlDistributionCenterGqlStock_AvailabilityArgs = {
  before: Maybe<Scalars['String']>;
  after: Maybe<Scalars['String']>;
  first: Maybe<Scalars['Int']>;
  last: Maybe<Scalars['Int']>;
};

export type GqlDepotRoutePlanSummaryGql = {
  __typename?: 'DepotRoutePlanSummaryGQL';
  depot_id: Maybe<Scalars['String']>;
  delivery_date: Maybe<Scalars['String']>;
  planned_orders: Maybe<Scalars['Int']>;
  vehicles: Maybe<Scalars['Int']>;
};

export type GqlShopContactV2Gql = {
  __typename?: 'ShopContactV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  contact_id: Scalars['String'];
  shop_id: Scalars['String'];
  contact_name: Scalars['String'];
  phone_number: Scalars['String'];
  email_address: Maybe<Scalars['String']>;
};

export type GqlCustomerTypeV2Gql = {
  __typename?: 'CustomerTypeV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  customer_type_id: Scalars['String'];
  name: Scalars['String'];
};

/** OrderReturn GQL. */
export type GqlOrderReturnGql = {
  __typename?: 'OrderReturnGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  return_date: Scalars['String'];
  return_number: Scalars['String'];
  user_id: Scalars['String'];
  route_plan_id: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  order_id: Scalars['String'];
  return_id: Scalars['String'];
  shop_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  return_items: Maybe<Array<Maybe<GqlOrderReturnItemGql>>>;
  order: Maybe<GqlOrderV2Gql>;
  shop: Maybe<GqlShopV2Gql>;
};

/** Order item return GQL. */
export type GqlOrderReturnItemGql = {
  __typename?: 'OrderReturnItemGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  return_item_id: Scalars['String'];
  unit_of_measure_id: Maybe<Scalars['String']>;
  return_date: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  comment: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  unit_price: Scalars['Float'];
  image: Maybe<Scalars['String']>;
  return_id: Scalars['String'];
  product_item_id: Scalars['String'];
  reason_id: Maybe<Scalars['String']>;
  reason: Maybe<GqlReturnReasonGql>;
  return: Maybe<GqlOrderReturnGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  signed_image_url: Maybe<Scalars['String']>;
};

/** Return Reason GQL */
export type GqlReturnReasonGql = {
  __typename?: 'ReturnReasonGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  reason_id: Scalars['String'];
  parent_id: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  return_type: GqlReturnTypeEnum;
  parent: Maybe<GqlReturnReasonGql>;
  children: Maybe<Array<Maybe<GqlReturnReasonGql>>>;
};

/** Return type Enum */
export enum GqlReturnTypeEnum {
  DeliveryReturn = 'DELIVERY_RETURN',
  OrderReturn = 'ORDER_RETURN'
}

/** Order GQL. */
export type GqlOrderV2Gql = {
  __typename?: 'OrderV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  order_id: Scalars['String'];
  shop_id: Scalars['String'];
  route_id: Scalars['String'];
  region_id: Maybe<Scalars['String']>;
  route_plan_id: Maybe<Scalars['String']>;
  trader_entity_id: Maybe<Scalars['String']>;
  order_date: Scalars['String'];
  delivery_date: Scalars['String'];
  order_number: Scalars['String'];
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  comment: Maybe<Scalars['String']>;
  version: Maybe<Scalars['String']>;
  priority: Maybe<Scalars['Boolean']>;
  cancellation_reason: Maybe<Scalars['String']>;
  trader_entity_user_id: Scalars['String'];
  trader_entity: GqlTraderEntityEnum;
  fulfilled: Scalars['Boolean'];
  dispatched: Scalars['Boolean'];
  non_delivery_reason: Maybe<Scalars['String']>;
  routing_order: Maybe<Scalars['Int']>;
  delivery_fee: Scalars['Float'];
  country_id: Maybe<Scalars['String']>;
  depot_id: Maybe<Scalars['String']>;
  shop: Maybe<GqlShopV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
  order_assignment: Maybe<GqlOrderAssignmentV2Gql>;
  order_items: Maybe<Array<Maybe<GqlOrderItemV2Gql>>>;
  order_returns: Maybe<Array<Maybe<GqlOrderReturnGql>>>;
  served_by: Maybe<GqlUserV2Gql>;
  updated_by_user: Maybe<GqlUserV2Gql>;
  route_plan: Maybe<GqlRoutePlanGql>;
  total_amount: Maybe<Scalars['Float']>;
};

/** Trader Entity. */
export enum GqlTraderEntityEnum {
  Mcommerce = 'MCOMMERCE',
  Dms = 'DMS',
  Courier = 'COURIER',
  Pwa = 'PWA',
  Sokocall = 'SOKOCALL',
  Sokoyetu = 'SOKOYETU'
}

/** Order Assignment GQL. */
export type GqlOrderAssignmentV2Gql = {
  __typename?: 'OrderAssignmentV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  assignment_id: Scalars['String'];
  order_id: Scalars['String'];
  trader_entity_id: Scalars['String'];
  trader_entity_user_id: Scalars['String'];
  sale_date: Scalars['String'];
  fulfilled: Scalars['Boolean'];
  order: Maybe<GqlOrderV2Gql>;
};

/** Order item GQL. */
export type GqlOrderItemV2Gql = {
  __typename?: 'OrderItemV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  order_item_id: Scalars['String'];
  order_id: Scalars['String'];
  product_item_id: Scalars['String'];
  fulfilled: Scalars['Boolean'];
  unit_of_measure_id: Maybe<Scalars['String']>;
  order_date: Scalars['String'];
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  unit_price: Scalars['Float'];
  comment: Maybe<Scalars['String']>;
  packed_weight: Maybe<Scalars['Float']>;
  packed_volume: Maybe<Scalars['Float']>;
  order: Maybe<GqlOrderV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlRoutePlanGql = {
  __typename?: 'RoutePlanGQL';
  route_plan_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  delivery_date: Scalars['String'];
  vehicle_id: Scalars['String'];
  depot_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  distance: Scalars['Float'];
  orders: Array<Maybe<Scalars['String']>>;
  weight: Maybe<Scalars['Float']>;
  volume: Maybe<Scalars['Float']>;
  num_shops: Maybe<Scalars['Int']>;
  starting_odometer: Maybe<Scalars['Float']>;
  closing_odometer: Maybe<Scalars['Float']>;
  region_id: Maybe<Scalars['String']>;
  trip_id: Maybe<Scalars['String']>;
  multiple_trips: Scalars['Boolean'];
  vehicle_trip: Scalars['Int'];
  vehicle: Maybe<GqlVehicleGql>;
  trip: Maybe<GqlTripGql>;
  fulfillment_teams: Maybe<Array<Maybe<GqlFulfillmentTeamGql>>>;
  planned_orders: Maybe<Scalars['Int']>;
  actual_distance: Maybe<Scalars['Float']>;
  depot: Maybe<GqlDepotV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
  region: Maybe<GqlRegionV2Gql>;
  order_summary: Maybe<GqlRoutePlanOrderSummaryGql>;
};

/** DeliveryReturn GQL. */
export type GqlDeliveryReturnGql = {
  __typename?: 'DeliveryReturnGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  return_date: Scalars['String'];
  return_number: Scalars['String'];
  user_id: Scalars['String'];
  route_plan_id: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  delivery_id: Scalars['String'];
  claim_processed: Scalars['Boolean'];
  claim_processed_at: Maybe<Scalars['DateTime']>;
  claim_processed_by: Maybe<Scalars['String']>;
  return_id: Scalars['String'];
  shop_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  return_items: Maybe<Array<Maybe<GqlDeliveryReturnItemGql>>>;
  delivery: Maybe<GqlDeliveryV2Gql>;
  shop: Maybe<GqlShopV2Gql>;
  refund_status: Maybe<Scalars['String']>;
};

/** Delivery item return GQL. */
export type GqlDeliveryReturnItemGql = {
  __typename?: 'DeliveryReturnItemGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  return_item_id: Scalars['String'];
  unit_of_measure_id: Maybe<Scalars['String']>;
  return_date: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  comment: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  unit_price: Scalars['Float'];
  image: Maybe<Scalars['String']>;
  return_id: Scalars['String'];
  approved: Maybe<Scalars['Boolean']>;
  approved_at: Maybe<Scalars['DateTime']>;
  approved_by: Maybe<Scalars['String']>;
  approved_amount: Maybe<Scalars['Float']>;
  approved_quantity: Maybe<Scalars['Float']>;
  rejection_reason_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  reason_id: Maybe<Scalars['String']>;
  rejection_reason: Maybe<GqlReturnItemRejectionReasonGql>;
  reason: Maybe<GqlReturnReasonGql>;
  delivery_return: Maybe<GqlDeliveryReturnGql>;
  signed_image_url: Maybe<Scalars['String']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  approved_by_user: Maybe<GqlUserV2Gql>;
};

/** Return Item Rejection Reason GQL */
export type GqlReturnItemRejectionReasonGql = {
  __typename?: 'ReturnItemRejectionReasonGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  rejection_reason_id: Scalars['String'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
};

export type GqlDeliveryV2Gql = {
  __typename?: 'DeliveryV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  delivery_id: Scalars['String'];
  order_id: Maybe<Scalars['String']>;
  depot_id: Maybe<Scalars['String']>;
  region_id: Maybe<Scalars['String']>;
  shop_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  trader_entity_id: Maybe<Scalars['String']>;
  delivery_date: Scalars['String'];
  route_plan_id: Maybe<Scalars['String']>;
  delivery_number: Scalars['String'];
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  comment: Maybe<Scalars['String']>;
  version: Maybe<Scalars['String']>;
  priority: Maybe<Scalars['Boolean']>;
  cancellation_reason: Maybe<Scalars['String']>;
  trader_entity_user_id: Scalars['String'];
  trader_entity: GqlTraderEntityEnum;
  delivery_fee: Scalars['Float'];
  country_id: Maybe<Scalars['String']>;
  shop: Maybe<GqlShopV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
  payments: Maybe<Array<Maybe<GqlPaymentV2Gql>>>;
  delivery_status: Maybe<Array<Maybe<GqlDeliveryStatusV2Gql>>>;
  order: Maybe<GqlOrderV2Gql>;
  depot: Maybe<GqlDepotV2Gql>;
  delivery_items: Maybe<Array<Maybe<GqlDeliveryItemV2Gql>>>;
  delivery_returns: Maybe<Array<Maybe<GqlDeliveryReturnGql>>>;
  total_amount: Maybe<Scalars['Float']>;
  served_by: Maybe<GqlUserV2Gql>;
};

export type GqlPaymentV2Gql = {
  __typename?: 'PaymentV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_id: Scalars['String'];
  delivery_id: Scalars['String'];
  payment_mode: GqlPaymentMode;
  reference_number: Maybe<Scalars['String']>;
  payment_number: Scalars['String'];
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  delivery: Maybe<GqlDeliveryV2Gql>;
};

/** Payment Mode Enum */
export enum GqlPaymentMode {
  Cash = 'CASH',
  MobileMoney = 'MOBILE_MONEY',
  Bank = 'BANK',
  Loan = 'LOAN',
  MpesaTill = 'MPESA_TILL',
  MpesaStk = 'MPESA_STK',
  MpesaTillAuto = 'MPESA_TILL_AUTO',
  Ewallet = 'EWALLET'
}

/** Delivery Status GQL. */
export type GqlDeliveryStatusV2Gql = {
  __typename?: 'DeliveryStatusV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  delivery_status_id: Scalars['String'];
  delivery_id: Scalars['String'];
  delivery_status: GqlDeliveryStatusEnum;
  delivery: Maybe<GqlDeliveryV2Gql>;
};

/** Delivery Status Enum */
export enum GqlDeliveryStatusEnum {
  Delivered = 'DELIVERED',
  Confirmed = 'CONFIRMED',
  PartiallyPaid = 'PARTIALLY_PAID',
  FullyPaid = 'FULLY_PAID'
}

/** Delivery item GQL. */
export type GqlDeliveryItemV2Gql = {
  __typename?: 'DeliveryItemV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  delivery_item_id: Scalars['String'];
  delivery_id: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Maybe<Scalars['String']>;
  delivery_date: Scalars['String'];
  amount: Scalars['Float'];
  currency: GqlCurrencyEnum;
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  packed_weight: Maybe<Scalars['Float']>;
  packed_volume: Maybe<Scalars['Float']>;
  unit_price: Scalars['Float'];
  comment: Maybe<Scalars['String']>;
  delivery: Maybe<GqlDeliveryV2Gql>;
  warranties: Maybe<Array<Maybe<GqlDeliveryItemWarrantyGql>>>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

/** Delivery item warranty GQL. */
export type GqlDeliveryItemWarrantyGql = {
  __typename?: 'DeliveryItemWarrantyGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warranty_id: Scalars['String'];
  delivery_item_id: Scalars['String'];
  serial_number: Scalars['String'];
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  delivery_item: Maybe<GqlDeliveryItemV2Gql>;
};

export type GqlWorkOrderItemGql = {
  __typename?: 'WorkOrderItemGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  work_order_item_id: Scalars['String'];
  work_order_id: Maybe<Scalars['String']>;
  reason_id: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  reference_entity_id: Maybe<Scalars['String']>;
  reference_entity: Maybe<GqlWorkOrderEntityEnum>;
  reason: Maybe<GqlWorkOrderReasonGql>;
  work_order: Maybe<GqlWorkOrderGql>;
};

/** Work Order Entity Enum */
export enum GqlWorkOrderEntityEnum {
  Order = 'ORDER',
  Delivery = 'DELIVERY',
  Payment = 'PAYMENT',
  Return = 'RETURN'
}

export type GqlWorkOrderReasonGql = {
  __typename?: 'WorkOrderReasonGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  reason_id: Scalars['String'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
};

export type GqlWorkOrderDefinitionGql = {
  __typename?: 'WorkOrderDefinitionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  definition_id: Scalars['String'];
  role_id: Scalars['String'];
  query: Scalars['String'];
  start_date: Maybe<Scalars['DateTime']>;
  end_date: Maybe<Scalars['DateTime']>;
  reason_id: Maybe<Scalars['String']>;
};

export type GqlWorkOrderItemGqlConnection = {
  __typename?: 'WorkOrderItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWorkOrderItemGqlEdge>>;
};

/** A Relay edge containing a `WorkOrderItemGQL` and its cursor. */
export type GqlWorkOrderItemGqlEdge = {
  __typename?: 'WorkOrderItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWorkOrderItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSalesAgentClusterGqlConnection = {
  __typename?: 'SalesAgentClusterGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSalesAgentClusterGqlEdge>>;
};

/** A Relay edge containing a `SalesAgentClusterGQL` and its cursor. */
export type GqlSalesAgentClusterGqlEdge = {
  __typename?: 'SalesAgentClusterGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSalesAgentClusterGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSalesAgentClusterGql = {
  __typename?: 'SalesAgentClusterGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  cluster_id: Scalars['String'];
  cluster_code: Scalars['String'];
  depot_id: Scalars['String'];
  depot_name: Maybe<Scalars['String']>;
  depot_code: Maybe<Scalars['Int']>;
  cluster_number: Maybe<Scalars['Int']>;
  depot: Maybe<GqlDepotV2Gql>;
};

export type GqlClusterAssignmentGqlConnection = {
  __typename?: 'ClusterAssignmentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlClusterAssignmentGqlEdge>>;
};

/** A Relay edge containing a `ClusterAssignmentGQL` and its cursor. */
export type GqlClusterAssignmentGqlEdge = {
  __typename?: 'ClusterAssignmentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlClusterAssignmentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlClusterAssignmentGql = {
  __typename?: 'ClusterAssignmentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  assignment_id: Scalars['String'];
  cluster_id: Scalars['String'];
  agent_id: Scalars['String'];
  date: Scalars['String'];
  start_time: Maybe<Scalars['DateTime']>;
  end_time: Maybe<Scalars['DateTime']>;
  cluster: Maybe<GqlSalesAgentClusterGql>;
  agent: Maybe<GqlUserV2Gql>;
};

export type GqlClusterAgentEarningGqlConnection = {
  __typename?: 'ClusterAgentEarningGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlClusterAgentEarningGqlEdge>>;
};

/** A Relay edge containing a `ClusterAgentEarningGQL` and its cursor. */
export type GqlClusterAgentEarningGqlEdge = {
  __typename?: 'ClusterAgentEarningGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlClusterAgentEarningGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlClusterAgentEarningGql = {
  __typename?: 'ClusterAgentEarningGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  agent_earning_id: Scalars['String'];
  cluster_id: Scalars['String'];
  cluster_code: Scalars['String'];
  depot_id: Maybe<Scalars['String']>;
  delivery_date: Scalars['String'];
  shop_id: Scalars['String'];
  product_item_segment: Scalars['String'];
  ordered_weight: Maybe<Scalars['Float']>;
  delivered_weight: Maybe<Scalars['Float']>;
  potential_pay: Maybe<Scalars['Float']>;
  unlocked_pay: Maybe<Scalars['Float']>;
  agent_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  product_name: Scalars['String'];
  product_item_name: Scalars['String'];
};

export type GqlClusterEarningSummaryGql = {
  __typename?: 'ClusterEarningSummaryGQL';
  agent_id: Maybe<Scalars['String']>;
  total_ordered_weight: Maybe<Scalars['Float']>;
  total_delivered_weight: Maybe<Scalars['Float']>;
  total_potential_pay: Maybe<Scalars['Float']>;
  total_unlocked_pay: Maybe<Scalars['Float']>;
  delivery_date: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['String']>;
  end_date: Maybe<Scalars['String']>;
};

export type GqlAgentDailyOrderSummaryGqlConnection = {
  __typename?: 'AgentDailyOrderSummaryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAgentDailyOrderSummaryGqlEdge>>;
};

/** A Relay edge containing a `AgentDailyOrderSummaryGQL` and its cursor. */
export type GqlAgentDailyOrderSummaryGqlEdge = {
  __typename?: 'AgentDailyOrderSummaryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAgentDailyOrderSummaryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAgentDailyOrderSummaryGql = {
  __typename?: 'AgentDailyOrderSummaryGQL';
  agent_id: Maybe<Scalars['String']>;
  delivery_date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  product_name: Maybe<Scalars['String']>;
  product_item_name: Maybe<Scalars['String']>;
  product_item_segment: Maybe<Scalars['String']>;
  total_ordered_weight: Maybe<Scalars['Float']>;
  total_potential_pay: Maybe<Scalars['Float']>;
};

export type GqlSegmentEarningsSummaryGql = {
  __typename?: 'SegmentEarningsSummaryGQL';
  agent_id: Maybe<Scalars['String']>;
  delivery_date: Maybe<Scalars['Date']>;
  segment_earnings: Maybe<Array<Maybe<GqlSegmentEarningsGql>>>;
};

export type GqlSegmentEarningsGql = {
  __typename?: 'SegmentEarningsGQL';
  delivery_date: Maybe<Scalars['String']>;
  product_item_segment: Maybe<Scalars['String']>;
  total_ordered_weight: Maybe<Scalars['Float']>;
  total_potential_pay: Maybe<Scalars['Float']>;
  total_delivered_weight: Maybe<Scalars['Float']>;
  total_unlocked_pay: Maybe<Scalars['Float']>;
};

export type GqlAgentEarningsGql = {
  __typename?: 'AgentEarningsGQL';
  agent_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  total_amount: Maybe<Scalars['Float']>;
  earnings_attributes: Maybe<Array<Maybe<GqlEarningsAttributesGql>>>;
};

export type GqlEarningsAttributesGql = {
  __typename?: 'EarningsAttributesGQL';
  attribute_id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  total_value: Maybe<Scalars['Float']>;
  unit: Maybe<Scalars['String']>;
};

export type GqlAgentEarningsSummaryGql = {
  __typename?: 'AgentEarningsSummaryGQL';
  agent_id: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['String']>;
  end_date: Maybe<Scalars['String']>;
  total_amount: Maybe<Scalars['Float']>;
  earnings_attributes: Maybe<Array<Maybe<GqlEarningsAttributesGql>>>;
};

/** Node and relay Connection. */
export type GqlDeliveryReturnGqlConnection = {
  __typename?: 'DeliveryReturnGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryReturnGqlEdge>>;
};

/** A Relay edge containing a `DeliveryReturnGQL` and its cursor. */
export type GqlDeliveryReturnGqlEdge = {
  __typename?: 'DeliveryReturnGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryReturnGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlDeliveryReturnItemGqlConnection = {
  __typename?: 'DeliveryReturnItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryReturnItemGqlEdge>>;
};

/** A Relay edge containing a `DeliveryReturnItemGQL` and its cursor. */
export type GqlDeliveryReturnItemGqlEdge = {
  __typename?: 'DeliveryReturnItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryReturnItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlOrderReturnGqlConnection = {
  __typename?: 'OrderReturnGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderReturnGqlEdge>>;
};

/** A Relay edge containing a `OrderReturnGQL` and its cursor. */
export type GqlOrderReturnGqlEdge = {
  __typename?: 'OrderReturnGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderReturnGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlOrderReturnItemGqlConnection = {
  __typename?: 'OrderReturnItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderReturnItemGqlEdge>>;
};

/** A Relay edge containing a `OrderReturnItemGQL` and its cursor. */
export type GqlOrderReturnItemGqlEdge = {
  __typename?: 'OrderReturnItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderReturnItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockNotificationGqlConnection = {
  __typename?: 'StockNotificationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockNotificationGqlEdge>>;
};

/** A Relay edge containing a `StockNotificationGQL` and its cursor. */
export type GqlStockNotificationGqlEdge = {
  __typename?: 'StockNotificationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockNotificationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockNotificationGql = {
  __typename?: 'StockNotificationGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_notification_id: Scalars['String'];
  shop_id: Scalars['String'];
  product_item_id: Scalars['String'];
  distribution_center_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  region_id: Maybe<Scalars['String']>;
  phone_number: Scalars['String'];
  device_token: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
};

export type GqlOrderingWindowGqlConnection = {
  __typename?: 'OrderingWindowGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderingWindowGqlEdge>>;
};

/** A Relay edge containing a `OrderingWindowGQL` and its cursor. */
export type GqlOrderingWindowGqlEdge = {
  __typename?: 'OrderingWindowGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderingWindowGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Ordering Window GQL */
export type GqlOrderingWindowGql = {
  __typename?: 'OrderingWindowGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  ordering_window_id: Scalars['String'];
  channel: GqlChannelEnum;
  region_id: Scalars['String'];
  depot_id: Maybe<Scalars['String']>;
  region: Maybe<GqlRegionV2Gql>;
  ordering_window_items: Maybe<Array<Maybe<GqlOrderingWindowItemGql>>>;
  depot: Maybe<GqlDepotV2Gql>;
};

/** Mcommerce Channel Enum */
export enum GqlChannelEnum {
  Sokocall = 'SOKOCALL',
  Sokoyetu = 'SOKOYETU',
  Mcommerce = 'MCOMMERCE',
  Dms = 'DMS',
  Courier = 'COURIER',
  Pwa = 'PWA'
}

/** Ordering Window Item GQL */
export type GqlOrderingWindowItemGql = {
  __typename?: 'OrderingWindowItemGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  ordering_window_item_id: Scalars['String'];
  ordering_window_id: Scalars['String'];
  day: Scalars['Int'];
  opening_time: Scalars['String'];
  closing_time: Scalars['String'];
  ordering_window: Maybe<GqlOrderingWindowGql>;
};

export type GqlOrderingWindowItemGqlConnection = {
  __typename?: 'OrderingWindowItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderingWindowItemGqlEdge>>;
};

/** A Relay edge containing a `OrderingWindowItemGQL` and its cursor. */
export type GqlOrderingWindowItemGqlEdge = {
  __typename?: 'OrderingWindowItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderingWindowItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlMcommerceFaqSectionGql = {
  __typename?: 'McommerceFAQSectionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  faq_section_id: Scalars['String'];
  name: Scalars['String'];
  icon_url: Maybe<Scalars['String']>;
  faqs: Maybe<Array<Maybe<GqlMcommerceFaqgql>>>;
};

export type GqlMcommerceFaqgql = {
  __typename?: 'McommerceFAQGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  faq_id: Scalars['String'];
  question: Scalars['String'];
  answer: Scalars['String'];
  faq_section_id: Scalars['String'];
  image_urls: Maybe<Array<Maybe<Scalars['String']>>>;
  faq_section: Maybe<GqlMcommerceFaqSectionGql>;
};

export type GqlMcommerceFaqgqlConnection = {
  __typename?: 'McommerceFAQGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlMcommerceFaqgqlEdge>>;
};

/** A Relay edge containing a `McommerceFAQGQL` and its cursor. */
export type GqlMcommerceFaqgqlEdge = {
  __typename?: 'McommerceFAQGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlMcommerceFaqgql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for PaymentAccountV2GQL */
export type GqlPaymentAccountV2GqlConnection = {
  __typename?: 'PaymentAccountV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentAccountV2GqlEdge>>;
};

/** A Relay edge containing a `PaymentAccountV2GQL` and its cursor. */
export type GqlPaymentAccountV2GqlEdge = {
  __typename?: 'PaymentAccountV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentAccountV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for RoutePaymentAccountV2GQL */
export type GqlRoutePaymentAccountV2GqlConnection = {
  __typename?: 'RoutePaymentAccountV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRoutePaymentAccountV2GqlEdge>>;
};

/** A Relay edge containing a `RoutePaymentAccountV2GQL` and its cursor. */
export type GqlRoutePaymentAccountV2GqlEdge = {
  __typename?: 'RoutePaymentAccountV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRoutePaymentAccountV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for PaymentV2GQL */
export type GqlPaymentV2GqlConnection = {
  __typename?: 'PaymentV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentV2GqlEdge>>;
};

/** A Relay edge containing a `PaymentV2GQL` and its cursor. */
export type GqlPaymentV2GqlEdge = {
  __typename?: 'PaymentV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPaymentVisibilityGql = {
  __typename?: 'PaymentVisibilityGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_visibility_id: Scalars['String'];
  payment_method_id: Scalars['String'];
  visible: Scalars['Boolean'];
  region_id: Scalars['String'];
  channel: GqlChannelEnum;
  payment_method: Maybe<GqlPaymentMethodGql>;
};

export type GqlPaymentMethodGql = {
  __typename?: 'PaymentMethodGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  payment_method_id: Scalars['String'];
  payment_method_name: GqlPaymentMode;
  description: Scalars['String'];
  logo_url: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  payment_visibilities: Maybe<Array<Maybe<GqlPaymentVisibilityGql>>>;
};

export type GqlRouteTillAlertContactGqlConnection = {
  __typename?: 'RouteTillAlertContactGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRouteTillAlertContactGqlEdge>>;
};

/** A Relay edge containing a `RouteTillAlertContactGQL` and its cursor. */
export type GqlRouteTillAlertContactGqlEdge = {
  __typename?: 'RouteTillAlertContactGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRouteTillAlertContactGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlRouteTillAlertContactGql = {
  __typename?: 'RouteTillAlertContactGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  route_till_alert_contact_id: Scalars['String'];
  user_id: Scalars['String'];
  phone_number: Scalars['String'];
  route_id: Scalars['String'];
  route: Maybe<GqlRouteV2Gql>;
};

/** Node and relay Connection. */
export type GqlDeliveryV2GqlConnection = {
  __typename?: 'DeliveryV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryV2GqlEdge>>;
  served_by: Maybe<GqlUserV2Gql>;
};

/** A Relay edge containing a `DeliveryV2GQL` and its cursor. */
export type GqlDeliveryV2GqlEdge = {
  __typename?: 'DeliveryV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlDeliveryFeeScheduleGqlConnection = {
  __typename?: 'DeliveryFeeScheduleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryFeeScheduleGqlEdge>>;
};

/** A Relay edge containing a `DeliveryFeeScheduleGQL` and its cursor. */
export type GqlDeliveryFeeScheduleGqlEdge = {
  __typename?: 'DeliveryFeeScheduleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryFeeScheduleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** DeliveryFeeSchedule GQL. */
export type GqlDeliveryFeeScheduleGql = {
  __typename?: 'DeliveryFeeScheduleGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  schedule_id: Scalars['String'];
  route_id: Scalars['String'];
  lower_bound: Scalars['Float'];
  upper_bound: Scalars['Float'];
  fee: Scalars['Float'];
  route: Maybe<GqlRouteV2Gql>;
};

export type GqlRealizedRevenueV2Gql = {
  __typename?: 'RealizedRevenueV2GQL';
  realized_revenue: Maybe<Scalars['Float']>;
  date: Maybe<Scalars['String']>;
};

/** Node and relay Connection. */
export type GqlDeliveryItemV2GqlConnection = {
  __typename?: 'DeliveryItemV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryItemV2GqlEdge>>;
};

/** A Relay edge containing a `DeliveryItemV2GQL` and its cursor. */
export type GqlDeliveryItemV2GqlEdge = {
  __typename?: 'DeliveryItemV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryItemV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlShopDeliverySummaryV2Gql = {
  __typename?: 'ShopDeliverySummaryV2GQL';
  date: Maybe<Scalars['String']>;
  last_delivery_date: Maybe<Scalars['String']>;
  total_sales: Maybe<Scalars['Float']>;
  average_drop_size: Maybe<Scalars['Float']>;
  last_sale_amount: Maybe<Scalars['Float']>;
};

/** Node and relay Connection. */
export type GqlDeliveryProductSummaryV2GqlConnection = {
  __typename?: 'DeliveryProductSummaryV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryProductSummaryV2GqlEdge>>;
};

/** A Relay edge containing a `DeliveryProductSummaryV2GQL` and its cursor. */
export type GqlDeliveryProductSummaryV2GqlEdge = {
  __typename?: 'DeliveryProductSummaryV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryProductSummaryV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDeliveryProductSummaryV2Gql = {
  __typename?: 'DeliveryProductSummaryV2GQL';
  date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  unit_price: Maybe<Scalars['Float']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
};

/** Node and relay Connection. */
export type GqlDeliveryItemWarrantyGqlConnection = {
  __typename?: 'DeliveryItemWarrantyGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDeliveryItemWarrantyGqlEdge>>;
};

/** A Relay edge containing a `DeliveryItemWarrantyGQL` and its cursor. */
export type GqlDeliveryItemWarrantyGqlEdge = {
  __typename?: 'DeliveryItemWarrantyGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDeliveryItemWarrantyGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** TraderEntity GQL. */
export type GqlTraderEntityV2Gql = {
  __typename?: 'TraderEntityV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  trader_entity_id: Scalars['String'];
  trader_entity_name: Scalars['String'];
  description: Maybe<Scalars['String']>;
};

/** Node and relay Connection. */
export type GqlOrderV2GqlConnection = {
  __typename?: 'OrderV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderV2GqlEdge>>;
};

/** A Relay edge containing a `OrderV2GQL` and its cursor. */
export type GqlOrderV2GqlEdge = {
  __typename?: 'OrderV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlOrderItemV2GqlConnection = {
  __typename?: 'OrderItemV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderItemV2GqlEdge>>;
};

/** A Relay edge containing a `OrderItemV2GQL` and its cursor. */
export type GqlOrderItemV2GqlEdge = {
  __typename?: 'OrderItemV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderItemV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlOrderAgainGql = {
  __typename?: 'OrderAgainGQL';
  product_items: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Node and relay Connection. */
export type GqlOrderAssignmentV2GqlConnection = {
  __typename?: 'OrderAssignmentV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderAssignmentV2GqlEdge>>;
};

/** A Relay edge containing a `OrderAssignmentV2GQL` and its cursor. */
export type GqlOrderAssignmentV2GqlEdge = {
  __typename?: 'OrderAssignmentV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderAssignmentV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockOrderedGql = {
  __typename?: 'StockOrderedGQL';
  product_item_id: Scalars['String'];
  order_quantity: Maybe<Scalars['Float']>;
  order_weight: Maybe<Scalars['Float']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
  depot_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  distribution_center_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  sale_date: Scalars['String'];
  date: Maybe<Scalars['String']>;
};

export type GqlShopOrderSummaryV2Gql = {
  __typename?: 'ShopOrderSummaryV2GQL';
  date: Maybe<Scalars['String']>;
  last_order_date: Maybe<Scalars['String']>;
  total_orders: Maybe<Scalars['Float']>;
  average_order_value: Maybe<Scalars['Float']>;
  last_order_amount: Maybe<Scalars['Float']>;
};

/** Node and relay Connection. */
export type GqlOrderProductSummaryV2GqlConnection = {
  __typename?: 'OrderProductSummaryV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderProductSummaryV2GqlEdge>>;
};

/** A Relay edge containing a `OrderProductSummaryV2GQL` and its cursor. */
export type GqlOrderProductSummaryV2GqlEdge = {
  __typename?: 'OrderProductSummaryV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderProductSummaryV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlOrderProductSummaryV2Gql = {
  __typename?: 'OrderProductSummaryV2GQL';
  date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  unit_price: Maybe<Scalars['Float']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
};

export type GqlProjectedRevenueV2Gql = {
  __typename?: 'ProjectedRevenueV2GQL';
  date: Maybe<Scalars['String']>;
  projected_revenue: Maybe<Scalars['Float']>;
};

export type GqlRoutePlanOrderSummaryGql = {
  __typename?: 'RoutePlanOrderSummaryGQL';
  route_plan_id: Maybe<Scalars['String']>;
  fulfilled_orders: Maybe<Scalars['Int']>;
};

export type GqlOrderRestrictionGqlConnection = {
  __typename?: 'OrderRestrictionGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlOrderRestrictionGqlEdge>>;
};

/** A Relay edge containing a `OrderRestrictionGQL` and its cursor. */
export type GqlOrderRestrictionGqlEdge = {
  __typename?: 'OrderRestrictionGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlOrderRestrictionGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlOrderRestrictionGql = {
  __typename?: 'OrderRestrictionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  order_restriction_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  product_id: Maybe<Scalars['String']>;
  category_id: Maybe<Scalars['String']>;
  max_orders: Maybe<Scalars['Int']>;
  max_order_quantity: Maybe<Scalars['Int']>;
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
};

export type GqlDepotDcProductItemRestrictionGqlConnection = {
  __typename?: 'DepotDCProductItemRestrictionGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDepotDcProductItemRestrictionGqlEdge>>;
};

/** A Relay edge containing a `DepotDCProductItemRestrictionGQL` and its cursor. */
export type GqlDepotDcProductItemRestrictionGqlEdge = {
  __typename?: 'DepotDCProductItemRestrictionGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDepotDcProductItemRestrictionGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDistributionCenterOrderSummaryGql = {
  __typename?: 'DistributionCenterOrderSummaryGQL';
  product_item_id: Maybe<Scalars['String']>;
  sale_date: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Float']>;
  distribution_center_id: Maybe<Scalars['String']>;
};

/** Node and relay Connection. */
export type GqlRegionV2GqlConnection = {
  __typename?: 'RegionV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRegionV2GqlEdge>>;
};

/** A Relay edge containing a `RegionV2GQL` and its cursor. */
export type GqlRegionV2GqlEdge = {
  __typename?: 'RegionV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRegionV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlAreaV2GqlConnection = {
  __typename?: 'AreaV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAreaV2GqlEdge>>;
};

/** A Relay edge containing a `AreaV2GQL` and its cursor. */
export type GqlAreaV2GqlEdge = {
  __typename?: 'AreaV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAreaV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlDepotV2GqlConnection = {
  __typename?: 'DepotV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDepotV2GqlEdge>>;
};

/** A Relay edge containing a `DepotV2GQL` and its cursor. */
export type GqlDepotV2GqlEdge = {
  __typename?: 'DepotV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDepotV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Route List. */
export enum GqlRouteType {
  Delivery = 'DELIVERY',
  Outermarket = 'OUTERMARKET',
  Courier = 'COURIER',
  Staff = 'STAFF'
}

/** Node and relay Connection. */
export type GqlRouteV2GqlConnection = {
  __typename?: 'RouteV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRouteV2GqlEdge>>;
};

/** A Relay edge containing a `RouteV2GQL` and its cursor. */
export type GqlRouteV2GqlEdge = {
  __typename?: 'RouteV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRouteV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlRouteTeamV2GqlConnection = {
  __typename?: 'RouteTeamV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRouteTeamV2GqlEdge>>;
};

/** A Relay edge containing a `RouteTeamV2GQL` and its cursor. */
export type GqlRouteTeamV2GqlEdge = {
  __typename?: 'RouteTeamV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRouteTeamV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Route Team GQL. */
export type GqlRouteTeamV2Gql = {
  __typename?: 'RouteTeamV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  route_team_id: Scalars['String'];
  route_id: Scalars['String'];
  sale_date: Scalars['String'];
  country_id: Maybe<Scalars['String']>;
  route: Maybe<GqlRouteV2Gql>;
  route_team_members: Maybe<Array<Maybe<GqlRouteTeamMemberV2Gql>>>;
};

/** Route Team Member GQL. */
export type GqlRouteTeamMemberV2Gql = {
  __typename?: 'RouteTeamMemberV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  route_team_member_id: Scalars['String'];
  route_team_id: Scalars['String'];
  user_id: Scalars['String'];
  sale_date: Scalars['String'];
  route_team: Maybe<GqlRouteTeamV2Gql>;
  user: Maybe<GqlUserV2Gql>;
};

/** Node and relay Connection. */
export type GqlRouteTeamMemberV2GqlConnection = {
  __typename?: 'RouteTeamMemberV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRouteTeamMemberV2GqlEdge>>;
};

/** A Relay edge containing a `RouteTeamMemberV2GQL` and its cursor. */
export type GqlRouteTeamMemberV2GqlEdge = {
  __typename?: 'RouteTeamMemberV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRouteTeamMemberV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlDepotRoutingSummaryGqlConnection = {
  __typename?: 'DepotRoutingSummaryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDepotRoutingSummaryGqlEdge>>;
};

/** A Relay edge containing a `DepotRoutingSummaryGQL` and its cursor. */
export type GqlDepotRoutingSummaryGqlEdge = {
  __typename?: 'DepotRoutingSummaryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDepotRoutingSummaryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDepotRoutingSummaryGql = {
  __typename?: 'DepotRoutingSummaryGQL';
  depot_id: Maybe<Scalars['String']>;
  depot_name: Maybe<Scalars['String']>;
  sale_date: Maybe<Scalars['String']>;
  route_plans: Maybe<Scalars['Int']>;
  total_orders: Maybe<Scalars['Int']>;
  routed_orders: Maybe<Scalars['Int']>;
  total_ordered_revenue: Maybe<Scalars['Float']>;
  total_routed_revenue: Maybe<Scalars['Float']>;
  total_ordered_weight: Maybe<Scalars['Float']>;
  total_routed_weight: Maybe<Scalars['Float']>;
};

/** Pagination Connection for CustomerV2GQL */
export type GqlCustomerV2GqlConnection = {
  __typename?: 'CustomerV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlCustomerV2GqlEdge>>;
};

/** A Relay edge containing a `CustomerV2GQL` and its cursor. */
export type GqlCustomerV2GqlEdge = {
  __typename?: 'CustomerV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlCustomerV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPhoneNumberChangeReasonGql = {
  __typename?: 'PhoneNumberChangeReasonGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  reason_id: Scalars['String'];
  reason: Scalars['String'];
  type: GqlPhoneNumberChangeReasonTypeEnum;
};

/** Phone change reason type enum */
export enum GqlPhoneNumberChangeReasonTypeEnum {
  Approval = 'APPROVAL',
  Decline = 'DECLINE'
}

export type GqlPhoneNumberChangeApprovalGql = {
  __typename?: 'PhoneNumberChangeApprovalGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  phone_number_change_id: Scalars['String'];
  customer_id: Scalars['String'];
  approved: Scalars['Boolean'];
  reason_id: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  customer: Maybe<GqlCustomerV2Gql>;
  phone_number_change_reason: Maybe<GqlPhoneNumberChangeReasonGql>;
};

/** Pagination Connection for ShopV2GQL */
export type GqlShopV2GqlConnection = {
  __typename?: 'ShopV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlShopV2GqlEdge>>;
};

/** A Relay edge containing a `ShopV2GQL` and its cursor. */
export type GqlShopV2GqlEdge = {
  __typename?: 'ShopV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlShopV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VendorKYCGQL */
export type GqlVendorKycgqlConnection = {
  __typename?: 'VendorKYCGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVendorKycgqlEdge>>;
};

/** A Relay edge containing a `VendorKYCGQL` and its cursor. */
export type GqlVendorKycgqlEdge = {
  __typename?: 'VendorKYCGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVendorKycgql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlShopDeliveryFeeGql = {
  __typename?: 'ShopDeliveryFeeGQL';
  shop_id: Maybe<Scalars['String']>;
  delivery_fee: Maybe<Scalars['Float']>;
};

export type GqlReturnsHandlingUnitItemGqlConnection = {
  __typename?: 'ReturnsHandlingUnitItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlReturnsHandlingUnitItemGqlEdge>>;
};

/** A Relay edge containing a `ReturnsHandlingUnitItemGQL` and its cursor. */
export type GqlReturnsHandlingUnitItemGqlEdge = {
  __typename?: 'ReturnsHandlingUnitItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlReturnsHandlingUnitItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlReturnsHandlingUnitItemGql = {
  __typename?: 'ReturnsHandlingUnitItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  returns_handling_unit_item_id: Scalars['String'];
  returns_handling_unit_id: Scalars['String'];
  handling_unit_item_id: Scalars['String'];
  product_loss_reason_id: Maybe<Scalars['String']>;
  picture: Maybe<Scalars['String']>;
  scheduled_for_picking: Scalars['Boolean'];
  wms_returns_id: Scalars['String'];
  returns_handling_units: Maybe<GqlReturnsHandlingUnitGql>;
  handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
  product_loss_reason: Maybe<GqlProductLossReasonGql>;
  wms_returns: Maybe<GqlWmsReturnsGql>;
};

export type GqlReturnsHandlingUnitGql = {
  __typename?: 'ReturnsHandlingUnitGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  returns_handling_unit_id: Scalars['String'];
  handling_unit_id: Scalars['String'];
  wms_returns_type: GqlWmsReturnsType;
  is_complete: Scalars['Boolean'];
  handling_unit: Maybe<GqlHandlingUnitGql>;
  returns_handling_unit_items: Maybe<Array<Maybe<GqlReturnsHandlingUnitItemGql>>>;
};

/** An enumeration. */
export enum GqlWmsReturnsType {
  Reavail = 'REAVAIL',
  Dispose = 'DISPOSE'
}

export type GqlHandlingUnitGql = {
  __typename?: 'HandlingUnitGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  handling_unit_id: Scalars['String'];
  asset_id: Scalars['String'];
  batch_id: Maybe<Scalars['String']>;
  booking_id: Maybe<Scalars['String']>;
  warehouse_transfer_id: Maybe<Scalars['String']>;
  return_id: Maybe<Scalars['String']>;
  storage_location_id: Scalars['String'];
  stock_date: Maybe<Scalars['String']>;
  quarantine_reason: Maybe<Scalars['String']>;
  disposal_reason: Maybe<Scalars['String']>;
  order_by_date: Maybe<Scalars['String']>;
  stock_availability_status: GqlHuStockAvailabilityStatus;
  asset: Maybe<GqlAssetGql>;
  warehouse_transfer: Maybe<GqlWarehouseTransferGql>;
  all_handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  storage_location: Maybe<GqlStorageLocationGql>;
  picking_handling_units: Maybe<Array<Maybe<GqlPickingHandlingUnitGql>>>;
  active_picking_hu: Maybe<GqlPickingHandlingUnitGql>;
  product_transfer_handling_unit: Maybe<Array<Maybe<GqlProductTransferHandlingUnitGql>>>;
  returns_handling_unit: Maybe<GqlReturnsHandlingUnitGql>;
  quantity: Maybe<Scalars['Int']>;
  batch: Maybe<GqlBatchGql>;
  returns: Maybe<GqlReturnGql>;
  booking: Maybe<GqlBookingGql>;
  updated_by_user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlHuStockAvailabilityStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Quarantined = 'QUARANTINED',
  Disposed = 'DISPOSED'
}

export type GqlAssetGql = {
  __typename?: 'AssetGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_id: Maybe<Scalars['String']>;
  asset_number: Scalars['String'];
  asset_type_id: Maybe<Scalars['String']>;
  asset_status: GqlAssetStatus;
  asset_type: Maybe<GqlAssetTypeGql>;
  asset_photos: Maybe<Array<Maybe<GqlAssetPhotoGql>>>;
  handling_units: Maybe<Array<Maybe<GqlHandlingUnitGql>>>;
  all_handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  asset_tracker_item: Maybe<Array<Maybe<GqlAssetTrackerItemGql>>>;
  last_active_hu_item: Maybe<GqlHandlingUnitItemGql>;
};

/** An enumeration. */
export enum GqlAssetStatus {
  Ok = 'OK',
  Lost = 'LOST',
  Damaged = 'DAMAGED'
}

export type GqlAssetTypeGql = {
  __typename?: 'AssetTypeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_type_id: Scalars['String'];
  asset_type_name: Scalars['String'];
  assets: Maybe<Array<Maybe<GqlAssetGql>>>;
};

export type GqlAssetPhotoGql = {
  __typename?: 'AssetPhotoGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_photo_id: Scalars['String'];
  asset_id: Scalars['String'];
  file_name: Scalars['String'];
  asset: Maybe<GqlAssetGql>;
  signed_url: Maybe<Scalars['String']>;
};

export type GqlHandlingUnitItemGql = {
  __typename?: 'HandlingUnitItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  handling_unit_item_id: Scalars['String'];
  stock_date: Maybe<Scalars['String']>;
  quarantine_reason: Maybe<Scalars['String']>;
  disposal_reason: Maybe<Scalars['String']>;
  order_by_date: Maybe<Scalars['String']>;
  parent_id: Maybe<Scalars['String']>;
  is_sku: Scalars['Boolean'];
  handling_unit_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  quantity: Scalars['Int'];
  weight: Maybe<Scalars['Int']>;
  asset_id: Scalars['String'];
  dispatched: Scalars['Boolean'];
  stock_availability_status: Maybe<Scalars['String']>;
  storage_location_id: Scalars['String'];
  parent: Maybe<GqlHandlingUnitItemGql>;
  handling_unit: Maybe<GqlHandlingUnitGql>;
  asset: Maybe<GqlAssetGql>;
  storage_location: Maybe<GqlStorageLocationGql>;
  product_transfer_handling_unit_item: Maybe<Array<Maybe<GqlProductTransferHandlingUnitItemGql>>>;
  returns_handling_unit_item: Maybe<GqlReturnsHandlingUnitItemGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlStorageLocationGql = {
  __typename?: 'StorageLocationGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  storage_location_id: Scalars['String'];
  storage_location_number: Scalars['String'];
  location_type_id: Scalars['String'];
  status: GqlStorageLocationStatus;
  location_type: Maybe<GqlStorageLocationTypeGql>;
  handling_units: Maybe<Array<Maybe<GqlHandlingUnitGql>>>;
  all_handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  handling_unit_items: Maybe<Array<Maybe<GqlHandlingUnitItemGql>>>;
  dock_door: Maybe<Array<Maybe<GqlDockDoorGql>>>;
  bin: Maybe<Array<Maybe<GqlBinGql>>>;
  waste_area: Maybe<Array<Maybe<GqlWasteAreaGql>>>;
  hu_count: Maybe<Scalars['Int']>;
  hui_count: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GqlStorageLocationStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Outoforder = 'OUTOFORDER'
}

export type GqlStorageLocationTypeGql = {
  __typename?: 'StorageLocationTypeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  location_type_id: Scalars['String'];
  location_type_name: Scalars['String'];
  storage_locations: Maybe<Array<Maybe<GqlStorageLocationGql>>>;
};

export type GqlDockDoorGql = {
  __typename?: 'DockDoorGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  dock_door_id: Scalars['String'];
  dock_door_number: Maybe<Scalars['Int']>;
  status: GqlDockDoorStatus;
  door_type: Array<Maybe<Scalars['String']>>;
  staging_area_name: Scalars['String'];
  warehouse_id: Scalars['String'];
  storage_location_id: Scalars['String'];
  appointments: Maybe<Array<Maybe<GqlAppointmentGql>>>;
  storage_location: Maybe<GqlStorageLocationGql>;
  warehouse: Maybe<GqlWarehouseGql>;
  storage: Maybe<GqlStorageLocationGql>;
};

/** An enumeration. */
export enum GqlDockDoorStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type GqlAppointmentGql = {
  __typename?: 'AppointmentGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  appointment_id: Scalars['String'];
  appointment_number: Scalars['String'];
  vehicle_registration: Maybe<Scalars['String']>;
  driver_name: Maybe<Scalars['String']>;
  driver_phone_number: Maybe<Scalars['String']>;
  status: GqlAppointmentStatus;
  decline_reason: Maybe<Scalars['String']>;
  appointment_type: GqlAppointmentType;
  dock_door_id: Maybe<Scalars['String']>;
  eta: Scalars['DateTime'];
  issued_by: Scalars['String'];
  assigned_by: Maybe<Scalars['String']>;
  delivery_note: Maybe<Scalars['String']>;
  images: Maybe<Scalars['GenericScalar']>;
  calender_event_id: Maybe<Scalars['String']>;
  type_of_truck: Maybe<Scalars['String']>;
  driver_id: Maybe<Scalars['String']>;
  vehicle_seal_number: Maybe<Scalars['String']>;
  distribution_center_id: Maybe<Scalars['String']>;
  appointment_items: Maybe<Array<Maybe<GqlAppointmentItemGql>>>;
  dock_door: Maybe<GqlDockDoorGql>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  intakes: Maybe<GqlStockIntakeGql>;
  wms_returns: Maybe<GqlWmsReturnsGql>;
  issued_by_user: Maybe<GqlUserV2Gql>;
  assigned_by_user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlAppointmentStatus {
  Upcoming = 'UPCOMING',
  Assigned = 'ASSIGNED',
  Receiving = 'RECEIVING',
  Closed = 'CLOSED',
  PastDue = 'PAST_DUE',
  Rejected = 'REJECTED',
  QaApproved = 'QA_APPROVED',
  QaDeclined = 'QA_DECLINED',
  SecurityApproved = 'SECURITY_APPROVED',
  SecurityDeclined = 'SECURITY_DECLINED'
}

/** An enumeration. */
export enum GqlAppointmentType {
  Booking = 'BOOKING',
  Returns = 'RETURNS',
  Purchase = 'PURCHASE',
  WarehouseTransfer = 'WAREHOUSE_TRANSFER',
  FfvBatch = 'FFV_BATCH',
  ReIntake = 'RE_INTAKE'
}

export type GqlAppointmentItemGql = {
  __typename?: 'AppointmentItemGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  appointment_item_id: Scalars['String'];
  appointment_id: Scalars['String'];
  batch_id: Maybe<Scalars['String']>;
  booking_id: Maybe<Scalars['String']>;
  warehouse_transfer_id: Maybe<Scalars['String']>;
  return_id: Maybe<Scalars['String']>;
  appointment: Maybe<GqlAppointmentGql>;
  warehouse_transfer: Maybe<GqlWarehouseTransferGql>;
  booking: Maybe<GqlBookingGql>;
  batch: Maybe<GqlBatchGql>;
  returns: Maybe<GqlReturnGql>;
};

export type GqlWarehouseTransferGql = {
  __typename?: 'WarehouseTransferGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warehouse_transfer_id: Scalars['String'];
  direction: GqlStockDirection;
  source_distribution_center_id: Scalars['String'];
  dest_distribution_center_id: Scalars['String'];
  transfer_date: Scalars['String'];
  transferred_by: Scalars['String'];
  transfer_number: Scalars['String'];
  vehicle_id: Maybe<Scalars['String']>;
  transfer_reason_id: Maybe<Scalars['String']>;
  source_distribution_center: Maybe<GqlDistributionCenterGql>;
  dest_distribution_center: Maybe<GqlDistributionCenterGql>;
  warehouse_transfer_items: Maybe<Array<Maybe<GqlWarehouseTransferItemGql>>>;
  appointment_item: Maybe<GqlAppointmentItemGql>;
  transfer_reason: Maybe<GqlWarehouseTransferReasonGql>;
  handling_units: Maybe<Array<Maybe<GqlHandlingUnitGql>>>;
  stock_intake_items: Maybe<Array<Maybe<GqlStockIntakeItemGql>>>;
  transferred_by_user: Maybe<GqlUserV2Gql>;
  vehicle: Maybe<GqlVehicleGql>;
};

/**
 * The direction of stock, either a dispatch (In) or a receipt (Out),
 * at a inventory_location.
 */
export enum GqlStockDirection {
  In = 'IN',
  Out = 'OUT'
}

export type GqlWarehouseGql = {
  __typename?: 'WarehouseGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warehouse_id: Scalars['String'];
  warehouse_name: Scalars['String'];
  distribution_center_id: Maybe<Scalars['String']>;
  storage_units: Maybe<Array<Maybe<GqlStorageUnitGql>>>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  warehouse_transfer_items: Maybe<Array<Maybe<GqlWarehouseTransferItemGql>>>;
};

export type GqlStorageUnitGql = {
  __typename?: 'StorageUnitGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  storage_unit_id: Scalars['String'];
  storage_unit_type_id: Scalars['String'];
  unit_name: Scalars['String'];
  warehouse_id: Scalars['String'];
  warehouse: Maybe<GqlWarehouseGql>;
  storage_unit_type: Maybe<GqlStorageUnitTypeGql>;
  storages: Maybe<Array<Maybe<GqlStorageGql>>>;
  warehouse_transfer_items: Maybe<Array<Maybe<GqlWarehouseTransferItemGql>>>;
};

export type GqlStorageUnitTypeGql = {
  __typename?: 'StorageUnitTypeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  storage_unit_type_id: Scalars['String'];
  storage_unit_type: Scalars['String'];
  storage_units: Maybe<Array<Maybe<GqlStorageUnitGql>>>;
};

export type GqlStorageGql = {
  __typename?: 'StorageGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  storage_id: Scalars['String'];
  batch_id: Maybe<Scalars['String']>;
  storage_unit_id: Scalars['String'];
  storage_entry_number: Scalars['String'];
  date: Scalars['DateTime'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  unit_of_measure_id: Scalars['String'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  comments: Maybe<Scalars['String']>;
  storage_unit: Maybe<GqlStorageUnitGql>;
  direction: Maybe<Scalars['String']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  batch: Maybe<GqlBatchGql>;
};

export type GqlPackagingUnitV2Gql = {
  __typename?: 'PackagingUnitV2GQL';
  packaging_unit_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  returnable: Scalars['Boolean'];
  weight: Scalars['Float'];
};

export type GqlBatchGql = {
  __typename?: 'BatchGQL';
  batch_id: Scalars['String'];
  field_weight: Maybe<Scalars['Float']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  batch_name: Scalars['String'];
  batch_date: Scalars['String'];
  collection_center_id: Maybe<Scalars['String']>;
  area_id: Maybe<Scalars['String']>;
  lpo_number: Maybe<Scalars['String']>;
  farmer_code: Maybe<Scalars['String']>;
  harvests: Maybe<Array<Maybe<GqlHarvestGql>>>;
  area: Maybe<GqlAreaGql>;
  collection_center: Maybe<GqlCollectionCenterGql>;
  intake_weight: Maybe<Scalars['Float']>;
  processing_loss_weight: Maybe<Scalars['Float']>;
  appointment_items: Maybe<Array<Maybe<GqlAppointmentItemGql>>>;
  stock_intake_items_batch: Maybe<GqlStockIntakeItemBatchGql>;
};

export type GqlWarehouseTransferItemGql = {
  __typename?: 'WarehouseTransferItemGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warehouse_transfer_item_id: Scalars['String'];
  warehouse_transfer_id: Scalars['String'];
  warehouse_id: Scalars['String'];
  storage_unit_id: Scalars['String'];
  batch_id: Maybe<Scalars['String']>;
  product_id: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Int'];
  weight: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  warehouse_transfer: Maybe<GqlWarehouseTransferGql>;
  warehouse: Maybe<GqlWarehouseGql>;
  storage_unit: Maybe<GqlStorageUnitGql>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  batch: Maybe<GqlBatchGql>;
};

export type GqlProductV2Gql = {
  __typename?: 'ProductV2GQL';
  product_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_name: Scalars['String'];
  product_code: Maybe<Scalars['String']>;
  hs_code: Maybe<Scalars['String']>;
  kra_code: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  product_description: Maybe<Scalars['String']>;
  category_id: Maybe<Scalars['String']>;
  vatable: Maybe<Scalars['Boolean']>;
  featured: Scalars['Boolean'];
  product_type: Maybe<GqlProductTypeEnum>;
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  finance_product_type_id: Maybe<Scalars['String']>;
  wms_shelf_life_days: Maybe<Scalars['Int']>;
  packaging_units: Maybe<Array<Maybe<GqlPackagingUnitV2Gql>>>;
  category: Maybe<GqlCategoryV2Gql>;
  categories: Maybe<Array<Maybe<GqlCategoryV2Gql>>>;
  domain_activations: Maybe<Array<Maybe<GqlProductDomainActivationV2Gql>>>;
  product_tags: Maybe<Array<Maybe<GqlProductTagV2Gql>>>;
  finance_product_type: Maybe<GqlFinanceProductTypeGql>;
  product_items: Maybe<Array<Maybe<GqlProductItemV2Gql>>>;
  sourcing_price_range: Maybe<GqlPriceRangeGql>;
};

export type GqlStockIntakeGql = {
  __typename?: 'StockIntakeGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_intake_id: Scalars['String'];
  stock_intake_number: Scalars['String'];
  arrival_date: Maybe<Scalars['DateTime']>;
  start_time: Maybe<Scalars['DateTime']>;
  close_time: Maybe<Scalars['DateTime']>;
  truck_number: Maybe<Scalars['String']>;
  stock_intake_status: Maybe<GqlStockIntakeStatus>;
  stock_intake_type: GqlStockIntakeType;
  product_type: Maybe<GqlProductType>;
  decline_reason: Maybe<Scalars['String']>;
  stock_date: Maybe<Scalars['String']>;
  order_by_date: Maybe<Scalars['String']>;
  stock_availability_status: Maybe<GqlStockAvailabilityStatus>;
  appointment_id: Maybe<Scalars['String']>;
  harvest_id: Maybe<Scalars['String']>;
  wms_intake: Scalars['Boolean'];
  distribution_center_id: Maybe<Scalars['String']>;
  intake_count: Maybe<Scalars['Int']>;
  appointment: Maybe<GqlAppointmentGql>;
  stock_intake_items: Maybe<Array<Maybe<GqlStockIntakeItemGql>>>;
  stock_intake_photos: Maybe<Array<Maybe<GqlStockIntakePhotoGql>>>;
  stock_intake_skus: Maybe<Array<Maybe<GqlStockIntakeSkuGql>>>;
  stock_intake_users: Maybe<Array<Maybe<GqlStockIntakeUserGql>>>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlStockIntakeStatus {
  Inprogress = 'INPROGRESS',
  Closed = 'CLOSED',
  Rejected = 'REJECTED',
  Onhold = 'ONHOLD',
  QaApproved = 'QA_APPROVED',
  QaDeclined = 'QA_DECLINED'
}

/** An enumeration. */
export enum GqlStockIntakeType {
  Supplier = 'SUPPLIER',
  Returns = 'RETURNS',
  Rework = 'REWORK'
}

/** An enumeration. */
export enum GqlProductType {
  Fmcg = 'FMCG',
  Ffv = 'FFV'
}

/** An enumeration. */
export enum GqlStockAvailabilityStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Quarantined = 'QUARANTINED'
}

export type GqlStockIntakeItemGql = {
  __typename?: 'StockIntakeItemGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_intake_item_id: Scalars['String'];
  stock_intake_id: Scalars['String'];
  batch_id: Maybe<Scalars['String']>;
  booking_id: Maybe<Scalars['String']>;
  warehouse_transfer_id: Maybe<Scalars['String']>;
  return_id: Maybe<Scalars['String']>;
  product_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Maybe<Scalars['Float']>;
  weight: Maybe<Scalars['Float']>;
  pallet_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Scalars['String'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  gross_weight: Maybe<Scalars['Float']>;
  pallet_weight: Scalars['Float'];
  waste: Scalars['Boolean'];
  stock_intake_item_status: Maybe<GqlStockIntakeItemStatus>;
  warehouse_transfer: Maybe<GqlWarehouseTransferGql>;
  pallet: Maybe<GqlAssetGql>;
  stock_intake: Maybe<GqlStockIntakeGql>;
  stock_intake_item_assets: Maybe<Array<Maybe<GqlStockIntakeItemAssetGql>>>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  batch: Maybe<GqlBatchGql>;
  returns: Maybe<GqlReturnGql>;
  booking: Maybe<GqlBookingGql>;
  user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlStockIntakeItemStatus {
  Inprogress = 'INPROGRESS',
  Closed = 'CLOSED'
}

export type GqlStockIntakeItemAssetGql = {
  __typename?: 'StockIntakeItemAssetGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_intake_item_asset_id: Scalars['String'];
  stock_intake_item_id: Maybe<Scalars['String']>;
  parent_id: Maybe<Scalars['String']>;
  is_sku: Scalars['Boolean'];
  asset_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  parent: Maybe<GqlStockIntakeItemAssetGql>;
  stock_intake_item: Maybe<GqlStockIntakeItemGql>;
  assets: Maybe<GqlAssetGql>;
};

export type GqlReturnGql = GqlNode & {
  __typename?: 'ReturnGQL';
  return_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  distribution_center_id: Maybe<Scalars['String']>;
  return_number: Scalars['String'];
  sale_date: Scalars['String'];
  depot_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  return_level: GqlReturnLevel;
  cancellation_reason: Maybe<Scalars['String']>;
  route_plan_id: Maybe<Scalars['String']>;
  product_return_items: Maybe<Array<Maybe<GqlProductReturnItemGql>>>;
  packaging_return_items: Maybe<Array<Maybe<GqlPackagingReturnItemGql>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  route: Maybe<GqlRouteV2Gql>;
  depot: Maybe<GqlDepotV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
};

export type GqlBookingGql = GqlNode & {
  __typename?: 'BookingGQL';
  booking_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  receipt_number: Scalars['String'];
  farm_id: Maybe<Scalars['String']>;
  farmer_id: Maybe<Scalars['String']>;
  collection_center_id: Scalars['String'];
  country_id: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Float']>;
  weight: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
  original_currency: Scalars['String'];
  fx_rate: Maybe<Scalars['Float']>;
  invoice_url: Maybe<Scalars['String']>;
  booking_date: Scalars['String'];
  harvest_date: Maybe<Scalars['String']>;
  booked_by: Maybe<Scalars['String']>;
  invoice_number: Maybe<Scalars['String']>;
  status: Maybe<GqlBookingStatus>;
  purchase_order_number: Maybe<Scalars['String']>;
  purchase_order_url: Maybe<Scalars['String']>;
  farm: Maybe<GqlFarmGql>;
  collection_center: Maybe<GqlCollectionCenterGql>;
  booking_items: Maybe<Array<Maybe<GqlBookingItemGql>>>;
  farmer: Maybe<GqlFarmerGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  signed_invoice_url: Maybe<Scalars['String']>;
  signed_purchase_order_url: Maybe<Scalars['String']>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  scout: Maybe<GqlUserV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  country: Maybe<GqlCountryGql>;
};

export type GqlStockIntakePhotoGql = {
  __typename?: 'StockIntakePhotoGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  intake_photo_id: Scalars['String'];
  stock_intake_id: Scalars['String'];
  file_name: Scalars['String'];
  signed_url: Maybe<Scalars['String']>;
};

export type GqlStockIntakeSkuGql = {
  __typename?: 'StockIntakeSkuGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_intake_sku_id: Scalars['String'];
  stock_intake_id: Scalars['String'];
  product_item_id: Scalars['String'];
  supplier_batch_number: Maybe<Scalars['String']>;
  batch_id: Maybe<Scalars['String']>;
  stock_date: Maybe<Scalars['String']>;
  order_by_date: Maybe<Scalars['String']>;
  stock_availability_status: Maybe<Scalars['String']>;
  expected_quantity: Scalars['Int'];
  rejected_quantity: Scalars['Int'];
  rejection_reason: Maybe<Scalars['String']>;
  stock_intake: Maybe<GqlStockIntakeGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlStockIntakeUserGql = {
  __typename?: 'StockIntakeUserGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_intake_user_id: Scalars['String'];
  stock_intake_id: Scalars['String'];
  user_id: Scalars['String'];
  stock_intake: Maybe<GqlStockIntakeGql>;
  user: Maybe<GqlUserV2Gql>;
};

export type GqlStockTakeGql = {
  __typename?: 'StockTakeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_take_id: Scalars['String'];
  date: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Maybe<Scalars['String']>;
  inventory_quantity: Maybe<Scalars['Float']>;
  verified_quantity: Maybe<Scalars['Float']>;
  distribution_center_id: Maybe<Scalars['String']>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlProcessingLossGql = {
  __typename?: 'ProcessingLossGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  processing_loss_id: Scalars['String'];
  processing_loss_number: Scalars['String'];
  depot_id: Maybe<Scalars['String']>;
  batch_id: Maybe<Scalars['String']>;
  date: Scalars['String'];
  cancellation_reason: Maybe<Scalars['String']>;
  loss_type: Maybe<GqlLossType>;
  processing_loss_type_id: Maybe<Scalars['String']>;
  distribution_center_id: Maybe<Scalars['String']>;
  processing_loss_items: Maybe<Array<Maybe<GqlProcessingLossItemGql>>>;
  processing_loss_type: Maybe<GqlProcessingLossTypeGql>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  depot: Maybe<GqlDepotV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  batch: Maybe<GqlBatchGql>;
};

/** An enumeration. */
export enum GqlLossType {
  Processing = 'PROCESSING',
  PostProcessing = 'POST_PROCESSING',
  Staging = 'STAGING',
  Ripening = 'RIPENING',
  Sampling = 'SAMPLING',
  Disposal = 'DISPOSAL',
  Warehouse = 'WAREHOUSE',
  Writeoff = 'WRITEOFF',
  B2CReturns = 'B2_C_RETURNS',
  GtReturns = 'GT_RETURNS',
  DepotStaging = 'DEPOT_STAGING',
  MarketResearch = 'MARKET_RESEARCH',
  InTransit = 'IN_TRANSIT'
}

export type GqlProcessingLossItemGql = {
  __typename?: 'ProcessingLossItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  processing_loss_item_id: Scalars['String'];
  processing_loss_id: Scalars['String'];
  date: Scalars['String'];
  product_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Float'];
  unit_of_measure_id: Scalars['String'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  product_loss_reason_id: Scalars['String'];
  picture: Maybe<Scalars['String']>;
  thumbnail: Maybe<Scalars['String']>;
  weight: Maybe<Scalars['Float']>;
  cancellation_reason: Maybe<Scalars['String']>;
  processing_loss: Maybe<GqlProcessingLossGql>;
  product_loss_reason: Maybe<GqlProductLossReasonGql>;
  signed_picture: Maybe<Scalars['String']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlProductLossReasonGql = {
  __typename?: 'ProductLossReasonGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_loss_reason_id: Scalars['String'];
  loss_reason_id: Scalars['String'];
  product_id: Scalars['String'];
  loss_reason: Maybe<GqlLossReasonGql>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlLossReasonGql = {
  __typename?: 'LossReasonGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  loss_reason_id: Scalars['String'];
  loss_reason: Scalars['String'];
  product_loss_reasons: Maybe<Array<Maybe<GqlProductLossReasonGql>>>;
};

export type GqlProcessingLossTypeGql = {
  __typename?: 'ProcessingLossTypeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  processing_loss_type_id: Scalars['String'];
  processing_loss_type_name: Scalars['String'];
  processing_loss_type_description: Maybe<Scalars['String']>;
  processing_losses: Maybe<Array<Maybe<GqlProcessingLossGql>>>;
};

export type GqlStockAvailabilityGqLv2Connection = {
  __typename?: 'StockAvailabilityGQLv2Connection';
  /** Pagination data for this connection. */
  pageInfo: GqlPageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockAvailabilityGqLv2Edge>>;
};

/** A Relay edge containing a `StockAvailabilityGQLv2` and its cursor. */
export type GqlStockAvailabilityGqLv2Edge = {
  __typename?: 'StockAvailabilityGQLv2Edge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockAvailabilityGqLv2>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockAvailabilityGqLv2 = GqlNode & {
  __typename?: 'StockAvailabilityGQLv2';
  region_id: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_availability_id: Scalars['String'];
  sale_date: Scalars['String'];
  stock_entry_number: Scalars['String'];
  product_item_id: Scalars['String'];
  wms_constraint: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Float']>;
  unit_of_measure_id: Scalars['String'];
  distribution_center_id: Scalars['String'];
  distribution_center: Maybe<GqlDistributionCenterGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  product_item: Maybe<GqlProductItemV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  ordered_stock: Maybe<GqlStockOrderedGql>;
  region: Maybe<GqlRegionV2Gql>;
};

export type GqlWarehouseTransferReasonGql = {
  __typename?: 'WarehouseTransferReasonGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  reason_id: Scalars['String'];
  reason_name: Scalars['String'];
};

export type GqlVehicleGql = {
  __typename?: 'VehicleGQL';
  vehicle_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  country_id: Maybe<Scalars['String']>;
  vehicle_cost_model: Maybe<Scalars['String']>;
  cost_rate: Scalars['Float'];
  logistics_type: Maybe<Scalars['String']>;
  vehicle_type_id: Scalars['String'];
  depot_id: Maybe<Scalars['String']>;
  route_id: Maybe<Scalars['String']>;
  registration_number: Scalars['String'];
  owner_name: Maybe<Scalars['String']>;
  phone_number: Maybe<Scalars['String']>;
  load_capacity: Scalars['Float'];
  usable_load_capacity: Scalars['Float'];
  capacity_volume: Maybe<Scalars['Float']>;
  usable_volume: Scalars['Float'];
  locked: Scalars['Boolean'];
  product_type: Maybe<Scalars['String']>;
  vehicle_supplier_id: Maybe<Scalars['String']>;
  insurance_expiry_date: Maybe<Scalars['String']>;
  service_due_date: Maybe<Scalars['String']>;
  region_id: Maybe<Scalars['String']>;
  rejected: Scalars['Boolean'];
  rejection_reason: Maybe<Array<Maybe<GqlVehicleRejectionReason>>>;
  till_number: Maybe<Scalars['Int']>;
  vehicle_type: Maybe<GqlVehicleTypeGql>;
  trips: Maybe<Array<Maybe<GqlTripGql>>>;
  vehicle_supplier: Maybe<GqlVehicleSupplierGql>;
  last_assigned: Maybe<Scalars['String']>;
  starting_odometer: Maybe<Scalars['String']>;
  closing_odometer: Maybe<Scalars['String']>;
  depot: Maybe<GqlDepotV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
  region: Maybe<GqlRegionV2Gql>;
};

export type GqlWmsReturnsGql = {
  __typename?: 'WMSReturnsGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  wms_returns_id: Scalars['String'];
  wms_returns_number: Scalars['String'];
  appointment_id: Scalars['String'];
  is_complete: Scalars['Boolean'];
  appointment: Maybe<GqlAppointmentGql>;
  returns_handling_unit_items: Maybe<Array<Maybe<GqlReturnsHandlingUnitItemGql>>>;
};

export type GqlBinGql = {
  __typename?: 'BinGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  bin_id: Scalars['String'];
  bin_type: GqlBinType;
  aisle: Maybe<Scalars['String']>;
  level: Maybe<Scalars['String']>;
  bin_position: Maybe<Scalars['String']>;
  is_pickface: Scalars['Boolean'];
  capacity: Scalars['Int'];
  pickface_product_item_id: Maybe<Scalars['String']>;
  warehouse_id: Scalars['String'];
  storage_location_id: Scalars['String'];
  storage_location: Maybe<GqlStorageLocationGql>;
  warehouse: Maybe<GqlWarehouseGql>;
  storage: Maybe<GqlStorageLocationGql>;
  product_zone: Maybe<Array<Maybe<GqlProductZoneGql>>>;
  bin_names: Maybe<Array<Maybe<GqlBinNameGql>>>;
  pickface_product_item: Maybe<GqlProductItemV2Gql>;
};

/** An enumeration. */
export enum GqlBinType {
  Blockstack = 'BLOCKSTACK',
  Crossdock = 'CROSSDOCK',
  Deepracking3 = 'DEEPRACKING3',
  Deepracking6 = 'DEEPRACKING6',
  Selectiveracking = 'SELECTIVERACKING',
  Qualitycontrol = 'QUALITYCONTROL',
  Returns = 'RETURNS',
  Waste = 'WASTE',
  Staging = 'STAGING',
  Bananaroom = 'BANANAROOM'
}

export type GqlProductZoneGql = {
  __typename?: 'ProductZoneGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_zone_id: Scalars['String'];
  product_zone_name: Scalars['String'];
  product_zone_description: Maybe<Scalars['String']>;
  product_zone_type: Maybe<Scalars['String']>;
  bins: Maybe<Array<Maybe<GqlBinGql>>>;
  rules: Maybe<Array<Maybe<GqlRuleGql>>>;
};

export type GqlRuleGql = {
  __typename?: 'RuleGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  rule_id: Scalars['String'];
  rule_name: Scalars['String'];
  rule_description: Maybe<Scalars['String']>;
  product_rules: Maybe<Array<Maybe<GqlProductRuleGql>>>;
  category_rules: Maybe<Array<Maybe<GqlCategoryRuleGql>>>;
  product_zone: Maybe<Array<Maybe<GqlProductZoneGql>>>;
};

export type GqlProductRuleGql = {
  __typename?: 'ProductRuleGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_rule_id: Scalars['String'];
  rule_id: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  is_sku_rule: Scalars['Boolean'];
  rule: Maybe<GqlRuleGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlCategoryRuleGql = {
  __typename?: 'CategoryRuleGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  category_rule_id: Scalars['String'];
  rule_id: Scalars['String'];
  category_rule_type: GqlCategoryType;
  category_id: Scalars['String'];
  rule: Maybe<GqlRuleGql>;
  category: Maybe<GqlCategoryV2Gql>;
};

/** An enumeration. */
export enum GqlCategoryType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Category GQL schema */
export type GqlCategoryV2Gql = {
  __typename?: 'CategoryV2GQL';
  category_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  category_name: Scalars['String'];
  slug: Scalars['String'];
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  banner_image: Maybe<Scalars['String']>;
  banner_image_url: Maybe<Scalars['String']>;
  department_id: Scalars['String'];
  featured: Scalars['Boolean'];
  parent_id: Maybe<Scalars['String']>;
  ordering_window: Maybe<Scalars['JSONString']>;
  department: Maybe<GqlDepartmentV2Gql>;
  products: Maybe<Array<Maybe<GqlProductV2Gql>>>;
  regions: Maybe<Array<Maybe<GqlCategoryRegionV2Gql>>>;
  sub_categories: Maybe<Array<Maybe<GqlCategoryV2Gql>>>;
  total_products: Maybe<Scalars['Int']>;
  total_regions: Maybe<Scalars['Int']>;
};

export type GqlBinNameGql = {
  __typename?: 'BinNameGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  bin_name_id: Scalars['String'];
  bin_id: Scalars['String'];
  aisle: Scalars['String'];
  level: Scalars['String'];
  bin_position: Scalars['String'];
  bin_name_direction: GqlBinNameDirection;
  bin: Maybe<GqlBinGql>;
};

/** An enumeration. */
export enum GqlBinNameDirection {
  In = 'IN',
  Out = 'OUT',
  Both = 'BOTH'
}

export type GqlWasteAreaGql = {
  __typename?: 'WasteAreaGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  waste_area_id: Scalars['String'];
  waste_area_number: Scalars['String'];
  warehouse_id: Scalars['String'];
  storage_location_id: Scalars['String'];
  storage_location: Maybe<GqlStorageLocationGql>;
  warehouse: Maybe<GqlWarehouseGql>;
  storage: Maybe<GqlStorageLocationGql>;
};

export type GqlProductTransferHandlingUnitItemGql = {
  __typename?: 'ProductTransferHandlingUnitItemGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_transfer_handling_unit_item_id: Scalars['String'];
  product_transfer_id: Scalars['String'];
  handling_unit_item_id: Scalars['String'];
  product_transfer: Maybe<GqlProductTransferGql>;
  handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
};

export type GqlProductTransferGql = {
  __typename?: 'ProductTransferGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_transfer_id: Scalars['String'];
  datetime: Scalars['DateTime'];
  product_transfer_reason_id: Maybe<Scalars['String']>;
  product_transfer_type: GqlProductTransferType;
  product_transfer_number: Scalars['String'];
  origin_handling_unit_id: Maybe<Scalars['String']>;
  destination_handling_unit_id: Maybe<Scalars['String']>;
  origin_handling_unit_item_id: Maybe<Scalars['String']>;
  destination_handling_unit_item_id: Maybe<Scalars['String']>;
  origin_storage_location_id: Scalars['String'];
  destination_storage_location_id: Scalars['String'];
  distribution_center_id: Maybe<Scalars['String']>;
  product_transfer_reason: Maybe<GqlProductTransferReasonGql>;
  origin_handling_unit: Maybe<GqlHandlingUnitGql>;
  destination_handling_unit: Maybe<GqlHandlingUnitGql>;
  origin_handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
  destination_handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
  origin_storage_location: Maybe<GqlStorageLocationGql>;
  destination_storage_location: Maybe<GqlStorageLocationGql>;
  product_transfer_handling_units: Maybe<Array<Maybe<GqlProductTransferHandlingUnitGql>>>;
  product_transfer_handling_unit_items: Maybe<Array<Maybe<GqlProductTransferHandlingUnitItemGql>>>;
};

/** An enumeration. */
export enum GqlProductTransferType {
  HandlingUnitTransfer = 'HANDLING_UNIT_TRANSFER',
  ProductTransfer = 'PRODUCT_TRANSFER',
  LocationTransfer = 'LOCATION_TRANSFER'
}

export type GqlProductTransferReasonGql = {
  __typename?: 'ProductTransferReasonGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_transfer_reason_id: Scalars['String'];
  product_transfer_reason_name: Scalars['String'];
  product_transfers: Maybe<Array<Maybe<GqlProductTransferGql>>>;
};

export type GqlProductTransferHandlingUnitGql = {
  __typename?: 'ProductTransferHandlingUnitGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_transfer_handling_unit_id: Scalars['String'];
  product_transfer_id: Scalars['String'];
  handling_unit_id: Scalars['String'];
  product_transfer: Maybe<GqlProductTransferGql>;
  handling_unit: Maybe<GqlHandlingUnitGql>;
};

export type GqlAssetTrackerItemGql = {
  __typename?: 'AssetTrackerItemGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_tracker_item_id: Scalars['String'];
  asset_tracker_id: Scalars['String'];
  asset_id: Scalars['String'];
  asset_tracker: Maybe<GqlAssetTrackerGql>;
  asset: Maybe<GqlAssetGql>;
};

export type GqlAssetTrackerGql = {
  __typename?: 'AssetTrackerGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_tracker_id: Scalars['String'];
  origin_id: Scalars['String'];
  destination_id: Scalars['String'];
  asset_tracker_number: Scalars['String'];
  asset_tracker_reason: GqlAssetTrackerReason;
  expected_final_destination_id: Maybe<Scalars['String']>;
  origin: Maybe<GqlInventoryLocationGql>;
  destination: Maybe<GqlInventoryLocationGql>;
  asset_tracker_items: Maybe<Array<Maybe<GqlAssetTrackerItemGql>>>;
  damaged_asset_photos: Maybe<Array<Maybe<GqlDamagedAssetPhotoGql>>>;
  expected_final_destination: Maybe<GqlInventoryLocationGql>;
  quantity: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GqlAssetTrackerReason {
  WarehouseTransfer = 'WAREHOUSE_TRANSFER',
  RepairAndMaintenance = 'REPAIR_AND_MAINTENANCE',
  Sourcing = 'SOURCING',
  Production = 'PRODUCTION',
  Disposal = 'DISPOSAL',
  Dispatch = 'DISPATCH',
  CrateCount = 'CRATE_COUNT'
}

export type GqlInventoryLocationGql = {
  __typename?: 'InventoryLocationGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  inventory_location_id: Scalars['String'];
  inventory_location_name: Scalars['String'];
  inventory_location_type: Maybe<Scalars['String']>;
  asset_tracker_origin: Maybe<Array<Maybe<GqlAssetTrackerGql>>>;
  asset_tracker_destination: Maybe<Array<Maybe<GqlAssetTrackerGql>>>;
  asset_tracker_expected_final_destination: Maybe<Array<Maybe<GqlAssetTrackerGql>>>;
};

export type GqlDamagedAssetPhotoGql = {
  __typename?: 'DamagedAssetPhotoGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_photo_id: Scalars['String'];
  asset_tracker_id: Scalars['String'];
  file_name: Scalars['String'];
  asset_tracker: Maybe<GqlAssetTrackerGql>;
  signed_url: Maybe<Scalars['String']>;
};

export type GqlPickingHandlingUnitGql = {
  __typename?: 'PickingHandlingUnitGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  picking_hu_id: Scalars['String'];
  dispatch_reference_id: Scalars['String'];
  handling_unit_id: Scalars['String'];
  is_complete: Scalars['Boolean'];
  final_location_id: Maybe<Scalars['String']>;
  final_location: Maybe<GqlStorageLocationGql>;
  picked_labels: Maybe<Array<Maybe<GqlPickFacePickingTaskItemGql>>>;
  handling_unit: Maybe<GqlHandlingUnitGql>;
  picked_quantity: Maybe<Scalars['Int']>;
};

export type GqlPickFacePickingTaskItemGql = {
  __typename?: 'PickFacePickingTaskItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  task_item_id: Scalars['String'];
  picking_task_id: Scalars['String'];
  source_handling_unit_id: Scalars['String'];
  handling_unit_item_id: Scalars['String'];
  picking_hu_id: Maybe<Scalars['String']>;
  picking_task: Maybe<GqlPickFacePickingTaskGql>;
  source_handling_unit: Maybe<GqlHandlingUnitGql>;
  handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
  picking_hu: Maybe<GqlPickingHandlingUnitGql>;
};

export type GqlPickFacePickingTaskGql = {
  __typename?: 'PickFacePickingTaskGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  task_id: Scalars['String'];
  fdr_id: Maybe<Scalars['String']>;
  warehouse_transfer_request_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  quantity: Scalars['Int'];
  source_location_id: Scalars['String'];
  fdr: Maybe<GqlFulfilmentDispatchRequestGql>;
  warehouse_transfer_request: Maybe<GqlWarehouseTransferRequestGql>;
  source_location: Maybe<GqlStorageLocationGql>;
  task_items: Maybe<Array<Maybe<GqlPickFacePickingTaskItemGql>>>;
  balance: Maybe<Scalars['Int']>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlFulfilmentDispatchRequestGql = {
  __typename?: 'FulfilmentDispatchRequestGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  fdr_id: Scalars['String'];
  fdr_number: Scalars['String'];
  sale_date: Scalars['String'];
  vehicle_registration_number: Maybe<Scalars['String']>;
  product_types: Array<Maybe<Scalars['String']>>;
  dock_door_id: Scalars['String'];
  order_time_start: Scalars['DateTime'];
  order_time_end: Scalars['DateTime'];
  depot_ids: Maybe<Array<Maybe<Scalars['String']>>>;
  fdr_complete: Scalars['Boolean'];
  distribution_center_id: Maybe<Scalars['String']>;
  dock_door: Maybe<GqlDockDoorGql>;
  fdr_items: Maybe<Array<Maybe<GqlFulfilmentDispatchRequestItemGql>>>;
  fdr_skus: Maybe<Array<Maybe<GqlFdrskugql>>>;
  reserve_picking_jobs: Maybe<Array<Maybe<GqlReservePickingJobGql>>>;
  pickface_picking_tasks: Maybe<Array<Maybe<GqlPickFacePickingTaskGql>>>;
  loading_task: Maybe<GqlLoadingTaskGql>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
  reserve_picking_balance: Maybe<Array<Maybe<GqlReservePickingBalanceGql>>>;
  created_by_user: Maybe<GqlUserV2Gql>;
};

export type GqlFulfilmentDispatchRequestItemGql = {
  __typename?: 'FulfilmentDispatchRequestItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  fdr_item_id: Scalars['String'];
  fdr_id: Scalars['String'];
  route_id: Maybe<Scalars['String']>;
  route_plan_id: Maybe<Scalars['String']>;
  fdr: Maybe<GqlFulfilmentDispatchRequestGql>;
  route_plan: Maybe<GqlRoutePlanGql>;
  route: Maybe<GqlRouteV2Gql>;
};

export type GqlFdrskugql = {
  __typename?: 'FDRSKUGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  fdr_sku_id: Scalars['String'];
  fdr_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Int'];
  available_stock: Scalars['Int'];
  amount_planned_from_reserve: Scalars['Int'];
  amount_planned_from_pickface: Scalars['Int'];
  fdr: Maybe<GqlFulfilmentDispatchRequestGql>;
  inventory_balance: Maybe<Scalars['Int']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  loaded_quantity: Maybe<Scalars['Int']>;
};

export type GqlReservePickingJobGql = {
  __typename?: 'ReservePickingJobGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  job_id: Scalars['String'];
  job_number: Scalars['String'];
  assigned_to: Maybe<Scalars['String']>;
  job_status: Maybe<Scalars['String']>;
  start_time: Maybe<Scalars['DateTime']>;
  close_time: Maybe<Scalars['DateTime']>;
  fdr_id: Maybe<Scalars['String']>;
  warehouse_transfer_request_id: Maybe<Scalars['String']>;
  pickface_id: Maybe<Scalars['String']>;
  source_location_id: Scalars['String'];
  product_item_id: Scalars['String'];
  destination_location_id: Scalars['String'];
  handling_unit_id: Scalars['String'];
  quantity: Scalars['Int'];
  job_type: GqlReserveJobType;
  fdr: Maybe<GqlFulfilmentDispatchRequestGql>;
  warehouse_transfer_request: Maybe<GqlWarehouseTransferRequestGql>;
  pickface: Maybe<GqlStorageLocationGql>;
  source_location: Maybe<GqlStorageLocationGql>;
  destination_location: Maybe<GqlStorageLocationGql>;
  handling_unit: Maybe<GqlHandlingUnitGql>;
  assigned: Maybe<GqlUserV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

/** An enumeration. */
export enum GqlReserveJobType {
  Letdown = 'LETDOWN',
  Dispatch = 'DISPATCH',
  Disposal = 'DISPOSAL'
}

export type GqlWarehouseTransferRequestGql = {
  __typename?: 'WarehouseTransferRequestGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warehouse_transfer_request_id: Scalars['String'];
  warehouse_transfer_request_number: Scalars['String'];
  vehicle_id: Maybe<Scalars['String']>;
  destination_dc_id: Scalars['String'];
  dock_door_id: Scalars['String'];
  warehouse_transfer_request_complete: Scalars['Boolean'];
  destination_dc: Maybe<GqlDistributionCenterGql>;
  dock_door: Maybe<GqlDockDoorGql>;
  warehouse_transfer_request_items: Maybe<Array<Maybe<GqlWarehouseTransferRequestItemGql>>>;
  reserve_picking_jobs: Maybe<Array<Maybe<GqlReservePickingJobGql>>>;
  pickface_picking_tasks: Maybe<Array<Maybe<GqlPickFacePickingTaskGql>>>;
  loading_task: Maybe<Array<Maybe<GqlLoadingTaskGql>>>;
  reserve_picking_balance: Maybe<Array<Maybe<GqlReservePickingBalanceGql>>>;
  vehicle: Maybe<GqlVehicleGql>;
};

export type GqlWarehouseTransferRequestItemGql = {
  __typename?: 'WarehouseTransferRequestItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  warehouse_transfer_request_item_id: Scalars['String'];
  warehouse_transfer_request_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Int'];
  warehouse_transfer_request: Maybe<GqlWarehouseTransferRequestGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  loaded_quantity: Maybe<Scalars['Int']>;
};

export type GqlLoadingTaskGql = {
  __typename?: 'LoadingTaskGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  loading_task_id: Scalars['String'];
  loading_number: Maybe<Scalars['String']>;
  inventory_location_id: Scalars['String'];
  picture: Maybe<Scalars['String']>;
  fdr_id: Maybe<Scalars['String']>;
  warehouse_transfer_request_id: Maybe<Scalars['String']>;
  disposal_id: Maybe<Scalars['String']>;
  status: GqlJobStatus;
  inventory_location: Maybe<GqlInventoryLocationGql>;
  fdr: Maybe<GqlFulfilmentDispatchRequestGql>;
  warehouse_transfer_request: Maybe<GqlWarehouseTransferRequestGql>;
  disposal: Maybe<GqlDisposalGql>;
  loading_task_items: Maybe<Array<Maybe<GqlLoadingTaskItemGql>>>;
  loaded_weight: Maybe<Scalars['Int']>;
  created_by_user: Maybe<GqlUserV2Gql>;
  loaded_quantity: Maybe<Array<Maybe<GqlLoadedQuantityGql>>>;
  total_loaded_quantity: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GqlJobStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Inprogress = 'INPROGRESS'
}

export type GqlDisposalGql = {
  __typename?: 'DisposalGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  disposal_id: Scalars['String'];
  disposal_number: Scalars['String'];
  dock_door_id: Scalars['String'];
  disposal_complete: Scalars['Boolean'];
  dock_door: Maybe<GqlDockDoorGql>;
  disposal_items: Maybe<Array<Maybe<GqlDisposalItemGql>>>;
  loading_task: Maybe<Array<Maybe<GqlLoadingTaskGql>>>;
};

export type GqlDisposalItemGql = {
  __typename?: 'DisposalItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  disposal_item_id: Scalars['String'];
  disposal_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Int'];
  disposal: Maybe<GqlDisposalGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  loaded_quantity: Maybe<Scalars['Int']>;
};

export type GqlLoadingTaskItemGql = {
  __typename?: 'LoadingTaskItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  task_item_id: Scalars['String'];
  loading_task_id: Scalars['String'];
  handling_unit_item_id: Scalars['String'];
  source_handling_unit_id: Scalars['String'];
  loading_task: Maybe<GqlLoadingTaskGql>;
  handling_unit_item: Maybe<GqlHandlingUnitItemGql>;
  source_handling_unit: Maybe<GqlHandlingUnitGql>;
};

export type GqlLoadedQuantityGql = {
  __typename?: 'LoadedQuantityGQL';
  quantity: Maybe<Scalars['Int']>;
  product_item_id: Maybe<Scalars['String']>;
};

export type GqlReservePickingBalanceGql = {
  __typename?: 'ReservePickingBalanceGQL';
  balance: Maybe<Scalars['Int']>;
  product_item_id: Maybe<Scalars['String']>;
};

export type GqlReturnsHandlingUnitGqlConnection = {
  __typename?: 'ReturnsHandlingUnitGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlReturnsHandlingUnitGqlEdge>>;
};

/** A Relay edge containing a `ReturnsHandlingUnitGQL` and its cursor. */
export type GqlReturnsHandlingUnitGqlEdge = {
  __typename?: 'ReturnsHandlingUnitGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlReturnsHandlingUnitGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWmsReturnsGqlConnection = {
  __typename?: 'WMSReturnsGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWmsReturnsGqlEdge>>;
};

/** A Relay edge containing a `WMSReturnsGQL` and its cursor. */
export type GqlWmsReturnsGqlEdge = {
  __typename?: 'WMSReturnsGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWmsReturnsGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDisposalItemGqlConnection = {
  __typename?: 'DisposalItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDisposalItemGqlEdge>>;
};

/** A Relay edge containing a `DisposalItemGQL` and its cursor. */
export type GqlDisposalItemGqlEdge = {
  __typename?: 'DisposalItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDisposalItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDisposalGqlConnection = {
  __typename?: 'DisposalGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDisposalGqlEdge>>;
};

/** A Relay edge containing a `DisposalGQL` and its cursor. */
export type GqlDisposalGqlEdge = {
  __typename?: 'DisposalGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDisposalGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWarehouseTransferRequestItemGqlConnection = {
  __typename?: 'WarehouseTransferRequestItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseTransferRequestItemGqlEdge>>;
};

/** A Relay edge containing a `WarehouseTransferRequestItemGQL` and its cursor. */
export type GqlWarehouseTransferRequestItemGqlEdge = {
  __typename?: 'WarehouseTransferRequestItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseTransferRequestItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWarehouseTransferRequestGqlConnection = {
  __typename?: 'WarehouseTransferRequestGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseTransferRequestGqlEdge>>;
};

/** A Relay edge containing a `WarehouseTransferRequestGQL` and its cursor. */
export type GqlWarehouseTransferRequestGqlEdge = {
  __typename?: 'WarehouseTransferRequestGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseTransferRequestGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlFdrskugqlConnection = {
  __typename?: 'FDRSKUGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFdrskugqlEdge>>;
};

/** A Relay edge containing a `FDRSKUGQL` and its cursor. */
export type GqlFdrskugqlEdge = {
  __typename?: 'FDRSKUGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFdrskugql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlFulfilmentDispatchRequestItemGqlConnection = {
  __typename?: 'FulfilmentDispatchRequestItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFulfilmentDispatchRequestItemGqlEdge>>;
};

/** A Relay edge containing a `FulfilmentDispatchRequestItemGQL` and its cursor. */
export type GqlFulfilmentDispatchRequestItemGqlEdge = {
  __typename?: 'FulfilmentDispatchRequestItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFulfilmentDispatchRequestItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlFulfilmentDispatchRequestGqlConnection = {
  __typename?: 'FulfilmentDispatchRequestGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFulfilmentDispatchRequestGqlEdge>>;
};

/** A Relay edge containing a `FulfilmentDispatchRequestGQL` and its cursor. */
export type GqlFulfilmentDispatchRequestGqlEdge = {
  __typename?: 'FulfilmentDispatchRequestGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFulfilmentDispatchRequestGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlReservePickingJobGqlConnection = {
  __typename?: 'ReservePickingJobGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlReservePickingJobGqlEdge>>;
};

/** A Relay edge containing a `ReservePickingJobGQL` and its cursor. */
export type GqlReservePickingJobGqlEdge = {
  __typename?: 'ReservePickingJobGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlReservePickingJobGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPickFacePickingTaskGqlConnection = {
  __typename?: 'PickFacePickingTaskGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPickFacePickingTaskGqlEdge>>;
};

/** A Relay edge containing a `PickFacePickingTaskGQL` and its cursor. */
export type GqlPickFacePickingTaskGqlEdge = {
  __typename?: 'PickFacePickingTaskGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPickFacePickingTaskGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPickingHandlingUnitGqlConnection = {
  __typename?: 'PickingHandlingUnitGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPickingHandlingUnitGqlEdge>>;
};

/** A Relay edge containing a `PickingHandlingUnitGQL` and its cursor. */
export type GqlPickingHandlingUnitGqlEdge = {
  __typename?: 'PickingHandlingUnitGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPickingHandlingUnitGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPickFacePickingTaskItemGqlConnection = {
  __typename?: 'PickFacePickingTaskItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPickFacePickingTaskItemGqlEdge>>;
};

/** A Relay edge containing a `PickFacePickingTaskItemGQL` and its cursor. */
export type GqlPickFacePickingTaskItemGqlEdge = {
  __typename?: 'PickFacePickingTaskItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPickFacePickingTaskItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlLoadingTaskGqlConnection = {
  __typename?: 'LoadingTaskGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlLoadingTaskGqlEdge>>;
};

/** A Relay edge containing a `LoadingTaskGQL` and its cursor. */
export type GqlLoadingTaskGqlEdge = {
  __typename?: 'LoadingTaskGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLoadingTaskGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlLoadingTaskItemGqlConnection = {
  __typename?: 'LoadingTaskItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlLoadingTaskItemGqlEdge>>;
};

/** A Relay edge containing a `LoadingTaskItemGQL` and its cursor. */
export type GqlLoadingTaskItemGqlEdge = {
  __typename?: 'LoadingTaskItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlLoadingTaskItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPutAwayJobGqlConnection = {
  __typename?: 'PutAwayJobGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPutAwayJobGqlEdge>>;
};

/** A Relay edge containing a `PutAwayJobGQL` and its cursor. */
export type GqlPutAwayJobGqlEdge = {
  __typename?: 'PutAwayJobGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPutAwayJobGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPutAwayJobGql = {
  __typename?: 'PutAwayJobGQL';
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  job_id: Scalars['String'];
  job_number: Scalars['String'];
  assigned_to: Maybe<Scalars['String']>;
  job_status: Maybe<Scalars['String']>;
  start_time: Maybe<Scalars['DateTime']>;
  close_time: Maybe<Scalars['DateTime']>;
  batch_id: Maybe<Scalars['String']>;
  stock_intake_id: Maybe<Scalars['String']>;
  stock_intake_item_id: Maybe<Scalars['String']>;
  source_location_id: Scalars['String'];
  destination_location_id: Scalars['String'];
  source_handling_unit_id: Scalars['String'];
  destination_handling_unit_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  stock_intake: Maybe<GqlStockIntakeGql>;
  stock_intake_item: Maybe<GqlStockIntakeItemGql>;
  source_location: Maybe<GqlStorageLocationGql>;
  destination_location: Maybe<GqlStorageLocationGql>;
  source_handling_unit: Maybe<GqlHandlingUnitGql>;
  destination_handling_unit: Maybe<GqlHandlingUnitGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  assigned: Maybe<GqlUserV2Gql>;
  batch: Maybe<GqlBatchGql>;
};

export type GqlProductZoneGqlConnection = {
  __typename?: 'ProductZoneGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductZoneGqlEdge>>;
};

/** A Relay edge containing a `ProductZoneGQL` and its cursor. */
export type GqlProductZoneGqlEdge = {
  __typename?: 'ProductZoneGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductZoneGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlRuleGqlConnection = {
  __typename?: 'RuleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRuleGqlEdge>>;
};

/** A Relay edge containing a `RuleGQL` and its cursor. */
export type GqlRuleGqlEdge = {
  __typename?: 'RuleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRuleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductRuleGqlConnection = {
  __typename?: 'ProductRuleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductRuleGqlEdge>>;
};

/** A Relay edge containing a `ProductRuleGQL` and its cursor. */
export type GqlProductRuleGqlEdge = {
  __typename?: 'ProductRuleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductRuleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlCategoryRuleGqlConnection = {
  __typename?: 'CategoryRuleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlCategoryRuleGqlEdge>>;
};

/** A Relay edge containing a `CategoryRuleGQL` and its cursor. */
export type GqlCategoryRuleGqlEdge = {
  __typename?: 'CategoryRuleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlCategoryRuleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlHandlingUnitGqlConnection = {
  __typename?: 'HandlingUnitGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlHandlingUnitGqlEdge>>;
};

/** A Relay edge containing a `HandlingUnitGQL` and its cursor. */
export type GqlHandlingUnitGqlEdge = {
  __typename?: 'HandlingUnitGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlHandlingUnitGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockIntakeSkuGqlConnection = {
  __typename?: 'StockIntakeSkuGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockIntakeSkuGqlEdge>>;
};

/** A Relay edge containing a `StockIntakeSkuGQL` and its cursor. */
export type GqlStockIntakeSkuGqlEdge = {
  __typename?: 'StockIntakeSkuGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockIntakeSkuGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlHandlingUnitItemGqlConnection = {
  __typename?: 'HandlingUnitItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlHandlingUnitItemGqlEdge>>;
};

/** A Relay edge containing a `HandlingUnitItemGQL` and its cursor. */
export type GqlHandlingUnitItemGqlEdge = {
  __typename?: 'HandlingUnitItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlHandlingUnitItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStorageLocationGqlConnection = {
  __typename?: 'StorageLocationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStorageLocationGqlEdge>>;
};

/** A Relay edge containing a `StorageLocationGQL` and its cursor. */
export type GqlStorageLocationGqlEdge = {
  __typename?: 'StorageLocationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStorageLocationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStorageLocationTypeGqlConnection = {
  __typename?: 'StorageLocationTypeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStorageLocationTypeGqlEdge>>;
};

/** A Relay edge containing a `StorageLocationTypeGQL` and its cursor. */
export type GqlStorageLocationTypeGqlEdge = {
  __typename?: 'StorageLocationTypeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStorageLocationTypeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductLossReasonGqlConnection = {
  __typename?: 'ProductLossReasonGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductLossReasonGqlEdge>>;
};

/** A Relay edge containing a `ProductLossReasonGQL` and its cursor. */
export type GqlProductLossReasonGqlEdge = {
  __typename?: 'ProductLossReasonGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductLossReasonGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDockDoorGqlConnection = {
  __typename?: 'DockDoorGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDockDoorGqlEdge>>;
};

/** A Relay edge containing a `DockDoorGQL` and its cursor. */
export type GqlDockDoorGqlEdge = {
  __typename?: 'DockDoorGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDockDoorGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlCustomBinGql = {
  __typename?: 'CustomBinGQL';
  bin_id: Maybe<Scalars['String']>;
  storage_location_id: Maybe<Scalars['String']>;
  aisle: Maybe<Scalars['String']>;
  bin_position: Maybe<Scalars['String']>;
  level: Maybe<Scalars['String']>;
};

export type GqlBinGqlConnection = {
  __typename?: 'BinGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBinGqlEdge>>;
};

/** A Relay edge containing a `BinGQL` and its cursor. */
export type GqlBinGqlEdge = {
  __typename?: 'BinGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBinGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBinNameGqlConnection = {
  __typename?: 'BinNameGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBinNameGqlEdge>>;
};

/** A Relay edge containing a `BinNameGQL` and its cursor. */
export type GqlBinNameGqlEdge = {
  __typename?: 'BinNameGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBinNameGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWasteAreaGqlConnection = {
  __typename?: 'WasteAreaGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWasteAreaGqlEdge>>;
};

/** A Relay edge containing a `WasteAreaGQL` and its cursor. */
export type GqlWasteAreaGqlEdge = {
  __typename?: 'WasteAreaGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWasteAreaGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAppointmentItemGqlConnection = {
  __typename?: 'AppointmentItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAppointmentItemGqlEdge>>;
};

/** A Relay edge containing a `AppointmentItemGQL` and its cursor. */
export type GqlAppointmentItemGqlEdge = {
  __typename?: 'AppointmentItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAppointmentItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAppointmentGqlConnection = {
  __typename?: 'AppointmentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAppointmentGqlEdge>>;
};

/** A Relay edge containing a `AppointmentGQL` and its cursor. */
export type GqlAppointmentGqlEdge = {
  __typename?: 'AppointmentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAppointmentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWarehouseGqlConnection = {
  __typename?: 'WarehouseGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseGqlEdge>>;
};

/** A Relay edge containing a `WarehouseGQL` and its cursor. */
export type GqlWarehouseGqlEdge = {
  __typename?: 'WarehouseGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockIntakeGqlConnection = {
  __typename?: 'StockIntakeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockIntakeGqlEdge>>;
};

/** A Relay edge containing a `StockIntakeGQL` and its cursor. */
export type GqlStockIntakeGqlEdge = {
  __typename?: 'StockIntakeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockIntakeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockIntakeItemGqlConnection = {
  __typename?: 'StockIntakeItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockIntakeItemGqlEdge>>;
};

/** A Relay edge containing a `StockIntakeItemGQL` and its cursor. */
export type GqlStockIntakeItemGqlEdge = {
  __typename?: 'StockIntakeItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockIntakeItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockIntakeItemBatchGql = {
  __typename?: 'StockIntakeItemBatchGQL';
  batch_id: Scalars['String'];
  stock_intake_items: Maybe<Array<Maybe<GqlStockIntakeItemGql>>>;
};

export type GqlProcessingLossGqlConnection = {
  __typename?: 'ProcessingLossGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProcessingLossGqlEdge>>;
};

/** A Relay edge containing a `ProcessingLossGQL` and its cursor. */
export type GqlProcessingLossGqlEdge = {
  __typename?: 'ProcessingLossGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProcessingLossGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProcessingLossItemGqlConnection = {
  __typename?: 'ProcessingLossItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProcessingLossItemGqlEdge>>;
};

/** A Relay edge containing a `ProcessingLossItemGQL` and its cursor. */
export type GqlProcessingLossItemGqlEdge = {
  __typename?: 'ProcessingLossItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProcessingLossItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStorageUnitGqlConnection = {
  __typename?: 'StorageUnitGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStorageUnitGqlEdge>>;
};

/** A Relay edge containing a `StorageUnitGQL` and its cursor. */
export type GqlStorageUnitGqlEdge = {
  __typename?: 'StorageUnitGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStorageUnitGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStorageGqlConnection = {
  __typename?: 'StorageGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStorageGqlEdge>>;
};

/** A Relay edge containing a `StorageGQL` and its cursor. */
export type GqlStorageGqlEdge = {
  __typename?: 'StorageGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStorageGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockAvailabilityGqlConnection = {
  __typename?: 'StockAvailabilityGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockAvailabilityGqlEdge>>;
};

/** A Relay edge containing a `StockAvailabilityGQL` and its cursor. */
export type GqlStockAvailabilityGqlEdge = {
  __typename?: 'StockAvailabilityGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockAvailabilityGqLv2>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockAvailabilitySummaryGqlConnection = {
  __typename?: 'StockAvailabilitySummaryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockAvailabilitySummaryGqlEdge>>;
};

/** A Relay edge containing a `StockAvailabilitySummaryGQL` and its cursor. */
export type GqlStockAvailabilitySummaryGqlEdge = {
  __typename?: 'StockAvailabilitySummaryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockAvailabilitySummaryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockAvailabilitySummaryGql = {
  __typename?: 'StockAvailabilitySummaryGQL';
  sale_date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Float']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  product_item_uom: Maybe<GqlProductItemUomv2Gql>;
};

/** ProductItemUOM GQL Schema */
export type GqlProductItemUomv2Gql = {
  __typename?: 'ProductItemUOMV2GQL';
  product_item_uom_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_item_id: Scalars['String'];
  uom_id: Scalars['String'];
  business_domain_id: Scalars['String'];
  conversion_ratio: Scalars['Float'];
  uom: Maybe<GqlUomv2Gql>;
  business_domain: Maybe<GqlBusinessDomainV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlStockAvailabilityProductItemGqlConnection = {
  __typename?: 'StockAvailabilityProductItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockAvailabilityProductItemGqlEdge>>;
};

/** A Relay edge containing a `StockAvailabilityProductItemGQL` and its cursor. */
export type GqlStockAvailabilityProductItemGqlEdge = {
  __typename?: 'StockAvailabilityProductItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockAvailabilityProductItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockAvailabilityProductItemGql = {
  __typename?: 'StockAvailabilityProductItemGQL';
  product_item_id: Maybe<Scalars['UUID']>;
  product_item_name: Maybe<Scalars['String']>;
  product_id: Maybe<Scalars['UUID']>;
  date_created: Maybe<Scalars['Date']>;
  created_by: Maybe<Scalars['String']>;
  date_updated: Maybe<Scalars['Date']>;
  updated_by: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
  stock_availability: Maybe<GqlStockAvailabilityGqLv2>;
  product_item: Maybe<GqlProductItemV2Gql>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlDcStockAvailabilityGql = {
  __typename?: 'DCStockAvailabilityGQL';
  product_item_id: Scalars['String'];
  quantity: Maybe<Scalars['Float']>;
  distribution_center_ids: Array<Maybe<Scalars['String']>>;
  depot_id: Scalars['String'];
};

export type GqlProcessingLossTypeGqlConnection = {
  __typename?: 'ProcessingLossTypeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProcessingLossTypeGqlEdge>>;
};

/** A Relay edge containing a `ProcessingLossTypeGQL` and its cursor. */
export type GqlProcessingLossTypeGqlEdge = {
  __typename?: 'ProcessingLossTypeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProcessingLossTypeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlInventoryGql = {
  __typename?: 'InventoryGQL';
  storage_quantity: Maybe<Scalars['Float']>;
  storage_weight: Maybe<Scalars['Float']>;
  packaging_unit_quantity: Maybe<Scalars['Float']>;
  inventory_quantity: Maybe<Scalars['Float']>;
  verified_quantity: Maybe<Scalars['Float']>;
  distribution_center_id: Scalars['String'];
  stock_take_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  date: Maybe<Scalars['String']>;
};

export type GqlDistributionCenterGqlConnection = {
  __typename?: 'DistributionCenterGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDistributionCenterGqlEdge>>;
};

/** A Relay edge containing a `DistributionCenterGQL` and its cursor. */
export type GqlDistributionCenterGqlEdge = {
  __typename?: 'DistributionCenterGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDistributionCenterGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockTakeGqlConnection = {
  __typename?: 'StockTakeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockTakeGqlEdge>>;
};

/** A Relay edge containing a `StockTakeGQL` and its cursor. */
export type GqlStockTakeGqlEdge = {
  __typename?: 'StockTakeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockTakeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockTakeLocationGqlConnection = {
  __typename?: 'StockTakeLocationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockTakeLocationGqlEdge>>;
};

/** A Relay edge containing a `StockTakeLocationGQL` and its cursor. */
export type GqlStockTakeLocationGqlEdge = {
  __typename?: 'StockTakeLocationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockTakeLocationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockTakeLocationGql = {
  __typename?: 'StockTakeLocationGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  stock_take_location_id: Scalars['String'];
  date: Scalars['String'];
  product_item_id: Scalars['String'];
  expected_pallets: Scalars['Int'];
  expected_quantity: Scalars['Int'];
  actual_quantity: Scalars['Int'];
  storage_location_id: Scalars['String'];
  amended: Scalars['Boolean'];
  distribution_center_id: Maybe<Scalars['String']>;
  storage_location: Maybe<GqlStorageLocationGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlWarehouseTransferItemGqlConnection = {
  __typename?: 'WarehouseTransferItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseTransferItemGqlEdge>>;
};

/** A Relay edge containing a `WarehouseTransferItemGQL` and its cursor. */
export type GqlWarehouseTransferItemGqlEdge = {
  __typename?: 'WarehouseTransferItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseTransferItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWarehouseTransferReasonGqlConnection = {
  __typename?: 'WarehouseTransferReasonGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseTransferReasonGqlEdge>>;
};

/** A Relay edge containing a `WarehouseTransferReasonGQL` and its cursor. */
export type GqlWarehouseTransferReasonGqlEdge = {
  __typename?: 'WarehouseTransferReasonGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseTransferReasonGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlWarehouseTransferGqlConnection = {
  __typename?: 'WarehouseTransferGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlWarehouseTransferGqlEdge>>;
};

/** A Relay edge containing a `WarehouseTransferGQL` and its cursor. */
export type GqlWarehouseTransferGqlEdge = {
  __typename?: 'WarehouseTransferGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlWarehouseTransferGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetGqlConnection = {
  __typename?: 'AssetGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAssetGqlEdge>>;
};

/** A Relay edge containing a `AssetGQL` and its cursor. */
export type GqlAssetGqlEdge = {
  __typename?: 'AssetGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAssetGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetPhotoGqlConnection = {
  __typename?: 'AssetPhotoGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAssetPhotoGqlEdge>>;
};

/** A Relay edge containing a `AssetPhotoGQL` and its cursor. */
export type GqlAssetPhotoGqlEdge = {
  __typename?: 'AssetPhotoGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAssetPhotoGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDamagedAssetPhotoGqlConnection = {
  __typename?: 'DamagedAssetPhotoGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDamagedAssetPhotoGqlEdge>>;
};

/** A Relay edge containing a `DamagedAssetPhotoGQL` and its cursor. */
export type GqlDamagedAssetPhotoGqlEdge = {
  __typename?: 'DamagedAssetPhotoGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDamagedAssetPhotoGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetTrackerGqlConnection = {
  __typename?: 'AssetTrackerGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAssetTrackerGqlEdge>>;
};

/** A Relay edge containing a `AssetTrackerGQL` and its cursor. */
export type GqlAssetTrackerGqlEdge = {
  __typename?: 'AssetTrackerGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAssetTrackerGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetTrackerItemGqlConnection = {
  __typename?: 'AssetTrackerItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAssetTrackerItemGqlEdge>>;
};

/** A Relay edge containing a `AssetTrackerItemGQL` and its cursor. */
export type GqlAssetTrackerItemGqlEdge = {
  __typename?: 'AssetTrackerItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAssetTrackerItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlInventoryLocationGqlConnection = {
  __typename?: 'InventoryLocationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlInventoryLocationGqlEdge>>;
};

/** A Relay edge containing a `InventoryLocationGQL` and its cursor. */
export type GqlInventoryLocationGqlEdge = {
  __typename?: 'InventoryLocationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlInventoryLocationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetControlGqlConnection = {
  __typename?: 'AssetControlGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAssetControlGqlEdge>>;
};

/** A Relay edge containing a `AssetControlGQL` and its cursor. */
export type GqlAssetControlGqlEdge = {
  __typename?: 'AssetControlGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAssetControlGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAssetControlGql = {
  __typename?: 'AssetControlGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  asset_location_id: Scalars['String'];
  storage_location_id: Scalars['String'];
  storage: Maybe<GqlStorageLocationGql>;
};

export type GqlProductLocationGqlConnection = {
  __typename?: 'ProductLocationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductLocationGqlEdge>>;
};

/** A Relay edge containing a `ProductLocationGQL` and its cursor. */
export type GqlProductLocationGqlEdge = {
  __typename?: 'ProductLocationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductLocationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductLocationGql = {
  __typename?: 'ProductLocationGQL';
  storage_location_id: Maybe<Scalars['String']>;
  storage_location_number: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  hu_count: Maybe<Scalars['Float']>;
  hui_count: Maybe<Scalars['Float']>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlProductTransferReasonGqlConnection = {
  __typename?: 'ProductTransferReasonGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductTransferReasonGqlEdge>>;
};

/** A Relay edge containing a `ProductTransferReasonGQL` and its cursor. */
export type GqlProductTransferReasonGqlEdge = {
  __typename?: 'ProductTransferReasonGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductTransferReasonGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductTransferGqlConnection = {
  __typename?: 'ProductTransferGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductTransferGqlEdge>>;
};

/** A Relay edge containing a `ProductTransferGQL` and its cursor. */
export type GqlProductTransferGqlEdge = {
  __typename?: 'ProductTransferGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductTransferGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductTransferHandlingUnitGqlConnection = {
  __typename?: 'ProductTransferHandlingUnitGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductTransferHandlingUnitGqlEdge>>;
};

/** A Relay edge containing a `ProductTransferHandlingUnitGQL` and its cursor. */
export type GqlProductTransferHandlingUnitGqlEdge = {
  __typename?: 'ProductTransferHandlingUnitGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductTransferHandlingUnitGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductTransferHandlingUnitItemGqlConnection = {
  __typename?: 'ProductTransferHandlingUnitItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductTransferHandlingUnitItemGqlEdge>>;
};

/** A Relay edge containing a `ProductTransferHandlingUnitItemGQL` and its cursor. */
export type GqlProductTransferHandlingUnitItemGqlEdge = {
  __typename?: 'ProductTransferHandlingUnitItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductTransferHandlingUnitItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for ProductGQL */
export type GqlProductItemV2GqlConnection = {
  __typename?: 'ProductItemV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductItemV2GqlEdge>>;
};

/** A Relay edge containing a `ProductItemV2GQL` and its cursor. */
export type GqlProductItemV2GqlEdge = {
  __typename?: 'ProductItemV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductItemV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum GqlProductTypeEnum {
  Fmcg = 'FMCG',
  Ffv = 'FFV',
  Bundle = 'BUNDLE'
}

/** Department GQL schema */
export type GqlDepartmentV2Gql = {
  __typename?: 'DepartmentV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  department_id: Scalars['String'];
  department_name: Scalars['String'];
  slug: Scalars['String'];
  short_name: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  categories: Maybe<Array<Maybe<GqlCategoryV2Gql>>>;
};

/** CategoryRegion GQL schema */
export type GqlCategoryRegionV2Gql = {
  __typename?: 'CategoryRegionV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  category_region_id: Scalars['String'];
  category_id: Scalars['String'];
  region_id: Scalars['String'];
  region: Maybe<GqlRegionV2Gql>;
};

/** ProductDomainActivation GQL Schema */
export type GqlProductDomainActivationV2Gql = {
  __typename?: 'ProductDomainActivationV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_domain_activation_id: Scalars['String'];
  product_id: Scalars['String'];
  business_domain_id: Scalars['String'];
  business_domain: Maybe<GqlBusinessDomainV2Gql>;
};

/** Business Domain GQL Schema */
export type GqlBusinessDomainV2Gql = {
  __typename?: 'BusinessDomainV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  business_domain_id: Scalars['String'];
  domain_name: Scalars['String'];
};

export type GqlProductTagV2Gql = {
  __typename?: 'ProductTagV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_tag_id: Scalars['String'];
  product_tag: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlFinanceProductTypeGql = {
  __typename?: 'FinanceProductTypeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  id: Scalars['String'];
  name: Scalars['String'];
  standard_unit_costs: Maybe<Array<Maybe<GqlStandardUnitCostGql>>>;
};

export type GqlStandardUnitCostGql = {
  __typename?: 'StandardUnitCostGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  id: Scalars['String'];
  finance_product_type_id: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  start_date: Scalars['DateTime'];
  end_date: Maybe<Scalars['DateTime']>;
  finance_product_type: Maybe<GqlFinanceProductTypeGql>;
};

export type GqlPriceRangeGql = {
  __typename?: 'PriceRangeGQL';
  product_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  price_range_id: Scalars['String'];
  client_stamp: Scalars['String'];
  min_price: Scalars['Float'];
  max_price: Scalars['Float'];
  product: Maybe<GqlProductV2Gql>;
};

export type GqlProductItemSegmentV2Gql = {
  __typename?: 'ProductItemSegmentV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_item_segment_id: Scalars['String'];
  segment_name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
};

export type GqlPromotionTagGql = {
  __typename?: 'PromotionTagGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  country_id: Maybe<Scalars['String']>;
  promotion_tag_id: Scalars['String'];
  region_ids: Array<Maybe<Scalars['String']>>;
  product_item_id: Scalars['String'];
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
  promotion_type_id: Scalars['String'];
  product_item: Maybe<GqlProductItemV2Gql>;
  promotion_type: Maybe<GqlPromotionTypeGql>;
};

export type GqlPromotionTypeGql = {
  __typename?: 'PromotionTypeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  promotion_type_id: Scalars['String'];
  title: Scalars['String'];
  background_color: Scalars['String'];
  promotion_tags: Maybe<Array<Maybe<GqlPromotionTagGql>>>;
};

export type GqlDynamicPriceGql = {
  __typename?: 'DynamicPriceGQL';
  dynamic_price: Maybe<Scalars['Float']>;
  base_price: Maybe<Scalars['Float']>;
  previous_price: Maybe<Scalars['Float']>;
  discount_tag: Maybe<Scalars['Boolean']>;
  discount_value_type: Maybe<Scalars['String']>;
  discount_value: Maybe<Scalars['Float']>;
  markdown_display: Maybe<Scalars['String']>;
  markdown: Maybe<Scalars['Float']>;
  currency: Maybe<Scalars['String']>;
};

export type GqlProductItemRegionV2Gql = {
  __typename?: 'ProductItemRegionV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  product_item_region_id: Scalars['String'];
  product_item_id: Scalars['String'];
  region_id: Scalars['String'];
  business_domain_id: Scalars['String'];
  product_item: Maybe<GqlProductItemV2Gql>;
  business_domain: Maybe<GqlBusinessDomainV2Gql>;
  region: Maybe<GqlRegionV2Gql>;
};

export type GqlWhitelistedRoutesGql = {
  __typename?: 'WhitelistedRoutesGQL';
  route_id: Maybe<Scalars['String']>;
  route: Maybe<GqlRouteV2Gql>;
};

export type GqlBlacklistedRoutesGql = {
  __typename?: 'BlacklistedRoutesGQL';
  route_id: Maybe<Scalars['String']>;
  route: Maybe<GqlRouteV2Gql>;
};

export type GqlBasePriceGql = {
  __typename?: 'BasePriceGQL';
  base_price: Maybe<Scalars['Float']>;
  currency: Maybe<Scalars['String']>;
};

export type GqlBundleAssociationV2Gql = {
  __typename?: 'BundleAssociationV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  association_id: Scalars['String'];
  parent_product_item_id: Scalars['String'];
  child_product_item_id: Scalars['String'];
  expiry_date: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Float'];
  discount: Scalars['Float'];
  parent_sku: Maybe<GqlProductItemV2Gql>;
  child_sku: Maybe<GqlProductItemV2Gql>;
};

export type GqlProductPromotionalBannerV2Gql = {
  __typename?: 'ProductPromotionalBannerV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  banner_id: Scalars['String'];
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  banner_name: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  destination_url: Scalars['String'];
  featured: Scalars['Boolean'];
};

export type GqlUomv2GqlConnection = {
  __typename?: 'UOMV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlUomv2GqlEdge>>;
};

/** A Relay edge containing a `UOMV2GQL` and its cursor. */
export type GqlUomv2GqlEdge = {
  __typename?: 'UOMV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlUomv2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductItemUomv2GqlConnection = {
  __typename?: 'ProductItemUOMV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductItemUomv2GqlEdge>>;
};

/** A Relay edge containing a `ProductItemUOMV2GQL` and its cursor. */
export type GqlProductItemUomv2GqlEdge = {
  __typename?: 'ProductItemUOMV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductItemUomv2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for ProductGQL */
export type GqlProductV2GqlConnection = {
  __typename?: 'ProductV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductV2GqlEdge>>;
};

/** A Relay edge containing a `ProductV2GQL` and its cursor. */
export type GqlProductV2GqlEdge = {
  __typename?: 'ProductV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination connection for PackagingUnitV2GQL */
export type GqlPackagingUnitV2GqlConnection = {
  __typename?: 'PackagingUnitV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPackagingUnitV2GqlEdge>>;
};

/** A Relay edge containing a `PackagingUnitV2GQL` and its cursor. */
export type GqlPackagingUnitV2GqlEdge = {
  __typename?: 'PackagingUnitV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPackagingUnitV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductVarietyGqlConnection = {
  __typename?: 'ProductVarietyGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductVarietyGqlEdge>>;
};

/** A Relay edge containing a `ProductVarietyGQL` and its cursor. */
export type GqlProductVarietyGqlEdge = {
  __typename?: 'ProductVarietyGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductVarietyGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlProductVarietyGql = {
  __typename?: 'ProductVarietyGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  id: Scalars['String'];
  product_id: Scalars['String'];
  variety_name: Scalars['String'];
  variety_code: Scalars['String'];
};

export type GqlCreateProductPromotionalBanner = {
  __typename?: 'CreateProductPromotionalBanner';
  created: Maybe<Scalars['Boolean']>;
  product_promotional_banner: Maybe<GqlProductPromotionalBannerV2Gql>;
};

export type GqlProductPromotionalBannerInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  banner_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destination_url?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
};

export type GqlUploadProductPromotionalBannerImage = {
  __typename?: 'UploadProductPromotionalBannerImage';
  uploaded: Maybe<Scalars['Boolean']>;
  product_promotional_banner: Maybe<GqlProductPromotionalBannerV2Gql>;
};


export type GqlUpdateProductPromotionalBanner = {
  __typename?: 'UpdateProductPromotionalBanner';
  product_promotional_banner: Maybe<GqlProductPromotionalBannerV2Gql>;
};

export type GqlDeleteProductPromotionalBanner = {
  __typename?: 'DeleteProductPromotionalBanner';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePromotionTag = {
  __typename?: 'CreatePromotionTag';
  created: Maybe<Scalars['Boolean']>;
  promotion_tag: Maybe<GqlPromotionTagGql>;
};

export type GqlPromotionTagInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  region_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  product_item_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  promotion_type_id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['GenericScalar']>;
  country_id?: Maybe<Scalars['String']>;
};

export type GqlUpdatePromotionTag = {
  __typename?: 'UpdatePromotionTag';
  promotion_tag: Maybe<GqlPromotionTagGql>;
};

export type GqlDeletePromotionTag = {
  __typename?: 'DeletePromotionTag';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePromotionType = {
  __typename?: 'CreatePromotionType';
  created: Maybe<Scalars['Boolean']>;
  promotion_type: Maybe<GqlPromotionTypeGql>;
};

export type GqlPromotionTypeInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  promotion_type_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['String']>;
};

export type GqlUpdatePromotionType = {
  __typename?: 'UpdatePromotionType';
  promotion_type: Maybe<GqlPromotionTypeGql>;
};

export type GqlDeletePromotionType = {
  __typename?: 'DeletePromotionType';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateDepartment = {
  __typename?: 'CreateDepartment';
  created: Maybe<Scalars['Boolean']>;
  department: Maybe<GqlDepartmentV2Gql>;
};

export type GqlDepartmentInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  department_name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
};

export type GqlUpdateDepartment = {
  __typename?: 'UpdateDepartment';
  department: Maybe<GqlDepartmentV2Gql>;
};

export type GqlDeleteDepartment = {
  __typename?: 'DeleteDepartment';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateCategory = {
  __typename?: 'CreateCategory';
  created: Maybe<Scalars['Boolean']>;
  category: Maybe<GqlCategoryV2Gql>;
};

export type GqlCategoryInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  category_name?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  banner_image?: Maybe<Scalars['String']>;
  banner_image_url?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  parent_id?: Maybe<Scalars['String']>;
  ordering_window?: Maybe<Scalars['GenericScalar']>;
};

export type GqlUpdateCategory = {
  __typename?: 'UpdateCategory';
  category: Maybe<GqlCategoryV2Gql>;
};

export type GqlDeleteCategory = {
  __typename?: 'DeleteCategory';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateCategoryRegion = {
  __typename?: 'CreateCategoryRegion';
  created: Maybe<Scalars['Boolean']>;
  category_region: Maybe<GqlCategoryRegionV2Gql>;
};

export type GqlCategoryRegionInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  category_id?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateCategoryRegion = {
  __typename?: 'UpdateCategoryRegion';
  category_region: Maybe<GqlCategoryRegionV2Gql>;
};

export type GqlDeleteCategoryRegion = {
  __typename?: 'DeleteCategoryRegion';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlUploadCategoryImage = {
  __typename?: 'UploadCategoryImage';
  uploaded: Maybe<Scalars['Boolean']>;
  category: Maybe<GqlCategoryV2Gql>;
};

export type GqlUploadDepartmentImage = {
  __typename?: 'UploadDepartmentImage';
  uploaded: Maybe<Scalars['Boolean']>;
  department: Maybe<GqlDepartmentV2Gql>;
};

export type GqlCreateProductItem = {
  __typename?: 'CreateProductItem';
  created: Maybe<Scalars['Boolean']>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlProductItemInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_item_name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  staff_only?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  supplier_item?: Maybe<Scalars['Boolean']>;
  product_item_segment_id?: Maybe<Scalars['String']>;
  uoms?: Maybe<Array<Maybe<GqlProductItemUomInput>>>;
  regions?: Maybe<Array<Maybe<GqlProductItemRegionInput>>>;
  packed_weight?: Maybe<Scalars['Float']>;
  packed_volume?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  whitelisted_routes?: Maybe<Array<Maybe<Scalars['String']>>>;
  blacklisted_routes?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotion_tag?: Maybe<GqlPromotionTagInput>;
  upc_code?: Maybe<Scalars['String']>;
  wms_default_available?: Maybe<Scalars['Boolean']>;
  wms_pickface_putaway?: Maybe<Scalars['Boolean']>;
  wms_std_pallet_quantity?: Maybe<Scalars['Int']>;
  has_warranty?: Maybe<Scalars['Boolean']>;
};

export type GqlProductItemUomInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_item_id?: Maybe<Scalars['String']>;
  uom_id?: Maybe<Scalars['String']>;
  business_domain_id?: Maybe<Scalars['String']>;
  conversion_ratio?: Maybe<Scalars['Float']>;
};

export type GqlProductItemRegionInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  region_id?: Maybe<Scalars['String']>;
  product_item_id?: Maybe<Scalars['String']>;
  business_domain_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateProductItem = {
  __typename?: 'UpdateProductItem';
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlDeleteProductItem = {
  __typename?: 'DeleteProductItem';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlUploadProductItemImage = {
  __typename?: 'UploadProductItemImage';
  product_item: Maybe<GqlProductItemV2Gql>;
  uploaded: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProductItemRegion = {
  __typename?: 'CreateProductItemRegion';
  created: Maybe<Scalars['Boolean']>;
  product_item_region: Maybe<GqlProductItemRegionV2Gql>;
};

export type GqlUpdateProductItemRegion = {
  __typename?: 'UpdateProductItemRegion';
  product_item_region: Maybe<GqlProductItemRegionV2Gql>;
};

export type GqlDeleteProductItemRegion = {
  __typename?: 'DeleteProductItemRegion';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProductItemSegment = {
  __typename?: 'CreateProductItemSegment';
  created: Maybe<Scalars['Boolean']>;
  product_item_segment: Maybe<GqlProductItemSegmentV2Gql>;
};

export type GqlProductItemSegmentInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  segment_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
};

export type GqlUpdateProductItemSegment = {
  __typename?: 'UpdateProductItemSegment';
  product_item_segment: Maybe<GqlProductItemSegmentV2Gql>;
};

export type GqlDeleteProductItemSegment = {
  __typename?: 'DeleteProductItemSegment';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateBundleAssociation = {
  __typename?: 'CreateBundleAssociation';
  created: Maybe<Scalars['Boolean']>;
  bundle_association: Maybe<Array<Maybe<GqlBundleAssociationV2Gql>>>;
};

export type GqlBundleAssociationInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  parent_product_item_id?: Maybe<Scalars['String']>;
  child_product_item_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
  expiry_date?: Maybe<Scalars['DateTime']>;
};

export type GqlDeleteBundleAssociation = {
  __typename?: 'DeleteBundleAssociation';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateUom = {
  __typename?: 'CreateUom';
  created: Maybe<Scalars['Boolean']>;
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlUomInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type GqlUpdateUom = {
  __typename?: 'UpdateUom';
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlDeleteUom = {
  __typename?: 'DeleteUom';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProductItemUom = {
  __typename?: 'CreateProductItemUOM';
  created: Maybe<Scalars['Boolean']>;
  product_item_uom: Maybe<GqlProductItemUomv2Gql>;
};

export type GqlUpdateProductItemUom = {
  __typename?: 'UpdateProductItemUOM';
  product_item_uom: Maybe<GqlProductItemUomv2Gql>;
};

export type GqlDeleteProductItemUom = {
  __typename?: 'DeleteProductItemUom';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateBusinessDomain = {
  __typename?: 'CreateBusinessDomain';
  created: Maybe<Scalars['Boolean']>;
  business_domain: Maybe<GqlBusinessDomainV2Gql>;
};

export type GqlBusinessDomainInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  domain_name?: Maybe<Scalars['String']>;
};

export type GqlUpdateBusinessDomain = {
  __typename?: 'UpdateBusinessDomain';
  business_domain: Maybe<GqlBusinessDomainV2Gql>;
};

export type GqlDeleteBusinessDomain = {
  __typename?: 'DeleteBusinessDomain';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProductDomainActivation = {
  __typename?: 'CreateProductDomainActivation';
  created: Maybe<Scalars['Boolean']>;
  product_domain_activation: Maybe<GqlProductDomainActivationV2Gql>;
};

export type GqlProductDomainActivationInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_id?: Maybe<Scalars['String']>;
  business_domain_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateProductDomainActivation = {
  __typename?: 'UpdateProductDomainActivation';
  product_domain_activation: Maybe<GqlProductDomainActivationV2Gql>;
};

export type GqlDeleteProductDomainActivation = {
  __typename?: 'DeleteProductDomainActivation';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreatePackagingUnit = {
  __typename?: 'CreatePackagingUnit';
  created: Maybe<Scalars['Boolean']>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
};

export type GqlPackagingUnitInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  returnable?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};

export type GqlUpdatePackagingUnit = {
  __typename?: 'UpdatePackagingUnit';
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
};

export type GqlDeletePackagingUnit = {
  __typename?: 'DeletePackagingUnit';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProduct = {
  __typename?: 'CreateProduct';
  created: Maybe<Scalars['Boolean']>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlProductInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_name?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  hs_code?: Maybe<Scalars['String']>;
  product_description?: Maybe<Scalars['String']>;
  product_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  category_id?: Maybe<Scalars['String']>;
  vatable?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  product_type?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  business_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  packaging_units?: Maybe<Array<Maybe<Scalars['String']>>>;
  loss_reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  finance_product_type_id?: Maybe<Scalars['String']>;
  wms_shelf_life_days?: Maybe<Scalars['Int']>;
  kra_code?: Maybe<Scalars['String']>;
};

export type GqlUpdateProduct = {
  __typename?: 'UpdateProduct';
  product: Maybe<GqlProductV2Gql>;
};

export type GqlDeleteProduct = {
  __typename?: 'DeleteProduct';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlUploadProductImage = {
  __typename?: 'UploadProductImage';
  product: Maybe<GqlProductV2Gql>;
  uploaded: Maybe<Scalars['Boolean']>;
};

export type GqlCreateProductTag = {
  __typename?: 'CreateProductTag';
  created: Maybe<Scalars['Boolean']>;
  product_tag: Maybe<GqlProductTagV2Gql>;
};

export type GqlProductTagInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_tag?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateProductTag = {
  __typename?: 'UpdateProductTag';
  product_tag: Maybe<GqlProductTagV2Gql>;
};

export type GqlDeleteProductTag = {
  __typename?: 'DeleteProductTag';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateFinanceProductType = {
  __typename?: 'CreateFinanceProductType';
  created: Maybe<Scalars['Boolean']>;
  finance_product_type: Maybe<GqlFinanceProductTypeGql>;
};

export type GqlFinanceProductTypeInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type GqlUpdateFinanceProductType = {
  __typename?: 'UpdateFinanceProductType';
  finance_product_type: Maybe<GqlFinanceProductTypeGql>;
};

export type GqlCreateStandardUnitCost = {
  __typename?: 'CreateStandardUnitCost';
  created: Maybe<Scalars['Boolean']>;
  standard_unit_cost: Maybe<GqlStandardUnitCostGql>;
};

export type GqlStandardUnitCostInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  finance_product_type_id?: Maybe<Scalars['UUID']>;
  amount?: Maybe<Scalars['Float']>;
  start_date?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
};

export type GqlUpdateStandardUnitCost = {
  __typename?: 'UpdateStandardUnitCost';
  standard_unit_cost: Maybe<GqlStandardUnitCostGql>;
};

export type GqlCreateProductVariety = {
  __typename?: 'CreateProductVariety';
  created: Maybe<Scalars['Boolean']>;
  product_variety: Maybe<GqlProductVarietyGql>;
};

export type GqlProductVarietyInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  product_id?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
  variety_code?: Maybe<Scalars['String']>;
};

export type GqlUpdateProductVariety = {
  __typename?: 'UpdateProductVariety';
  product_variety: Maybe<GqlProductVarietyGql>;
};

export type GqlDeleteProductVariety = {
  __typename?: 'DeleteProductVariety';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlDispatchGqlConnection = {
  __typename?: 'DispatchGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDispatchGqlEdge>>;
};

/** A Relay edge containing a `DispatchGQL` and its cursor. */
export type GqlDispatchGqlEdge = {
  __typename?: 'DispatchGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDispatchGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDispatchGql = GqlNode & {
  __typename?: 'DispatchGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  distribution_center_id: Maybe<Scalars['String']>;
  dispatch_id: Scalars['String'];
  dispatch_number: Scalars['String'];
  depot_id: Scalars['String'];
  sale_date: Scalars['String'];
  dispatch_type: GqlDispatchType;
  stock_transfer_id: Maybe<Scalars['String']>;
  cancellation_reason: Maybe<Scalars['String']>;
  dispatch_items: Maybe<Array<Maybe<GqlDispatchItemGql>>>;
  dispatch: Maybe<GqlDispatchItemGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  total_products: Maybe<Scalars['Float']>;
  depot: Maybe<GqlDepotV2Gql>;
  user: Maybe<GqlUserV2Gql>;
  distribution_center: Maybe<GqlDistributionCenterGql>;
};

/** An enumeration. */
export enum GqlDispatchType {
  Dispatch = 'DISPATCH',
  StockTransfer = 'STOCK_TRANSFER'
}

export type GqlDispatchItemGql = {
  __typename?: 'DispatchItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  dispatch_item_id: Scalars['String'];
  dispatch_id: Scalars['String'];
  route_id: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  cancellation_reason: Maybe<Scalars['String']>;
  dispatch: Maybe<GqlDispatchGql>;
  dispatch_items: Maybe<GqlDispatchGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  route: Maybe<GqlRouteV2Gql>;
};

export type GqlDispatchItemGqlConnection = {
  __typename?: 'DispatchItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDispatchItemGqlEdge>>;
};

/** A Relay edge containing a `DispatchItemGQL` and its cursor. */
export type GqlDispatchItemGqlEdge = {
  __typename?: 'DispatchItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDispatchItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockTransferGqlConnection = {
  __typename?: 'StockTransferGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockTransferGqlEdge>>;
};

/** A Relay edge containing a `StockTransferGQL` and its cursor. */
export type GqlStockTransferGqlEdge = {
  __typename?: 'StockTransferGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockTransferGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStockTransferGql = GqlNode & {
  __typename?: 'StockTransferGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  stock_transfer_id: Scalars['String'];
  stock_transfer_number: Scalars['String'];
  sale_date: Scalars['String'];
  product_item_id: Scalars['String'];
  depot_id: Scalars['String'];
  route_id_from: Scalars['String'];
  cancellation_reason: Maybe<Scalars['String']>;
  stock_transfer_items: Maybe<Array<Maybe<GqlStockTransferItemGql>>>;
  stock_transfer: Maybe<GqlStockTransferItemGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  product_item: Maybe<GqlProductItemV2Gql>;
  route_from: Maybe<GqlRouteV2Gql>;
  user: Maybe<GqlUserV2Gql>;
};

export type GqlStockTransferItemGql = {
  __typename?: 'StockTransferItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  stock_transfer_item_id: Scalars['String'];
  stock_transfer_id: Scalars['String'];
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  route_id_to: Scalars['String'];
  stock_transfer: Maybe<GqlStockTransferGql>;
  stock_transfer_items: Maybe<GqlStockTransferGql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  route_to: Maybe<GqlRouteV2Gql>;
};

export type GqlStockTransferItemGqlConnection = {
  __typename?: 'StockTransferItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStockTransferItemGqlEdge>>;
};

/** A Relay edge containing a `StockTransferItemGQL` and its cursor. */
export type GqlStockTransferItemGqlEdge = {
  __typename?: 'StockTransferItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStockTransferItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDispatchBalanceGql = {
  __typename?: 'DispatchBalanceGQL';
  route_id: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  stock_balance: Maybe<Scalars['Float']>;
  packaging_balance: Maybe<Scalars['Float']>;
  product_item: Maybe<GqlProductItemV2Gql>;
};

export type GqlDepotIntakeGqlConnection = {
  __typename?: 'DepotIntakeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDepotIntakeGqlEdge>>;
};

/** A Relay edge containing a `DepotIntakeGQL` and its cursor. */
export type GqlDepotIntakeGqlEdge = {
  __typename?: 'DepotIntakeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDepotIntakeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDepotIntakeGql = GqlNode & {
  __typename?: 'DepotIntakeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  depot_intake_id: Scalars['String'];
  depot_intake_number: Scalars['String'];
  sale_date: Scalars['String'];
  depot_id: Scalars['String'];
  route_id: Scalars['String'];
  cancellation_reason: Maybe<Scalars['String']>;
  depot_intake_items: Maybe<Array<Maybe<GqlDepotIntakeItemGql>>>;
  depot_intake: Maybe<GqlDepotIntakeItemGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  route: Maybe<GqlRouteV2Gql>;
  user: Maybe<GqlUserV2Gql>;
};

export type GqlDepotIntakeItemGql = {
  __typename?: 'DepotIntakeItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  depot_intake_item_id: Scalars['String'];
  depot_intake_id: Scalars['String'];
  product_id: Scalars['String'];
  product_item_id: Scalars['String'];
  quantity: Scalars['Float'];
  unit_of_measure_id: Scalars['String'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  depot_intake: Maybe<GqlDepotIntakeGql>;
  depot_intake_item: Maybe<GqlDepotIntakeGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlDepotIntakeItemGqlConnection = {
  __typename?: 'DepotIntakeItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDepotIntakeItemGqlEdge>>;
};

/** A Relay edge containing a `DepotIntakeItemGQL` and its cursor. */
export type GqlDepotIntakeItemGqlEdge = {
  __typename?: 'DepotIntakeItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDepotIntakeItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlReturnGqlConnection = {
  __typename?: 'ReturnGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlReturnGqlEdge>>;
};

/** A Relay edge containing a `ReturnGQL` and its cursor. */
export type GqlReturnGqlEdge = {
  __typename?: 'ReturnGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlReturnGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum GqlReturnLevel {
  Depot = 'DEPOT',
  PackHouse = 'PACK_HOUSE',
  DcDepot = 'DC_DEPOT'
}

export type GqlProductReturnItemGql = {
  __typename?: 'ProductReturnItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  product_return_item_id: Scalars['String'];
  return_id: Scalars['String'];
  product_item_id: Scalars['String'];
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Maybe<Scalars['Float']>;
  product_loss_reason_id: Maybe<Scalars['String']>;
  cancellation_reason: Maybe<Scalars['String']>;
  picture: Maybe<Scalars['String']>;
  return_type: Maybe<GqlReturnType>;
  returns: Maybe<GqlReturnGql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

/** An enumeration. */
export enum GqlReturnType {
  Disposed = 'DISPOSED',
  Resale = 'RESALE',
  Conforming = 'CONFORMING',
  Nonconforming = 'NONCONFORMING'
}

export type GqlPackagingReturnItemGql = {
  __typename?: 'PackagingReturnItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  packaging_return_item_id: Scalars['String'];
  return_id: Scalars['String'];
  quantity: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  cancellation_reason: Maybe<Scalars['String']>;
  returns: Maybe<GqlReturnGql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
};

export type GqlProductReturnItemGqlConnection = {
  __typename?: 'ProductReturnItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlProductReturnItemGqlEdge>>;
};

/** A Relay edge containing a `ProductReturnItemGQL` and its cursor. */
export type GqlProductReturnItemGqlEdge = {
  __typename?: 'ProductReturnItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlProductReturnItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPackagingReturnItemGqlConnection = {
  __typename?: 'PackagingReturnItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPackagingReturnItemGqlEdge>>;
};

/** A Relay edge containing a `PackagingReturnItemGQL` and its cursor. */
export type GqlPackagingReturnItemGqlEdge = {
  __typename?: 'PackagingReturnItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPackagingReturnItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDispatchProductSummaryV2GqlConnection = {
  __typename?: 'DispatchProductSummaryV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlDispatchProductSummaryV2GqlEdge>>;
};

/** A Relay edge containing a `DispatchProductSummaryV2GQL` and its cursor. */
export type GqlDispatchProductSummaryV2GqlEdge = {
  __typename?: 'DispatchProductSummaryV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlDispatchProductSummaryV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlDispatchProductSummaryV2Gql = {
  __typename?: 'DispatchProductSummaryV2GQL';
  date: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  dispatch_quantity: Maybe<Scalars['Float']>;
  intake_quantity: Maybe<Scalars['Float']>;
  variance: Maybe<Scalars['Float']>;
};

export type GqlProjectedPhRevenueV2Gql = {
  __typename?: 'ProjectedPhRevenueV2GQL';
  date: Maybe<Scalars['String']>;
  projected_ph_revenue: Maybe<Scalars['Float']>;
};

export type GqlVehicleStockAllocationGqlConnection = {
  __typename?: 'VehicleStockAllocationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleStockAllocationGqlEdge>>;
};

/** A Relay edge containing a `VehicleStockAllocationGQL` and its cursor. */
export type GqlVehicleStockAllocationGqlEdge = {
  __typename?: 'VehicleStockAllocationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleStockAllocationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlVehicleStockAllocationGql = {
  __typename?: 'VehicleStockAllocationGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  vehicle_stock_allocation_id: Scalars['String'];
  delivery_date: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  product_item_id: Scalars['String'];
  depot_id: Scalars['String'];
  route_plan_id: Scalars['String'];
  quantity: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  unit_of_measure_id: Scalars['String'];
  weight: Scalars['Float'];
  confirmed: Maybe<Scalars['Boolean']>;
  country_id: Maybe<Scalars['String']>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  depot: Maybe<GqlDepotV2Gql>;
  route_plan: Maybe<GqlRoutePlanGql>;
};

export type GqlBatchGqlConnection = {
  __typename?: 'BatchGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBatchGqlEdge>>;
};

/** A Relay edge containing a `BatchGQL` and its cursor. */
export type GqlBatchGqlEdge = {
  __typename?: 'BatchGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBatchGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlHarvestGql = {
  __typename?: 'HarvestGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  harvest_id: Scalars['String'];
  collection_center_id: Scalars['String'];
  farm_id: Maybe<Scalars['String']>;
  farmer_id: Maybe<Scalars['String']>;
  batch_id: Maybe<Scalars['String']>;
  country_id: Scalars['String'];
  product_id: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Maybe<Scalars['String']>;
  receipt_number: Scalars['String'];
  receipt_url: Maybe<Scalars['String']>;
  unit_price: Maybe<Scalars['Float']>;
  original_currency: Scalars['String'];
  fx_rate: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  weight: Maybe<Scalars['Float']>;
  total_payable: Maybe<Scalars['Float']>;
  harvest_date: Scalars['String'];
  harvested_by: Maybe<Scalars['String']>;
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  invoice_number: Maybe<Scalars['String']>;
  control_unit_invoice_number: Maybe<Scalars['String']>;
  farm: Maybe<GqlFarmGql>;
  collection_center: Maybe<GqlCollectionCenterGql>;
  harvest_issues: Maybe<GqlHarvestIssueGql>;
  batch: Maybe<GqlBatchGql>;
  farmer: Maybe<GqlFarmerGql>;
  harvest_items: Maybe<Array<Maybe<GqlHarvestItemGql>>>;
  harvest_payment_batch_detail: Maybe<GqlPaymentDetailGql>;
  payment: Maybe<GqlHarvestPaymentGql>;
  signed_receipt_url: Maybe<Scalars['String']>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  harvester: Maybe<GqlUserV2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  country: Maybe<GqlCountryGql>;
};

export type GqlFarmGql = GqlNode & {
  __typename?: 'FarmGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  farm_id: Scalars['String'];
  farm_number: Scalars['Int'];
  farm_name: Maybe<Scalars['String']>;
  farmer_type: Scalars['String'];
  farm_size: Scalars['Float'];
  farmer_id: Scalars['String'];
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  harvest_area_id: Scalars['String'];
  agent_farm: Maybe<Scalars['Boolean']>;
  products: Maybe<Array<Maybe<GqlFarmProductGql>>>;
  farmer: Maybe<GqlFarmerGql>;
  harvest_area: Maybe<GqlHarvestAreaGql>;
  harvest: Maybe<GqlHarvestGql>;
  booking: Maybe<GqlBookingGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlFarmProductGql = GqlNode & {
  __typename?: 'FarmProductGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  farm_product_id: Scalars['String'];
  product_id: Scalars['String'];
  farm_id: Scalars['String'];
  farm: Maybe<GqlFarmGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  product: Maybe<GqlProductV2Gql>;
};

export type GqlFarmerGql = GqlNode & {
  __typename?: 'FarmerGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  farmer_id: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  farmer_number: Scalars['Int'];
  phone_number: Scalars['String'];
  alt_phone_number: Maybe<Scalars['String']>;
  farmer_type: Maybe<Scalars['String']>;
  supplier_name: Maybe<Scalars['String']>;
  email_address: Maybe<Scalars['String']>;
  country_id: Scalars['String'];
  discovery_id: Maybe<Scalars['String']>;
  discovery_other: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  farmer_payment_accounts: Maybe<Array<Maybe<GqlFarmerPaymentAccountGql>>>;
  agent: Maybe<GqlSourcingAgentGql>;
  discovery: Maybe<GqlDiscoveryGql>;
  supplier_products: Maybe<Array<Maybe<GqlSupplierProductGql>>>;
  supplier_users: Maybe<Array<Maybe<GqlSupplierUserGql>>>;
  farms: Maybe<Array<Maybe<GqlFarmGql>>>;
  Farmer: Maybe<GqlBidApplicationGql>;
  harvests: Maybe<GqlHarvestGql>;
  harvest_payment_batch_detail: Maybe<GqlPaymentDetailGql>;
  bookings: Maybe<GqlBookingGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  primary_payment_account: Maybe<GqlFarmerPaymentAccountGql>;
  batch_code: Maybe<Scalars['String']>;
  country: Maybe<GqlCountryGql>;
};

export type GqlFarmerPaymentAccountGql = GqlNode & {
  __typename?: 'FarmerPaymentAccountGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  farmer_payment_account_id: Scalars['String'];
  farmer_id: Scalars['String'];
  account_type: Maybe<Scalars['String']>;
  party: Scalars['String'];
  party_code: Maybe<Scalars['String']>;
  account_number: Scalars['String'];
  account_name: Scalars['String'];
  is_primary: Scalars['Boolean'];
  farmer_payment_accounts: Maybe<GqlFarmerGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlSourcingAgentGql = {
  __typename?: 'SourcingAgentGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  agent_id: Scalars['String'];
  farmer_id: Scalars['String'];
  user_name: Scalars['String'];
  password: Scalars['String'];
  last_login: Maybe<Scalars['DateTime']>;
  locale: Scalars['String'];
  farmer: Maybe<GqlFarmerGql>;
  agent: Maybe<GqlBidApplicationGql>;
  products: Maybe<Array<Maybe<Scalars['GenericScalar']>>>;
};

export type GqlBidApplicationGql = {
  __typename?: 'BidApplicationGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  bid_application_id: Scalars['String'];
  bid_id: Scalars['String'];
  bid_application_number: Scalars['String'];
  farmer_id: Scalars['String'];
  agent_id: Scalars['String'];
  bid_application_date: Scalars['DateTime'];
  delivery_date: Scalars['DateTime'];
  product_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  unit_price: Scalars['Float'];
  original_currency: Scalars['String'];
  fx_rate: Maybe<Scalars['Float']>;
  bid_application_status: Maybe<Scalars['String']>;
  cancellation_reason: Maybe<Scalars['String']>;
  vehicle_registration: Maybe<Scalars['String']>;
  bid_application_status_type: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  country_id: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  bid: Maybe<GqlBidGql>;
  agent: Maybe<GqlSourcingAgentGql>;
  farmer: Maybe<GqlFarmerGql>;
  agent_feedback: Maybe<Array<Maybe<GqlAgentFeedbackGql>>>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  country: Maybe<GqlCountryGql>;
};

export type GqlBidGql = {
  __typename?: 'BidGQL';
  bid_application_count: Maybe<Scalars['Int']>;
  bid_application_lowest_price: Maybe<Scalars['Float']>;
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  bid_id: Scalars['String'];
  bid_number: Scalars['String'];
  opening_bid_price: Scalars['Float'];
  minimum_quantity: Scalars['Float'];
  product_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  opening_date: Scalars['DateTime'];
  closing_date: Scalars['DateTime'];
  delivery_date: Scalars['DateTime'];
  bid_notes: Maybe<Scalars['String']>;
  bid_status: Maybe<Scalars['String']>;
  cancellation_reason: Maybe<Scalars['String']>;
  country_id: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  bid_applications: Maybe<Array<Maybe<GqlBidApplicationGql>>>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
  user: Maybe<GqlUserV2Gql>;
  country: Maybe<GqlCountryGql>;
};

export type GqlAgentFeedbackGql = {
  __typename?: 'AgentFeedbackGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  agent_feedback_id: Scalars['String'];
  agent_id: Scalars['String'];
  harvest_id: Scalars['String'];
  bid_application_id: Scalars['String'];
  delivery_id: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  categories: Maybe<Array<Maybe<GqlFeedbackCategoryGql>>>;
  bid_application: Maybe<GqlBidApplicationGql>;
};

export type GqlFeedbackCategoryGql = {
  __typename?: 'FeedbackCategoryGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  feedback_category_id: Scalars['String'];
  feedback_category_name: Scalars['String'];
  feedback_category_description: Maybe<Scalars['String']>;
};

export type GqlDiscoveryGql = {
  __typename?: 'DiscoveryGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  discovery_id: Scalars['String'];
  method: Scalars['String'];
};

export type GqlSupplierProductGql = {
  __typename?: 'SupplierProductGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  supplier_product_id: Scalars['String'];
  farmer_id: Scalars['String'];
  product_id: Scalars['String'];
  supplier: Maybe<GqlFarmerGql>;
  product: Maybe<GqlProductV2Gql>;
};

export type GqlSupplierUserGql = {
  __typename?: 'SupplierUserGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  supplier_user_id: Scalars['String'];
  farmer_id: Scalars['String'];
  user_id: Scalars['String'];
  role_id: Scalars['String'];
  supplier: Maybe<GqlFarmerGql>;
  user: Maybe<GqlUserV2Gql>;
  role: Maybe<GqlRoleV2Gql>;
};

export type GqlRoleV2Gql = {
  __typename?: 'RoleV2GQL';
  role_id: Scalars['String'];
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Scalars['String'];
  client_timestamp: Scalars['DateTime'];
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  role_name: Scalars['String'];
  domain: Scalars['String'];
  permissions: Maybe<Array<Maybe<GqlPermissionV2Gql>>>;
};

export type GqlPaymentDetailGql = GqlNode & {
  __typename?: 'PaymentDetailGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_payment_batch_detail_id: Scalars['String'];
  harvest_payment_batch_id: Scalars['String'];
  harvest_id: Scalars['String'];
  amount: Scalars['Float'];
  farmer_payment_account_id: Scalars['String'];
  farmer_id: Scalars['String'];
  account_type: Maybe<Scalars['String']>;
  account_number: Scalars['String'];
  payment_provider_mode_id: Scalars['String'];
  payment_transaction_type: Maybe<Scalars['String']>;
  payment_status: Maybe<Scalars['String']>;
  external_payment_transaction_id: Maybe<Scalars['String']>;
  external_payment_date: Maybe<Scalars['DateTime']>;
  harvest: Maybe<GqlHarvestGql>;
  farmer: Maybe<GqlFarmerGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

/** An enumeration. */
export enum GqlBookingStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED'
}

export type GqlCollectionCenterGql = GqlNode & {
  __typename?: 'CollectionCenterGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  collection_center_id: Scalars['String'];
  collection_center_name: Scalars['String'];
  area_id: Scalars['String'];
  country_id: Scalars['String'];
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  collection_center_supervisor: Maybe<Scalars['String']>;
  collection_center_code: Maybe<Scalars['String']>;
  harvest_areas: Maybe<Array<Maybe<GqlHarvestAreaGql>>>;
  area: Maybe<GqlAreaGql>;
  harvest: Maybe<GqlHarvestGql>;
  booking: Maybe<GqlBookingGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  country: Maybe<GqlCountryGql>;
};

export type GqlHarvestAreaGql = GqlNode & {
  __typename?: 'HarvestAreaGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_area_id: Scalars['String'];
  harvest_area_name: Scalars['String'];
  collection_center_id: Scalars['String'];
  collection_center: Maybe<GqlCollectionCenterGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
  area: Maybe<GqlAreaGql>;
};

export type GqlAreaGql = GqlNode & {
  __typename?: 'AreaGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  area_id: Scalars['String'];
  area_name: Scalars['String'];
  area_manager: Maybe<Scalars['String']>;
  area_code: Maybe<Scalars['String']>;
  collection_centers: Maybe<Array<Maybe<GqlCollectionCenterGql>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlBookingItemGql = {
  __typename?: 'BookingItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  booking_item_id: Scalars['String'];
  booking_id: Scalars['String'];
  product_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Scalars['String'];
  quantity: Scalars['Float'];
  weight: Maybe<Scalars['Float']>;
  unit_price: Scalars['Float'];
  harvest_date: Scalars['String'];
  booked_by: Maybe<Scalars['String']>;
  booking: Maybe<GqlBookingGql>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  scout: Maybe<GqlUserV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlHarvestIssueGql = GqlNode & {
  __typename?: 'HarvestIssueGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_issue_id: Scalars['String'];
  harvest_id: Scalars['String'];
  comment: Maybe<Scalars['String']>;
  harvest_issue_types: Maybe<Array<Maybe<GqlHarvestIssueDetailGql>>>;
  harvest: Maybe<GqlHarvestGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlHarvestIssueDetailGql = GqlNode & {
  __typename?: 'HarvestIssueDetailGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_issue_detail_id: Scalars['String'];
  harvest_issue_type_id: Scalars['Int'];
  harvest_issue_id: Scalars['String'];
  harvest_issue_type: Maybe<GqlHarvestIssueTypeGql>;
  harvest_issue: Maybe<GqlHarvestIssueGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlHarvestIssueTypeGql = GqlNode & {
  __typename?: 'HarvestIssueTypeGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_issue_type_id: Scalars['ID'];
  harvest_issue_type_name: Scalars['String'];
  harvest_issue_detail: Maybe<GqlHarvestIssueDetailGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlHarvestItemGql = {
  __typename?: 'HarvestItemGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  cancelled: Scalars['Boolean'];
  cancellation_reason: Maybe<Scalars['String']>;
  harvest_item_id: Scalars['String'];
  harvest_id: Scalars['String'];
  product_id: Scalars['String'];
  product_item_id: Maybe<Scalars['String']>;
  unit_of_measure_id: Scalars['String'];
  unit_price: Scalars['Float'];
  quantity: Scalars['Float'];
  weight: Scalars['Float'];
  waste: Scalars['Boolean'];
  total_payable: Scalars['Float'];
  packaging_unit_id: Maybe<Scalars['String']>;
  packaging_unit_quantity: Maybe<Scalars['Int']>;
  number_of_crates: Maybe<Scalars['Int']>;
  harvest: Maybe<GqlHarvestGql>;
  assets: Maybe<Array<Maybe<GqlHarvestItemAssetGql>>>;
  product: Maybe<GqlProductV2Gql>;
  product_item: Maybe<GqlProductItemV2Gql>;
  harvester: Maybe<GqlUserV2Gql>;
  packaging_unit: Maybe<GqlPackagingUnitV2Gql>;
  uom: Maybe<GqlUomv2Gql>;
};

export type GqlHarvestItemAssetGql = {
  __typename?: 'HarvestItemAssetGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  harvest_item_asset_id: Scalars['String'];
  harvest_item_id: Scalars['String'];
  asset_number: Scalars['String'];
  harvest_item: Maybe<GqlHarvestItemGql>;
  asset: Maybe<GqlAssetGql>;
};

export type GqlHarvestPaymentGql = {
  __typename?: 'HarvestPaymentGQL';
  harvest_id: Maybe<Scalars['String']>;
  amount_paid: Maybe<Scalars['Float']>;
  total_payable: Maybe<Scalars['Float']>;
  harvest_payment_status: Maybe<Scalars['String']>;
  payment_details: Maybe<Array<Maybe<GqlHarvestPaymentDetailGql>>>;
};

export type GqlHarvestPaymentDetailGql = {
  __typename?: 'HarvestPaymentDetailGQL';
  amount: Maybe<Scalars['Float']>;
  payment_date: Maybe<Scalars['String']>;
  account_type: Maybe<Scalars['String']>;
  account_number: Maybe<Scalars['String']>;
  harvest_id: Maybe<Scalars['String']>;
  transaction_id: Maybe<Scalars['String']>;
  payment_status: Maybe<Scalars['String']>;
  date_created: Maybe<Scalars['String']>;
  payer_name: Maybe<Scalars['String']>;
  harvest_payment_batch_id: Maybe<Scalars['String']>;
  harvest_payment_batch_detail_id: Maybe<Scalars['String']>;
};

export type GqlArticleGqlConnection = {
  __typename?: 'ArticleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlArticleGqlEdge>>;
};

/** A Relay edge containing a `ArticleGQL` and its cursor. */
export type GqlArticleGqlEdge = {
  __typename?: 'ArticleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlArticleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlArticleGql = GqlNode & {
  __typename?: 'ArticleGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  article_id: Scalars['String'];
  date: Scalars['DateTime'];
  title: Scalars['String'];
  category: GqlArticleCategory;
  body: Scalars['String'];
  image: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  saved_article: Maybe<GqlSavedArticleGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

/** An enumeration. */
export enum GqlArticleCategory {
  Tutorial = 'TUTORIAL',
  Statistics = 'STATISTICS'
}

export type GqlSavedArticleGql = GqlNode & {
  __typename?: 'SavedArticleGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  article_id: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  save_date: Scalars['DateTime'];
  saved_article_id: Scalars['String'];
  article: Maybe<GqlArticleGql>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlSavedArticleGqlConnection = {
  __typename?: 'SavedArticleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSavedArticleGqlEdge>>;
};

/** A Relay edge containing a `SavedArticleGQL` and its cursor. */
export type GqlSavedArticleGqlEdge = {
  __typename?: 'SavedArticleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSavedArticleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBidGqlConnection = {
  __typename?: 'BidGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBidGqlEdge>>;
};

/** A Relay edge containing a `BidGQL` and its cursor. */
export type GqlBidGqlEdge = {
  __typename?: 'BidGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBidGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBidApplicationGqlConnection = {
  __typename?: 'BidApplicationGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBidApplicationGqlEdge>>;
};

/** A Relay edge containing a `BidApplicationGQL` and its cursor. */
export type GqlBidApplicationGqlEdge = {
  __typename?: 'BidApplicationGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBidApplicationGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum GqlBidStatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

/** An enumeration. */
export enum GqlBidApplicationStatus {
  Submitted = 'SUBMITTED',
  Accepted = 'ACCEPTED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED'
}

/** An enumeration. */
export enum GqlBidApplicationType {
  Active = 'ACTIVE',
  Past = 'PAST',
  Won = 'WON'
}

/** An enumeration. */
export enum GqlCurrency {
  Kes = 'KES',
  Tzs = 'TZS',
  Ugx = 'UGX'
}

export type GqlHarvestGqlConnection = {
  __typename?: 'HarvestGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlHarvestGqlEdge>>;
};

/** A Relay edge containing a `HarvestGQL` and its cursor. */
export type GqlHarvestGqlEdge = {
  __typename?: 'HarvestGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlHarvestGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPaymentDetailGqlConnection = {
  __typename?: 'PaymentDetailGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPaymentDetailGqlEdge>>;
};

/** A Relay edge containing a `PaymentDetailGQL` and its cursor. */
export type GqlPaymentDetailGqlEdge = {
  __typename?: 'PaymentDetailGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPaymentDetailGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlHarvestItemGqlConnection = {
  __typename?: 'HarvestItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlHarvestItemGqlEdge>>;
};

/** A Relay edge containing a `HarvestItemGQL` and its cursor. */
export type GqlHarvestItemGqlEdge = {
  __typename?: 'HarvestItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlHarvestItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlHarvestItemAssetGqlConnection = {
  __typename?: 'HarvestItemAssetGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlHarvestItemAssetGqlEdge>>;
};

/** A Relay edge containing a `HarvestItemAssetGQL` and its cursor. */
export type GqlHarvestItemAssetGqlEdge = {
  __typename?: 'HarvestItemAssetGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlHarvestItemAssetGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum GqlPaymentAccountType {
  Bank = 'BANK',
  Mobile = 'MOBILE',
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum GqlFarmerType {
  NonContractFarmer = 'NON_CONTRACT_FARMER',
  ContractFarmer = 'CONTRACT_FARMER',
  Agent = 'AGENT',
  Wholesaler = 'WHOLESALER',
  Distributor = 'DISTRIBUTOR',
  Manufacturer = 'MANUFACTURER'
}

export type GqlFarmerGqlConnection = {
  __typename?: 'FarmerGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFarmerGqlEdge>>;
};

/** A Relay edge containing a `FarmerGQL` and its cursor. */
export type GqlFarmerGqlEdge = {
  __typename?: 'FarmerGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFarmerGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSourcingAgentGqlConnection = {
  __typename?: 'SourcingAgentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSourcingAgentGqlEdge>>;
};

/** A Relay edge containing a `SourcingAgentGQL` and its cursor. */
export type GqlSourcingAgentGqlEdge = {
  __typename?: 'SourcingAgentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSourcingAgentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlFarmGqlConnection = {
  __typename?: 'FarmGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFarmGqlEdge>>;
};

/** A Relay edge containing a `FarmGQL` and its cursor. */
export type GqlFarmGqlEdge = {
  __typename?: 'FarmGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFarmGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlFarmerPaymentAccountGqlConnection = {
  __typename?: 'FarmerPaymentAccountGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFarmerPaymentAccountGqlEdge>>;
};

/** A Relay edge containing a `FarmerPaymentAccountGQL` and its cursor. */
export type GqlFarmerPaymentAccountGqlEdge = {
  __typename?: 'FarmerPaymentAccountGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFarmerPaymentAccountGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlAgentFeedbackGqlConnection = {
  __typename?: 'AgentFeedbackGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlAgentFeedbackGqlEdge>>;
};

/** A Relay edge containing a `AgentFeedbackGQL` and its cursor. */
export type GqlAgentFeedbackGqlEdge = {
  __typename?: 'AgentFeedbackGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlAgentFeedbackGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSupplierUserGqlConnection = {
  __typename?: 'SupplierUserGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierUserGqlEdge>>;
};

/** A Relay edge containing a `SupplierUserGQL` and its cursor. */
export type GqlSupplierUserGqlEdge = {
  __typename?: 'SupplierUserGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierUserGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlSupplierProductGqlConnection = {
  __typename?: 'SupplierProductGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlSupplierProductGqlEdge>>;
};

/** A Relay edge containing a `SupplierProductGQL` and its cursor. */
export type GqlSupplierProductGqlEdge = {
  __typename?: 'SupplierProductGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlSupplierProductGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBookingGqlConnection = {
  __typename?: 'BookingGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBookingGqlEdge>>;
};

/** A Relay edge containing a `BookingGQL` and its cursor. */
export type GqlBookingGqlEdge = {
  __typename?: 'BookingGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBookingGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPriceRangeGqlConnection = {
  __typename?: 'PriceRangeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPriceRangeGqlEdge>>;
};

/** A Relay edge containing a `PriceRangeGQL` and its cursor. */
export type GqlPriceRangeGqlEdge = {
  __typename?: 'PriceRangeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPriceRangeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBookingItemGqlConnection = {
  __typename?: 'BookingItemGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlBookingItemGqlEdge>>;
};

/** A Relay edge containing a `BookingItemGQL` and its cursor. */
export type GqlBookingItemGqlEdge = {
  __typename?: 'BookingItemGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlBookingItemGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlBlockGql = GqlNode & {
  __typename?: 'BlockGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  block_id: Scalars['String'];
  block_name: Scalars['String'];
  block_code: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type GqlPivotGql = GqlNode & {
  __typename?: 'PivotGQL';
  date_created: Scalars['DateTime'];
  created_by: Scalars['String'];
  date_updated: Scalars['DateTime'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  pivot_id: Scalars['String'];
  pivot_name: Scalars['String'];
  pivot_code: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

/** Pagination Connection for PermissionV2GQL */
export type GqlPermissionV2GqlConnection = {
  __typename?: 'PermissionV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlPermissionV2GqlEdge>>;
};

export type GqlPermissionV2GqlEdge = {
  __typename?: 'PermissionV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPermissionV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPermissionV2Gql = {
  __typename?: 'PermissionV2GQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Scalars['String'];
  client_timestamp: Scalars['DateTime'];
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  permission_id: Scalars['String'];
  permission_name: Scalars['String'];
  domain: Scalars['String'];
  roles: Maybe<Array<Maybe<GqlRoleV2Gql>>>;
};

/** Pagination Connection for UserV2GQL */
export type GqlUserV2GqlConnection = {
  __typename?: 'UserV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlUserV2GqlEdge>>;
};

export type GqlUserV2GqlEdge = {
  __typename?: 'UserV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlUserV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for RoleV2GQL */
export type GqlRoleV2GqlConnection = {
  __typename?: 'RoleV2GQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlRoleV2GqlEdge>>;
};

export type GqlRoleV2GqlEdge = {
  __typename?: 'RoleV2GQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRoleV2Gql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};


export type GqlAverageRating = {
  __typename?: 'AverageRating';
  average_rating: Scalars['Int'];
  total_ratings: Scalars['Int'];
};

export type GqlMetaData = {
  __typename?: 'MetaData';
  total_feedbacks: Scalars['Int'];
  total_by_feedback_type: Maybe<GqlTotalSummary>;
};

export type GqlTotalSummary = {
  __typename?: 'TotalSummary';
  issues: Scalars['Int'];
  ideas: Scalars['Int'];
  other: Scalars['Int'];
};

export enum GqlMedium {
  Sokoyetu = 'SOKOYETU',
  Sokocall = 'SOKOCALL'
}

export enum GqlFeedBackType {
  Other = 'OTHER',
  Issue = 'ISSUE',
  Idea = 'IDEA'
}

export enum GqlSentiment {
  Happy = 'Happy',
  Unhappy = 'Unhappy'
}

export type GqlFeedbackInput = {
  channel: GqlMedium;
  comment: Scalars['String'];
  feedback_type: GqlFeedBackType;
  meta?: Maybe<Scalars['JSON']>;
  user_id?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  page_url?: Maybe<Scalars['String']>;
};

export type GqlNpsInput = {
  channel: GqlMedium;
  sentiment: GqlSentiment;
  meta?: Maybe<Scalars['JSON']>;
  page_url?: Maybe<Scalars['String']>;
};

export type GqlUserRatingInput = {
  delivery_id: Scalars['String'];
  fulfiller_id: Scalars['String'];
  rating: Scalars['Int'];
  channel: GqlMedium;
  submitted_by: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};

export type GqlRatingType = {
  __typename?: 'RatingType';
  id: Scalars['ID'];
  delivery_id: Scalars['String'];
  submitted_by: Scalars['String'];
  date_created: Scalars['Date'];
  rating: Scalars['Int'];
  channel: GqlMedium;
};

export type GqlNps = {
  __typename?: 'Nps';
  date_created: Scalars['Date'];
  active: Scalars['Boolean'];
  meta: Maybe<Scalars['JSON']>;
  device: Maybe<Scalars['String']>;
  page_url: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  channel: GqlMedium;
  published: Scalars['Boolean'];
  sentiment: GqlSentiment;
};

export type GqlFeedback = {
  __typename?: 'Feedback';
  id: Scalars['ID'];
  date_created: Scalars['Date'];
  active: Scalars['Boolean'];
  published: Scalars['Boolean'];
  device: Maybe<Scalars['String']>;
  feedback_type: GqlFeedBackType;
  channel: GqlMedium;
  page_url: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  user_id: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSON']>;
};

export type GqlUserRating = {
  __typename?: 'UserRating';
  id: Scalars['ID'];
  date_created: Scalars['Date'];
  delivery: GqlDeliveryV2Gql;
  rating: Scalars['Int'];
  channel: GqlMedium;
  submitted_by: GqlUserV2Gql;
};

/** Node and relay Connection. */
export type GqlNotificationTemplateGqlConnection = {
  __typename?: 'NotificationTemplateGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlNotificationTemplateGqlEdge>>;
};

export type GqlNotificationTemplateGqlEdge = {
  __typename?: 'NotificationTemplateGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlNotificationTemplateGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** NotificationTemplate GQL. */
export type GqlNotificationTemplateGql = {
  __typename?: 'NotificationTemplateGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Maybe<Scalars['String']>;
  updated_by: Maybe<Scalars['String']>;
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  template_id: Scalars['String'];
  template_name: Scalars['String'];
  description: Scalars['String'];
  template_string: Scalars['String'];
};

/** Node and relay Connection. */
export type GqlNotificationMessageGqlConnection = {
  __typename?: 'NotificationMessageGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlNotificationMessageGqlEdge>>;
};

export type GqlNotificationMessageGqlEdge = {
  __typename?: 'NotificationMessageGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlNotificationMessageGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** NotificationMessage GQL. */
export type GqlNotificationMessageGql = {
  __typename?: 'NotificationMessageGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Maybe<Scalars['String']>;
  updated_by: Maybe<Scalars['String']>;
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  notification_id: Scalars['String'];
  title: Scalars['String'];
  message: Scalars['String'];
  user_id: Scalars['String'];
  service_name: Maybe<Scalars['String']>;
  topic: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  data: Maybe<Scalars['JSONString']>;
};

/** Node and relay Connection. */
export type GqlNotificationProviderGqlConnection = {
  __typename?: 'NotificationProviderGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  edges: Array<Maybe<GqlNotificationProviderGqlEdge>>;
};

export type GqlNotificationProviderGqlEdge = {
  __typename?: 'NotificationProviderGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlNotificationProviderGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Provider GQL. */
export type GqlNotificationProviderGql = {
  __typename?: 'NotificationProviderGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Maybe<Scalars['String']>;
  updated_by: Maybe<Scalars['String']>;
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  provider_id: Scalars['String'];
  name: Scalars['String'];
};

export type GqlCreditNote = {
  __typename?: 'CreditNote';
  id: Scalars['ID'];
  creditNoteUrl: Scalars['String'];
  deliveryID: Scalars['String'];
  taxInvoiceID: Scalars['ID'];
};

export type GqlHsCode = {
  __typename?: 'HsCode';
  TaxRate: Scalars['Int'];
  KraCode: Scalars['String'];
  HSDesc: Scalars['String'];
  TaxType: Scalars['String'];
};

export type GqlHsCodeFilters = {
  search?: Maybe<Scalars['String']>;
};

export type GqlTaxInvoice = {
  __typename?: 'TaxInvoice';
  id: Scalars['ID'];
  taxInvoiceUrl: Scalars['String'];
  deliveryID: Scalars['String'];
  creditNote: Maybe<GqlCreditNote>;
};

export type GqlTaxInvoiceFilter = {
  deliveryID: Scalars['String'];
};

export type GqlChecklistSectionGql = {
  __typename?: 'ChecklistSectionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  section_id: Scalars['String'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  checklist: GqlChecklistEnum;
  questions: Maybe<Array<Maybe<GqlChecklistQuestionGql>>>;
};

/** An enumeration. */
export enum GqlChecklistEnum {
  Driver = 'DRIVER',
  Maintenance = 'MAINTENANCE'
}

export type GqlChecklistQuestionGql = {
  __typename?: 'ChecklistQuestionGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  question_id: Scalars['String'];
  section_id: Scalars['String'];
  question: Scalars['String'];
  section: Maybe<GqlChecklistSectionGql>;
};

export type GqlChecklistQuestionGqlConnection = {
  __typename?: 'ChecklistQuestionGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlChecklistQuestionGqlEdge>>;
};

/** A Relay edge containing a `ChecklistQuestionGQL` and its cursor. */
export type GqlChecklistQuestionGqlEdge = {
  __typename?: 'ChecklistQuestionGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlChecklistQuestionGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlChecklistEntryGqlConnection = {
  __typename?: 'ChecklistEntryGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlChecklistEntryGqlEdge>>;
};

/** A Relay edge containing a `ChecklistEntryGQL` and its cursor. */
export type GqlChecklistEntryGqlEdge = {
  __typename?: 'ChecklistEntryGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlChecklistEntryGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlChecklistEntryGql = {
  __typename?: 'ChecklistEntryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  entry_id: Scalars['String'];
  checklist_entry_number: Scalars['String'];
  odometer_reading: Maybe<Scalars['Float']>;
  route_plan_id: Scalars['String'];
  vehicle_id: Scalars['String'];
  user_id: Scalars['String'];
  depot_id: Maybe<Scalars['String']>;
  entry_date: Scalars['String'];
  service_due_date: Maybe<Scalars['String']>;
  vehicle: Maybe<GqlVehicleGql>;
  route_plan: Maybe<GqlRoutePlanGql>;
  entry_items: Maybe<Array<Maybe<GqlChecklistEntryItemGql>>>;
};

/** An enumeration. */
export enum GqlVehicleRejectionReason {
  MissingTracker = 'MISSING_TRACKER',
  MissingSpareWheel = 'MISSING_SPARE_WHEEL',
  DamagedOdometer = 'DAMAGED_ODOMETER',
  MissingLogBook = 'MISSING_LOG_BOOK',
  MissingInsuranceCover = 'MISSING_INSURANCE_COVER'
}

export type GqlVehicleTypeGql = {
  __typename?: 'VehicleTypeGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  vehicle_type_id: Scalars['String'];
  vehicle_type_name: Scalars['String'];
  details: Maybe<Scalars['String']>;
};

export type GqlTripGql = {
  __typename?: 'TripGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  vehicle_cost_model: Maybe<Scalars['String']>;
  cost_rate: Scalars['Float'];
  logistics_type: Maybe<Scalars['String']>;
  trip_id: Scalars['String'];
  vehicle_id: Scalars['String'];
  starting_odometer: Maybe<Scalars['Float']>;
  closing_odometer: Maybe<Scalars['Float']>;
  distance: Maybe<Scalars['Float']>;
  weight: Maybe<Scalars['Float']>;
  cost: Maybe<Scalars['Float']>;
  variable_cost: Maybe<Scalars['Float']>;
  starting_date: Maybe<Scalars['DateTime']>;
  end_date: Maybe<Scalars['DateTime']>;
  region_id: Maybe<Scalars['String']>;
  from_location: Maybe<Scalars['String']>;
  to_location: Maybe<Scalars['String']>;
  status: GqlTripStatus;
  vehicle: Maybe<GqlVehicleGql>;
  route_plan: Maybe<Array<Maybe<GqlRoutePlanGql>>>;
  has_statement: Maybe<Scalars['Boolean']>;
  total_cost: Maybe<Scalars['Int']>;
  region: Maybe<GqlRegionV2Gql>;
  from_inventory_location: Maybe<GqlInventoryLocationGql>;
  to_inventory_location: Maybe<GqlInventoryLocationGql>;
};

/** An enumeration. */
export enum GqlTripStatus {
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Complete = 'COMPLETE'
}

export type GqlFulfillmentTeamGql = {
  __typename?: 'FulfillmentTeamGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  country_id: Maybe<Scalars['String']>;
  fulfillment_team_id: Scalars['String'];
  route_plan_id: Scalars['String'];
  start_time: Maybe<Scalars['DateTime']>;
  end_time: Maybe<Scalars['DateTime']>;
  user_id: Scalars['String'];
  assignment_number: Scalars['String'];
  delivery_date: Scalars['String'];
  route_plan: Maybe<GqlRoutePlanGql>;
  status: Maybe<Scalars['String']>;
  user: Maybe<GqlUserV2Gql>;
};

export type GqlVehicleSupplierGql = {
  __typename?: 'VehicleSupplierGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  vehicle_supplier_id: Scalars['String'];
  supplier_number: Scalars['String'];
  name: Scalars['String'];
  phone_number: Scalars['String'];
  alt_phone_number: Maybe<Scalars['String']>;
  email: Scalars['String'];
  country_id: Scalars['String'];
  vehicles: Maybe<Array<Maybe<GqlVehicleGql>>>;
  payment_accounts: Maybe<Array<Maybe<GqlVehicleSupplierPaymentAccountGql>>>;
  statements: Maybe<Array<Maybe<GqlVehicleSupplierStatementGql>>>;
  num_vehicles: Maybe<Scalars['Int']>;
  country: Maybe<GqlCountryGql>;
};

export type GqlVehicleSupplierPaymentAccountGql = {
  __typename?: 'VehicleSupplierPaymentAccountGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  vehicle_supplier_payment_account_id: Scalars['String'];
  vehicle_supplier_id: Scalars['String'];
  account_type: GqlPaymentAccountType;
  party: Scalars['String'];
  party_code: Maybe<Scalars['String']>;
  account_number: Scalars['String'];
  account_name: Scalars['String'];
  is_primary: Scalars['Boolean'];
  vehicle_supplier: Maybe<GqlVehicleSupplierGql>;
};

export type GqlVehicleSupplierStatementGql = {
  __typename?: 'VehicleSupplierStatementGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  statement_id: Scalars['String'];
  statement_number: Scalars['String'];
  vehicle_supplier_id: Scalars['String'];
  date_from: Scalars['DateTime'];
  date_to: Scalars['DateTime'];
  amount: Scalars['Float'];
  approval_status: GqlStatementApprovalStatus;
  approved_by: Maybe<Scalars['String']>;
  payment_status: GqlPaymentStatus;
  invoice_amount: Maybe<Scalars['Float']>;
  vehicle_supplier: Maybe<GqlVehicleSupplierGql>;
  statement_files: Maybe<Array<Maybe<GqlVehicleSupplierStatementFileGql>>>;
  trips: Maybe<Array<Maybe<GqlTripGql>>>;
  created_by_user: Maybe<GqlUserV2Gql>;
  updated_by_user: Maybe<GqlUserV2Gql>;
  approved_by_user: Maybe<GqlUserV2Gql>;
};

/** An enumeration. */
export enum GqlStatementApprovalStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Approved = 'APPROVED'
}

/** An enumeration. */
export enum GqlPaymentStatus {
  Notpaid = 'NOTPAID',
  Fullypaid = 'FULLYPAID',
  Partiallypaid = 'PARTIALLYPAID',
  Inprogress = 'INPROGRESS'
}

export type GqlVehicleSupplierStatementFileGql = {
  __typename?: 'VehicleSupplierStatementFileGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  statement_file_id: Scalars['String'];
  statement_id: Scalars['String'];
  file_url: Scalars['String'];
  vehicle_supplier_statement: Maybe<GqlVehicleSupplierStatementGql>;
};

export type GqlChecklistEntryItemGql = {
  __typename?: 'ChecklistEntryItemGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  entry_item_id: Scalars['String'];
  entry_id: Maybe<Scalars['String']>;
  question_id: Maybe<Scalars['String']>;
  okay: Scalars['Boolean'];
  comment: Maybe<Scalars['String']>;
  question: Maybe<GqlChecklistQuestionGql>;
  entry: Maybe<GqlChecklistEntryGql>;
};

export type GqlIncidentCategoryGql = {
  __typename?: 'IncidentCategoryGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  incident_category_id: Scalars['String'];
  name: Scalars['String'];
  parent_id: Maybe<Scalars['String']>;
  parent: Maybe<GqlIncidentCategoryGql>;
  incident_categories: Maybe<Array<Maybe<GqlIncidentCategoryGql>>>;
};

export type GqlIncidentGqlConnection = {
  __typename?: 'IncidentGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlIncidentGqlEdge>>;
};

/** A Relay edge containing a `IncidentGQL` and its cursor. */
export type GqlIncidentGqlEdge = {
  __typename?: 'IncidentGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlIncidentGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlIncidentGql = {
  __typename?: 'IncidentGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  incident_id: Scalars['String'];
  incident_category_id: Scalars['String'];
  incident_number: Scalars['String'];
  vehicle_id: Scalars['String'];
  depot_id: Scalars['String'];
  report_date: Scalars['DateTime'];
  reported_by_id: Scalars['String'];
  incident_status: Scalars['Boolean'];
  incident_comment: Maybe<Scalars['String']>;
  closing_comment: Maybe<Scalars['String']>;
  closed_by_id: Maybe<Scalars['String']>;
  image_url: Maybe<Scalars['String']>;
  images: Array<Maybe<Scalars['String']>>;
  vehicle: Maybe<GqlVehicleGql>;
  incident_category: Maybe<GqlIncidentCategoryGql>;
  depot: Maybe<GqlDepotV2Gql>;
  reported_by: Maybe<GqlUserV2Gql>;
  closed_by: Maybe<GqlUserV2Gql>;
};

/** Pagination Connection for VehicleSupplierGQL */
export type GqlVehicleSupplierGqlConnection = {
  __typename?: 'VehicleSupplierGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleSupplierGqlEdge>>;
};

/** A Relay edge containing a `VehicleSupplierGQL` and its cursor. */
export type GqlVehicleSupplierGqlEdge = {
  __typename?: 'VehicleSupplierGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleSupplierGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VehicleSupplierPaymentAccountGQL */
export type GqlVehicleSupplierPaymentAccountGqlConnection = {
  __typename?: 'VehicleSupplierPaymentAccountGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleSupplierPaymentAccountGqlEdge>>;
};

/** A Relay edge containing a `VehicleSupplierPaymentAccountGQL` and its cursor. */
export type GqlVehicleSupplierPaymentAccountGqlEdge = {
  __typename?: 'VehicleSupplierPaymentAccountGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleSupplierPaymentAccountGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for TripGQL */
export type GqlTripGqlConnection = {
  __typename?: 'TripGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlTripGqlEdge>>;
};

/** A Relay edge containing a `TripGQL` and its cursor. */
export type GqlTripGqlEdge = {
  __typename?: 'TripGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlTripGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VehicleSupplierStatementFileGQL */
export type GqlVehicleSupplierStatementFileGqlConnection = {
  __typename?: 'VehicleSupplierStatementFileGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleSupplierStatementFileGqlEdge>>;
};

/** A Relay edge containing a `VehicleSupplierStatementFileGQL` and its cursor. */
export type GqlVehicleSupplierStatementFileGqlEdge = {
  __typename?: 'VehicleSupplierStatementFileGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleSupplierStatementFileGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VehicleSupplierStatementGQL */
export type GqlVehicleSupplierStatementGqlConnection = {
  __typename?: 'VehicleSupplierStatementGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleSupplierStatementGqlEdge>>;
};

/** A Relay edge containing a `VehicleSupplierStatementGQL` and its cursor. */
export type GqlVehicleSupplierStatementGqlEdge = {
  __typename?: 'VehicleSupplierStatementGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleSupplierStatementGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VehicleTypeGQL */
export type GqlVehicleTypeGqlConnection = {
  __typename?: 'VehicleTypeGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleTypeGqlEdge>>;
};

/** A Relay edge containing a `VehicleTypeGQL` and its cursor. */
export type GqlVehicleTypeGqlEdge = {
  __typename?: 'VehicleTypeGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleTypeGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for VehicleGQL */
export type GqlVehicleGqlConnection = {
  __typename?: 'VehicleGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlVehicleGqlEdge>>;
};

/** A Relay edge containing a `VehicleGQL` and its cursor. */
export type GqlVehicleGqlEdge = {
  __typename?: 'VehicleGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlVehicleGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlRoutePlanGqlConnection = {
  __typename?: 'RoutePlanGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlRoutePlanGqlEdge>>;
};

/** A Relay edge containing a `RoutePlanGQL` and its cursor. */
export type GqlRoutePlanGqlEdge = {
  __typename?: 'RoutePlanGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlRoutePlanGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Pagination Connection for Fulfillment Team GQL */
export type GqlFulfillmentTeamGqlConnection = {
  __typename?: 'FulfillmentTeamGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlFulfillmentTeamGqlEdge>>;
};

/** A Relay edge containing a `FulfillmentTeamGQL` and its cursor. */
export type GqlFulfillmentTeamGqlEdge = {
  __typename?: 'FulfillmentTeamGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlFulfillmentTeamGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStaticRouteGqlConnection = {
  __typename?: 'StaticRouteGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlStaticRouteGqlEdge>>;
};

/** A Relay edge containing a `StaticRouteGQL` and its cursor. */
export type GqlStaticRouteGqlEdge = {
  __typename?: 'StaticRouteGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlStaticRouteGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlStaticRouteGql = {
  __typename?: 'StaticRouteGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  static_route_id: Scalars['String'];
  delivery_date: Scalars['String'];
  status: Scalars['String'];
  route_name: Scalars['String'];
  route_id: Scalars['String'];
  distance: Scalars['Float'];
  path: Scalars['String'];
  shops: Array<Maybe<Scalars['JSONString']>>;
  purged_shops: Maybe<Array<Maybe<Scalars['JSONString']>>>;
  flagged_shops: Maybe<Array<Maybe<Scalars['JSONString']>>>;
  total_amount: Scalars['Float'];
  revenue_per_kilometer: Scalars['Float'];
  errors: Maybe<Array<Maybe<Scalars['JSONString']>>>;
};

export type GqlPseudoRouteGqlConnection = {
  __typename?: 'PseudoRouteGQLConnection';
  page_info: Maybe<GqlPaginatorInfo>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GqlPseudoRouteGqlEdge>>;
};

/** A Relay edge containing a `PseudoRouteGQL` and its cursor. */
export type GqlPseudoRouteGqlEdge = {
  __typename?: 'PseudoRouteGQLEdge';
  /** The item at the end of the edge */
  node: Maybe<GqlPseudoRouteGql>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GqlPseudoRouteGql = {
  __typename?: 'PseudoRouteGQL';
  date_created: Scalars['DateTime'];
  date_updated: Scalars['DateTime'];
  created_by: Scalars['String'];
  updated_by: Scalars['String'];
  client_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
  client_timestamp: Maybe<Scalars['DateTime']>;
  client_info: Maybe<Scalars['JSONString']>;
  active: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSONString']>;
  pseudo_route_id: Scalars['String'];
  name: Scalars['String'];
  merged_routes: Array<Maybe<Scalars['String']>>;
  constraints: Array<Maybe<Scalars['String']>>;
  force_share: Scalars['Boolean'];
  custom_constraints: Scalars['JSONString'];
  routes: Array<Maybe<GqlRouteV2Gql>>;
};

export type GqlUploadIncidentImage = {
  __typename?: 'UploadIncidentImage';
  uploaded: Maybe<Scalars['Boolean']>;
  incident: Maybe<GqlIncidentGql>;
};

export type GqlCreateIncidentCategory = {
  __typename?: 'CreateIncidentCategory';
  created: Maybe<Scalars['Boolean']>;
  incident_category: Maybe<GqlIncidentCategoryGql>;
};

export type GqlIncidentCategoryInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateIncidentCategory = {
  __typename?: 'UpdateIncidentCategory';
  incident_category: Maybe<GqlIncidentCategoryGql>;
};

export type GqlDeleteIncidentCategory = {
  __typename?: 'DeleteIncidentCategory';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlCreateIncident = {
  __typename?: 'CreateIncident';
  created: Maybe<Scalars['Boolean']>;
  incident: Maybe<GqlIncidentGql>;
};

export type GqlIncidentInput = {
  created_by?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_stamp?: Maybe<Scalars['String']>;
  client_timestamp?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  incident_category_id?: Maybe<Scalars['String']>;
  incident_number?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  depot_id?: Maybe<Scalars['String']>;
  report_date?: Maybe<Scalars['String']>;
  reported_by_id?: Maybe<Scalars['String']>;
  incident_status?: Maybe<Scalars['Boolean']>;
  incident_comment?: Maybe<Scalars['String']>;
  closing_comment?: Maybe<Scalars['String']>;
  closed_by_id?: Maybe<Scalars['String']>;
};

export type GqlUpdateIncident = {
  __typename?: 'UpdateIncident';
  incident: Maybe<GqlIncidentGql>;
};

export type GqlDeleteIncident = {
  __typename?: 'DeleteIncident';
  deleted: Maybe<Scalars['Boolean']>;
};

export type GqlPaginationFragment = (
  { __typename?: 'PaginatorInfo' }
  & Pick<GqlPaginatorInfo, 'current_page' | 'per_page' | 'has_next' | 'has_previous' | 'total_pages' | 'total_count'>
);

export type GqlCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlCountriesQuery = (
  { __typename?: 'Query' }
  & { countries: Maybe<Array<Maybe<(
    { __typename?: 'CountryGQL' }
    & GqlCountryFragment
  )>>> }
);

export type GqlCountryFragment = (
  { __typename?: 'CountryGQL' }
  & Pick<GqlCountryGql, 'country_id' | 'iso_alpha2_name' | 'iso_alpha2_code' | 'default_currency' | 'country_calling_code'>
);

export type GqlDepotsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDepotsQuery = (
  { __typename?: 'Query' }
  & { depots_v2: Maybe<(
    { __typename?: 'DepotV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'DepotV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DepotV2GQL' }
        & Pick<GqlDepotV2Gql, 'active' | 'depot_id' | 'depot_name'>
        & { routes: Maybe<Array<Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'active' | 'route_id' | 'route_name'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlRoutesQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlRoutesQuery = (
  { __typename?: 'Query' }
  & { routes_v2: Maybe<(
    { __typename?: 'RouteV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'RouteV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RouteV2GQL' }
        & Pick<GqlRouteV2Gql, 'date_created' | 'depot_id' | 'route_id' | 'route_name'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name' | 'depot_id' | 'area_id'>
          & { area: Maybe<(
            { __typename?: 'AreaV2GQL' }
            & Pick<GqlAreaV2Gql, 'area_name' | 'region_id'>
            & { region: Maybe<(
              { __typename?: 'RegionV2GQL' }
              & Pick<GqlRegionV2Gql, 'region_name' | 'region_id'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlRegionsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlRegionsQuery = (
  { __typename?: 'Query' }
  & { regions_v2: Maybe<(
    { __typename?: 'RegionV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'RegionV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RegionV2GQL' }
        & Pick<GqlRegionV2Gql, 'region_id' | 'region_name' | 'country_id'>
        & { country: Maybe<(
          { __typename?: 'CountryGQL' }
          & Pick<GqlCountryGql, 'default_currency'>
        )>, areas: Maybe<Array<Maybe<(
          { __typename?: 'AreaV2GQL' }
          & Pick<GqlAreaV2Gql, 'area_id' | 'area_name'>
          & { depots: Maybe<Array<Maybe<(
            { __typename?: 'DepotV2GQL' }
            & Pick<GqlDepotV2Gql, 'depot_id' | 'depot_name'>
            & { routes: Maybe<Array<Maybe<(
              { __typename?: 'RouteV2GQL' }
              & Pick<GqlRouteV2Gql, 'route_id' | 'route_name'>
            )>>> }
          )>>> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlFetchDistributionCentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchDistributionCentersQuery = (
  { __typename?: 'Query' }
  & { distribution_centers: Maybe<Array<Maybe<(
    { __typename?: 'DistributionCenterGQL' }
    & Pick<GqlDistributionCenterGql, 'distribution_center_name' | 'distribution_center_id' | 'distribution_center_type'>
  )>>> }
);

export type GqlFetchDynamicPricingQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlFetchDynamicPricingQuery = (
  { __typename?: 'Query' }
  & { dynamic_pricing: Maybe<(
    { __typename?: 'DynamicPricingGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DynamicPricingGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DynamicPricingGQL' }
        & Pick<GqlDynamicPricingGql, 'dynamic_pricing_id' | 'pricing_name' | 'description' | 'formula' | 'active' | 'start_time' | 'end_time'>
      )> }
    )>> }
  )> }
);

export type GqlMcommerceFaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMcommerceFaqsQuery = (
  { __typename?: 'Query' }
  & { mcommerce_faqs: Maybe<(
    { __typename?: 'McommerceFAQGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'McommerceFAQGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'McommerceFAQGQL' }
        & Pick<GqlMcommerceFaqgql, 'client_stamp' | 'client_id' | 'answer' | 'question' | 'date_created' | 'created_by' | 'faq_id' | 'faq_section_id'>
        & { faq_section: Maybe<(
          { __typename?: 'McommerceFAQSectionGQL' }
          & Pick<GqlMcommerceFaqSectionGql, 'name' | 'faq_section_id'>
        )> }
      )> }
    )>> }
  )>, mcommerce_faq_sections: Maybe<Array<Maybe<(
    { __typename?: 'McommerceFAQSectionGQL' }
    & Pick<GqlMcommerceFaqSectionGql, 'name' | 'date_created' | 'active' | 'icon_url' | 'faq_section_id' | 'client_stamp'>
    & { faqs: Maybe<Array<Maybe<(
      { __typename?: 'McommerceFAQGQL' }
      & Pick<GqlMcommerceFaqgql, 'client_stamp' | 'client_id' | 'answer' | 'active' | 'question' | 'date_created' | 'created_by' | 'faq_id' | 'faq_section_id'>
      & { faq_section: Maybe<(
        { __typename?: 'McommerceFAQSectionGQL' }
        & Pick<GqlMcommerceFaqSectionGql, 'name' | 'faq_section_id'>
      )> }
    )>>> }
  )>>> }
);

export type GqlMcommerceFaqSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMcommerceFaqSectionsQuery = (
  { __typename?: 'Query' }
  & { mcommerce_faq_sections: Maybe<Array<Maybe<(
    { __typename?: 'McommerceFAQSectionGQL' }
    & Pick<GqlMcommerceFaqSectionGql, 'date_created' | 'created_by' | 'client_stamp' | 'faq_section_id' | 'name'>
  )>>> }
);

export type GqlPermissionsV2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlPermissionsV2Query = (
  { __typename?: 'Query' }
  & { permissions_v2: Maybe<(
    { __typename?: 'PermissionV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'PermissionV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PermissionV2GQL' }
        & Pick<GqlPermissionV2Gql, 'permission_name' | 'permission_id' | 'active'>
        & { roles: Maybe<Array<Maybe<(
          { __typename?: 'RoleV2GQL' }
          & Pick<GqlRoleV2Gql, 'role_id' | 'role_name'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlProductFragment = (
  { __typename?: 'ProductItemV2GQL' }
  & Pick<GqlProductItemV2Gql, 'active' | 'product_item_name' | 'product_item_id' | 'base_price'>
  & { dynamic_price: Maybe<(
    { __typename?: 'DynamicPriceGQL' }
    & Pick<GqlDynamicPriceGql, 'base_price' | 'dynamic_price'>
  )>, units_of_measure: Maybe<Array<Maybe<(
    { __typename?: 'ProductItemUOMV2GQL' }
    & Pick<GqlProductItemUomv2Gql, 'active' | 'conversion_ratio'>
    & { business_domain: Maybe<(
      { __typename?: 'BusinessDomainV2GQL' }
      & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
    )>, uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'name' | 'uom_id'>
    )> }
  )>>>, product: Maybe<(
    { __typename?: 'ProductV2GQL' }
    & Pick<GqlProductV2Gql, 'active' | 'product_name' | 'product_id'>
    & { packaging_units: Maybe<Array<Maybe<(
      { __typename?: 'PackagingUnitV2GQL' }
      & Pick<GqlPackagingUnitV2Gql, 'active' | 'name' | 'weight' | 'packaging_unit_id'>
    )>>>, domain_activations: Maybe<Array<Maybe<(
      { __typename?: 'ProductDomainActivationV2GQL' }
      & { business_domain: Maybe<(
        { __typename?: 'BusinessDomainV2GQL' }
        & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
      )> }
    )>>> }
  )> }
);

export type GqlProductsV2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  productFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlProductsV2Query = (
  { __typename?: 'Query' }
  & { paginated_products_v2: Maybe<(
    { __typename?: 'ProductV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'active' | 'product_name' | 'product_id' | 'product_code' | 'product_type'>
        & { product_items: Maybe<Array<Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'base_price'>
          & { units_of_measure: Maybe<Array<Maybe<(
            { __typename?: 'ProductItemUOMV2GQL' }
            & Pick<GqlProductItemUomv2Gql, 'business_domain_id' | 'uom_id'>
            & { business_domain: Maybe<(
              { __typename?: 'BusinessDomainV2GQL' }
              & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name' | 'uom_id'>
            )> }
          )>>>, regions: Maybe<Array<Maybe<(
            { __typename?: 'ProductItemRegionV2GQL' }
            & Pick<GqlProductItemRegionV2Gql, 'region_id'>
            & { region: Maybe<(
              { __typename?: 'RegionV2GQL' }
              & Pick<GqlRegionV2Gql, 'region_name' | 'region_id'>
              & { country: Maybe<(
                { __typename?: 'CountryGQL' }
                & GqlCountryFragment
              )> }
            )> }
          )>>> }
        )>>>, packaging_units: Maybe<Array<Maybe<(
          { __typename?: 'PackagingUnitV2GQL' }
          & Pick<GqlPackagingUnitV2Gql, 'active' | 'name' | 'weight' | 'packaging_unit_id'>
        )>>>, domain_activations: Maybe<Array<Maybe<(
          { __typename?: 'ProductDomainActivationV2GQL' }
          & { business_domain: Maybe<(
            { __typename?: 'BusinessDomainV2GQL' }
            & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlProductItemsV2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  productItemFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlProductItemsV2Query = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & GqlProductFragment
      )> }
    )>> }
  )> }
);

export type GqlProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProductTypesQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'product_types_v2'>
);

export type GqlProductVarietiesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlProductVarietiesQuery = (
  { __typename?: 'Query' }
  & { product_varieties: Maybe<(
    { __typename?: 'ProductVarietyGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductVarietyGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductVarietyGQL' }
        & Pick<GqlProductVarietyGql, 'variety_name' | 'variety_code'>
      )> }
    )>> }
  )> }
);

export type GqlRolesV2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlRolesV2Query = (
  { __typename?: 'Query' }
  & { roles_v2: Maybe<(
    { __typename?: 'RoleV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'RoleV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RoleV2GQL' }
        & Pick<GqlRoleV2Gql, 'role_id' | 'role_name' | 'active'>
        & { permissions: Maybe<Array<Maybe<(
          { __typename?: 'PermissionV2GQL' }
          & Pick<GqlPermissionV2Gql, 'permission_id' | 'permission_name'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlUserV2ByIdQueryVariables = Exact<{
  user_id: Maybe<Scalars['String']>;
}>;


export type GqlUserV2ByIdQuery = (
  { __typename?: 'Query' }
  & { user_v2_by_id: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'date_created' | 'first_name' | 'last_name' | 'region_id' | 'default_country_id' | 'country_ids' | 'phone_number' | 'email' | 'active' | 'user_no'>
    & { region: Maybe<(
      { __typename?: 'RegionV2GQL' }
      & Pick<GqlRegionV2Gql, 'region_id' | 'region_name'>
    )>, roles: Maybe<Array<Maybe<(
      { __typename?: 'RoleV2GQL' }
      & Pick<GqlRoleV2Gql, 'role_id' | 'role_name'>
    )>>>, permissions: Maybe<Array<Maybe<(
      { __typename?: 'PermissionV2GQL' }
      & Pick<GqlPermissionV2Gql, 'permission_id' | 'permission_name'>
    )>>>, primary_role: Maybe<(
      { __typename?: 'RoleV2GQL' }
      & Pick<GqlRoleV2Gql, 'role_name' | 'role_id'>
      & { permissions: Maybe<Array<Maybe<(
        { __typename?: 'PermissionV2GQL' }
        & Pick<GqlPermissionV2Gql, 'permission_name' | 'permission_id'>
      )>>> }
    )>, permissions_blacklist: Maybe<Array<Maybe<(
      { __typename?: 'PermissionV2GQL' }
      & Pick<GqlPermissionV2Gql, 'permission_name' | 'permission_id'>
    )>>> }
  )> }
);

export type GqlUsersV2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlUsersV2Query = (
  { __typename?: 'Query' }
  & { users_v2: Maybe<(
    { __typename?: 'UserV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'UserV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'UserV2GQL' }
        & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'user_id' | 'user_no' | 'phone_number' | 'active' | 'country_ids' | 'default_country_id' | 'primary_role_id'>
        & { primary_role: Maybe<(
          { __typename?: 'RoleV2GQL' }
          & Pick<GqlRoleV2Gql, 'role_name'>
        )>, roles: Maybe<Array<Maybe<(
          { __typename?: 'RoleV2GQL' }
          & Pick<GqlRoleV2Gql, 'role_id' | 'role_name'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlGetDepotRestrictionsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlGetDepotRestrictionsQuery = (
  { __typename?: 'Query' }
  & { depot_dc_product_item_restrictions: Maybe<(
    { __typename?: 'DepotDCProductItemRestrictionGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DepotDCProductItemRestrictionGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DepotDCProductItemRestrictionGQL' }
        & Pick<GqlDepotDcProductItemRestrictionGql, 'depot_dc_product_item_restriction_id' | 'depot_id' | 'product_item_id' | 'distribution_center_ids'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name'>
          & { area: Maybe<(
            { __typename?: 'AreaV2GQL' }
            & { region: Maybe<(
              { __typename?: 'RegionV2GQL' }
              & Pick<GqlRegionV2Gql, 'region_id' | 'region_name'>
              & { country: Maybe<(
                { __typename?: 'CountryGQL' }
                & Pick<GqlCountryGql, 'country_id' | 'iso_alpha2_name'>
              )> }
            )> }
          )> }
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, distribution_centers: Array<Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name' | 'distribution_center_type' | 'distribution_center_id'>
        )>> }
      )> }
    )>> }
  )> }
);

export type GqlDistribution_CentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlDistribution_CentersQuery = (
  { __typename?: 'Query' }
  & { distribution_centers: Maybe<Array<Maybe<(
    { __typename?: 'DistributionCenterGQL' }
    & Pick<GqlDistributionCenterGql, 'date_created' | 'distribution_center_id' | 'distribution_center_name' | 'distribution_center_type' | 'description'>
  )>>> }
);

export type GqlFetchPseudoRoutesQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlFetchPseudoRoutesQuery = (
  { __typename?: 'Query' }
  & { pseudo_routes: Maybe<(
    { __typename?: 'PseudoRouteGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PseudoRouteGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PseudoRouteGQL' }
        & Pick<GqlPseudoRouteGql, 'active' | 'pseudo_route_id' | 'name' | 'merged_routes' | 'constraints' | 'custom_constraints' | 'force_share'>
        & { routes: Array<Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_id' | 'route_name'>
          & { depot: Maybe<(
            { __typename?: 'DepotV2GQL' }
            & Pick<GqlDepotV2Gql, 'depot_name'>
          )> }
        )>> }
      )> }
    )>>, page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )> }
  )> }
);

export type GqlFetchPseudoRouteByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GqlFetchPseudoRouteByNameQuery = (
  { __typename?: 'Query' }
  & { pseudo_route_by_id: Maybe<(
    { __typename?: 'PseudoRouteGQL' }
    & Pick<GqlPseudoRouteGql, 'pseudo_route_id'>
  )> }
);

export type GqlRoutesV2QueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlRoutesV2Query = (
  { __typename?: 'Query' }
  & { routes_v2: Maybe<(
    { __typename?: 'RouteV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'current_page' | 'has_next' | 'has_previous'>
    )>, edges: Array<Maybe<(
      { __typename?: 'RouteV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RouteV2GQL' }
        & Pick<GqlRouteV2Gql, 'route_name' | 'route_id' | 'date_created' | 'depot_id'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name' | 'depot_id' | 'area_id'>
          & { area: Maybe<(
            { __typename?: 'AreaV2GQL' }
            & Pick<GqlAreaV2Gql, 'area_name' | 'region_id'>
            & { region: Maybe<(
              { __typename?: 'RegionV2GQL' }
              & Pick<GqlRegionV2Gql, 'region_name'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlRouteTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlRouteTypesQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'route_types'>
);

export type GqlStorage_Unit_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlStorage_Unit_TypesQuery = (
  { __typename?: 'Query' }
  & { storage_unit_types: Maybe<Array<Maybe<(
    { __typename?: 'StorageUnitTypeGQL' }
    & Pick<GqlStorageUnitTypeGql, 'date_created' | 'storage_unit_type_id' | 'storage_unit_type'>
  )>>> }
);

export type GqlStorage_UnitsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlStorage_UnitsQuery = (
  { __typename?: 'Query' }
  & { storage_units: Maybe<(
    { __typename?: 'StorageUnitGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'StorageUnitGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StorageUnitGQL' }
        & Pick<GqlStorageUnitGql, 'date_created' | 'unit_name' | 'warehouse_id'>
        & { warehouse: Maybe<(
          { __typename?: 'WarehouseGQL' }
          & Pick<GqlWarehouseGql, 'warehouse_name' | 'distribution_center_id'>
          & { distribution_center: Maybe<(
            { __typename?: 'DistributionCenterGQL' }
            & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlWarehousesQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlWarehousesQuery = (
  { __typename?: 'Query' }
  & { warehouses: Maybe<(
    { __typename?: 'WarehouseGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'WarehouseGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WarehouseGQL' }
        & Pick<GqlWarehouseGql, 'warehouse_id' | 'warehouse_name' | 'distribution_center_id' | 'date_created'>
        & { distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_id' | 'distribution_center_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlSourcingAgentsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlSourcingAgentsQuery = (
  { __typename?: 'Query' }
  & { sourcing_agents: Maybe<(
    { __typename?: 'SourcingAgentGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'SourcingAgentGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'SourcingAgentGQL' }
        & Pick<GqlSourcingAgentGql, 'agent_id' | 'user_name' | 'date_created' | 'active' | 'farmer_id'>
        & { farmer: Maybe<(
          { __typename?: 'FarmerGQL' }
          & Pick<GqlFarmerGql, 'supplier_name' | 'first_name' | 'last_name' | 'phone_number' | 'batch_code' | 'country_id'>
          & { country: Maybe<(
            { __typename?: 'CountryGQL' }
            & Pick<GqlCountryGql, 'iso_alpha2_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlSourcingAgentByIdQueryVariables = Exact<{
  agent_id: Maybe<Scalars['String']>;
}>;


export type GqlSourcingAgentByIdQuery = (
  { __typename?: 'Query' }
  & { sourcing_agent_by_id: Maybe<(
    { __typename?: 'SourcingAgentGQL' }
    & Pick<GqlSourcingAgentGql, 'agent_id' | 'user_name' | 'active' | 'farmer_id'>
    & { farmer: Maybe<(
      { __typename?: 'FarmerGQL' }
      & Pick<GqlFarmerGql, 'supplier_name' | 'first_name' | 'last_name' | 'phone_number' | 'alt_phone_number' | 'batch_code' | 'farmer_type' | 'country_id'>
      & { country: Maybe<(
        { __typename?: 'CountryGQL' }
        & Pick<GqlCountryGql, 'iso_alpha2_name'>
      )> }
    )> }
  )> }
);

export type GqlBidApplicationsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlBidApplicationsQuery = (
  { __typename?: 'Query' }
  & { bid_applications: Maybe<(
    { __typename?: 'BidApplicationGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'BidApplicationGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BidApplicationGQL' }
        & Pick<GqlBidApplicationGql, 'quantity' | 'bid_application_number' | 'bid_application_date' | 'bid_application_id' | 'vehicle_registration' | 'delivery_date' | 'active' | 'unit_price' | 'agent_id' | 'product_item_id' | 'product_id' | 'unit_of_measure_id' | 'bid_application_status' | 'country_id' | 'currency' | 'latitude' | 'longitude'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
        )>, product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, agent: Maybe<(
          { __typename?: 'SourcingAgentGQL' }
          & Pick<GqlSourcingAgentGql, 'farmer_id'>
          & { farmer: Maybe<(
            { __typename?: 'FarmerGQL' }
            & Pick<GqlFarmerGql, 'supplier_name' | 'farmer_number' | 'first_name' | 'last_name' | 'phone_number'>
          )> }
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name' | 'abbreviation'>
        )>, country: Maybe<(
          { __typename?: 'CountryGQL' }
          & Pick<GqlCountryGql, 'iso_alpha2_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlBidsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlBidsQuery = (
  { __typename?: 'Query' }
  & { bids: Maybe<(
    { __typename?: 'BidGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'BidGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BidGQL' }
        & Pick<GqlBidGql, 'bid_id' | 'date_created' | 'opening_date' | 'closing_date' | 'bid_notes' | 'active' | 'minimum_quantity' | 'bid_application_lowest_price' | 'bid_application_count' | 'delivery_date' | 'bid_number' | 'opening_bid_price' | 'quantity' | 'bid_status' | 'product_item_id' | 'product_id' | 'unit_of_measure_id' | 'country_id'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
        )>, product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )>, country: Maybe<(
          { __typename?: 'CountryGQL' }
          & Pick<GqlCountryGql, 'iso_alpha2_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlBid_By_IdQueryVariables = Exact<{
  bid_id: Maybe<Scalars['String']>;
}>;


export type GqlBid_By_IdQuery = (
  { __typename?: 'Query' }
  & { bid_by_id: Maybe<(
    { __typename?: 'BidGQL' }
    & Pick<GqlBidGql, 'bid_id' | 'opening_date' | 'closing_date' | 'bid_notes' | 'active' | 'minimum_quantity' | 'bid_application_lowest_price' | 'delivery_date' | 'bid_number' | 'opening_bid_price' | 'quantity' | 'bid_status' | 'product_item_id' | 'product_id' | 'unit_of_measure_id' | 'country_id' | 'cancellation_reason' | 'currency'>
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_name'>
    )>, product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_name'>
    )>, uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'name'>
    )>, country: Maybe<(
      { __typename?: 'CountryGQL' }
      & Pick<GqlCountryGql, 'iso_alpha2_name'>
    )> }
  )> }
);

export type GqlSupplierUsersQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlSupplierUsersQuery = (
  { __typename?: 'Query' }
  & { supplier_users: Maybe<(
    { __typename?: 'SupplierUserGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'SupplierUserGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'SupplierUserGQL' }
        & Pick<GqlSupplierUserGql, 'supplier_user_id' | 'date_created' | 'user_id' | 'active'>
        & { user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'email' | 'phone_number' | 'user_no'>
        )>, supplier: Maybe<(
          { __typename?: 'FarmerGQL' }
          & Pick<GqlFarmerGql, 'farmer_number' | 'supplier_name' | 'first_name' | 'last_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlGetClustersQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlGetClustersQuery = (
  { __typename?: 'Query' }
  & { clusters: Maybe<(
    { __typename?: 'SalesAgentClusterGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'SalesAgentClusterGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'SalesAgentClusterGQL' }
        & Pick<GqlSalesAgentClusterGql, 'date_created' | 'depot_name' | 'depot_code' | 'cluster_code' | 'cluster_number' | 'cluster_id'>
      )> }
    )>>, page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )> }
  )> }
);

export type GqlGetClusterAssignmentsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  perPage: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
}>;


export type GqlGetClusterAssignmentsQuery = (
  { __typename?: 'Query' }
  & { cluster_assignments: Maybe<(
    { __typename?: 'ClusterAssignmentGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ClusterAssignmentGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ClusterAssignmentGQL' }
        & Pick<GqlClusterAssignmentGql, 'assignment_id' | 'date_created' | 'active' | 'agent_id'>
        & { cluster: Maybe<(
          { __typename?: 'SalesAgentClusterGQL' }
          & Pick<GqlSalesAgentClusterGql, 'depot_name' | 'depot_id' | 'depot_code' | 'cluster_code' | 'cluster_number'>
        )>, agent: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'last_name' | 'first_name' | 'phone_number'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDeliveryDetailsFragment = (
  { __typename?: 'DeliveryV2GQL' }
  & Pick<GqlDeliveryV2Gql, 'delivery_number' | 'delivery_date' | 'date_created' | 'active' | 'amount' | 'currency' | 'route_id' | 'shop_id'>
  & { served_by: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
  )>, route: Maybe<(
    { __typename?: 'RouteV2GQL' }
    & Pick<GqlRouteV2Gql, 'route_name'>
  )>, shop: Maybe<(
    { __typename?: 'ShopV2GQL' }
    & Pick<GqlShopV2Gql, 'shop_id' | 'shop_number' | 'shop_name' | 'delivery_fee' | 'customer_id'>
    & { customer: Maybe<(
      { __typename?: 'CustomerV2GQL' }
      & Pick<GqlCustomerV2Gql, 'customer_name' | 'phone_number'>
    )> }
  )> }
);

export type GqlDeliveriesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  deliveryFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDeliveriesQuery = (
  { __typename?: 'Query' }
  & { deliveries_v2: Maybe<(
    { __typename?: 'DeliveryV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DeliveryV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DeliveryV2GQL' }
        & Pick<GqlDeliveryV2Gql, 'delivery_id'>
        & { payments: Maybe<Array<Maybe<(
          { __typename?: 'PaymentV2GQL' }
          & Pick<GqlPaymentV2Gql, 'payment_id' | 'amount' | 'currency'>
        )>>> }
        & GqlDeliveryDetailsFragment
      )> }
    )>> }
  )> }
);

export type GqlDelivery_V2_By_IdQueryVariables = Exact<{
  deliveryId: Scalars['String'];
}>;


export type GqlDelivery_V2_By_IdQuery = (
  { __typename?: 'Query' }
  & { delivery_v2_by_id: Maybe<(
    { __typename?: 'DeliveryV2GQL' }
    & Pick<GqlDeliveryV2Gql, 'delivery_id' | 'cancellation_reason' | 'amount' | 'currency' | 'active'>
    & { delivery_items: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryItemV2GQL' }
      & Pick<GqlDeliveryItemV2Gql, 'product_item_id' | 'unit_price' | 'amount' | 'currency' | 'quantity' | 'unit_of_measure_id'>
      & { product_item: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_item_name'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )> }
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name' | 'abbreviation'>
      )> }
    )>>>, payments: Maybe<Array<Maybe<(
      { __typename?: 'PaymentV2GQL' }
      & Pick<GqlPaymentV2Gql, 'payment_id' | 'reference_number' | 'payment_number' | 'payment_mode' | 'date_created' | 'amount' | 'currency'>
    )>>> }
    & GqlDeliveryDetailsFragment
  )> }
);

export type GqlDeliveryReturnsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDeliveryReturnsQuery = (
  { __typename?: 'Query' }
  & { delivery_returns: Maybe<(
    { __typename?: 'DeliveryReturnGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'has_next' | 'has_previous'>
    )>, edges: Array<Maybe<(
      { __typename?: 'DeliveryReturnGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DeliveryReturnGQL' }
        & Pick<GqlDeliveryReturnGql, 'return_id' | 'return_number' | 'return_date' | 'currency' | 'active' | 'shop_id' | 'claim_processed' | 'refund_status'>
        & { delivery: Maybe<(
          { __typename?: 'DeliveryV2GQL' }
          & Pick<GqlDeliveryV2Gql, 'delivery_date' | 'delivery_id' | 'delivery_number'>
          & { delivery_status: Maybe<Array<Maybe<(
            { __typename?: 'DeliveryStatusV2GQL' }
            & Pick<GqlDeliveryStatusV2Gql, 'delivery_status'>
          )>>> }
        )>, return_items: Maybe<Array<Maybe<(
          { __typename?: 'DeliveryReturnItemGQL' }
          & Pick<GqlDeliveryReturnItemGql, 'approved_by' | 'approved_amount' | 'approved_quantity' | 'comment' | 'approved' | 'image' | 'active' | 'return_item_id' | 'quantity' | 'amount' | 'currency' | 'signed_image_url' | 'unit_of_measure_id' | 'product_item_id' | 'rejection_reason_id'>
          & { approved_by_user: Maybe<(
            { __typename?: 'UserV2GQL' }
            & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )>, reason: Maybe<(
            { __typename?: 'ReturnReasonGQL' }
            & Pick<GqlReturnReasonGql, 'name' | 'description'>
          )>, rejection_reason: Maybe<(
            { __typename?: 'ReturnItemRejectionReasonGQL' }
            & Pick<GqlReturnItemRejectionReasonGql, 'name'>
          )> }
        )>>>, shop: Maybe<(
          { __typename?: 'ShopV2GQL' }
          & Pick<GqlShopV2Gql, 'shop_name' | 'shop_number' | 'signed_image_url' | 'route_id' | 'customer_id'>
          & { region: Maybe<(
            { __typename?: 'RegionV2GQL' }
            & Pick<GqlRegionV2Gql, 'region_name'>
          )>, route: Maybe<(
            { __typename?: 'RouteV2GQL' }
            & Pick<GqlRouteV2Gql, 'route_name'>
            & { depot: Maybe<(
              { __typename?: 'DepotV2GQL' }
              & Pick<GqlDepotV2Gql, 'depot_name'>
            )> }
          )>, customer: Maybe<(
            { __typename?: 'CustomerV2GQL' }
            & Pick<GqlCustomerV2Gql, 'customer_name' | 'phone_number'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlReturnItemRejectionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlReturnItemRejectionReasonsQuery = (
  { __typename?: 'Query' }
  & { return_item_rejection_reasons: Maybe<Array<Maybe<(
    { __typename?: 'ReturnItemRejectionReasonGQL' }
    & Pick<GqlReturnItemRejectionReasonGql, 'rejection_reason_id' | 'name' | 'description'>
  )>>> }
);

export type GqlDepotIntakeQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  filterArray: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDepotIntakeQuery = (
  { __typename?: 'Query' }
  & { depot_intake: Maybe<(
    { __typename?: 'DepotIntakeGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DepotIntakeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DepotIntakeGQL' }
        & Pick<GqlDepotIntakeGql, 'depot_intake_id' | 'depot_intake_number' | 'cancellation_reason' | 'active' | 'sale_date' | 'route_id' | 'created_by'>
        & { depot_intake_items: Maybe<Array<Maybe<(
          { __typename?: 'DepotIntakeItemGQL' }
          & Pick<GqlDepotIntakeItemGql, 'depot_intake_item_id' | 'packaging_unit_id' | 'packaging_unit_quantity' | 'quantity' | 'unit_of_measure_id' | 'product_item_id'>
          & { uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'abbreviation'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
              & { packaging_units: Maybe<Array<Maybe<(
                { __typename?: 'PackagingUnitV2GQL' }
                & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'name'>
              )>>> }
            )> }
          )> }
        )>>>, user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'phone_number' | 'user_no' | 'user_id'>
        )>, route: Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_name' | 'route_id' | 'depot_id'>
          & { depot: Maybe<(
            { __typename?: 'DepotV2GQL' }
            & Pick<GqlDepotV2Gql, 'depot_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDepotReturnsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filterArray: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDepotReturnsQuery = (
  { __typename?: 'Query' }
  & { returns: Maybe<(
    { __typename?: 'ReturnGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ReturnGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ReturnGQL' }
        & Pick<GqlReturnGql, 'return_id' | 'return_number' | 'sale_date' | 'created_by' | 'active' | 'depot_id' | 'route_id'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name'>
        )>, user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'phone_number' | 'user_number' | 'user_id'>
        )>, packaging_return_items: Maybe<Array<Maybe<(
          { __typename?: 'PackagingReturnItemGQL' }
          & Pick<GqlPackagingReturnItemGql, 'packaging_return_item_id' | 'active' | 'cancellation_reason' | 'packaging_unit_id' | 'quantity'>
          & { packaging_unit: Maybe<(
            { __typename?: 'PackagingUnitV2GQL' }
            & Pick<GqlPackagingUnitV2Gql, 'name'>
          )> }
        )>>>, product_return_items: Maybe<Array<Maybe<(
          { __typename?: 'ProductReturnItemGQL' }
          & Pick<GqlProductReturnItemGql, 'active' | 'cancellation_reason' | 'return_type' | 'product_item_id' | 'product_return_item_id' | 'quantity' | 'unit_of_measure_id'>
          & { uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'abbreviation'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )> }
        )>>>, route: Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockTransferQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  filterArray: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlStockTransferQuery = (
  { __typename?: 'Query' }
  & { stock_transfer: Maybe<(
    { __typename?: 'StockTransferGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'StockTransferGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockTransferGQL' }
        & Pick<GqlStockTransferGql, 'stock_transfer_id' | 'stock_transfer_number' | 'active' | 'sale_date' | 'route_id_from' | 'product_item_id' | 'created_by'>
        & { route_from: Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_name' | 'depot_id'>
          & { depot: Maybe<(
            { __typename?: 'DepotV2GQL' }
            & Pick<GqlDepotV2Gql, 'depot_name'>
          )> }
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, stock_transfer_items: Maybe<Array<Maybe<(
          { __typename?: 'StockTransferItemGQL' }
          & Pick<GqlStockTransferItemGql, 'route_id_to' | 'stock_transfer_item_id' | 'unit_of_measure_id' | 'quantity' | 'packaging_unit_id' | 'packaging_unit_quantity'>
          & { route_to: Maybe<(
            { __typename?: 'RouteV2GQL' }
            & Pick<GqlRouteV2Gql, 'route_name'>
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'abbreviation'>
          )>, packaging_unit: Maybe<(
            { __typename?: 'PackagingUnitV2GQL' }
            & Pick<GqlPackagingUnitV2Gql, 'name'>
          )> }
        )>>>, user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDispatchBalanceQueryVariables = Exact<{
  route_id_from: Maybe<Scalars['String']>;
  saleDate: Maybe<Scalars['String']>;
  product_item_id: Maybe<Scalars['String']>;
}>;


export type GqlDispatchBalanceQuery = (
  { __typename?: 'Query' }
  & { dispatch_balance: Maybe<(
    { __typename?: 'DispatchBalanceGQL' }
    & Pick<GqlDispatchBalanceGql, 'date' | 'route_id' | 'stock_balance' | 'packaging_balance' | 'product_item_id'>
  )> }
);

export type GqlOrdersQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlOrdersQuery = (
  { __typename?: 'Query' }
  & { orders_v2: Maybe<(
    { __typename?: 'OrderV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'OrderV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'OrderV2GQL' }
        & Pick<GqlOrderV2Gql, 'priority' | 'order_number' | 'order_id' | 'shop_id' | 'active' | 'cancellation_reason' | 'currency' | 'trader_entity_user_id' | 'route_id' | 'amount' | 'delivery_date' | 'order_date'>
        & { shop: Maybe<(
          { __typename?: 'ShopV2GQL' }
          & Pick<GqlShopV2Gql, 'shop_name' | 'shop_number'>
        )>, served_by: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'user_id' | 'first_name' | 'last_name' | 'user_no' | 'phone_number'>
        )>, route: Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_name'>
        )>, order_items: Maybe<Array<Maybe<(
          { __typename?: 'OrderItemV2GQL' }
          & Pick<GqlOrderItemV2Gql, 'product_item_id' | 'amount' | 'currency' | 'unit_price' | 'quantity' | 'unit_of_measure_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'uom_id' | 'name'>
          )> }
        )>>> }
      )> }
    )>>, page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )> }
  )> }
);

export type GqlCustomerDetailsFragment = (
  { __typename?: 'ShopV2GQL' }
  & { customer: Maybe<(
    { __typename?: 'CustomerV2GQL' }
    & Pick<GqlCustomerV2Gql, 'customer_id' | 'phone_number' | 'customer_name'>
  )> }
);

export type GqlShopDetailsFragment = (
  { __typename?: 'ShopV2GQL' }
  & Pick<GqlShopV2Gql, 'shop_id' | 'shop_number' | 'shop_name' | 'active' | 'shop_type_id' | 'updated_by' | 'region_id' | 'route_id'>
  & { shop_type: Maybe<(
    { __typename?: 'ShopTypeV2GQL' }
    & Pick<GqlShopTypeV2Gql, 'name'>
  )>, country: Maybe<(
    { __typename?: 'CountryGQL' }
    & Pick<GqlCountryGql, 'default_currency'>
  )>, distribution_centers: Maybe<Array<Maybe<(
    { __typename?: 'DepotDistributionCenterGQL' }
    & Pick<GqlDepotDistributionCenterGql, 'distribution_center_id'>
  )>>>, updated_by_user: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'user_id'>
  )>, route: Maybe<(
    { __typename?: 'RouteV2GQL' }
    & Pick<GqlRouteV2Gql, 'route_id' | 'route_name' | 'depot_id'>
    & { depot: Maybe<(
      { __typename?: 'DepotV2GQL' }
      & Pick<GqlDepotV2Gql, 'depot_name'>
    )> }
  )> }
);

export type GqlShopsV2QueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlShopsV2Query = (
  { __typename?: 'Query' }
  & { shops_v2: Maybe<(
    { __typename?: 'ShopV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ShopV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ShopV2GQL' }
        & Pick<GqlShopV2Gql, 'customer_id' | 'approved' | 'signed_image_url'>
        & { customer_types: Maybe<Array<Maybe<(
          { __typename?: 'CustomerTypeV2GQL' }
          & Pick<GqlCustomerTypeV2Gql, 'customer_type_id' | 'name'>
        )>>> }
        & GqlShopDetailsFragment
        & GqlCustomerDetailsFragment
      )> }
    )>>, page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )> }
  )> }
);

export type GqlShopByIdQueryVariables = Exact<{
  shop_id: Scalars['String'];
}>;


export type GqlShopByIdQuery = (
  { __typename?: 'Query' }
  & { shop_v2_by_id: Maybe<(
    { __typename?: 'ShopV2GQL' }
    & Pick<GqlShopV2Gql, 'region_id' | 'kra_pin' | 'customer_id'>
    & { region: Maybe<(
      { __typename?: 'RegionV2GQL' }
      & Pick<GqlRegionV2Gql, 'region_name'>
    )>, customer_types: Maybe<Array<Maybe<(
      { __typename?: 'CustomerTypeV2GQL' }
      & Pick<GqlCustomerTypeV2Gql, 'customer_type_id' | 'name'>
    )>>> }
    & GqlShopDetailsFragment
    & GqlCustomerDetailsFragment
  )> }
);

export type GqlShopTypesV2QueryVariables = Exact<{
  grouped: Maybe<Scalars['Boolean']>;
}>;


export type GqlShopTypesV2Query = (
  { __typename?: 'Query' }
  & { shop_types_v2: Maybe<Array<Maybe<(
    { __typename?: 'ShopTypeV2GQL' }
    & Pick<GqlShopTypeV2Gql, 'shop_type_id' | 'name' | 'active'>
    & { children: Maybe<Array<Maybe<(
      { __typename?: 'ShopTypeV2GQL' }
      & Pick<GqlShopTypeV2Gql, 'shop_type_id' | 'name' | 'active'>
    )>>> }
  )>>> }
);

export type GqlCustomerTypesV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GqlCustomerTypesV2Query = (
  { __typename?: 'Query' }
  & { customer_types_v2: Maybe<Array<Maybe<(
    { __typename?: 'CustomerTypeV2GQL' }
    & Pick<GqlCustomerTypeV2Gql, 'customer_type_id' | 'name'>
  )>>> }
);

export type GqlDeliveryItemWarrantiesQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDeliveryItemWarrantiesQuery = (
  { __typename?: 'Query' }
  & { delivery_item_warranties: Maybe<(
    { __typename?: 'DeliveryItemWarrantyGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DeliveryItemWarrantyGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DeliveryItemWarrantyGQL' }
        & Pick<GqlDeliveryItemWarrantyGql, 'warranty_id' | 'serial_number' | 'delivery_item_id' | 'image_url'>
        & { delivery_item: Maybe<(
          { __typename?: 'DeliveryItemV2GQL' }
          & Pick<GqlDeliveryItemV2Gql, 'product_item_id' | 'unit_price' | 'amount' | 'quantity'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )>, delivery: Maybe<(
            { __typename?: 'DeliveryV2GQL' }
            & Pick<GqlDeliveryV2Gql, 'delivery_number' | 'delivery_date' | 'route_id'>
            & { route: Maybe<(
              { __typename?: 'RouteV2GQL' }
              & Pick<GqlRouteV2Gql, 'route_name'>
            )>, shop: Maybe<(
              { __typename?: 'ShopV2GQL' }
              & Pick<GqlShopV2Gql, 'shop_number'>
              & { customer: Maybe<(
                { __typename?: 'CustomerV2GQL' }
                & Pick<GqlCustomerV2Gql, 'phone_number'>
              )> }
            )> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlFarmersQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlFarmersQuery = (
  { __typename?: 'Query' }
  & { farmers: Maybe<(
    { __typename?: 'FarmerGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'has_next' | 'has_previous' | 'per_page' | 'total_pages' | 'total_count' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'FarmerGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'FarmerGQL' }
        & Pick<GqlFarmerGql, 'farmer_type' | 'farmer_id' | 'farmer_number' | 'first_name' | 'last_name' | 'supplier_name' | 'active'>
      )> }
    )>> }
  )> }
);

export type GqlVehicleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlVehicleTypesQuery = (
  { __typename?: 'Query' }
  & { vehicle_types: Maybe<(
    { __typename?: 'VehicleTypeGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'VehicleTypeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'VehicleTypeGQL' }
        & Pick<GqlVehicleTypeGql, 'vehicle_type_id' | 'vehicle_type_name'>
      )> }
    )>> }
  )> }
);

export type GqlInventory_LocationsQueryVariables = Exact<{
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlInventory_LocationsQuery = (
  { __typename?: 'Query' }
  & { inventory_locations: Maybe<(
    { __typename?: 'InventoryLocationGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'InventoryLocationGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'InventoryLocationGQL' }
        & Pick<GqlInventoryLocationGql, 'inventory_location_id' | 'inventory_location_name' | 'inventory_location_type'>
      )> }
    )>> }
  )> }
);

export type GqlVehicle_SuppliersQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlVehicle_SuppliersQuery = (
  { __typename?: 'Query' }
  & { vehicle_suppliers: Maybe<(
    { __typename?: 'VehicleSupplierGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'VehicleSupplierGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'VehicleSupplierGQL' }
        & Pick<GqlVehicleSupplierGql, 'name' | 'active' | 'date_created' | 'email' | 'vehicle_supplier_id' | 'phone_number' | 'alt_phone_number' | 'country_id' | 'supplier_number'>
        & { country: Maybe<(
          { __typename?: 'CountryGQL' }
          & Pick<GqlCountryGql, 'iso_alpha2_name'>
        )>, vehicles: Maybe<Array<Maybe<(
          { __typename?: 'VehicleGQL' }
          & Pick<GqlVehicleGql, 'vehicle_id'>
        )>>>, payment_accounts: Maybe<Array<Maybe<(
          { __typename?: 'VehicleSupplierPaymentAccountGQL' }
          & Pick<GqlVehicleSupplierPaymentAccountGql, 'vehicle_supplier_id' | 'vehicle_supplier_payment_account_id' | 'account_type' | 'account_name' | 'party' | 'account_number' | 'is_primary'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlCost_ModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlCost_ModelQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'vehicle_cost_models'>
);

export type GqlVehicle_Rejection_ReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlVehicle_Rejection_ReasonsQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'vehicle_rejection_reasons'>
);

export type GqlSupplierVehiclesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlSupplierVehiclesQuery = (
  { __typename?: 'Query' }
  & { vehicles: Maybe<(
    { __typename?: 'VehicleGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'VehicleGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'VehicleGQL' }
        & Pick<GqlVehicleGql, 'vehicle_id' | 'vehicle_supplier_id' | 'date_created' | 'registration_number' | 'logistics_type' | 'region_id' | 'cost_rate' | 'load_capacity' | 'insurance_expiry_date' | 'service_due_date' | 'capacity_volume' | 'active' | 'vehicle_cost_model' | 'rejection_reason' | 'rejected'>
        & { vehicle_type: Maybe<(
          { __typename?: 'VehicleTypeGQL' }
          & Pick<GqlVehicleTypeGql, 'vehicle_type_name' | 'vehicle_type_id'>
        )>, region: Maybe<(
          { __typename?: 'RegionV2GQL' }
          & Pick<GqlRegionV2Gql, 'region_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlTripsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlTripsQuery = (
  { __typename?: 'Query' }
  & { trips: Maybe<(
    { __typename?: 'TripGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'TripGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'TripGQL' }
        & Pick<GqlTripGql, 'trip_id' | 'active' | 'logistics_type' | 'starting_odometer' | 'closing_odometer' | 'starting_date' | 'end_date' | 'region_id' | 'from_location' | 'to_location' | 'weight' | 'cost_rate' | 'vehicle_cost_model' | 'distance' | 'cost' | 'total_cost' | 'variable_cost' | 'has_statement'>
        & { route_plan: Maybe<Array<Maybe<(
          { __typename?: 'RoutePlanGQL' }
          & Pick<GqlRoutePlanGql, 'route_plan_id' | 'depot_id' | 'route_id'>
          & { depot: Maybe<(
            { __typename?: 'DepotV2GQL' }
            & Pick<GqlDepotV2Gql, 'depot_name'>
          )>, route: Maybe<(
            { __typename?: 'RouteV2GQL' }
            & Pick<GqlRouteV2Gql, 'route_name'>
          )> }
        )>>>, vehicle: Maybe<(
          { __typename?: 'VehicleGQL' }
          & Pick<GqlVehicleGql, 'registration_number' | 'logistics_type' | 'load_capacity' | 'usable_load_capacity'>
          & { vehicle_supplier: Maybe<(
            { __typename?: 'VehicleSupplierGQL' }
            & Pick<GqlVehicleSupplierGql, 'name'>
          )> }
        )>, region: Maybe<(
          { __typename?: 'RegionV2GQL' }
          & Pick<GqlRegionV2Gql, 'region_name'>
        )>, from_inventory_location: Maybe<(
          { __typename?: 'InventoryLocationGQL' }
          & Pick<GqlInventoryLocationGql, 'inventory_location_name'>
        )>, to_inventory_location: Maybe<(
          { __typename?: 'InventoryLocationGQL' }
          & Pick<GqlInventoryLocationGql, 'inventory_location_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlSupplierStatementsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlSupplierStatementsQuery = (
  { __typename?: 'Query' }
  & { vehicle_supplier_statements: Maybe<(
    { __typename?: 'VehicleSupplierStatementGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'VehicleSupplierStatementGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'VehicleSupplierStatementGQL' }
        & Pick<GqlVehicleSupplierStatementGql, 'active' | 'statement_id' | 'statement_number' | 'invoice_amount' | 'vehicle_supplier_id' | 'amount' | 'approval_status' | 'approved_by' | 'date_from' | 'date_to' | 'date_created' | 'created_by' | 'payment_status'>
        & { vehicle_supplier: Maybe<(
          { __typename?: 'VehicleSupplierGQL' }
          & Pick<GqlVehicleSupplierGql, 'name' | 'country_id'>
          & { country: Maybe<(
            { __typename?: 'CountryGQL' }
            & Pick<GqlCountryGql, 'iso_alpha2_code' | 'iso_alpha2_name'>
          )> }
        )>, created_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )>, approved_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlOrdering_WindowsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlOrdering_WindowsQuery = (
  { __typename?: 'Query' }
  & { ordering_windows: Maybe<(
    { __typename?: 'OrderingWindowGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'OrderingWindowGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'OrderingWindowGQL' }
        & Pick<GqlOrderingWindowGql, 'ordering_window_id' | 'active' | 'region_id' | 'channel' | 'depot_id'>
        & { region: Maybe<(
          { __typename?: 'RegionV2GQL' }
          & Pick<GqlRegionV2Gql, 'region_name' | 'region_id'>
        )>, depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name'>
        )>, ordering_window_items: Maybe<Array<Maybe<(
          { __typename?: 'OrderingWindowItemGQL' }
          & Pick<GqlOrderingWindowItemGql, 'active' | 'ordering_window_item_id' | 'day' | 'opening_time' | 'closing_time'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlPayment_VisibilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlPayment_VisibilitiesQuery = (
  { __typename?: 'Query' }
  & { payment_visibilities: Maybe<Array<Maybe<(
    { __typename?: 'PaymentVisibilityGQL' }
    & Pick<GqlPaymentVisibilityGql, 'payment_visibility_id' | 'region_id' | 'channel' | 'visible' | 'active'>
    & { payment_method: Maybe<(
      { __typename?: 'PaymentMethodGQL' }
      & Pick<GqlPaymentMethodGql, 'description' | 'payment_method_id' | 'payment_method_name'>
    )> }
  )>>> }
);

export type GqlPromo_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlPromo_TypesQuery = (
  { __typename?: 'Query' }
  & { promotion_types: Maybe<Array<Maybe<(
    { __typename?: 'PromotionTypeGQL' }
    & Pick<GqlPromotionTypeGql, 'promotion_type_id' | 'title' | 'active' | 'background_color'>
  )>>> }
);

export type GqlAdd_PromoMutationVariables = Exact<{
  title: Scalars['String'];
  background_color: Scalars['String'];
}>;


export type GqlAdd_PromoMutation = (
  { __typename?: 'Mutation' }
  & { add_promotion_type: Maybe<(
    { __typename?: 'CreatePromotionType' }
    & { promotion_type: Maybe<(
      { __typename?: 'PromotionTypeGQL' }
      & Pick<GqlPromotionTypeGql, 'promotion_type_id' | 'title' | 'background_color'>
    )> }
  )> }
);

export type GqlUpdate_Promotion_TypeMutationVariables = Exact<{
  promotion_type_id: Scalars['String'];
  data: GqlPromotionTypeInput;
}>;


export type GqlUpdate_Promotion_TypeMutation = (
  { __typename?: 'Mutation' }
  & { update_promotion_type: Maybe<(
    { __typename?: 'UpdatePromotionType' }
    & { promotion_type: Maybe<(
      { __typename?: 'PromotionTypeGQL' }
      & Pick<GqlPromotionTypeGql, 'promotion_type_id' | 'title' | 'background_color'>
    )> }
  )> }
);

export type GqlProduct_Items_With_TagsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlProduct_Items_With_TagsQuery = (
  { __typename?: 'Query' }
  & { product_items_with_tags: Maybe<Array<Maybe<(
    { __typename?: 'PromotionTagGQL' }
    & Pick<GqlPromotionTagGql, 'promotion_tag_id' | 'promotion_type_id' | 'active' | 'region_ids' | 'start_date' | 'end_date' | 'product_item_id'>
    & { promotion_type: Maybe<(
      { __typename?: 'PromotionTypeGQL' }
      & Pick<GqlPromotionTypeGql, 'title' | 'background_color'>
    )>, product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_name'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_name'>
      )> }
    )> }
  )>>> }
);

export type GqlPromotion_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlPromotion_TypesQuery = (
  { __typename?: 'Query' }
  & { promotion_types: Maybe<Array<Maybe<(
    { __typename?: 'PromotionTypeGQL' }
    & Pick<GqlPromotionTypeGql, 'promotion_type_id' | 'title'>
  )>>> }
);

export type GqlAdd_Promotion_TagMutationVariables = Exact<{
  product_item_id: Scalars['String'];
  promotion_type_id: Maybe<Scalars['String']>;
  region_ids: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  start_date: Maybe<Scalars['String']>;
  end_date: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['GenericScalar']>;
  country_id: Scalars['String'];
}>;


export type GqlAdd_Promotion_TagMutation = (
  { __typename?: 'Mutation' }
  & { add_promotion_tag: Maybe<(
    { __typename?: 'CreatePromotionTag' }
    & Pick<GqlCreatePromotionTag, 'created'>
    & { promotion_tag: Maybe<(
      { __typename?: 'PromotionTagGQL' }
      & Pick<GqlPromotionTagGql, 'promotion_tag_id' | 'product_item_id' | 'region_ids' | 'start_date' | 'end_date'>
    )> }
  )> }
);

export type GqlUpdate_Promotion_TagMutationVariables = Exact<{
  promotion_tag_id: Scalars['String'];
  data: GqlPromotionTagInput;
}>;


export type GqlUpdate_Promotion_TagMutation = (
  { __typename?: 'Mutation' }
  & { update_promotion_tag: Maybe<(
    { __typename?: 'UpdatePromotionTag' }
    & { promotion_tag: Maybe<(
      { __typename?: 'PromotionTagGQL' }
      & Pick<GqlPromotionTagGql, 'promotion_tag_id' | 'product_item_id' | 'region_ids' | 'start_date' | 'end_date'>
    )> }
  )> }
);

export type GqlUserFeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlUserFeedbackQuery = (
  { __typename?: 'Query' }
  & { agent_feedback: Maybe<(
    { __typename?: 'AgentFeedbackGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AgentFeedbackGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'AgentFeedbackGQL' }
        & Pick<GqlAgentFeedbackGql, 'client_stamp'>
      )> }
    )>> }
  )> }
);

export type GqlBase_PricingQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  regionId: Scalars['String'];
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlBase_PricingQuery = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, units_of_measure: Maybe<Array<Maybe<(
          { __typename?: 'ProductItemUOMV2GQL' }
          & Pick<GqlProductItemUomv2Gql, 'business_domain_id'>
          & { business_domain: Maybe<(
            { __typename?: 'BusinessDomainV2GQL' }
            & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'uom_id' | 'name'>
          )> }
        )>>>, current_pricing_v2: Maybe<(
          { __typename?: 'PricingV2GQL' }
          & Pick<GqlPricingV2Gql, 'unit_of_measure_id' | 'base_price' | 'currency' | 'rrp' | 'pricing_date' | 'region_id'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlPricingQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlPricingQuery = (
  { __typename?: 'Query' }
  & { pricing_v2: Maybe<(
    { __typename?: 'PricingV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PricingV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PricingV2GQL' }
        & Pick<GqlPricingV2Gql, 'date_updated' | 'updated_by' | 'base_price' | 'currency' | 'rrp'>
        & { user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlProduct_Departments_V2QueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProduct_Departments_V2Query = (
  { __typename?: 'Query' }
  & { product_departments_v2: Maybe<Array<Maybe<(
    { __typename?: 'DepartmentV2GQL' }
    & Pick<GqlDepartmentV2Gql, 'department_id' | 'department_name'>
  )>>> }
);

export type GqlPaginated_Products_V2QueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
}>;


export type GqlPaginated_Products_V2Query = (
  { __typename?: 'Query' }
  & { paginated_products_v2: Maybe<(
    { __typename?: 'ProductV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_id' | 'product_name' | 'product_type'>
        & { product_items: Maybe<Array<Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlAdd_CategoryMutationVariables = Exact<{
  data: GqlCategoryInput;
}>;


export type GqlAdd_CategoryMutation = (
  { __typename?: 'Mutation' }
  & { add_category: Maybe<(
    { __typename?: 'CreateCategory' }
    & Pick<GqlCreateCategory, 'created'>
    & { category: Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name' | 'department_id'>
    )> }
  )> }
);

export type GqlProduct_CategoriesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
}>;


export type GqlProduct_CategoriesQuery = (
  { __typename?: 'Query' }
  & { product_categories_v2: Maybe<Array<Maybe<(
    { __typename?: 'CategoryV2GQL' }
    & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name' | 'image_url' | 'banner_image_url' | 'date_updated' | 'active' | 'total_products' | 'department_id'>
    & { products: Maybe<Array<Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_id' | 'product_name'>
    )>>>, sub_categories: Maybe<Array<Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name' | 'image_url' | 'active' | 'total_products'>
    )>>>, department: Maybe<(
      { __typename?: 'DepartmentV2GQL' }
      & Pick<GqlDepartmentV2Gql, 'department_id' | 'department_name'>
    )> }
  )>>> }
);

export type GqlUpdate_CategoryMutationVariables = Exact<{
  category_id: Scalars['String'];
  data: GqlCategoryInput;
}>;


export type GqlUpdate_CategoryMutation = (
  { __typename?: 'Mutation' }
  & { update_category: Maybe<(
    { __typename?: 'UpdateCategory' }
    & { category: Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'category_id' | 'active'>
    )> }
  )> }
);

export type GqlUpload_Category_ImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  category_id: Scalars['String'];
}>;


export type GqlUpload_Category_ImageMutation = (
  { __typename?: 'Mutation' }
  & { upload_category_image: Maybe<(
    { __typename?: 'UploadCategoryImage' }
    & Pick<GqlUploadCategoryImage, 'uploaded'>
    & { category: Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'image_url'>
    )> }
  )> }
);

export type GqlProduct_Category_V2_By_IdQueryVariables = Exact<{
  category_id: Scalars['String'];
}>;


export type GqlProduct_Category_V2_By_IdQuery = (
  { __typename?: 'Query' }
  & { product_category_v2_by_id: Maybe<(
    { __typename?: 'CategoryV2GQL' }
    & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name' | 'image_url' | 'active' | 'parent_id' | 'ordering_window' | 'department_id' | 'total_regions'>
    & { department: Maybe<(
      { __typename?: 'DepartmentV2GQL' }
      & Pick<GqlDepartmentV2Gql, 'department_name' | 'department_id'>
    )>, products: Maybe<Array<Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_id' | 'product_name'>
    )>>>, regions: Maybe<Array<Maybe<(
      { __typename?: 'CategoryRegionV2GQL' }
      & Pick<GqlCategoryRegionV2Gql, 'active' | 'category_region_id' | 'region_id'>
      & { region: Maybe<(
        { __typename?: 'RegionV2GQL' }
        & Pick<GqlRegionV2Gql, 'region_id' | 'region_name'>
      )> }
    )>>> }
  )> }
);

export type GqlAdd_Category_RegionMutationVariables = Exact<{
  category_id: Scalars['String'];
  region_id: Scalars['String'];
}>;


export type GqlAdd_Category_RegionMutation = (
  { __typename?: 'Mutation' }
  & { add_category_region: Maybe<(
    { __typename?: 'CreateCategoryRegion' }
    & Pick<GqlCreateCategoryRegion, 'created'>
    & { category_region: Maybe<(
      { __typename?: 'CategoryRegionV2GQL' }
      & Pick<GqlCategoryRegionV2Gql, 'category_region_id' | 'category_id' | 'region_id'>
    )> }
  )> }
);

export type GqlActivate_Category_RegionMutationVariables = Exact<{
  data: GqlCategoryRegionInput;
  category_region_id: Scalars['String'];
}>;


export type GqlActivate_Category_RegionMutation = (
  { __typename?: 'Mutation' }
  & { update_category_region: Maybe<(
    { __typename?: 'UpdateCategoryRegion' }
    & { category_region: Maybe<(
      { __typename?: 'CategoryRegionV2GQL' }
      & Pick<GqlCategoryRegionV2Gql, 'category_region_id' | 'category_id' | 'region_id'>
    )> }
  )> }
);

export type GqlProductDepartmentsv2QueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  filter_string: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
}>;


export type GqlProductDepartmentsv2Query = (
  { __typename?: 'Query' }
  & { product_departments_v2: Maybe<Array<Maybe<(
    { __typename?: 'DepartmentV2GQL' }
    & Pick<GqlDepartmentV2Gql, 'department_id' | 'department_name' | 'description' | 'slug' | 'active'>
  )>>> }
);

export type GqlAddDepartmentMutationVariables = Exact<{
  department_name: Scalars['String'];
  description: Maybe<Scalars['String']>;
}>;


export type GqlAddDepartmentMutation = (
  { __typename?: 'Mutation' }
  & { add_department: Maybe<(
    { __typename?: 'CreateDepartment' }
    & Pick<GqlCreateDepartment, 'created'>
    & { department: Maybe<(
      { __typename?: 'DepartmentV2GQL' }
      & Pick<GqlDepartmentV2Gql, 'department_id' | 'department_name'>
    )> }
  )> }
);

export type GqlUpdateDepartmentMutationVariables = Exact<{
  department_id: Scalars['String'];
  data: GqlDepartmentInput;
}>;


export type GqlUpdateDepartmentMutation = (
  { __typename?: 'Mutation' }
  & { update_department: Maybe<(
    { __typename?: 'UpdateDepartment' }
    & { department: Maybe<(
      { __typename?: 'DepartmentV2GQL' }
      & Pick<GqlDepartmentV2Gql, 'department_id' | 'department_name' | 'description' | 'slug'>
    )> }
  )> }
);

export type GqlAdd_GeofencingMutationVariables = Exact<{
  product_item_id: Scalars['String'];
  whitelisted_routes: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  blacklisted_routes: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GqlAdd_GeofencingMutation = (
  { __typename?: 'Mutation' }
  & { update_product_item: Maybe<(
    { __typename?: 'UpdateProductItem' }
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'whitelisted_routes' | 'blacklisted_routes' | 'active'>
    )> }
  )> }
);

export type GqlDelete_GeofencingMutationVariables = Exact<{
  product_item_id: Scalars['String'];
}>;


export type GqlDelete_GeofencingMutation = (
  { __typename?: 'Mutation' }
  & { update_product_item: Maybe<(
    { __typename?: 'UpdateProductItem' }
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'whitelisted_routes' | 'blacklisted_routes'>
    )> }
  )> }
);

export type GqlRoutes_V2QueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlRoutes_V2Query = (
  { __typename?: 'Query' }
  & { routes_v2: Maybe<(
    { __typename?: 'RouteV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'RouteV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RouteV2GQL' }
        & Pick<GqlRouteV2Gql, 'route_id' | 'route_name' | 'depot_id'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name'>
          & { area: Maybe<(
            { __typename?: 'AreaV2GQL' }
            & Pick<GqlAreaV2Gql, 'area_id' | 'region_id'>
            & { region: Maybe<(
              { __typename?: 'RegionV2GQL' }
              & Pick<GqlRegionV2Gql, 'region_name'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlRouteV2ByIdQueryVariables = Exact<{
  route_id: Maybe<Scalars['String']>;
}>;


export type GqlRouteV2ByIdQuery = (
  { __typename?: 'Query' }
  & { route_v2_by_id: Maybe<(
    { __typename?: 'RouteV2GQL' }
    & Pick<GqlRouteV2Gql, 'route_id' | 'route_name' | 'depot_id'>
    & { depot: Maybe<(
      { __typename?: 'DepotV2GQL' }
      & Pick<GqlDepotV2Gql, 'depot_name'>
      & { area: Maybe<(
        { __typename?: 'AreaV2GQL' }
        & Pick<GqlAreaV2Gql, 'area_id' | 'region_id'>
        & { region: Maybe<(
          { __typename?: 'RegionV2GQL' }
          & Pick<GqlRegionV2Gql, 'region_name'>
        )> }
      )> }
    )> }
  )> }
);

export type GqlPackaging_Units_V2QueryVariables = Exact<{ [key: string]: never; }>;


export type GqlPackaging_Units_V2Query = (
  { __typename?: 'Query' }
  & { packaging_units_v2: Maybe<(
    { __typename?: 'PackagingUnitV2GQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PackagingUnitV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PackagingUnitV2GQL' }
        & Pick<GqlPackagingUnitV2Gql, 'name' | 'active' | 'packaging_unit_id' | 'returnable' | 'weight'>
      )> }
    )>> }
  )> }
);

export type GqlAdd_Packaging_UnitMutationVariables = Exact<{
  name: Scalars['String'];
  weight: Scalars['Float'];
  returnable: Maybe<Scalars['Boolean']>;
}>;


export type GqlAdd_Packaging_UnitMutation = (
  { __typename?: 'Mutation' }
  & { add_packaging_unit: Maybe<(
    { __typename?: 'CreatePackagingUnit' }
    & Pick<GqlCreatePackagingUnit, 'created'>
    & { packaging_unit: Maybe<(
      { __typename?: 'PackagingUnitV2GQL' }
      & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'name' | 'created_by' | 'date_created' | 'date_updated'>
    )> }
  )> }
);

export type GqlUpdate_Packaging_UnitMutationVariables = Exact<{
  data: GqlPackagingUnitInput;
  packaging_unit_id: Scalars['String'];
}>;


export type GqlUpdate_Packaging_UnitMutation = (
  { __typename?: 'Mutation' }
  & { update_packaging_unit: Maybe<(
    { __typename?: 'UpdatePackagingUnit' }
    & { packaging_unit: Maybe<(
      { __typename?: 'PackagingUnitV2GQL' }
      & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'returnable' | 'active' | 'name' | 'weight'>
    )> }
  )> }
);

export type GqlAdd_Product_ItemMutationVariables = Exact<{
  data: GqlProductItemInput;
}>;


export type GqlAdd_Product_ItemMutation = (
  { __typename?: 'Mutation' }
  & { add_product_item: Maybe<(
    { __typename?: 'CreateProductItem' }
    & Pick<GqlCreateProductItem, 'created'>
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id'>
      & { units_of_measure: Maybe<Array<Maybe<(
        { __typename?: 'ProductItemUOMV2GQL' }
        & Pick<GqlProductItemUomv2Gql, 'uom_id' | 'business_domain_id'>
      )>>>, regions: Maybe<Array<Maybe<(
        { __typename?: 'ProductItemRegionV2GQL' }
        & Pick<GqlProductItemRegionV2Gql, 'business_domain_id' | 'region_id'>
      )>>> }
    )> }
  )> }
);

export type GqlAdd_Product_Item_ImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  product_item_id: Scalars['String'];
}>;


export type GqlAdd_Product_Item_ImageMutation = (
  { __typename?: 'Mutation' }
  & { add_product_item_image: Maybe<(
    { __typename?: 'UploadProductItemImage' }
    & Pick<GqlUploadProductItemImage, 'uploaded'>
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name'>
    )> }
  )> }
);

export type GqlProduct_Item_SegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProduct_Item_SegmentsQuery = (
  { __typename?: 'Query' }
  & { product_item_segments_v2: Maybe<Array<Maybe<(
    { __typename?: 'ProductItemSegmentV2GQL' }
    & Pick<GqlProductItemSegmentV2Gql, 'segment_name' | 'product_item_segment_id'>
  )>>> }
);

export type GqlProduct_Item_V2_By_IdQueryVariables = Exact<{
  product_item_id: Scalars['String'];
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlProduct_Item_V2_By_IdQuery = (
  { __typename?: 'Query' }
  & { product_item_v2_by_id: Maybe<(
    { __typename?: 'ProductItemV2GQL' }
    & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'active' | 'image_url' | 'base_price' | 'total_regions' | 'packed_weight' | 'packed_volume' | 'description' | 'wms_default_available' | 'wms_std_pallet_quantity' | 'wms_pickface_putaway' | 'product_id' | 'product_item_segment_id'>
    & { product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_name'>
    )>, product_item_segment: Maybe<(
      { __typename?: 'ProductItemSegmentV2GQL' }
      & Pick<GqlProductItemSegmentV2Gql, 'segment_name'>
    )>, units_of_measure: Maybe<Array<Maybe<(
      { __typename?: 'ProductItemUOMV2GQL' }
      & Pick<GqlProductItemUomv2Gql, 'business_domain_id' | 'active' | 'conversion_ratio' | 'product_item_uom_id' | 'product_item_id' | 'uom_id'>
      & { business_domain: Maybe<(
        { __typename?: 'BusinessDomainV2GQL' }
        & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name' | 'uom_id'>
      )> }
    )>>>, regions: Maybe<Array<Maybe<(
      { __typename?: 'ProductItemRegionV2GQL' }
      & Pick<GqlProductItemRegionV2Gql, 'region_id' | 'product_item_region_id' | 'business_domain_id' | 'active'>
      & { region: Maybe<(
        { __typename?: 'RegionV2GQL' }
        & Pick<GqlRegionV2Gql, 'region_id' | 'region_name'>
      )>, business_domain: Maybe<(
        { __typename?: 'BusinessDomainV2GQL' }
        & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
      )> }
    )>>> }
  )> }
);

export type GqlAdd_Product_Item_UomMutationVariables = Exact<{
  data: GqlProductItemUomInput;
}>;


export type GqlAdd_Product_Item_UomMutation = (
  { __typename?: 'Mutation' }
  & { add_product_item_uom: Maybe<(
    { __typename?: 'CreateProductItemUOM' }
    & { product_item_uom: Maybe<(
      { __typename?: 'ProductItemUOMV2GQL' }
      & Pick<GqlProductItemUomv2Gql, 'product_item_uom_id' | 'product_item_id' | 'business_domain_id' | 'conversion_ratio'>
    )> }
  )> }
);

export type GqlUpdate_Product_Item_UomMutationVariables = Exact<{
  product_item_uom_id: Scalars['String'];
  uom_id: Scalars['String'];
  product_item_id: Scalars['String'];
  business_domain_id: Scalars['String'];
  data: GqlProductItemUomInput;
}>;


export type GqlUpdate_Product_Item_UomMutation = (
  { __typename?: 'Mutation' }
  & { update_product_item_uom: Maybe<(
    { __typename?: 'UpdateProductItemUOM' }
    & { product_item_uom: Maybe<(
      { __typename?: 'ProductItemUOMV2GQL' }
      & Pick<GqlProductItemUomv2Gql, 'product_item_uom_id' | 'active'>
    )> }
  )> }
);

export type GqlAdd_Product_Item_RegionMutationVariables = Exact<{
  data: GqlProductItemRegionInput;
}>;


export type GqlAdd_Product_Item_RegionMutation = (
  { __typename?: 'Mutation' }
  & { add_product_item_region: Maybe<(
    { __typename?: 'CreateProductItemRegion' }
    & Pick<GqlCreateProductItemRegion, 'created'>
    & { product_item_region: Maybe<(
      { __typename?: 'ProductItemRegionV2GQL' }
      & Pick<GqlProductItemRegionV2Gql, 'region_id' | 'product_item_id' | 'business_domain_id'>
    )> }
  )> }
);

export type GqlActivate_Product_Item_RegionMutationVariables = Exact<{
  active: Scalars['Boolean'];
  product_item_region_id: Scalars['String'];
}>;


export type GqlActivate_Product_Item_RegionMutation = (
  { __typename?: 'Mutation' }
  & { update_product_item_region: Maybe<(
    { __typename?: 'UpdateProductItemRegion' }
    & { product_item_region: Maybe<(
      { __typename?: 'ProductItemRegionV2GQL' }
      & Pick<GqlProductItemRegionV2Gql, 'product_item_id' | 'active'>
    )> }
  )> }
);

export type GqlBusiness_Domains_V2QueryVariables = Exact<{ [key: string]: never; }>;


export type GqlBusiness_Domains_V2Query = (
  { __typename?: 'Query' }
  & { business_domains_v2: Maybe<Array<Maybe<(
    { __typename?: 'BusinessDomainV2GQL' }
    & Pick<GqlBusinessDomainV2Gql, 'business_domain_id' | 'domain_name'>
  )>>> }
);

export type GqlPaginated_Product_ItemsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlPaginated_Product_ItemsQuery = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'total_pages' | 'total_count' | 'current_page' | 'per_page' | 'has_previous' | 'has_next'>
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'active' | 'product_item_id' | 'product_item_name' | 'product_id' | 'image_url' | 'staff_only' | 'packed_weight' | 'packed_volume' | 'featured' | 'product_item_segment_id' | 'blacklisted_routes' | 'whitelisted_routes'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, product_item_segment: Maybe<(
          { __typename?: 'ProductItemSegmentV2GQL' }
          & Pick<GqlProductItemSegmentV2Gql, 'segment_name'>
        )>, blacklisted: Maybe<Array<Maybe<(
          { __typename?: 'BlacklistedRoutesGQL' }
          & Pick<GqlBlacklistedRoutesGql, 'route_id'>
          & { route: Maybe<(
            { __typename?: 'RouteV2GQL' }
            & Pick<GqlRouteV2Gql, 'route_id' | 'route_name' | 'depot_id'>
            & { depot: Maybe<(
              { __typename?: 'DepotV2GQL' }
              & Pick<GqlDepotV2Gql, 'depot_name'>
              & { area: Maybe<(
                { __typename?: 'AreaV2GQL' }
                & Pick<GqlAreaV2Gql, 'area_id' | 'region_id'>
                & { region: Maybe<(
                  { __typename?: 'RegionV2GQL' }
                  & Pick<GqlRegionV2Gql, 'region_name'>
                )> }
              )> }
            )> }
          )> }
        )>>>, whitelisted: Maybe<Array<Maybe<(
          { __typename?: 'WhitelistedRoutesGQL' }
          & Pick<GqlWhitelistedRoutesGql, 'route_id'>
          & { route: Maybe<(
            { __typename?: 'RouteV2GQL' }
            & Pick<GqlRouteV2Gql, 'route_id' | 'route_name' | 'depot_id'>
            & { depot: Maybe<(
              { __typename?: 'DepotV2GQL' }
              & Pick<GqlDepotV2Gql, 'depot_name'>
              & { area: Maybe<(
                { __typename?: 'AreaV2GQL' }
                & Pick<GqlAreaV2Gql, 'area_id' | 'region_id'>
                & { region: Maybe<(
                  { __typename?: 'RegionV2GQL' }
                  & Pick<GqlRegionV2Gql, 'region_name'>
                )> }
              )> }
            )> }
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlUpdate_Product_ItemMutationVariables = Exact<{
  product_item_id: Scalars['String'];
  data: GqlProductItemInput;
}>;


export type GqlUpdate_Product_ItemMutation = (
  { __typename?: 'Mutation' }
  & { update_product_item: Maybe<(
    { __typename?: 'UpdateProductItem' }
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id' | 'active'>
    )> }
  )> }
);

export type GqlPaginatedProductsV2QueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  active: Maybe<Scalars['Boolean']>;
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlPaginatedProductsV2Query = (
  { __typename?: 'Query' }
  & { paginated_products_v2: Maybe<(
    { __typename?: 'ProductV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'has_next' | 'has_previous'>
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'active' | 'product_id' | 'product_name' | 'product_code' | 'hs_code' | 'kra_code' | 'vatable' | 'product_type' | 'image_url' | 'date_created'>
        & { category: Maybe<(
          { __typename?: 'CategoryV2GQL' }
          & Pick<GqlCategoryV2Gql, 'category_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlAddProductMutationVariables = Exact<{
  data: GqlProductInput;
}>;


export type GqlAddProductMutation = (
  { __typename?: 'Mutation' }
  & { add_product: Maybe<(
    { __typename?: 'CreateProduct' }
    & Pick<GqlCreateProduct, 'created'>
    & { product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_id' | 'product_code' | 'category_id' | 'wms_shelf_life_days' | 'hs_code' | 'kra_code'>
      & { product_tags: Maybe<Array<Maybe<(
        { __typename?: 'ProductTagV2GQL' }
        & Pick<GqlProductTagV2Gql, 'product_tag' | 'product_tag_id' | 'product_id'>
      )>>>, category: Maybe<(
        { __typename?: 'CategoryV2GQL' }
        & Pick<GqlCategoryV2Gql, 'category_name'>
      )>, categories: Maybe<Array<Maybe<(
        { __typename?: 'CategoryV2GQL' }
        & Pick<GqlCategoryV2Gql, 'category_name'>
      )>>> }
    )> }
  )> }
);

export type GqlUpdateProductMutationVariables = Exact<{
  product_id: Scalars['String'];
  data: GqlProductInput;
}>;


export type GqlUpdateProductMutation = (
  { __typename?: 'Mutation' }
  & { update_product: Maybe<(
    { __typename?: 'UpdateProduct' }
    & { product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_id' | 'active' | 'product_code' | 'product_type' | 'category_id' | 'vatable' | 'wms_shelf_life_days' | 'hs_code' | 'kra_code'>
      & { categories: Maybe<Array<Maybe<(
        { __typename?: 'CategoryV2GQL' }
        & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name'>
      )>>> }
    )> }
  )> }
);

export type GqlProductByIdV2QueryVariables = Exact<{
  product_id: Scalars['String'];
}>;


export type GqlProductByIdV2Query = (
  { __typename?: 'Query' }
  & { product_v2_by_id: Maybe<(
    { __typename?: 'ProductV2GQL' }
    & Pick<GqlProductV2Gql, 'product_id' | 'active' | 'product_type' | 'product_name' | 'product_code' | 'product_description' | 'vatable' | 'image_url' | 'date_created' | 'wms_shelf_life_days' | 'hs_code' | 'kra_code' | 'category_id'>
    & { category: Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'category_id' | 'category_name'>
    )>, categories: Maybe<Array<Maybe<(
      { __typename?: 'CategoryV2GQL' }
      & Pick<GqlCategoryV2Gql, 'active' | 'category_id' | 'category_name'>
    )>>>, product_tags: Maybe<Array<Maybe<(
      { __typename?: 'ProductTagV2GQL' }
      & Pick<GqlProductTagV2Gql, 'product_tag' | 'product_tag_id' | 'product_id'>
    )>>>, domain_activations: Maybe<Array<Maybe<(
      { __typename?: 'ProductDomainActivationV2GQL' }
      & Pick<GqlProductDomainActivationV2Gql, 'product_domain_activation_id' | 'active'>
      & { business_domain: Maybe<(
        { __typename?: 'BusinessDomainV2GQL' }
        & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
      )> }
    )>>>, packaging_units: Maybe<Array<Maybe<(
      { __typename?: 'PackagingUnitV2GQL' }
      & Pick<GqlPackagingUnitV2Gql, 'name' | 'active' | 'packaging_unit_id'>
    )>>> }
  )> }
);

export type GqlLossReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlLossReasonsQuery = (
  { __typename?: 'Query' }
  & { loss_reasons: Maybe<Array<Maybe<(
    { __typename?: 'LossReasonGQL' }
    & Pick<GqlLossReasonGql, 'active' | 'loss_reason' | 'loss_reason_id'>
  )>>> }
);

export type GqlProductLossReasonsQueryVariables = Exact<{
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlProductLossReasonsQuery = (
  { __typename?: 'Query' }
  & { product_loss_reasons: Maybe<(
    { __typename?: 'ProductLossReasonGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductLossReasonGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductLossReasonGQL' }
        & Pick<GqlProductLossReasonGql, 'product_loss_reason_id' | 'loss_reason_id' | 'active'>
        & { loss_reason: Maybe<(
          { __typename?: 'LossReasonGQL' }
          & Pick<GqlLossReasonGql, 'loss_reason'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlAddProductDomainActivationMutationVariables = Exact<{
  data: GqlProductDomainActivationInput;
}>;


export type GqlAddProductDomainActivationMutation = (
  { __typename?: 'Mutation' }
  & { add_product_domain_activation: Maybe<(
    { __typename?: 'CreateProductDomainActivation' }
    & Pick<GqlCreateProductDomainActivation, 'created'>
  )> }
);

export type GqlUpdateProductDomainActivationMutationVariables = Exact<{
  product_domain_activation_id: Scalars['String'];
  data: GqlProductDomainActivationInput;
}>;


export type GqlUpdateProductDomainActivationMutation = (
  { __typename?: 'Mutation' }
  & { update_product_domain_activation: Maybe<(
    { __typename?: 'UpdateProductDomainActivation' }
    & { product_domain_activation: Maybe<(
      { __typename?: 'ProductDomainActivationV2GQL' }
      & Pick<GqlProductDomainActivationV2Gql, 'product_id' | 'business_domain_id' | 'active'>
    )> }
  )> }
);

export type GqlUploadProductImageMutationVariables = Exact<{
  image: Scalars['Upload'];
  product_id: Scalars['String'];
}>;


export type GqlUploadProductImageMutation = (
  { __typename?: 'Mutation' }
  & { add_product_image: Maybe<(
    { __typename?: 'UploadProductImage' }
    & Pick<GqlUploadProductImage, 'uploaded'>
    & { product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_id' | 'image_url'>
    )> }
  )> }
);

export type GqlAddProductTagMutationVariables = Exact<{
  data: GqlProductTagInput;
}>;


export type GqlAddProductTagMutation = (
  { __typename?: 'Mutation' }
  & { add_product_tag: Maybe<(
    { __typename?: 'CreateProductTag' }
    & Pick<GqlCreateProductTag, 'created'>
    & { product_tag: Maybe<(
      { __typename?: 'ProductTagV2GQL' }
      & Pick<GqlProductTagV2Gql, 'product_tag'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_name'>
      )> }
    )> }
  )> }
);

export type GqlDeleteProductTagMutationVariables = Exact<{
  product_tag_id: Scalars['String'];
}>;


export type GqlDeleteProductTagMutation = (
  { __typename?: 'Mutation' }
  & { delete_product_tag: Maybe<(
    { __typename?: 'DeleteProductTag' }
    & Pick<GqlDeleteProductTag, 'deleted'>
  )> }
);

export type GqlAddProductBundleMutationVariables = Exact<{
  data: Maybe<Array<Maybe<GqlBundleAssociationInput>> | Maybe<GqlBundleAssociationInput>>;
}>;


export type GqlAddProductBundleMutation = (
  { __typename?: 'Mutation' }
  & { add_bundle_association: Maybe<(
    { __typename?: 'CreateBundleAssociation' }
    & Pick<GqlCreateBundleAssociation, 'created'>
  )> }
);

export type GqlDeleteBundleAssociationMutationVariables = Exact<{
  association_id: Maybe<Scalars['String']>;
  client_stamp: Maybe<Scalars['String']>;
}>;


export type GqlDeleteBundleAssociationMutation = (
  { __typename?: 'Mutation' }
  & { delete_bundle_association: Maybe<(
    { __typename?: 'DeleteBundleAssociation' }
    & Pick<GqlDeleteBundleAssociation, 'deleted'>
  )> }
);

export type GqlGetBundleAssociationQueryVariables = Exact<{
  product_item_id: Scalars['String'];
}>;


export type GqlGetBundleAssociationQuery = (
  { __typename?: 'Query' }
  & { bundle_association_v2_by_sku: Maybe<Array<Maybe<(
    { __typename?: 'BundleAssociationV2GQL' }
    & Pick<GqlBundleAssociationV2Gql, 'association_id' | 'quantity' | 'discount' | 'client_stamp' | 'parent_product_item_id' | 'child_product_item_id'>
    & { parent_sku: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_name'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_name' | 'product_id'>
      )> }
    )>, child_sku: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_id' | 'product_name'>
      )> }
    )> }
  )>>> }
);

export type GqlUoms_V2QueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlUoms_V2Query = (
  { __typename?: 'Query' }
  & { uoms_v2: Maybe<(
    { __typename?: 'UOMV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'has_next' | 'has_previous' | 'total_pages' | 'total_count' | 'current_page' | 'per_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'UOMV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'uom_id' | 'name' | 'description' | 'abbreviation' | 'active'>
      )> }
    )>> }
  )> }
);

export type GqlAdd_UomMutationVariables = Exact<{
  name: Scalars['String'];
  abbreviation: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
}>;


export type GqlAdd_UomMutation = (
  { __typename?: 'Mutation' }
  & { add_uom: Maybe<(
    { __typename?: 'CreateUom' }
    & Pick<GqlCreateUom, 'created'>
    & { uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'uom_id' | 'name' | 'abbreviation' | 'description'>
    )> }
  )> }
);

export type GqlUpdate_UomMutationVariables = Exact<{
  uom_id: Scalars['String'];
  data: GqlUomInput;
}>;


export type GqlUpdate_UomMutation = (
  { __typename?: 'Mutation' }
  & { update_uom: Maybe<(
    { __typename?: 'UpdateUom' }
    & { uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'uom_id' | 'name' | 'active' | 'abbreviation' | 'description'>
    )> }
  )> }
);

export type GqlProductPriceRangeQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  productFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlProductPriceRangeQuery = (
  { __typename?: 'Query' }
  & { paginated_products_v2: Maybe<(
    { __typename?: 'ProductV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'active' | 'product_name' | 'product_id'>
        & { sourcing_price_range: Maybe<(
          { __typename?: 'PriceRangeGQL' }
          & Pick<GqlPriceRangeGql, 'min_price' | 'max_price' | 'date_updated' | 'price_range_id'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlPurchasesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  purchaseFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlPurchasesQuery = (
  { __typename?: 'Query' }
  & { harvests: Maybe<(
    { __typename?: 'HarvestGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'has_next' | 'has_previous' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'HarvestGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'HarvestGQL' }
        & Pick<GqlHarvestGql, 'active' | 'original_currency' | 'cancelled' | 'cancellation_reason' | 'date_created' | 'receipt_number' | 'harvest_id' | 'invoice_number' | 'batch_id' | 'signed_receipt_url' | 'farmer_id' | 'quantity' | 'weight' | 'unit_price' | 'collection_center_id' | 'farm_id' | 'product_id' | 'product_item_id' | 'unit_of_measure_id' | 'harvest_date'>
        & { batch: Maybe<(
          { __typename?: 'BatchGQL' }
          & Pick<GqlBatchGql, 'batch_name'>
        )>, collection_center: Maybe<(
          { __typename?: 'CollectionCenterGQL' }
          & Pick<GqlCollectionCenterGql, 'collection_center_name' | 'area_id'>
          & { area: Maybe<(
            { __typename?: 'AreaGQL' }
            & Pick<GqlAreaGql, 'area_name'>
          )> }
        )>, farmer: Maybe<(
          { __typename?: 'FarmerGQL' }
          & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'phone_number' | 'farmer_number' | 'farmer_id' | 'supplier_name'>
        )>, farm: Maybe<(
          { __typename?: 'FarmGQL' }
          & Pick<GqlFarmGql, 'farm_number'>
          & { farmer: Maybe<(
            { __typename?: 'FarmerGQL' }
            & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'phone_number' | 'supplier_name' | 'farmer_id'>
          )> }
        )>, product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )>, harvest_items: Maybe<Array<Maybe<(
          { __typename?: 'HarvestItemGQL' }
          & Pick<GqlHarvestItemGql, 'harvest_id' | 'product_id' | 'product_item_id' | 'quantity' | 'unit_price' | 'weight' | 'unit_of_measure_id'>
          & { harvest: Maybe<(
            { __typename?: 'HarvestGQL' }
            & Pick<GqlHarvestGql, 'batch_id'>
          )>, product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )> }
        )>>>, payment: Maybe<(
          { __typename?: 'HarvestPaymentGQL' }
          & Pick<GqlHarvestPaymentGql, 'amount_paid' | 'total_payable' | 'harvest_payment_status'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlBookingsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  bookingFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlBookingsQuery = (
  { __typename?: 'Query' }
  & { bookings: Maybe<(
    { __typename?: 'BookingGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'has_next' | 'has_previous' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'BookingGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BookingGQL' }
        & Pick<GqlBookingGql, 'active' | 'cancelled' | 'cancellation_reason' | 'date_created' | 'receipt_number' | 'booking_id' | 'booking_date' | 'harvest_date' | 'signed_invoice_url' | 'quantity' | 'weight' | 'price' | 'farmer_id' | 'product_id' | 'product_item_id' | 'unit_of_measure_id' | 'collection_center_id' | 'farm_id'>
        & { farmer: Maybe<(
          { __typename?: 'FarmerGQL' }
          & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'phone_number' | 'supplier_name' | 'farmer_id'>
        )>, product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )>, collection_center: Maybe<(
          { __typename?: 'CollectionCenterGQL' }
          & Pick<GqlCollectionCenterGql, 'collection_center_name' | 'area_id'>
          & { area: Maybe<(
            { __typename?: 'AreaGQL' }
            & Pick<GqlAreaGql, 'area_name'>
          )> }
        )>, farm: Maybe<(
          { __typename?: 'FarmGQL' }
          & Pick<GqlFarmGql, 'farm_number' | 'harvest_area_id'>
          & { farmer: Maybe<(
            { __typename?: 'FarmerGQL' }
            & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'phone_number' | 'supplier_name' | 'farmer_id'>
          )>, harvest_area: Maybe<(
            { __typename?: 'HarvestAreaGQL' }
            & Pick<GqlHarvestAreaGql, 'harvest_area_name'>
          )> }
        )>, booking_items: Maybe<Array<Maybe<(
          { __typename?: 'BookingItemGQL' }
          & Pick<GqlBookingItemGql, 'booking_id' | 'product_id' | 'product_item_id' | 'unit_price' | 'quantity' | 'weight' | 'date_created' | 'harvest_date' | 'unit_of_measure_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & Pick<GqlProductItemUomv2Gql, 'conversion_ratio'>
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
              )> }
            )>>> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlSupplierProductsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  productFilter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlSupplierProductsQuery = (
  { __typename?: 'Query' }
  & { supplier_products: Maybe<(
    { __typename?: 'SupplierProductGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'has_next' | 'has_previous' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'SupplierProductGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'SupplierProductGQL' }
        & Pick<GqlSupplierProductGql, 'active' | 'farmer_id' | 'supplier_product_id' | 'product_id'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name' | 'product_id'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlPivotsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlPivotsQuery = (
  { __typename?: 'Query' }
  & { pivots: Maybe<Array<Maybe<(
    { __typename?: 'PivotGQL' }
    & Pick<GqlPivotGql, 'pivot_id' | 'pivot_name' | 'pivot_code'>
  )>>> }
);

export type GqlBlocksQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlBlocksQuery = (
  { __typename?: 'Query' }
  & { blocks: Maybe<Array<Maybe<(
    { __typename?: 'BlockGQL' }
    & Pick<GqlBlockGql, 'block_id' | 'block_name' | 'block_code'>
  )>>> }
);

export type GqlStorageQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Scalars['Int'];
  page: Scalars['Int'];
  search: Maybe<Scalars['String']>;
}>;


export type GqlStorageQuery = (
  { __typename?: 'Query' }
  & { storage: Maybe<(
    { __typename?: 'StorageGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'StorageGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StorageGQL' }
        & Pick<GqlStorageGql, 'storage_id' | 'storage_entry_number' | 'batch_id' | 'date' | 'quantity' | 'packaging_unit_quantity' | 'created_by' | 'direction' | 'weight' | 'comments' | 'packaging_unit_id' | 'unit_of_measure_id' | 'product_item_id'>
        & { batch: Maybe<(
          { __typename?: 'BatchGQL' }
          & Pick<GqlBatchGql, 'batch_name'>
        )>, user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )>, packaging_unit: Maybe<(
          { __typename?: 'PackagingUnitV2GQL' }
          & Pick<GqlPackagingUnitV2Gql, 'name'>
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )>, storage_unit: Maybe<(
          { __typename?: 'StorageUnitGQL' }
          & Pick<GqlStorageUnitGql, 'unit_name' | 'warehouse_id'>
          & { warehouse: Maybe<(
            { __typename?: 'WarehouseGQL' }
            & Pick<GqlWarehouseGql, 'warehouse_name' | 'distribution_center_id'>
            & { distribution_center: Maybe<(
              { __typename?: 'DistributionCenterGQL' }
              & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
            )> }
          )> }
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlGetBatchesQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlGetBatchesQuery = (
  { __typename?: 'Query' }
  & { batches: Maybe<(
    { __typename?: 'BatchGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'BatchGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BatchGQL' }
        & Pick<GqlBatchGql, 'batch_id' | 'batch_name' | 'batch_date' | 'field_weight' | 'processing_loss_weight' | 'intake_weight' | 'active'>
      )> }
    )>> }
  )> }
);

export type GqlBatchSummaryDetailQueryVariables = Exact<{
  batch_id: Scalars['String'];
}>;


export type GqlBatchSummaryDetailQuery = (
  { __typename?: 'Query' }
  & { batch_by_id: Maybe<(
    { __typename?: 'BatchGQL' }
    & Pick<GqlBatchGql, 'batch_id' | 'batch_name' | 'batch_date' | 'field_weight' | 'intake_weight' | 'collection_center_id'>
    & { collection_center: Maybe<(
      { __typename?: 'CollectionCenterGQL' }
      & Pick<GqlCollectionCenterGql, 'collection_center_name'>
      & { area: Maybe<(
        { __typename?: 'AreaGQL' }
        & Pick<GqlAreaGql, 'area_name'>
      )> }
    )>, stock_intake_items_batch: Maybe<(
      { __typename?: 'StockIntakeItemBatchGQL' }
      & Pick<GqlStockIntakeItemBatchGql, 'batch_id'>
      & { stock_intake_items: Maybe<Array<Maybe<(
        { __typename?: 'StockIntakeItemGQL' }
        & Pick<GqlStockIntakeItemGql, 'active' | 'stock_intake_item_id' | 'product_item_id' | 'cancellation_reason' | 'weight' | 'quantity' | 'unit_of_measure_id' | 'packaging_unit_quantity' | 'packaging_unit_id'>
        & { stock_intake: Maybe<(
          { __typename?: 'StockIntakeGQL' }
          & Pick<GqlStockIntakeGql, 'stock_intake_number'>
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )>, packaging_unit: Maybe<(
          { __typename?: 'PackagingUnitV2GQL' }
          & Pick<GqlPackagingUnitV2Gql, 'name'>
        )> }
      )>>> }
    )> }
  )> }
);

export type GqlDcReturnFragment = (
  { __typename?: 'ReturnGQL' }
  & Pick<GqlReturnGql, 'return_id' | 'return_number' | 'sale_date' | 'created_by' | 'return_level' | 'active' | 'cancellation_reason' | 'depot_id' | 'distribution_center_id'>
  & { user: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'phone_number' | 'user_number' | 'user_id'>
  )>, packaging_return_items: Maybe<Array<Maybe<(
    { __typename?: 'PackagingReturnItemGQL' }
    & Pick<GqlPackagingReturnItemGql, 'packaging_return_item_id' | 'active' | 'cancellation_reason' | 'packaging_unit_id' | 'quantity'>
    & { packaging_unit: Maybe<(
      { __typename?: 'PackagingUnitV2GQL' }
      & Pick<GqlPackagingUnitV2Gql, 'name'>
    )> }
  )>>>, product_return_items: Maybe<Array<Maybe<(
    { __typename?: 'ProductReturnItemGQL' }
    & Pick<GqlProductReturnItemGql, 'active' | 'cancellation_reason' | 'product_item_id' | 'product_return_item_id' | 'quantity' | 'unit_of_measure_id'>
    & { uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'abbreviation'>
    )>, product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_name'>
      )> }
    )> }
  )>>>, depot: Maybe<(
    { __typename?: 'DepotV2GQL' }
    & Pick<GqlDepotV2Gql, 'depot_name' | 'depot_id'>
  )>, distribution_center: Maybe<(
    { __typename?: 'DistributionCenterGQL' }
    & Pick<GqlDistributionCenterGql, 'distribution_center_id' | 'distribution_center_name'>
  )> }
);

export type GqlDcReturnsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filter_array: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDcReturnsQuery = (
  { __typename?: 'Query' }
  & { returns: Maybe<(
    { __typename?: 'ReturnGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'ReturnGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ReturnGQL' }
        & GqlDcReturnFragment
      )> }
    )>> }
  )> }
);

export type GqlDcReturnByIdQueryVariables = Exact<{
  return_id: Scalars['String'];
}>;


export type GqlDcReturnByIdQuery = (
  { __typename?: 'Query' }
  & { return_by_id: Maybe<(
    { __typename?: 'ReturnGQL' }
    & GqlDcReturnFragment
  )> }
);

export type GqlDispatchesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  dispatchFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDispatchesQuery = (
  { __typename?: 'Query' }
  & { dispatches: Maybe<(
    { __typename?: 'DispatchGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DispatchGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DispatchGQL' }
        & Pick<GqlDispatchGql, 'active' | 'dispatch_id' | 'depot_id' | 'dispatch_number' | 'date_created' | 'total_products' | 'created_by' | 'sale_date' | 'dispatch_type' | 'distribution_center_id'>
        & { user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'phone_number' | 'user_number' | 'user_id'>
        )>, depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name' | 'depot_id'>
        )>, distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_id' | 'distribution_center_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDispatchDetailsQueryVariables = Exact<{
  dispatch_id: Scalars['String'];
  depot_id: Scalars['String'];
  date: Scalars['String'];
}>;


export type GqlDispatchDetailsQuery = (
  { __typename?: 'Query' }
  & { dispatch_by_id: Maybe<(
    { __typename?: 'DispatchGQL' }
    & Pick<GqlDispatchGql, 'dispatch_id' | 'dispatch_type' | 'date_created' | 'sale_date' | 'depot_id' | 'created_by'>
    & { depot: Maybe<(
      { __typename?: 'DepotV2GQL' }
      & Pick<GqlDepotV2Gql, 'depot_name' | 'depot_id'>
    )>, user: Maybe<(
      { __typename?: 'UserV2GQL' }
      & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'phone_number' | 'user_number' | 'user_id'>
    )>, dispatch_items: Maybe<Array<Maybe<(
      { __typename?: 'DispatchItemGQL' }
      & Pick<GqlDispatchItemGql, 'dispatch_item_id' | 'quantity' | 'cancellation_reason' | 'packaging_unit_quantity' | 'active' | 'route_id' | 'packaging_unit_id' | 'unit_of_measure_id' | 'product_item_id'>
      & { route: Maybe<(
        { __typename?: 'RouteV2GQL' }
        & Pick<GqlRouteV2Gql, 'route_name'>
      )>, packaging_unit: Maybe<(
        { __typename?: 'PackagingUnitV2GQL' }
        & Pick<GqlPackagingUnitV2Gql, 'name'>
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name' | 'abbreviation' | 'uom_id'>
      )>, product_item: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'product_id'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name' | 'product_type'>
          & { packaging_units: Maybe<Array<Maybe<(
            { __typename?: 'PackagingUnitV2GQL' }
            & Pick<GqlPackagingUnitV2Gql, 'active' | 'name' | 'weight' | 'packaging_unit_id'>
          )>>> }
        )>, ordered_stock_depot: Maybe<(
          { __typename?: 'StockOrderedGQL' }
          & Pick<GqlStockOrderedGql, 'order_quantity'>
        )> }
      )> }
    )>>> }
  )> }
);

export type GqlProcessing_LossQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Scalars['Int'];
  page: Scalars['Int'];
  search: Maybe<Scalars['String']>;
}>;


export type GqlProcessing_LossQuery = (
  { __typename?: 'Query' }
  & { processing_loss: Maybe<(
    { __typename?: 'ProcessingLossGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProcessingLossGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProcessingLossGQL' }
        & Pick<GqlProcessingLossGql, 'date' | 'processing_loss_number' | 'batch_id' | 'processing_loss_id' | 'loss_type' | 'created_by' | 'distribution_center_id'>
        & { batch: Maybe<(
          { __typename?: 'BatchGQL' }
          & Pick<GqlBatchGql, 'batch_name'>
        )>, processing_loss_type: Maybe<(
          { __typename?: 'ProcessingLossTypeGQL' }
          & Pick<GqlProcessingLossTypeGql, 'processing_loss_type_id' | 'processing_loss_type_name'>
        )>, user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )>, distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlProcessing_Loss_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProcessing_Loss_TypesQuery = (
  { __typename?: 'Query' }
  & { processing_loss_types: Maybe<(
    { __typename?: 'ProcessingLossTypeGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProcessingLossTypeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProcessingLossTypeGQL' }
        & Pick<GqlProcessingLossTypeGql, 'processing_loss_type_name' | 'processing_loss_type_id'>
      )> }
    )>> }
  )> }
);

export type GqlProcessingLossByIdQueryVariables = Exact<{
  processingLossId: Maybe<Scalars['String']>;
}>;


export type GqlProcessingLossByIdQuery = (
  { __typename?: 'Query' }
  & { processing_loss_by_id: Maybe<(
    { __typename?: 'ProcessingLossGQL' }
    & Pick<GqlProcessingLossGql, 'date' | 'batch_id' | 'processing_loss_id' | 'loss_type' | 'created_by'>
    & { batch: Maybe<(
      { __typename?: 'BatchGQL' }
      & Pick<GqlBatchGql, 'batch_name'>
    )>, processing_loss_type: Maybe<(
      { __typename?: 'ProcessingLossTypeGQL' }
      & Pick<GqlProcessingLossTypeGql, 'processing_loss_type_id' | 'processing_loss_type_name'>
    )>, user: Maybe<(
      { __typename?: 'UserV2GQL' }
      & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
    )>, processing_loss_items: Maybe<Array<Maybe<(
      { __typename?: 'ProcessingLossItemGQL' }
      & Pick<GqlProcessingLossItemGql, 'active' | 'quantity' | 'thumbnail' | 'cancellation_reason' | 'processing_loss_item_id' | 'product_item_id' | 'unit_of_measure_id'>
      & { product_loss_reason: Maybe<(
        { __typename?: 'ProductLossReasonGQL' }
        & { loss_reason: Maybe<(
          { __typename?: 'LossReasonGQL' }
          & Pick<GqlLossReasonGql, 'loss_reason'>
        )> }
      )>, product_item: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )> }
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name'>
      )>, processing_loss: Maybe<(
        { __typename?: 'ProcessingLossGQL' }
        & Pick<GqlProcessingLossGql, 'processing_loss_id' | 'loss_type'>
      )> }
    )>>> }
  )> }
);

export type GqlProductItemV2Fragment = (
  { __typename?: 'ProductItemV2GQL' }
  & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'packed_weight' | 'packed_volume'>
  & { product: Maybe<(
    { __typename?: 'ProductV2GQL' }
    & Pick<GqlProductV2Gql, 'product_name'>
  )>, units_of_measure: Maybe<Array<Maybe<(
    { __typename?: 'ProductItemUOMV2GQL' }
    & Pick<GqlProductItemUomv2Gql, 'business_domain_id' | 'conversion_ratio'>
    & { business_domain: Maybe<(
      { __typename?: 'BusinessDomainV2GQL' }
      & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
    )>, uom: Maybe<(
      { __typename?: 'UOMV2GQL' }
      & Pick<GqlUomv2Gql, 'uom_id' | 'name'>
    )> }
  )>>> }
);

export type GqlStock_AvailabilityQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  distribution_center_id: Scalars['String'];
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlStock_AvailabilityQuery = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & { current_stock_availability: Maybe<(
          { __typename?: 'StockAvailabilityGQLv2' }
          & Pick<GqlStockAvailabilityGqLv2, 'region_id' | 'created_by' | 'stock_availability_id' | 'updated_by' | 'sale_date' | 'quantity' | 'stock_entry_number' | 'unit_of_measure_id' | 'active'>
          & { region: Maybe<(
            { __typename?: 'RegionV2GQL' }
            & Pick<GqlRegionV2Gql, 'region_name'>
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name' | 'abbreviation'>
          )>, user: Maybe<(
            { __typename?: 'UserV2GQL' }
            & Pick<GqlUserV2Gql, 'user_id' | 'first_name' | 'last_name' | 'user_number'>
          )> }
        )> }
        & GqlProductItemV2Fragment
      )> }
    )>> }
  )> }
);

export type GqlGetDCsStockAvailabilityQueryVariables = Exact<{
  regionId: Scalars['String'];
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  distribution_center_ids: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  depot_id: Scalars['String'];
  static_params: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlGetDCsStockAvailabilityQuery = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'base_price'>
        & { current_pricing_v2: Maybe<(
          { __typename?: 'PricingV2GQL' }
          & Pick<GqlPricingV2Gql, 'unit_of_measure_id' | 'base_price' | 'currency' | 'rrp' | 'pricing_date' | 'region_id'>
        )>, current_dcs_stock_availability: Maybe<(
          { __typename?: 'DCStockAvailabilityGQL' }
          & Pick<GqlDcStockAvailabilityGql, 'quantity'>
        )>, dynamic_price: Maybe<(
          { __typename?: 'DynamicPriceGQL' }
          & Pick<GqlDynamicPriceGql, 'base_price' | 'dynamic_price'>
        )> }
        & GqlProductItemV2Fragment
      )> }
    )>> }
  )> }
);

export type GqlWarehouseStockIntakeQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlWarehouseStockIntakeQuery = (
  { __typename?: 'Query' }
  & { stock_intakes: Maybe<(
    { __typename?: 'StockIntakeGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'StockIntakeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockIntakeGQL' }
        & Pick<GqlStockIntakeGql, 'created_by' | 'stock_intake_id' | 'stock_intake_number' | 'arrival_date' | 'truck_number' | 'intake_count' | 'distribution_center_id'>
        & { distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_id' | 'distribution_center_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlWarehouseStockIntakeByIdQueryVariables = Exact<{
  stock_intake_id: Scalars['String'];
}>;


export type GqlWarehouseStockIntakeByIdQuery = (
  { __typename?: 'Query' }
  & { stock_intake_by_id: Maybe<(
    { __typename?: 'StockIntakeGQL' }
    & Pick<GqlStockIntakeGql, 'stock_intake_id' | 'stock_intake_number' | 'arrival_date' | 'truck_number' | 'created_by'>
    & { stock_intake_photos: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakePhotoGQL' }
      & Pick<GqlStockIntakePhotoGql, 'signed_url'>
    )>>>, user: Maybe<(
      { __typename?: 'UserV2GQL' }
      & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
    )>, stock_intake_items: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakeItemGQL' }
      & Pick<GqlStockIntakeItemGql, 'active' | 'stock_intake_item_id' | 'cancellation_reason' | 'gross_weight' | 'batch_id' | 'weight' | 'quantity' | 'packaging_unit_id' | 'packaging_unit_quantity' | 'unit_of_measure_id' | 'product_item_id'>
      & { batch: Maybe<(
        { __typename?: 'BatchGQL' }
        & Pick<GqlBatchGql, 'batch_name'>
      )>, packaging_unit: Maybe<(
        { __typename?: 'PackagingUnitV2GQL' }
        & Pick<GqlPackagingUnitV2Gql, 'name'>
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name'>
      )>, product_item: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )> }
      )> }
    )>>> }
  )> }
);

export type GqlDistributionCentersQueryVariables = Exact<{
  dc_names: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GqlDistributionCentersQuery = (
  { __typename?: 'Query' }
  & { distribution_centers: Maybe<Array<Maybe<(
    { __typename?: 'DistributionCenterGQL' }
    & Pick<GqlDistributionCenterGql, 'distribution_center_name' | 'distribution_center_id'>
    & { warehouses: Maybe<Array<Maybe<(
      { __typename?: 'WarehouseGQL' }
      & Pick<GqlWarehouseGql, 'warehouse_id' | 'warehouse_name'>
      & { storage_units: Maybe<Array<Maybe<(
        { __typename?: 'StorageUnitGQL' }
        & Pick<GqlStorageUnitGql, 'storage_unit_id' | 'unit_name'>
        & { warehouse: Maybe<(
          { __typename?: 'WarehouseGQL' }
          & Pick<GqlWarehouseGql, 'warehouse_name' | 'warehouse_id'>
        )> }
      )>>> }
    )>>> }
  )>>> }
);

export type GqlBatchesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  batchFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlBatchesQuery = (
  { __typename?: 'Query' }
  & { batches: Maybe<(
    { __typename?: 'BatchGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'BatchGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BatchGQL' }
        & Pick<GqlBatchGql, 'active' | 'batch_id' | 'batch_name'>
        & { harvests: Maybe<Array<Maybe<(
          { __typename?: 'HarvestGQL' }
          & Pick<GqlHarvestGql, 'original_currency' | 'batch_id'>
          & { batch: Maybe<(
            { __typename?: 'BatchGQL' }
            & Pick<GqlBatchGql, 'batch_name'>
          )>, harvest_items: Maybe<Array<Maybe<(
            { __typename?: 'HarvestItemGQL' }
            & Pick<GqlHarvestItemGql, 'product_item_id' | 'quantity' | 'unit_of_measure_id' | 'weight' | 'packaging_unit_id' | 'number_of_crates' | 'packaging_unit_quantity'>
            & { uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )>, packaging_unit: Maybe<(
              { __typename?: 'PackagingUnitV2GQL' }
              & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'name'>
            )>, product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlWarehouseTransferQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  warehouseFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlWarehouseTransferQuery = (
  { __typename?: 'Query' }
  & { warehouse_transfer: Maybe<(
    { __typename?: 'WarehouseTransferGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'WarehouseTransferGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WarehouseTransferGQL' }
        & Pick<GqlWarehouseTransferGql, 'cancelled' | 'cancellation_reason' | 'active' | 'date_created' | 'warehouse_transfer_id' | 'transfer_number' | 'transfer_date' | 'direction' | 'vehicle_id' | 'transfer_reason_id' | 'source_distribution_center_id' | 'dest_distribution_center_id' | 'transferred_by'>
        & { vehicle: Maybe<(
          { __typename?: 'VehicleGQL' }
          & Pick<GqlVehicleGql, 'registration_number'>
        )>, transfer_reason: Maybe<(
          { __typename?: 'WarehouseTransferReasonGQL' }
          & Pick<GqlWarehouseTransferReasonGql, 'reason_name' | 'reason_id'>
        )>, source_distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
        )>, dest_distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
        )>, transferred_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name' | 'user_number'>
        )>, warehouse_transfer_items: Maybe<Array<Maybe<(
          { __typename?: 'WarehouseTransferItemGQL' }
          & Pick<GqlWarehouseTransferItemGql, 'cancelled' | 'cancellation_reason' | 'warehouse_transfer_item_id' | 'warehouse_transfer_id' | 'quantity' | 'packaging_unit_quantity' | 'batch_id' | 'product_id' | 'weight' | 'product_item_id' | 'unit_of_measure_id' | 'packaging_unit_id'>
          & { batch: Maybe<(
            { __typename?: 'BatchGQL' }
            & Pick<GqlBatchGql, 'batch_name'>
          )>, product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & Pick<GqlProductItemUomv2Gql, 'conversion_ratio'>
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
              )> }
            )>>> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )>, packaging_unit: Maybe<(
            { __typename?: 'PackagingUnitV2GQL' }
            & Pick<GqlPackagingUnitV2Gql, 'name'>
          )>, warehouse: Maybe<(
            { __typename?: 'WarehouseGQL' }
            & Pick<GqlWarehouseGql, 'warehouse_name'>
            & { storage_units: Maybe<Array<Maybe<(
              { __typename?: 'StorageUnitGQL' }
              & Pick<GqlStorageUnitGql, 'unit_name'>
            )>>> }
          )>, storage_unit: Maybe<(
            { __typename?: 'StorageUnitGQL' }
            & Pick<GqlStorageUnitGql, 'unit_name'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlVehiclesQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlVehiclesQuery = (
  { __typename?: 'Query' }
  & { vehicles: Maybe<(
    { __typename?: 'VehicleGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'VehicleGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'VehicleGQL' }
        & Pick<GqlVehicleGql, 'vehicle_id' | 'registration_number' | 'owner_name' | 'phone_number'>
      )> }
    )>> }
  )> }
);

export type GqlAppointmentsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  appointmentFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlAppointmentsQuery = (
  { __typename?: 'Query' }
  & { appointments: Maybe<(
    { __typename?: 'AppointmentGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'AppointmentGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'AppointmentGQL' }
        & Pick<GqlAppointmentGql, 'active' | 'cancelled' | 'cancellation_reason' | 'date_created' | 'appointment_id' | 'appointment_number' | 'appointment_type' | 'eta' | 'decline_reason' | 'distribution_center_id' | 'driver_name' | 'driver_phone_number' | 'images' | 'type_of_truck' | 'driver_id' | 'vehicle_seal_number' | 'dock_door_id' | 'vehicle_registration' | 'status' | 'issued_by'>
        & { distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_id' | 'distribution_center_name'>
        )>, dock_door: Maybe<(
          { __typename?: 'DockDoorGQL' }
          & Pick<GqlDockDoorGql, 'dock_door_number'>
        )>, issued_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )>, appointment_items: Maybe<Array<Maybe<(
          { __typename?: 'AppointmentItemGQL' }
          & Pick<GqlAppointmentItemGql, 'booking_id' | 'batch_id'>
          & { booking: Maybe<(
            { __typename?: 'BookingGQL' }
            & Pick<GqlBookingGql, 'farmer_id'>
            & { farmer: Maybe<(
              { __typename?: 'FarmerGQL' }
              & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number' | 'supplier_name' | 'farmer_id'>
            )>, booking_items: Maybe<Array<Maybe<(
              { __typename?: 'BookingItemGQL' }
              & Pick<GqlBookingItemGql, 'product_item_id'>
              & { product_item: Maybe<(
                { __typename?: 'ProductItemV2GQL' }
                & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
                & { product: Maybe<(
                  { __typename?: 'ProductV2GQL' }
                  & Pick<GqlProductV2Gql, 'product_name'>
                )> }
              )> }
            )>>> }
          )>, batch: Maybe<(
            { __typename?: 'BatchGQL' }
            & Pick<GqlBatchGql, 'batch_id'>
            & { harvests: Maybe<Array<Maybe<(
              { __typename?: 'HarvestGQL' }
              & Pick<GqlHarvestGql, 'farmer_id'>
              & { farmer: Maybe<(
                { __typename?: 'FarmerGQL' }
                & Pick<GqlFarmerGql, 'farmer_id' | 'farmer_number' | 'first_name' | 'last_name'>
              )> }
            )>>> }
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlAppointmentItemsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  appointmentFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlAppointmentItemsQuery = (
  { __typename?: 'Query' }
  & { appointment_items: Maybe<(
    { __typename?: 'AppointmentItemGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'AppointmentItemGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'AppointmentItemGQL' }
        & Pick<GqlAppointmentItemGql, 'active' | 'cancelled' | 'appointment_id' | 'warehouse_transfer_id' | 'batch_id' | 'booking_id' | 'return_id'>
        & { warehouse_transfer: Maybe<(
          { __typename?: 'WarehouseTransferGQL' }
          & Pick<GqlWarehouseTransferGql, 'warehouse_transfer_id'>
          & { warehouse_transfer_items: Maybe<Array<Maybe<(
            { __typename?: 'WarehouseTransferItemGQL' }
            & Pick<GqlWarehouseTransferItemGql, 'active' | 'product_item_id' | 'quantity' | 'weight' | 'unit_of_measure_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, returns: Maybe<(
          { __typename?: 'ReturnGQL' }
          & Pick<GqlReturnGql, 'active' | 'return_id'>
          & { product_return_items: Maybe<Array<Maybe<(
            { __typename?: 'ProductReturnItemGQL' }
            & Pick<GqlProductReturnItemGql, 'active' | 'product_item_id' | 'quantity' | 'unit_of_measure_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, booking: Maybe<(
          { __typename?: 'BookingGQL' }
          & Pick<GqlBookingGql, 'booking_id' | 'farmer_id'>
          & { farmer: Maybe<(
            { __typename?: 'FarmerGQL' }
            & Pick<GqlFarmerGql, 'supplier_name' | 'first_name' | 'last_name' | 'farmer_type' | 'phone_number'>
          )>, booking_items: Maybe<Array<Maybe<(
            { __typename?: 'BookingItemGQL' }
            & Pick<GqlBookingItemGql, 'active' | 'unit_of_measure_id' | 'product_item_id' | 'quantity' | 'weight'>
            & { uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )>, product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>> }
        )>, batch: Maybe<(
          { __typename?: 'BatchGQL' }
          & Pick<GqlBatchGql, 'batch_name' | 'batch_id'>
          & { harvests: Maybe<Array<Maybe<(
            { __typename?: 'HarvestGQL' }
            & Pick<GqlHarvestGql, 'original_currency' | 'farmer_id' | 'weight'>
            & { farmer: Maybe<(
              { __typename?: 'FarmerGQL' }
              & Pick<GqlFarmerGql, 'supplier_name' | 'first_name' | 'last_name' | 'farmer_type' | 'phone_number'>
            )>, harvest_items: Maybe<Array<Maybe<(
              { __typename?: 'HarvestItemGQL' }
              & Pick<GqlHarvestItemGql, 'product_item_id' | 'quantity' | 'unit_of_measure_id' | 'weight' | 'packaging_unit_id' | 'packaging_unit_quantity'>
              & { uom: Maybe<(
                { __typename?: 'UOMV2GQL' }
                & Pick<GqlUomv2Gql, 'name'>
              )>, packaging_unit: Maybe<(
                { __typename?: 'PackagingUnitV2GQL' }
                & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'name'>
              )>, product_item: Maybe<(
                { __typename?: 'ProductItemV2GQL' }
                & Pick<GqlProductItemV2Gql, 'product_item_name'>
                & { product: Maybe<(
                  { __typename?: 'ProductV2GQL' }
                  & Pick<GqlProductV2Gql, 'product_name'>
                )> }
              )> }
            )>>> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDockDoorsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlDockDoorsQuery = (
  { __typename?: 'Query' }
  & { dock_doors: Maybe<(
    { __typename?: 'DockDoorGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DockDoorGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DockDoorGQL' }
        & Pick<GqlDockDoorGql, 'active' | 'status' | 'dock_door_id' | 'dock_door_number' | 'door_type'>
        & { warehouse: Maybe<(
          { __typename?: 'WarehouseGQL' }
          & { distribution_center: Maybe<(
            { __typename?: 'DistributionCenterGQL' }
            & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakeQueryVariables = Exact<{
  intakeFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlStockIntakeQuery = (
  { __typename?: 'Query' }
  & { stock_intakes: Maybe<(
    { __typename?: 'StockIntakeGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'StockIntakeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockIntakeGQL' }
        & Pick<GqlStockIntakeGql, 'appointment_id' | 'stock_intake_number'>
        & { appointment: Maybe<(
          { __typename?: 'AppointmentGQL' }
          & Pick<GqlAppointmentGql, 'appointment_number' | 'vehicle_registration' | 'driver_name' | 'eta' | 'dock_door_id'>
          & { dock_door: Maybe<(
            { __typename?: 'DockDoorGQL' }
            & Pick<GqlDockDoorGql, 'dock_door_number'>
          )>, appointment_items: Maybe<Array<Maybe<(
            { __typename?: 'AppointmentItemGQL' }
            & Pick<GqlAppointmentItemGql, 'batch_id' | 'booking_id' | 'warehouse_transfer_id' | 'return_id'>
            & { returns: Maybe<(
              { __typename?: 'ReturnGQL' }
              & Pick<GqlReturnGql, 'active' | 'return_id'>
              & { product_return_items: Maybe<Array<Maybe<(
                { __typename?: 'ProductReturnItemGQL' }
                & Pick<GqlProductReturnItemGql, 'active' | 'product_item_id' | 'quantity' | 'unit_of_measure_id'>
                & { product_item: Maybe<(
                  { __typename?: 'ProductItemV2GQL' }
                  & Pick<GqlProductItemV2Gql, 'product_item_name'>
                  & { product: Maybe<(
                    { __typename?: 'ProductV2GQL' }
                    & Pick<GqlProductV2Gql, 'product_name'>
                  )> }
                )>, uom: Maybe<(
                  { __typename?: 'UOMV2GQL' }
                  & Pick<GqlUomv2Gql, 'name'>
                )> }
              )>>> }
            )>, warehouse_transfer: Maybe<(
              { __typename?: 'WarehouseTransferGQL' }
              & Pick<GqlWarehouseTransferGql, 'warehouse_transfer_id'>
              & { warehouse_transfer_items: Maybe<Array<Maybe<(
                { __typename?: 'WarehouseTransferItemGQL' }
                & Pick<GqlWarehouseTransferItemGql, 'active' | 'product_item_id' | 'quantity' | 'weight' | 'unit_of_measure_id'>
                & { product_item: Maybe<(
                  { __typename?: 'ProductItemV2GQL' }
                  & Pick<GqlProductItemV2Gql, 'product_item_name'>
                  & { product: Maybe<(
                    { __typename?: 'ProductV2GQL' }
                    & Pick<GqlProductV2Gql, 'product_name'>
                  )> }
                )>, uom: Maybe<(
                  { __typename?: 'UOMV2GQL' }
                  & Pick<GqlUomv2Gql, 'name'>
                )> }
              )>>> }
            )>, booking: Maybe<(
              { __typename?: 'BookingGQL' }
              & Pick<GqlBookingGql, 'booking_id' | 'farmer_id'>
              & { farmer: Maybe<(
                { __typename?: 'FarmerGQL' }
                & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number' | 'supplier_name'>
              )>, booking_items: Maybe<Array<Maybe<(
                { __typename?: 'BookingItemGQL' }
                & Pick<GqlBookingItemGql, 'active' | 'unit_of_measure_id' | 'product_item_id' | 'quantity' | 'weight'>
                & { uom: Maybe<(
                  { __typename?: 'UOMV2GQL' }
                  & Pick<GqlUomv2Gql, 'name'>
                )>, product_item: Maybe<(
                  { __typename?: 'ProductItemV2GQL' }
                  & Pick<GqlProductItemV2Gql, 'product_item_name'>
                  & { product: Maybe<(
                    { __typename?: 'ProductV2GQL' }
                    & Pick<GqlProductV2Gql, 'product_name'>
                  )> }
                )> }
              )>>> }
            )>, batch: Maybe<(
              { __typename?: 'BatchGQL' }
              & Pick<GqlBatchGql, 'batch_name'>
              & { harvests: Maybe<Array<Maybe<(
                { __typename?: 'HarvestGQL' }
                & Pick<GqlHarvestGql, 'original_currency' | 'farmer_id' | 'weight' | 'batch_id'>
                & { farmer: Maybe<(
                  { __typename?: 'FarmerGQL' }
                  & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number' | 'supplier_name'>
                )>, harvest_items: Maybe<Array<Maybe<(
                  { __typename?: 'HarvestItemGQL' }
                  & Pick<GqlHarvestItemGql, 'product_item_id' | 'quantity' | 'unit_of_measure_id' | 'weight' | 'packaging_unit_id' | 'packaging_unit_quantity'>
                  & { uom: Maybe<(
                    { __typename?: 'UOMV2GQL' }
                    & Pick<GqlUomv2Gql, 'name'>
                  )>, packaging_unit: Maybe<(
                    { __typename?: 'PackagingUnitV2GQL' }
                    & Pick<GqlPackagingUnitV2Gql, 'packaging_unit_id' | 'name'>
                  )>, product_item: Maybe<(
                    { __typename?: 'ProductItemV2GQL' }
                    & Pick<GqlProductItemV2Gql, 'product_item_name'>
                    & { product: Maybe<(
                      { __typename?: 'ProductV2GQL' }
                      & Pick<GqlProductV2Gql, 'product_name'>
                    )> }
                  )> }
                )>>> }
              )>>> }
            )> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlReturnsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  returnsFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlReturnsQuery = (
  { __typename?: 'Query' }
  & { returns: Maybe<(
    { __typename?: 'ReturnGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ReturnGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ReturnGQL' }
        & Pick<GqlReturnGql, 'return_number' | 'return_id'>
        & { product_return_items: Maybe<Array<Maybe<(
          { __typename?: 'ProductReturnItemGQL' }
          & Pick<GqlProductReturnItemGql, 'return_id' | 'product_item_id' | 'unit_of_measure_id' | 'quantity' | 'return_type'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlWarehouseTransferReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlWarehouseTransferReasonQuery = (
  { __typename?: 'Query' }
  & { warehouse_transfer_reason: Maybe<(
    { __typename?: 'WarehouseTransferReasonGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'WarehouseTransferReasonGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WarehouseTransferReasonGQL' }
        & Pick<GqlWarehouseTransferReasonGql, 'reason_id' | 'reason_name'>
      )> }
    )>> }
  )> }
);

export type GqlStockTakeQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  distribution_center_id: Scalars['String'];
}>;


export type GqlStockTakeQuery = (
  { __typename?: 'Query' }
  & { paginated_product_items_v2: Maybe<(
    { __typename?: 'ProductItemV2GQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & Pick<GqlPaginatorInfo, 'per_page' | 'total_count' | 'total_pages' | 'current_page'>
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductItemV2GQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'active' | 'product_item_name' | 'product_item_id'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )>, units_of_measure: Maybe<Array<Maybe<(
          { __typename?: 'ProductItemUOMV2GQL' }
          & { business_domain: Maybe<(
            { __typename?: 'BusinessDomainV2GQL' }
            & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'abbreviation' | 'uom_id'>
          )> }
        )>>>, inventory: Maybe<(
          { __typename?: 'InventoryGQL' }
          & Pick<GqlInventoryGql, 'storage_quantity' | 'inventory_quantity' | 'verified_quantity' | 'distribution_center_id'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakesQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlStockIntakesQuery = (
  { __typename?: 'Query' }
  & { stock_intakes: Maybe<(
    { __typename?: 'StockIntakeGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'StockIntakeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockIntakeGQL' }
        & Pick<GqlStockIntakeGql, 'active' | 'stock_intake_id' | 'stock_intake_number' | 'stock_intake_status' | 'date_created' | 'created_by' | 'appointment_id'>
        & { user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'user_id' | 'first_name' | 'last_name'>
        )>, appointment: Maybe<(
          { __typename?: 'AppointmentGQL' }
          & Pick<GqlAppointmentGql, 'appointment_number' | 'vehicle_seal_number' | 'distribution_center_id'>
          & { dock_door: Maybe<(
            { __typename?: 'DockDoorGQL' }
            & Pick<GqlDockDoorGql, 'dock_door_number'>
          )>, distribution_center: Maybe<(
            { __typename?: 'DistributionCenterGQL' }
            & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
          )>, appointment_items: Maybe<Array<Maybe<(
            { __typename?: 'AppointmentItemGQL' }
            & Pick<GqlAppointmentItemGql, 'booking_id'>
            & { booking: Maybe<(
              { __typename?: 'BookingGQL' }
              & Pick<GqlBookingGql, 'farmer_id'>
              & { farmer: Maybe<(
                { __typename?: 'FarmerGQL' }
                & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number' | 'supplier_name' | 'farmer_id'>
              )>, booking_items: Maybe<Array<Maybe<(
                { __typename?: 'BookingItemGQL' }
                & Pick<GqlBookingItemGql, 'product_item_id'>
                & { product_item: Maybe<(
                  { __typename?: 'ProductItemV2GQL' }
                  & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
                  & { product: Maybe<(
                    { __typename?: 'ProductV2GQL' }
                    & Pick<GqlProductV2Gql, 'product_name'>
                  )> }
                )> }
              )>>> }
            )> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakeItemsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlStockIntakeItemsQuery = (
  { __typename?: 'Query' }
  & { stock_intakes: Maybe<(
    { __typename?: 'StockIntakeGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'StockIntakeGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockIntakeGQL' }
        & Pick<GqlStockIntakeGql, 'active' | 'stock_intake_id' | 'stock_intake_number'>
        & { stock_intake_skus: Maybe<Array<Maybe<(
          { __typename?: 'StockIntakeSkuGQL' }
          & Pick<GqlStockIntakeSkuGql, 'product_item_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_id' | 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & Pick<GqlProductItemUomv2Gql, 'uom_id' | 'conversion_ratio'>
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
              )> }
            )>>> }
          )> }
        )>>>, stock_intake_items: Maybe<Array<Maybe<(
          { __typename?: 'StockIntakeItemGQL' }
          & Pick<GqlStockIntakeItemGql, 'stock_intake_item_id' | 'batch_id' | 'quantity' | 'active' | 'weight' | 'product_item_id' | 'unit_of_measure_id' | 'booking_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_id' | 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & Pick<GqlProductItemUomv2Gql, 'conversion_ratio'>
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
              )> }
            )>>> }
          )>, uom: Maybe<(
            { __typename?: 'UOMV2GQL' }
            & Pick<GqlUomv2Gql, 'name'>
          )>, booking: Maybe<(
            { __typename?: 'BookingGQL' }
            & Pick<GqlBookingGql, 'price'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakeSkusQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  filter: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlStockIntakeSkusQuery = (
  { __typename?: 'Query' }
  & { stock_intake_skus: Maybe<(
    { __typename?: 'StockIntakeSkuGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'StockIntakeSkuGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StockIntakeSkuGQL' }
        & Pick<GqlStockIntakeSkuGql, 'active' | 'stock_intake_sku_id' | 'stock_intake_id' | 'product_item_id' | 'supplier_batch_number' | 'stock_date' | 'order_by_date' | 'stock_availability_status' | 'rejected_quantity' | 'rejection_reason'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_id' | 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )>, units_of_measure: Maybe<Array<Maybe<(
            { __typename?: 'ProductItemUOMV2GQL' }
            & { business_domain: Maybe<(
              { __typename?: 'BusinessDomainV2GQL' }
              & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, stock_intake: Maybe<(
          { __typename?: 'StockIntakeGQL' }
          & Pick<GqlStockIntakeGql, 'stock_intake_status' | 'appointment_id'>
          & { stock_intake_items: Maybe<Array<Maybe<(
            { __typename?: 'StockIntakeItemGQL' }
            & Pick<GqlStockIntakeItemGql, 'active' | 'weight' | 'quantity' | 'unit_of_measure_id' | 'product_item_id'>
            & { stock_intake_item_assets: Maybe<Array<Maybe<(
              { __typename?: 'StockIntakeItemAssetGQL' }
              & Pick<GqlStockIntakeItemAssetGql, 'stock_intake_item_asset_id' | 'quantity'>
            )>>>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )>, product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>>, appointment: Maybe<(
            { __typename?: 'AppointmentGQL' }
            & { appointment_items: Maybe<Array<Maybe<(
              { __typename?: 'AppointmentItemGQL' }
              & Pick<GqlAppointmentItemGql, 'active' | 'appointment_id' | 'warehouse_transfer_id' | 'batch_id' | 'booking_id' | 'return_id'>
              & { warehouse_transfer: Maybe<(
                { __typename?: 'WarehouseTransferGQL' }
                & Pick<GqlWarehouseTransferGql, 'warehouse_transfer_id'>
                & { warehouse_transfer_items: Maybe<Array<Maybe<(
                  { __typename?: 'WarehouseTransferItemGQL' }
                  & Pick<GqlWarehouseTransferItemGql, 'active' | 'product_item_id' | 'quantity' | 'weight'>
                  & { product_item: Maybe<(
                    { __typename?: 'ProductItemV2GQL' }
                    & Pick<GqlProductItemV2Gql, 'product_item_name'>
                    & { product: Maybe<(
                      { __typename?: 'ProductV2GQL' }
                      & Pick<GqlProductV2Gql, 'product_name'>
                    )> }
                  )> }
                )>>> }
              )>, returns: Maybe<(
                { __typename?: 'ReturnGQL' }
                & Pick<GqlReturnGql, 'active' | 'return_id'>
                & { product_return_items: Maybe<Array<Maybe<(
                  { __typename?: 'ProductReturnItemGQL' }
                  & Pick<GqlProductReturnItemGql, 'active' | 'product_item_id' | 'quantity' | 'weight'>
                  & { product_item: Maybe<(
                    { __typename?: 'ProductItemV2GQL' }
                    & Pick<GqlProductItemV2Gql, 'product_item_name'>
                    & { product: Maybe<(
                      { __typename?: 'ProductV2GQL' }
                      & Pick<GqlProductV2Gql, 'product_name'>
                    )> }
                  )> }
                )>>> }
              )>, booking: Maybe<(
                { __typename?: 'BookingGQL' }
                & Pick<GqlBookingGql, 'booking_id'>
                & { booking_items: Maybe<Array<Maybe<(
                  { __typename?: 'BookingItemGQL' }
                  & Pick<GqlBookingItemGql, 'active' | 'product_item_id' | 'quantity' | 'weight'>
                  & { product_item: Maybe<(
                    { __typename?: 'ProductItemV2GQL' }
                    & Pick<GqlProductItemV2Gql, 'product_item_name'>
                    & { product: Maybe<(
                      { __typename?: 'ProductV2GQL' }
                      & Pick<GqlProductV2Gql, 'product_name'>
                    )> }
                  )> }
                )>>> }
              )>, batch: Maybe<(
                { __typename?: 'BatchGQL' }
                & Pick<GqlBatchGql, 'batch_name' | 'batch_id'>
                & { harvests: Maybe<Array<Maybe<(
                  { __typename?: 'HarvestGQL' }
                  & Pick<GqlHarvestGql, 'original_currency'>
                  & { harvest_items: Maybe<Array<Maybe<(
                    { __typename?: 'HarvestItemGQL' }
                    & Pick<GqlHarvestItemGql, 'product_item_id' | 'quantity' | 'weight'>
                    & { product_item: Maybe<(
                      { __typename?: 'ProductItemV2GQL' }
                      & Pick<GqlProductItemV2Gql, 'product_item_name'>
                      & { product: Maybe<(
                        { __typename?: 'ProductV2GQL' }
                        & Pick<GqlProductV2Gql, 'product_name'>
                      )> }
                    )> }
                  )>>> }
                )>>> }
              )> }
            )>>> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakeByIdQueryVariables = Exact<{
  stock_intake_id: Maybe<Scalars['String']>;
}>;


export type GqlStockIntakeByIdQuery = (
  { __typename?: 'Query' }
  & { stock_intake_by_id: Maybe<(
    { __typename?: 'StockIntakeGQL' }
    & Pick<GqlStockIntakeGql, 'active' | 'stock_intake_number' | 'stock_intake_id' | 'appointment_id' | 'date_created' | 'created_by' | 'stock_intake_status' | 'decline_reason'>
    & { stock_intake_photos: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakePhotoGQL' }
      & Pick<GqlStockIntakePhotoGql, 'intake_photo_id'>
    )>>>, stock_intake_users: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakeUserGQL' }
      & Pick<GqlStockIntakeUserGql, 'active' | 'user_id' | 'stock_intake_user_id'>
      & { user: Maybe<(
        { __typename?: 'UserV2GQL' }
        & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
      )> }
    )>>>, appointment: Maybe<(
      { __typename?: 'AppointmentGQL' }
      & Pick<GqlAppointmentGql, 'appointment_number' | 'vehicle_registration' | 'vehicle_seal_number' | 'driver_name' | 'issued_by' | 'distribution_center_id'>
      & { issued_by_user: Maybe<(
        { __typename?: 'UserV2GQL' }
        & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
      )>, dock_door: Maybe<(
        { __typename?: 'DockDoorGQL' }
        & Pick<GqlDockDoorGql, 'dock_door_number' | 'dock_door_id'>
      )>, distribution_center: Maybe<(
        { __typename?: 'DistributionCenterGQL' }
        & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
      )>, appointment_items: Maybe<Array<Maybe<(
        { __typename?: 'AppointmentItemGQL' }
        & Pick<GqlAppointmentItemGql, 'active' | 'appointment_id' | 'warehouse_transfer_id' | 'batch_id' | 'booking_id' | 'return_id'>
        & { warehouse_transfer: Maybe<(
          { __typename?: 'WarehouseTransferGQL' }
          & Pick<GqlWarehouseTransferGql, 'warehouse_transfer_id'>
          & { warehouse_transfer_items: Maybe<Array<Maybe<(
            { __typename?: 'WarehouseTransferItemGQL' }
            & Pick<GqlWarehouseTransferItemGql, 'active' | 'product_item_id' | 'unit_of_measure_id' | 'quantity'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, returns: Maybe<(
          { __typename?: 'ReturnGQL' }
          & Pick<GqlReturnGql, 'active' | 'return_id'>
          & { product_return_items: Maybe<Array<Maybe<(
            { __typename?: 'ProductReturnItemGQL' }
            & Pick<GqlProductReturnItemGql, 'active' | 'product_item_id' | 'quantity' | 'unit_of_measure_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, booking: Maybe<(
          { __typename?: 'BookingGQL' }
          & Pick<GqlBookingGql, 'booking_id' | 'farmer_id'>
          & { farmer: Maybe<(
            { __typename?: 'FarmerGQL' }
            & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number'>
          )>, booking_items: Maybe<Array<Maybe<(
            { __typename?: 'BookingItemGQL' }
            & Pick<GqlBookingItemGql, 'active' | 'product_item_id' | 'quantity' | 'unit_of_measure_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )>, uom: Maybe<(
              { __typename?: 'UOMV2GQL' }
              & Pick<GqlUomv2Gql, 'name'>
            )> }
          )>>> }
        )>, batch: Maybe<(
          { __typename?: 'BatchGQL' }
          & Pick<GqlBatchGql, 'batch_name' | 'batch_id'>
          & { harvests: Maybe<Array<Maybe<(
            { __typename?: 'HarvestGQL' }
            & Pick<GqlHarvestGql, 'original_currency' | 'farmer_id'>
            & { farmer: Maybe<(
              { __typename?: 'FarmerGQL' }
              & Pick<GqlFarmerGql, 'first_name' | 'last_name' | 'farmer_number'>
            )>, harvest_items: Maybe<Array<Maybe<(
              { __typename?: 'HarvestItemGQL' }
              & Pick<GqlHarvestItemGql, 'product_item_id' | 'quantity' | 'unit_of_measure_id'>
              & { uom: Maybe<(
                { __typename?: 'UOMV2GQL' }
                & Pick<GqlUomv2Gql, 'name'>
              )>, product_item: Maybe<(
                { __typename?: 'ProductItemV2GQL' }
                & Pick<GqlProductItemV2Gql, 'product_item_name'>
                & { product: Maybe<(
                  { __typename?: 'ProductV2GQL' }
                  & Pick<GqlProductV2Gql, 'product_name'>
                )> }
              )> }
            )>>> }
          )>>> }
        )> }
      )>>> }
    )>, user: Maybe<(
      { __typename?: 'UserV2GQL' }
      & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
    )>, stock_intake_items: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakeItemGQL' }
      & Pick<GqlStockIntakeItemGql, 'stock_intake_item_id' | 'quantity' | 'active' | 'weight' | 'product_item_id' | 'unit_of_measure_id' | 'pallet_id' | 'stock_intake_item_status'>
      & { product_item: Maybe<(
        { __typename?: 'ProductItemV2GQL' }
        & Pick<GqlProductItemV2Gql, 'product_id' | 'product_item_name'>
        & { product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )> }
      )>, uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name'>
      )>, pallet: Maybe<(
        { __typename?: 'AssetGQL' }
        & Pick<GqlAssetGql, 'asset_number'>
      )> }
    )>>> }
  )> }
);

export type GqlStockIntakeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlStockIntakeStatusQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'stock_intake_status'>
);

export type GqlStockAvailabilityStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlStockAvailabilityStatusQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'stock_availability_status'>
);

export type GqlIntakesPutAwayJobsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlIntakesPutAwayJobsQuery = (
  { __typename?: 'Query' }
  & { putaway_jobs: Maybe<(
    { __typename?: 'PutAwayJobGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'PutAwayJobGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PutAwayJobGQL' }
        & Pick<GqlPutAwayJobGql, 'active' | 'stock_intake_id' | 'job_id' | 'job_number' | 'job_status' | 'assigned_to' | 'product_item_id' | 'source_location_id'>
        & { assigned: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, destination_handling_unit: Maybe<(
          { __typename?: 'HandlingUnitGQL' }
          & Pick<GqlHandlingUnitGql, 'handling_unit_id' | 'quantity'>
          & { asset: Maybe<(
            { __typename?: 'AssetGQL' }
            & Pick<GqlAssetGql, 'asset_number'>
            & { asset_type: Maybe<(
              { __typename?: 'AssetTypeGQL' }
              & Pick<GqlAssetTypeGql, 'asset_type_name'>
            )> }
          )> }
        )>, source_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & { dock_door: Maybe<Array<Maybe<(
            { __typename?: 'DockDoorGQL' }
            & Pick<GqlDockDoorGql, 'dock_door_number'>
          )>>> }
        )>, destination_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & { bin: Maybe<Array<Maybe<(
            { __typename?: 'BinGQL' }
            & Pick<GqlBinGql, 'aisle' | 'bin_position' | 'level'>
            & { bin_names: Maybe<Array<Maybe<(
              { __typename?: 'BinNameGQL' }
              & Pick<GqlBinNameGql, 'bin_name_direction' | 'aisle' | 'bin_position' | 'level'>
            )>>> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlStockIntakeUsersQueryVariables = Exact<{
  stock_intake_id: Maybe<Scalars['String']>;
}>;


export type GqlStockIntakeUsersQuery = (
  { __typename?: 'Query' }
  & { stock_intake_by_id: Maybe<(
    { __typename?: 'StockIntakeGQL' }
    & Pick<GqlStockIntakeGql, 'stock_intake_id'>
    & { stock_intake_users: Maybe<Array<Maybe<(
      { __typename?: 'StockIntakeUserGQL' }
      & Pick<GqlStockIntakeUserGql, 'active' | 'user_id' | 'stock_intake_user_id'>
      & { user: Maybe<(
        { __typename?: 'UserV2GQL' }
        & Pick<GqlUserV2Gql, 'active' | 'first_name' | 'last_name'>
      )> }
    )>>> }
  )> }
);

export type GqlPutAwayJobsFragment = (
  { __typename?: 'PutAwayJobGQL' }
  & Pick<GqlPutAwayJobGql, 'active' | 'stock_intake_id' | 'quantity' | 'job_id' | 'job_number' | 'job_status' | 'assigned_to' | 'product_item_id' | 'source_location_id'>
  & { assigned: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
  )>, product_item: Maybe<(
    { __typename?: 'ProductItemV2GQL' }
    & Pick<GqlProductItemV2Gql, 'product_item_name'>
    & { product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_name'>
    )> }
  )>, destination_handling_unit: Maybe<(
    { __typename?: 'HandlingUnitGQL' }
    & Pick<GqlHandlingUnitGql, 'handling_unit_id'>
    & { asset: Maybe<(
      { __typename?: 'AssetGQL' }
      & Pick<GqlAssetGql, 'asset_number'>
      & { asset_type: Maybe<(
        { __typename?: 'AssetTypeGQL' }
        & Pick<GqlAssetTypeGql, 'asset_type_name'>
      )> }
    )> }
  )>, source_location: Maybe<(
    { __typename?: 'StorageLocationGQL' }
    & { dock_door: Maybe<Array<Maybe<(
      { __typename?: 'DockDoorGQL' }
      & Pick<GqlDockDoorGql, 'dock_door_number'>
    )>>> }
  )>, destination_location: Maybe<(
    { __typename?: 'StorageLocationGQL' }
    & { bin: Maybe<Array<Maybe<(
      { __typename?: 'BinGQL' }
      & Pick<GqlBinGql, 'aisle' | 'bin_position' | 'level'>
      & { bin_names: Maybe<Array<Maybe<(
        { __typename?: 'BinNameGQL' }
        & Pick<GqlBinNameGql, 'bin_name_direction' | 'aisle' | 'bin_position' | 'level'>
      )>>> }
    )>>> }
  )> }
);

export type GqlPutAwayJobsQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlPutAwayJobsQuery = (
  { __typename?: 'Query' }
  & { putaway_jobs: Maybe<(
    { __typename?: 'PutAwayJobGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'PutAwayJobGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PutAwayJobGQL' }
        & Pick<GqlPutAwayJobGql, 'date_created' | 'close_time' | 'start_time' | 'stock_intake_item_id' | 'cancelled'>
        & { stock_intake: Maybe<(
          { __typename?: 'StockIntakeGQL' }
          & Pick<GqlStockIntakeGql, 'stock_intake_number' | 'stock_intake_id'>
        )> }
        & GqlPutAwayJobsFragment
      )> }
    )>> }
  )> }
);

export type GqlReservePickingJobsFragmentFragment = (
  { __typename?: 'ReservePickingJobGQL' }
  & Pick<GqlReservePickingJobGql, 'active' | 'cancelled' | 'job_number' | 'job_id' | 'quantity' | 'handling_unit_id' | 'source_location_id' | 'assigned_to' | 'job_status' | 'product_item_id'>
  & { handling_unit: Maybe<(
    { __typename?: 'HandlingUnitGQL' }
    & Pick<GqlHandlingUnitGql, 'quantity' | 'asset_id'>
    & { asset: Maybe<(
      { __typename?: 'AssetGQL' }
      & Pick<GqlAssetGql, 'asset_number'>
    )> }
  )>, source_location: Maybe<(
    { __typename?: 'StorageLocationGQL' }
    & { bin: Maybe<Array<Maybe<(
      { __typename?: 'BinGQL' }
      & Pick<GqlBinGql, 'aisle' | 'bin_position' | 'level'>
      & { bin_names: Maybe<Array<Maybe<(
        { __typename?: 'BinNameGQL' }
        & Pick<GqlBinNameGql, 'bin_name_direction' | 'aisle' | 'bin_position' | 'level'>
      )>>> }
    )>>> }
  )>, assigned: Maybe<(
    { __typename?: 'UserV2GQL' }
    & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
  )>, product_item: Maybe<(
    { __typename?: 'ProductItemV2GQL' }
    & Pick<GqlProductItemV2Gql, 'product_item_name'>
    & { units_of_measure: Maybe<Array<Maybe<(
      { __typename?: 'ProductItemUOMV2GQL' }
      & { uom: Maybe<(
        { __typename?: 'UOMV2GQL' }
        & Pick<GqlUomv2Gql, 'name'>
      )> }
    )>>>, product: Maybe<(
      { __typename?: 'ProductV2GQL' }
      & Pick<GqlProductV2Gql, 'product_name'>
    )> }
  )> }
);

export type GqlAllReservePickingJobsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlAllReservePickingJobsQuery = (
  { __typename?: 'Query' }
  & { reserve_picking_jobs: Maybe<(
    { __typename?: 'ReservePickingJobGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ReservePickingJobGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ReservePickingJobGQL' }
        & Pick<GqlReservePickingJobGql, 'date_created' | 'close_time' | 'start_time' | 'job_type' | 'warehouse_transfer_request_id' | 'fdr_id'>
        & { warehouse_transfer_request: Maybe<(
          { __typename?: 'WarehouseTransferRequestGQL' }
          & Pick<GqlWarehouseTransferRequestGql, 'warehouse_transfer_request_number'>
        )>, fdr: Maybe<(
          { __typename?: 'FulfilmentDispatchRequestGQL' }
          & Pick<GqlFulfilmentDispatchRequestGql, 'fdr_number'>
        )>, destination_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & { dock_door: Maybe<Array<Maybe<(
            { __typename?: 'DockDoorGQL' }
            & Pick<GqlDockDoorGql, 'dock_door_number'>
          )>>>, bin: Maybe<Array<Maybe<(
            { __typename?: 'BinGQL' }
            & Pick<GqlBinGql, 'aisle' | 'bin_position' | 'level'>
            & { bin_names: Maybe<Array<Maybe<(
              { __typename?: 'BinNameGQL' }
              & Pick<GqlBinNameGql, 'bin_name_direction' | 'aisle' | 'bin_position' | 'level'>
            )>>> }
          )>>> }
        )> }
        & GqlReservePickingJobsFragmentFragment
      )> }
    )>> }
  )> }
);

export type GqlProductItemPickfacesBinQueryVariables = Exact<{
  page: Maybe<Scalars['Int']>;
  per_page: Maybe<Scalars['Int']>;
  search: Maybe<Scalars['String']>;
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlProductItemPickfacesBinQuery = (
  { __typename?: 'Query' }
  & { bins: Maybe<(
    { __typename?: 'BinGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'BinGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BinGQL' }
        & Pick<GqlBinGql, 'pickface_product_item_id' | 'active' | 'bin_type' | 'is_pickface' | 'storage_location_id' | 'capacity' | 'bin_id'>
        & { storage_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & Pick<GqlStorageLocationGql, 'storage_location_number'>
        )>, product_zone: Maybe<Array<Maybe<(
          { __typename?: 'ProductZoneGQL' }
          & Pick<GqlProductZoneGql, 'active' | 'product_zone_id' | 'product_zone_name'>
        )>>>, pickface_product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_id' | 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlLocationsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
}>;


export type GqlLocationsQuery = (
  { __typename?: 'Query' }
  & { storage_locations: Maybe<(
    { __typename?: 'StorageLocationGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'StorageLocationGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'StorageLocationGQL' }
        & Pick<GqlStorageLocationGql, 'status' | 'storage_location_id' | 'storage_location_number' | 'active'>
        & { bin: Maybe<Array<Maybe<(
          { __typename?: 'BinGQL' }
          & Pick<GqlBinGql, 'bin_id' | 'capacity' | 'is_pickface'>
          & { product_zone: Maybe<Array<Maybe<(
            { __typename?: 'ProductZoneGQL' }
            & Pick<GqlProductZoneGql, 'active' | 'product_zone_id' | 'product_zone_name'>
          )>>> }
        )>>>, location_type: Maybe<(
          { __typename?: 'StorageLocationTypeGQL' }
          & Pick<GqlStorageLocationTypeGql, 'location_type_name'>
        )>, handling_units: Maybe<Array<Maybe<(
          { __typename?: 'HandlingUnitGQL' }
          & Pick<GqlHandlingUnitGql, 'quantity' | 'stock_date' | 'stock_availability_status' | 'order_by_date' | 'active' | 'handling_unit_id'>
          & { asset: Maybe<(
            { __typename?: 'AssetGQL' }
            & Pick<GqlAssetGql, 'asset_id' | 'asset_number'>
          )>, handling_unit_items: Maybe<Array<Maybe<(
            { __typename?: 'HandlingUnitItemGQL' }
            & Pick<GqlHandlingUnitItemGql, 'dispatched' | 'active' | 'product_item_id' | 'handling_unit_item_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlProductLocationsQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  product_item_id: Maybe<Scalars['String']>;
  storage_location_number: Maybe<Scalars['String']>;
}>;


export type GqlProductLocationsQuery = (
  { __typename?: 'Query' }
  & { product_locations: Maybe<(
    { __typename?: 'ProductLocationGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductLocationGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductLocationGQL' }
        & Pick<GqlProductLocationGql, 'storage_location_id' | 'storage_location_number' | 'product_item_id' | 'hu_count' | 'hui_count'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_id' | 'image_url' | 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_id' | 'product_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlProductTransferReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProductTransferReasonsQuery = (
  { __typename?: 'Query' }
  & { product_transfer_reasons: Maybe<(
    { __typename?: 'ProductTransferReasonGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ProductTransferReasonGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductTransferReasonGQL' }
        & Pick<GqlProductTransferReasonGql, 'product_transfer_reason_id' | 'product_transfer_reason_name'>
      )> }
    )>> }
  )> }
);

export type GqlHandlingUnitItemsQueryVariables = Exact<{
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlHandlingUnitItemsQuery = (
  { __typename?: 'Query' }
  & { handling_unit_items: Maybe<(
    { __typename?: 'HandlingUnitItemGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'HandlingUnitItemGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'HandlingUnitItemGQL' }
        & Pick<GqlHandlingUnitItemGql, 'active' | 'handling_unit_item_id' | 'quantity' | 'dispatched' | 'stock_date' | 'stock_availability_status' | 'order_by_date' | 'product_item_id'>
        & { asset: Maybe<(
          { __typename?: 'AssetGQL' }
          & Pick<GqlAssetGql, 'asset_number'>
          & { asset_type: Maybe<(
            { __typename?: 'AssetTypeGQL' }
            & Pick<GqlAssetTypeGql, 'asset_type_name'>
          )> }
        )>, storage_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & Pick<GqlStorageLocationGql, 'storage_location_number'>
          & { location_type: Maybe<(
            { __typename?: 'StorageLocationTypeGQL' }
            & Pick<GqlStorageLocationTypeGql, 'location_type_name'>
          )> }
        )>, handling_unit: Maybe<(
          { __typename?: 'HandlingUnitGQL' }
          & { asset: Maybe<(
            { __typename?: 'AssetGQL' }
            & Pick<GqlAssetGql, 'asset_number'>
            & { asset_type: Maybe<(
              { __typename?: 'AssetTypeGQL' }
              & Pick<GqlAssetTypeGql, 'asset_type_name'>
            )> }
          )> }
        )>, product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlAssetsQueryVariables = Exact<{
  filter: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlAssetsQuery = (
  { __typename?: 'Query' }
  & { assets: Maybe<(
    { __typename?: 'AssetGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AssetGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'AssetGQL' }
        & Pick<GqlAssetGql, 'asset_id' | 'active' | 'asset_number' | 'asset_type_id'>
        & { asset_type: Maybe<(
          { __typename?: 'AssetTypeGQL' }
          & Pick<GqlAssetTypeGql, 'asset_type_name'>
        )>, handling_units: Maybe<Array<Maybe<(
          { __typename?: 'HandlingUnitGQL' }
          & Pick<GqlHandlingUnitGql, 'active' | 'quantity' | 'storage_location_id' | 'stock_availability_status' | 'stock_date' | 'order_by_date' | 'handling_unit_id'>
          & { storage_location: Maybe<(
            { __typename?: 'StorageLocationGQL' }
            & Pick<GqlStorageLocationGql, 'storage_location_number'>
            & { location_type: Maybe<(
              { __typename?: 'StorageLocationTypeGQL' }
              & Pick<GqlStorageLocationTypeGql, 'location_type_name'>
            )> }
          )>, asset: Maybe<(
            { __typename?: 'AssetGQL' }
            & Pick<GqlAssetGql, 'asset_id' | 'asset_number'>
            & { asset_type: Maybe<(
              { __typename?: 'AssetTypeGQL' }
              & Pick<GqlAssetTypeGql, 'asset_type_name'>
            )> }
          )>, handling_unit_items: Maybe<Array<Maybe<(
            { __typename?: 'HandlingUnitItemGQL' }
            & Pick<GqlHandlingUnitItemGql, 'dispatched' | 'storage_location_id' | 'active' | 'product_item_id' | 'handling_unit_id' | 'handling_unit_item_id' | 'date_updated' | 'order_by_date'>
            & { asset: Maybe<(
              { __typename?: 'AssetGQL' }
              & Pick<GqlAssetGql, 'asset_id' | 'asset_number'>
              & { asset_type: Maybe<(
                { __typename?: 'AssetTypeGQL' }
                & Pick<GqlAssetTypeGql, 'asset_type_name'>
              )> }
            )>, product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_id' | 'product_item_id' | 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlFulfilmentDispatchReQuestFragment = (
  { __typename?: 'FulfilmentDispatchRequestGQL' }
  & Pick<GqlFulfilmentDispatchRequestGql, 'fdr_number' | 'fdr_id' | 'active' | 'fdr_complete' | 'sale_date' | 'date_created' | 'order_time_start' | 'order_time_end' | 'dock_door_id'>
  & { dock_door: Maybe<(
    { __typename?: 'DockDoorGQL' }
    & Pick<GqlDockDoorGql, 'dock_door_number' | 'staging_area_name' | 'warehouse_id'>
    & { warehouse: Maybe<(
      { __typename?: 'WarehouseGQL' }
      & Pick<GqlWarehouseGql, 'distribution_center_id'>
      & { distribution_center: Maybe<(
        { __typename?: 'DistributionCenterGQL' }
        & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
      )> }
    )> }
  )>, fdr_items: Maybe<Array<Maybe<(
    { __typename?: 'FulfilmentDispatchRequestItemGQL' }
    & Pick<GqlFulfilmentDispatchRequestItemGql, 'route_id' | 'route_plan_id'>
    & { route: Maybe<(
      { __typename?: 'RouteV2GQL' }
      & Pick<GqlRouteV2Gql, 'route_name' | 'depot_id'>
      & { depot: Maybe<(
        { __typename?: 'DepotV2GQL' }
        & Pick<GqlDepotV2Gql, 'depot_name'>
      )> }
    )>, route_plan: Maybe<(
      { __typename?: 'RoutePlanGQL' }
      & Pick<GqlRoutePlanGql, 'multiple_trips' | 'vehicle_trip' | 'vehicle_id' | 'depot_id'>
      & { vehicle: Maybe<(
        { __typename?: 'VehicleGQL' }
        & Pick<GqlVehicleGql, 'registration_number'>
      )>, depot: Maybe<(
        { __typename?: 'DepotV2GQL' }
        & Pick<GqlDepotV2Gql, 'depot_name'>
      )> }
    )> }
  )>>> }
);

export type GqlFdrSkusFragment = (
  { __typename?: 'FulfilmentDispatchRequestGQL' }
  & { fdr_skus: Maybe<Array<Maybe<(
    { __typename?: 'FDRSKUGQL' }
    & Pick<GqlFdrskugql, 'active' | 'product_item_id' | 'quantity' | 'loaded_quantity' | 'available_stock' | 'amount_planned_from_reserve' | 'amount_planned_from_pickface'>
    & { product_item: Maybe<(
      { __typename?: 'ProductItemV2GQL' }
      & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
      & { product: Maybe<(
        { __typename?: 'ProductV2GQL' }
        & Pick<GqlProductV2Gql, 'product_name'>
      )>, units_of_measure: Maybe<Array<Maybe<(
        { __typename?: 'ProductItemUOMV2GQL' }
        & { business_domain: Maybe<(
          { __typename?: 'BusinessDomainV2GQL' }
          & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
        )>, uom: Maybe<(
          { __typename?: 'UOMV2GQL' }
          & Pick<GqlUomv2Gql, 'name'>
        )> }
      )>>> }
    )> }
  )>>> }
);

export type GqlOrderFulfilmentQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  orderFulfilmentFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlOrderFulfilmentQuery = (
  { __typename?: 'Query' }
  & { fulfilment_dispatch_requests: Maybe<(
    { __typename?: 'FulfilmentDispatchRequestGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'FulfilmentDispatchRequestGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'FulfilmentDispatchRequestGQL' }
        & Pick<GqlFulfilmentDispatchRequestGql, 'distribution_center_id'>
        & { distribution_center: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
        )> }
        & GqlFulfilmentDispatchReQuestFragment
      )> }
    )>> }
  )> }
);

export type GqlOrderFulfilmentByIdQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  orderFulfilmentFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlOrderFulfilmentByIdQuery = (
  { __typename?: 'Query' }
  & { fulfilment_dispatch_requests: Maybe<(
    { __typename?: 'FulfilmentDispatchRequestGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'FulfilmentDispatchRequestGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'FulfilmentDispatchRequestGQL' }
        & Pick<GqlFulfilmentDispatchRequestGql, 'created_by'>
        & { loading_task: Maybe<(
          { __typename?: 'LoadingTaskGQL' }
          & { loaded_quantity: Maybe<Array<Maybe<(
            { __typename?: 'LoadedQuantityGQL' }
            & Pick<GqlLoadedQuantityGql, 'quantity'>
          )>>> }
        )>, created_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )> }
        & GqlFulfilmentDispatchReQuestFragment
        & GqlFdrSkusFragment
      )> }
    )>> }
  )> }
);

export type GqlOrderFulfilmentByIdSummaryQueryVariables = Exact<{
  orderFulfilmentFilters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlOrderFulfilmentByIdSummaryQuery = (
  { __typename?: 'Query' }
  & { fulfilment_dispatch_requests: Maybe<(
    { __typename?: 'FulfilmentDispatchRequestGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'FulfilmentDispatchRequestGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'FulfilmentDispatchRequestGQL' }
        & { reserve_picking_jobs: Maybe<Array<Maybe<(
          { __typename?: 'ReservePickingJobGQL' }
          & Pick<GqlReservePickingJobGql, 'job_status' | 'job_id' | 'quantity'>
        )>>>, pickface_picking_tasks: Maybe<Array<Maybe<(
          { __typename?: 'PickFacePickingTaskGQL' }
          & Pick<GqlPickFacePickingTaskGql, 'task_id' | 'quantity' | 'balance' | 'product_item_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )> }
        )>>> }
        & GqlFulfilmentDispatchReQuestFragment
        & GqlFdrSkusFragment
      )> }
    )>> }
  )> }
);

export type GqlFdrSkuQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  fdrSkuFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlFdrSkuQuery = (
  { __typename?: 'Query' }
  & { fdr_skus: Maybe<(
    { __typename?: 'FDRSKUGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'FDRSKUGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'FDRSKUGQL' }
        & Pick<GqlFdrskugql, 'active' | 'product_item_id' | 'available_stock' | 'inventory_balance' | 'loaded_quantity' | 'quantity' | 'fdr_id'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, fdr: Maybe<(
          { __typename?: 'FulfilmentDispatchRequestGQL' }
          & { reserve_picking_jobs: Maybe<Array<Maybe<(
            { __typename?: 'ReservePickingJobGQL' }
            & Pick<GqlReservePickingJobGql, 'product_item_id' | 'job_status'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>>, reserve_picking_balance: Maybe<Array<Maybe<(
            { __typename?: 'ReservePickingBalanceGQL' }
            & Pick<GqlReservePickingBalanceGql, 'balance'>
          )>>>, pickface_picking_tasks: Maybe<Array<Maybe<(
            { __typename?: 'PickFacePickingTaskGQL' }
            & Pick<GqlPickFacePickingTaskGql, 'quantity' | 'balance' | 'product_item_id'>
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlReservePickingJobsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  pickingJobsFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlReservePickingJobsQuery = (
  { __typename?: 'Query' }
  & { reserve_picking_jobs: Maybe<(
    { __typename?: 'ReservePickingJobGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ReservePickingJobGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ReservePickingJobGQL' }
        & GqlReservePickingJobsFragmentFragment
      )> }
    )>> }
  )> }
);

export type GqlWarehouseTransferRequestQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  warehouseFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlWarehouseTransferRequestQuery = (
  { __typename?: 'Query' }
  & { warehouse_transfer_requests: Maybe<(
    { __typename?: 'WarehouseTransferRequestGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'WarehouseTransferRequestGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WarehouseTransferRequestGQL' }
        & Pick<GqlWarehouseTransferRequestGql, 'active' | 'warehouse_transfer_request_id' | 'warehouse_transfer_request_number' | 'warehouse_transfer_request_complete' | 'vehicle_id' | 'date_created' | 'destination_dc_id' | 'dock_door_id'>
        & { vehicle: Maybe<(
          { __typename?: 'VehicleGQL' }
          & Pick<GqlVehicleGql, 'registration_number'>
        )>, destination_dc: Maybe<(
          { __typename?: 'DistributionCenterGQL' }
          & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
        )>, dock_door: Maybe<(
          { __typename?: 'DockDoorGQL' }
          & Pick<GqlDockDoorGql, 'dock_door_number' | 'staging_area_name' | 'warehouse_id'>
          & { warehouse: Maybe<(
            { __typename?: 'WarehouseGQL' }
            & Pick<GqlWarehouseGql, 'warehouse_name' | 'distribution_center_id'>
            & { distribution_center: Maybe<(
              { __typename?: 'DistributionCenterGQL' }
              & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
            )> }
          )> }
        )>, warehouse_transfer_request_items: Maybe<Array<Maybe<(
          { __typename?: 'WarehouseTransferRequestItemGQL' }
          & Pick<GqlWarehouseTransferRequestItemGql, 'warehouse_transfer_request_item_id' | 'quantity' | 'product_item_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
              )>, uom: Maybe<(
                { __typename?: 'UOMV2GQL' }
                & Pick<GqlUomv2Gql, 'name'>
              )> }
            )>>> }
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlWarehouseTransferRequestItemsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  warehouseItemFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlWarehouseTransferRequestItemsQuery = (
  { __typename?: 'Query' }
  & { warehouse_transfer_request_items: Maybe<(
    { __typename?: 'WarehouseTransferRequestItemGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'WarehouseTransferRequestItemGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WarehouseTransferRequestItemGQL' }
        & Pick<GqlWarehouseTransferRequestItemGql, 'active' | 'warehouse_transfer_request_id' | 'product_item_id' | 'quantity'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, warehouse_transfer_request: Maybe<(
          { __typename?: 'WarehouseTransferRequestGQL' }
          & { reserve_picking_jobs: Maybe<Array<Maybe<(
            { __typename?: 'ReservePickingJobGQL' }
            & Pick<GqlReservePickingJobGql, 'product_item_id' | 'job_status'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>>, reserve_picking_balance: Maybe<Array<Maybe<(
            { __typename?: 'ReservePickingBalanceGQL' }
            & Pick<GqlReservePickingBalanceGql, 'balance'>
          )>>>, pickface_picking_tasks: Maybe<Array<Maybe<(
            { __typename?: 'PickFacePickingTaskGQL' }
            & Pick<GqlPickFacePickingTaskGql, 'quantity' | 'balance' | 'product_item_id'>
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlDisposalsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  disposalFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlDisposalsQuery = (
  { __typename?: 'Query' }
  & { disposals: Maybe<(
    { __typename?: 'DisposalGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DisposalGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DisposalGQL' }
        & Pick<GqlDisposalGql, 'dock_door_id' | 'disposal_id' | 'active' | 'date_created' | 'disposal_number' | 'disposal_complete'>
        & { dock_door: Maybe<(
          { __typename?: 'DockDoorGQL' }
          & Pick<GqlDockDoorGql, 'dock_door_number' | 'warehouse_id'>
          & { warehouse: Maybe<(
            { __typename?: 'WarehouseGQL' }
            & Pick<GqlWarehouseGql, 'warehouse_name' | 'distribution_center_id'>
            & { distribution_center: Maybe<(
              { __typename?: 'DistributionCenterGQL' }
              & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
            )> }
          )> }
        )>, disposal_items: Maybe<Array<Maybe<(
          { __typename?: 'DisposalItemGQL' }
          & Pick<GqlDisposalItemGql, 'quantity' | 'product_item_id'>
          & { product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )>, units_of_measure: Maybe<Array<Maybe<(
              { __typename?: 'ProductItemUOMV2GQL' }
              & { business_domain: Maybe<(
                { __typename?: 'BusinessDomainV2GQL' }
                & Pick<GqlBusinessDomainV2Gql, 'domain_name' | 'business_domain_id'>
              )>, uom: Maybe<(
                { __typename?: 'UOMV2GQL' }
                & Pick<GqlUomv2Gql, 'name'>
              )> }
            )>>> }
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlDisposalItemsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  disposalItemFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlDisposalItemsQuery = (
  { __typename?: 'Query' }
  & { disposal_items: Maybe<(
    { __typename?: 'DisposalItemGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'DisposalItemGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'DisposalItemGQL' }
        & Pick<GqlDisposalItemGql, 'active' | 'disposal_item_id' | 'disposal_id' | 'product_item_id' | 'quantity'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlWmsReturnsQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  returnsFilters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlWmsReturnsQuery = (
  { __typename?: 'Query' }
  & { wms_returns: Maybe<(
    { __typename?: 'WMSReturnsGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'WMSReturnsGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'WMSReturnsGQL' }
        & Pick<GqlWmsReturnsGql, 'wms_returns_number' | 'wms_returns_id' | 'appointment_id'>
        & { appointment: Maybe<(
          { __typename?: 'AppointmentGQL' }
          & Pick<GqlAppointmentGql, 'appointment_number' | 'vehicle_registration' | 'driver_name' | 'eta' | 'dock_door_id' | 'issued_by' | 'distribution_center_id'>
          & { dock_door: Maybe<(
            { __typename?: 'DockDoorGQL' }
            & Pick<GqlDockDoorGql, 'dock_door_number'>
          )>, issued_by_user: Maybe<(
            { __typename?: 'UserV2GQL' }
            & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
          )>, distribution_center: Maybe<(
            { __typename?: 'DistributionCenterGQL' }
            & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
          )>, appointment_items: Maybe<Array<Maybe<(
            { __typename?: 'AppointmentItemGQL' }
            & Pick<GqlAppointmentItemGql, 'return_id'>
            & { returns: Maybe<(
              { __typename?: 'ReturnGQL' }
              & { product_return_items: Maybe<Array<Maybe<(
                { __typename?: 'ProductReturnItemGQL' }
                & Pick<GqlProductReturnItemGql, 'quantity' | 'unit_of_measure_id' | 'product_item_id'>
                & { uom: Maybe<(
                  { __typename?: 'UOMV2GQL' }
                  & Pick<GqlUomv2Gql, 'name'>
                )>, product_item: Maybe<(
                  { __typename?: 'ProductItemV2GQL' }
                  & Pick<GqlProductItemV2Gql, 'product_item_name'>
                  & { product: Maybe<(
                    { __typename?: 'ProductV2GQL' }
                    & Pick<GqlProductV2Gql, 'product_name'>
                  )> }
                )> }
              )>>> }
            )> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlLoadingTasksQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlLoadingTasksQuery = (
  { __typename?: 'Query' }
  & { loading_tasks: Maybe<(
    { __typename?: 'LoadingTaskGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'LoadingTaskGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'LoadingTaskGQL' }
        & Pick<GqlLoadingTaskGql, 'active' | 'status' | 'loading_number' | 'loaded_weight' | 'loading_task_id' | 'date_updated' | 'inventory_location_id' | 'total_loaded_quantity' | 'picture' | 'created_by'>
        & { fdr: Maybe<(
          { __typename?: 'FulfilmentDispatchRequestGQL' }
          & Pick<GqlFulfilmentDispatchRequestGql, 'fdr_number'>
          & { dock_door: Maybe<(
            { __typename?: 'DockDoorGQL' }
            & { warehouse: Maybe<(
              { __typename?: 'WarehouseGQL' }
              & { distribution_center: Maybe<(
                { __typename?: 'DistributionCenterGQL' }
                & Pick<GqlDistributionCenterGql, 'distribution_center_name'>
              )> }
            )> }
          )>, fdr_items: Maybe<Array<Maybe<(
            { __typename?: 'FulfilmentDispatchRequestItemGQL' }
            & Pick<GqlFulfilmentDispatchRequestItemGql, 'route_id' | 'route_plan_id'>
            & { route: Maybe<(
              { __typename?: 'RouteV2GQL' }
              & Pick<GqlRouteV2Gql, 'route_name' | 'depot_id'>
              & { depot: Maybe<(
                { __typename?: 'DepotV2GQL' }
                & Pick<GqlDepotV2Gql, 'depot_name'>
              )> }
            )>, route_plan: Maybe<(
              { __typename?: 'RoutePlanGQL' }
              & Pick<GqlRoutePlanGql, 'vehicle_id' | 'depot_id'>
              & { vehicle: Maybe<(
                { __typename?: 'VehicleGQL' }
                & Pick<GqlVehicleGql, 'registration_number'>
              )>, depot: Maybe<(
                { __typename?: 'DepotV2GQL' }
                & Pick<GqlDepotV2Gql, 'depot_name'>
              )> }
            )> }
          )>>> }
        )>, inventory_location: Maybe<(
          { __typename?: 'InventoryLocationGQL' }
          & Pick<GqlInventoryLocationGql, 'inventory_location_name'>
        )>, loading_task_items: Maybe<Array<Maybe<(
          { __typename?: 'LoadingTaskItemGQL' }
          & Pick<GqlLoadingTaskItemGql, 'handling_unit_item_id'>
          & { handling_unit_item: Maybe<(
            { __typename?: 'HandlingUnitItemGQL' }
            & Pick<GqlHandlingUnitItemGql, 'quantity' | 'product_item_id'>
            & { product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )>, units_of_measure: Maybe<Array<Maybe<(
                { __typename?: 'ProductItemUOMV2GQL' }
                & { business_domain: Maybe<(
                  { __typename?: 'BusinessDomainV2GQL' }
                  & Pick<GqlBusinessDomainV2Gql, 'domain_name'>
                )>, uom: Maybe<(
                  { __typename?: 'UOMV2GQL' }
                  & Pick<GqlUomv2Gql, 'name'>
                )> }
              )>>> }
            )> }
          )> }
        )>>>, created_by_user: Maybe<(
          { __typename?: 'UserV2GQL' }
          & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlPickingHandlingUnitsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
}>;


export type GqlPickingHandlingUnitsQuery = (
  { __typename?: 'Query' }
  & { picking_handling_units: Maybe<(
    { __typename?: 'PickingHandlingUnitGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'PickingHandlingUnitGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'PickingHandlingUnitGQL' }
        & Pick<GqlPickingHandlingUnitGql, 'active' | 'picking_hu_id' | 'dispatch_reference_id' | 'handling_unit_id' | 'final_location_id' | 'is_complete' | 'picked_quantity'>
        & { final_location: Maybe<(
          { __typename?: 'StorageLocationGQL' }
          & Pick<GqlStorageLocationGql, 'storage_location_number'>
        )>, handling_unit: Maybe<(
          { __typename?: 'HandlingUnitGQL' }
          & Pick<GqlHandlingUnitGql, 'storage_location_id' | 'updated_by'>
          & { asset: Maybe<(
            { __typename?: 'AssetGQL' }
            & Pick<GqlAssetGql, 'asset_number'>
          )>, storage_location: Maybe<(
            { __typename?: 'StorageLocationGQL' }
            & Pick<GqlStorageLocationGql, 'storage_location_number'>
          )>, updated_by_user: Maybe<(
            { __typename?: 'UserV2GQL' }
            & Pick<GqlUserV2Gql, 'first_name' | 'last_name'>
          )>, handling_unit_items: Maybe<Array<Maybe<(
            { __typename?: 'HandlingUnitItemGQL' }
            & Pick<GqlHandlingUnitItemGql, 'storage_location_id' | 'product_item_id'>
            & { storage_location: Maybe<(
              { __typename?: 'StorageLocationGQL' }
              & Pick<GqlStorageLocationGql, 'storage_location_number'>
            )>, asset: Maybe<(
              { __typename?: 'AssetGQL' }
              & Pick<GqlAssetGql, 'asset_number'>
            )>, product_item: Maybe<(
              { __typename?: 'ProductItemV2GQL' }
              & Pick<GqlProductItemV2Gql, 'product_item_name' | 'product_id'>
              & { product: Maybe<(
                { __typename?: 'ProductV2GQL' }
                & Pick<GqlProductV2Gql, 'product_name'>
              )> }
            )> }
          )>>> }
        )> }
      )> }
    )>> }
  )> }
);

export type GqlProductZonesQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlProductZonesQuery = (
  { __typename?: 'Query' }
  & { product_zones: Maybe<(
    { __typename?: 'ProductZoneGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductZoneGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductZoneGQL' }
        & Pick<GqlProductZoneGql, 'active' | 'product_zone_name' | 'product_zone_type' | 'product_zone_id' | 'product_zone_description'>
        & { rules: Maybe<Array<Maybe<(
          { __typename?: 'RuleGQL' }
          & Pick<GqlRuleGql, 'active' | 'rule_name' | 'rule_id'>
        )>>>, bins: Maybe<Array<Maybe<(
          { __typename?: 'BinGQL' }
          & Pick<GqlBinGql, 'active' | 'is_pickface' | 'capacity' | 'storage_location_id'>
          & { storage_location: Maybe<(
            { __typename?: 'StorageLocationGQL' }
            & Pick<GqlStorageLocationGql, 'status'>
          )>, bin_names: Maybe<Array<Maybe<(
            { __typename?: 'BinNameGQL' }
            & Pick<GqlBinNameGql, 'aisle' | 'level' | 'bin_position' | 'bin_id'>
          )>>> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlRulesQueryVariables = Exact<{
  per_page: Maybe<Scalars['Int']>;
  page: Maybe<Scalars['Int']>;
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  active: Maybe<Scalars['Boolean']>;
}>;


export type GqlRulesQuery = (
  { __typename?: 'Query' }
  & { rules: Maybe<(
    { __typename?: 'RuleGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'RuleGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RuleGQL' }
        & Pick<GqlRuleGql, 'active' | 'rule_id' | 'rule_name' | 'rule_description'>
        & { product_rules: Maybe<Array<Maybe<(
          { __typename?: 'ProductRuleGQL' }
          & Pick<GqlProductRuleGql, 'product_id' | 'product_item_id' | 'is_sku_rule'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'active' | 'product_name' | 'product_id'>
          )>, product_item: Maybe<(
            { __typename?: 'ProductItemV2GQL' }
            & Pick<GqlProductItemV2Gql, 'active' | 'product_item_name'>
            & { product: Maybe<(
              { __typename?: 'ProductV2GQL' }
              & Pick<GqlProductV2Gql, 'product_name'>
            )> }
          )> }
        )>>>, category_rules: Maybe<Array<Maybe<(
          { __typename?: 'CategoryRuleGQL' }
          & Pick<GqlCategoryRuleGql, 'category_id' | 'category_rule_type' | 'active'>
          & { category: Maybe<(
            { __typename?: 'CategoryV2GQL' }
            & Pick<GqlCategoryV2Gql, 'category_name' | 'category_id'>
          )> }
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlProductRulesQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlProductRulesQuery = (
  { __typename?: 'Query' }
  & { product_rules: Maybe<(
    { __typename?: 'ProductRuleGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'ProductRuleGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'ProductRuleGQL' }
        & Pick<GqlProductRuleGql, 'active' | 'rule_id' | 'product_id' | 'product_item_id' | 'is_sku_rule'>
        & { product_item: Maybe<(
          { __typename?: 'ProductItemV2GQL' }
          & Pick<GqlProductItemV2Gql, 'product_item_name'>
          & { product: Maybe<(
            { __typename?: 'ProductV2GQL' }
            & Pick<GqlProductV2Gql, 'product_name'>
          )> }
        )>, product: Maybe<(
          { __typename?: 'ProductV2GQL' }
          & Pick<GqlProductV2Gql, 'product_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlCategoryRulesQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
}>;


export type GqlCategoryRulesQuery = (
  { __typename?: 'Query' }
  & { category_rules: Maybe<(
    { __typename?: 'CategoryRuleGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'CategoryRuleGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'CategoryRuleGQL' }
        & Pick<GqlCategoryRuleGql, 'active' | 'rule_id' | 'category_id'>
        & { category: Maybe<(
          { __typename?: 'CategoryV2GQL' }
          & Pick<GqlCategoryV2Gql, 'category_name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GqlZoneTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlZoneTypesQuery = (
  { __typename?: 'Query' }
  & Pick<GqlQuery, 'product_zone_types'>
);

export type GqlStorageLocationsQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
  per_page: Maybe<Scalars['Int']>;
}>;


export type GqlStorageLocationsQuery = (
  { __typename?: 'Query' }
  & { bins: Maybe<(
    { __typename?: 'BinGQLConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'BinGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'BinGQL' }
        & Pick<GqlBinGql, 'pickface_product_item_id' | 'is_pickface'>
        & { bin_names: Maybe<Array<Maybe<(
          { __typename?: 'BinNameGQL' }
          & Pick<GqlBinNameGql, 'bin_id' | 'aisle' | 'level' | 'bin_position'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type GqlFilterBinsQueryVariables = Exact<{
  from: Maybe<Scalars['String']>;
  to: Maybe<Scalars['String']>;
}>;


export type GqlFilterBinsQuery = (
  { __typename?: 'Query' }
  & { filter_bins: Maybe<Array<Maybe<(
    { __typename?: 'CustomBinGQL' }
    & Pick<GqlCustomBinGql, 'bin_id' | 'aisle' | 'bin_position' | 'level' | 'storage_location_id'>
  )>>> }
);

export type GqlRoutePlansQueryVariables = Exact<{
  filters: Maybe<Scalars['GenericScalar']>;
  search: Maybe<Scalars['String']>;
}>;


export type GqlRoutePlansQuery = (
  { __typename?: 'Query' }
  & { route_plans: Maybe<(
    { __typename?: 'RoutePlanGQLConnection' }
    & { page_info: Maybe<(
      { __typename?: 'PaginatorInfo' }
      & GqlPaginationFragment
    )>, edges: Array<Maybe<(
      { __typename?: 'RoutePlanGQLEdge' }
      & { node: Maybe<(
        { __typename?: 'RoutePlanGQL' }
        & Pick<GqlRoutePlanGql, 'route_plan_id' | 'delivery_date' | 'depot_id' | 'multiple_trips' | 'vehicle_trip' | 'vehicle_id' | 'route_id'>
        & { depot: Maybe<(
          { __typename?: 'DepotV2GQL' }
          & Pick<GqlDepotV2Gql, 'depot_name'>
        )>, vehicle: Maybe<(
          { __typename?: 'VehicleGQL' }
          & Pick<GqlVehicleGql, 'registration_number'>
        )>, route: Maybe<(
          { __typename?: 'RouteV2GQL' }
          & Pick<GqlRouteV2Gql, 'route_name'>
        )> }
      )> }
    )>> }
  )> }
);

export const PaginationFragmentDoc = gql`
    fragment Pagination on PaginatorInfo {
  current_page
  per_page
  has_next
  has_previous
  total_pages
  total_count
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on CountryGQL {
  country_id
  iso_alpha2_name
  iso_alpha2_code
  default_currency
  country_calling_code
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on ProductItemV2GQL {
  active
  product_item_name
  product_item_id
  dynamic_price {
    base_price
    dynamic_price
  }
  base_price
  units_of_measure {
    active
    business_domain {
      domain_name
    }
    conversion_ratio
    uom {
      name
      uom_id
    }
  }
  product {
    active
    product_name
    product_id
    packaging_units {
      active
      name
      weight
      packaging_unit_id
    }
    domain_activations {
      business_domain {
        domain_name
        business_domain_id
      }
    }
  }
}
    `;
export const DeliveryDetailsFragmentDoc = gql`
    fragment DeliveryDetails on DeliveryV2GQL {
  delivery_number
  delivery_date
  date_created
  active
  amount
  currency
  served_by {
    first_name
    last_name
  }
  route_id
  route {
    route_name
  }
  shop_id
  shop {
    shop_id
    shop_number
    shop_name
    delivery_fee
    customer_id
    customer {
      customer_name
      phone_number
    }
  }
}
    `;
export const CustomerDetailsFragmentDoc = gql`
    fragment CustomerDetails on ShopV2GQL {
  customer {
    customer_id
    phone_number
    customer_name
  }
}
    `;
export const ShopDetailsFragmentDoc = gql`
    fragment ShopDetails on ShopV2GQL {
  shop_id
  shop_number
  shop_name
  active
  shop_type_id
  shop_type {
    name
  }
  country {
    default_currency
  }
  distribution_centers {
    distribution_center_id
  }
  updated_by
  updated_by_user {
    first_name
    last_name
    user_id
  }
  region_id
  route_id
  route {
    route_id
    route_name
    depot_id
    depot {
      depot_name
    }
  }
}
    `;
export const DcReturnFragmentDoc = gql`
    fragment DCReturn on ReturnGQL {
  return_id
  return_number
  sale_date
  created_by
  return_level
  active
  cancellation_reason
  user {
    first_name
    last_name
    phone_number
    user_number
    user_id
  }
  packaging_return_items {
    packaging_return_item_id
    active
    cancellation_reason
    packaging_unit_id
    quantity
    packaging_unit {
      name
    }
  }
  product_return_items {
    active
    cancellation_reason
    product_item_id
    product_return_item_id
    quantity
    unit_of_measure_id
    uom {
      abbreviation
    }
    product_item {
      product_item_name
      product_id
      product {
        product_name
      }
    }
  }
  depot_id
  depot {
    depot_name
    depot_id
  }
  distribution_center_id
  distribution_center {
    distribution_center_id
    distribution_center_name
  }
}
    `;
export const ProductItemV2FragmentDoc = gql`
    fragment ProductItemV2 on ProductItemV2GQL {
  product_item_id
  product_item_name
  product {
    product_name
  }
  packed_weight
  packed_volume
  units_of_measure {
    business_domain_id
    business_domain {
      domain_name
    }
    conversion_ratio
    uom {
      uom_id
      name
    }
  }
}
    `;
export const PutAwayJobsFragmentDoc = gql`
    fragment PutAwayJobs on PutAwayJobGQL {
  active
  stock_intake_id
  quantity
  job_id
  job_number
  job_status
  quantity
  assigned_to
  assigned {
    first_name
    last_name
  }
  product_item_id
  product_item {
    product_item_name
    product {
      product_name
    }
  }
  destination_handling_unit {
    handling_unit_id
    asset {
      asset_number
      asset_type {
        asset_type_name
      }
    }
  }
  source_location_id
  source_location {
    dock_door {
      dock_door_number
    }
  }
  destination_location {
    bin {
      aisle
      bin_position
      level
      bin_names {
        bin_name_direction
        aisle
        bin_position
        level
      }
    }
  }
}
    `;
export const ReservePickingJobsFragmentFragmentDoc = gql`
    fragment ReservePickingJobsFragment on ReservePickingJobGQL {
  active
  cancelled
  job_number
  job_id
  quantity
  handling_unit_id
  handling_unit {
    quantity
    asset_id
    asset {
      asset_number
    }
  }
  source_location_id
  source_location {
    bin {
      aisle
      bin_position
      level
      bin_names {
        bin_name_direction
        aisle
        bin_position
        level
      }
    }
  }
  assigned_to
  assigned {
    first_name
    last_name
  }
  job_status
  product_item_id
  product_item {
    product_item_name
    units_of_measure {
      uom {
        name
      }
    }
    product {
      product_name
    }
  }
}
    `;
export const FulfilmentDispatchReQuestFragmentDoc = gql`
    fragment FulfilmentDispatchReQuest on FulfilmentDispatchRequestGQL {
  fdr_number
  fdr_id
  active
  fdr_complete
  sale_date
  date_created
  order_time_start
  order_time_end
  dock_door_id
  dock_door {
    dock_door_number
    staging_area_name
    warehouse_id
    warehouse {
      distribution_center_id
      distribution_center {
        distribution_center_name
      }
    }
  }
  fdr_items {
    route_id
    route {
      route_name
      depot_id
      depot {
        depot_name
      }
    }
    route_plan_id
    route_plan {
      multiple_trips
      vehicle_trip
      vehicle_id
      vehicle {
        registration_number
      }
      depot_id
      depot {
        depot_name
      }
    }
  }
}
    `;
export const FdrSkusFragmentDoc = gql`
    fragment FDRSkus on FulfilmentDispatchRequestGQL {
  fdr_skus {
    active
    product_item_id
    quantity
    loaded_quantity
    available_stock
    amount_planned_from_reserve
    amount_planned_from_pickface
    product_item {
      product_item_name
      product_id
      product {
        product_name
      }
      units_of_measure {
        business_domain {
          domain_name
          business_domain_id
        }
        uom {
          name
        }
      }
    }
  }
}
    `;
export const CountriesDocument = gql`
    query countries {
  countries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GqlCountriesQuery, GqlCountriesQueryVariables>) {
        return Apollo.useQuery<GqlCountriesQuery, GqlCountriesQueryVariables>(CountriesDocument, baseOptions);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCountriesQuery, GqlCountriesQueryVariables>) {
          return Apollo.useLazyQuery<GqlCountriesQuery, GqlCountriesQueryVariables>(CountriesDocument, baseOptions);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<GqlCountriesQuery, GqlCountriesQueryVariables>;
export const DepotsDocument = gql`
    query depots($filters: GenericScalar) {
  depots_v2(filters: $filters) {
    edges {
      node {
        active
        depot_id
        depot_name
        routes {
          active
          route_id
          route_name
        }
      }
    }
  }
}
    `;

/**
 * __useDepotsQuery__
 *
 * To run a query within a React component, call `useDepotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepotsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDepotsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDepotsQuery, GqlDepotsQueryVariables>) {
        return Apollo.useQuery<GqlDepotsQuery, GqlDepotsQueryVariables>(DepotsDocument, baseOptions);
      }
export function useDepotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDepotsQuery, GqlDepotsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDepotsQuery, GqlDepotsQueryVariables>(DepotsDocument, baseOptions);
        }
export type DepotsQueryHookResult = ReturnType<typeof useDepotsQuery>;
export type DepotsLazyQueryHookResult = ReturnType<typeof useDepotsLazyQuery>;
export type DepotsQueryResult = Apollo.QueryResult<GqlDepotsQuery, GqlDepotsQueryVariables>;
export const RoutesDocument = gql`
    query Routes($filters: GenericScalar, $search: String, $per_page: Int, $page: Int) {
  routes_v2(filters: $filters, search: $search, page: $page, per_page: $per_page) {
    edges {
      node {
        date_created
        depot_id
        depot {
          depot_name
          depot_id
          area_id
          area {
            area_name
            region_id
            region {
              region_name
              region_id
            }
          }
        }
        route_id
        route_name
      }
    }
  }
}
    `;

/**
 * __useRoutesQuery__
 *
 * To run a query within a React component, call `useRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useRoutesQuery(baseOptions?: Apollo.QueryHookOptions<GqlRoutesQuery, GqlRoutesQueryVariables>) {
        return Apollo.useQuery<GqlRoutesQuery, GqlRoutesQueryVariables>(RoutesDocument, baseOptions);
      }
export function useRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRoutesQuery, GqlRoutesQueryVariables>) {
          return Apollo.useLazyQuery<GqlRoutesQuery, GqlRoutesQueryVariables>(RoutesDocument, baseOptions);
        }
export type RoutesQueryHookResult = ReturnType<typeof useRoutesQuery>;
export type RoutesLazyQueryHookResult = ReturnType<typeof useRoutesLazyQuery>;
export type RoutesQueryResult = Apollo.QueryResult<GqlRoutesQuery, GqlRoutesQueryVariables>;
export const RegionsDocument = gql`
    query Regions($filters: GenericScalar) {
  regions_v2(filters: $filters) {
    edges {
      node {
        region_id
        region_name
        country_id
        country {
          default_currency
        }
        areas {
          area_id
          area_name
          depots {
            depot_id
            depot_name
            routes {
              route_id
              route_name
            }
          }
        }
        country_id
      }
    }
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlRegionsQuery, GqlRegionsQueryVariables>) {
        return Apollo.useQuery<GqlRegionsQuery, GqlRegionsQueryVariables>(RegionsDocument, baseOptions);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRegionsQuery, GqlRegionsQueryVariables>) {
          return Apollo.useLazyQuery<GqlRegionsQuery, GqlRegionsQueryVariables>(RegionsDocument, baseOptions);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<GqlRegionsQuery, GqlRegionsQueryVariables>;
export const FetchDistributionCentersDocument = gql`
    query fetchDistributionCenters {
  distribution_centers {
    distribution_center_name
    distribution_center_id
    distribution_center_type
  }
}
    `;

/**
 * __useFetchDistributionCentersQuery__
 *
 * To run a query within a React component, call `useFetchDistributionCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDistributionCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDistributionCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDistributionCentersQuery(baseOptions?: Apollo.QueryHookOptions<GqlFetchDistributionCentersQuery, GqlFetchDistributionCentersQueryVariables>) {
        return Apollo.useQuery<GqlFetchDistributionCentersQuery, GqlFetchDistributionCentersQueryVariables>(FetchDistributionCentersDocument, baseOptions);
      }
export function useFetchDistributionCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFetchDistributionCentersQuery, GqlFetchDistributionCentersQueryVariables>) {
          return Apollo.useLazyQuery<GqlFetchDistributionCentersQuery, GqlFetchDistributionCentersQueryVariables>(FetchDistributionCentersDocument, baseOptions);
        }
export type FetchDistributionCentersQueryHookResult = ReturnType<typeof useFetchDistributionCentersQuery>;
export type FetchDistributionCentersLazyQueryHookResult = ReturnType<typeof useFetchDistributionCentersLazyQuery>;
export type FetchDistributionCentersQueryResult = Apollo.QueryResult<GqlFetchDistributionCentersQuery, GqlFetchDistributionCentersQueryVariables>;
export const FetchDynamicPricingDocument = gql`
    query fetchDynamicPricing($page: Int, $per_page: Int) {
  dynamic_pricing(
    exclude_markdowns: false
    valid_only: true
    page: $page
    per_page: $per_page
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        dynamic_pricing_id
        pricing_name
        description
        formula
        active
        start_time
        end_time
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useFetchDynamicPricingQuery__
 *
 * To run a query within a React component, call `useFetchDynamicPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDynamicPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDynamicPricingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useFetchDynamicPricingQuery(baseOptions?: Apollo.QueryHookOptions<GqlFetchDynamicPricingQuery, GqlFetchDynamicPricingQueryVariables>) {
        return Apollo.useQuery<GqlFetchDynamicPricingQuery, GqlFetchDynamicPricingQueryVariables>(FetchDynamicPricingDocument, baseOptions);
      }
export function useFetchDynamicPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFetchDynamicPricingQuery, GqlFetchDynamicPricingQueryVariables>) {
          return Apollo.useLazyQuery<GqlFetchDynamicPricingQuery, GqlFetchDynamicPricingQueryVariables>(FetchDynamicPricingDocument, baseOptions);
        }
export type FetchDynamicPricingQueryHookResult = ReturnType<typeof useFetchDynamicPricingQuery>;
export type FetchDynamicPricingLazyQueryHookResult = ReturnType<typeof useFetchDynamicPricingLazyQuery>;
export type FetchDynamicPricingQueryResult = Apollo.QueryResult<GqlFetchDynamicPricingQuery, GqlFetchDynamicPricingQueryVariables>;
export const McommerceFaqsDocument = gql`
    query mcommerceFAQS {
  mcommerce_faqs {
    page_info {
      ...Pagination
    }
    edges {
      node {
        client_stamp
        client_id
        answer
        question
        answer
        date_created
        created_by
        faq_id
        faq_section_id
        faq_section {
          name
          faq_section_id
        }
      }
    }
  }
  mcommerce_faq_sections {
    name
    date_created
    active
    icon_url
    faq_section_id
    client_stamp
    faqs {
      client_stamp
      client_id
      answer
      active
      question
      answer
      date_created
      created_by
      faq_id
      faq_section_id
      faq_section {
        name
        faq_section_id
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useMcommerceFaqsQuery__
 *
 * To run a query within a React component, call `useMcommerceFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcommerceFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcommerceFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMcommerceFaqsQuery(baseOptions?: Apollo.QueryHookOptions<GqlMcommerceFaqsQuery, GqlMcommerceFaqsQueryVariables>) {
        return Apollo.useQuery<GqlMcommerceFaqsQuery, GqlMcommerceFaqsQueryVariables>(McommerceFaqsDocument, baseOptions);
      }
export function useMcommerceFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMcommerceFaqsQuery, GqlMcommerceFaqsQueryVariables>) {
          return Apollo.useLazyQuery<GqlMcommerceFaqsQuery, GqlMcommerceFaqsQueryVariables>(McommerceFaqsDocument, baseOptions);
        }
export type McommerceFaqsQueryHookResult = ReturnType<typeof useMcommerceFaqsQuery>;
export type McommerceFaqsLazyQueryHookResult = ReturnType<typeof useMcommerceFaqsLazyQuery>;
export type McommerceFaqsQueryResult = Apollo.QueryResult<GqlMcommerceFaqsQuery, GqlMcommerceFaqsQueryVariables>;
export const McommerceFaqSectionsDocument = gql`
    query mcommerceFAQSections {
  mcommerce_faq_sections {
    date_created
    created_by
    client_stamp
    faq_section_id
    name
  }
}
    `;

/**
 * __useMcommerceFaqSectionsQuery__
 *
 * To run a query within a React component, call `useMcommerceFaqSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcommerceFaqSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcommerceFaqSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMcommerceFaqSectionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlMcommerceFaqSectionsQuery, GqlMcommerceFaqSectionsQueryVariables>) {
        return Apollo.useQuery<GqlMcommerceFaqSectionsQuery, GqlMcommerceFaqSectionsQueryVariables>(McommerceFaqSectionsDocument, baseOptions);
      }
export function useMcommerceFaqSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMcommerceFaqSectionsQuery, GqlMcommerceFaqSectionsQueryVariables>) {
          return Apollo.useLazyQuery<GqlMcommerceFaqSectionsQuery, GqlMcommerceFaqSectionsQueryVariables>(McommerceFaqSectionsDocument, baseOptions);
        }
export type McommerceFaqSectionsQueryHookResult = ReturnType<typeof useMcommerceFaqSectionsQuery>;
export type McommerceFaqSectionsLazyQueryHookResult = ReturnType<typeof useMcommerceFaqSectionsLazyQuery>;
export type McommerceFaqSectionsQueryResult = Apollo.QueryResult<GqlMcommerceFaqSectionsQuery, GqlMcommerceFaqSectionsQueryVariables>;
export const PermissionsV2Document = gql`
    query permissionsV2($search: String, $page: Int, $per_page: Int) {
  permissions_v2(search: $search, page: $page, per_page: $per_page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        permission_name
        permission_id
        active
        roles {
          role_id
          role_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __usePermissionsV2Query__
 *
 * To run a query within a React component, call `usePermissionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsV2Query({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function usePermissionsV2Query(baseOptions?: Apollo.QueryHookOptions<GqlPermissionsV2Query, GqlPermissionsV2QueryVariables>) {
        return Apollo.useQuery<GqlPermissionsV2Query, GqlPermissionsV2QueryVariables>(PermissionsV2Document, baseOptions);
      }
export function usePermissionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPermissionsV2Query, GqlPermissionsV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlPermissionsV2Query, GqlPermissionsV2QueryVariables>(PermissionsV2Document, baseOptions);
        }
export type PermissionsV2QueryHookResult = ReturnType<typeof usePermissionsV2Query>;
export type PermissionsV2LazyQueryHookResult = ReturnType<typeof usePermissionsV2LazyQuery>;
export type PermissionsV2QueryResult = Apollo.QueryResult<GqlPermissionsV2Query, GqlPermissionsV2QueryVariables>;
export const ProductsV2Document = gql`
    query ProductsV2($search: String, $productFilters: GenericScalar, $per_page: Int) {
  paginated_products_v2(
    search: $search
    per_page: $per_page
    filters: $productFilters
  ) {
    edges {
      node {
        active
        product_name
        product_id
        product_code
        product_type
        product_items {
          product_item_id
          product_item_name
          base_price
          units_of_measure {
            business_domain_id
            business_domain {
              domain_name
            }
            uom_id
            uom {
              name
              uom_id
            }
          }
          regions {
            region_id
            region {
              region_name
              region_id
              country {
                ...Country
              }
            }
          }
        }
        packaging_units {
          active
          name
          weight
          packaging_unit_id
        }
        domain_activations {
          business_domain {
            domain_name
            business_domain_id
          }
        }
      }
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useProductsV2Query__
 *
 * To run a query within a React component, call `useProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsV2Query({
 *   variables: {
 *      search: // value for 'search'
 *      productFilters: // value for 'productFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useProductsV2Query(baseOptions?: Apollo.QueryHookOptions<GqlProductsV2Query, GqlProductsV2QueryVariables>) {
        return Apollo.useQuery<GqlProductsV2Query, GqlProductsV2QueryVariables>(ProductsV2Document, baseOptions);
      }
export function useProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductsV2Query, GqlProductsV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlProductsV2Query, GqlProductsV2QueryVariables>(ProductsV2Document, baseOptions);
        }
export type ProductsV2QueryHookResult = ReturnType<typeof useProductsV2Query>;
export type ProductsV2LazyQueryHookResult = ReturnType<typeof useProductsV2LazyQuery>;
export type ProductsV2QueryResult = Apollo.QueryResult<GqlProductsV2Query, GqlProductsV2QueryVariables>;
export const ProductItemsV2Document = gql`
    query ProductItemsV2($search: String, $productItemFilters: GenericScalar, $per_page: Int) {
  paginated_product_items_v2(
    search: $search
    per_page: $per_page
    filters: $productItemFilters
  ) {
    edges {
      node {
        ...Product
      }
    }
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductItemsV2Query__
 *
 * To run a query within a React component, call `useProductItemsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductItemsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductItemsV2Query({
 *   variables: {
 *      search: // value for 'search'
 *      productItemFilters: // value for 'productItemFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useProductItemsV2Query(baseOptions?: Apollo.QueryHookOptions<GqlProductItemsV2Query, GqlProductItemsV2QueryVariables>) {
        return Apollo.useQuery<GqlProductItemsV2Query, GqlProductItemsV2QueryVariables>(ProductItemsV2Document, baseOptions);
      }
export function useProductItemsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductItemsV2Query, GqlProductItemsV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlProductItemsV2Query, GqlProductItemsV2QueryVariables>(ProductItemsV2Document, baseOptions);
        }
export type ProductItemsV2QueryHookResult = ReturnType<typeof useProductItemsV2Query>;
export type ProductItemsV2LazyQueryHookResult = ReturnType<typeof useProductItemsV2LazyQuery>;
export type ProductItemsV2QueryResult = Apollo.QueryResult<GqlProductItemsV2Query, GqlProductItemsV2QueryVariables>;
export const ProductTypesDocument = gql`
    query productTypes {
  product_types_v2
}
    `;

/**
 * __useProductTypesQuery__
 *
 * To run a query within a React component, call `useProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductTypesQuery, GqlProductTypesQueryVariables>) {
        return Apollo.useQuery<GqlProductTypesQuery, GqlProductTypesQueryVariables>(ProductTypesDocument, baseOptions);
      }
export function useProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductTypesQuery, GqlProductTypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductTypesQuery, GqlProductTypesQueryVariables>(ProductTypesDocument, baseOptions);
        }
export type ProductTypesQueryHookResult = ReturnType<typeof useProductTypesQuery>;
export type ProductTypesLazyQueryHookResult = ReturnType<typeof useProductTypesLazyQuery>;
export type ProductTypesQueryResult = Apollo.QueryResult<GqlProductTypesQuery, GqlProductTypesQueryVariables>;
export const ProductVarietiesDocument = gql`
    query ProductVarieties($search: String, $filters: GenericScalar, $per_page: Int) {
  product_varieties(search: $search, per_page: $per_page, filters: $filters) {
    edges {
      node {
        variety_name
        variety_code
      }
    }
  }
}
    `;

/**
 * __useProductVarietiesQuery__
 *
 * To run a query within a React component, call `useProductVarietiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVarietiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVarietiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useProductVarietiesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductVarietiesQuery, GqlProductVarietiesQueryVariables>) {
        return Apollo.useQuery<GqlProductVarietiesQuery, GqlProductVarietiesQueryVariables>(ProductVarietiesDocument, baseOptions);
      }
export function useProductVarietiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductVarietiesQuery, GqlProductVarietiesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductVarietiesQuery, GqlProductVarietiesQueryVariables>(ProductVarietiesDocument, baseOptions);
        }
export type ProductVarietiesQueryHookResult = ReturnType<typeof useProductVarietiesQuery>;
export type ProductVarietiesLazyQueryHookResult = ReturnType<typeof useProductVarietiesLazyQuery>;
export type ProductVarietiesQueryResult = Apollo.QueryResult<GqlProductVarietiesQuery, GqlProductVarietiesQueryVariables>;
export const RolesV2Document = gql`
    query rolesV2($search: String, $page: Int, $per_page: Int, $filters: GenericScalar) {
  roles_v2(search: $search, page: $page, per_page: $per_page, filters: $filters) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        role_id
        role_name
        active
        permissions {
          permission_id
          permission_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useRolesV2Query__
 *
 * To run a query within a React component, call `useRolesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRolesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesV2Query({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRolesV2Query(baseOptions?: Apollo.QueryHookOptions<GqlRolesV2Query, GqlRolesV2QueryVariables>) {
        return Apollo.useQuery<GqlRolesV2Query, GqlRolesV2QueryVariables>(RolesV2Document, baseOptions);
      }
export function useRolesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRolesV2Query, GqlRolesV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlRolesV2Query, GqlRolesV2QueryVariables>(RolesV2Document, baseOptions);
        }
export type RolesV2QueryHookResult = ReturnType<typeof useRolesV2Query>;
export type RolesV2LazyQueryHookResult = ReturnType<typeof useRolesV2LazyQuery>;
export type RolesV2QueryResult = Apollo.QueryResult<GqlRolesV2Query, GqlRolesV2QueryVariables>;
export const UserV2ByIdDocument = gql`
    query userV2ById($user_id: String) {
  user_v2_by_id(user_id: $user_id) {
    date_created
    first_name
    last_name
    region_id
    region {
      region_id
      region_name
    }
    default_country_id
    country_ids
    roles {
      role_id
      role_name
    }
    permissions {
      permission_id
      permission_name
    }
    primary_role {
      role_name
      role_id
      permissions {
        permission_name
        permission_id
      }
    }
    permissions_blacklist {
      permission_name
      permission_id
    }
    phone_number
    email
    active
    user_no
  }
}
    `;

/**
 * __useUserV2ByIdQuery__
 *
 * To run a query within a React component, call `useUserV2ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserV2ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserV2ByIdQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserV2ByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlUserV2ByIdQuery, GqlUserV2ByIdQueryVariables>) {
        return Apollo.useQuery<GqlUserV2ByIdQuery, GqlUserV2ByIdQueryVariables>(UserV2ByIdDocument, baseOptions);
      }
export function useUserV2ByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlUserV2ByIdQuery, GqlUserV2ByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlUserV2ByIdQuery, GqlUserV2ByIdQueryVariables>(UserV2ByIdDocument, baseOptions);
        }
export type UserV2ByIdQueryHookResult = ReturnType<typeof useUserV2ByIdQuery>;
export type UserV2ByIdLazyQueryHookResult = ReturnType<typeof useUserV2ByIdLazyQuery>;
export type UserV2ByIdQueryResult = Apollo.QueryResult<GqlUserV2ByIdQuery, GqlUserV2ByIdQueryVariables>;
export const UsersV2Document = gql`
    query usersV2($search: String, $per_page: Int, $page: Int, $filters: GenericScalar) {
  users_v2(search: $search, per_page: $per_page, page: $page, filters: $filters) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        first_name
        last_name
        user_id
        user_no
        phone_number
        active
        country_ids
        default_country_id
        primary_role_id
        primary_role {
          role_name
        }
        roles {
          role_id
          role_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useUsersV2Query__
 *
 * To run a query within a React component, call `useUsersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useUsersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersV2Query({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUsersV2Query(baseOptions?: Apollo.QueryHookOptions<GqlUsersV2Query, GqlUsersV2QueryVariables>) {
        return Apollo.useQuery<GqlUsersV2Query, GqlUsersV2QueryVariables>(UsersV2Document, baseOptions);
      }
export function useUsersV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlUsersV2Query, GqlUsersV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlUsersV2Query, GqlUsersV2QueryVariables>(UsersV2Document, baseOptions);
        }
export type UsersV2QueryHookResult = ReturnType<typeof useUsersV2Query>;
export type UsersV2LazyQueryHookResult = ReturnType<typeof useUsersV2LazyQuery>;
export type UsersV2QueryResult = Apollo.QueryResult<GqlUsersV2Query, GqlUsersV2QueryVariables>;
export const GetDepotRestrictionsDocument = gql`
    query getDepotRestrictions($page: Int, $per_page: Int) {
  depot_dc_product_item_restrictions(
    active: true
    page: $page
    per_page: $per_page
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        depot_dc_product_item_restriction_id
        depot_id
        depot {
          depot_name
          area {
            region {
              region_id
              region_name
              country {
                country_id
                iso_alpha2_name
              }
            }
          }
        }
        product_item_id
        product_item {
          product_item_name
          product {
            product_name
          }
        }
        distribution_center_ids
        distribution_centers {
          distribution_center_name
          distribution_center_type
          distribution_center_id
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useGetDepotRestrictionsQuery__
 *
 * To run a query within a React component, call `useGetDepotRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepotRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepotRestrictionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useGetDepotRestrictionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetDepotRestrictionsQuery, GqlGetDepotRestrictionsQueryVariables>) {
        return Apollo.useQuery<GqlGetDepotRestrictionsQuery, GqlGetDepotRestrictionsQueryVariables>(GetDepotRestrictionsDocument, baseOptions);
      }
export function useGetDepotRestrictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDepotRestrictionsQuery, GqlGetDepotRestrictionsQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetDepotRestrictionsQuery, GqlGetDepotRestrictionsQueryVariables>(GetDepotRestrictionsDocument, baseOptions);
        }
export type GetDepotRestrictionsQueryHookResult = ReturnType<typeof useGetDepotRestrictionsQuery>;
export type GetDepotRestrictionsLazyQueryHookResult = ReturnType<typeof useGetDepotRestrictionsLazyQuery>;
export type GetDepotRestrictionsQueryResult = Apollo.QueryResult<GqlGetDepotRestrictionsQuery, GqlGetDepotRestrictionsQueryVariables>;
export const Distribution_CentersDocument = gql`
    query distribution_centers {
  distribution_centers {
    date_created
    distribution_center_id
    distribution_center_name
    distribution_center_type
    description
  }
}
    `;

/**
 * __useDistribution_CentersQuery__
 *
 * To run a query within a React component, call `useDistribution_CentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistribution_CentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistribution_CentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDistribution_CentersQuery(baseOptions?: Apollo.QueryHookOptions<GqlDistribution_CentersQuery, GqlDistribution_CentersQueryVariables>) {
        return Apollo.useQuery<GqlDistribution_CentersQuery, GqlDistribution_CentersQueryVariables>(Distribution_CentersDocument, baseOptions);
      }
export function useDistribution_CentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDistribution_CentersQuery, GqlDistribution_CentersQueryVariables>) {
          return Apollo.useLazyQuery<GqlDistribution_CentersQuery, GqlDistribution_CentersQueryVariables>(Distribution_CentersDocument, baseOptions);
        }
export type Distribution_CentersQueryHookResult = ReturnType<typeof useDistribution_CentersQuery>;
export type Distribution_CentersLazyQueryHookResult = ReturnType<typeof useDistribution_CentersLazyQuery>;
export type Distribution_CentersQueryResult = Apollo.QueryResult<GqlDistribution_CentersQuery, GqlDistribution_CentersQueryVariables>;
export const FetchPseudoRoutesDocument = gql`
    query fetchPseudoRoutes($filters: GenericScalar, $per_page: Int, $page: Int) {
  pseudo_routes(filters: $filters, per_page: $per_page, page: $page) {
    edges {
      node {
        active
        pseudo_route_id
        name
        merged_routes
        constraints
        custom_constraints
        force_share
        routes {
          route_id
          route_name
          depot {
            depot_name
          }
        }
      }
    }
    page_info {
      ...Pagination
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useFetchPseudoRoutesQuery__
 *
 * To run a query within a React component, call `useFetchPseudoRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPseudoRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPseudoRoutesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFetchPseudoRoutesQuery(baseOptions?: Apollo.QueryHookOptions<GqlFetchPseudoRoutesQuery, GqlFetchPseudoRoutesQueryVariables>) {
        return Apollo.useQuery<GqlFetchPseudoRoutesQuery, GqlFetchPseudoRoutesQueryVariables>(FetchPseudoRoutesDocument, baseOptions);
      }
export function useFetchPseudoRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFetchPseudoRoutesQuery, GqlFetchPseudoRoutesQueryVariables>) {
          return Apollo.useLazyQuery<GqlFetchPseudoRoutesQuery, GqlFetchPseudoRoutesQueryVariables>(FetchPseudoRoutesDocument, baseOptions);
        }
export type FetchPseudoRoutesQueryHookResult = ReturnType<typeof useFetchPseudoRoutesQuery>;
export type FetchPseudoRoutesLazyQueryHookResult = ReturnType<typeof useFetchPseudoRoutesLazyQuery>;
export type FetchPseudoRoutesQueryResult = Apollo.QueryResult<GqlFetchPseudoRoutesQuery, GqlFetchPseudoRoutesQueryVariables>;
export const FetchPseudoRouteByNameDocument = gql`
    query fetchPseudoRouteByName($name: String!) {
  pseudo_route_by_id(pseudo_route_id: $name) {
    pseudo_route_id
  }
}
    `;

/**
 * __useFetchPseudoRouteByNameQuery__
 *
 * To run a query within a React component, call `useFetchPseudoRouteByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPseudoRouteByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPseudoRouteByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFetchPseudoRouteByNameQuery(baseOptions: Apollo.QueryHookOptions<GqlFetchPseudoRouteByNameQuery, GqlFetchPseudoRouteByNameQueryVariables>) {
        return Apollo.useQuery<GqlFetchPseudoRouteByNameQuery, GqlFetchPseudoRouteByNameQueryVariables>(FetchPseudoRouteByNameDocument, baseOptions);
      }
export function useFetchPseudoRouteByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFetchPseudoRouteByNameQuery, GqlFetchPseudoRouteByNameQueryVariables>) {
          return Apollo.useLazyQuery<GqlFetchPseudoRouteByNameQuery, GqlFetchPseudoRouteByNameQueryVariables>(FetchPseudoRouteByNameDocument, baseOptions);
        }
export type FetchPseudoRouteByNameQueryHookResult = ReturnType<typeof useFetchPseudoRouteByNameQuery>;
export type FetchPseudoRouteByNameLazyQueryHookResult = ReturnType<typeof useFetchPseudoRouteByNameLazyQuery>;
export type FetchPseudoRouteByNameQueryResult = Apollo.QueryResult<GqlFetchPseudoRouteByNameQuery, GqlFetchPseudoRouteByNameQueryVariables>;
export const RoutesV2Document = gql`
    query routesV2($per_page: Int, $page: Int, $search: String, $filters: GenericScalar) {
  routes_v2(page: $page, per_page: $per_page, search: $search, filters: $filters) {
    page_info {
      per_page
      total_count
      total_pages
      current_page
      has_next
      has_previous
    }
    edges {
      node {
        route_name
        route_id
        date_created
        depot_id
        depot {
          depot_name
          depot_id
          area_id
          area {
            area_name
            region_id
            region {
              region_name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRoutesV2Query__
 *
 * To run a query within a React component, call `useRoutesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRoutesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutesV2Query({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRoutesV2Query(baseOptions?: Apollo.QueryHookOptions<GqlRoutesV2Query, GqlRoutesV2QueryVariables>) {
        return Apollo.useQuery<GqlRoutesV2Query, GqlRoutesV2QueryVariables>(RoutesV2Document, baseOptions);
      }
export function useRoutesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRoutesV2Query, GqlRoutesV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlRoutesV2Query, GqlRoutesV2QueryVariables>(RoutesV2Document, baseOptions);
        }
export type RoutesV2QueryHookResult = ReturnType<typeof useRoutesV2Query>;
export type RoutesV2LazyQueryHookResult = ReturnType<typeof useRoutesV2LazyQuery>;
export type RoutesV2QueryResult = Apollo.QueryResult<GqlRoutesV2Query, GqlRoutesV2QueryVariables>;
export const RouteTypesDocument = gql`
    query routeTypes {
  route_types
}
    `;

/**
 * __useRouteTypesQuery__
 *
 * To run a query within a React component, call `useRouteTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRouteTypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlRouteTypesQuery, GqlRouteTypesQueryVariables>) {
        return Apollo.useQuery<GqlRouteTypesQuery, GqlRouteTypesQueryVariables>(RouteTypesDocument, baseOptions);
      }
export function useRouteTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRouteTypesQuery, GqlRouteTypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlRouteTypesQuery, GqlRouteTypesQueryVariables>(RouteTypesDocument, baseOptions);
        }
export type RouteTypesQueryHookResult = ReturnType<typeof useRouteTypesQuery>;
export type RouteTypesLazyQueryHookResult = ReturnType<typeof useRouteTypesLazyQuery>;
export type RouteTypesQueryResult = Apollo.QueryResult<GqlRouteTypesQuery, GqlRouteTypesQueryVariables>;
export const Storage_Unit_TypesDocument = gql`
    query storage_unit_types {
  storage_unit_types {
    date_created
    storage_unit_type_id
    storage_unit_type
  }
}
    `;

/**
 * __useStorage_Unit_TypesQuery__
 *
 * To run a query within a React component, call `useStorage_Unit_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorage_Unit_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorage_Unit_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorage_Unit_TypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlStorage_Unit_TypesQuery, GqlStorage_Unit_TypesQueryVariables>) {
        return Apollo.useQuery<GqlStorage_Unit_TypesQuery, GqlStorage_Unit_TypesQueryVariables>(Storage_Unit_TypesDocument, baseOptions);
      }
export function useStorage_Unit_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStorage_Unit_TypesQuery, GqlStorage_Unit_TypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlStorage_Unit_TypesQuery, GqlStorage_Unit_TypesQueryVariables>(Storage_Unit_TypesDocument, baseOptions);
        }
export type Storage_Unit_TypesQueryHookResult = ReturnType<typeof useStorage_Unit_TypesQuery>;
export type Storage_Unit_TypesLazyQueryHookResult = ReturnType<typeof useStorage_Unit_TypesLazyQuery>;
export type Storage_Unit_TypesQueryResult = Apollo.QueryResult<GqlStorage_Unit_TypesQuery, GqlStorage_Unit_TypesQueryVariables>;
export const Storage_UnitsDocument = gql`
    query storage_units($per_page: Int, $page: Int) {
  storage_units(page: $page, per_page: $per_page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        date_created
        unit_name
        warehouse_id
        warehouse {
          warehouse_name
          distribution_center_id
          distribution_center {
            distribution_center_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useStorage_UnitsQuery__
 *
 * To run a query within a React component, call `useStorage_UnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorage_UnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorage_UnitsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useStorage_UnitsQuery(baseOptions?: Apollo.QueryHookOptions<GqlStorage_UnitsQuery, GqlStorage_UnitsQueryVariables>) {
        return Apollo.useQuery<GqlStorage_UnitsQuery, GqlStorage_UnitsQueryVariables>(Storage_UnitsDocument, baseOptions);
      }
export function useStorage_UnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStorage_UnitsQuery, GqlStorage_UnitsQueryVariables>) {
          return Apollo.useLazyQuery<GqlStorage_UnitsQuery, GqlStorage_UnitsQueryVariables>(Storage_UnitsDocument, baseOptions);
        }
export type Storage_UnitsQueryHookResult = ReturnType<typeof useStorage_UnitsQuery>;
export type Storage_UnitsLazyQueryHookResult = ReturnType<typeof useStorage_UnitsLazyQuery>;
export type Storage_UnitsQueryResult = Apollo.QueryResult<GqlStorage_UnitsQuery, GqlStorage_UnitsQueryVariables>;
export const WarehousesDocument = gql`
    query warehouses($per_page: Int, $page: Int) {
  warehouses(page: $page, per_page: $per_page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        warehouse_id
        warehouse_name
        distribution_center_id
        distribution_center {
          distribution_center_id
          distribution_center_name
        }
        date_created
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useWarehousesQuery__
 *
 * To run a query within a React component, call `useWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useWarehousesQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehousesQuery, GqlWarehousesQueryVariables>) {
        return Apollo.useQuery<GqlWarehousesQuery, GqlWarehousesQueryVariables>(WarehousesDocument, baseOptions);
      }
export function useWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehousesQuery, GqlWarehousesQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehousesQuery, GqlWarehousesQueryVariables>(WarehousesDocument, baseOptions);
        }
export type WarehousesQueryHookResult = ReturnType<typeof useWarehousesQuery>;
export type WarehousesLazyQueryHookResult = ReturnType<typeof useWarehousesLazyQuery>;
export type WarehousesQueryResult = Apollo.QueryResult<GqlWarehousesQuery, GqlWarehousesQueryVariables>;
export const SourcingAgentsDocument = gql`
    query SourcingAgents($page: Int, $filters: GenericScalar, $per_page: Int, $search: String) {
  sourcing_agents(
    page: $page
    filter: $filters
    per_page: $per_page
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        agent_id
        user_name
        date_created
        active
        farmer_id
        farmer {
          supplier_name
          first_name
          last_name
          phone_number
          batch_code
          country_id
          country {
            iso_alpha2_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useSourcingAgentsQuery__
 *
 * To run a query within a React component, call `useSourcingAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcingAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcingAgentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSourcingAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GqlSourcingAgentsQuery, GqlSourcingAgentsQueryVariables>) {
        return Apollo.useQuery<GqlSourcingAgentsQuery, GqlSourcingAgentsQueryVariables>(SourcingAgentsDocument, baseOptions);
      }
export function useSourcingAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSourcingAgentsQuery, GqlSourcingAgentsQueryVariables>) {
          return Apollo.useLazyQuery<GqlSourcingAgentsQuery, GqlSourcingAgentsQueryVariables>(SourcingAgentsDocument, baseOptions);
        }
export type SourcingAgentsQueryHookResult = ReturnType<typeof useSourcingAgentsQuery>;
export type SourcingAgentsLazyQueryHookResult = ReturnType<typeof useSourcingAgentsLazyQuery>;
export type SourcingAgentsQueryResult = Apollo.QueryResult<GqlSourcingAgentsQuery, GqlSourcingAgentsQueryVariables>;
export const SourcingAgentByIdDocument = gql`
    query SourcingAgentByID($agent_id: String) {
  sourcing_agent_by_id(agent_id: $agent_id) {
    agent_id
    user_name
    active
    farmer_id
    farmer {
      supplier_name
      first_name
      last_name
      phone_number
      alt_phone_number
      batch_code
      farmer_type
      country_id
      country {
        iso_alpha2_name
      }
    }
  }
}
    `;

/**
 * __useSourcingAgentByIdQuery__
 *
 * To run a query within a React component, call `useSourcingAgentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcingAgentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcingAgentByIdQuery({
 *   variables: {
 *      agent_id: // value for 'agent_id'
 *   },
 * });
 */
export function useSourcingAgentByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlSourcingAgentByIdQuery, GqlSourcingAgentByIdQueryVariables>) {
        return Apollo.useQuery<GqlSourcingAgentByIdQuery, GqlSourcingAgentByIdQueryVariables>(SourcingAgentByIdDocument, baseOptions);
      }
export function useSourcingAgentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSourcingAgentByIdQuery, GqlSourcingAgentByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlSourcingAgentByIdQuery, GqlSourcingAgentByIdQueryVariables>(SourcingAgentByIdDocument, baseOptions);
        }
export type SourcingAgentByIdQueryHookResult = ReturnType<typeof useSourcingAgentByIdQuery>;
export type SourcingAgentByIdLazyQueryHookResult = ReturnType<typeof useSourcingAgentByIdLazyQuery>;
export type SourcingAgentByIdQueryResult = Apollo.QueryResult<GqlSourcingAgentByIdQuery, GqlSourcingAgentByIdQueryVariables>;
export const BidApplicationsDocument = gql`
    query BidApplications($page: Int, $filters: GenericScalar, $per_page: Int, $search: String) {
  bid_applications(
    page: $page
    filter: $filters
    per_page: $per_page
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        quantity
        bid_application_number
        bid_application_date
        bid_application_id
        vehicle_registration
        delivery_date
        active
        unit_price
        agent_id
        product_item_id
        product_item {
          product_item_name
        }
        product_id
        product {
          product_name
        }
        agent {
          farmer_id
          farmer {
            supplier_name
            farmer_number
            first_name
            last_name
            phone_number
          }
        }
        unit_of_measure_id
        uom {
          name
          abbreviation
        }
        bid_application_status
        country_id
        country {
          iso_alpha2_name
        }
        currency
        latitude
        longitude
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useBidApplicationsQuery__
 *
 * To run a query within a React component, call `useBidApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidApplicationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBidApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GqlBidApplicationsQuery, GqlBidApplicationsQueryVariables>) {
        return Apollo.useQuery<GqlBidApplicationsQuery, GqlBidApplicationsQueryVariables>(BidApplicationsDocument, baseOptions);
      }
export function useBidApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBidApplicationsQuery, GqlBidApplicationsQueryVariables>) {
          return Apollo.useLazyQuery<GqlBidApplicationsQuery, GqlBidApplicationsQueryVariables>(BidApplicationsDocument, baseOptions);
        }
export type BidApplicationsQueryHookResult = ReturnType<typeof useBidApplicationsQuery>;
export type BidApplicationsLazyQueryHookResult = ReturnType<typeof useBidApplicationsLazyQuery>;
export type BidApplicationsQueryResult = Apollo.QueryResult<GqlBidApplicationsQuery, GqlBidApplicationsQueryVariables>;
export const BidsDocument = gql`
    query bids($page: Int, $filters: GenericScalar, $per_page: Int, $search: String) {
  bids(page: $page, filter: $filters, per_page: $per_page, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        bid_id
        date_created
        opening_date
        closing_date
        bid_notes
        active
        minimum_quantity
        bid_application_lowest_price
        bid_application_count
        delivery_date
        bid_number
        opening_bid_price
        quantity
        bid_status
        bid_notes
        product_item_id
        product_item {
          product_item_name
        }
        product_id
        product {
          product_name
        }
        unit_of_measure_id
        uom {
          name
        }
        country_id
        country {
          iso_alpha2_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useBidsQuery__
 *
 * To run a query within a React component, call `useBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBidsQuery(baseOptions?: Apollo.QueryHookOptions<GqlBidsQuery, GqlBidsQueryVariables>) {
        return Apollo.useQuery<GqlBidsQuery, GqlBidsQueryVariables>(BidsDocument, baseOptions);
      }
export function useBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBidsQuery, GqlBidsQueryVariables>) {
          return Apollo.useLazyQuery<GqlBidsQuery, GqlBidsQueryVariables>(BidsDocument, baseOptions);
        }
export type BidsQueryHookResult = ReturnType<typeof useBidsQuery>;
export type BidsLazyQueryHookResult = ReturnType<typeof useBidsLazyQuery>;
export type BidsQueryResult = Apollo.QueryResult<GqlBidsQuery, GqlBidsQueryVariables>;
export const Bid_By_IdDocument = gql`
    query bid_by_id($bid_id: String) {
  bid_by_id(bid_id: $bid_id) {
    bid_id
    opening_date
    closing_date
    bid_notes
    active
    minimum_quantity
    bid_application_lowest_price
    delivery_date
    bid_number
    opening_bid_price
    quantity
    bid_status
    bid_notes
    product_item_id
    product_item {
      product_item_name
    }
    product_id
    product {
      product_name
    }
    unit_of_measure_id
    uom {
      name
    }
    country_id
    country {
      iso_alpha2_name
    }
    cancellation_reason
    currency
  }
}
    `;

/**
 * __useBid_By_IdQuery__
 *
 * To run a query within a React component, call `useBid_By_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBid_By_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBid_By_IdQuery({
 *   variables: {
 *      bid_id: // value for 'bid_id'
 *   },
 * });
 */
export function useBid_By_IdQuery(baseOptions?: Apollo.QueryHookOptions<GqlBid_By_IdQuery, GqlBid_By_IdQueryVariables>) {
        return Apollo.useQuery<GqlBid_By_IdQuery, GqlBid_By_IdQueryVariables>(Bid_By_IdDocument, baseOptions);
      }
export function useBid_By_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBid_By_IdQuery, GqlBid_By_IdQueryVariables>) {
          return Apollo.useLazyQuery<GqlBid_By_IdQuery, GqlBid_By_IdQueryVariables>(Bid_By_IdDocument, baseOptions);
        }
export type Bid_By_IdQueryHookResult = ReturnType<typeof useBid_By_IdQuery>;
export type Bid_By_IdLazyQueryHookResult = ReturnType<typeof useBid_By_IdLazyQuery>;
export type Bid_By_IdQueryResult = Apollo.QueryResult<GqlBid_By_IdQuery, GqlBid_By_IdQueryVariables>;
export const SupplierUsersDocument = gql`
    query supplierUsers($page: Int, $per_page: Int, $search: String) {
  supplier_users(page: $page, per_page: $per_page, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        supplier_user_id
        date_created
        user_id
        active
        user {
          first_name
          last_name
          email
          phone_number
          user_no
        }
        supplier {
          farmer_number
          supplier_name
          first_name
          last_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useSupplierUsersQuery__
 *
 * To run a query within a React component, call `useSupplierUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSupplierUsersQuery(baseOptions?: Apollo.QueryHookOptions<GqlSupplierUsersQuery, GqlSupplierUsersQueryVariables>) {
        return Apollo.useQuery<GqlSupplierUsersQuery, GqlSupplierUsersQueryVariables>(SupplierUsersDocument, baseOptions);
      }
export function useSupplierUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSupplierUsersQuery, GqlSupplierUsersQueryVariables>) {
          return Apollo.useLazyQuery<GqlSupplierUsersQuery, GqlSupplierUsersQueryVariables>(SupplierUsersDocument, baseOptions);
        }
export type SupplierUsersQueryHookResult = ReturnType<typeof useSupplierUsersQuery>;
export type SupplierUsersLazyQueryHookResult = ReturnType<typeof useSupplierUsersLazyQuery>;
export type SupplierUsersQueryResult = Apollo.QueryResult<GqlSupplierUsersQuery, GqlSupplierUsersQueryVariables>;
export const GetClustersDocument = gql`
    query getClusters($page: Int, $per_page: Int, $search: String, $filters: GenericScalar) {
  clusters(
    page: $page
    per_page: $per_page
    search: $search
    active: true
    filters: $filters
  ) {
    edges {
      node {
        date_created
        depot_name
        depot_code
        cluster_code
        cluster_number
        cluster_id
      }
    }
    page_info {
      ...Pagination
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useGetClustersQuery__
 *
 * To run a query within a React component, call `useGetClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClustersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClustersQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetClustersQuery, GqlGetClustersQueryVariables>) {
        return Apollo.useQuery<GqlGetClustersQuery, GqlGetClustersQueryVariables>(GetClustersDocument, baseOptions);
      }
export function useGetClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetClustersQuery, GqlGetClustersQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetClustersQuery, GqlGetClustersQueryVariables>(GetClustersDocument, baseOptions);
        }
export type GetClustersQueryHookResult = ReturnType<typeof useGetClustersQuery>;
export type GetClustersLazyQueryHookResult = ReturnType<typeof useGetClustersLazyQuery>;
export type GetClustersQueryResult = Apollo.QueryResult<GqlGetClustersQuery, GqlGetClustersQueryVariables>;
export const GetClusterAssignmentsDocument = gql`
    query getClusterAssignments($page: Int, $perPage: Int, $filters: GenericScalar, $search: String, $active: Boolean) {
  cluster_assignments(
    page: $page
    per_page: $perPage
    filters: $filters
    search: $search
    active: $active
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        assignment_id
        date_created
        cluster {
          depot_name
          depot_id
          depot_code
          cluster_code
          cluster_number
        }
        active
        agent_id
        agent {
          last_name
          first_name
          phone_number
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useGetClusterAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetClusterAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterAssignmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetClusterAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetClusterAssignmentsQuery, GqlGetClusterAssignmentsQueryVariables>) {
        return Apollo.useQuery<GqlGetClusterAssignmentsQuery, GqlGetClusterAssignmentsQueryVariables>(GetClusterAssignmentsDocument, baseOptions);
      }
export function useGetClusterAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetClusterAssignmentsQuery, GqlGetClusterAssignmentsQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetClusterAssignmentsQuery, GqlGetClusterAssignmentsQueryVariables>(GetClusterAssignmentsDocument, baseOptions);
        }
export type GetClusterAssignmentsQueryHookResult = ReturnType<typeof useGetClusterAssignmentsQuery>;
export type GetClusterAssignmentsLazyQueryHookResult = ReturnType<typeof useGetClusterAssignmentsLazyQuery>;
export type GetClusterAssignmentsQueryResult = Apollo.QueryResult<GqlGetClusterAssignmentsQuery, GqlGetClusterAssignmentsQueryVariables>;
export const DeliveriesDocument = gql`
    query deliveries($search: String, $per_page: Int, $page: Int, $deliveryFilters: GenericScalar) {
  deliveries_v2(
    search: $search
    page: $page
    per_page: $per_page
    filters: $deliveryFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        delivery_id
        ...DeliveryDetails
        payments {
          payment_id
          amount
          currency
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}
${DeliveryDetailsFragmentDoc}`;

/**
 * __useDeliveriesQuery__
 *
 * To run a query within a React component, call `useDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      deliveryFilters: // value for 'deliveryFilters'
 *   },
 * });
 */
export function useDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<GqlDeliveriesQuery, GqlDeliveriesQueryVariables>) {
        return Apollo.useQuery<GqlDeliveriesQuery, GqlDeliveriesQueryVariables>(DeliveriesDocument, baseOptions);
      }
export function useDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDeliveriesQuery, GqlDeliveriesQueryVariables>) {
          return Apollo.useLazyQuery<GqlDeliveriesQuery, GqlDeliveriesQueryVariables>(DeliveriesDocument, baseOptions);
        }
export type DeliveriesQueryHookResult = ReturnType<typeof useDeliveriesQuery>;
export type DeliveriesLazyQueryHookResult = ReturnType<typeof useDeliveriesLazyQuery>;
export type DeliveriesQueryResult = Apollo.QueryResult<GqlDeliveriesQuery, GqlDeliveriesQueryVariables>;
export const Delivery_V2_By_IdDocument = gql`
    query delivery_v2_by_id($deliveryId: String!) {
  delivery_v2_by_id(delivery_id: $deliveryId) {
    delivery_id
    ...DeliveryDetails
    cancellation_reason
    delivery_items {
      product_item_id
      product_item {
        product {
          product_name
        }
        product_item_name
      }
      unit_price
      amount
      currency
      quantity
      unit_of_measure_id
      uom {
        name
        abbreviation
      }
    }
    payments {
      payment_id
      reference_number
      payment_number
      payment_mode
      date_created
      amount
      currency
    }
    amount
    currency
    active
  }
}
    ${DeliveryDetailsFragmentDoc}`;

/**
 * __useDelivery_V2_By_IdQuery__
 *
 * To run a query within a React component, call `useDelivery_V2_By_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelivery_V2_By_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelivery_V2_By_IdQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useDelivery_V2_By_IdQuery(baseOptions: Apollo.QueryHookOptions<GqlDelivery_V2_By_IdQuery, GqlDelivery_V2_By_IdQueryVariables>) {
        return Apollo.useQuery<GqlDelivery_V2_By_IdQuery, GqlDelivery_V2_By_IdQueryVariables>(Delivery_V2_By_IdDocument, baseOptions);
      }
export function useDelivery_V2_By_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDelivery_V2_By_IdQuery, GqlDelivery_V2_By_IdQueryVariables>) {
          return Apollo.useLazyQuery<GqlDelivery_V2_By_IdQuery, GqlDelivery_V2_By_IdQueryVariables>(Delivery_V2_By_IdDocument, baseOptions);
        }
export type Delivery_V2_By_IdQueryHookResult = ReturnType<typeof useDelivery_V2_By_IdQuery>;
export type Delivery_V2_By_IdLazyQueryHookResult = ReturnType<typeof useDelivery_V2_By_IdLazyQuery>;
export type Delivery_V2_By_IdQueryResult = Apollo.QueryResult<GqlDelivery_V2_By_IdQuery, GqlDelivery_V2_By_IdQueryVariables>;
export const DeliveryReturnsDocument = gql`
    query deliveryReturns($per_page: Int, $page: Int, $search: String, $filter: GenericScalar) {
  delivery_returns(
    page: $page
    per_page: $per_page
    search: $search
    filters: $filter
  ) {
    page_info {
      per_page
      total_count
      total_pages
      has_next
      has_previous
    }
    edges {
      node {
        return_id
        return_number
        return_date
        currency
        active
        shop_id
        claim_processed
        delivery {
          delivery_date
          delivery_id
          delivery_number
          delivery_status {
            delivery_status
          }
        }
        refund_status
        return_items {
          approved_by
          approved_by_user {
            first_name
            last_name
          }
          approved_amount
          approved_quantity
          comment
          approved
          approved_amount
          approved_quantity
          image
          active
          return_item_id
          quantity
          amount
          currency
          signed_image_url
          unit_of_measure_id
          uom {
            name
          }
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
          }
          reason {
            name
            description
          }
          rejection_reason_id
          rejection_reason {
            name
          }
        }
        delivery {
          delivery_date
          delivery_id
          delivery_number
          delivery_status {
            delivery_status
          }
        }
        shop {
          shop_name
          shop_number
          signed_image_url
          route_id
          region {
            region_name
          }
          route {
            route_name
            depot {
              depot_name
            }
          }
          customer_id
          customer {
            customer_name
            phone_number
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeliveryReturnsQuery__
 *
 * To run a query within a React component, call `useDeliveryReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryReturnsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeliveryReturnsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDeliveryReturnsQuery, GqlDeliveryReturnsQueryVariables>) {
        return Apollo.useQuery<GqlDeliveryReturnsQuery, GqlDeliveryReturnsQueryVariables>(DeliveryReturnsDocument, baseOptions);
      }
export function useDeliveryReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDeliveryReturnsQuery, GqlDeliveryReturnsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDeliveryReturnsQuery, GqlDeliveryReturnsQueryVariables>(DeliveryReturnsDocument, baseOptions);
        }
export type DeliveryReturnsQueryHookResult = ReturnType<typeof useDeliveryReturnsQuery>;
export type DeliveryReturnsLazyQueryHookResult = ReturnType<typeof useDeliveryReturnsLazyQuery>;
export type DeliveryReturnsQueryResult = Apollo.QueryResult<GqlDeliveryReturnsQuery, GqlDeliveryReturnsQueryVariables>;
export const ReturnItemRejectionReasonsDocument = gql`
    query returnItemRejectionReasons {
  return_item_rejection_reasons {
    rejection_reason_id
    name
    description
  }
}
    `;

/**
 * __useReturnItemRejectionReasonsQuery__
 *
 * To run a query within a React component, call `useReturnItemRejectionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnItemRejectionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnItemRejectionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReturnItemRejectionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GqlReturnItemRejectionReasonsQuery, GqlReturnItemRejectionReasonsQueryVariables>) {
        return Apollo.useQuery<GqlReturnItemRejectionReasonsQuery, GqlReturnItemRejectionReasonsQueryVariables>(ReturnItemRejectionReasonsDocument, baseOptions);
      }
export function useReturnItemRejectionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlReturnItemRejectionReasonsQuery, GqlReturnItemRejectionReasonsQueryVariables>) {
          return Apollo.useLazyQuery<GqlReturnItemRejectionReasonsQuery, GqlReturnItemRejectionReasonsQueryVariables>(ReturnItemRejectionReasonsDocument, baseOptions);
        }
export type ReturnItemRejectionReasonsQueryHookResult = ReturnType<typeof useReturnItemRejectionReasonsQuery>;
export type ReturnItemRejectionReasonsLazyQueryHookResult = ReturnType<typeof useReturnItemRejectionReasonsLazyQuery>;
export type ReturnItemRejectionReasonsQueryResult = Apollo.QueryResult<GqlReturnItemRejectionReasonsQuery, GqlReturnItemRejectionReasonsQueryVariables>;
export const DepotIntakeDocument = gql`
    query depotIntake($page: Int, $per_page: Int, $filter: GenericScalar, $search: String, $filterArray: GenericScalar) {
  depot_intake(
    per_page: $per_page
    page: $page
    filter: $filter
    search: $search
    filter_array: $filterArray
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        depot_intake_id
        depot_intake_number
        cancellation_reason
        active
        sale_date
        route_id
        depot_intake_items {
          depot_intake_item_id
          packaging_unit_id
          packaging_unit_quantity
          quantity
          unit_of_measure_id
          uom {
            abbreviation
          }
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
              packaging_units {
                packaging_unit_id
                name
              }
            }
          }
        }
        created_by
        user {
          first_name
          last_name
          phone_number
          user_no
          user_id
        }
        route {
          route_name
          route_id
          depot_id
          depot {
            depot_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDepotIntakeQuery__
 *
 * To run a query within a React component, call `useDepotIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepotIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepotIntakeQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      filterArray: // value for 'filterArray'
 *   },
 * });
 */
export function useDepotIntakeQuery(baseOptions?: Apollo.QueryHookOptions<GqlDepotIntakeQuery, GqlDepotIntakeQueryVariables>) {
        return Apollo.useQuery<GqlDepotIntakeQuery, GqlDepotIntakeQueryVariables>(DepotIntakeDocument, baseOptions);
      }
export function useDepotIntakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDepotIntakeQuery, GqlDepotIntakeQueryVariables>) {
          return Apollo.useLazyQuery<GqlDepotIntakeQuery, GqlDepotIntakeQueryVariables>(DepotIntakeDocument, baseOptions);
        }
export type DepotIntakeQueryHookResult = ReturnType<typeof useDepotIntakeQuery>;
export type DepotIntakeLazyQueryHookResult = ReturnType<typeof useDepotIntakeLazyQuery>;
export type DepotIntakeQueryResult = Apollo.QueryResult<GqlDepotIntakeQuery, GqlDepotIntakeQueryVariables>;
export const DepotReturnsDocument = gql`
    query depotReturns($page: Int, $per_page: Int, $filter: GenericScalar, $filterArray: GenericScalar) {
  returns(
    per_page: $per_page
    page: $page
    filter: $filter
    filter_array: $filterArray
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        return_id
        return_number
        sale_date
        created_by
        active
        depot_id
        depot {
          depot_name
        }
        user {
          first_name
          last_name
          phone_number
          user_number
          user_id
        }
        packaging_return_items {
          packaging_return_item_id
          active
          cancellation_reason
          packaging_unit_id
          quantity
          packaging_unit {
            name
          }
        }
        product_return_items {
          active
          cancellation_reason
          return_type
          product_item_id
          product_return_item_id
          quantity
          unit_of_measure_id
          uom {
            abbreviation
          }
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
          }
        }
        route_id
        route {
          route_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDepotReturnsQuery__
 *
 * To run a query within a React component, call `useDepotReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepotReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepotReturnsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      filter: // value for 'filter'
 *      filterArray: // value for 'filterArray'
 *   },
 * });
 */
export function useDepotReturnsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDepotReturnsQuery, GqlDepotReturnsQueryVariables>) {
        return Apollo.useQuery<GqlDepotReturnsQuery, GqlDepotReturnsQueryVariables>(DepotReturnsDocument, baseOptions);
      }
export function useDepotReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDepotReturnsQuery, GqlDepotReturnsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDepotReturnsQuery, GqlDepotReturnsQueryVariables>(DepotReturnsDocument, baseOptions);
        }
export type DepotReturnsQueryHookResult = ReturnType<typeof useDepotReturnsQuery>;
export type DepotReturnsLazyQueryHookResult = ReturnType<typeof useDepotReturnsLazyQuery>;
export type DepotReturnsQueryResult = Apollo.QueryResult<GqlDepotReturnsQuery, GqlDepotReturnsQueryVariables>;
export const StockTransferDocument = gql`
    query stockTransfer($page: Int, $per_page: Int, $filter: GenericScalar, $filterArray: GenericScalar) {
  stock_transfer(
    per_page: $per_page
    page: $page
    filter: $filter
    filter_array: $filterArray
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        stock_transfer_id
        stock_transfer_number
        active
        sale_date
        route_id_from
        route_from {
          route_name
          depot_id
          depot {
            depot_name
          }
        }
        product_item_id
        product_item {
          product_item_name
          product_id
          product {
            product_name
          }
        }
        stock_transfer_items {
          route_id_to
          route_to {
            route_name
          }
          stock_transfer_item_id
          unit_of_measure_id
          uom {
            abbreviation
          }
          quantity
          packaging_unit_id
          packaging_unit_quantity
          packaging_unit {
            name
          }
        }
        created_by
        user {
          first_name
          last_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useStockTransferQuery__
 *
 * To run a query within a React component, call `useStockTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTransferQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      filter: // value for 'filter'
 *      filterArray: // value for 'filterArray'
 *   },
 * });
 */
export function useStockTransferQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockTransferQuery, GqlStockTransferQueryVariables>) {
        return Apollo.useQuery<GqlStockTransferQuery, GqlStockTransferQueryVariables>(StockTransferDocument, baseOptions);
      }
export function useStockTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockTransferQuery, GqlStockTransferQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockTransferQuery, GqlStockTransferQueryVariables>(StockTransferDocument, baseOptions);
        }
export type StockTransferQueryHookResult = ReturnType<typeof useStockTransferQuery>;
export type StockTransferLazyQueryHookResult = ReturnType<typeof useStockTransferLazyQuery>;
export type StockTransferQueryResult = Apollo.QueryResult<GqlStockTransferQuery, GqlStockTransferQueryVariables>;
export const DispatchBalanceDocument = gql`
    query DispatchBalance($route_id_from: String, $saleDate: String, $product_item_id: String) {
  dispatch_balance(
    route_id: $route_id_from
    date: $saleDate
    product_item_id: $product_item_id
  ) {
    date
    route_id
    stock_balance
    packaging_balance
    product_item_id
  }
}
    `;

/**
 * __useDispatchBalanceQuery__
 *
 * To run a query within a React component, call `useDispatchBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchBalanceQuery({
 *   variables: {
 *      route_id_from: // value for 'route_id_from'
 *      saleDate: // value for 'saleDate'
 *      product_item_id: // value for 'product_item_id'
 *   },
 * });
 */
export function useDispatchBalanceQuery(baseOptions?: Apollo.QueryHookOptions<GqlDispatchBalanceQuery, GqlDispatchBalanceQueryVariables>) {
        return Apollo.useQuery<GqlDispatchBalanceQuery, GqlDispatchBalanceQueryVariables>(DispatchBalanceDocument, baseOptions);
      }
export function useDispatchBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispatchBalanceQuery, GqlDispatchBalanceQueryVariables>) {
          return Apollo.useLazyQuery<GqlDispatchBalanceQuery, GqlDispatchBalanceQueryVariables>(DispatchBalanceDocument, baseOptions);
        }
export type DispatchBalanceQueryHookResult = ReturnType<typeof useDispatchBalanceQuery>;
export type DispatchBalanceLazyQueryHookResult = ReturnType<typeof useDispatchBalanceLazyQuery>;
export type DispatchBalanceQueryResult = Apollo.QueryResult<GqlDispatchBalanceQuery, GqlDispatchBalanceQueryVariables>;
export const OrdersDocument = gql`
    query orders($search: String, $per_page: Int, $page: Int, $filter: GenericScalar) {
  orders_v2(search: $search, page: $page, per_page: $per_page, filters: $filter) {
    edges {
      node {
        priority
        order_number
        order_id
        shop_id
        active
        cancellation_reason
        currency
        shop {
          shop_name
          shop_number
        }
        trader_entity_user_id
        served_by {
          user_id
          first_name
          last_name
          user_no
          phone_number
        }
        route_id
        route {
          route_name
        }
        amount
        delivery_date
        order_date
        order_items {
          product_item_id
          amount
          currency
          unit_price
          quantity
          product_item {
            product {
              product_name
            }
            product_item_name
          }
          unit_of_measure_id
          uom {
            uom_id
            name
          }
        }
      }
    }
    page_info {
      ...Pagination
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GqlOrdersQuery, GqlOrdersQueryVariables>) {
        return Apollo.useQuery<GqlOrdersQuery, GqlOrdersQueryVariables>(OrdersDocument, baseOptions);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrdersQuery, GqlOrdersQueryVariables>) {
          return Apollo.useLazyQuery<GqlOrdersQuery, GqlOrdersQueryVariables>(OrdersDocument, baseOptions);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<GqlOrdersQuery, GqlOrdersQueryVariables>;
export const ShopsV2Document = gql`
    query shopsV2($per_page: Int, $page: Int, $search: String, $filter: GenericScalar) {
  shops_v2(page: $page, per_page: $per_page, search: $search, filters: $filter) {
    edges {
      node {
        ...ShopDetails
        customer_id
        ...CustomerDetails
        approved
        signed_image_url
        customer_types {
          customer_type_id
          name
        }
      }
    }
    page_info {
      ...Pagination
    }
  }
}
    ${ShopDetailsFragmentDoc}
${CustomerDetailsFragmentDoc}
${PaginationFragmentDoc}`;

/**
 * __useShopsV2Query__
 *
 * To run a query within a React component, call `useShopsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useShopsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopsV2Query({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useShopsV2Query(baseOptions?: Apollo.QueryHookOptions<GqlShopsV2Query, GqlShopsV2QueryVariables>) {
        return Apollo.useQuery<GqlShopsV2Query, GqlShopsV2QueryVariables>(ShopsV2Document, baseOptions);
      }
export function useShopsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShopsV2Query, GqlShopsV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlShopsV2Query, GqlShopsV2QueryVariables>(ShopsV2Document, baseOptions);
        }
export type ShopsV2QueryHookResult = ReturnType<typeof useShopsV2Query>;
export type ShopsV2LazyQueryHookResult = ReturnType<typeof useShopsV2LazyQuery>;
export type ShopsV2QueryResult = Apollo.QueryResult<GqlShopsV2Query, GqlShopsV2QueryVariables>;
export const ShopByIdDocument = gql`
    query shopById($shop_id: String!) {
  shop_v2_by_id(shop_id: $shop_id) {
    ...ShopDetails
    region_id
    region {
      region_name
    }
    kra_pin
    customer_types {
      customer_type_id
      name
    }
    customer_id
    ...CustomerDetails
  }
}
    ${ShopDetailsFragmentDoc}
${CustomerDetailsFragmentDoc}`;

/**
 * __useShopByIdQuery__
 *
 * To run a query within a React component, call `useShopByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopByIdQuery({
 *   variables: {
 *      shop_id: // value for 'shop_id'
 *   },
 * });
 */
export function useShopByIdQuery(baseOptions: Apollo.QueryHookOptions<GqlShopByIdQuery, GqlShopByIdQueryVariables>) {
        return Apollo.useQuery<GqlShopByIdQuery, GqlShopByIdQueryVariables>(ShopByIdDocument, baseOptions);
      }
export function useShopByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShopByIdQuery, GqlShopByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlShopByIdQuery, GqlShopByIdQueryVariables>(ShopByIdDocument, baseOptions);
        }
export type ShopByIdQueryHookResult = ReturnType<typeof useShopByIdQuery>;
export type ShopByIdLazyQueryHookResult = ReturnType<typeof useShopByIdLazyQuery>;
export type ShopByIdQueryResult = Apollo.QueryResult<GqlShopByIdQuery, GqlShopByIdQueryVariables>;
export const ShopTypesV2Document = gql`
    query shopTypesV2($grouped: Boolean) {
  shop_types_v2(grouped: $grouped) {
    shop_type_id
    name
    active
    children {
      shop_type_id
      name
      active
    }
  }
}
    `;

/**
 * __useShopTypesV2Query__
 *
 * To run a query within a React component, call `useShopTypesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useShopTypesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopTypesV2Query({
 *   variables: {
 *      grouped: // value for 'grouped'
 *   },
 * });
 */
export function useShopTypesV2Query(baseOptions?: Apollo.QueryHookOptions<GqlShopTypesV2Query, GqlShopTypesV2QueryVariables>) {
        return Apollo.useQuery<GqlShopTypesV2Query, GqlShopTypesV2QueryVariables>(ShopTypesV2Document, baseOptions);
      }
export function useShopTypesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShopTypesV2Query, GqlShopTypesV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlShopTypesV2Query, GqlShopTypesV2QueryVariables>(ShopTypesV2Document, baseOptions);
        }
export type ShopTypesV2QueryHookResult = ReturnType<typeof useShopTypesV2Query>;
export type ShopTypesV2LazyQueryHookResult = ReturnType<typeof useShopTypesV2LazyQuery>;
export type ShopTypesV2QueryResult = Apollo.QueryResult<GqlShopTypesV2Query, GqlShopTypesV2QueryVariables>;
export const CustomerTypesV2Document = gql`
    query customerTypesV2 {
  customer_types_v2 {
    customer_type_id
    name
  }
}
    `;

/**
 * __useCustomerTypesV2Query__
 *
 * To run a query within a React component, call `useCustomerTypesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTypesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTypesV2Query({
 *   variables: {
 *   },
 * });
 */
export function useCustomerTypesV2Query(baseOptions?: Apollo.QueryHookOptions<GqlCustomerTypesV2Query, GqlCustomerTypesV2QueryVariables>) {
        return Apollo.useQuery<GqlCustomerTypesV2Query, GqlCustomerTypesV2QueryVariables>(CustomerTypesV2Document, baseOptions);
      }
export function useCustomerTypesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCustomerTypesV2Query, GqlCustomerTypesV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlCustomerTypesV2Query, GqlCustomerTypesV2QueryVariables>(CustomerTypesV2Document, baseOptions);
        }
export type CustomerTypesV2QueryHookResult = ReturnType<typeof useCustomerTypesV2Query>;
export type CustomerTypesV2LazyQueryHookResult = ReturnType<typeof useCustomerTypesV2LazyQuery>;
export type CustomerTypesV2QueryResult = Apollo.QueryResult<GqlCustomerTypesV2Query, GqlCustomerTypesV2QueryVariables>;
export const DeliveryItemWarrantiesDocument = gql`
    query deliveryItemWarranties($per_page: Int, $page: Int, $filters: GenericScalar) {
  delivery_item_warranties(page: $page, per_page: $per_page, filters: $filters) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        warranty_id
        serial_number
        delivery_item_id
        image_url
        delivery_item {
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
          }
          unit_price
          amount
          quantity
          delivery {
            delivery_number
            delivery_date
            route_id
            route {
              route_name
            }
            shop {
              shop_number
              customer {
                phone_number
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDeliveryItemWarrantiesQuery__
 *
 * To run a query within a React component, call `useDeliveryItemWarrantiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryItemWarrantiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryItemWarrantiesQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDeliveryItemWarrantiesQuery(baseOptions?: Apollo.QueryHookOptions<GqlDeliveryItemWarrantiesQuery, GqlDeliveryItemWarrantiesQueryVariables>) {
        return Apollo.useQuery<GqlDeliveryItemWarrantiesQuery, GqlDeliveryItemWarrantiesQueryVariables>(DeliveryItemWarrantiesDocument, baseOptions);
      }
export function useDeliveryItemWarrantiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDeliveryItemWarrantiesQuery, GqlDeliveryItemWarrantiesQueryVariables>) {
          return Apollo.useLazyQuery<GqlDeliveryItemWarrantiesQuery, GqlDeliveryItemWarrantiesQueryVariables>(DeliveryItemWarrantiesDocument, baseOptions);
        }
export type DeliveryItemWarrantiesQueryHookResult = ReturnType<typeof useDeliveryItemWarrantiesQuery>;
export type DeliveryItemWarrantiesLazyQueryHookResult = ReturnType<typeof useDeliveryItemWarrantiesLazyQuery>;
export type DeliveryItemWarrantiesQueryResult = Apollo.QueryResult<GqlDeliveryItemWarrantiesQuery, GqlDeliveryItemWarrantiesQueryVariables>;
export const FarmersDocument = gql`
    query farmers($per_page: Int, $page: Int, $filters: GenericScalar) {
  farmers(per_page: $per_page, page: $page, filter: $filters) {
    page_info {
      has_next
      has_previous
      per_page
      total_pages
      total_count
      current_page
    }
    edges {
      node {
        farmer_type
        farmer_id
        farmer_number
        first_name
        last_name
        supplier_name
        active
      }
    }
  }
}
    `;

/**
 * __useFarmersQuery__
 *
 * To run a query within a React component, call `useFarmersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmersQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFarmersQuery(baseOptions?: Apollo.QueryHookOptions<GqlFarmersQuery, GqlFarmersQueryVariables>) {
        return Apollo.useQuery<GqlFarmersQuery, GqlFarmersQueryVariables>(FarmersDocument, baseOptions);
      }
export function useFarmersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFarmersQuery, GqlFarmersQueryVariables>) {
          return Apollo.useLazyQuery<GqlFarmersQuery, GqlFarmersQueryVariables>(FarmersDocument, baseOptions);
        }
export type FarmersQueryHookResult = ReturnType<typeof useFarmersQuery>;
export type FarmersLazyQueryHookResult = ReturnType<typeof useFarmersLazyQuery>;
export type FarmersQueryResult = Apollo.QueryResult<GqlFarmersQuery, GqlFarmersQueryVariables>;
export const VehicleTypesDocument = gql`
    query vehicleTypes {
  vehicle_types {
    edges {
      node {
        vehicle_type_id
        vehicle_type_name
      }
    }
  }
}
    `;

/**
 * __useVehicleTypesQuery__
 *
 * To run a query within a React component, call `useVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVehicleTypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlVehicleTypesQuery, GqlVehicleTypesQueryVariables>) {
        return Apollo.useQuery<GqlVehicleTypesQuery, GqlVehicleTypesQueryVariables>(VehicleTypesDocument, baseOptions);
      }
export function useVehicleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlVehicleTypesQuery, GqlVehicleTypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlVehicleTypesQuery, GqlVehicleTypesQueryVariables>(VehicleTypesDocument, baseOptions);
        }
export type VehicleTypesQueryHookResult = ReturnType<typeof useVehicleTypesQuery>;
export type VehicleTypesLazyQueryHookResult = ReturnType<typeof useVehicleTypesLazyQuery>;
export type VehicleTypesQueryResult = Apollo.QueryResult<GqlVehicleTypesQuery, GqlVehicleTypesQueryVariables>;
export const Inventory_LocationsDocument = gql`
    query inventory_locations($filter: GenericScalar) {
  inventory_locations(filter: $filter) {
    edges {
      node {
        inventory_location_id
        inventory_location_name
        inventory_location_type
      }
    }
  }
}
    `;

/**
 * __useInventory_LocationsQuery__
 *
 * To run a query within a React component, call `useInventory_LocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventory_LocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventory_LocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInventory_LocationsQuery(baseOptions?: Apollo.QueryHookOptions<GqlInventory_LocationsQuery, GqlInventory_LocationsQueryVariables>) {
        return Apollo.useQuery<GqlInventory_LocationsQuery, GqlInventory_LocationsQueryVariables>(Inventory_LocationsDocument, baseOptions);
      }
export function useInventory_LocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlInventory_LocationsQuery, GqlInventory_LocationsQueryVariables>) {
          return Apollo.useLazyQuery<GqlInventory_LocationsQuery, GqlInventory_LocationsQueryVariables>(Inventory_LocationsDocument, baseOptions);
        }
export type Inventory_LocationsQueryHookResult = ReturnType<typeof useInventory_LocationsQuery>;
export type Inventory_LocationsLazyQueryHookResult = ReturnType<typeof useInventory_LocationsLazyQuery>;
export type Inventory_LocationsQueryResult = Apollo.QueryResult<GqlInventory_LocationsQuery, GqlInventory_LocationsQueryVariables>;
export const Vehicle_SuppliersDocument = gql`
    query vehicle_suppliers($page: Int, $filters: GenericScalar, $per_page: Int, $search: String) {
  vehicle_suppliers(
    page: $page
    filters: $filters
    per_page: $per_page
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        name
        active
        date_created
        email
        vehicle_supplier_id
        phone_number
        alt_phone_number
        country_id
        country {
          iso_alpha2_name
        }
        supplier_number
        vehicles {
          vehicle_id
        }
        payment_accounts {
          vehicle_supplier_id
          vehicle_supplier_payment_account_id
          account_type
          account_name
          party
          account_number
          is_primary
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useVehicle_SuppliersQuery__
 *
 * To run a query within a React component, call `useVehicle_SuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicle_SuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicle_SuppliersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useVehicle_SuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GqlVehicle_SuppliersQuery, GqlVehicle_SuppliersQueryVariables>) {
        return Apollo.useQuery<GqlVehicle_SuppliersQuery, GqlVehicle_SuppliersQueryVariables>(Vehicle_SuppliersDocument, baseOptions);
      }
export function useVehicle_SuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlVehicle_SuppliersQuery, GqlVehicle_SuppliersQueryVariables>) {
          return Apollo.useLazyQuery<GqlVehicle_SuppliersQuery, GqlVehicle_SuppliersQueryVariables>(Vehicle_SuppliersDocument, baseOptions);
        }
export type Vehicle_SuppliersQueryHookResult = ReturnType<typeof useVehicle_SuppliersQuery>;
export type Vehicle_SuppliersLazyQueryHookResult = ReturnType<typeof useVehicle_SuppliersLazyQuery>;
export type Vehicle_SuppliersQueryResult = Apollo.QueryResult<GqlVehicle_SuppliersQuery, GqlVehicle_SuppliersQueryVariables>;
export const Cost_ModelDocument = gql`
    query cost_model {
  vehicle_cost_models
}
    `;

/**
 * __useCost_ModelQuery__
 *
 * To run a query within a React component, call `useCost_ModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCost_ModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCost_ModelQuery({
 *   variables: {
 *   },
 * });
 */
export function useCost_ModelQuery(baseOptions?: Apollo.QueryHookOptions<GqlCost_ModelQuery, GqlCost_ModelQueryVariables>) {
        return Apollo.useQuery<GqlCost_ModelQuery, GqlCost_ModelQueryVariables>(Cost_ModelDocument, baseOptions);
      }
export function useCost_ModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCost_ModelQuery, GqlCost_ModelQueryVariables>) {
          return Apollo.useLazyQuery<GqlCost_ModelQuery, GqlCost_ModelQueryVariables>(Cost_ModelDocument, baseOptions);
        }
export type Cost_ModelQueryHookResult = ReturnType<typeof useCost_ModelQuery>;
export type Cost_ModelLazyQueryHookResult = ReturnType<typeof useCost_ModelLazyQuery>;
export type Cost_ModelQueryResult = Apollo.QueryResult<GqlCost_ModelQuery, GqlCost_ModelQueryVariables>;
export const Vehicle_Rejection_ReasonsDocument = gql`
    query vehicle_rejection_reasons {
  vehicle_rejection_reasons
}
    `;

/**
 * __useVehicle_Rejection_ReasonsQuery__
 *
 * To run a query within a React component, call `useVehicle_Rejection_ReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicle_Rejection_ReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicle_Rejection_ReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVehicle_Rejection_ReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GqlVehicle_Rejection_ReasonsQuery, GqlVehicle_Rejection_ReasonsQueryVariables>) {
        return Apollo.useQuery<GqlVehicle_Rejection_ReasonsQuery, GqlVehicle_Rejection_ReasonsQueryVariables>(Vehicle_Rejection_ReasonsDocument, baseOptions);
      }
export function useVehicle_Rejection_ReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlVehicle_Rejection_ReasonsQuery, GqlVehicle_Rejection_ReasonsQueryVariables>) {
          return Apollo.useLazyQuery<GqlVehicle_Rejection_ReasonsQuery, GqlVehicle_Rejection_ReasonsQueryVariables>(Vehicle_Rejection_ReasonsDocument, baseOptions);
        }
export type Vehicle_Rejection_ReasonsQueryHookResult = ReturnType<typeof useVehicle_Rejection_ReasonsQuery>;
export type Vehicle_Rejection_ReasonsLazyQueryHookResult = ReturnType<typeof useVehicle_Rejection_ReasonsLazyQuery>;
export type Vehicle_Rejection_ReasonsQueryResult = Apollo.QueryResult<GqlVehicle_Rejection_ReasonsQuery, GqlVehicle_Rejection_ReasonsQueryVariables>;
export const SupplierVehiclesDocument = gql`
    query supplierVehicles($search: String, $per_page: Int, $page: Int, $filters: GenericScalar) {
  vehicles(search: $search, per_page: $per_page, filters: $filters, page: $page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        vehicle_id
        vehicle_supplier_id
        date_created
        registration_number
        vehicle_type {
          vehicle_type_name
          vehicle_type_id
        }
        logistics_type
        region_id
        cost_rate
        load_capacity
        insurance_expiry_date
        service_due_date
        capacity_volume
        active
        vehicle_cost_model
        region {
          region_name
        }
        rejection_reason
        rejected
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useSupplierVehiclesQuery__
 *
 * To run a query within a React component, call `useSupplierVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierVehiclesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSupplierVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<GqlSupplierVehiclesQuery, GqlSupplierVehiclesQueryVariables>) {
        return Apollo.useQuery<GqlSupplierVehiclesQuery, GqlSupplierVehiclesQueryVariables>(SupplierVehiclesDocument, baseOptions);
      }
export function useSupplierVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSupplierVehiclesQuery, GqlSupplierVehiclesQueryVariables>) {
          return Apollo.useLazyQuery<GqlSupplierVehiclesQuery, GqlSupplierVehiclesQueryVariables>(SupplierVehiclesDocument, baseOptions);
        }
export type SupplierVehiclesQueryHookResult = ReturnType<typeof useSupplierVehiclesQuery>;
export type SupplierVehiclesLazyQueryHookResult = ReturnType<typeof useSupplierVehiclesLazyQuery>;
export type SupplierVehiclesQueryResult = Apollo.QueryResult<GqlSupplierVehiclesQuery, GqlSupplierVehiclesQueryVariables>;
export const TripsDocument = gql`
    query trips($page: Int, $filters: GenericScalar, $per_page: Int, $search: String) {
  trips(page: $page, filters: $filters, per_page: $per_page, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        trip_id
        active
        logistics_type
        route_plan {
          route_plan_id
          depot_id
          depot {
            depot_name
          }
          route_id
          route {
            route_name
          }
        }
        starting_odometer
        closing_odometer
        vehicle {
          vehicle_supplier {
            name
          }
          registration_number
          logistics_type
          load_capacity
          usable_load_capacity
        }
        starting_date
        end_date
        region_id
        region {
          region_name
        }
        from_location
        to_location
        from_inventory_location {
          inventory_location_name
        }
        to_inventory_location {
          inventory_location_name
        }
        weight
        cost_rate
        vehicle_cost_model
        active
        distance
        cost
        total_cost
        variable_cost
        has_statement
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useTripsQuery__
 *
 * To run a query within a React component, call `useTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTripsQuery(baseOptions?: Apollo.QueryHookOptions<GqlTripsQuery, GqlTripsQueryVariables>) {
        return Apollo.useQuery<GqlTripsQuery, GqlTripsQueryVariables>(TripsDocument, baseOptions);
      }
export function useTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlTripsQuery, GqlTripsQueryVariables>) {
          return Apollo.useLazyQuery<GqlTripsQuery, GqlTripsQueryVariables>(TripsDocument, baseOptions);
        }
export type TripsQueryHookResult = ReturnType<typeof useTripsQuery>;
export type TripsLazyQueryHookResult = ReturnType<typeof useTripsLazyQuery>;
export type TripsQueryResult = Apollo.QueryResult<GqlTripsQuery, GqlTripsQueryVariables>;
export const SupplierStatementsDocument = gql`
    query supplierStatements($search: String, $per_page: Int, $page: Int, $filters: GenericScalar) {
  vehicle_supplier_statements(
    search: $search
    per_page: $per_page
    filters: $filters
    page: $page
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        statement_id
        statement_number
        invoice_amount
        vehicle_supplier_id
        vehicle_supplier {
          name
          country_id
          country {
            iso_alpha2_code
            iso_alpha2_name
          }
        }
        amount
        approval_status
        approved_by
        date_from
        date_to
        date_created
        created_by
        created_by_user {
          first_name
          last_name
        }
        approved_by
        approved_by_user {
          first_name
          last_name
        }
        payment_status
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useSupplierStatementsQuery__
 *
 * To run a query within a React component, call `useSupplierStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierStatementsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSupplierStatementsQuery(baseOptions?: Apollo.QueryHookOptions<GqlSupplierStatementsQuery, GqlSupplierStatementsQueryVariables>) {
        return Apollo.useQuery<GqlSupplierStatementsQuery, GqlSupplierStatementsQueryVariables>(SupplierStatementsDocument, baseOptions);
      }
export function useSupplierStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSupplierStatementsQuery, GqlSupplierStatementsQueryVariables>) {
          return Apollo.useLazyQuery<GqlSupplierStatementsQuery, GqlSupplierStatementsQueryVariables>(SupplierStatementsDocument, baseOptions);
        }
export type SupplierStatementsQueryHookResult = ReturnType<typeof useSupplierStatementsQuery>;
export type SupplierStatementsLazyQueryHookResult = ReturnType<typeof useSupplierStatementsLazyQuery>;
export type SupplierStatementsQueryResult = Apollo.QueryResult<GqlSupplierStatementsQuery, GqlSupplierStatementsQueryVariables>;
export const Ordering_WindowsDocument = gql`
    query ordering_windows($page: Int, $per_page: Int, $search: String, $filters: GenericScalar) {
  ordering_windows(
    per_page: $per_page
    page: $page
    search: $search
    filters: $filters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ordering_window_id
        active
        region_id
        region {
          region_name
          region_id
        }
        channel
        depot_id
        depot {
          depot_name
        }
        ordering_window_items {
          active
          ordering_window_item_id
          day
          opening_time
          closing_time
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useOrdering_WindowsQuery__
 *
 * To run a query within a React component, call `useOrdering_WindowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdering_WindowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdering_WindowsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrdering_WindowsQuery(baseOptions?: Apollo.QueryHookOptions<GqlOrdering_WindowsQuery, GqlOrdering_WindowsQueryVariables>) {
        return Apollo.useQuery<GqlOrdering_WindowsQuery, GqlOrdering_WindowsQueryVariables>(Ordering_WindowsDocument, baseOptions);
      }
export function useOrdering_WindowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrdering_WindowsQuery, GqlOrdering_WindowsQueryVariables>) {
          return Apollo.useLazyQuery<GqlOrdering_WindowsQuery, GqlOrdering_WindowsQueryVariables>(Ordering_WindowsDocument, baseOptions);
        }
export type Ordering_WindowsQueryHookResult = ReturnType<typeof useOrdering_WindowsQuery>;
export type Ordering_WindowsLazyQueryHookResult = ReturnType<typeof useOrdering_WindowsLazyQuery>;
export type Ordering_WindowsQueryResult = Apollo.QueryResult<GqlOrdering_WindowsQuery, GqlOrdering_WindowsQueryVariables>;
export const Payment_VisibilitiesDocument = gql`
    query payment_visibilities {
  payment_visibilities {
    payment_method {
      description
      payment_method_id
      payment_method_name
      description
    }
    payment_visibility_id
    region_id
    channel
    visible
    active
  }
}
    `;

/**
 * __usePayment_VisibilitiesQuery__
 *
 * To run a query within a React component, call `usePayment_VisibilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayment_VisibilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayment_VisibilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayment_VisibilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GqlPayment_VisibilitiesQuery, GqlPayment_VisibilitiesQueryVariables>) {
        return Apollo.useQuery<GqlPayment_VisibilitiesQuery, GqlPayment_VisibilitiesQueryVariables>(Payment_VisibilitiesDocument, baseOptions);
      }
export function usePayment_VisibilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPayment_VisibilitiesQuery, GqlPayment_VisibilitiesQueryVariables>) {
          return Apollo.useLazyQuery<GqlPayment_VisibilitiesQuery, GqlPayment_VisibilitiesQueryVariables>(Payment_VisibilitiesDocument, baseOptions);
        }
export type Payment_VisibilitiesQueryHookResult = ReturnType<typeof usePayment_VisibilitiesQuery>;
export type Payment_VisibilitiesLazyQueryHookResult = ReturnType<typeof usePayment_VisibilitiesLazyQuery>;
export type Payment_VisibilitiesQueryResult = Apollo.QueryResult<GqlPayment_VisibilitiesQuery, GqlPayment_VisibilitiesQueryVariables>;
export const Promo_TypesDocument = gql`
    query promo_types {
  promotion_types {
    promotion_type_id
    title
    active
    background_color
  }
}
    `;

/**
 * __usePromo_TypesQuery__
 *
 * To run a query within a React component, call `usePromo_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromo_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromo_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromo_TypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlPromo_TypesQuery, GqlPromo_TypesQueryVariables>) {
        return Apollo.useQuery<GqlPromo_TypesQuery, GqlPromo_TypesQueryVariables>(Promo_TypesDocument, baseOptions);
      }
export function usePromo_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPromo_TypesQuery, GqlPromo_TypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlPromo_TypesQuery, GqlPromo_TypesQueryVariables>(Promo_TypesDocument, baseOptions);
        }
export type Promo_TypesQueryHookResult = ReturnType<typeof usePromo_TypesQuery>;
export type Promo_TypesLazyQueryHookResult = ReturnType<typeof usePromo_TypesLazyQuery>;
export type Promo_TypesQueryResult = Apollo.QueryResult<GqlPromo_TypesQuery, GqlPromo_TypesQueryVariables>;
export const Add_PromoDocument = gql`
    mutation add_promo($title: String!, $background_color: String!) {
  add_promotion_type(data: {title: $title, background_color: $background_color}) {
    promotion_type {
      promotion_type_id
      title
      background_color
    }
  }
}
    `;
export type GqlAdd_PromoMutationFn = Apollo.MutationFunction<GqlAdd_PromoMutation, GqlAdd_PromoMutationVariables>;

/**
 * __useAdd_PromoMutation__
 *
 * To run a mutation, you first call `useAdd_PromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_PromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromoMutation, { data, loading, error }] = useAdd_PromoMutation({
 *   variables: {
 *      title: // value for 'title'
 *      background_color: // value for 'background_color'
 *   },
 * });
 */
export function useAdd_PromoMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_PromoMutation, GqlAdd_PromoMutationVariables>) {
        return Apollo.useMutation<GqlAdd_PromoMutation, GqlAdd_PromoMutationVariables>(Add_PromoDocument, baseOptions);
      }
export type Add_PromoMutationHookResult = ReturnType<typeof useAdd_PromoMutation>;
export type Add_PromoMutationResult = Apollo.MutationResult<GqlAdd_PromoMutation>;
export type Add_PromoMutationOptions = Apollo.BaseMutationOptions<GqlAdd_PromoMutation, GqlAdd_PromoMutationVariables>;
export const Update_Promotion_TypeDocument = gql`
    mutation update_promotion_type($promotion_type_id: String!, $data: PromotionTypeInput!) {
  update_promotion_type(data: $data, promotion_type_id: $promotion_type_id) {
    promotion_type {
      promotion_type_id
      title
      background_color
    }
  }
}
    `;
export type GqlUpdate_Promotion_TypeMutationFn = Apollo.MutationFunction<GqlUpdate_Promotion_TypeMutation, GqlUpdate_Promotion_TypeMutationVariables>;

/**
 * __useUpdate_Promotion_TypeMutation__
 *
 * To run a mutation, you first call `useUpdate_Promotion_TypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Promotion_TypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromotionTypeMutation, { data, loading, error }] = useUpdate_Promotion_TypeMutation({
 *   variables: {
 *      promotion_type_id: // value for 'promotion_type_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_Promotion_TypeMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_Promotion_TypeMutation, GqlUpdate_Promotion_TypeMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_Promotion_TypeMutation, GqlUpdate_Promotion_TypeMutationVariables>(Update_Promotion_TypeDocument, baseOptions);
      }
export type Update_Promotion_TypeMutationHookResult = ReturnType<typeof useUpdate_Promotion_TypeMutation>;
export type Update_Promotion_TypeMutationResult = Apollo.MutationResult<GqlUpdate_Promotion_TypeMutation>;
export type Update_Promotion_TypeMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_Promotion_TypeMutation, GqlUpdate_Promotion_TypeMutationVariables>;
export const Product_Items_With_TagsDocument = gql`
    query product_items_with_tags($filters: GenericScalar) {
  product_items_with_tags(filters: $filters) {
    promotion_tag_id
    promotion_type_id
    active
    region_ids
    start_date
    end_date
    promotion_type {
      title
      background_color
    }
    product_item_id
    product_item {
      product_item_name
      product {
        product_name
      }
    }
  }
}
    `;

/**
 * __useProduct_Items_With_TagsQuery__
 *
 * To run a query within a React component, call `useProduct_Items_With_TagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProduct_Items_With_TagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_Items_With_TagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProduct_Items_With_TagsQuery(baseOptions?: Apollo.QueryHookOptions<GqlProduct_Items_With_TagsQuery, GqlProduct_Items_With_TagsQueryVariables>) {
        return Apollo.useQuery<GqlProduct_Items_With_TagsQuery, GqlProduct_Items_With_TagsQueryVariables>(Product_Items_With_TagsDocument, baseOptions);
      }
export function useProduct_Items_With_TagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_Items_With_TagsQuery, GqlProduct_Items_With_TagsQueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_Items_With_TagsQuery, GqlProduct_Items_With_TagsQueryVariables>(Product_Items_With_TagsDocument, baseOptions);
        }
export type Product_Items_With_TagsQueryHookResult = ReturnType<typeof useProduct_Items_With_TagsQuery>;
export type Product_Items_With_TagsLazyQueryHookResult = ReturnType<typeof useProduct_Items_With_TagsLazyQuery>;
export type Product_Items_With_TagsQueryResult = Apollo.QueryResult<GqlProduct_Items_With_TagsQuery, GqlProduct_Items_With_TagsQueryVariables>;
export const Promotion_TypesDocument = gql`
    query promotion_types {
  promotion_types {
    promotion_type_id
    title
  }
}
    `;

/**
 * __usePromotion_TypesQuery__
 *
 * To run a query within a React component, call `usePromotion_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotion_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotion_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromotion_TypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlPromotion_TypesQuery, GqlPromotion_TypesQueryVariables>) {
        return Apollo.useQuery<GqlPromotion_TypesQuery, GqlPromotion_TypesQueryVariables>(Promotion_TypesDocument, baseOptions);
      }
export function usePromotion_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPromotion_TypesQuery, GqlPromotion_TypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlPromotion_TypesQuery, GqlPromotion_TypesQueryVariables>(Promotion_TypesDocument, baseOptions);
        }
export type Promotion_TypesQueryHookResult = ReturnType<typeof usePromotion_TypesQuery>;
export type Promotion_TypesLazyQueryHookResult = ReturnType<typeof usePromotion_TypesLazyQuery>;
export type Promotion_TypesQueryResult = Apollo.QueryResult<GqlPromotion_TypesQuery, GqlPromotion_TypesQueryVariables>;
export const Add_Promotion_TagDocument = gql`
    mutation add_promotion_tag($product_item_id: String!, $promotion_type_id: String, $region_ids: [String], $start_date: String, $end_date: String, $meta: GenericScalar, $country_id: String!) {
  add_promotion_tag(
    data: {product_item_id: $product_item_id, promotion_type_id: $promotion_type_id, region_ids: $region_ids, start_date: $start_date, end_date: $end_date, country_id: $country_id, meta: $meta}
  ) {
    created
    promotion_tag {
      promotion_tag_id
      product_item_id
      region_ids
      start_date
      end_date
    }
  }
}
    `;
export type GqlAdd_Promotion_TagMutationFn = Apollo.MutationFunction<GqlAdd_Promotion_TagMutation, GqlAdd_Promotion_TagMutationVariables>;

/**
 * __useAdd_Promotion_TagMutation__
 *
 * To run a mutation, you first call `useAdd_Promotion_TagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Promotion_TagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromotionTagMutation, { data, loading, error }] = useAdd_Promotion_TagMutation({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *      promotion_type_id: // value for 'promotion_type_id'
 *      region_ids: // value for 'region_ids'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      meta: // value for 'meta'
 *      country_id: // value for 'country_id'
 *   },
 * });
 */
export function useAdd_Promotion_TagMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Promotion_TagMutation, GqlAdd_Promotion_TagMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Promotion_TagMutation, GqlAdd_Promotion_TagMutationVariables>(Add_Promotion_TagDocument, baseOptions);
      }
export type Add_Promotion_TagMutationHookResult = ReturnType<typeof useAdd_Promotion_TagMutation>;
export type Add_Promotion_TagMutationResult = Apollo.MutationResult<GqlAdd_Promotion_TagMutation>;
export type Add_Promotion_TagMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Promotion_TagMutation, GqlAdd_Promotion_TagMutationVariables>;
export const Update_Promotion_TagDocument = gql`
    mutation update_promotion_tag($promotion_tag_id: String!, $data: PromotionTagInput!) {
  update_promotion_tag(promotion_tag_id: $promotion_tag_id, data: $data) {
    promotion_tag {
      promotion_tag_id
      product_item_id
      region_ids
      start_date
      end_date
    }
  }
}
    `;
export type GqlUpdate_Promotion_TagMutationFn = Apollo.MutationFunction<GqlUpdate_Promotion_TagMutation, GqlUpdate_Promotion_TagMutationVariables>;

/**
 * __useUpdate_Promotion_TagMutation__
 *
 * To run a mutation, you first call `useUpdate_Promotion_TagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Promotion_TagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromotionTagMutation, { data, loading, error }] = useUpdate_Promotion_TagMutation({
 *   variables: {
 *      promotion_tag_id: // value for 'promotion_tag_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_Promotion_TagMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_Promotion_TagMutation, GqlUpdate_Promotion_TagMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_Promotion_TagMutation, GqlUpdate_Promotion_TagMutationVariables>(Update_Promotion_TagDocument, baseOptions);
      }
export type Update_Promotion_TagMutationHookResult = ReturnType<typeof useUpdate_Promotion_TagMutation>;
export type Update_Promotion_TagMutationResult = Apollo.MutationResult<GqlUpdate_Promotion_TagMutation>;
export type Update_Promotion_TagMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_Promotion_TagMutation, GqlUpdate_Promotion_TagMutationVariables>;
export const UserFeedbackDocument = gql`
    query userFeedback {
  agent_feedback {
    edges {
      node {
        client_stamp
      }
    }
  }
}
    `;

/**
 * __useUserFeedbackQuery__
 *
 * To run a query within a React component, call `useUserFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeedbackQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFeedbackQuery(baseOptions?: Apollo.QueryHookOptions<GqlUserFeedbackQuery, GqlUserFeedbackQueryVariables>) {
        return Apollo.useQuery<GqlUserFeedbackQuery, GqlUserFeedbackQueryVariables>(UserFeedbackDocument, baseOptions);
      }
export function useUserFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlUserFeedbackQuery, GqlUserFeedbackQueryVariables>) {
          return Apollo.useLazyQuery<GqlUserFeedbackQuery, GqlUserFeedbackQueryVariables>(UserFeedbackDocument, baseOptions);
        }
export type UserFeedbackQueryHookResult = ReturnType<typeof useUserFeedbackQuery>;
export type UserFeedbackLazyQueryHookResult = ReturnType<typeof useUserFeedbackLazyQuery>;
export type UserFeedbackQueryResult = Apollo.QueryResult<GqlUserFeedbackQuery, GqlUserFeedbackQueryVariables>;
export const Base_PricingDocument = gql`
    query base_pricing($page: Int, $per_page: Int, $search: String, $regionId: String!, $filters: GenericScalar) {
  paginated_product_items_v2(
    per_page: $per_page
    page: $page
    search: $search
    filters: $filters
    active: true
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        product_item_id
        product_item_name
        product {
          product_name
        }
        units_of_measure {
          business_domain_id
          business_domain {
            domain_name
          }
          uom {
            uom_id
            name
          }
        }
        current_pricing_v2(region_id: $regionId) {
          unit_of_measure_id
          base_price
          currency
          rrp
          pricing_date
          region_id
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useBase_PricingQuery__
 *
 * To run a query within a React component, call `useBase_PricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBase_PricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBase_PricingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      regionId: // value for 'regionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBase_PricingQuery(baseOptions: Apollo.QueryHookOptions<GqlBase_PricingQuery, GqlBase_PricingQueryVariables>) {
        return Apollo.useQuery<GqlBase_PricingQuery, GqlBase_PricingQueryVariables>(Base_PricingDocument, baseOptions);
      }
export function useBase_PricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBase_PricingQuery, GqlBase_PricingQueryVariables>) {
          return Apollo.useLazyQuery<GqlBase_PricingQuery, GqlBase_PricingQueryVariables>(Base_PricingDocument, baseOptions);
        }
export type Base_PricingQueryHookResult = ReturnType<typeof useBase_PricingQuery>;
export type Base_PricingLazyQueryHookResult = ReturnType<typeof useBase_PricingLazyQuery>;
export type Base_PricingQueryResult = Apollo.QueryResult<GqlBase_PricingQuery, GqlBase_PricingQueryVariables>;
export const PricingDocument = gql`
    query pricing($page: Int, $per_page: Int, $filters: GenericScalar) {
  pricing_v2(page: $page, per_page: $per_page, filter: $filters) {
    edges {
      node {
        date_updated
        updated_by
        base_price
        currency
        rrp
        user {
          first_name
          last_name
        }
      }
    }
  }
}
    `;

/**
 * __usePricingQuery__
 *
 * To run a query within a React component, call `usePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePricingQuery(baseOptions?: Apollo.QueryHookOptions<GqlPricingQuery, GqlPricingQueryVariables>) {
        return Apollo.useQuery<GqlPricingQuery, GqlPricingQueryVariables>(PricingDocument, baseOptions);
      }
export function usePricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPricingQuery, GqlPricingQueryVariables>) {
          return Apollo.useLazyQuery<GqlPricingQuery, GqlPricingQueryVariables>(PricingDocument, baseOptions);
        }
export type PricingQueryHookResult = ReturnType<typeof usePricingQuery>;
export type PricingLazyQueryHookResult = ReturnType<typeof usePricingLazyQuery>;
export type PricingQueryResult = Apollo.QueryResult<GqlPricingQuery, GqlPricingQueryVariables>;
export const Product_Departments_V2Document = gql`
    query product_departments_v2 {
  product_departments_v2 {
    department_id
    department_name
  }
}
    `;

/**
 * __useProduct_Departments_V2Query__
 *
 * To run a query within a React component, call `useProduct_Departments_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useProduct_Departments_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_Departments_V2Query({
 *   variables: {
 *   },
 * });
 */
export function useProduct_Departments_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlProduct_Departments_V2Query, GqlProduct_Departments_V2QueryVariables>) {
        return Apollo.useQuery<GqlProduct_Departments_V2Query, GqlProduct_Departments_V2QueryVariables>(Product_Departments_V2Document, baseOptions);
      }
export function useProduct_Departments_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_Departments_V2Query, GqlProduct_Departments_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_Departments_V2Query, GqlProduct_Departments_V2QueryVariables>(Product_Departments_V2Document, baseOptions);
        }
export type Product_Departments_V2QueryHookResult = ReturnType<typeof useProduct_Departments_V2Query>;
export type Product_Departments_V2LazyQueryHookResult = ReturnType<typeof useProduct_Departments_V2LazyQuery>;
export type Product_Departments_V2QueryResult = Apollo.QueryResult<GqlProduct_Departments_V2Query, GqlProduct_Departments_V2QueryVariables>;
export const Paginated_Products_V2Document = gql`
    query paginated_products_v2($search: String) {
  paginated_products_v2(search: $search) {
    edges {
      node {
        product_id
        product_name
        product_type
        product_items {
          product_item_id
          product_item_name
        }
      }
    }
  }
}
    `;

/**
 * __usePaginated_Products_V2Query__
 *
 * To run a query within a React component, call `usePaginated_Products_V2Query` and pass it any options that fit your needs.
 * When your component renders, `usePaginated_Products_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginated_Products_V2Query({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaginated_Products_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlPaginated_Products_V2Query, GqlPaginated_Products_V2QueryVariables>) {
        return Apollo.useQuery<GqlPaginated_Products_V2Query, GqlPaginated_Products_V2QueryVariables>(Paginated_Products_V2Document, baseOptions);
      }
export function usePaginated_Products_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPaginated_Products_V2Query, GqlPaginated_Products_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlPaginated_Products_V2Query, GqlPaginated_Products_V2QueryVariables>(Paginated_Products_V2Document, baseOptions);
        }
export type Paginated_Products_V2QueryHookResult = ReturnType<typeof usePaginated_Products_V2Query>;
export type Paginated_Products_V2LazyQueryHookResult = ReturnType<typeof usePaginated_Products_V2LazyQuery>;
export type Paginated_Products_V2QueryResult = Apollo.QueryResult<GqlPaginated_Products_V2Query, GqlPaginated_Products_V2QueryVariables>;
export const Add_CategoryDocument = gql`
    mutation add_category($data: CategoryInput!) {
  add_category(data: $data) {
    category {
      category_id
      category_name
      department_id
    }
    created
  }
}
    `;
export type GqlAdd_CategoryMutationFn = Apollo.MutationFunction<GqlAdd_CategoryMutation, GqlAdd_CategoryMutationVariables>;

/**
 * __useAdd_CategoryMutation__
 *
 * To run a mutation, you first call `useAdd_CategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_CategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCategoryMutation, { data, loading, error }] = useAdd_CategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdd_CategoryMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_CategoryMutation, GqlAdd_CategoryMutationVariables>) {
        return Apollo.useMutation<GqlAdd_CategoryMutation, GqlAdd_CategoryMutationVariables>(Add_CategoryDocument, baseOptions);
      }
export type Add_CategoryMutationHookResult = ReturnType<typeof useAdd_CategoryMutation>;
export type Add_CategoryMutationResult = Apollo.MutationResult<GqlAdd_CategoryMutation>;
export type Add_CategoryMutationOptions = Apollo.BaseMutationOptions<GqlAdd_CategoryMutation, GqlAdd_CategoryMutationVariables>;
export const Product_CategoriesDocument = gql`
    query product_categories($search: String, $active: Boolean) {
  product_categories_v2(search: $search, active: $active) {
    category_id
    category_name
    image_url
    banner_image_url
    date_updated
    active
    total_products
    products {
      product_id
      product_name
    }
    sub_categories {
      category_id
      category_name
      image_url
      active
      total_products
    }
    department_id
    department {
      department_id
      department_name
    }
  }
}
    `;

/**
 * __useProduct_CategoriesQuery__
 *
 * To run a query within a React component, call `useProduct_CategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProduct_CategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_CategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useProduct_CategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProduct_CategoriesQuery, GqlProduct_CategoriesQueryVariables>) {
        return Apollo.useQuery<GqlProduct_CategoriesQuery, GqlProduct_CategoriesQueryVariables>(Product_CategoriesDocument, baseOptions);
      }
export function useProduct_CategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_CategoriesQuery, GqlProduct_CategoriesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_CategoriesQuery, GqlProduct_CategoriesQueryVariables>(Product_CategoriesDocument, baseOptions);
        }
export type Product_CategoriesQueryHookResult = ReturnType<typeof useProduct_CategoriesQuery>;
export type Product_CategoriesLazyQueryHookResult = ReturnType<typeof useProduct_CategoriesLazyQuery>;
export type Product_CategoriesQueryResult = Apollo.QueryResult<GqlProduct_CategoriesQuery, GqlProduct_CategoriesQueryVariables>;
export const Update_CategoryDocument = gql`
    mutation update_category($category_id: String!, $data: CategoryInput!) {
  update_category(category_id: $category_id, data: $data) {
    category {
      category_id
      active
    }
  }
}
    `;
export type GqlUpdate_CategoryMutationFn = Apollo.MutationFunction<GqlUpdate_CategoryMutation, GqlUpdate_CategoryMutationVariables>;

/**
 * __useUpdate_CategoryMutation__
 *
 * To run a mutation, you first call `useUpdate_CategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_CategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdate_CategoryMutation({
 *   variables: {
 *      category_id: // value for 'category_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_CategoryMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_CategoryMutation, GqlUpdate_CategoryMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_CategoryMutation, GqlUpdate_CategoryMutationVariables>(Update_CategoryDocument, baseOptions);
      }
export type Update_CategoryMutationHookResult = ReturnType<typeof useUpdate_CategoryMutation>;
export type Update_CategoryMutationResult = Apollo.MutationResult<GqlUpdate_CategoryMutation>;
export type Update_CategoryMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_CategoryMutation, GqlUpdate_CategoryMutationVariables>;
export const Upload_Category_ImageDocument = gql`
    mutation upload_category_image($image: Upload!, $category_id: String!) {
  upload_category_image(category_id: $category_id, image: $image) {
    uploaded
    category {
      image_url
    }
  }
}
    `;
export type GqlUpload_Category_ImageMutationFn = Apollo.MutationFunction<GqlUpload_Category_ImageMutation, GqlUpload_Category_ImageMutationVariables>;

/**
 * __useUpload_Category_ImageMutation__
 *
 * To run a mutation, you first call `useUpload_Category_ImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpload_Category_ImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCategoryImageMutation, { data, loading, error }] = useUpload_Category_ImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      category_id: // value for 'category_id'
 *   },
 * });
 */
export function useUpload_Category_ImageMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpload_Category_ImageMutation, GqlUpload_Category_ImageMutationVariables>) {
        return Apollo.useMutation<GqlUpload_Category_ImageMutation, GqlUpload_Category_ImageMutationVariables>(Upload_Category_ImageDocument, baseOptions);
      }
export type Upload_Category_ImageMutationHookResult = ReturnType<typeof useUpload_Category_ImageMutation>;
export type Upload_Category_ImageMutationResult = Apollo.MutationResult<GqlUpload_Category_ImageMutation>;
export type Upload_Category_ImageMutationOptions = Apollo.BaseMutationOptions<GqlUpload_Category_ImageMutation, GqlUpload_Category_ImageMutationVariables>;
export const Product_Category_V2_By_IdDocument = gql`
    query product_category_v2_by_id($category_id: String!) {
  product_category_v2_by_id(category_id: $category_id) {
    category_id
    category_name
    image_url
    active
    parent_id
    ordering_window
    department_id
    department {
      department_name
      department_id
    }
    products {
      product_id
      product_name
    }
    total_regions
    regions {
      active
      category_region_id
      region_id
      region {
        region_id
        region_name
      }
    }
  }
}
    `;

/**
 * __useProduct_Category_V2_By_IdQuery__
 *
 * To run a query within a React component, call `useProduct_Category_V2_By_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProduct_Category_V2_By_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_Category_V2_By_IdQuery({
 *   variables: {
 *      category_id: // value for 'category_id'
 *   },
 * });
 */
export function useProduct_Category_V2_By_IdQuery(baseOptions: Apollo.QueryHookOptions<GqlProduct_Category_V2_By_IdQuery, GqlProduct_Category_V2_By_IdQueryVariables>) {
        return Apollo.useQuery<GqlProduct_Category_V2_By_IdQuery, GqlProduct_Category_V2_By_IdQueryVariables>(Product_Category_V2_By_IdDocument, baseOptions);
      }
export function useProduct_Category_V2_By_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_Category_V2_By_IdQuery, GqlProduct_Category_V2_By_IdQueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_Category_V2_By_IdQuery, GqlProduct_Category_V2_By_IdQueryVariables>(Product_Category_V2_By_IdDocument, baseOptions);
        }
export type Product_Category_V2_By_IdQueryHookResult = ReturnType<typeof useProduct_Category_V2_By_IdQuery>;
export type Product_Category_V2_By_IdLazyQueryHookResult = ReturnType<typeof useProduct_Category_V2_By_IdLazyQuery>;
export type Product_Category_V2_By_IdQueryResult = Apollo.QueryResult<GqlProduct_Category_V2_By_IdQuery, GqlProduct_Category_V2_By_IdQueryVariables>;
export const Add_Category_RegionDocument = gql`
    mutation add_category_region($category_id: String!, $region_id: String!) {
  add_category_region(data: {category_id: $category_id, region_id: $region_id}) {
    category_region {
      category_region_id
      category_id
      region_id
    }
    created
  }
}
    `;
export type GqlAdd_Category_RegionMutationFn = Apollo.MutationFunction<GqlAdd_Category_RegionMutation, GqlAdd_Category_RegionMutationVariables>;

/**
 * __useAdd_Category_RegionMutation__
 *
 * To run a mutation, you first call `useAdd_Category_RegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Category_RegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCategoryRegionMutation, { data, loading, error }] = useAdd_Category_RegionMutation({
 *   variables: {
 *      category_id: // value for 'category_id'
 *      region_id: // value for 'region_id'
 *   },
 * });
 */
export function useAdd_Category_RegionMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Category_RegionMutation, GqlAdd_Category_RegionMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Category_RegionMutation, GqlAdd_Category_RegionMutationVariables>(Add_Category_RegionDocument, baseOptions);
      }
export type Add_Category_RegionMutationHookResult = ReturnType<typeof useAdd_Category_RegionMutation>;
export type Add_Category_RegionMutationResult = Apollo.MutationResult<GqlAdd_Category_RegionMutation>;
export type Add_Category_RegionMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Category_RegionMutation, GqlAdd_Category_RegionMutationVariables>;
export const Activate_Category_RegionDocument = gql`
    mutation activate_category_region($data: CategoryRegionInput!, $category_region_id: String!) {
  update_category_region(category_region_id: $category_region_id, data: $data) {
    category_region {
      category_region_id
      category_id
      region_id
    }
  }
}
    `;
export type GqlActivate_Category_RegionMutationFn = Apollo.MutationFunction<GqlActivate_Category_RegionMutation, GqlActivate_Category_RegionMutationVariables>;

/**
 * __useActivate_Category_RegionMutation__
 *
 * To run a mutation, you first call `useActivate_Category_RegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivate_Category_RegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCategoryRegionMutation, { data, loading, error }] = useActivate_Category_RegionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      category_region_id: // value for 'category_region_id'
 *   },
 * });
 */
export function useActivate_Category_RegionMutation(baseOptions?: Apollo.MutationHookOptions<GqlActivate_Category_RegionMutation, GqlActivate_Category_RegionMutationVariables>) {
        return Apollo.useMutation<GqlActivate_Category_RegionMutation, GqlActivate_Category_RegionMutationVariables>(Activate_Category_RegionDocument, baseOptions);
      }
export type Activate_Category_RegionMutationHookResult = ReturnType<typeof useActivate_Category_RegionMutation>;
export type Activate_Category_RegionMutationResult = Apollo.MutationResult<GqlActivate_Category_RegionMutation>;
export type Activate_Category_RegionMutationOptions = Apollo.BaseMutationOptions<GqlActivate_Category_RegionMutation, GqlActivate_Category_RegionMutationVariables>;
export const ProductDepartmentsv2Document = gql`
    query ProductDepartmentsv2($filters: GenericScalar, $filter_string: String, $active: Boolean) {
  product_departments_v2(
    filters: $filters
    filter_string: $filter_string
    active: $active
  ) {
    department_id
    department_name
    description
    slug
    active
  }
}
    `;

/**
 * __useProductDepartmentsv2Query__
 *
 * To run a query within a React component, call `useProductDepartmentsv2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductDepartmentsv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDepartmentsv2Query({
 *   variables: {
 *      filters: // value for 'filters'
 *      filter_string: // value for 'filter_string'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useProductDepartmentsv2Query(baseOptions?: Apollo.QueryHookOptions<GqlProductDepartmentsv2Query, GqlProductDepartmentsv2QueryVariables>) {
        return Apollo.useQuery<GqlProductDepartmentsv2Query, GqlProductDepartmentsv2QueryVariables>(ProductDepartmentsv2Document, baseOptions);
      }
export function useProductDepartmentsv2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductDepartmentsv2Query, GqlProductDepartmentsv2QueryVariables>) {
          return Apollo.useLazyQuery<GqlProductDepartmentsv2Query, GqlProductDepartmentsv2QueryVariables>(ProductDepartmentsv2Document, baseOptions);
        }
export type ProductDepartmentsv2QueryHookResult = ReturnType<typeof useProductDepartmentsv2Query>;
export type ProductDepartmentsv2LazyQueryHookResult = ReturnType<typeof useProductDepartmentsv2LazyQuery>;
export type ProductDepartmentsv2QueryResult = Apollo.QueryResult<GqlProductDepartmentsv2Query, GqlProductDepartmentsv2QueryVariables>;
export const AddDepartmentDocument = gql`
    mutation addDepartment($department_name: String!, $description: String) {
  add_department(
    data: {department_name: $department_name, description: $description}
  ) {
    department {
      department_id
      department_name
    }
    created
  }
}
    `;
export type GqlAddDepartmentMutationFn = Apollo.MutationFunction<GqlAddDepartmentMutation, GqlAddDepartmentMutationVariables>;

/**
 * __useAddDepartmentMutation__
 *
 * To run a mutation, you first call `useAddDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDepartmentMutation, { data, loading, error }] = useAddDepartmentMutation({
 *   variables: {
 *      department_name: // value for 'department_name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddDepartmentMutation, GqlAddDepartmentMutationVariables>) {
        return Apollo.useMutation<GqlAddDepartmentMutation, GqlAddDepartmentMutationVariables>(AddDepartmentDocument, baseOptions);
      }
export type AddDepartmentMutationHookResult = ReturnType<typeof useAddDepartmentMutation>;
export type AddDepartmentMutationResult = Apollo.MutationResult<GqlAddDepartmentMutation>;
export type AddDepartmentMutationOptions = Apollo.BaseMutationOptions<GqlAddDepartmentMutation, GqlAddDepartmentMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation updateDepartment($department_id: String!, $data: DepartmentInput!) {
  update_department(department_id: $department_id, data: $data) {
    department {
      department_id
      department_name
      description
      slug
    }
  }
}
    `;
export type GqlUpdateDepartmentMutationFn = Apollo.MutationFunction<GqlUpdateDepartmentMutation, GqlUpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      department_id: // value for 'department_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDepartmentMutation, GqlUpdateDepartmentMutationVariables>) {
        return Apollo.useMutation<GqlUpdateDepartmentMutation, GqlUpdateDepartmentMutationVariables>(UpdateDepartmentDocument, baseOptions);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<GqlUpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDepartmentMutation, GqlUpdateDepartmentMutationVariables>;
export const Add_GeofencingDocument = gql`
    mutation add_geofencing($product_item_id: String!, $whitelisted_routes: [String], $blacklisted_routes: [String]) {
  update_product_item(
    product_item_id: $product_item_id
    data: {whitelisted_routes: $whitelisted_routes, blacklisted_routes: $blacklisted_routes}
  ) {
    product_item {
      product_item_id
      product_item_name
      whitelisted_routes
      blacklisted_routes
      active
    }
  }
}
    `;
export type GqlAdd_GeofencingMutationFn = Apollo.MutationFunction<GqlAdd_GeofencingMutation, GqlAdd_GeofencingMutationVariables>;

/**
 * __useAdd_GeofencingMutation__
 *
 * To run a mutation, you first call `useAdd_GeofencingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_GeofencingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGeofencingMutation, { data, loading, error }] = useAdd_GeofencingMutation({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *      whitelisted_routes: // value for 'whitelisted_routes'
 *      blacklisted_routes: // value for 'blacklisted_routes'
 *   },
 * });
 */
export function useAdd_GeofencingMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_GeofencingMutation, GqlAdd_GeofencingMutationVariables>) {
        return Apollo.useMutation<GqlAdd_GeofencingMutation, GqlAdd_GeofencingMutationVariables>(Add_GeofencingDocument, baseOptions);
      }
export type Add_GeofencingMutationHookResult = ReturnType<typeof useAdd_GeofencingMutation>;
export type Add_GeofencingMutationResult = Apollo.MutationResult<GqlAdd_GeofencingMutation>;
export type Add_GeofencingMutationOptions = Apollo.BaseMutationOptions<GqlAdd_GeofencingMutation, GqlAdd_GeofencingMutationVariables>;
export const Delete_GeofencingDocument = gql`
    mutation delete_geofencing($product_item_id: String!) {
  update_product_item(
    product_item_id: $product_item_id
    data: {whitelisted_routes: null, blacklisted_routes: null}
  ) {
    product_item {
      product_item_id
      product_item_name
      whitelisted_routes
      blacklisted_routes
    }
  }
}
    `;
export type GqlDelete_GeofencingMutationFn = Apollo.MutationFunction<GqlDelete_GeofencingMutation, GqlDelete_GeofencingMutationVariables>;

/**
 * __useDelete_GeofencingMutation__
 *
 * To run a mutation, you first call `useDelete_GeofencingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_GeofencingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeofencingMutation, { data, loading, error }] = useDelete_GeofencingMutation({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *   },
 * });
 */
export function useDelete_GeofencingMutation(baseOptions?: Apollo.MutationHookOptions<GqlDelete_GeofencingMutation, GqlDelete_GeofencingMutationVariables>) {
        return Apollo.useMutation<GqlDelete_GeofencingMutation, GqlDelete_GeofencingMutationVariables>(Delete_GeofencingDocument, baseOptions);
      }
export type Delete_GeofencingMutationHookResult = ReturnType<typeof useDelete_GeofencingMutation>;
export type Delete_GeofencingMutationResult = Apollo.MutationResult<GqlDelete_GeofencingMutation>;
export type Delete_GeofencingMutationOptions = Apollo.BaseMutationOptions<GqlDelete_GeofencingMutation, GqlDelete_GeofencingMutationVariables>;
export const Routes_V2Document = gql`
    query routes_v2($filters: GenericScalar, $search: String) {
  routes_v2(filters: $filters, search: $search) {
    edges {
      node {
        route_id
        route_name
        depot_id
        depot {
          depot_name
          area {
            area_id
            region_id
            region {
              region_name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRoutes_V2Query__
 *
 * To run a query within a React component, call `useRoutes_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useRoutes_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutes_V2Query({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRoutes_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlRoutes_V2Query, GqlRoutes_V2QueryVariables>) {
        return Apollo.useQuery<GqlRoutes_V2Query, GqlRoutes_V2QueryVariables>(Routes_V2Document, baseOptions);
      }
export function useRoutes_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRoutes_V2Query, GqlRoutes_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlRoutes_V2Query, GqlRoutes_V2QueryVariables>(Routes_V2Document, baseOptions);
        }
export type Routes_V2QueryHookResult = ReturnType<typeof useRoutes_V2Query>;
export type Routes_V2LazyQueryHookResult = ReturnType<typeof useRoutes_V2LazyQuery>;
export type Routes_V2QueryResult = Apollo.QueryResult<GqlRoutes_V2Query, GqlRoutes_V2QueryVariables>;
export const RouteV2ByIdDocument = gql`
    query RouteV2ById($route_id: String) {
  route_v2_by_id(route_id: $route_id) {
    route_id
    route_name
    depot_id
    depot {
      depot_name
      area {
        area_id
        region_id
        region {
          region_name
        }
      }
    }
  }
}
    `;

/**
 * __useRouteV2ByIdQuery__
 *
 * To run a query within a React component, call `useRouteV2ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteV2ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteV2ByIdQuery({
 *   variables: {
 *      route_id: // value for 'route_id'
 *   },
 * });
 */
export function useRouteV2ByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlRouteV2ByIdQuery, GqlRouteV2ByIdQueryVariables>) {
        return Apollo.useQuery<GqlRouteV2ByIdQuery, GqlRouteV2ByIdQueryVariables>(RouteV2ByIdDocument, baseOptions);
      }
export function useRouteV2ByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRouteV2ByIdQuery, GqlRouteV2ByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlRouteV2ByIdQuery, GqlRouteV2ByIdQueryVariables>(RouteV2ByIdDocument, baseOptions);
        }
export type RouteV2ByIdQueryHookResult = ReturnType<typeof useRouteV2ByIdQuery>;
export type RouteV2ByIdLazyQueryHookResult = ReturnType<typeof useRouteV2ByIdLazyQuery>;
export type RouteV2ByIdQueryResult = Apollo.QueryResult<GqlRouteV2ByIdQuery, GqlRouteV2ByIdQueryVariables>;
export const Packaging_Units_V2Document = gql`
    query packaging_units_v2 {
  packaging_units_v2 {
    edges {
      node {
        name
        active
        packaging_unit_id
        returnable
        weight
        active
      }
    }
  }
}
    `;

/**
 * __usePackaging_Units_V2Query__
 *
 * To run a query within a React component, call `usePackaging_Units_V2Query` and pass it any options that fit your needs.
 * When your component renders, `usePackaging_Units_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackaging_Units_V2Query({
 *   variables: {
 *   },
 * });
 */
export function usePackaging_Units_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlPackaging_Units_V2Query, GqlPackaging_Units_V2QueryVariables>) {
        return Apollo.useQuery<GqlPackaging_Units_V2Query, GqlPackaging_Units_V2QueryVariables>(Packaging_Units_V2Document, baseOptions);
      }
export function usePackaging_Units_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPackaging_Units_V2Query, GqlPackaging_Units_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlPackaging_Units_V2Query, GqlPackaging_Units_V2QueryVariables>(Packaging_Units_V2Document, baseOptions);
        }
export type Packaging_Units_V2QueryHookResult = ReturnType<typeof usePackaging_Units_V2Query>;
export type Packaging_Units_V2LazyQueryHookResult = ReturnType<typeof usePackaging_Units_V2LazyQuery>;
export type Packaging_Units_V2QueryResult = Apollo.QueryResult<GqlPackaging_Units_V2Query, GqlPackaging_Units_V2QueryVariables>;
export const Add_Packaging_UnitDocument = gql`
    mutation add_packaging_unit($name: String!, $weight: Float!, $returnable: Boolean) {
  add_packaging_unit(
    data: {name: $name, weight: $weight, returnable: $returnable}
  ) {
    packaging_unit {
      packaging_unit_id
      name
      created_by
      date_created
      date_updated
    }
    created
  }
}
    `;
export type GqlAdd_Packaging_UnitMutationFn = Apollo.MutationFunction<GqlAdd_Packaging_UnitMutation, GqlAdd_Packaging_UnitMutationVariables>;

/**
 * __useAdd_Packaging_UnitMutation__
 *
 * To run a mutation, you first call `useAdd_Packaging_UnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Packaging_UnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackagingUnitMutation, { data, loading, error }] = useAdd_Packaging_UnitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *      returnable: // value for 'returnable'
 *   },
 * });
 */
export function useAdd_Packaging_UnitMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Packaging_UnitMutation, GqlAdd_Packaging_UnitMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Packaging_UnitMutation, GqlAdd_Packaging_UnitMutationVariables>(Add_Packaging_UnitDocument, baseOptions);
      }
export type Add_Packaging_UnitMutationHookResult = ReturnType<typeof useAdd_Packaging_UnitMutation>;
export type Add_Packaging_UnitMutationResult = Apollo.MutationResult<GqlAdd_Packaging_UnitMutation>;
export type Add_Packaging_UnitMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Packaging_UnitMutation, GqlAdd_Packaging_UnitMutationVariables>;
export const Update_Packaging_UnitDocument = gql`
    mutation update_packaging_unit($data: PackagingUnitInput!, $packaging_unit_id: String!) {
  update_packaging_unit(data: $data, packaging_unit_id: $packaging_unit_id) {
    packaging_unit {
      packaging_unit_id
      returnable
      active
      name
      weight
    }
  }
}
    `;
export type GqlUpdate_Packaging_UnitMutationFn = Apollo.MutationFunction<GqlUpdate_Packaging_UnitMutation, GqlUpdate_Packaging_UnitMutationVariables>;

/**
 * __useUpdate_Packaging_UnitMutation__
 *
 * To run a mutation, you first call `useUpdate_Packaging_UnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Packaging_UnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackagingUnitMutation, { data, loading, error }] = useUpdate_Packaging_UnitMutation({
 *   variables: {
 *      data: // value for 'data'
 *      packaging_unit_id: // value for 'packaging_unit_id'
 *   },
 * });
 */
export function useUpdate_Packaging_UnitMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_Packaging_UnitMutation, GqlUpdate_Packaging_UnitMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_Packaging_UnitMutation, GqlUpdate_Packaging_UnitMutationVariables>(Update_Packaging_UnitDocument, baseOptions);
      }
export type Update_Packaging_UnitMutationHookResult = ReturnType<typeof useUpdate_Packaging_UnitMutation>;
export type Update_Packaging_UnitMutationResult = Apollo.MutationResult<GqlUpdate_Packaging_UnitMutation>;
export type Update_Packaging_UnitMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_Packaging_UnitMutation, GqlUpdate_Packaging_UnitMutationVariables>;
export const Add_Product_ItemDocument = gql`
    mutation add_product_item($data: ProductItemInput!) {
  add_product_item(data: $data) {
    created
    product_item {
      product_item_id
      units_of_measure {
        uom_id
        business_domain_id
      }
      regions {
        business_domain_id
        region_id
      }
    }
  }
}
    `;
export type GqlAdd_Product_ItemMutationFn = Apollo.MutationFunction<GqlAdd_Product_ItemMutation, GqlAdd_Product_ItemMutationVariables>;

/**
 * __useAdd_Product_ItemMutation__
 *
 * To run a mutation, you first call `useAdd_Product_ItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Product_ItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductItemMutation, { data, loading, error }] = useAdd_Product_ItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdd_Product_ItemMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Product_ItemMutation, GqlAdd_Product_ItemMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Product_ItemMutation, GqlAdd_Product_ItemMutationVariables>(Add_Product_ItemDocument, baseOptions);
      }
export type Add_Product_ItemMutationHookResult = ReturnType<typeof useAdd_Product_ItemMutation>;
export type Add_Product_ItemMutationResult = Apollo.MutationResult<GqlAdd_Product_ItemMutation>;
export type Add_Product_ItemMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Product_ItemMutation, GqlAdd_Product_ItemMutationVariables>;
export const Add_Product_Item_ImageDocument = gql`
    mutation add_product_item_image($image: Upload!, $product_item_id: String!) {
  add_product_item_image(product_item_id: $product_item_id, image: $image) {
    uploaded
    product_item {
      product_item_id
      product_item_name
    }
  }
}
    `;
export type GqlAdd_Product_Item_ImageMutationFn = Apollo.MutationFunction<GqlAdd_Product_Item_ImageMutation, GqlAdd_Product_Item_ImageMutationVariables>;

/**
 * __useAdd_Product_Item_ImageMutation__
 *
 * To run a mutation, you first call `useAdd_Product_Item_ImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Product_Item_ImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductItemImageMutation, { data, loading, error }] = useAdd_Product_Item_ImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      product_item_id: // value for 'product_item_id'
 *   },
 * });
 */
export function useAdd_Product_Item_ImageMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Product_Item_ImageMutation, GqlAdd_Product_Item_ImageMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Product_Item_ImageMutation, GqlAdd_Product_Item_ImageMutationVariables>(Add_Product_Item_ImageDocument, baseOptions);
      }
export type Add_Product_Item_ImageMutationHookResult = ReturnType<typeof useAdd_Product_Item_ImageMutation>;
export type Add_Product_Item_ImageMutationResult = Apollo.MutationResult<GqlAdd_Product_Item_ImageMutation>;
export type Add_Product_Item_ImageMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Product_Item_ImageMutation, GqlAdd_Product_Item_ImageMutationVariables>;
export const Product_Item_SegmentsDocument = gql`
    query product_item_segments {
  product_item_segments_v2 {
    segment_name
    product_item_segment_id
  }
}
    `;

/**
 * __useProduct_Item_SegmentsQuery__
 *
 * To run a query within a React component, call `useProduct_Item_SegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProduct_Item_SegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_Item_SegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProduct_Item_SegmentsQuery(baseOptions?: Apollo.QueryHookOptions<GqlProduct_Item_SegmentsQuery, GqlProduct_Item_SegmentsQueryVariables>) {
        return Apollo.useQuery<GqlProduct_Item_SegmentsQuery, GqlProduct_Item_SegmentsQueryVariables>(Product_Item_SegmentsDocument, baseOptions);
      }
export function useProduct_Item_SegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_Item_SegmentsQuery, GqlProduct_Item_SegmentsQueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_Item_SegmentsQuery, GqlProduct_Item_SegmentsQueryVariables>(Product_Item_SegmentsDocument, baseOptions);
        }
export type Product_Item_SegmentsQueryHookResult = ReturnType<typeof useProduct_Item_SegmentsQuery>;
export type Product_Item_SegmentsLazyQueryHookResult = ReturnType<typeof useProduct_Item_SegmentsLazyQuery>;
export type Product_Item_SegmentsQueryResult = Apollo.QueryResult<GqlProduct_Item_SegmentsQuery, GqlProduct_Item_SegmentsQueryVariables>;
export const Product_Item_V2_By_IdDocument = gql`
    query product_item_v2_by_id($product_item_id: String!, $filters: GenericScalar) {
  product_item_v2_by_id(product_item_id: $product_item_id, filters: $filters) {
    product_item_id
    product_item_name
    active
    image_url
    base_price
    total_regions
    packed_weight
    packed_volume
    description
    base_price
    wms_default_available
    wms_std_pallet_quantity
    wms_pickface_putaway
    product_id
    product {
      product_name
    }
    product_item_segment_id
    product_item_segment {
      segment_name
    }
    units_of_measure {
      business_domain_id
      business_domain {
        domain_name
      }
      active
      conversion_ratio
      product_item_uom_id
      product_item_id
      uom_id
      uom {
        name
        uom_id
      }
    }
    regions {
      region_id
      region {
        region_id
        region_name
      }
      product_item_region_id
      business_domain_id
      business_domain {
        domain_name
      }
      active
    }
  }
}
    `;

/**
 * __useProduct_Item_V2_By_IdQuery__
 *
 * To run a query within a React component, call `useProduct_Item_V2_By_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProduct_Item_V2_By_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProduct_Item_V2_By_IdQuery({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProduct_Item_V2_By_IdQuery(baseOptions: Apollo.QueryHookOptions<GqlProduct_Item_V2_By_IdQuery, GqlProduct_Item_V2_By_IdQueryVariables>) {
        return Apollo.useQuery<GqlProduct_Item_V2_By_IdQuery, GqlProduct_Item_V2_By_IdQueryVariables>(Product_Item_V2_By_IdDocument, baseOptions);
      }
export function useProduct_Item_V2_By_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProduct_Item_V2_By_IdQuery, GqlProduct_Item_V2_By_IdQueryVariables>) {
          return Apollo.useLazyQuery<GqlProduct_Item_V2_By_IdQuery, GqlProduct_Item_V2_By_IdQueryVariables>(Product_Item_V2_By_IdDocument, baseOptions);
        }
export type Product_Item_V2_By_IdQueryHookResult = ReturnType<typeof useProduct_Item_V2_By_IdQuery>;
export type Product_Item_V2_By_IdLazyQueryHookResult = ReturnType<typeof useProduct_Item_V2_By_IdLazyQuery>;
export type Product_Item_V2_By_IdQueryResult = Apollo.QueryResult<GqlProduct_Item_V2_By_IdQuery, GqlProduct_Item_V2_By_IdQueryVariables>;
export const Add_Product_Item_UomDocument = gql`
    mutation add_product_item_uom($data: ProductItemUomInput!) {
  add_product_item_uom(data: $data) {
    product_item_uom {
      product_item_uom_id
      product_item_id
      business_domain_id
      conversion_ratio
    }
  }
}
    `;
export type GqlAdd_Product_Item_UomMutationFn = Apollo.MutationFunction<GqlAdd_Product_Item_UomMutation, GqlAdd_Product_Item_UomMutationVariables>;

/**
 * __useAdd_Product_Item_UomMutation__
 *
 * To run a mutation, you first call `useAdd_Product_Item_UomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Product_Item_UomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductItemUomMutation, { data, loading, error }] = useAdd_Product_Item_UomMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdd_Product_Item_UomMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Product_Item_UomMutation, GqlAdd_Product_Item_UomMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Product_Item_UomMutation, GqlAdd_Product_Item_UomMutationVariables>(Add_Product_Item_UomDocument, baseOptions);
      }
export type Add_Product_Item_UomMutationHookResult = ReturnType<typeof useAdd_Product_Item_UomMutation>;
export type Add_Product_Item_UomMutationResult = Apollo.MutationResult<GqlAdd_Product_Item_UomMutation>;
export type Add_Product_Item_UomMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Product_Item_UomMutation, GqlAdd_Product_Item_UomMutationVariables>;
export const Update_Product_Item_UomDocument = gql`
    mutation update_product_item_uom($product_item_uom_id: String!, $uom_id: String!, $product_item_id: String!, $business_domain_id: String!, $data: ProductItemUomInput!) {
  update_product_item_uom(
    product_item_uom_id: $product_item_uom_id
    product_item_id: $product_item_id
    uom_id: $uom_id
    business_domain_id: $business_domain_id
    data: $data
  ) {
    product_item_uom {
      product_item_uom_id
      active
    }
  }
}
    `;
export type GqlUpdate_Product_Item_UomMutationFn = Apollo.MutationFunction<GqlUpdate_Product_Item_UomMutation, GqlUpdate_Product_Item_UomMutationVariables>;

/**
 * __useUpdate_Product_Item_UomMutation__
 *
 * To run a mutation, you first call `useUpdate_Product_Item_UomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Product_Item_UomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductItemUomMutation, { data, loading, error }] = useUpdate_Product_Item_UomMutation({
 *   variables: {
 *      product_item_uom_id: // value for 'product_item_uom_id'
 *      uom_id: // value for 'uom_id'
 *      product_item_id: // value for 'product_item_id'
 *      business_domain_id: // value for 'business_domain_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_Product_Item_UomMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_Product_Item_UomMutation, GqlUpdate_Product_Item_UomMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_Product_Item_UomMutation, GqlUpdate_Product_Item_UomMutationVariables>(Update_Product_Item_UomDocument, baseOptions);
      }
export type Update_Product_Item_UomMutationHookResult = ReturnType<typeof useUpdate_Product_Item_UomMutation>;
export type Update_Product_Item_UomMutationResult = Apollo.MutationResult<GqlUpdate_Product_Item_UomMutation>;
export type Update_Product_Item_UomMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_Product_Item_UomMutation, GqlUpdate_Product_Item_UomMutationVariables>;
export const Add_Product_Item_RegionDocument = gql`
    mutation add_product_item_region($data: ProductItemRegionInput!) {
  add_product_item_region(data: $data) {
    created
    product_item_region {
      region_id
      product_item_id
      business_domain_id
    }
  }
}
    `;
export type GqlAdd_Product_Item_RegionMutationFn = Apollo.MutationFunction<GqlAdd_Product_Item_RegionMutation, GqlAdd_Product_Item_RegionMutationVariables>;

/**
 * __useAdd_Product_Item_RegionMutation__
 *
 * To run a mutation, you first call `useAdd_Product_Item_RegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Product_Item_RegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductItemRegionMutation, { data, loading, error }] = useAdd_Product_Item_RegionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdd_Product_Item_RegionMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_Product_Item_RegionMutation, GqlAdd_Product_Item_RegionMutationVariables>) {
        return Apollo.useMutation<GqlAdd_Product_Item_RegionMutation, GqlAdd_Product_Item_RegionMutationVariables>(Add_Product_Item_RegionDocument, baseOptions);
      }
export type Add_Product_Item_RegionMutationHookResult = ReturnType<typeof useAdd_Product_Item_RegionMutation>;
export type Add_Product_Item_RegionMutationResult = Apollo.MutationResult<GqlAdd_Product_Item_RegionMutation>;
export type Add_Product_Item_RegionMutationOptions = Apollo.BaseMutationOptions<GqlAdd_Product_Item_RegionMutation, GqlAdd_Product_Item_RegionMutationVariables>;
export const Activate_Product_Item_RegionDocument = gql`
    mutation activate_product_item_region($active: Boolean!, $product_item_region_id: String!) {
  update_product_item_region(
    data: {active: $active}
    product_item_region_id: $product_item_region_id
  ) {
    product_item_region {
      product_item_id
      active
    }
  }
}
    `;
export type GqlActivate_Product_Item_RegionMutationFn = Apollo.MutationFunction<GqlActivate_Product_Item_RegionMutation, GqlActivate_Product_Item_RegionMutationVariables>;

/**
 * __useActivate_Product_Item_RegionMutation__
 *
 * To run a mutation, you first call `useActivate_Product_Item_RegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivate_Product_Item_RegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProductItemRegionMutation, { data, loading, error }] = useActivate_Product_Item_RegionMutation({
 *   variables: {
 *      active: // value for 'active'
 *      product_item_region_id: // value for 'product_item_region_id'
 *   },
 * });
 */
export function useActivate_Product_Item_RegionMutation(baseOptions?: Apollo.MutationHookOptions<GqlActivate_Product_Item_RegionMutation, GqlActivate_Product_Item_RegionMutationVariables>) {
        return Apollo.useMutation<GqlActivate_Product_Item_RegionMutation, GqlActivate_Product_Item_RegionMutationVariables>(Activate_Product_Item_RegionDocument, baseOptions);
      }
export type Activate_Product_Item_RegionMutationHookResult = ReturnType<typeof useActivate_Product_Item_RegionMutation>;
export type Activate_Product_Item_RegionMutationResult = Apollo.MutationResult<GqlActivate_Product_Item_RegionMutation>;
export type Activate_Product_Item_RegionMutationOptions = Apollo.BaseMutationOptions<GqlActivate_Product_Item_RegionMutation, GqlActivate_Product_Item_RegionMutationVariables>;
export const Business_Domains_V2Document = gql`
    query business_domains_v2 {
  business_domains_v2 {
    business_domain_id
    domain_name
  }
}
    `;

/**
 * __useBusiness_Domains_V2Query__
 *
 * To run a query within a React component, call `useBusiness_Domains_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useBusiness_Domains_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusiness_Domains_V2Query({
 *   variables: {
 *   },
 * });
 */
export function useBusiness_Domains_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlBusiness_Domains_V2Query, GqlBusiness_Domains_V2QueryVariables>) {
        return Apollo.useQuery<GqlBusiness_Domains_V2Query, GqlBusiness_Domains_V2QueryVariables>(Business_Domains_V2Document, baseOptions);
      }
export function useBusiness_Domains_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBusiness_Domains_V2Query, GqlBusiness_Domains_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlBusiness_Domains_V2Query, GqlBusiness_Domains_V2QueryVariables>(Business_Domains_V2Document, baseOptions);
        }
export type Business_Domains_V2QueryHookResult = ReturnType<typeof useBusiness_Domains_V2Query>;
export type Business_Domains_V2LazyQueryHookResult = ReturnType<typeof useBusiness_Domains_V2LazyQuery>;
export type Business_Domains_V2QueryResult = Apollo.QueryResult<GqlBusiness_Domains_V2Query, GqlBusiness_Domains_V2QueryVariables>;
export const Paginated_Product_ItemsDocument = gql`
    query paginated_product_items($filters: GenericScalar, $page: Int, $per_page: Int) {
  paginated_product_items_v2(filters: $filters, page: $page, per_page: $per_page) {
    page_info {
      total_pages
      total_count
      current_page
      per_page
      has_previous
      has_next
    }
    edges {
      node {
        active
        product_item_id
        product_item_name
        active
        product_id
        product {
          product_name
        }
        image_url
        staff_only
        packed_weight
        packed_volume
        featured
        product_item_segment_id
        product_item_segment {
          segment_name
        }
        blacklisted_routes
        blacklisted {
          route_id
          route {
            route_id
            route_name
            depot_id
            depot {
              depot_name
              area {
                area_id
                region_id
                region {
                  region_name
                }
              }
            }
          }
        }
        whitelisted_routes
        whitelisted {
          route_id
          route {
            route_id
            route_name
            depot_id
            depot {
              depot_name
              area {
                area_id
                region_id
                region {
                  region_name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaginated_Product_ItemsQuery__
 *
 * To run a query within a React component, call `usePaginated_Product_ItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginated_Product_ItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginated_Product_ItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function usePaginated_Product_ItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlPaginated_Product_ItemsQuery, GqlPaginated_Product_ItemsQueryVariables>) {
        return Apollo.useQuery<GqlPaginated_Product_ItemsQuery, GqlPaginated_Product_ItemsQueryVariables>(Paginated_Product_ItemsDocument, baseOptions);
      }
export function usePaginated_Product_ItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPaginated_Product_ItemsQuery, GqlPaginated_Product_ItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlPaginated_Product_ItemsQuery, GqlPaginated_Product_ItemsQueryVariables>(Paginated_Product_ItemsDocument, baseOptions);
        }
export type Paginated_Product_ItemsQueryHookResult = ReturnType<typeof usePaginated_Product_ItemsQuery>;
export type Paginated_Product_ItemsLazyQueryHookResult = ReturnType<typeof usePaginated_Product_ItemsLazyQuery>;
export type Paginated_Product_ItemsQueryResult = Apollo.QueryResult<GqlPaginated_Product_ItemsQuery, GqlPaginated_Product_ItemsQueryVariables>;
export const Update_Product_ItemDocument = gql`
    mutation update_product_item($product_item_id: String!, $data: ProductItemInput!) {
  update_product_item(product_item_id: $product_item_id, data: $data) {
    product_item {
      product_item_id
      active
    }
  }
}
    `;
export type GqlUpdate_Product_ItemMutationFn = Apollo.MutationFunction<GqlUpdate_Product_ItemMutation, GqlUpdate_Product_ItemMutationVariables>;

/**
 * __useUpdate_Product_ItemMutation__
 *
 * To run a mutation, you first call `useUpdate_Product_ItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Product_ItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductItemMutation, { data, loading, error }] = useUpdate_Product_ItemMutation({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_Product_ItemMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_Product_ItemMutation, GqlUpdate_Product_ItemMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_Product_ItemMutation, GqlUpdate_Product_ItemMutationVariables>(Update_Product_ItemDocument, baseOptions);
      }
export type Update_Product_ItemMutationHookResult = ReturnType<typeof useUpdate_Product_ItemMutation>;
export type Update_Product_ItemMutationResult = Apollo.MutationResult<GqlUpdate_Product_ItemMutation>;
export type Update_Product_ItemMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_Product_ItemMutation, GqlUpdate_Product_ItemMutationVariables>;
export const PaginatedProductsV2Document = gql`
    query paginatedProductsV2($per_page: Int, $page: Int, $active: Boolean, $search: String, $filters: GenericScalar) {
  paginated_products_v2(
    per_page: $per_page
    page: $page
    active: $active
    search: $search
    filters: $filters
  ) {
    page_info {
      per_page
      total_count
      total_pages
      has_next
      has_previous
    }
    edges {
      node {
        active
        product_id
        product_name
        product_code
        hs_code
        kra_code
        vatable
        product_type
        image_url
        date_created
        category {
          category_name
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedProductsV2Query__
 *
 * To run a query within a React component, call `usePaginatedProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProductsV2Query({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePaginatedProductsV2Query(baseOptions?: Apollo.QueryHookOptions<GqlPaginatedProductsV2Query, GqlPaginatedProductsV2QueryVariables>) {
        return Apollo.useQuery<GqlPaginatedProductsV2Query, GqlPaginatedProductsV2QueryVariables>(PaginatedProductsV2Document, baseOptions);
      }
export function usePaginatedProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPaginatedProductsV2Query, GqlPaginatedProductsV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlPaginatedProductsV2Query, GqlPaginatedProductsV2QueryVariables>(PaginatedProductsV2Document, baseOptions);
        }
export type PaginatedProductsV2QueryHookResult = ReturnType<typeof usePaginatedProductsV2Query>;
export type PaginatedProductsV2LazyQueryHookResult = ReturnType<typeof usePaginatedProductsV2LazyQuery>;
export type PaginatedProductsV2QueryResult = Apollo.QueryResult<GqlPaginatedProductsV2Query, GqlPaginatedProductsV2QueryVariables>;
export const AddProductDocument = gql`
    mutation addProduct($data: ProductInput!) {
  add_product(data: $data) {
    created
    product {
      product_id
      product_code
      category_id
      wms_shelf_life_days
      hs_code
      kra_code
      product_tags {
        product_tag
        product_tag_id
        product_id
      }
      category {
        category_name
      }
      categories {
        category_name
      }
    }
  }
}
    `;
export type GqlAddProductMutationFn = Apollo.MutationFunction<GqlAddProductMutation, GqlAddProductMutationVariables>;

/**
 * __useAddProductMutation__
 *
 * To run a mutation, you first call `useAddProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductMutation, { data, loading, error }] = useAddProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddProductMutation, GqlAddProductMutationVariables>) {
        return Apollo.useMutation<GqlAddProductMutation, GqlAddProductMutationVariables>(AddProductDocument, baseOptions);
      }
export type AddProductMutationHookResult = ReturnType<typeof useAddProductMutation>;
export type AddProductMutationResult = Apollo.MutationResult<GqlAddProductMutation>;
export type AddProductMutationOptions = Apollo.BaseMutationOptions<GqlAddProductMutation, GqlAddProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($product_id: String!, $data: ProductInput!) {
  update_product(data: $data, product_id: $product_id) {
    product {
      product_id
      active
      product_code
      product_type
      category_id
      vatable
      wms_shelf_life_days
      hs_code
      kra_code
      categories {
        category_id
        category_name
      }
      active
    }
  }
}
    `;
export type GqlUpdateProductMutationFn = Apollo.MutationFunction<GqlUpdateProductMutation, GqlUpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      product_id: // value for 'product_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateProductMutation, GqlUpdateProductMutationVariables>) {
        return Apollo.useMutation<GqlUpdateProductMutation, GqlUpdateProductMutationVariables>(UpdateProductDocument, baseOptions);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<GqlUpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<GqlUpdateProductMutation, GqlUpdateProductMutationVariables>;
export const ProductByIdV2Document = gql`
    query productByIdV2($product_id: String!) {
  product_v2_by_id(product_id: $product_id) {
    product_id
    active
    product_type
    product_name
    product_code
    product_description
    vatable
    image_url
    date_created
    wms_shelf_life_days
    hs_code
    kra_code
    category_id
    category {
      category_id
      category_name
    }
    categories {
      active
      category_id
      category_name
    }
    product_tags {
      product_tag
      product_tag_id
      product_id
    }
    domain_activations {
      product_domain_activation_id
      active
      business_domain {
        domain_name
        business_domain_id
      }
    }
    packaging_units {
      name
      active
      packaging_unit_id
    }
  }
}
    `;

/**
 * __useProductByIdV2Query__
 *
 * To run a query within a React component, call `useProductByIdV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdV2Query({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useProductByIdV2Query(baseOptions: Apollo.QueryHookOptions<GqlProductByIdV2Query, GqlProductByIdV2QueryVariables>) {
        return Apollo.useQuery<GqlProductByIdV2Query, GqlProductByIdV2QueryVariables>(ProductByIdV2Document, baseOptions);
      }
export function useProductByIdV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductByIdV2Query, GqlProductByIdV2QueryVariables>) {
          return Apollo.useLazyQuery<GqlProductByIdV2Query, GqlProductByIdV2QueryVariables>(ProductByIdV2Document, baseOptions);
        }
export type ProductByIdV2QueryHookResult = ReturnType<typeof useProductByIdV2Query>;
export type ProductByIdV2LazyQueryHookResult = ReturnType<typeof useProductByIdV2LazyQuery>;
export type ProductByIdV2QueryResult = Apollo.QueryResult<GqlProductByIdV2Query, GqlProductByIdV2QueryVariables>;
export const LossReasonsDocument = gql`
    query lossReasons {
  loss_reasons {
    active
    loss_reason
    loss_reason_id
  }
}
    `;

/**
 * __useLossReasonsQuery__
 *
 * To run a query within a React component, call `useLossReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLossReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLossReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLossReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GqlLossReasonsQuery, GqlLossReasonsQueryVariables>) {
        return Apollo.useQuery<GqlLossReasonsQuery, GqlLossReasonsQueryVariables>(LossReasonsDocument, baseOptions);
      }
export function useLossReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlLossReasonsQuery, GqlLossReasonsQueryVariables>) {
          return Apollo.useLazyQuery<GqlLossReasonsQuery, GqlLossReasonsQueryVariables>(LossReasonsDocument, baseOptions);
        }
export type LossReasonsQueryHookResult = ReturnType<typeof useLossReasonsQuery>;
export type LossReasonsLazyQueryHookResult = ReturnType<typeof useLossReasonsLazyQuery>;
export type LossReasonsQueryResult = Apollo.QueryResult<GqlLossReasonsQuery, GqlLossReasonsQueryVariables>;
export const ProductLossReasonsDocument = gql`
    query productLossReasons($filter: GenericScalar) {
  product_loss_reasons(filter: $filter) {
    edges {
      node {
        product_loss_reason_id
        loss_reason_id
        loss_reason {
          loss_reason
        }
        active
      }
    }
  }
}
    `;

/**
 * __useProductLossReasonsQuery__
 *
 * To run a query within a React component, call `useProductLossReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLossReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLossReasonsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductLossReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductLossReasonsQuery, GqlProductLossReasonsQueryVariables>) {
        return Apollo.useQuery<GqlProductLossReasonsQuery, GqlProductLossReasonsQueryVariables>(ProductLossReasonsDocument, baseOptions);
      }
export function useProductLossReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductLossReasonsQuery, GqlProductLossReasonsQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductLossReasonsQuery, GqlProductLossReasonsQueryVariables>(ProductLossReasonsDocument, baseOptions);
        }
export type ProductLossReasonsQueryHookResult = ReturnType<typeof useProductLossReasonsQuery>;
export type ProductLossReasonsLazyQueryHookResult = ReturnType<typeof useProductLossReasonsLazyQuery>;
export type ProductLossReasonsQueryResult = Apollo.QueryResult<GqlProductLossReasonsQuery, GqlProductLossReasonsQueryVariables>;
export const AddProductDomainActivationDocument = gql`
    mutation addProductDomainActivation($data: ProductDomainActivationInput!) {
  add_product_domain_activation(data: $data) {
    created
  }
}
    `;
export type GqlAddProductDomainActivationMutationFn = Apollo.MutationFunction<GqlAddProductDomainActivationMutation, GqlAddProductDomainActivationMutationVariables>;

/**
 * __useAddProductDomainActivationMutation__
 *
 * To run a mutation, you first call `useAddProductDomainActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductDomainActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductDomainActivationMutation, { data, loading, error }] = useAddProductDomainActivationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddProductDomainActivationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddProductDomainActivationMutation, GqlAddProductDomainActivationMutationVariables>) {
        return Apollo.useMutation<GqlAddProductDomainActivationMutation, GqlAddProductDomainActivationMutationVariables>(AddProductDomainActivationDocument, baseOptions);
      }
export type AddProductDomainActivationMutationHookResult = ReturnType<typeof useAddProductDomainActivationMutation>;
export type AddProductDomainActivationMutationResult = Apollo.MutationResult<GqlAddProductDomainActivationMutation>;
export type AddProductDomainActivationMutationOptions = Apollo.BaseMutationOptions<GqlAddProductDomainActivationMutation, GqlAddProductDomainActivationMutationVariables>;
export const UpdateProductDomainActivationDocument = gql`
    mutation updateProductDomainActivation($product_domain_activation_id: String!, $data: ProductDomainActivationInput!) {
  update_product_domain_activation(
    data: $data
    product_domain_activation_id: $product_domain_activation_id
  ) {
    product_domain_activation {
      product_id
      business_domain_id
      active
    }
  }
}
    `;
export type GqlUpdateProductDomainActivationMutationFn = Apollo.MutationFunction<GqlUpdateProductDomainActivationMutation, GqlUpdateProductDomainActivationMutationVariables>;

/**
 * __useUpdateProductDomainActivationMutation__
 *
 * To run a mutation, you first call `useUpdateProductDomainActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductDomainActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductDomainActivationMutation, { data, loading, error }] = useUpdateProductDomainActivationMutation({
 *   variables: {
 *      product_domain_activation_id: // value for 'product_domain_activation_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductDomainActivationMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateProductDomainActivationMutation, GqlUpdateProductDomainActivationMutationVariables>) {
        return Apollo.useMutation<GqlUpdateProductDomainActivationMutation, GqlUpdateProductDomainActivationMutationVariables>(UpdateProductDomainActivationDocument, baseOptions);
      }
export type UpdateProductDomainActivationMutationHookResult = ReturnType<typeof useUpdateProductDomainActivationMutation>;
export type UpdateProductDomainActivationMutationResult = Apollo.MutationResult<GqlUpdateProductDomainActivationMutation>;
export type UpdateProductDomainActivationMutationOptions = Apollo.BaseMutationOptions<GqlUpdateProductDomainActivationMutation, GqlUpdateProductDomainActivationMutationVariables>;
export const UploadProductImageDocument = gql`
    mutation uploadProductImage($image: Upload!, $product_id: String!) {
  add_product_image(product_id: $product_id, image: $image) {
    uploaded
    product {
      product_id
      image_url
    }
  }
}
    `;
export type GqlUploadProductImageMutationFn = Apollo.MutationFunction<GqlUploadProductImageMutation, GqlUploadProductImageMutationVariables>;

/**
 * __useUploadProductImageMutation__
 *
 * To run a mutation, you first call `useUploadProductImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProductImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProductImageMutation, { data, loading, error }] = useUploadProductImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useUploadProductImageMutation(baseOptions?: Apollo.MutationHookOptions<GqlUploadProductImageMutation, GqlUploadProductImageMutationVariables>) {
        return Apollo.useMutation<GqlUploadProductImageMutation, GqlUploadProductImageMutationVariables>(UploadProductImageDocument, baseOptions);
      }
export type UploadProductImageMutationHookResult = ReturnType<typeof useUploadProductImageMutation>;
export type UploadProductImageMutationResult = Apollo.MutationResult<GqlUploadProductImageMutation>;
export type UploadProductImageMutationOptions = Apollo.BaseMutationOptions<GqlUploadProductImageMutation, GqlUploadProductImageMutationVariables>;
export const AddProductTagDocument = gql`
    mutation addProductTag($data: ProductTagInput!) {
  add_product_tag(data: $data) {
    created
    product_tag {
      product_tag
      product {
        product_name
      }
    }
  }
}
    `;
export type GqlAddProductTagMutationFn = Apollo.MutationFunction<GqlAddProductTagMutation, GqlAddProductTagMutationVariables>;

/**
 * __useAddProductTagMutation__
 *
 * To run a mutation, you first call `useAddProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductTagMutation, { data, loading, error }] = useAddProductTagMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddProductTagMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddProductTagMutation, GqlAddProductTagMutationVariables>) {
        return Apollo.useMutation<GqlAddProductTagMutation, GqlAddProductTagMutationVariables>(AddProductTagDocument, baseOptions);
      }
export type AddProductTagMutationHookResult = ReturnType<typeof useAddProductTagMutation>;
export type AddProductTagMutationResult = Apollo.MutationResult<GqlAddProductTagMutation>;
export type AddProductTagMutationOptions = Apollo.BaseMutationOptions<GqlAddProductTagMutation, GqlAddProductTagMutationVariables>;
export const DeleteProductTagDocument = gql`
    mutation deleteProductTag($product_tag_id: String!) {
  delete_product_tag(product_tag_id: $product_tag_id) {
    deleted
  }
}
    `;
export type GqlDeleteProductTagMutationFn = Apollo.MutationFunction<GqlDeleteProductTagMutation, GqlDeleteProductTagMutationVariables>;

/**
 * __useDeleteProductTagMutation__
 *
 * To run a mutation, you first call `useDeleteProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTagMutation, { data, loading, error }] = useDeleteProductTagMutation({
 *   variables: {
 *      product_tag_id: // value for 'product_tag_id'
 *   },
 * });
 */
export function useDeleteProductTagMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteProductTagMutation, GqlDeleteProductTagMutationVariables>) {
        return Apollo.useMutation<GqlDeleteProductTagMutation, GqlDeleteProductTagMutationVariables>(DeleteProductTagDocument, baseOptions);
      }
export type DeleteProductTagMutationHookResult = ReturnType<typeof useDeleteProductTagMutation>;
export type DeleteProductTagMutationResult = Apollo.MutationResult<GqlDeleteProductTagMutation>;
export type DeleteProductTagMutationOptions = Apollo.BaseMutationOptions<GqlDeleteProductTagMutation, GqlDeleteProductTagMutationVariables>;
export const AddProductBundleDocument = gql`
    mutation addProductBundle($data: [BundleAssociationInput]) {
  add_bundle_association(data: $data) {
    created
  }
}
    `;
export type GqlAddProductBundleMutationFn = Apollo.MutationFunction<GqlAddProductBundleMutation, GqlAddProductBundleMutationVariables>;

/**
 * __useAddProductBundleMutation__
 *
 * To run a mutation, you first call `useAddProductBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductBundleMutation, { data, loading, error }] = useAddProductBundleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddProductBundleMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddProductBundleMutation, GqlAddProductBundleMutationVariables>) {
        return Apollo.useMutation<GqlAddProductBundleMutation, GqlAddProductBundleMutationVariables>(AddProductBundleDocument, baseOptions);
      }
export type AddProductBundleMutationHookResult = ReturnType<typeof useAddProductBundleMutation>;
export type AddProductBundleMutationResult = Apollo.MutationResult<GqlAddProductBundleMutation>;
export type AddProductBundleMutationOptions = Apollo.BaseMutationOptions<GqlAddProductBundleMutation, GqlAddProductBundleMutationVariables>;
export const DeleteBundleAssociationDocument = gql`
    mutation deleteBundleAssociation($association_id: String, $client_stamp: String) {
  delete_bundle_association(
    association_id: $association_id
    client_stamp: $client_stamp
  ) {
    deleted
  }
}
    `;
export type GqlDeleteBundleAssociationMutationFn = Apollo.MutationFunction<GqlDeleteBundleAssociationMutation, GqlDeleteBundleAssociationMutationVariables>;

/**
 * __useDeleteBundleAssociationMutation__
 *
 * To run a mutation, you first call `useDeleteBundleAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBundleAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBundleAssociationMutation, { data, loading, error }] = useDeleteBundleAssociationMutation({
 *   variables: {
 *      association_id: // value for 'association_id'
 *      client_stamp: // value for 'client_stamp'
 *   },
 * });
 */
export function useDeleteBundleAssociationMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteBundleAssociationMutation, GqlDeleteBundleAssociationMutationVariables>) {
        return Apollo.useMutation<GqlDeleteBundleAssociationMutation, GqlDeleteBundleAssociationMutationVariables>(DeleteBundleAssociationDocument, baseOptions);
      }
export type DeleteBundleAssociationMutationHookResult = ReturnType<typeof useDeleteBundleAssociationMutation>;
export type DeleteBundleAssociationMutationResult = Apollo.MutationResult<GqlDeleteBundleAssociationMutation>;
export type DeleteBundleAssociationMutationOptions = Apollo.BaseMutationOptions<GqlDeleteBundleAssociationMutation, GqlDeleteBundleAssociationMutationVariables>;
export const GetBundleAssociationDocument = gql`
    query getBundleAssociation($product_item_id: String!) {
  bundle_association_v2_by_sku(product_item_id: $product_item_id) {
    association_id
    quantity
    discount
    client_stamp
    parent_product_item_id
    parent_sku {
      product_item_name
      product {
        product_name
        product_id
      }
    }
    child_product_item_id
    child_sku {
      product_item_id
      product_item_name
      product {
        product_id
        product_name
      }
    }
  }
}
    `;

/**
 * __useGetBundleAssociationQuery__
 *
 * To run a query within a React component, call `useGetBundleAssociationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundleAssociationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundleAssociationQuery({
 *   variables: {
 *      product_item_id: // value for 'product_item_id'
 *   },
 * });
 */
export function useGetBundleAssociationQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBundleAssociationQuery, GqlGetBundleAssociationQueryVariables>) {
        return Apollo.useQuery<GqlGetBundleAssociationQuery, GqlGetBundleAssociationQueryVariables>(GetBundleAssociationDocument, baseOptions);
      }
export function useGetBundleAssociationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBundleAssociationQuery, GqlGetBundleAssociationQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetBundleAssociationQuery, GqlGetBundleAssociationQueryVariables>(GetBundleAssociationDocument, baseOptions);
        }
export type GetBundleAssociationQueryHookResult = ReturnType<typeof useGetBundleAssociationQuery>;
export type GetBundleAssociationLazyQueryHookResult = ReturnType<typeof useGetBundleAssociationLazyQuery>;
export type GetBundleAssociationQueryResult = Apollo.QueryResult<GqlGetBundleAssociationQuery, GqlGetBundleAssociationQueryVariables>;
export const Uoms_V2Document = gql`
    query uoms_v2($page: Int, $per_page: Int, $search: String) {
  uoms_v2(per_page: $per_page, page: $page, search: $search) {
    page_info {
      has_next
      has_previous
      total_pages
      total_count
      current_page
      per_page
    }
    edges {
      node {
        uom_id
        name
        description
        abbreviation
        active
      }
    }
  }
}
    `;

/**
 * __useUoms_V2Query__
 *
 * To run a query within a React component, call `useUoms_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useUoms_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUoms_V2Query({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUoms_V2Query(baseOptions?: Apollo.QueryHookOptions<GqlUoms_V2Query, GqlUoms_V2QueryVariables>) {
        return Apollo.useQuery<GqlUoms_V2Query, GqlUoms_V2QueryVariables>(Uoms_V2Document, baseOptions);
      }
export function useUoms_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlUoms_V2Query, GqlUoms_V2QueryVariables>) {
          return Apollo.useLazyQuery<GqlUoms_V2Query, GqlUoms_V2QueryVariables>(Uoms_V2Document, baseOptions);
        }
export type Uoms_V2QueryHookResult = ReturnType<typeof useUoms_V2Query>;
export type Uoms_V2LazyQueryHookResult = ReturnType<typeof useUoms_V2LazyQuery>;
export type Uoms_V2QueryResult = Apollo.QueryResult<GqlUoms_V2Query, GqlUoms_V2QueryVariables>;
export const Add_UomDocument = gql`
    mutation add_uom($name: String!, $abbreviation: String, $description: String) {
  add_uom(
    data: {name: $name, abbreviation: $abbreviation, description: $description}
  ) {
    uom {
      uom_id
      name
      abbreviation
      description
    }
    created
  }
}
    `;
export type GqlAdd_UomMutationFn = Apollo.MutationFunction<GqlAdd_UomMutation, GqlAdd_UomMutationVariables>;

/**
 * __useAdd_UomMutation__
 *
 * To run a mutation, you first call `useAdd_UomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_UomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUomMutation, { data, loading, error }] = useAdd_UomMutation({
 *   variables: {
 *      name: // value for 'name'
 *      abbreviation: // value for 'abbreviation'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAdd_UomMutation(baseOptions?: Apollo.MutationHookOptions<GqlAdd_UomMutation, GqlAdd_UomMutationVariables>) {
        return Apollo.useMutation<GqlAdd_UomMutation, GqlAdd_UomMutationVariables>(Add_UomDocument, baseOptions);
      }
export type Add_UomMutationHookResult = ReturnType<typeof useAdd_UomMutation>;
export type Add_UomMutationResult = Apollo.MutationResult<GqlAdd_UomMutation>;
export type Add_UomMutationOptions = Apollo.BaseMutationOptions<GqlAdd_UomMutation, GqlAdd_UomMutationVariables>;
export const Update_UomDocument = gql`
    mutation update_uom($uom_id: String!, $data: UOMInput!) {
  update_uom(uom_id: $uom_id, data: $data) {
    uom {
      uom_id
      name
      active
      abbreviation
      description
    }
  }
}
    `;
export type GqlUpdate_UomMutationFn = Apollo.MutationFunction<GqlUpdate_UomMutation, GqlUpdate_UomMutationVariables>;

/**
 * __useUpdate_UomMutation__
 *
 * To run a mutation, you first call `useUpdate_UomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_UomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUomMutation, { data, loading, error }] = useUpdate_UomMutation({
 *   variables: {
 *      uom_id: // value for 'uom_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdate_UomMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdate_UomMutation, GqlUpdate_UomMutationVariables>) {
        return Apollo.useMutation<GqlUpdate_UomMutation, GqlUpdate_UomMutationVariables>(Update_UomDocument, baseOptions);
      }
export type Update_UomMutationHookResult = ReturnType<typeof useUpdate_UomMutation>;
export type Update_UomMutationResult = Apollo.MutationResult<GqlUpdate_UomMutation>;
export type Update_UomMutationOptions = Apollo.BaseMutationOptions<GqlUpdate_UomMutation, GqlUpdate_UomMutationVariables>;
export const ProductPriceRangeDocument = gql`
    query productPriceRange($search: String, $productFilters: GenericScalar, $per_page: Int, $page: Int) {
  paginated_products_v2(
    search: $search
    per_page: $per_page
    page: $page
    filters: $productFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        product_name
        product_id
        sourcing_price_range {
          min_price
          max_price
          date_updated
          price_range_id
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProductPriceRangeQuery__
 *
 * To run a query within a React component, call `useProductPriceRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceRangeQuery({
 *   variables: {
 *      search: // value for 'search'
 *      productFilters: // value for 'productFilters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProductPriceRangeQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductPriceRangeQuery, GqlProductPriceRangeQueryVariables>) {
        return Apollo.useQuery<GqlProductPriceRangeQuery, GqlProductPriceRangeQueryVariables>(ProductPriceRangeDocument, baseOptions);
      }
export function useProductPriceRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductPriceRangeQuery, GqlProductPriceRangeQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductPriceRangeQuery, GqlProductPriceRangeQueryVariables>(ProductPriceRangeDocument, baseOptions);
        }
export type ProductPriceRangeQueryHookResult = ReturnType<typeof useProductPriceRangeQuery>;
export type ProductPriceRangeLazyQueryHookResult = ReturnType<typeof useProductPriceRangeLazyQuery>;
export type ProductPriceRangeQueryResult = Apollo.QueryResult<GqlProductPriceRangeQuery, GqlProductPriceRangeQueryVariables>;
export const PurchasesDocument = gql`
    query Purchases($search: String, $per_page: Int, $page: Int, $purchaseFilters: GenericScalar) {
  harvests(
    search: $search
    per_page: $per_page
    page: $page
    filter: $purchaseFilters
  ) {
    page_info {
      per_page
      total_count
      total_pages
      has_next
      has_previous
      current_page
    }
    edges {
      node {
        active
        original_currency
        cancelled
        cancellation_reason
        date_created
        receipt_number
        harvest_id
        invoice_number
        batch_id
        batch {
          batch_name
        }
        signed_receipt_url
        farmer_id
        quantity
        weight
        unit_price
        collection_center_id
        collection_center {
          collection_center_name
          area_id
          area {
            area_name
          }
        }
        farmer {
          first_name
          last_name
          phone_number
          farmer_number
          farmer_id
          supplier_name
        }
        farm_id
        farm {
          farm_number
          farmer {
            first_name
            last_name
            phone_number
            supplier_name
            farmer_id
          }
        }
        product_id
        product {
          product_name
        }
        product_item_id
        product_item {
          product_item_name
        }
        unit_of_measure_id
        uom {
          name
        }
        harvest_date
        harvest_items {
          harvest_id
          harvest {
            batch_id
          }
          product_id
          product {
            product_name
          }
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
          }
          quantity
          unit_price
          weight
          unit_of_measure_id
          uom {
            name
          }
        }
        payment {
          amount_paid
          total_payable
          harvest_payment_status
        }
      }
    }
  }
}
    `;

/**
 * __usePurchasesQuery__
 *
 * To run a query within a React component, call `usePurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchasesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      purchaseFilters: // value for 'purchaseFilters'
 *   },
 * });
 */
export function usePurchasesQuery(baseOptions?: Apollo.QueryHookOptions<GqlPurchasesQuery, GqlPurchasesQueryVariables>) {
        return Apollo.useQuery<GqlPurchasesQuery, GqlPurchasesQueryVariables>(PurchasesDocument, baseOptions);
      }
export function usePurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPurchasesQuery, GqlPurchasesQueryVariables>) {
          return Apollo.useLazyQuery<GqlPurchasesQuery, GqlPurchasesQueryVariables>(PurchasesDocument, baseOptions);
        }
export type PurchasesQueryHookResult = ReturnType<typeof usePurchasesQuery>;
export type PurchasesLazyQueryHookResult = ReturnType<typeof usePurchasesLazyQuery>;
export type PurchasesQueryResult = Apollo.QueryResult<GqlPurchasesQuery, GqlPurchasesQueryVariables>;
export const BookingsDocument = gql`
    query Bookings($search: String, $per_page: Int, $page: Int, $bookingFilters: GenericScalar) {
  bookings(
    search: $search
    per_page: $per_page
    page: $page
    filter: $bookingFilters
  ) {
    page_info {
      per_page
      total_count
      total_pages
      has_next
      has_previous
      current_page
    }
    edges {
      node {
        active
        cancelled
        cancellation_reason
        date_created
        receipt_number
        booking_id
        booking_date
        harvest_date
        date_created
        signed_invoice_url
        quantity
        weight
        price
        farmer_id
        farmer {
          first_name
          last_name
          phone_number
          supplier_name
          farmer_id
        }
        product_id
        product {
          product_name
        }
        product_item_id
        product_item {
          product_item_name
        }
        unit_of_measure_id
        uom {
          name
        }
        collection_center_id
        collection_center {
          collection_center_name
          area_id
          area {
            area_name
          }
        }
        farm_id
        farm {
          farm_number
          farmer {
            first_name
            last_name
            phone_number
            supplier_name
            farmer_id
          }
          harvest_area_id
          harvest_area {
            harvest_area_name
          }
        }
        booking_items {
          booking_id
          product_id
          product {
            product_name
          }
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
            units_of_measure {
              business_domain {
                domain_name
              }
              conversion_ratio
            }
          }
          unit_price
          quantity
          weight
          date_created
          harvest_date
          unit_of_measure_id
          uom {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBookingsQuery__
 *
 * To run a query within a React component, call `useBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      bookingFilters: // value for 'bookingFilters'
 *   },
 * });
 */
export function useBookingsQuery(baseOptions?: Apollo.QueryHookOptions<GqlBookingsQuery, GqlBookingsQueryVariables>) {
        return Apollo.useQuery<GqlBookingsQuery, GqlBookingsQueryVariables>(BookingsDocument, baseOptions);
      }
export function useBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBookingsQuery, GqlBookingsQueryVariables>) {
          return Apollo.useLazyQuery<GqlBookingsQuery, GqlBookingsQueryVariables>(BookingsDocument, baseOptions);
        }
export type BookingsQueryHookResult = ReturnType<typeof useBookingsQuery>;
export type BookingsLazyQueryHookResult = ReturnType<typeof useBookingsLazyQuery>;
export type BookingsQueryResult = Apollo.QueryResult<GqlBookingsQuery, GqlBookingsQueryVariables>;
export const SupplierProductsDocument = gql`
    query SupplierProducts($per_page: Int, $page: Int, $productFilter: GenericScalar) {
  supplier_products(per_page: $per_page, page: $page, filter: $productFilter) {
    page_info {
      per_page
      total_count
      total_pages
      has_next
      has_previous
      current_page
    }
    edges {
      node {
        active
        farmer_id
        supplier_product_id
        product_id
        product {
          product_name
          product_id
        }
      }
    }
  }
}
    `;

/**
 * __useSupplierProductsQuery__
 *
 * To run a query within a React component, call `useSupplierProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierProductsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      productFilter: // value for 'productFilter'
 *   },
 * });
 */
export function useSupplierProductsQuery(baseOptions?: Apollo.QueryHookOptions<GqlSupplierProductsQuery, GqlSupplierProductsQueryVariables>) {
        return Apollo.useQuery<GqlSupplierProductsQuery, GqlSupplierProductsQueryVariables>(SupplierProductsDocument, baseOptions);
      }
export function useSupplierProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSupplierProductsQuery, GqlSupplierProductsQueryVariables>) {
          return Apollo.useLazyQuery<GqlSupplierProductsQuery, GqlSupplierProductsQueryVariables>(SupplierProductsDocument, baseOptions);
        }
export type SupplierProductsQueryHookResult = ReturnType<typeof useSupplierProductsQuery>;
export type SupplierProductsLazyQueryHookResult = ReturnType<typeof useSupplierProductsLazyQuery>;
export type SupplierProductsQueryResult = Apollo.QueryResult<GqlSupplierProductsQuery, GqlSupplierProductsQueryVariables>;
export const PivotsDocument = gql`
    query Pivots {
  pivots {
    pivot_id
    pivot_name
    pivot_code
  }
}
    `;

/**
 * __usePivotsQuery__
 *
 * To run a query within a React component, call `usePivotsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePivotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePivotsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePivotsQuery(baseOptions?: Apollo.QueryHookOptions<GqlPivotsQuery, GqlPivotsQueryVariables>) {
        return Apollo.useQuery<GqlPivotsQuery, GqlPivotsQueryVariables>(PivotsDocument, baseOptions);
      }
export function usePivotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPivotsQuery, GqlPivotsQueryVariables>) {
          return Apollo.useLazyQuery<GqlPivotsQuery, GqlPivotsQueryVariables>(PivotsDocument, baseOptions);
        }
export type PivotsQueryHookResult = ReturnType<typeof usePivotsQuery>;
export type PivotsLazyQueryHookResult = ReturnType<typeof usePivotsLazyQuery>;
export type PivotsQueryResult = Apollo.QueryResult<GqlPivotsQuery, GqlPivotsQueryVariables>;
export const BlocksDocument = gql`
    query Blocks {
  blocks {
    block_id
    block_name
    block_code
  }
}
    `;

/**
 * __useBlocksQuery__
 *
 * To run a query within a React component, call `useBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlocksQuery(baseOptions?: Apollo.QueryHookOptions<GqlBlocksQuery, GqlBlocksQueryVariables>) {
        return Apollo.useQuery<GqlBlocksQuery, GqlBlocksQueryVariables>(BlocksDocument, baseOptions);
      }
export function useBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBlocksQuery, GqlBlocksQueryVariables>) {
          return Apollo.useLazyQuery<GqlBlocksQuery, GqlBlocksQueryVariables>(BlocksDocument, baseOptions);
        }
export type BlocksQueryHookResult = ReturnType<typeof useBlocksQuery>;
export type BlocksLazyQueryHookResult = ReturnType<typeof useBlocksLazyQuery>;
export type BlocksQueryResult = Apollo.QueryResult<GqlBlocksQuery, GqlBlocksQueryVariables>;
export const StorageDocument = gql`
    query storage($filters: GenericScalar, $per_page: Int!, $page: Int!, $search: String) {
  storage(per_page: $per_page, filter: $filters, page: $page, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        storage_id
        storage_entry_number
        batch_id
        batch {
          batch_name
        }
        date
        quantity
        packaging_unit_quantity
        created_by
        user {
          first_name
          last_name
        }
        direction
        weight
        comments
        packaging_unit_id
        packaging_unit {
          name
        }
        unit_of_measure_id
        uom {
          name
        }
        storage_unit {
          unit_name
          warehouse_id
          warehouse {
            warehouse_name
            distribution_center_id
            distribution_center {
              distribution_center_name
            }
          }
        }
        product_item_id
        product_item {
          product_item_name
          product {
            product_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useStorageQuery__
 *
 * To run a query within a React component, call `useStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useStorageQuery(baseOptions: Apollo.QueryHookOptions<GqlStorageQuery, GqlStorageQueryVariables>) {
        return Apollo.useQuery<GqlStorageQuery, GqlStorageQueryVariables>(StorageDocument, baseOptions);
      }
export function useStorageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStorageQuery, GqlStorageQueryVariables>) {
          return Apollo.useLazyQuery<GqlStorageQuery, GqlStorageQueryVariables>(StorageDocument, baseOptions);
        }
export type StorageQueryHookResult = ReturnType<typeof useStorageQuery>;
export type StorageLazyQueryHookResult = ReturnType<typeof useStorageLazyQuery>;
export type StorageQueryResult = Apollo.QueryResult<GqlStorageQuery, GqlStorageQueryVariables>;
export const GetBatchesDocument = gql`
    query getBatches($filters: GenericScalar, $per_page: Int, $page: Int, $search: String) {
  batches(per_page: $per_page, filter: $filters, page: $page, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        batch_id
        batch_name
        batch_date
        field_weight
        processing_loss_weight
        intake_weight
        active
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useGetBatchesQuery__
 *
 * To run a query within a React component, call `useGetBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetBatchesQuery, GqlGetBatchesQueryVariables>) {
        return Apollo.useQuery<GqlGetBatchesQuery, GqlGetBatchesQueryVariables>(GetBatchesDocument, baseOptions);
      }
export function useGetBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBatchesQuery, GqlGetBatchesQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetBatchesQuery, GqlGetBatchesQueryVariables>(GetBatchesDocument, baseOptions);
        }
export type GetBatchesQueryHookResult = ReturnType<typeof useGetBatchesQuery>;
export type GetBatchesLazyQueryHookResult = ReturnType<typeof useGetBatchesLazyQuery>;
export type GetBatchesQueryResult = Apollo.QueryResult<GqlGetBatchesQuery, GqlGetBatchesQueryVariables>;
export const BatchSummaryDetailDocument = gql`
    query batchSummaryDetail($batch_id: String!) {
  batch_by_id(batch_id: $batch_id) {
    batch_id
    batch_name
    batch_date
    field_weight
    intake_weight
    collection_center_id
    collection_center {
      collection_center_name
      area {
        area_name
      }
    }
    stock_intake_items_batch {
      batch_id
      stock_intake_items {
        active
        stock_intake_item_id
        stock_intake {
          stock_intake_number
        }
        product_item_id
        product_item {
          product_item_name
          product {
            product_name
          }
        }
        cancellation_reason
        weight
        quantity
        unit_of_measure_id
        uom {
          name
        }
        packaging_unit_quantity
        packaging_unit_id
        packaging_unit {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBatchSummaryDetailQuery__
 *
 * To run a query within a React component, call `useBatchSummaryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchSummaryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchSummaryDetailQuery({
 *   variables: {
 *      batch_id: // value for 'batch_id'
 *   },
 * });
 */
export function useBatchSummaryDetailQuery(baseOptions: Apollo.QueryHookOptions<GqlBatchSummaryDetailQuery, GqlBatchSummaryDetailQueryVariables>) {
        return Apollo.useQuery<GqlBatchSummaryDetailQuery, GqlBatchSummaryDetailQueryVariables>(BatchSummaryDetailDocument, baseOptions);
      }
export function useBatchSummaryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBatchSummaryDetailQuery, GqlBatchSummaryDetailQueryVariables>) {
          return Apollo.useLazyQuery<GqlBatchSummaryDetailQuery, GqlBatchSummaryDetailQueryVariables>(BatchSummaryDetailDocument, baseOptions);
        }
export type BatchSummaryDetailQueryHookResult = ReturnType<typeof useBatchSummaryDetailQuery>;
export type BatchSummaryDetailLazyQueryHookResult = ReturnType<typeof useBatchSummaryDetailLazyQuery>;
export type BatchSummaryDetailQueryResult = Apollo.QueryResult<GqlBatchSummaryDetailQuery, GqlBatchSummaryDetailQueryVariables>;
export const DcReturnsDocument = gql`
    query dcReturns($filters: GenericScalar, $per_page: Int, $page: Int, $filter_array: GenericScalar) {
  returns(
    filter: $filters
    per_page: $per_page
    page: $page
    filter_array: $filter_array
  ) {
    page_info {
      per_page
      total_count
      total_pages
      current_page
    }
    edges {
      node {
        ...DCReturn
      }
    }
  }
}
    ${DcReturnFragmentDoc}`;

/**
 * __useDcReturnsQuery__
 *
 * To run a query within a React component, call `useDcReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcReturnsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filter_array: // value for 'filter_array'
 *   },
 * });
 */
export function useDcReturnsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDcReturnsQuery, GqlDcReturnsQueryVariables>) {
        return Apollo.useQuery<GqlDcReturnsQuery, GqlDcReturnsQueryVariables>(DcReturnsDocument, baseOptions);
      }
export function useDcReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDcReturnsQuery, GqlDcReturnsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDcReturnsQuery, GqlDcReturnsQueryVariables>(DcReturnsDocument, baseOptions);
        }
export type DcReturnsQueryHookResult = ReturnType<typeof useDcReturnsQuery>;
export type DcReturnsLazyQueryHookResult = ReturnType<typeof useDcReturnsLazyQuery>;
export type DcReturnsQueryResult = Apollo.QueryResult<GqlDcReturnsQuery, GqlDcReturnsQueryVariables>;
export const DcReturnByIdDocument = gql`
    query dcReturnById($return_id: String!) {
  return_by_id(return_id: $return_id) {
    ...DCReturn
  }
}
    ${DcReturnFragmentDoc}`;

/**
 * __useDcReturnByIdQuery__
 *
 * To run a query within a React component, call `useDcReturnByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcReturnByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcReturnByIdQuery({
 *   variables: {
 *      return_id: // value for 'return_id'
 *   },
 * });
 */
export function useDcReturnByIdQuery(baseOptions: Apollo.QueryHookOptions<GqlDcReturnByIdQuery, GqlDcReturnByIdQueryVariables>) {
        return Apollo.useQuery<GqlDcReturnByIdQuery, GqlDcReturnByIdQueryVariables>(DcReturnByIdDocument, baseOptions);
      }
export function useDcReturnByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDcReturnByIdQuery, GqlDcReturnByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlDcReturnByIdQuery, GqlDcReturnByIdQueryVariables>(DcReturnByIdDocument, baseOptions);
        }
export type DcReturnByIdQueryHookResult = ReturnType<typeof useDcReturnByIdQuery>;
export type DcReturnByIdLazyQueryHookResult = ReturnType<typeof useDcReturnByIdLazyQuery>;
export type DcReturnByIdQueryResult = Apollo.QueryResult<GqlDcReturnByIdQuery, GqlDcReturnByIdQueryVariables>;
export const DispatchesDocument = gql`
    query Dispatches($search: String, $per_page: Int, $page: Int, $dispatchFilters: GenericScalar) {
  dispatches(
    search: $search
    per_page: $per_page
    page: $page
    return_all: true
    filter: $dispatchFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        dispatch_id
        depot_id
        dispatch_number
        date_created
        total_products
        created_by
        sale_date
        dispatch_type
        user {
          first_name
          last_name
          phone_number
          user_number
          user_id
        }
        depot_id
        depot {
          depot_name
          depot_id
        }
        distribution_center_id
        distribution_center {
          distribution_center_id
          distribution_center_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDispatchesQuery__
 *
 * To run a query within a React component, call `useDispatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      dispatchFilters: // value for 'dispatchFilters'
 *   },
 * });
 */
export function useDispatchesQuery(baseOptions?: Apollo.QueryHookOptions<GqlDispatchesQuery, GqlDispatchesQueryVariables>) {
        return Apollo.useQuery<GqlDispatchesQuery, GqlDispatchesQueryVariables>(DispatchesDocument, baseOptions);
      }
export function useDispatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispatchesQuery, GqlDispatchesQueryVariables>) {
          return Apollo.useLazyQuery<GqlDispatchesQuery, GqlDispatchesQueryVariables>(DispatchesDocument, baseOptions);
        }
export type DispatchesQueryHookResult = ReturnType<typeof useDispatchesQuery>;
export type DispatchesLazyQueryHookResult = ReturnType<typeof useDispatchesLazyQuery>;
export type DispatchesQueryResult = Apollo.QueryResult<GqlDispatchesQuery, GqlDispatchesQueryVariables>;
export const DispatchDetailsDocument = gql`
    query DispatchDetails($dispatch_id: String!, $depot_id: String!, $date: String!) {
  dispatch_by_id(dispatch_id: $dispatch_id) {
    dispatch_id
    dispatch_type
    date_created
    sale_date
    depot_id
    depot {
      depot_name
      depot_id
    }
    created_by
    user {
      first_name
      last_name
      phone_number
      user_number
      user_id
    }
    dispatch_items {
      dispatch_item_id
      quantity
      cancellation_reason
      packaging_unit_quantity
      active
      route_id
      route {
        route_name
      }
      packaging_unit_id
      packaging_unit {
        name
      }
      unit_of_measure_id
      uom {
        name
        abbreviation
        uom_id
      }
      product_item_id
      product_item {
        product_item_id
        product_item_name
        product_id
        product {
          product_name
          product_type
          packaging_units {
            active
            name
            weight
            packaging_unit_id
          }
        }
        ordered_stock_depot(date: $date, depot_id: $depot_id) {
          order_quantity
        }
      }
    }
  }
}
    `;

/**
 * __useDispatchDetailsQuery__
 *
 * To run a query within a React component, call `useDispatchDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchDetailsQuery({
 *   variables: {
 *      dispatch_id: // value for 'dispatch_id'
 *      depot_id: // value for 'depot_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDispatchDetailsQuery(baseOptions: Apollo.QueryHookOptions<GqlDispatchDetailsQuery, GqlDispatchDetailsQueryVariables>) {
        return Apollo.useQuery<GqlDispatchDetailsQuery, GqlDispatchDetailsQueryVariables>(DispatchDetailsDocument, baseOptions);
      }
export function useDispatchDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispatchDetailsQuery, GqlDispatchDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDispatchDetailsQuery, GqlDispatchDetailsQueryVariables>(DispatchDetailsDocument, baseOptions);
        }
export type DispatchDetailsQueryHookResult = ReturnType<typeof useDispatchDetailsQuery>;
export type DispatchDetailsLazyQueryHookResult = ReturnType<typeof useDispatchDetailsLazyQuery>;
export type DispatchDetailsQueryResult = Apollo.QueryResult<GqlDispatchDetailsQuery, GqlDispatchDetailsQueryVariables>;
export const Processing_LossDocument = gql`
    query processing_loss($filters: GenericScalar, $per_page: Int!, $page: Int!, $search: String) {
  processing_loss(
    per_page: $per_page
    filter: $filters
    page: $page
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        date
        processing_loss_number
        batch_id
        batch {
          batch_name
        }
        processing_loss_id
        processing_loss_type {
          processing_loss_type_id
          processing_loss_type_name
        }
        date
        loss_type
        created_by
        user {
          first_name
          last_name
        }
        distribution_center_id
        distribution_center {
          distribution_center_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProcessing_LossQuery__
 *
 * To run a query within a React component, call `useProcessing_LossQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessing_LossQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessing_LossQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProcessing_LossQuery(baseOptions: Apollo.QueryHookOptions<GqlProcessing_LossQuery, GqlProcessing_LossQueryVariables>) {
        return Apollo.useQuery<GqlProcessing_LossQuery, GqlProcessing_LossQueryVariables>(Processing_LossDocument, baseOptions);
      }
export function useProcessing_LossLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProcessing_LossQuery, GqlProcessing_LossQueryVariables>) {
          return Apollo.useLazyQuery<GqlProcessing_LossQuery, GqlProcessing_LossQueryVariables>(Processing_LossDocument, baseOptions);
        }
export type Processing_LossQueryHookResult = ReturnType<typeof useProcessing_LossQuery>;
export type Processing_LossLazyQueryHookResult = ReturnType<typeof useProcessing_LossLazyQuery>;
export type Processing_LossQueryResult = Apollo.QueryResult<GqlProcessing_LossQuery, GqlProcessing_LossQueryVariables>;
export const Processing_Loss_TypesDocument = gql`
    query processing_loss_types {
  processing_loss_types {
    edges {
      node {
        processing_loss_type_name
        processing_loss_type_id
      }
    }
  }
}
    `;

/**
 * __useProcessing_Loss_TypesQuery__
 *
 * To run a query within a React component, call `useProcessing_Loss_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessing_Loss_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessing_Loss_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessing_Loss_TypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProcessing_Loss_TypesQuery, GqlProcessing_Loss_TypesQueryVariables>) {
        return Apollo.useQuery<GqlProcessing_Loss_TypesQuery, GqlProcessing_Loss_TypesQueryVariables>(Processing_Loss_TypesDocument, baseOptions);
      }
export function useProcessing_Loss_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProcessing_Loss_TypesQuery, GqlProcessing_Loss_TypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProcessing_Loss_TypesQuery, GqlProcessing_Loss_TypesQueryVariables>(Processing_Loss_TypesDocument, baseOptions);
        }
export type Processing_Loss_TypesQueryHookResult = ReturnType<typeof useProcessing_Loss_TypesQuery>;
export type Processing_Loss_TypesLazyQueryHookResult = ReturnType<typeof useProcessing_Loss_TypesLazyQuery>;
export type Processing_Loss_TypesQueryResult = Apollo.QueryResult<GqlProcessing_Loss_TypesQuery, GqlProcessing_Loss_TypesQueryVariables>;
export const ProcessingLossByIdDocument = gql`
    query processingLossById($processingLossId: String) {
  processing_loss_by_id(processing_loss_id: $processingLossId) {
    date
    batch_id
    batch {
      batch_name
    }
    processing_loss_id
    processing_loss_type {
      processing_loss_type_id
      processing_loss_type_name
    }
    date
    loss_type
    created_by
    user {
      first_name
      last_name
    }
    processing_loss_items {
      active
      quantity
      thumbnail
      product_loss_reason {
        loss_reason {
          loss_reason
        }
      }
      cancellation_reason
      processing_loss_item_id
      product_item_id
      product_item {
        product_item_name
        product_id
        product {
          product_name
        }
      }
      unit_of_measure_id
      uom {
        name
      }
      processing_loss {
        processing_loss_id
        loss_type
      }
    }
  }
}
    `;

/**
 * __useProcessingLossByIdQuery__
 *
 * To run a query within a React component, call `useProcessingLossByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingLossByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingLossByIdQuery({
 *   variables: {
 *      processingLossId: // value for 'processingLossId'
 *   },
 * });
 */
export function useProcessingLossByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlProcessingLossByIdQuery, GqlProcessingLossByIdQueryVariables>) {
        return Apollo.useQuery<GqlProcessingLossByIdQuery, GqlProcessingLossByIdQueryVariables>(ProcessingLossByIdDocument, baseOptions);
      }
export function useProcessingLossByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProcessingLossByIdQuery, GqlProcessingLossByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlProcessingLossByIdQuery, GqlProcessingLossByIdQueryVariables>(ProcessingLossByIdDocument, baseOptions);
        }
export type ProcessingLossByIdQueryHookResult = ReturnType<typeof useProcessingLossByIdQuery>;
export type ProcessingLossByIdLazyQueryHookResult = ReturnType<typeof useProcessingLossByIdLazyQuery>;
export type ProcessingLossByIdQueryResult = Apollo.QueryResult<GqlProcessingLossByIdQuery, GqlProcessingLossByIdQueryVariables>;
export const Stock_AvailabilityDocument = gql`
    query stock_availability($page: Int, $per_page: Int, $search: String, $distribution_center_id: String!, $filters: GenericScalar) {
  paginated_product_items_v2(
    per_page: $per_page
    page: $page
    search: $search
    filters: $filters
    active: true
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...ProductItemV2
        current_stock_availability(distribution_center_id: $distribution_center_id) {
          region_id
          created_by
          region {
            region_name
          }
          stock_availability_id
          updated_by
          sale_date
          quantity
          stock_entry_number
          unit_of_measure_id
          active
          uom {
            name
            abbreviation
          }
          user {
            user_id
            first_name
            last_name
            user_number
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}
${ProductItemV2FragmentDoc}`;

/**
 * __useStock_AvailabilityQuery__
 *
 * To run a query within a React component, call `useStock_AvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useStock_AvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStock_AvailabilityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      distribution_center_id: // value for 'distribution_center_id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStock_AvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GqlStock_AvailabilityQuery, GqlStock_AvailabilityQueryVariables>) {
        return Apollo.useQuery<GqlStock_AvailabilityQuery, GqlStock_AvailabilityQueryVariables>(Stock_AvailabilityDocument, baseOptions);
      }
export function useStock_AvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStock_AvailabilityQuery, GqlStock_AvailabilityQueryVariables>) {
          return Apollo.useLazyQuery<GqlStock_AvailabilityQuery, GqlStock_AvailabilityQueryVariables>(Stock_AvailabilityDocument, baseOptions);
        }
export type Stock_AvailabilityQueryHookResult = ReturnType<typeof useStock_AvailabilityQuery>;
export type Stock_AvailabilityLazyQueryHookResult = ReturnType<typeof useStock_AvailabilityLazyQuery>;
export type Stock_AvailabilityQueryResult = Apollo.QueryResult<GqlStock_AvailabilityQuery, GqlStock_AvailabilityQueryVariables>;
export const GetDCsStockAvailabilityDocument = gql`
    query getDCsStockAvailability($regionId: String!, $page: Int, $per_page: Int, $search: String, $distribution_center_ids: [String]!, $filters: GenericScalar, $depot_id: String!, $static_params: GenericScalar) {
  paginated_product_items_v2(
    per_page: $per_page
    page: $page
    search: $search
    filters: $filters
    active: true
    static_params: $static_params
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...ProductItemV2
        current_pricing_v2(region_id: $regionId) {
          unit_of_measure_id
          base_price
          currency
          rrp
          pricing_date
          region_id
        }
        current_dcs_stock_availability(
          distribution_center_ids: $distribution_center_ids
          depot_id: $depot_id
        ) {
          quantity
        }
        dynamic_price {
          base_price
          dynamic_price
        }
        base_price
      }
    }
  }
}
    ${PaginationFragmentDoc}
${ProductItemV2FragmentDoc}`;

/**
 * __useGetDCsStockAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetDCsStockAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDCsStockAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDCsStockAvailabilityQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      distribution_center_ids: // value for 'distribution_center_ids'
 *      filters: // value for 'filters'
 *      depot_id: // value for 'depot_id'
 *      static_params: // value for 'static_params'
 *   },
 * });
 */
export function useGetDCsStockAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDCsStockAvailabilityQuery, GqlGetDCsStockAvailabilityQueryVariables>) {
        return Apollo.useQuery<GqlGetDCsStockAvailabilityQuery, GqlGetDCsStockAvailabilityQueryVariables>(GetDCsStockAvailabilityDocument, baseOptions);
      }
export function useGetDCsStockAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDCsStockAvailabilityQuery, GqlGetDCsStockAvailabilityQueryVariables>) {
          return Apollo.useLazyQuery<GqlGetDCsStockAvailabilityQuery, GqlGetDCsStockAvailabilityQueryVariables>(GetDCsStockAvailabilityDocument, baseOptions);
        }
export type GetDCsStockAvailabilityQueryHookResult = ReturnType<typeof useGetDCsStockAvailabilityQuery>;
export type GetDCsStockAvailabilityLazyQueryHookResult = ReturnType<typeof useGetDCsStockAvailabilityLazyQuery>;
export type GetDCsStockAvailabilityQueryResult = Apollo.QueryResult<GqlGetDCsStockAvailabilityQuery, GqlGetDCsStockAvailabilityQueryVariables>;
export const WarehouseStockIntakeDocument = gql`
    query warehouseStockIntake($filters: GenericScalar, $per_page: Int, $page: Int, $search: String) {
  stock_intakes(
    filter: $filters
    per_page: $per_page
    page: $page
    search: $search
  ) {
    page_info {
      per_page
      total_count
      total_pages
      current_page
    }
    edges {
      node {
        created_by
        stock_intake_id
        stock_intake_number
        arrival_date
        truck_number
        intake_count
        distribution_center_id
        distribution_center {
          distribution_center_id
          distribution_center_name
        }
      }
    }
  }
}
    `;

/**
 * __useWarehouseStockIntakeQuery__
 *
 * To run a query within a React component, call `useWarehouseStockIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseStockIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseStockIntakeQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useWarehouseStockIntakeQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehouseStockIntakeQuery, GqlWarehouseStockIntakeQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseStockIntakeQuery, GqlWarehouseStockIntakeQueryVariables>(WarehouseStockIntakeDocument, baseOptions);
      }
export function useWarehouseStockIntakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseStockIntakeQuery, GqlWarehouseStockIntakeQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseStockIntakeQuery, GqlWarehouseStockIntakeQueryVariables>(WarehouseStockIntakeDocument, baseOptions);
        }
export type WarehouseStockIntakeQueryHookResult = ReturnType<typeof useWarehouseStockIntakeQuery>;
export type WarehouseStockIntakeLazyQueryHookResult = ReturnType<typeof useWarehouseStockIntakeLazyQuery>;
export type WarehouseStockIntakeQueryResult = Apollo.QueryResult<GqlWarehouseStockIntakeQuery, GqlWarehouseStockIntakeQueryVariables>;
export const WarehouseStockIntakeByIdDocument = gql`
    query warehouseStockIntakeById($stock_intake_id: String!) {
  stock_intake_by_id(stock_intake_id: $stock_intake_id) {
    stock_intake_id
    stock_intake_number
    arrival_date
    truck_number
    stock_intake_photos {
      signed_url
    }
    created_by
    user {
      first_name
      last_name
    }
    stock_intake_items {
      active
      stock_intake_item_id
      cancellation_reason
      gross_weight
      batch_id
      batch {
        batch_name
      }
      weight
      quantity
      packaging_unit_id
      packaging_unit_quantity
      packaging_unit {
        name
      }
      unit_of_measure_id
      uom {
        name
      }
      product_item_id
      product_item {
        product_item_name
        product_id
        product {
          product_name
        }
      }
    }
  }
}
    `;

/**
 * __useWarehouseStockIntakeByIdQuery__
 *
 * To run a query within a React component, call `useWarehouseStockIntakeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseStockIntakeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseStockIntakeByIdQuery({
 *   variables: {
 *      stock_intake_id: // value for 'stock_intake_id'
 *   },
 * });
 */
export function useWarehouseStockIntakeByIdQuery(baseOptions: Apollo.QueryHookOptions<GqlWarehouseStockIntakeByIdQuery, GqlWarehouseStockIntakeByIdQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseStockIntakeByIdQuery, GqlWarehouseStockIntakeByIdQueryVariables>(WarehouseStockIntakeByIdDocument, baseOptions);
      }
export function useWarehouseStockIntakeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseStockIntakeByIdQuery, GqlWarehouseStockIntakeByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseStockIntakeByIdQuery, GqlWarehouseStockIntakeByIdQueryVariables>(WarehouseStockIntakeByIdDocument, baseOptions);
        }
export type WarehouseStockIntakeByIdQueryHookResult = ReturnType<typeof useWarehouseStockIntakeByIdQuery>;
export type WarehouseStockIntakeByIdLazyQueryHookResult = ReturnType<typeof useWarehouseStockIntakeByIdLazyQuery>;
export type WarehouseStockIntakeByIdQueryResult = Apollo.QueryResult<GqlWarehouseStockIntakeByIdQuery, GqlWarehouseStockIntakeByIdQueryVariables>;
export const DistributionCentersDocument = gql`
    query distributionCenters($dc_names: [String]) {
  distribution_centers(dc_names: $dc_names) {
    distribution_center_name
    distribution_center_id
    warehouses {
      warehouse_id
      warehouse_name
      storage_units {
        storage_unit_id
        unit_name
        warehouse {
          warehouse_name
          warehouse_id
        }
      }
    }
  }
}
    `;

/**
 * __useDistributionCentersQuery__
 *
 * To run a query within a React component, call `useDistributionCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionCentersQuery({
 *   variables: {
 *      dc_names: // value for 'dc_names'
 *   },
 * });
 */
export function useDistributionCentersQuery(baseOptions?: Apollo.QueryHookOptions<GqlDistributionCentersQuery, GqlDistributionCentersQueryVariables>) {
        return Apollo.useQuery<GqlDistributionCentersQuery, GqlDistributionCentersQueryVariables>(DistributionCentersDocument, baseOptions);
      }
export function useDistributionCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDistributionCentersQuery, GqlDistributionCentersQueryVariables>) {
          return Apollo.useLazyQuery<GqlDistributionCentersQuery, GqlDistributionCentersQueryVariables>(DistributionCentersDocument, baseOptions);
        }
export type DistributionCentersQueryHookResult = ReturnType<typeof useDistributionCentersQuery>;
export type DistributionCentersLazyQueryHookResult = ReturnType<typeof useDistributionCentersLazyQuery>;
export type DistributionCentersQueryResult = Apollo.QueryResult<GqlDistributionCentersQuery, GqlDistributionCentersQueryVariables>;
export const BatchesDocument = gql`
    query batches($search: String, $batchFilters: GenericScalar, $per_page: Int) {
  batches(search: $search, per_page: $per_page, filter: $batchFilters) {
    edges {
      node {
        active
        batch_id
        batch_name
        harvests {
          original_currency
          batch_id
          batch {
            batch_name
          }
          harvest_items {
            product_item_id
            quantity
            unit_of_measure_id
            uom {
              name
            }
            weight
            packaging_unit_id
            packaging_unit {
              packaging_unit_id
              name
            }
            number_of_crates
            packaging_unit_quantity
            product_item {
              product_item_name
              product {
                product_name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBatchesQuery__
 *
 * To run a query within a React component, call `useBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      batchFilters: // value for 'batchFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GqlBatchesQuery, GqlBatchesQueryVariables>) {
        return Apollo.useQuery<GqlBatchesQuery, GqlBatchesQueryVariables>(BatchesDocument, baseOptions);
      }
export function useBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBatchesQuery, GqlBatchesQueryVariables>) {
          return Apollo.useLazyQuery<GqlBatchesQuery, GqlBatchesQueryVariables>(BatchesDocument, baseOptions);
        }
export type BatchesQueryHookResult = ReturnType<typeof useBatchesQuery>;
export type BatchesLazyQueryHookResult = ReturnType<typeof useBatchesLazyQuery>;
export type BatchesQueryResult = Apollo.QueryResult<GqlBatchesQuery, GqlBatchesQueryVariables>;
export const WarehouseTransferDocument = gql`
    query warehouseTransfer($search: String, $per_page: Int, $page: Int, $warehouseFilters: GenericScalar) {
  warehouse_transfer(
    search: $search
    per_page: $per_page
    page: $page
    filter: $warehouseFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        cancelled
        cancellation_reason
        active
        date_created
        warehouse_transfer_id
        transfer_number
        transfer_date
        direction
        vehicle_id
        vehicle {
          registration_number
        }
        transfer_reason_id
        transfer_reason {
          reason_name
          reason_id
        }
        source_distribution_center_id
        source_distribution_center {
          distribution_center_name
        }
        dest_distribution_center_id
        dest_distribution_center {
          distribution_center_name
        }
        transferred_by
        transferred_by_user {
          first_name
          last_name
          user_number
        }
        warehouse_transfer_items {
          cancelled
          cancellation_reason
          warehouse_transfer_item_id
          warehouse_transfer_id
          quantity
          packaging_unit_quantity
          batch_id
          batch {
            batch_name
          }
          product_id
          product {
            product_name
          }
          weight
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
            units_of_measure {
              business_domain {
                domain_name
              }
              conversion_ratio
            }
          }
          unit_of_measure_id
          uom {
            name
          }
          packaging_unit_id
          packaging_unit {
            name
          }
          warehouse {
            warehouse_name
            storage_units {
              unit_name
            }
          }
          storage_unit {
            unit_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useWarehouseTransferQuery__
 *
 * To run a query within a React component, call `useWarehouseTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseTransferQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      warehouseFilters: // value for 'warehouseFilters'
 *   },
 * });
 */
export function useWarehouseTransferQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehouseTransferQuery, GqlWarehouseTransferQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseTransferQuery, GqlWarehouseTransferQueryVariables>(WarehouseTransferDocument, baseOptions);
      }
export function useWarehouseTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseTransferQuery, GqlWarehouseTransferQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseTransferQuery, GqlWarehouseTransferQueryVariables>(WarehouseTransferDocument, baseOptions);
        }
export type WarehouseTransferQueryHookResult = ReturnType<typeof useWarehouseTransferQuery>;
export type WarehouseTransferLazyQueryHookResult = ReturnType<typeof useWarehouseTransferLazyQuery>;
export type WarehouseTransferQueryResult = Apollo.QueryResult<GqlWarehouseTransferQuery, GqlWarehouseTransferQueryVariables>;
export const VehiclesDocument = gql`
    query vehicles($search: String, $per_page: Int) {
  vehicles(search: $search, per_page: $per_page) {
    edges {
      node {
        vehicle_id
        registration_number
        owner_name
        phone_number
      }
    }
  }
}
    `;

/**
 * __useVehiclesQuery__
 *
 * To run a query within a React component, call `useVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<GqlVehiclesQuery, GqlVehiclesQueryVariables>) {
        return Apollo.useQuery<GqlVehiclesQuery, GqlVehiclesQueryVariables>(VehiclesDocument, baseOptions);
      }
export function useVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlVehiclesQuery, GqlVehiclesQueryVariables>) {
          return Apollo.useLazyQuery<GqlVehiclesQuery, GqlVehiclesQueryVariables>(VehiclesDocument, baseOptions);
        }
export type VehiclesQueryHookResult = ReturnType<typeof useVehiclesQuery>;
export type VehiclesLazyQueryHookResult = ReturnType<typeof useVehiclesLazyQuery>;
export type VehiclesQueryResult = Apollo.QueryResult<GqlVehiclesQuery, GqlVehiclesQueryVariables>;
export const AppointmentsDocument = gql`
    query appointments($search: String, $per_page: Int, $page: Int, $appointmentFilters: GenericScalar) {
  appointments(
    search: $search
    per_page: $per_page
    page: $page
    filter: $appointmentFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        cancelled
        cancellation_reason
        date_created
        appointment_id
        appointment_number
        appointment_type
        eta
        decline_reason
        distribution_center_id
        distribution_center {
          distribution_center_id
          distribution_center_name
        }
        driver_name
        driver_phone_number
        images
        type_of_truck
        driver_id
        vehicle_seal_number
        dock_door_id
        dock_door {
          dock_door_number
        }
        vehicle_registration
        status
        issued_by
        issued_by_user {
          first_name
          last_name
        }
        appointment_items {
          booking_id
          booking {
            farmer_id
            farmer {
              first_name
              last_name
              farmer_number
              supplier_name
              farmer_id
            }
            booking_items {
              product_item_id
              product_item {
                product_item_name
                product_id
                product {
                  product_name
                }
              }
            }
          }
          batch_id
          batch {
            batch_id
            harvests {
              farmer_id
              farmer {
                farmer_id
                farmer_number
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      appointmentFilters: // value for 'appointmentFilters'
 *   },
 * });
 */
export function useAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GqlAppointmentsQuery, GqlAppointmentsQueryVariables>) {
        return Apollo.useQuery<GqlAppointmentsQuery, GqlAppointmentsQueryVariables>(AppointmentsDocument, baseOptions);
      }
export function useAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAppointmentsQuery, GqlAppointmentsQueryVariables>) {
          return Apollo.useLazyQuery<GqlAppointmentsQuery, GqlAppointmentsQueryVariables>(AppointmentsDocument, baseOptions);
        }
export type AppointmentsQueryHookResult = ReturnType<typeof useAppointmentsQuery>;
export type AppointmentsLazyQueryHookResult = ReturnType<typeof useAppointmentsLazyQuery>;
export type AppointmentsQueryResult = Apollo.QueryResult<GqlAppointmentsQuery, GqlAppointmentsQueryVariables>;
export const AppointmentItemsDocument = gql`
    query appointmentItems($search: String, $per_page: Int, $page: Int, $appointmentFilters: GenericScalar) {
  appointment_items(
    search: $search
    per_page: $per_page
    page: $page
    filter: $appointmentFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        cancelled
        appointment_id
        warehouse_transfer_id
        batch_id
        booking_id
        return_id
        warehouse_transfer {
          warehouse_transfer_id
          warehouse_transfer_items {
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            quantity
            weight
            unit_of_measure_id
            uom {
              name
            }
          }
        }
        returns {
          active
          return_id
          product_return_items {
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            quantity
            unit_of_measure_id
            uom {
              name
            }
          }
        }
        booking {
          booking_id
          farmer_id
          farmer {
            supplier_name
            first_name
            last_name
            farmer_type
            phone_number
          }
          booking_items {
            active
            unit_of_measure_id
            uom {
              name
            }
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            quantity
            weight
          }
        }
        batch {
          batch_name
          batch_id
          harvests {
            original_currency
            farmer_id
            farmer {
              supplier_name
              first_name
              last_name
              farmer_type
              phone_number
            }
            weight
            harvest_items {
              product_item_id
              quantity
              unit_of_measure_id
              uom {
                name
              }
              weight
              packaging_unit_id
              packaging_unit {
                packaging_unit_id
                name
              }
              packaging_unit_quantity
              product_item {
                product_item_name
                product {
                  product_name
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useAppointmentItemsQuery__
 *
 * To run a query within a React component, call `useAppointmentItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      appointmentFilters: // value for 'appointmentFilters'
 *   },
 * });
 */
export function useAppointmentItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlAppointmentItemsQuery, GqlAppointmentItemsQueryVariables>) {
        return Apollo.useQuery<GqlAppointmentItemsQuery, GqlAppointmentItemsQueryVariables>(AppointmentItemsDocument, baseOptions);
      }
export function useAppointmentItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAppointmentItemsQuery, GqlAppointmentItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlAppointmentItemsQuery, GqlAppointmentItemsQueryVariables>(AppointmentItemsDocument, baseOptions);
        }
export type AppointmentItemsQueryHookResult = ReturnType<typeof useAppointmentItemsQuery>;
export type AppointmentItemsLazyQueryHookResult = ReturnType<typeof useAppointmentItemsLazyQuery>;
export type AppointmentItemsQueryResult = Apollo.QueryResult<GqlAppointmentItemsQuery, GqlAppointmentItemsQueryVariables>;
export const DockDoorsDocument = gql`
    query dockDoors($per_page: Int, $page: Int, $search: String, $filter: GenericScalar) {
  dock_doors(per_page: $per_page, page: $page, search: $search, filter: $filter) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        status
        dock_door_id
        dock_door_number
        door_type
        warehouse {
          distribution_center {
            distribution_center_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDockDoorsQuery__
 *
 * To run a query within a React component, call `useDockDoorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDockDoorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDockDoorsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDockDoorsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDockDoorsQuery, GqlDockDoorsQueryVariables>) {
        return Apollo.useQuery<GqlDockDoorsQuery, GqlDockDoorsQueryVariables>(DockDoorsDocument, baseOptions);
      }
export function useDockDoorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDockDoorsQuery, GqlDockDoorsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDockDoorsQuery, GqlDockDoorsQueryVariables>(DockDoorsDocument, baseOptions);
        }
export type DockDoorsQueryHookResult = ReturnType<typeof useDockDoorsQuery>;
export type DockDoorsLazyQueryHookResult = ReturnType<typeof useDockDoorsLazyQuery>;
export type DockDoorsQueryResult = Apollo.QueryResult<GqlDockDoorsQuery, GqlDockDoorsQueryVariables>;
export const StockIntakeDocument = gql`
    query StockIntake($intakeFilters: GenericScalar) {
  stock_intakes(filter: $intakeFilters) {
    edges {
      node {
        appointment_id
        stock_intake_number
        appointment {
          appointment_number
          vehicle_registration
          driver_name
          eta
          dock_door_id
          dock_door {
            dock_door_number
          }
          appointment_items {
            batch_id
            booking_id
            warehouse_transfer_id
            return_id
            returns {
              active
              return_id
              product_return_items {
                active
                product_item_id
                product_item {
                  product_item_name
                  product {
                    product_name
                  }
                }
                quantity
                unit_of_measure_id
                uom {
                  name
                }
              }
            }
            warehouse_transfer {
              warehouse_transfer_id
              warehouse_transfer_items {
                active
                product_item_id
                product_item {
                  product_item_name
                  product {
                    product_name
                  }
                }
                quantity
                weight
                unit_of_measure_id
                uom {
                  name
                }
              }
            }
            booking {
              booking_id
              farmer_id
              farmer {
                first_name
                last_name
                farmer_number
                supplier_name
              }
              booking_items {
                active
                unit_of_measure_id
                uom {
                  name
                }
                product_item_id
                product_item {
                  product_item_name
                  product {
                    product_name
                  }
                }
                quantity
                weight
              }
            }
            batch {
              batch_name
              harvests {
                original_currency
                farmer_id
                farmer {
                  first_name
                  last_name
                  farmer_number
                  supplier_name
                }
                weight
                batch_id
                harvest_items {
                  product_item_id
                  quantity
                  unit_of_measure_id
                  uom {
                    name
                  }
                  weight
                  packaging_unit_id
                  packaging_unit {
                    packaging_unit_id
                    name
                  }
                  packaging_unit_quantity
                  product_item {
                    product_item_name
                    product {
                      product_name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStockIntakeQuery__
 *
 * To run a query within a React component, call `useStockIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeQuery({
 *   variables: {
 *      intakeFilters: // value for 'intakeFilters'
 *   },
 * });
 */
export function useStockIntakeQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeQuery, GqlStockIntakeQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeQuery, GqlStockIntakeQueryVariables>(StockIntakeDocument, baseOptions);
      }
export function useStockIntakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeQuery, GqlStockIntakeQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeQuery, GqlStockIntakeQueryVariables>(StockIntakeDocument, baseOptions);
        }
export type StockIntakeQueryHookResult = ReturnType<typeof useStockIntakeQuery>;
export type StockIntakeLazyQueryHookResult = ReturnType<typeof useStockIntakeLazyQuery>;
export type StockIntakeQueryResult = Apollo.QueryResult<GqlStockIntakeQuery, GqlStockIntakeQueryVariables>;
export const ReturnsDocument = gql`
    query Returns($search: String, $per_page: Int, $page: Int, $returnsFilters: GenericScalar) {
  returns(
    search: $search
    per_page: $per_page
    page: $page
    filter: $returnsFilters
  ) {
    edges {
      node {
        return_number
        return_id
        product_return_items {
          return_id
          product_item_id
          product_item {
            product_item_name
            product_id
            product {
              product_name
            }
          }
          unit_of_measure_id
          uom {
            name
          }
          quantity
          return_type
        }
      }
    }
  }
}
    `;

/**
 * __useReturnsQuery__
 *
 * To run a query within a React component, call `useReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      returnsFilters: // value for 'returnsFilters'
 *   },
 * });
 */
export function useReturnsQuery(baseOptions?: Apollo.QueryHookOptions<GqlReturnsQuery, GqlReturnsQueryVariables>) {
        return Apollo.useQuery<GqlReturnsQuery, GqlReturnsQueryVariables>(ReturnsDocument, baseOptions);
      }
export function useReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlReturnsQuery, GqlReturnsQueryVariables>) {
          return Apollo.useLazyQuery<GqlReturnsQuery, GqlReturnsQueryVariables>(ReturnsDocument, baseOptions);
        }
export type ReturnsQueryHookResult = ReturnType<typeof useReturnsQuery>;
export type ReturnsLazyQueryHookResult = ReturnType<typeof useReturnsLazyQuery>;
export type ReturnsQueryResult = Apollo.QueryResult<GqlReturnsQuery, GqlReturnsQueryVariables>;
export const WarehouseTransferReasonDocument = gql`
    query WarehouseTransferReason {
  warehouse_transfer_reason {
    edges {
      node {
        reason_id
        reason_name
      }
    }
  }
}
    `;

/**
 * __useWarehouseTransferReasonQuery__
 *
 * To run a query within a React component, call `useWarehouseTransferReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseTransferReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseTransferReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useWarehouseTransferReasonQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehouseTransferReasonQuery, GqlWarehouseTransferReasonQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseTransferReasonQuery, GqlWarehouseTransferReasonQueryVariables>(WarehouseTransferReasonDocument, baseOptions);
      }
export function useWarehouseTransferReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseTransferReasonQuery, GqlWarehouseTransferReasonQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseTransferReasonQuery, GqlWarehouseTransferReasonQueryVariables>(WarehouseTransferReasonDocument, baseOptions);
        }
export type WarehouseTransferReasonQueryHookResult = ReturnType<typeof useWarehouseTransferReasonQuery>;
export type WarehouseTransferReasonLazyQueryHookResult = ReturnType<typeof useWarehouseTransferReasonLazyQuery>;
export type WarehouseTransferReasonQueryResult = Apollo.QueryResult<GqlWarehouseTransferReasonQuery, GqlWarehouseTransferReasonQueryVariables>;
export const StockTakeDocument = gql`
    query StockTake($search: String, $per_page: Int, $page: Int, $filters: GenericScalar, $distribution_center_id: String!) {
  paginated_product_items_v2(
    filters: $filters
    search: $search
    per_page: $per_page
    page: $page
  ) {
    page_info {
      per_page
      total_count
      total_pages
      current_page
    }
    edges {
      node {
        active
        product_item_name
        product_item_id
        product {
          product_name
        }
        units_of_measure {
          business_domain {
            domain_name
          }
          uom {
            abbreviation
            uom_id
          }
        }
        inventory(distribution_center_id: $distribution_center_id) {
          storage_quantity
          inventory_quantity
          verified_quantity
          distribution_center_id
        }
      }
    }
  }
}
    `;

/**
 * __useStockTakeQuery__
 *
 * To run a query within a React component, call `useStockTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTakeQuery({
 *   variables: {
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      distribution_center_id: // value for 'distribution_center_id'
 *   },
 * });
 */
export function useStockTakeQuery(baseOptions: Apollo.QueryHookOptions<GqlStockTakeQuery, GqlStockTakeQueryVariables>) {
        return Apollo.useQuery<GqlStockTakeQuery, GqlStockTakeQueryVariables>(StockTakeDocument, baseOptions);
      }
export function useStockTakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockTakeQuery, GqlStockTakeQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockTakeQuery, GqlStockTakeQueryVariables>(StockTakeDocument, baseOptions);
        }
export type StockTakeQueryHookResult = ReturnType<typeof useStockTakeQuery>;
export type StockTakeLazyQueryHookResult = ReturnType<typeof useStockTakeLazyQuery>;
export type StockTakeQueryResult = Apollo.QueryResult<GqlStockTakeQuery, GqlStockTakeQueryVariables>;
export const StockIntakesDocument = gql`
    query StockIntakes($page: Int, $per_page: Int, $search: String, $filter: GenericScalar) {
  stock_intakes(
    page: $page
    per_page: $per_page
    search: $search
    filter: $filter
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        stock_intake_id
        stock_intake_number
        stock_intake_status
        date_created
        created_by
        user {
          user_id
          first_name
          last_name
        }
        appointment_id
        appointment {
          appointment_number
          vehicle_seal_number
          dock_door {
            dock_door_number
          }
          distribution_center_id
          distribution_center {
            distribution_center_name
          }
          appointment_items {
            booking_id
            booking {
              farmer_id
              farmer {
                first_name
                last_name
                farmer_number
                supplier_name
                farmer_id
              }
              booking_items {
                product_item_id
                product_item {
                  product_item_name
                  product_id
                  product {
                    product_name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useStockIntakesQuery__
 *
 * To run a query within a React component, call `useStockIntakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStockIntakesQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakesQuery, GqlStockIntakesQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakesQuery, GqlStockIntakesQueryVariables>(StockIntakesDocument, baseOptions);
      }
export function useStockIntakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakesQuery, GqlStockIntakesQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakesQuery, GqlStockIntakesQueryVariables>(StockIntakesDocument, baseOptions);
        }
export type StockIntakesQueryHookResult = ReturnType<typeof useStockIntakesQuery>;
export type StockIntakesLazyQueryHookResult = ReturnType<typeof useStockIntakesLazyQuery>;
export type StockIntakesQueryResult = Apollo.QueryResult<GqlStockIntakesQuery, GqlStockIntakesQueryVariables>;
export const StockIntakeItemsDocument = gql`
    query StockIntakeItems($per_page: Int, $search: String, $filter: GenericScalar) {
  stock_intakes(per_page: $per_page, search: $search, filter: $filter) {
    edges {
      node {
        active
        stock_intake_id
        stock_intake_number
        stock_intake_skus {
          product_item_id
          product_item {
            product_id
            product {
              product_name
            }
            product_item_name
            units_of_measure {
              business_domain {
                domain_name
              }
              uom_id
              conversion_ratio
            }
          }
        }
        stock_intake_items {
          stock_intake_item_id
          batch_id
          quantity
          active
          weight
          product_item_id
          product_item {
            product_id
            product {
              product_name
            }
            product_item_name
            units_of_measure {
              business_domain {
                domain_name
              }
              conversion_ratio
            }
          }
          unit_of_measure_id
          uom {
            name
          }
          booking_id
          booking {
            price
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStockIntakeItemsQuery__
 *
 * To run a query within a React component, call `useStockIntakeItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeItemsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStockIntakeItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeItemsQuery, GqlStockIntakeItemsQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeItemsQuery, GqlStockIntakeItemsQueryVariables>(StockIntakeItemsDocument, baseOptions);
      }
export function useStockIntakeItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeItemsQuery, GqlStockIntakeItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeItemsQuery, GqlStockIntakeItemsQueryVariables>(StockIntakeItemsDocument, baseOptions);
        }
export type StockIntakeItemsQueryHookResult = ReturnType<typeof useStockIntakeItemsQuery>;
export type StockIntakeItemsLazyQueryHookResult = ReturnType<typeof useStockIntakeItemsLazyQuery>;
export type StockIntakeItemsQueryResult = Apollo.QueryResult<GqlStockIntakeItemsQuery, GqlStockIntakeItemsQueryVariables>;
export const StockIntakeSkusDocument = gql`
    query StockIntakeSkus($page: Int, $filter: GenericScalar, $per_page: Int, $search: String) {
  stock_intake_skus(
    page: $page
    filter: $filter
    per_page: $per_page
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        stock_intake_sku_id
        stock_intake_id
        product_item_id
        supplier_batch_number
        stock_date
        order_by_date
        stock_availability_status
        rejected_quantity
        rejection_reason
        product_item {
          product_id
          product {
            product_name
          }
          product_item_name
          units_of_measure {
            business_domain {
              domain_name
            }
            uom {
              name
            }
          }
        }
        stock_intake {
          stock_intake_status
          stock_intake_items {
            active
            weight
            stock_intake_item_assets {
              stock_intake_item_asset_id
              quantity
            }
            quantity
            unit_of_measure_id
            uom {
              name
            }
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
          }
          appointment_id
          appointment {
            appointment_items {
              active
              appointment_id
              warehouse_transfer_id
              batch_id
              booking_id
              return_id
              warehouse_transfer {
                warehouse_transfer_id
                warehouse_transfer_items {
                  active
                  product_item_id
                  product_item {
                    product_item_name
                    product {
                      product_name
                    }
                  }
                  quantity
                  weight
                }
              }
              returns {
                active
                return_id
                product_return_items {
                  active
                  product_item_id
                  product_item {
                    product_item_name
                    product {
                      product_name
                    }
                  }
                  quantity
                  weight
                }
              }
              booking {
                booking_id
                booking_items {
                  active
                  product_item_id
                  product_item {
                    product_item_name
                    product {
                      product_name
                    }
                  }
                  quantity
                  weight
                }
              }
              batch {
                batch_name
                batch_id
                harvests {
                  original_currency
                  harvest_items {
                    product_item_id
                    quantity
                    weight
                    product_item {
                      product_item_name
                      product {
                        product_name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useStockIntakeSkusQuery__
 *
 * To run a query within a React component, call `useStockIntakeSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeSkusQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useStockIntakeSkusQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeSkusQuery, GqlStockIntakeSkusQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeSkusQuery, GqlStockIntakeSkusQueryVariables>(StockIntakeSkusDocument, baseOptions);
      }
export function useStockIntakeSkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeSkusQuery, GqlStockIntakeSkusQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeSkusQuery, GqlStockIntakeSkusQueryVariables>(StockIntakeSkusDocument, baseOptions);
        }
export type StockIntakeSkusQueryHookResult = ReturnType<typeof useStockIntakeSkusQuery>;
export type StockIntakeSkusLazyQueryHookResult = ReturnType<typeof useStockIntakeSkusLazyQuery>;
export type StockIntakeSkusQueryResult = Apollo.QueryResult<GqlStockIntakeSkusQuery, GqlStockIntakeSkusQueryVariables>;
export const StockIntakeByIdDocument = gql`
    query StockIntakeById($stock_intake_id: String) {
  stock_intake_by_id(stock_intake_id: $stock_intake_id) {
    active
    stock_intake_number
    stock_intake_id
    stock_intake_photos {
      intake_photo_id
    }
    stock_intake_users {
      active
      user_id
      stock_intake_user_id
      user {
        first_name
        last_name
      }
    }
    appointment_id
    appointment {
      appointment_number
      vehicle_registration
      vehicle_seal_number
      driver_name
      issued_by
      issued_by_user {
        first_name
        last_name
      }
      dock_door {
        dock_door_number
        dock_door_id
      }
      distribution_center_id
      distribution_center {
        distribution_center_name
      }
      appointment_items {
        active
        appointment_id
        warehouse_transfer_id
        batch_id
        booking_id
        return_id
        warehouse_transfer {
          warehouse_transfer_id
          warehouse_transfer_items {
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            unit_of_measure_id
            uom {
              name
            }
            quantity
          }
        }
        returns {
          active
          return_id
          product_return_items {
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            quantity
            unit_of_measure_id
            uom {
              name
            }
          }
        }
        booking {
          booking_id
          farmer_id
          farmer {
            first_name
            last_name
            farmer_number
          }
          booking_items {
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            quantity
            unit_of_measure_id
            uom {
              name
            }
          }
        }
        batch {
          batch_name
          batch_id
          harvests {
            original_currency
            farmer_id
            farmer {
              first_name
              last_name
              farmer_number
            }
            harvest_items {
              product_item_id
              quantity
              unit_of_measure_id
              uom {
                name
              }
              product_item {
                product_item_name
                product {
                  product_name
                }
              }
            }
          }
        }
      }
    }
    date_created
    created_by
    user {
      first_name
      last_name
    }
    stock_intake_status
    decline_reason
    stock_intake_items {
      stock_intake_item_id
      quantity
      active
      weight
      product_item_id
      product_item {
        product_id
        product {
          product_name
        }
        product_item_name
      }
      unit_of_measure_id
      uom {
        name
      }
      pallet_id
      pallet {
        asset_number
      }
      stock_intake_item_status
    }
  }
}
    `;

/**
 * __useStockIntakeByIdQuery__
 *
 * To run a query within a React component, call `useStockIntakeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeByIdQuery({
 *   variables: {
 *      stock_intake_id: // value for 'stock_intake_id'
 *   },
 * });
 */
export function useStockIntakeByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeByIdQuery, GqlStockIntakeByIdQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeByIdQuery, GqlStockIntakeByIdQueryVariables>(StockIntakeByIdDocument, baseOptions);
      }
export function useStockIntakeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeByIdQuery, GqlStockIntakeByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeByIdQuery, GqlStockIntakeByIdQueryVariables>(StockIntakeByIdDocument, baseOptions);
        }
export type StockIntakeByIdQueryHookResult = ReturnType<typeof useStockIntakeByIdQuery>;
export type StockIntakeByIdLazyQueryHookResult = ReturnType<typeof useStockIntakeByIdLazyQuery>;
export type StockIntakeByIdQueryResult = Apollo.QueryResult<GqlStockIntakeByIdQuery, GqlStockIntakeByIdQueryVariables>;
export const StockIntakeStatusDocument = gql`
    query StockIntakeStatus {
  stock_intake_status
}
    `;

/**
 * __useStockIntakeStatusQuery__
 *
 * To run a query within a React component, call `useStockIntakeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useStockIntakeStatusQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeStatusQuery, GqlStockIntakeStatusQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeStatusQuery, GqlStockIntakeStatusQueryVariables>(StockIntakeStatusDocument, baseOptions);
      }
export function useStockIntakeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeStatusQuery, GqlStockIntakeStatusQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeStatusQuery, GqlStockIntakeStatusQueryVariables>(StockIntakeStatusDocument, baseOptions);
        }
export type StockIntakeStatusQueryHookResult = ReturnType<typeof useStockIntakeStatusQuery>;
export type StockIntakeStatusLazyQueryHookResult = ReturnType<typeof useStockIntakeStatusLazyQuery>;
export type StockIntakeStatusQueryResult = Apollo.QueryResult<GqlStockIntakeStatusQuery, GqlStockIntakeStatusQueryVariables>;
export const StockAvailabilityStatusDocument = gql`
    query StockAvailabilityStatus {
  stock_availability_status
}
    `;

/**
 * __useStockAvailabilityStatusQuery__
 *
 * To run a query within a React component, call `useStockAvailabilityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockAvailabilityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockAvailabilityStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useStockAvailabilityStatusQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockAvailabilityStatusQuery, GqlStockAvailabilityStatusQueryVariables>) {
        return Apollo.useQuery<GqlStockAvailabilityStatusQuery, GqlStockAvailabilityStatusQueryVariables>(StockAvailabilityStatusDocument, baseOptions);
      }
export function useStockAvailabilityStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockAvailabilityStatusQuery, GqlStockAvailabilityStatusQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockAvailabilityStatusQuery, GqlStockAvailabilityStatusQueryVariables>(StockAvailabilityStatusDocument, baseOptions);
        }
export type StockAvailabilityStatusQueryHookResult = ReturnType<typeof useStockAvailabilityStatusQuery>;
export type StockAvailabilityStatusLazyQueryHookResult = ReturnType<typeof useStockAvailabilityStatusLazyQuery>;
export type StockAvailabilityStatusQueryResult = Apollo.QueryResult<GqlStockAvailabilityStatusQuery, GqlStockAvailabilityStatusQueryVariables>;
export const IntakesPutAwayJobsDocument = gql`
    query IntakesPutAwayJobs($page: Int, $per_page: Int, $search: String, $filter: GenericScalar) {
  putaway_jobs(page: $page, per_page: $per_page, search: $search, filter: $filter) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        stock_intake_id
        job_id
        job_number
        job_status
        assigned_to
        assigned {
          first_name
          last_name
        }
        product_item_id
        product_item {
          product_item_name
          product {
            product_name
          }
        }
        destination_handling_unit {
          handling_unit_id
          quantity
          asset {
            asset_number
            asset_type {
              asset_type_name
            }
          }
        }
        source_location_id
        source_location {
          dock_door {
            dock_door_number
          }
        }
        destination_location {
          bin {
            aisle
            bin_position
            level
            bin_names {
              bin_name_direction
              aisle
              bin_position
              level
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useIntakesPutAwayJobsQuery__
 *
 * To run a query within a React component, call `useIntakesPutAwayJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntakesPutAwayJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntakesPutAwayJobsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntakesPutAwayJobsQuery(baseOptions?: Apollo.QueryHookOptions<GqlIntakesPutAwayJobsQuery, GqlIntakesPutAwayJobsQueryVariables>) {
        return Apollo.useQuery<GqlIntakesPutAwayJobsQuery, GqlIntakesPutAwayJobsQueryVariables>(IntakesPutAwayJobsDocument, baseOptions);
      }
export function useIntakesPutAwayJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlIntakesPutAwayJobsQuery, GqlIntakesPutAwayJobsQueryVariables>) {
          return Apollo.useLazyQuery<GqlIntakesPutAwayJobsQuery, GqlIntakesPutAwayJobsQueryVariables>(IntakesPutAwayJobsDocument, baseOptions);
        }
export type IntakesPutAwayJobsQueryHookResult = ReturnType<typeof useIntakesPutAwayJobsQuery>;
export type IntakesPutAwayJobsLazyQueryHookResult = ReturnType<typeof useIntakesPutAwayJobsLazyQuery>;
export type IntakesPutAwayJobsQueryResult = Apollo.QueryResult<GqlIntakesPutAwayJobsQuery, GqlIntakesPutAwayJobsQueryVariables>;
export const StockIntakeUsersDocument = gql`
    query StockIntakeUsers($stock_intake_id: String) {
  stock_intake_by_id(stock_intake_id: $stock_intake_id) {
    stock_intake_id
    stock_intake_users {
      active
      user_id
      stock_intake_user_id
      user {
        active
        first_name
        last_name
      }
    }
  }
}
    `;

/**
 * __useStockIntakeUsersQuery__
 *
 * To run a query within a React component, call `useStockIntakeUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockIntakeUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockIntakeUsersQuery({
 *   variables: {
 *      stock_intake_id: // value for 'stock_intake_id'
 *   },
 * });
 */
export function useStockIntakeUsersQuery(baseOptions?: Apollo.QueryHookOptions<GqlStockIntakeUsersQuery, GqlStockIntakeUsersQueryVariables>) {
        return Apollo.useQuery<GqlStockIntakeUsersQuery, GqlStockIntakeUsersQueryVariables>(StockIntakeUsersDocument, baseOptions);
      }
export function useStockIntakeUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStockIntakeUsersQuery, GqlStockIntakeUsersQueryVariables>) {
          return Apollo.useLazyQuery<GqlStockIntakeUsersQuery, GqlStockIntakeUsersQueryVariables>(StockIntakeUsersDocument, baseOptions);
        }
export type StockIntakeUsersQueryHookResult = ReturnType<typeof useStockIntakeUsersQuery>;
export type StockIntakeUsersLazyQueryHookResult = ReturnType<typeof useStockIntakeUsersLazyQuery>;
export type StockIntakeUsersQueryResult = Apollo.QueryResult<GqlStockIntakeUsersQuery, GqlStockIntakeUsersQueryVariables>;
export const PutAwayJobsDocument = gql`
    query PutAwayJobs($page: Int, $per_page: Int, $search: String, $filter: GenericScalar) {
  putaway_jobs(page: $page, per_page: $per_page, search: $search, filter: $filter) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...PutAwayJobs
        date_created
        close_time
        start_time
        stock_intake {
          stock_intake_number
          stock_intake_id
        }
        stock_intake_item_id
        cancelled
      }
    }
  }
}
    ${PaginationFragmentDoc}
${PutAwayJobsFragmentDoc}`;

/**
 * __usePutAwayJobsQuery__
 *
 * To run a query within a React component, call `usePutAwayJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePutAwayJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePutAwayJobsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePutAwayJobsQuery(baseOptions?: Apollo.QueryHookOptions<GqlPutAwayJobsQuery, GqlPutAwayJobsQueryVariables>) {
        return Apollo.useQuery<GqlPutAwayJobsQuery, GqlPutAwayJobsQueryVariables>(PutAwayJobsDocument, baseOptions);
      }
export function usePutAwayJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPutAwayJobsQuery, GqlPutAwayJobsQueryVariables>) {
          return Apollo.useLazyQuery<GqlPutAwayJobsQuery, GqlPutAwayJobsQueryVariables>(PutAwayJobsDocument, baseOptions);
        }
export type PutAwayJobsQueryHookResult = ReturnType<typeof usePutAwayJobsQuery>;
export type PutAwayJobsLazyQueryHookResult = ReturnType<typeof usePutAwayJobsLazyQuery>;
export type PutAwayJobsQueryResult = Apollo.QueryResult<GqlPutAwayJobsQuery, GqlPutAwayJobsQueryVariables>;
export const AllReservePickingJobsDocument = gql`
    query AllReservePickingJobs($search: String, $filter: GenericScalar, $per_page: Int, $page: Int) {
  reserve_picking_jobs(
    search: $search
    per_page: $per_page
    page: $page
    filter: $filter
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...ReservePickingJobsFragment
        date_created
        close_time
        start_time
        job_type
        warehouse_transfer_request_id
        warehouse_transfer_request {
          warehouse_transfer_request_number
        }
        fdr_id
        fdr {
          fdr_number
        }
        destination_location {
          dock_door {
            dock_door_number
          }
          bin {
            aisle
            bin_position
            level
            bin_names {
              bin_name_direction
              aisle
              bin_position
              level
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}
${ReservePickingJobsFragmentFragmentDoc}`;

/**
 * __useAllReservePickingJobsQuery__
 *
 * To run a query within a React component, call `useAllReservePickingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReservePickingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReservePickingJobsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAllReservePickingJobsQuery(baseOptions?: Apollo.QueryHookOptions<GqlAllReservePickingJobsQuery, GqlAllReservePickingJobsQueryVariables>) {
        return Apollo.useQuery<GqlAllReservePickingJobsQuery, GqlAllReservePickingJobsQueryVariables>(AllReservePickingJobsDocument, baseOptions);
      }
export function useAllReservePickingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAllReservePickingJobsQuery, GqlAllReservePickingJobsQueryVariables>) {
          return Apollo.useLazyQuery<GqlAllReservePickingJobsQuery, GqlAllReservePickingJobsQueryVariables>(AllReservePickingJobsDocument, baseOptions);
        }
export type AllReservePickingJobsQueryHookResult = ReturnType<typeof useAllReservePickingJobsQuery>;
export type AllReservePickingJobsLazyQueryHookResult = ReturnType<typeof useAllReservePickingJobsLazyQuery>;
export type AllReservePickingJobsQueryResult = Apollo.QueryResult<GqlAllReservePickingJobsQuery, GqlAllReservePickingJobsQueryVariables>;
export const ProductItemPickfacesBinDocument = gql`
    query ProductItemPickfacesBin($page: Int, $per_page: Int, $search: String, $filter: GenericScalar) {
  bins(search: $search, filter: $filter, page: $page, per_page: $per_page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        pickface_product_item_id
        active
        bin_type
        is_pickface
        storage_location_id
        storage_location {
          storage_location_number
        }
        capacity
        bin_id
        product_zone {
          active
          product_zone_id
          product_zone_name
        }
        pickface_product_item {
          product_item_id
          product_item_name
          product_id
          product {
            product_name
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProductItemPickfacesBinQuery__
 *
 * To run a query within a React component, call `useProductItemPickfacesBinQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductItemPickfacesBinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductItemPickfacesBinQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductItemPickfacesBinQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductItemPickfacesBinQuery, GqlProductItemPickfacesBinQueryVariables>) {
        return Apollo.useQuery<GqlProductItemPickfacesBinQuery, GqlProductItemPickfacesBinQueryVariables>(ProductItemPickfacesBinDocument, baseOptions);
      }
export function useProductItemPickfacesBinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductItemPickfacesBinQuery, GqlProductItemPickfacesBinQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductItemPickfacesBinQuery, GqlProductItemPickfacesBinQueryVariables>(ProductItemPickfacesBinDocument, baseOptions);
        }
export type ProductItemPickfacesBinQueryHookResult = ReturnType<typeof useProductItemPickfacesBinQuery>;
export type ProductItemPickfacesBinLazyQueryHookResult = ReturnType<typeof useProductItemPickfacesBinLazyQuery>;
export type ProductItemPickfacesBinQueryResult = Apollo.QueryResult<GqlProductItemPickfacesBinQuery, GqlProductItemPickfacesBinQueryVariables>;
export const LocationsDocument = gql`
    query Locations($search: String) {
  storage_locations(search: $search) {
    edges {
      node {
        status
        storage_location_id
        storage_location_number
        active
        bin {
          bin_id
          capacity
          is_pickface
          product_zone {
            active
            product_zone_id
            product_zone_name
          }
        }
        location_type {
          location_type_name
        }
        handling_units {
          quantity
          stock_date
          stock_availability_status
          order_by_date
          active
          handling_unit_id
          asset {
            asset_id
            asset_number
          }
          handling_unit_items {
            dispatched
            active
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
            }
            handling_unit_item_id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GqlLocationsQuery, GqlLocationsQueryVariables>) {
        return Apollo.useQuery<GqlLocationsQuery, GqlLocationsQueryVariables>(LocationsDocument, baseOptions);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlLocationsQuery, GqlLocationsQueryVariables>) {
          return Apollo.useLazyQuery<GqlLocationsQuery, GqlLocationsQueryVariables>(LocationsDocument, baseOptions);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<GqlLocationsQuery, GqlLocationsQueryVariables>;
export const ProductLocationsDocument = gql`
    query ProductLocations($per_page: Int, $page: Int, $product_item_id: String, $storage_location_number: String) {
  product_locations(
    per_page: $per_page
    page: $page
    product_item_id: $product_item_id
    storage_location_number: $storage_location_number
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        storage_location_id
        storage_location_number
        product_item_id
        product_item {
          product_id
          product {
            product_id
            product_name
          }
          image_url
          product_item_name
        }
        hu_count
        hui_count
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProductLocationsQuery__
 *
 * To run a query within a React component, call `useProductLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLocationsQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      product_item_id: // value for 'product_item_id'
 *      storage_location_number: // value for 'storage_location_number'
 *   },
 * });
 */
export function useProductLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductLocationsQuery, GqlProductLocationsQueryVariables>) {
        return Apollo.useQuery<GqlProductLocationsQuery, GqlProductLocationsQueryVariables>(ProductLocationsDocument, baseOptions);
      }
export function useProductLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductLocationsQuery, GqlProductLocationsQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductLocationsQuery, GqlProductLocationsQueryVariables>(ProductLocationsDocument, baseOptions);
        }
export type ProductLocationsQueryHookResult = ReturnType<typeof useProductLocationsQuery>;
export type ProductLocationsLazyQueryHookResult = ReturnType<typeof useProductLocationsLazyQuery>;
export type ProductLocationsQueryResult = Apollo.QueryResult<GqlProductLocationsQuery, GqlProductLocationsQueryVariables>;
export const ProductTransferReasonsDocument = gql`
    query ProductTransferReasons {
  product_transfer_reasons {
    edges {
      node {
        product_transfer_reason_id
        product_transfer_reason_name
      }
    }
  }
}
    `;

/**
 * __useProductTransferReasonsQuery__
 *
 * To run a query within a React component, call `useProductTransferReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTransferReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTransferReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductTransferReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductTransferReasonsQuery, GqlProductTransferReasonsQueryVariables>) {
        return Apollo.useQuery<GqlProductTransferReasonsQuery, GqlProductTransferReasonsQueryVariables>(ProductTransferReasonsDocument, baseOptions);
      }
export function useProductTransferReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductTransferReasonsQuery, GqlProductTransferReasonsQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductTransferReasonsQuery, GqlProductTransferReasonsQueryVariables>(ProductTransferReasonsDocument, baseOptions);
        }
export type ProductTransferReasonsQueryHookResult = ReturnType<typeof useProductTransferReasonsQuery>;
export type ProductTransferReasonsLazyQueryHookResult = ReturnType<typeof useProductTransferReasonsLazyQuery>;
export type ProductTransferReasonsQueryResult = Apollo.QueryResult<GqlProductTransferReasonsQuery, GqlProductTransferReasonsQueryVariables>;
export const HandlingUnitItemsDocument = gql`
    query HandlingUnitItems($filter: GenericScalar) {
  handling_unit_items(filter: $filter) {
    edges {
      node {
        active
        handling_unit_item_id
        quantity
        dispatched
        asset {
          asset_type {
            asset_type_name
          }
          asset_number
        }
        storage_location {
          location_type {
            location_type_name
          }
          storage_location_number
        }
        handling_unit {
          asset {
            asset_type {
              asset_type_name
            }
            asset_number
          }
        }
        stock_date
        stock_availability_status
        order_by_date
        product_item_id
        product_item {
          product_item_name
          product_id
          product {
            product_name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHandlingUnitItemsQuery__
 *
 * To run a query within a React component, call `useHandlingUnitItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandlingUnitItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandlingUnitItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHandlingUnitItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlHandlingUnitItemsQuery, GqlHandlingUnitItemsQueryVariables>) {
        return Apollo.useQuery<GqlHandlingUnitItemsQuery, GqlHandlingUnitItemsQueryVariables>(HandlingUnitItemsDocument, baseOptions);
      }
export function useHandlingUnitItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlHandlingUnitItemsQuery, GqlHandlingUnitItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlHandlingUnitItemsQuery, GqlHandlingUnitItemsQueryVariables>(HandlingUnitItemsDocument, baseOptions);
        }
export type HandlingUnitItemsQueryHookResult = ReturnType<typeof useHandlingUnitItemsQuery>;
export type HandlingUnitItemsLazyQueryHookResult = ReturnType<typeof useHandlingUnitItemsLazyQuery>;
export type HandlingUnitItemsQueryResult = Apollo.QueryResult<GqlHandlingUnitItemsQuery, GqlHandlingUnitItemsQueryVariables>;
export const AssetsDocument = gql`
    query Assets($filter: GenericScalar) {
  assets(filter: $filter) {
    edges {
      node {
        asset_id
        active
        asset_number
        asset_type_id
        asset_type {
          asset_type_name
        }
        handling_units {
          active
          quantity
          storage_location_id
          stock_availability_status
          stock_date
          order_by_date
          storage_location {
            location_type {
              location_type_name
            }
            storage_location_number
          }
          handling_unit_id
          quantity
          asset {
            asset_id
            asset_number
            asset_type {
              asset_type_name
            }
          }
          handling_unit_items {
            dispatched
            storage_location_id
            active
            asset {
              asset_id
              asset_number
              asset_type {
                asset_type_name
              }
            }
            product_item_id
            product_item {
              product_id
              product_item_id
              product_item_name
              product_id
              product {
                product_name
              }
            }
            handling_unit_id
            handling_unit_item_id
            date_updated
            order_by_date
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GqlAssetsQuery, GqlAssetsQueryVariables>) {
        return Apollo.useQuery<GqlAssetsQuery, GqlAssetsQueryVariables>(AssetsDocument, baseOptions);
      }
export function useAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAssetsQuery, GqlAssetsQueryVariables>) {
          return Apollo.useLazyQuery<GqlAssetsQuery, GqlAssetsQueryVariables>(AssetsDocument, baseOptions);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsQueryResult = Apollo.QueryResult<GqlAssetsQuery, GqlAssetsQueryVariables>;
export const OrderFulfilmentDocument = gql`
    query OrderFulfilment($search: String, $orderFulfilmentFilters: GenericScalar, $per_page: Int, $page: Int) {
  fulfilment_dispatch_requests(
    search: $search
    per_page: $per_page
    page: $page
    filter: $orderFulfilmentFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...FulfilmentDispatchReQuest
        distribution_center_id
        distribution_center {
          distribution_center_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}
${FulfilmentDispatchReQuestFragmentDoc}`;

/**
 * __useOrderFulfilmentQuery__
 *
 * To run a query within a React component, call `useOrderFulfilmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfilmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFulfilmentQuery({
 *   variables: {
 *      search: // value for 'search'
 *      orderFulfilmentFilters: // value for 'orderFulfilmentFilters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrderFulfilmentQuery(baseOptions?: Apollo.QueryHookOptions<GqlOrderFulfilmentQuery, GqlOrderFulfilmentQueryVariables>) {
        return Apollo.useQuery<GqlOrderFulfilmentQuery, GqlOrderFulfilmentQueryVariables>(OrderFulfilmentDocument, baseOptions);
      }
export function useOrderFulfilmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrderFulfilmentQuery, GqlOrderFulfilmentQueryVariables>) {
          return Apollo.useLazyQuery<GqlOrderFulfilmentQuery, GqlOrderFulfilmentQueryVariables>(OrderFulfilmentDocument, baseOptions);
        }
export type OrderFulfilmentQueryHookResult = ReturnType<typeof useOrderFulfilmentQuery>;
export type OrderFulfilmentLazyQueryHookResult = ReturnType<typeof useOrderFulfilmentLazyQuery>;
export type OrderFulfilmentQueryResult = Apollo.QueryResult<GqlOrderFulfilmentQuery, GqlOrderFulfilmentQueryVariables>;
export const OrderFulfilmentByIdDocument = gql`
    query OrderFulfilmentById($search: String, $orderFulfilmentFilters: GenericScalar, $per_page: Int) {
  fulfilment_dispatch_requests(
    search: $search
    per_page: $per_page
    filter: $orderFulfilmentFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...FulfilmentDispatchReQuest
        ...FDRSkus
        loading_task {
          loaded_quantity {
            quantity
          }
        }
        created_by
        created_by_user {
          first_name
          last_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}
${FulfilmentDispatchReQuestFragmentDoc}
${FdrSkusFragmentDoc}`;

/**
 * __useOrderFulfilmentByIdQuery__
 *
 * To run a query within a React component, call `useOrderFulfilmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfilmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFulfilmentByIdQuery({
 *   variables: {
 *      search: // value for 'search'
 *      orderFulfilmentFilters: // value for 'orderFulfilmentFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useOrderFulfilmentByIdQuery(baseOptions?: Apollo.QueryHookOptions<GqlOrderFulfilmentByIdQuery, GqlOrderFulfilmentByIdQueryVariables>) {
        return Apollo.useQuery<GqlOrderFulfilmentByIdQuery, GqlOrderFulfilmentByIdQueryVariables>(OrderFulfilmentByIdDocument, baseOptions);
      }
export function useOrderFulfilmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrderFulfilmentByIdQuery, GqlOrderFulfilmentByIdQueryVariables>) {
          return Apollo.useLazyQuery<GqlOrderFulfilmentByIdQuery, GqlOrderFulfilmentByIdQueryVariables>(OrderFulfilmentByIdDocument, baseOptions);
        }
export type OrderFulfilmentByIdQueryHookResult = ReturnType<typeof useOrderFulfilmentByIdQuery>;
export type OrderFulfilmentByIdLazyQueryHookResult = ReturnType<typeof useOrderFulfilmentByIdLazyQuery>;
export type OrderFulfilmentByIdQueryResult = Apollo.QueryResult<GqlOrderFulfilmentByIdQuery, GqlOrderFulfilmentByIdQueryVariables>;
export const OrderFulfilmentByIdSummaryDocument = gql`
    query OrderFulfilmentByIdSummary($orderFulfilmentFilters: GenericScalar) {
  fulfilment_dispatch_requests(filter: $orderFulfilmentFilters) {
    edges {
      node {
        ...FulfilmentDispatchReQuest
        ...FDRSkus
        reserve_picking_jobs {
          job_status
          job_id
          quantity
        }
        pickface_picking_tasks {
          task_id
          quantity
          balance
          product_item_id
          product_item {
            product_item_name
            product {
              product_name
            }
          }
        }
      }
    }
  }
}
    ${FulfilmentDispatchReQuestFragmentDoc}
${FdrSkusFragmentDoc}`;

/**
 * __useOrderFulfilmentByIdSummaryQuery__
 *
 * To run a query within a React component, call `useOrderFulfilmentByIdSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfilmentByIdSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFulfilmentByIdSummaryQuery({
 *   variables: {
 *      orderFulfilmentFilters: // value for 'orderFulfilmentFilters'
 *   },
 * });
 */
export function useOrderFulfilmentByIdSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GqlOrderFulfilmentByIdSummaryQuery, GqlOrderFulfilmentByIdSummaryQueryVariables>) {
        return Apollo.useQuery<GqlOrderFulfilmentByIdSummaryQuery, GqlOrderFulfilmentByIdSummaryQueryVariables>(OrderFulfilmentByIdSummaryDocument, baseOptions);
      }
export function useOrderFulfilmentByIdSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrderFulfilmentByIdSummaryQuery, GqlOrderFulfilmentByIdSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GqlOrderFulfilmentByIdSummaryQuery, GqlOrderFulfilmentByIdSummaryQueryVariables>(OrderFulfilmentByIdSummaryDocument, baseOptions);
        }
export type OrderFulfilmentByIdSummaryQueryHookResult = ReturnType<typeof useOrderFulfilmentByIdSummaryQuery>;
export type OrderFulfilmentByIdSummaryLazyQueryHookResult = ReturnType<typeof useOrderFulfilmentByIdSummaryLazyQuery>;
export type OrderFulfilmentByIdSummaryQueryResult = Apollo.QueryResult<GqlOrderFulfilmentByIdSummaryQuery, GqlOrderFulfilmentByIdSummaryQueryVariables>;
export const FdrSkuDocument = gql`
    query FdrSKU($search: String, $fdrSkuFilters: GenericScalar, $per_page: Int, $page: Int) {
  fdr_skus(
    search: $search
    per_page: $per_page
    filter: $fdrSkuFilters
    page: $page
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        product_item_id
        available_stock
        inventory_balance
        loaded_quantity
        product_item {
          product_item_name
          product_id
          product {
            product_name
          }
        }
        quantity
        fdr_id
        fdr {
          reserve_picking_jobs {
            product_item_id
            job_status
            product_item {
              product_item_name
              product {
                product_name
              }
            }
          }
          reserve_picking_balance {
            balance
          }
          pickface_picking_tasks {
            quantity
            balance
            product_item_id
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useFdrSkuQuery__
 *
 * To run a query within a React component, call `useFdrSkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdrSkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdrSkuQuery({
 *   variables: {
 *      search: // value for 'search'
 *      fdrSkuFilters: // value for 'fdrSkuFilters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFdrSkuQuery(baseOptions?: Apollo.QueryHookOptions<GqlFdrSkuQuery, GqlFdrSkuQueryVariables>) {
        return Apollo.useQuery<GqlFdrSkuQuery, GqlFdrSkuQueryVariables>(FdrSkuDocument, baseOptions);
      }
export function useFdrSkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFdrSkuQuery, GqlFdrSkuQueryVariables>) {
          return Apollo.useLazyQuery<GqlFdrSkuQuery, GqlFdrSkuQueryVariables>(FdrSkuDocument, baseOptions);
        }
export type FdrSkuQueryHookResult = ReturnType<typeof useFdrSkuQuery>;
export type FdrSkuLazyQueryHookResult = ReturnType<typeof useFdrSkuLazyQuery>;
export type FdrSkuQueryResult = Apollo.QueryResult<GqlFdrSkuQuery, GqlFdrSkuQueryVariables>;
export const ReservePickingJobsDocument = gql`
    query ReservePickingJobs($search: String, $pickingJobsFilters: GenericScalar, $per_page: Int, $page: Int) {
  reserve_picking_jobs(
    search: $search
    per_page: $per_page
    page: $page
    filter: $pickingJobsFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        ...ReservePickingJobsFragment
      }
    }
  }
}
    ${PaginationFragmentDoc}
${ReservePickingJobsFragmentFragmentDoc}`;

/**
 * __useReservePickingJobsQuery__
 *
 * To run a query within a React component, call `useReservePickingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservePickingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservePickingJobsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pickingJobsFilters: // value for 'pickingJobsFilters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useReservePickingJobsQuery(baseOptions?: Apollo.QueryHookOptions<GqlReservePickingJobsQuery, GqlReservePickingJobsQueryVariables>) {
        return Apollo.useQuery<GqlReservePickingJobsQuery, GqlReservePickingJobsQueryVariables>(ReservePickingJobsDocument, baseOptions);
      }
export function useReservePickingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlReservePickingJobsQuery, GqlReservePickingJobsQueryVariables>) {
          return Apollo.useLazyQuery<GqlReservePickingJobsQuery, GqlReservePickingJobsQueryVariables>(ReservePickingJobsDocument, baseOptions);
        }
export type ReservePickingJobsQueryHookResult = ReturnType<typeof useReservePickingJobsQuery>;
export type ReservePickingJobsLazyQueryHookResult = ReturnType<typeof useReservePickingJobsLazyQuery>;
export type ReservePickingJobsQueryResult = Apollo.QueryResult<GqlReservePickingJobsQuery, GqlReservePickingJobsQueryVariables>;
export const WarehouseTransferRequestDocument = gql`
    query WarehouseTransferRequest($search: String, $warehouseFilters: GenericScalar, $per_page: Int) {
  warehouse_transfer_requests(
    search: $search
    per_page: $per_page
    filter: $warehouseFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        warehouse_transfer_request_id
        warehouse_transfer_request_number
        warehouse_transfer_request_complete
        vehicle_id
        vehicle {
          registration_number
        }
        date_created
        destination_dc_id
        destination_dc {
          distribution_center_name
        }
        dock_door_id
        dock_door {
          dock_door_number
          staging_area_name
          warehouse_id
          warehouse {
            warehouse_name
            distribution_center_id
            distribution_center {
              distribution_center_name
            }
          }
        }
        warehouse_transfer_request_items {
          warehouse_transfer_request_item_id
          quantity
          product_item_id
          product_item {
            product_item_name
            product {
              product_name
            }
            units_of_measure {
              business_domain {
                domain_name
                business_domain_id
              }
              uom {
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useWarehouseTransferRequestQuery__
 *
 * To run a query within a React component, call `useWarehouseTransferRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseTransferRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseTransferRequestQuery({
 *   variables: {
 *      search: // value for 'search'
 *      warehouseFilters: // value for 'warehouseFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useWarehouseTransferRequestQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehouseTransferRequestQuery, GqlWarehouseTransferRequestQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseTransferRequestQuery, GqlWarehouseTransferRequestQueryVariables>(WarehouseTransferRequestDocument, baseOptions);
      }
export function useWarehouseTransferRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseTransferRequestQuery, GqlWarehouseTransferRequestQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseTransferRequestQuery, GqlWarehouseTransferRequestQueryVariables>(WarehouseTransferRequestDocument, baseOptions);
        }
export type WarehouseTransferRequestQueryHookResult = ReturnType<typeof useWarehouseTransferRequestQuery>;
export type WarehouseTransferRequestLazyQueryHookResult = ReturnType<typeof useWarehouseTransferRequestLazyQuery>;
export type WarehouseTransferRequestQueryResult = Apollo.QueryResult<GqlWarehouseTransferRequestQuery, GqlWarehouseTransferRequestQueryVariables>;
export const WarehouseTransferRequestItemsDocument = gql`
    query WarehouseTransferRequestItems($search: String, $warehouseItemFilters: GenericScalar, $per_page: Int) {
  warehouse_transfer_request_items(
    search: $search
    per_page: $per_page
    filter: $warehouseItemFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        warehouse_transfer_request_id
        product_item_id
        product_item {
          product_item_name
          product_id
          product {
            product_name
          }
        }
        warehouse_transfer_request {
          reserve_picking_jobs {
            product_item_id
            job_status
            product_item {
              product_item_name
              product {
                product_name
              }
            }
          }
          reserve_picking_balance {
            balance
          }
          pickface_picking_tasks {
            quantity
            balance
            product_item_id
          }
        }
        quantity
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useWarehouseTransferRequestItemsQuery__
 *
 * To run a query within a React component, call `useWarehouseTransferRequestItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseTransferRequestItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseTransferRequestItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      warehouseItemFilters: // value for 'warehouseItemFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useWarehouseTransferRequestItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlWarehouseTransferRequestItemsQuery, GqlWarehouseTransferRequestItemsQueryVariables>) {
        return Apollo.useQuery<GqlWarehouseTransferRequestItemsQuery, GqlWarehouseTransferRequestItemsQueryVariables>(WarehouseTransferRequestItemsDocument, baseOptions);
      }
export function useWarehouseTransferRequestItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWarehouseTransferRequestItemsQuery, GqlWarehouseTransferRequestItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlWarehouseTransferRequestItemsQuery, GqlWarehouseTransferRequestItemsQueryVariables>(WarehouseTransferRequestItemsDocument, baseOptions);
        }
export type WarehouseTransferRequestItemsQueryHookResult = ReturnType<typeof useWarehouseTransferRequestItemsQuery>;
export type WarehouseTransferRequestItemsLazyQueryHookResult = ReturnType<typeof useWarehouseTransferRequestItemsLazyQuery>;
export type WarehouseTransferRequestItemsQueryResult = Apollo.QueryResult<GqlWarehouseTransferRequestItemsQuery, GqlWarehouseTransferRequestItemsQueryVariables>;
export const DisposalsDocument = gql`
    query Disposals($search: String, $disposalFilters: GenericScalar, $per_page: Int, $page: Int) {
  disposals(
    search: $search
    per_page: $per_page
    page: $page
    filter: $disposalFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        dock_door_id
        disposal_id
        active
        date_created
        disposal_number
        disposal_complete
        dock_door_id
        dock_door {
          dock_door_number
          warehouse_id
          warehouse {
            warehouse_name
            distribution_center_id
            distribution_center {
              distribution_center_name
            }
          }
        }
        disposal_items {
          quantity
          product_item_id
          product_item {
            product_item_name
            product {
              product_name
            }
            units_of_measure {
              business_domain {
                domain_name
                business_domain_id
              }
              uom {
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDisposalsQuery__
 *
 * To run a query within a React component, call `useDisposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisposalsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      disposalFilters: // value for 'disposalFilters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDisposalsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDisposalsQuery, GqlDisposalsQueryVariables>) {
        return Apollo.useQuery<GqlDisposalsQuery, GqlDisposalsQueryVariables>(DisposalsDocument, baseOptions);
      }
export function useDisposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDisposalsQuery, GqlDisposalsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDisposalsQuery, GqlDisposalsQueryVariables>(DisposalsDocument, baseOptions);
        }
export type DisposalsQueryHookResult = ReturnType<typeof useDisposalsQuery>;
export type DisposalsLazyQueryHookResult = ReturnType<typeof useDisposalsLazyQuery>;
export type DisposalsQueryResult = Apollo.QueryResult<GqlDisposalsQuery, GqlDisposalsQueryVariables>;
export const DisposalItemsDocument = gql`
    query DisposalItems($search: String, $disposalItemFilters: GenericScalar, $per_page: Int) {
  disposal_items(
    search: $search
    per_page: $per_page
    filter: $disposalItemFilters
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        disposal_item_id
        disposal_id
        product_item_id
        product_item {
          product_item_name
          product_id
          product {
            product_name
          }
        }
        quantity
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useDisposalItemsQuery__
 *
 * To run a query within a React component, call `useDisposalItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisposalItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisposalItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      disposalItemFilters: // value for 'disposalItemFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useDisposalItemsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDisposalItemsQuery, GqlDisposalItemsQueryVariables>) {
        return Apollo.useQuery<GqlDisposalItemsQuery, GqlDisposalItemsQueryVariables>(DisposalItemsDocument, baseOptions);
      }
export function useDisposalItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDisposalItemsQuery, GqlDisposalItemsQueryVariables>) {
          return Apollo.useLazyQuery<GqlDisposalItemsQuery, GqlDisposalItemsQueryVariables>(DisposalItemsDocument, baseOptions);
        }
export type DisposalItemsQueryHookResult = ReturnType<typeof useDisposalItemsQuery>;
export type DisposalItemsLazyQueryHookResult = ReturnType<typeof useDisposalItemsLazyQuery>;
export type DisposalItemsQueryResult = Apollo.QueryResult<GqlDisposalItemsQuery, GqlDisposalItemsQueryVariables>;
export const WmsReturnsDocument = gql`
    query WMSReturns($search: String, $returnsFilters: GenericScalar, $per_page: Int) {
  wms_returns(search: $search, per_page: $per_page, filter: $returnsFilters) {
    edges {
      node {
        wms_returns_number
        wms_returns_id
        appointment_id
        appointment {
          appointment_number
          vehicle_registration
          driver_name
          eta
          dock_door_id
          dock_door {
            dock_door_number
          }
          issued_by
          issued_by_user {
            first_name
            last_name
          }
          distribution_center_id
          distribution_center {
            distribution_center_name
          }
          appointment_items {
            return_id
            returns {
              product_return_items {
                quantity
                unit_of_measure_id
                uom {
                  name
                }
                product_item_id
                product_item {
                  product_item_name
                  product {
                    product_name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWmsReturnsQuery__
 *
 * To run a query within a React component, call `useWmsReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWmsReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWmsReturnsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      returnsFilters: // value for 'returnsFilters'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useWmsReturnsQuery(baseOptions?: Apollo.QueryHookOptions<GqlWmsReturnsQuery, GqlWmsReturnsQueryVariables>) {
        return Apollo.useQuery<GqlWmsReturnsQuery, GqlWmsReturnsQueryVariables>(WmsReturnsDocument, baseOptions);
      }
export function useWmsReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWmsReturnsQuery, GqlWmsReturnsQueryVariables>) {
          return Apollo.useLazyQuery<GqlWmsReturnsQuery, GqlWmsReturnsQueryVariables>(WmsReturnsDocument, baseOptions);
        }
export type WmsReturnsQueryHookResult = ReturnType<typeof useWmsReturnsQuery>;
export type WmsReturnsLazyQueryHookResult = ReturnType<typeof useWmsReturnsLazyQuery>;
export type WmsReturnsQueryResult = Apollo.QueryResult<GqlWmsReturnsQuery, GqlWmsReturnsQueryVariables>;
export const LoadingTasksDocument = gql`
    query LoadingTasks($search: String, $filters: GenericScalar, $per_page: Int, $page: Int) {
  loading_tasks(
    search: $search
    per_page: $per_page
    filter: $filters
    page: $page
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        status
        loading_number
        loaded_weight
        loading_task_id
        date_updated
        fdr {
          fdr_number
          dock_door {
            warehouse {
              distribution_center {
                distribution_center_name
              }
            }
          }
          fdr_items {
            route_id
            route {
              route_name
              depot_id
              depot {
                depot_name
              }
            }
            route_plan_id
            route_plan {
              vehicle_id
              vehicle {
                registration_number
              }
              depot_id
              depot {
                depot_name
              }
            }
          }
        }
        inventory_location_id
        inventory_location {
          inventory_location_name
        }
        total_loaded_quantity
        loading_task_items {
          handling_unit_item_id
          handling_unit_item {
            quantity
            product_item_id
            product_item {
              product_item_name
              product {
                product_name
              }
              units_of_measure {
                business_domain {
                  domain_name
                }
                uom {
                  name
                }
              }
            }
          }
        }
        picture
        created_by
        created_by_user {
          first_name
          last_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useLoadingTasksQuery__
 *
 * To run a query within a React component, call `useLoadingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadingTasksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useLoadingTasksQuery(baseOptions?: Apollo.QueryHookOptions<GqlLoadingTasksQuery, GqlLoadingTasksQueryVariables>) {
        return Apollo.useQuery<GqlLoadingTasksQuery, GqlLoadingTasksQueryVariables>(LoadingTasksDocument, baseOptions);
      }
export function useLoadingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlLoadingTasksQuery, GqlLoadingTasksQueryVariables>) {
          return Apollo.useLazyQuery<GqlLoadingTasksQuery, GqlLoadingTasksQueryVariables>(LoadingTasksDocument, baseOptions);
        }
export type LoadingTasksQueryHookResult = ReturnType<typeof useLoadingTasksQuery>;
export type LoadingTasksLazyQueryHookResult = ReturnType<typeof useLoadingTasksLazyQuery>;
export type LoadingTasksQueryResult = Apollo.QueryResult<GqlLoadingTasksQuery, GqlLoadingTasksQueryVariables>;
export const PickingHandlingUnitsDocument = gql`
    query PickingHandlingUnits($filters: GenericScalar, $per_page: Int, $page: Int) {
  picking_handling_units(filter: $filters, per_page: $per_page, page: $page) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        picking_hu_id
        dispatch_reference_id
        handling_unit_id
        final_location_id
        final_location {
          storage_location_number
        }
        handling_unit {
          asset {
            asset_number
          }
          storage_location_id
          storage_location {
            storage_location_number
          }
          updated_by
          updated_by_user {
            first_name
            last_name
          }
          handling_unit_items {
            storage_location_id
            storage_location {
              storage_location_number
            }
            asset {
              asset_number
            }
            product_item_id
            product_item {
              product_item_name
              product_id
              product {
                product_name
              }
            }
          }
        }
        is_complete
        picked_quantity
        handling_unit_id
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __usePickingHandlingUnitsQuery__
 *
 * To run a query within a React component, call `usePickingHandlingUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickingHandlingUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickingHandlingUnitsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePickingHandlingUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GqlPickingHandlingUnitsQuery, GqlPickingHandlingUnitsQueryVariables>) {
        return Apollo.useQuery<GqlPickingHandlingUnitsQuery, GqlPickingHandlingUnitsQueryVariables>(PickingHandlingUnitsDocument, baseOptions);
      }
export function usePickingHandlingUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPickingHandlingUnitsQuery, GqlPickingHandlingUnitsQueryVariables>) {
          return Apollo.useLazyQuery<GqlPickingHandlingUnitsQuery, GqlPickingHandlingUnitsQueryVariables>(PickingHandlingUnitsDocument, baseOptions);
        }
export type PickingHandlingUnitsQueryHookResult = ReturnType<typeof usePickingHandlingUnitsQuery>;
export type PickingHandlingUnitsLazyQueryHookResult = ReturnType<typeof usePickingHandlingUnitsLazyQuery>;
export type PickingHandlingUnitsQueryResult = Apollo.QueryResult<GqlPickingHandlingUnitsQuery, GqlPickingHandlingUnitsQueryVariables>;
export const ProductZonesDocument = gql`
    query ProductZones($per_page: Int, $page: Int, $filters: GenericScalar, $search: String) {
  product_zones(
    per_page: $per_page
    page: $page
    filter: $filters
    search: $search
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        product_zone_name
        product_zone_type
        product_zone_id
        product_zone_description
        rules {
          active
          rule_name
          rule_id
        }
        bins {
          active
          is_pickface
          capacity
          storage_location_id
          storage_location {
            status
          }
          bin_names {
            aisle
            level
            bin_position
            bin_id
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProductZonesQuery__
 *
 * To run a query within a React component, call `useProductZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductZonesQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductZonesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductZonesQuery, GqlProductZonesQueryVariables>) {
        return Apollo.useQuery<GqlProductZonesQuery, GqlProductZonesQueryVariables>(ProductZonesDocument, baseOptions);
      }
export function useProductZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductZonesQuery, GqlProductZonesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductZonesQuery, GqlProductZonesQueryVariables>(ProductZonesDocument, baseOptions);
        }
export type ProductZonesQueryHookResult = ReturnType<typeof useProductZonesQuery>;
export type ProductZonesLazyQueryHookResult = ReturnType<typeof useProductZonesLazyQuery>;
export type ProductZonesQueryResult = Apollo.QueryResult<GqlProductZonesQuery, GqlProductZonesQueryVariables>;
export const RulesDocument = gql`
    query Rules($per_page: Int, $page: Int, $filters: GenericScalar, $search: String, $active: Boolean) {
  rules(
    per_page: $per_page
    page: $page
    filter: $filters
    search: $search
    active: $active
  ) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        rule_id
        rule_name
        rule_description
        product_rules {
          product_id
          product_item_id
          product {
            active
            product_name
            product_id
          }
          product_item_id
          is_sku_rule
          product_item {
            active
            product {
              product_name
            }
            product_item_name
          }
        }
        category_rules {
          category_id
          category_rule_type
          active
          category {
            category_name
            category_id
          }
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useRulesQuery__
 *
 * To run a query within a React component, call `useRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRulesQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useRulesQuery(baseOptions?: Apollo.QueryHookOptions<GqlRulesQuery, GqlRulesQueryVariables>) {
        return Apollo.useQuery<GqlRulesQuery, GqlRulesQueryVariables>(RulesDocument, baseOptions);
      }
export function useRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRulesQuery, GqlRulesQueryVariables>) {
          return Apollo.useLazyQuery<GqlRulesQuery, GqlRulesQueryVariables>(RulesDocument, baseOptions);
        }
export type RulesQueryHookResult = ReturnType<typeof useRulesQuery>;
export type RulesLazyQueryHookResult = ReturnType<typeof useRulesLazyQuery>;
export type RulesQueryResult = Apollo.QueryResult<GqlRulesQuery, GqlRulesQueryVariables>;
export const ProductRulesDocument = gql`
    query ProductRules($filters: GenericScalar) {
  product_rules(filter: $filters) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        rule_id
        product_id
        product_item_id
        is_sku_rule
        product_item {
          product {
            product_name
          }
          product_item_name
        }
        product {
          product_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useProductRulesQuery__
 *
 * To run a query within a React component, call `useProductRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRulesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProductRulesQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductRulesQuery, GqlProductRulesQueryVariables>) {
        return Apollo.useQuery<GqlProductRulesQuery, GqlProductRulesQueryVariables>(ProductRulesDocument, baseOptions);
      }
export function useProductRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductRulesQuery, GqlProductRulesQueryVariables>) {
          return Apollo.useLazyQuery<GqlProductRulesQuery, GqlProductRulesQueryVariables>(ProductRulesDocument, baseOptions);
        }
export type ProductRulesQueryHookResult = ReturnType<typeof useProductRulesQuery>;
export type ProductRulesLazyQueryHookResult = ReturnType<typeof useProductRulesLazyQuery>;
export type ProductRulesQueryResult = Apollo.QueryResult<GqlProductRulesQuery, GqlProductRulesQueryVariables>;
export const CategoryRulesDocument = gql`
    query CategoryRules($filters: GenericScalar) {
  category_rules(filter: $filters) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        active
        rule_id
        category_id
        category {
          category_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useCategoryRulesQuery__
 *
 * To run a query within a React component, call `useCategoryRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryRulesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCategoryRulesQuery(baseOptions?: Apollo.QueryHookOptions<GqlCategoryRulesQuery, GqlCategoryRulesQueryVariables>) {
        return Apollo.useQuery<GqlCategoryRulesQuery, GqlCategoryRulesQueryVariables>(CategoryRulesDocument, baseOptions);
      }
export function useCategoryRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCategoryRulesQuery, GqlCategoryRulesQueryVariables>) {
          return Apollo.useLazyQuery<GqlCategoryRulesQuery, GqlCategoryRulesQueryVariables>(CategoryRulesDocument, baseOptions);
        }
export type CategoryRulesQueryHookResult = ReturnType<typeof useCategoryRulesQuery>;
export type CategoryRulesLazyQueryHookResult = ReturnType<typeof useCategoryRulesLazyQuery>;
export type CategoryRulesQueryResult = Apollo.QueryResult<GqlCategoryRulesQuery, GqlCategoryRulesQueryVariables>;
export const ZoneTypesDocument = gql`
    query ZoneTypes {
  product_zone_types
}
    `;

/**
 * __useZoneTypesQuery__
 *
 * To run a query within a React component, call `useZoneTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZoneTypesQuery(baseOptions?: Apollo.QueryHookOptions<GqlZoneTypesQuery, GqlZoneTypesQueryVariables>) {
        return Apollo.useQuery<GqlZoneTypesQuery, GqlZoneTypesQueryVariables>(ZoneTypesDocument, baseOptions);
      }
export function useZoneTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlZoneTypesQuery, GqlZoneTypesQueryVariables>) {
          return Apollo.useLazyQuery<GqlZoneTypesQuery, GqlZoneTypesQueryVariables>(ZoneTypesDocument, baseOptions);
        }
export type ZoneTypesQueryHookResult = ReturnType<typeof useZoneTypesQuery>;
export type ZoneTypesLazyQueryHookResult = ReturnType<typeof useZoneTypesLazyQuery>;
export type ZoneTypesQueryResult = Apollo.QueryResult<GqlZoneTypesQuery, GqlZoneTypesQueryVariables>;
export const StorageLocationsDocument = gql`
    query StorageLocations($filters: GenericScalar, $search: String, $per_page: Int) {
  bins(filter: $filters, search: $search, per_page: $per_page) {
    edges {
      node {
        pickface_product_item_id
        is_pickface
        bin_names {
          bin_id
          aisle
          level
          bin_position
        }
      }
    }
  }
}
    `;

/**
 * __useStorageLocationsQuery__
 *
 * To run a query within a React component, call `useStorageLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useStorageLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GqlStorageLocationsQuery, GqlStorageLocationsQueryVariables>) {
        return Apollo.useQuery<GqlStorageLocationsQuery, GqlStorageLocationsQueryVariables>(StorageLocationsDocument, baseOptions);
      }
export function useStorageLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStorageLocationsQuery, GqlStorageLocationsQueryVariables>) {
          return Apollo.useLazyQuery<GqlStorageLocationsQuery, GqlStorageLocationsQueryVariables>(StorageLocationsDocument, baseOptions);
        }
export type StorageLocationsQueryHookResult = ReturnType<typeof useStorageLocationsQuery>;
export type StorageLocationsLazyQueryHookResult = ReturnType<typeof useStorageLocationsLazyQuery>;
export type StorageLocationsQueryResult = Apollo.QueryResult<GqlStorageLocationsQuery, GqlStorageLocationsQueryVariables>;
export const FilterBinsDocument = gql`
    query FilterBins($from: String, $to: String) {
  filter_bins(_from: $from, _to: $to) {
    bin_id
    aisle
    bin_position
    level
    storage_location_id
  }
}
    `;

/**
 * __useFilterBinsQuery__
 *
 * To run a query within a React component, call `useFilterBinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterBinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterBinsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useFilterBinsQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilterBinsQuery, GqlFilterBinsQueryVariables>) {
        return Apollo.useQuery<GqlFilterBinsQuery, GqlFilterBinsQueryVariables>(FilterBinsDocument, baseOptions);
      }
export function useFilterBinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilterBinsQuery, GqlFilterBinsQueryVariables>) {
          return Apollo.useLazyQuery<GqlFilterBinsQuery, GqlFilterBinsQueryVariables>(FilterBinsDocument, baseOptions);
        }
export type FilterBinsQueryHookResult = ReturnType<typeof useFilterBinsQuery>;
export type FilterBinsLazyQueryHookResult = ReturnType<typeof useFilterBinsLazyQuery>;
export type FilterBinsQueryResult = Apollo.QueryResult<GqlFilterBinsQuery, GqlFilterBinsQueryVariables>;
export const RoutePlansDocument = gql`
    query RoutePlans($filters: GenericScalar, $search: String) {
  route_plans(filters: $filters, search: $search) {
    page_info {
      ...Pagination
    }
    edges {
      node {
        route_plan_id
        delivery_date
        depot_id
        depot {
          depot_name
        }
        multiple_trips
        vehicle_trip
        vehicle_id
        vehicle {
          registration_number
        }
        route_id
        route {
          route_name
        }
      }
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useRoutePlansQuery__
 *
 * To run a query within a React component, call `useRoutePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutePlansQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRoutePlansQuery(baseOptions?: Apollo.QueryHookOptions<GqlRoutePlansQuery, GqlRoutePlansQueryVariables>) {
        return Apollo.useQuery<GqlRoutePlansQuery, GqlRoutePlansQueryVariables>(RoutePlansDocument, baseOptions);
      }
export function useRoutePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRoutePlansQuery, GqlRoutePlansQueryVariables>) {
          return Apollo.useLazyQuery<GqlRoutePlansQuery, GqlRoutePlansQueryVariables>(RoutePlansDocument, baseOptions);
        }
export type RoutePlansQueryHookResult = ReturnType<typeof useRoutePlansQuery>;
export type RoutePlansLazyQueryHookResult = ReturnType<typeof useRoutePlansLazyQuery>;
export type RoutePlansQueryResult = Apollo.QueryResult<GqlRoutePlansQuery, GqlRoutePlansQueryVariables>;